(function(f){if(typeof exports==="object"&&typeof module!=="undefined"){module.exports=f()}else if(typeof define==="function"&&define.amd){define([],f)}else{var g;if(typeof window!=="undefined"){g=window}else if(typeof global!=="undefined"){g=global}else if(typeof self!=="undefined"){g=self}else{g=this}g.Pict = f()}})(function(){var define,module,exports;return (function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
'use strict';

var eachOfLimit = require('async.util.eachoflimit');
var withoutIndex = require('async.util.withoutindex');

module.exports = function eachLimit(arr, limit, iterator, cb) {
    return eachOfLimit(limit)(arr, withoutIndex(iterator), cb);
};

},{"async.util.eachoflimit":3,"async.util.withoutindex":14}],2:[function(require,module,exports){
'use strict';

module.exports = function(tasks) {
    function makeCallback(index) {
        function fn() {
            if (tasks.length) {
                tasks[index].apply(null, arguments);
            }
            return fn.next();
        }
        fn.next = function() {
            return (index < tasks.length - 1) ? makeCallback(index + 1) : null;
        };
        return fn;
    }
    return makeCallback(0);
};

},{}],3:[function(require,module,exports){
var once = require('async.util.once');
var noop = require('async.util.noop');
var onlyOnce = require('async.util.onlyonce');
var keyIterator = require('async.util.keyiterator');

module.exports = function eachOfLimit(limit) {
    return function(obj, iterator, cb) {
        cb = once(cb || noop);
        obj = obj || [];
        var nextKey = keyIterator(obj);
        if (limit <= 0) {
            return cb(null);
        }
        var done = false;
        var running = 0;
        var errored = false;

        (function replenish() {
            if (done && running <= 0) {
                return cb(null);
            }

            while (running < limit && !errored) {
                var key = nextKey();
                if (key === null) {
                    done = true;
                    if (running <= 0) {
                        cb(null);
                    }
                    return;
                }
                running += 1;
                iterator(obj[key], key, onlyOnce(function(err) {
                    running -= 1;
                    if (err) {
                        cb(err);
                        errored = true;
                    } else {
                        replenish();
                    }
                }));
            }
        })();
    };
};

},{"async.util.keyiterator":7,"async.util.noop":9,"async.util.once":10,"async.util.onlyonce":11}],4:[function(require,module,exports){
'use strict';
var setImmediate = require('async.util.setimmediate');
var restParam = require('async.util.restparam');

module.exports = function(fn) {
    return restParam(function(args) {
        var callback = args.pop();
        args.push(function() {
            var innerArgs = arguments;
            if (sync) {
                setImmediate(function() {
                    callback.apply(null, innerArgs);
                });
            } else {
                callback.apply(null, innerArgs);
            }
        });
        var sync = true;
        fn.apply(this, args);
        sync = false;
    });
};

},{"async.util.restparam":12,"async.util.setimmediate":13}],5:[function(require,module,exports){
'use strict';

module.exports = Array.isArray || function isArray(obj) {
    return Object.prototype.toString.call(obj) === '[object Array]';
};

},{}],6:[function(require,module,exports){
'use strict';

var isArray = require('async.util.isarray');

module.exports = function isArrayLike(arr) {
    return isArray(arr) || (
        // has a positive integer length property
        typeof arr.length === 'number' &&
        arr.length >= 0 &&
        arr.length % 1 === 0
    );
};

},{"async.util.isarray":5}],7:[function(require,module,exports){
'use strict';

var _keys = require('async.util.keys');
var isArrayLike = require('async.util.isarraylike');

module.exports = function keyIterator(coll) {
    var i = -1;
    var len;
    var keys;
    if (isArrayLike(coll)) {
        len = coll.length;
        return function next() {
            i++;
            return i < len ? i : null;
        };
    } else {
        keys = _keys(coll);
        len = keys.length;
        return function next() {
            i++;
            return i < len ? keys[i] : null;
        };
    }
};

},{"async.util.isarraylike":6,"async.util.keys":8}],8:[function(require,module,exports){
'use strict';

module.exports = Object.keys || function keys(obj) {
    var _keys = [];
    for (var k in obj) {
        if (obj.hasOwnProperty(k)) {
            _keys.push(k);
        }
    }
    return _keys;
};

},{}],9:[function(require,module,exports){
'use strict';

module.exports = function noop () {};

},{}],10:[function(require,module,exports){
'use strict';

module.exports = function once(fn) {
    return function() {
        if (fn === null) return;
        fn.apply(this, arguments);
        fn = null;
    };
};

},{}],11:[function(require,module,exports){
'use strict';

module.exports = function only_once(fn) {
    return function() {
        if (fn === null) throw new Error('Callback was already called.');
        fn.apply(this, arguments);
        fn = null;
    };
};

},{}],12:[function(require,module,exports){
'use strict';
module.exports = function restParam(func, startIndex) {
    startIndex = startIndex == null ? func.length - 1 : +startIndex;
    return function() {
        var length = Math.max(arguments.length - startIndex, 0);
        var rest = new Array(length);
        for (var index = 0; index < length; index++) {
            rest[index] = arguments[index + startIndex];
        }
        switch (startIndex) {
            case 0:
                return func.call(this, rest);
            case 1:
                return func.call(this, arguments[0], rest);
        }
    };
};

},{}],13:[function(require,module,exports){
(function (setImmediate){(function (){
'use strict';

var _setImmediate = typeof setImmediate === 'function' && setImmediate;
var fallback = function(fn) {
    setTimeout(fn, 0);
};

module.exports = function setImmediate(fn) {
    // not a direct alias for IE10 compatibility
    return (_setImmediate || fallback)(fn);
};

}).call(this)}).call(this,require("timers").setImmediate)

},{"timers":186}],14:[function(require,module,exports){
'use strict';

module.exports = function withoutIndex(iterator) {
    return function(value, index, callback) {
        return iterator(value, callback);
    };
};

},{}],15:[function(require,module,exports){
'use strict';

var once = require('async.util.once');
var noop = require('async.util.noop');
var isArray = require('async.util.isarray');
var restParam = require('async.util.restparam');
var ensureAsync = require('async.util.ensureasync');
var iterator = require('async.iterator');

module.exports = function(tasks, cb) {
    cb = once(cb || noop);
    if (!isArray(tasks)) return cb(new Error('First argument to waterfall must be an array of functions'));
    if (!tasks.length) return cb();

    function wrapIterator(iterator) {
        return restParam(function(err, args) {
            if (err) {
                cb.apply(null, [err].concat(args));
            } else {
                var next = iterator.next();
                if (next) {
                    args.push(wrapIterator(next));
                } else {
                    args.push(cb);
                }
                ensureAsync(iterator).apply(null, args);
            }
        });
    }
    wrapIterator(iterator(tasks))();
};

},{"async.iterator":2,"async.util.ensureasync":4,"async.util.isarray":5,"async.util.noop":9,"async.util.once":10,"async.util.restparam":12}],16:[function(require,module,exports){
'use strict'

exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}

},{}],17:[function(require,module,exports){
/*
 *  big.js v7.0.1
 *  A small, fast, easy-to-use library for arbitrary-precision decimal arithmetic.
 *  Copyright (c) 2025 Michael Mclaughlin
 *  https://github.com/MikeMcl/big.js/LICENCE.md
 */
;(function (GLOBAL) {
  'use strict';
  var Big,


/************************************** EDITABLE DEFAULTS *****************************************/


    // The default values below must be integers within the stated ranges.

    /*
     * The maximum number of decimal places (DP) of the results of operations involving division:
     * div and sqrt, and pow with negative exponents.
     */
    DP = 20,            // 0 to MAX_DP

    /*
     * The rounding mode (RM) used when rounding to the above decimal places.
     *
     *  0  Towards zero (i.e. truncate, no rounding).       (ROUND_DOWN)
     *  1  To nearest neighbour. If equidistant, round up.  (ROUND_HALF_UP)
     *  2  To nearest neighbour. If equidistant, to even.   (ROUND_HALF_EVEN)
     *  3  Away from zero.                                  (ROUND_UP)
     */
    RM = 1,             // 0, 1, 2 or 3

    // The maximum value of DP and Big.DP.
    MAX_DP = 1E6,       // 0 to 1000000

    // The maximum magnitude of the exponent argument to the pow method.
    MAX_POWER = 1E6,    // 1 to 1000000

    /*
     * The negative exponent (NE) at and beneath which toString returns exponential notation.
     * (JavaScript numbers: -7)
     * -1000000 is the minimum recommended exponent value of a Big.
     */
    NE = -7,            // 0 to -1000000

    /*
     * The positive exponent (PE) at and above which toString returns exponential notation.
     * (JavaScript numbers: 21)
     * 1000000 is the maximum recommended exponent value of a Big, but this limit is not enforced.
     */
    PE = 21,            // 0 to 1000000

    /*
     * When true, an error will be thrown if a primitive number is passed to the Big constructor,
     * or if valueOf is called, or if toNumber is called on a Big which cannot be converted to a
     * primitive number without a loss of precision.
     */
    STRICT = false,     // true or false


/**************************************************************************************************/


    // Error messages.
    NAME = '[big.js] ',
    INVALID = NAME + 'Invalid ',
    INVALID_DP = INVALID + 'decimal places',
    INVALID_RM = INVALID + 'rounding mode',
    DIV_BY_ZERO = NAME + 'Division by zero',

    // The shared prototype object.
    P = {},
    UNDEFINED = void 0,
    NUMERIC = /^-?(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i;


  /*
   * Create and return a Big constructor.
   */
  function _Big_() {

    /*
     * The Big constructor and exported function.
     * Create and return a new instance of a Big number object.
     *
     * n {number|string|Big} A numeric value.
     */
    function Big(n) {
      var x = this;

      // Enable constructor usage without new.
      if (!(x instanceof Big)) {
        return n === UNDEFINED && arguments.length === 0 ? _Big_() : new Big(n);
      }

      // Duplicate.
      if (n instanceof Big) {
        x.s = n.s;
        x.e = n.e;
        x.c = n.c.slice();
      } else {
        if (typeof n !== 'string') {
          if (Big.strict === true && typeof n !== 'bigint') {
            throw TypeError(INVALID + 'value');
          }

          // Minus zero?
          n = n === 0 && 1 / n < 0 ? '-0' : String(n);
        }

        parse(x, n);
      }

      // Retain a reference to this Big constructor.
      // Shadow Big.prototype.constructor which points to Object.
      x.constructor = Big;
    }

    Big.prototype = P;
    Big.DP = DP;
    Big.RM = RM;
    Big.NE = NE;
    Big.PE = PE;
    Big.strict = STRICT;
    Big.roundDown = 0;
    Big.roundHalfUp = 1;
    Big.roundHalfEven = 2;
    Big.roundUp = 3;

    return Big;
  }


  /*
   * Parse the number or string value passed to a Big constructor.
   *
   * x {Big} A Big number instance.
   * n {number|string} A numeric value.
   */
  function parse(x, n) {
    var e, i, nl;

    if (!NUMERIC.test(n)) {
      throw Error(INVALID + 'number');
    }

    // Determine sign.
    x.s = n.charAt(0) == '-' ? (n = n.slice(1), -1) : 1;

    // Decimal point?
    if ((e = n.indexOf('.')) > -1) n = n.replace('.', '');

    // Exponential form?
    if ((i = n.search(/e/i)) > 0) {

      // Determine exponent.
      if (e < 0) e = i;
      e += +n.slice(i + 1);
      n = n.substring(0, i);
    } else if (e < 0) {

      // Integer.
      e = n.length;
    }

    nl = n.length;

    // Determine leading zeros.
    for (i = 0; i < nl && n.charAt(i) == '0';) ++i;

    if (i == nl) {

      // Zero.
      x.c = [x.e = 0];
    } else {

      // Determine trailing zeros.
      for (; nl > 0 && n.charAt(--nl) == '0';);
      x.e = e - i - 1;
      x.c = [];

      // Convert string to array of digits without leading/trailing zeros.
      for (e = 0; i <= nl;) x.c[e++] = +n.charAt(i++);
    }

    return x;
  }


  /*
   * Round Big x to a maximum of sd significant digits using rounding mode rm.
   *
   * x {Big} The Big to round.
   * sd {number} Significant digits: integer, 0 to MAX_DP inclusive.
   * rm {number} Rounding mode: 0 (down), 1 (half-up), 2 (half-even) or 3 (up).
   * [more] {boolean} Whether the result of division was truncated.
   */
  function round(x, sd, rm, more) {
    var xc = x.c;

    if (rm === UNDEFINED) rm = x.constructor.RM;
    if (rm !== 0 && rm !== 1 && rm !== 2 && rm !== 3) {
      throw Error(INVALID_RM);
    }

    if (sd < 1) {
      more =
        rm === 3 && (more || !!xc[0]) || sd === 0 && (
        rm === 1 && xc[0] >= 5 ||
        rm === 2 && (xc[0] > 5 || xc[0] === 5 && (more || xc[1] !== UNDEFINED))
      );

      xc.length = 1;

      if (more) {

        // 1, 0.1, 0.01, 0.001, 0.0001 etc.
        x.e = x.e - sd + 1;
        xc[0] = 1;
      } else {

        // Zero.
        xc[0] = x.e = 0;
      }
    } else if (sd < xc.length) {

      // xc[sd] is the digit after the digit that may be rounded up.
      more =
        rm === 1 && xc[sd] >= 5 ||
        rm === 2 && (xc[sd] > 5 || xc[sd] === 5 &&
          (more || xc[sd + 1] !== UNDEFINED || xc[sd - 1] & 1)) ||
        rm === 3 && (more || !!xc[0]);

      // Remove any digits after the required precision.
      xc.length = sd;

      // Round up?
      if (more) {

        // Rounding up may mean the previous digit has to be rounded up.
        for (; ++xc[--sd] > 9;) {
          xc[sd] = 0;
          if (sd === 0) {
            ++x.e;
            xc.unshift(1);
            break;
          }
        }
      }

      // Remove trailing zeros.
      for (sd = xc.length; !xc[--sd];) xc.pop();
    }

    return x;
  }


  /*
   * Return a string representing the value of Big x in normal or exponential notation.
   * Handles P.toExponential, P.toFixed, P.toJSON, P.toPrecision, P.toString and P.valueOf.
   */
  function stringify(x, doExponential, isNonzero) {
    var e = x.e,
      s = x.c.join(''),
      n = s.length;

    // Exponential notation?
    if (doExponential) {
      s = s.charAt(0) + (n > 1 ? '.' + s.slice(1) : '') + (e < 0 ? 'e' : 'e+') + e;

    // Normal notation.
    } else if (e < 0) {
      for (; ++e;) s = '0' + s;
      s = '0.' + s;
    } else if (e > 0) {
      if (++e > n) {
        for (e -= n; e--;) s += '0';
      } else if (e < n) {
        s = s.slice(0, e) + '.' + s.slice(e);
      }
    } else if (n > 1) {
      s = s.charAt(0) + '.' + s.slice(1);
    }

    return x.s < 0 && isNonzero ? '-' + s : s;
  }


  // Prototype/instance methods


  /*
   * Return a new Big whose value is the absolute value of this Big.
   */
  P.abs = function () {
    var x = new this.constructor(this);
    x.s = 1;
    return x;
  };


  /*
   * Return 1 if the value of this Big is greater than the value of Big y,
   *       -1 if the value of this Big is less than the value of Big y, or
   *        0 if they have the same value.
   */
  P.cmp = function (y) {
    var isneg,
      x = this,
      xc = x.c,
      yc = (y = new x.constructor(y)).c,
      i = x.s,
      j = y.s,
      k = x.e,
      l = y.e;

    // Either zero?
    if (!xc[0] || !yc[0]) return !xc[0] ? !yc[0] ? 0 : -j : i;

    // Signs differ?
    if (i != j) return i;

    isneg = i < 0;

    // Compare exponents.
    if (k != l) return k > l ^ isneg ? 1 : -1;

    j = (k = xc.length) < (l = yc.length) ? k : l;

    // Compare digit by digit.
    for (i = -1; ++i < j;) {
      if (xc[i] != yc[i]) return xc[i] > yc[i] ^ isneg ? 1 : -1;
    }

    // Compare lengths.
    return k == l ? 0 : k > l ^ isneg ? 1 : -1;
  };


  /*
   * Return a new Big whose value is the value of this Big divided by the value of Big y, rounded,
   * if necessary, to a maximum of Big.DP decimal places using rounding mode Big.RM.
   */
  P.div = function (y) {
    var x = this,
      Big = x.constructor,
      a = x.c,                  // dividend
      b = (y = new Big(y)).c,   // divisor
      k = x.s == y.s ? 1 : -1,
      dp = Big.DP;

    if (dp !== ~~dp || dp < 0 || dp > MAX_DP) {
      throw Error(INVALID_DP);
    }

    // Divisor is zero?
    if (!b[0]) {
      throw Error(DIV_BY_ZERO);
    }

    // Dividend is 0? Return +-0.
    if (!a[0]) {
      y.s = k;
      y.c = [y.e = 0];
      return y;
    }

    var bl, bt, n, cmp, ri,
      bz = b.slice(),
      ai = bl = b.length,
      al = a.length,
      r = a.slice(0, bl),   // remainder
      rl = r.length,
      q = y,                // quotient
      qc = q.c = [],
      qi = 0,
      p = dp + (q.e = x.e - y.e) + 1;    // precision of the result

    q.s = k;
    k = p < 0 ? 0 : p;

    // Create version of divisor with leading zero.
    bz.unshift(0);

    // Add zeros to make remainder as long as divisor.
    for (; rl++ < bl;) r.push(0);

    do {

      // n is how many times the divisor goes into current remainder.
      for (n = 0; n < 10; n++) {

        // Compare divisor and remainder.
        if (bl != (rl = r.length)) {
          cmp = bl > rl ? 1 : -1;
        } else {
          for (ri = -1, cmp = 0; ++ri < bl;) {
            if (b[ri] != r[ri]) {
              cmp = b[ri] > r[ri] ? 1 : -1;
              break;
            }
          }
        }

        // If divisor < remainder, subtract divisor from remainder.
        if (cmp < 0) {

          // Remainder can't be more than 1 digit longer than divisor.
          // Equalise lengths using divisor with extra leading zero?
          for (bt = rl == bl ? b : bz; rl;) {
            if (r[--rl] < bt[rl]) {
              ri = rl;
              for (; ri && !r[--ri];) r[ri] = 9;
              --r[ri];
              r[rl] += 10;
            }
            r[rl] -= bt[rl];
          }

          for (; !r[0];) r.shift();
        } else {
          break;
        }
      }

      // Add the digit n to the result array.
      qc[qi++] = cmp ? n : ++n;

      // Update the remainder.
      if (r[0] && cmp) r[rl] = a[ai] || 0;
      else r = [a[ai]];

    } while ((ai++ < al || r[0] !== UNDEFINED) && k--);

    // Leading zero? Do not remove if result is simply zero (qi == 1).
    if (!qc[0] && qi != 1) {

      // There can't be more than one zero.
      qc.shift();
      q.e--;
      p--;
    }

    // Round?
    if (qi > p) round(q, p, Big.RM, r[0] !== UNDEFINED);

    return q;
  };


  /*
   * Return true if the value of this Big is equal to the value of Big y, otherwise return false.
   */
  P.eq = function (y) {
    return this.cmp(y) === 0;
  };


  /*
   * Return true if the value of this Big is greater than the value of Big y, otherwise return
   * false.
   */
  P.gt = function (y) {
    return this.cmp(y) > 0;
  };


  /*
   * Return true if the value of this Big is greater than or equal to the value of Big y, otherwise
   * return false.
   */
  P.gte = function (y) {
    return this.cmp(y) > -1;
  };


  /*
   * Return true if the value of this Big is less than the value of Big y, otherwise return false.
   */
  P.lt = function (y) {
    return this.cmp(y) < 0;
  };


  /*
   * Return true if the value of this Big is less than or equal to the value of Big y, otherwise
   * return false.
   */
  P.lte = function (y) {
    return this.cmp(y) < 1;
  };


  /*
   * Return a new Big whose value is the value of this Big minus the value of Big y.
   */
  P.minus = P.sub = function (y) {
    var i, j, t, xlty,
      x = this,
      Big = x.constructor,
      a = x.s,
      b = (y = new Big(y)).s;

    // Signs differ?
    if (a != b) {
      y.s = -b;
      return x.plus(y);
    }

    var xc = x.c.slice(),
      xe = x.e,
      yc = y.c,
      ye = y.e;

    // Either zero?
    if (!xc[0] || !yc[0]) {
      if (yc[0]) {
        y.s = -b;
      } else if (xc[0]) {
        y = new Big(x);
      } else {
        y.s = 1;
      }
      return y;
    }

    // Determine which is the bigger number. Prepend zeros to equalise exponents.
    if (a = xe - ye) {

      if (xlty = a < 0) {
        a = -a;
        t = xc;
      } else {
        ye = xe;
        t = yc;
      }

      t.reverse();
      for (b = a; b--;) t.push(0);
      t.reverse();
    } else {

      // Exponents equal. Check digit by digit.
      j = ((xlty = xc.length < yc.length) ? xc : yc).length;

      for (a = b = 0; b < j; b++) {
        if (xc[b] != yc[b]) {
          xlty = xc[b] < yc[b];
          break;
        }
      }
    }

    // x < y? Point xc to the array of the bigger number.
    if (xlty) {
      t = xc;
      xc = yc;
      yc = t;
      y.s = -y.s;
    }

    /*
     * Append zeros to xc if shorter. No need to add zeros to yc if shorter as subtraction only
     * needs to start at yc.length.
     */
    if ((b = (j = yc.length) - (i = xc.length)) > 0) for (; b--;) xc[i++] = 0;

    // Subtract yc from xc.
    for (b = i; j > a;) {
      if (xc[--j] < yc[j]) {
        for (i = j; i && !xc[--i];) xc[i] = 9;
        --xc[i];
        xc[j] += 10;
      }

      xc[j] -= yc[j];
    }

    // Remove trailing zeros.
    for (; xc[--b] === 0;) xc.pop();

    // Remove leading zeros and adjust exponent accordingly.
    for (; xc[0] === 0;) {
      xc.shift();
      --ye;
    }

    if (!xc[0]) {

      // n - n = +0
      y.s = 1;

      // Result must be zero.
      xc = [ye = 0];
    }

    y.c = xc;
    y.e = ye;

    return y;
  };


  /*
   * Return a new Big whose value is the value of this Big modulo the value of Big y.
   */
  P.mod = function (y) {
    var ygtx,
      x = this,
      Big = x.constructor,
      a = x.s,
      b = (y = new Big(y)).s;

    if (!y.c[0]) {
      throw Error(DIV_BY_ZERO);
    }

    x.s = y.s = 1;
    ygtx = y.cmp(x) == 1;
    x.s = a;
    y.s = b;

    if (ygtx) return new Big(x);

    a = Big.DP;
    b = Big.RM;
    Big.DP = Big.RM = 0;
    x = x.div(y);
    Big.DP = a;
    Big.RM = b;

    return this.minus(x.times(y));
  };


  /*
   * Return a new Big whose value is the value of this Big negated.
   */
  P.neg = function () {
    var x = new this.constructor(this);
    x.s = -x.s;
    return x;
  };


  /*
   * Return a new Big whose value is the value of this Big plus the value of Big y.
   */
  P.plus = P.add = function (y) {
    var e, k, t,
      x = this,
      Big = x.constructor;

    y = new Big(y);

    // Signs differ?
    if (x.s != y.s) {
      y.s = -y.s;
      return x.minus(y);
    }

    var xe = x.e,
      xc = x.c,
      ye = y.e,
      yc = y.c;

    // Either zero?
    if (!xc[0] || !yc[0]) {
      if (!yc[0]) {
        if (xc[0]) {
          y = new Big(x);
        } else {
          y.s = x.s;
        }
      }
      return y;
    }

    xc = xc.slice();

    // Prepend zeros to equalise exponents.
    // Note: reverse faster than unshifts.
    if (e = xe - ye) {
      if (e > 0) {
        ye = xe;
        t = yc;
      } else {
        e = -e;
        t = xc;
      }

      t.reverse();
      for (; e--;) t.push(0);
      t.reverse();
    }

    // Point xc to the longer array.
    if (xc.length - yc.length < 0) {
      t = yc;
      yc = xc;
      xc = t;
    }

    e = yc.length;

    // Only start adding at yc.length - 1 as the further digits of xc can be left as they are.
    for (k = 0; e; xc[e] %= 10) k = (xc[--e] = xc[e] + yc[e] + k) / 10 | 0;

    // No need to check for zero, as +x + +y != 0 && -x + -y != 0

    if (k) {
      xc.unshift(k);
      ++ye;
    }

    // Remove trailing zeros.
    for (e = xc.length; xc[--e] === 0;) xc.pop();

    y.c = xc;
    y.e = ye;

    return y;
  };


  /*
   * Return a Big whose value is the value of this Big raised to the power n.
   * If n is negative, round to a maximum of Big.DP decimal places using rounding
   * mode Big.RM.
   *
   * n {number} Integer, -MAX_POWER to MAX_POWER inclusive.
   */
  P.pow = function (n) {
    var x = this,
      one = new x.constructor('1'),
      y = one,
      isneg = n < 0;

    if (n !== ~~n || n < -MAX_POWER || n > MAX_POWER) {
      throw Error(INVALID + 'exponent');
    }

    if (isneg) n = -n;

    for (;;) {
      if (n & 1) y = y.times(x);
      n >>= 1;
      if (!n) break;
      x = x.times(x);
    }

    return isneg ? one.div(y) : y;
  };


  /*
   * Return a new Big whose value is the value of this Big rounded to a maximum precision of sd
   * significant digits using rounding mode rm, or Big.RM if rm is not specified.
   *
   * sd {number} Significant digits: integer, 1 to MAX_DP inclusive.
   * rm? {number} Rounding mode: 0 (down), 1 (half-up), 2 (half-even) or 3 (up).
   */
  P.prec = function (sd, rm) {
    if (sd !== ~~sd || sd < 1 || sd > MAX_DP) {
      throw Error(INVALID + 'precision');
    }
    return round(new this.constructor(this), sd, rm);
  };


  /*
   * Return a new Big whose value is the value of this Big rounded to a maximum of dp decimal places
   * using rounding mode rm, or Big.RM if rm is not specified.
   * If dp is negative, round to an integer which is a multiple of 10**-dp.
   * If dp is not specified, round to 0 decimal places.
   *
   * dp? {number} Integer, -MAX_DP to MAX_DP inclusive.
   * rm? {number} Rounding mode: 0 (down), 1 (half-up), 2 (half-even) or 3 (up).
   */
  P.round = function (dp, rm) {
    if (dp === UNDEFINED) dp = 0;
    else if (dp !== ~~dp || dp < -MAX_DP || dp > MAX_DP) {
      throw Error(INVALID_DP);
    }
    return round(new this.constructor(this), dp + this.e + 1, rm);
  };


  /*
   * Return a new Big whose value is the square root of the value of this Big, rounded, if
   * necessary, to a maximum of Big.DP decimal places using rounding mode Big.RM.
   */
  P.sqrt = function () {
    var r, c, t,
      x = this,
      Big = x.constructor,
      s = x.s,
      e = x.e,
      half = new Big('0.5');

    // Zero?
    if (!x.c[0]) return new Big(x);

    // Negative?
    if (s < 0) {
      throw Error(NAME + 'No square root');
    }

    // Estimate.
    s = Math.sqrt(+stringify(x, true, true));

    // Math.sqrt underflow/overflow?
    // Re-estimate: pass x coefficient to Math.sqrt as integer, then adjust the result exponent.
    if (s === 0 || s === 1 / 0) {
      c = x.c.join('');
      if (!(c.length + e & 1)) c += '0';
      s = Math.sqrt(c);
      e = ((e + 1) / 2 | 0) - (e < 0 || e & 1);
      r = new Big((s == 1 / 0 ? '5e' : (s = s.toExponential()).slice(0, s.indexOf('e') + 1)) + e);
    } else {
      r = new Big(s + '');
    }

    e = r.e + (Big.DP += 4);

    // Newton-Raphson iteration.
    do {
      t = r;
      r = half.times(t.plus(x.div(t)));
    } while (t.c.slice(0, e).join('') !== r.c.slice(0, e).join(''));

    return round(r, (Big.DP -= 4) + r.e + 1, Big.RM);
  };


  /*
   * Return a new Big whose value is the value of this Big times the value of Big y.
   */
  P.times = P.mul = function (y) {
    var c,
      x = this,
      Big = x.constructor,
      xc = x.c,
      yc = (y = new Big(y)).c,
      a = xc.length,
      b = yc.length,
      i = x.e,
      j = y.e;

    // Determine sign of result.
    y.s = x.s == y.s ? 1 : -1;

    // Return signed 0 if either 0.
    if (!xc[0] || !yc[0]) {
      y.c = [y.e = 0];
      return y;
    }

    // Initialise exponent of result as x.e + y.e.
    y.e = i + j;

    // If array xc has fewer digits than yc, swap xc and yc, and lengths.
    if (a < b) {
      c = xc;
      xc = yc;
      yc = c;
      j = a;
      a = b;
      b = j;
    }

    // Initialise coefficient array of result with zeros.
    for (c = new Array(j = a + b); j--;) c[j] = 0;

    // Multiply.

    // i is initially xc.length.
    for (i = b; i--;) {
      b = 0;

      // a is yc.length.
      for (j = a + i; j > i;) {

        // Current sum of products at this digit position, plus carry.
        b = c[j] + yc[i] * xc[j - i - 1] + b;
        c[j--] = b % 10;

        // carry
        b = b / 10 | 0;
      }

      c[j] = b;
    }

    // Increment result exponent if there is a final carry, otherwise remove leading zero.
    if (b) ++y.e;
    else c.shift();

    // Remove trailing zeros.
    for (i = c.length; !c[--i];) c.pop();
    y.c = c;

    return y;
  };


  /*
   * Return a string representing the value of this Big in exponential notation rounded to dp fixed
   * decimal places using rounding mode rm, or Big.RM if rm is not specified.
   *
   * dp? {number} Decimal places: integer, 0 to MAX_DP inclusive.
   * rm? {number} Rounding mode: 0 (down), 1 (half-up), 2 (half-even) or 3 (up).
   */
  P.toExponential = function (dp, rm) {
    var x = this,
      n = x.c[0];

    if (dp !== UNDEFINED) {
      if (dp !== ~~dp || dp < 0 || dp > MAX_DP) {
        throw Error(INVALID_DP);
      }
      x = round(new x.constructor(x), ++dp, rm);
      for (; x.c.length < dp;) x.c.push(0);
    }

    return stringify(x, true, !!n);
  };


  /*
   * Return a string representing the value of this Big in normal notation rounded to dp fixed
   * decimal places using rounding mode rm, or Big.RM if rm is not specified.
   *
   * dp? {number} Decimal places: integer, 0 to MAX_DP inclusive.
   * rm? {number} Rounding mode: 0 (down), 1 (half-up), 2 (half-even) or 3 (up).
   *
   * (-0).toFixed(0) is '0', but (-0.1).toFixed(0) is '-0'.
   * (-0).toFixed(1) is '0.0', but (-0.01).toFixed(1) is '-0.0'.
   */
  P.toFixed = function (dp, rm) {
    var x = this,
      n = x.c[0];

    if (dp !== UNDEFINED) {
      if (dp !== ~~dp || dp < 0 || dp > MAX_DP) {
        throw Error(INVALID_DP);
      }
      x = round(new x.constructor(x), dp + x.e + 1, rm);

      // x.e may have changed if the value is rounded up.
      for (dp = dp + x.e + 1; x.c.length < dp;) x.c.push(0);
    }

    return stringify(x, false, !!n);
  };


  /*
   * Return a string representing the value of this Big.
   * Return exponential notation if this Big has a positive exponent equal to or greater than
   * Big.PE, or a negative exponent equal to or less than Big.NE.
   * Omit the sign for negative zero.
   */
  P.toJSON = P.toString = function () {
    var x = this,
      Big = x.constructor;
    return stringify(x, x.e <= Big.NE || x.e >= Big.PE, !!x.c[0]);
  };


  /*
   * Return the value of this Big as a primitve number.
   */
  P.toNumber = function () {
    var n = +stringify(this, true, true);
    if (this.constructor.strict === true && !this.eq(n.toString())) {
      throw Error(NAME + 'Imprecise conversion');
    }
    return n;
  };


  /*
   * Return a string representing the value of this Big rounded to sd significant digits using
   * rounding mode rm, or Big.RM if rm is not specified.
   * Use exponential notation if sd is less than the number of digits necessary to represent
   * the integer part of the value in normal notation.
   *
   * sd {number} Significant digits: integer, 1 to MAX_DP inclusive.
   * rm? {number} Rounding mode: 0 (down), 1 (half-up), 2 (half-even) or 3 (up).
   */
  P.toPrecision = function (sd, rm) {
    var x = this,
      Big = x.constructor,
      n = x.c[0];

    if (sd !== UNDEFINED) {
      if (sd !== ~~sd || sd < 1 || sd > MAX_DP) {
        throw Error(INVALID + 'precision');
      }
      x = round(new Big(x), sd, rm);
      for (; x.c.length < sd;) x.c.push(0);
    }

    return stringify(x, sd <= x.e || x.e <= Big.NE || x.e >= Big.PE, !!n);
  };


  /*
   * Return a string representing the value of this Big.
   * Return exponential notation if this Big has a positive exponent equal to or greater than
   * Big.PE, or a negative exponent equal to or less than Big.NE.
   * Include the sign for negative zero.
   */
  P.valueOf = function () {
    var x = this,
      Big = x.constructor;
    if (Big.strict === true) {
      throw Error(NAME + 'valueOf disallowed');
    }
    return stringify(x, x.e <= Big.NE || x.e >= Big.PE, true);
  };


  // Export


  Big = _Big_();

  Big['default'] = Big.Big = Big;

  //AMD.
  if (typeof define === 'function' && define.amd) {
    define(function () { return Big; });

  // Node and other CommonJS-like environments that support module.exports.
  } else if (typeof module !== 'undefined' && module.exports) {
    module.exports = Big;

  //Browser.
  } else {
    GLOBAL.Big = Big;
  }
})(this);

},{}],18:[function(require,module,exports){

},{}],19:[function(require,module,exports){
arguments[4][18][0].apply(exports,arguments)
},{"dup":18}],20:[function(require,module,exports){
(function (Buffer){(function (){
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */

'use strict'

var base64 = require('base64-js')
var ieee754 = require('ieee754')

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

var K_MAX_LENGTH = 0x7fffffff
exports.kMaxLength = K_MAX_LENGTH

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */
Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport()

if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' &&
    typeof console.error === 'function') {
  console.error(
    'This browser lacks typed array (Uint8Array) support which is required by ' +
    '`buffer` v5.x. Use `buffer` v4.x if you require old browser support.'
  )
}

function typedArraySupport () {
  // Can typed array instances can be augmented?
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = { __proto__: Uint8Array.prototype, foo: function () { return 42 } }
    return arr.foo() === 42
  } catch (e) {
    return false
  }
}

Object.defineProperty(Buffer.prototype, 'parent', {
  enumerable: true,
  get: function () {
    if (!Buffer.isBuffer(this)) return undefined
    return this.buffer
  }
})

Object.defineProperty(Buffer.prototype, 'offset', {
  enumerable: true,
  get: function () {
    if (!Buffer.isBuffer(this)) return undefined
    return this.byteOffset
  }
})

function createBuffer (length) {
  if (length > K_MAX_LENGTH) {
    throw new RangeError('The value "' + length + '" is invalid for option "size"')
  }
  // Return an augmented `Uint8Array` instance
  var buf = new Uint8Array(length)
  buf.__proto__ = Buffer.prototype
  return buf
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new TypeError(
        'The "string" argument must be of type string. Received type number'
      )
    }
    return allocUnsafe(arg)
  }
  return from(arg, encodingOrOffset, length)
}

// Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
if (typeof Symbol !== 'undefined' && Symbol.species != null &&
    Buffer[Symbol.species] === Buffer) {
  Object.defineProperty(Buffer, Symbol.species, {
    value: null,
    configurable: true,
    enumerable: false,
    writable: false
  })
}

Buffer.poolSize = 8192 // not used by this implementation

function from (value, encodingOrOffset, length) {
  if (typeof value === 'string') {
    return fromString(value, encodingOrOffset)
  }

  if (ArrayBuffer.isView(value)) {
    return fromArrayLike(value)
  }

  if (value == null) {
    throw TypeError(
      'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
      'or Array-like Object. Received type ' + (typeof value)
    )
  }

  if (isInstance(value, ArrayBuffer) ||
      (value && isInstance(value.buffer, ArrayBuffer))) {
    return fromArrayBuffer(value, encodingOrOffset, length)
  }

  if (typeof value === 'number') {
    throw new TypeError(
      'The "value" argument must not be of type number. Received type number'
    )
  }

  var valueOf = value.valueOf && value.valueOf()
  if (valueOf != null && valueOf !== value) {
    return Buffer.from(valueOf, encodingOrOffset, length)
  }

  var b = fromObject(value)
  if (b) return b

  if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null &&
      typeof value[Symbol.toPrimitive] === 'function') {
    return Buffer.from(
      value[Symbol.toPrimitive]('string'), encodingOrOffset, length
    )
  }

  throw new TypeError(
    'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
    'or Array-like Object. Received type ' + (typeof value)
  )
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(value, encodingOrOffset, length)
}

// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Buffer.prototype.__proto__ = Uint8Array.prototype
Buffer.__proto__ = Uint8Array

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be of type number')
  } else if (size < 0) {
    throw new RangeError('The value "' + size + '" is invalid for option "size"')
  }
}

function alloc (size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(size).fill(fill, encoding)
      : createBuffer(size).fill(fill)
  }
  return createBuffer(size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(size, fill, encoding)
}

function allocUnsafe (size) {
  assertSize(size)
  return createBuffer(size < 0 ? 0 : checked(size) | 0)
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(size)
}

function fromString (string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('Unknown encoding: ' + encoding)
  }

  var length = byteLength(string, encoding) | 0
  var buf = createBuffer(length)

  var actual = buf.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual)
  }

  return buf
}

function fromArrayLike (array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  var buf = createBuffer(length)
  for (var i = 0; i < length; i += 1) {
    buf[i] = array[i] & 255
  }
  return buf
}

function fromArrayBuffer (array, byteOffset, length) {
  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('"offset" is outside of buffer bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('"length" is outside of buffer bounds')
  }

  var buf
  if (byteOffset === undefined && length === undefined) {
    buf = new Uint8Array(array)
  } else if (length === undefined) {
    buf = new Uint8Array(array, byteOffset)
  } else {
    buf = new Uint8Array(array, byteOffset, length)
  }

  // Return an augmented `Uint8Array` instance
  buf.__proto__ = Buffer.prototype
  return buf
}

function fromObject (obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    var buf = createBuffer(len)

    if (buf.length === 0) {
      return buf
    }

    obj.copy(buf, 0, 0, len)
    return buf
  }

  if (obj.length !== undefined) {
    if (typeof obj.length !== 'number' || numberIsNaN(obj.length)) {
      return createBuffer(0)
    }
    return fromArrayLike(obj)
  }

  if (obj.type === 'Buffer' && Array.isArray(obj.data)) {
    return fromArrayLike(obj.data)
  }
}

function checked (length) {
  // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= K_MAX_LENGTH) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + K_MAX_LENGTH.toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return b != null && b._isBuffer === true &&
    b !== Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
}

Buffer.compare = function compare (a, b) {
  if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength)
  if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength)
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError(
      'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
    )
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!Array.isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (isInstance(buf, Uint8Array)) {
      buf = Buffer.from(buf)
    }
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    throw new TypeError(
      'The "string" argument must be one of type string, Buffer, or ArrayBuffer. ' +
      'Received type ' + typeof string
    )
  }

  var len = string.length
  var mustMatch = (arguments.length > 2 && arguments[2] === true)
  if (!mustMatch && len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) {
          return mustMatch ? -1 : utf8ToBytes(string).length // assume utf8
        }
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.toLocaleString = Buffer.prototype.toString

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim()
  if (this.length > max) str += ' ... '
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (isInstance(target, Uint8Array)) {
    target = Buffer.from(target, target.offset, target.byteLength)
  }
  if (!Buffer.isBuffer(target)) {
    throw new TypeError(
      'The "target" argument must be one of type Buffer or Uint8Array. ' +
      'Received type ' + (typeof target)
    )
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset // Coerce to Number.
  if (numberIsNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  var strLen = string.length

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (numberIsNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset >>> 0
    if (isFinite(length)) {
      length = length >>> 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
        : (firstByte > 0xBF) ? 2
          : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + (bytes[i + 1] * 256))
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf = this.subarray(start, end)
  // Return an augmented `Uint8Array` instance
  newBuf.__proto__ = Buffer.prototype
  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  this[offset] = (value >>> 8)
  this[offset + 1] = (value & 0xff)
  return offset + 2
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  this[offset + 3] = (value >>> 24)
  this[offset + 2] = (value >>> 16)
  this[offset + 1] = (value >>> 8)
  this[offset] = (value & 0xff)
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  this[offset] = (value >>> 24)
  this[offset + 1] = (value >>> 16)
  this[offset + 2] = (value >>> 8)
  this[offset + 3] = (value & 0xff)
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    var limit = Math.pow(2, (8 * byteLength) - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    var limit = Math.pow(2, (8 * byteLength) - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  this[offset] = (value >>> 8)
  this[offset + 1] = (value & 0xff)
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  this[offset + 2] = (value >>> 16)
  this[offset + 3] = (value >>> 24)
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  this[offset] = (value >>> 24)
  this[offset + 1] = (value >>> 16)
  this[offset + 2] = (value >>> 8)
  this[offset + 3] = (value & 0xff)
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer')
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('Index out of range')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start

  if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') {
    // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end)
  } else if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (var i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, end),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if ((encoding === 'utf8' && code < 128) ||
          encoding === 'latin1') {
        // Fast path: If `val` fits into a single byte, use that numeric value.
        val = code
      }
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : Buffer.from(val, encoding)
    var len = bytes.length
    if (len === 0) {
      throw new TypeError('The value "' + val +
        '" is invalid for argument "value"')
    }
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node takes equal signs as end of the Base64 encoding
  str = str.split('=')[0]
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = str.trim().replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function isInstance (obj, type) {
  return obj instanceof type ||
    (obj != null && obj.constructor != null && obj.constructor.name != null &&
      obj.constructor.name === type.name)
}
function numberIsNaN (obj) {
  // For IE11 support
  return obj !== obj // eslint-disable-line no-self-compare
}

}).call(this)}).call(this,require("buffer").Buffer)

},{"base64-js":16,"buffer":20,"ieee754":114}],21:[function(require,module,exports){
module.exports = {
  "100": "Continue",
  "101": "Switching Protocols",
  "102": "Processing",
  "200": "OK",
  "201": "Created",
  "202": "Accepted",
  "203": "Non-Authoritative Information",
  "204": "No Content",
  "205": "Reset Content",
  "206": "Partial Content",
  "207": "Multi-Status",
  "208": "Already Reported",
  "226": "IM Used",
  "300": "Multiple Choices",
  "301": "Moved Permanently",
  "302": "Found",
  "303": "See Other",
  "304": "Not Modified",
  "305": "Use Proxy",
  "307": "Temporary Redirect",
  "308": "Permanent Redirect",
  "400": "Bad Request",
  "401": "Unauthorized",
  "402": "Payment Required",
  "403": "Forbidden",
  "404": "Not Found",
  "405": "Method Not Allowed",
  "406": "Not Acceptable",
  "407": "Proxy Authentication Required",
  "408": "Request Timeout",
  "409": "Conflict",
  "410": "Gone",
  "411": "Length Required",
  "412": "Precondition Failed",
  "413": "Payload Too Large",
  "414": "URI Too Long",
  "415": "Unsupported Media Type",
  "416": "Range Not Satisfiable",
  "417": "Expectation Failed",
  "418": "I'm a teapot",
  "421": "Misdirected Request",
  "422": "Unprocessable Entity",
  "423": "Locked",
  "424": "Failed Dependency",
  "425": "Unordered Collection",
  "426": "Upgrade Required",
  "428": "Precondition Required",
  "429": "Too Many Requests",
  "431": "Request Header Fields Too Large",
  "451": "Unavailable For Legal Reasons",
  "500": "Internal Server Error",
  "501": "Not Implemented",
  "502": "Bad Gateway",
  "503": "Service Unavailable",
  "504": "Gateway Timeout",
  "505": "HTTP Version Not Supported",
  "506": "Variant Also Negotiates",
  "507": "Insufficient Storage",
  "508": "Loop Detected",
  "509": "Bandwidth Limit Exceeded",
  "510": "Not Extended",
  "511": "Network Authentication Required"
}

},{}],22:[function(require,module,exports){
/**
* Cache data structure with:
*  - enumerable items
*  - unique hash item access (if none is passed in, one is generated)
*  - size (length) expiration
*  - controllable expiration (e.g. keep in cache longer if older/less likely to change)
*  - time-based expiration
*  - custom expiration based on passed-in function
*
* Also:
*  - built to work well with browserify
*  - pet friendly
*
* @author Steven Velozo <steven@velozo.com>
*/
const libFableServiceProviderBase = require('fable-serviceproviderbase');

const libLinkedList = require(`./LinkedList.js`);

class CashMoney extends libFableServiceProviderBase
{
	constructor(pFable, pManifest, pServiceHash)
	{
		if (pFable === undefined)
		{
			super({});
		}
		else
		{
			super(pFable, pManifest, pServiceHash);
		}

        this.serviceType = 'ObjectCache';

		// The map of node objects by hash because Reasons.
		this._HashMap = {};

		this._RecordMap = {};

		this._List = new libLinkedList();

		// If the list gets over maxLength, we will automatically remove nodes on insertion.
		this.maxLength = 0;

		// If cache entries get over this age, they are removed with prune
		this.maxAge = 0;
	}

	get RecordMap()
	{
		return this._RecordMap;
	}

	// Add (or update) a node in the cache
	put(pData, pHash)
	{
		// If the hash of the record exists
		if (this._HashMap.hasOwnProperty(pHash))
		{
			// Just update the hashed records datum
			this._HashMap[pHash].Datum = pData;
			this._RecordMap[pHash] = pData;
			return this._HashMap[pHash].Datum;
		}

		let tmpNode = this._List.push(pData, pHash);
		this._HashMap[tmpNode.Hash] = tmpNode;
		this._RecordMap[pHash] = pData;

		// Automatically prune if over length, but only prune this nodes worth.
		if (this.maxLength > 0   &&   this._List.length > this.maxLength)
		{
			// Pop it off the head of the list
			tmpNode = this._List.pop();
			// Also remove it from the hashmap
			delete this._RecordMap[tmpNode.Hash];
			delete this._HashMap[tmpNode.Hash];
		}

		// Now some expiration properties on the node metadata... namely the birthdate in ms of the node
		tmpNode.Metadata.Created = +new Date();

		return tmpNode.Datum;
	}

	// Read a datum by hash from the cache
	read(pHash)
	{
		if (!this._HashMap.hasOwnProperty(pHash))
		{
			return false;
		}

		return this._HashMap[pHash].Datum;
	}

	// Reinvigorate a node based on hash, updating the timestamp and moving it to the head of the list (also removes custom metadata)
	touch(pHash)
	{
		if (!this._HashMap.hasOwnProperty(pHash))
		{
			return false;
		}

		// Get the old node out of the list
		let tmpNode = this._List.remove(this._HashMap[pHash]);
		// Remove it from the hash map
		delete this._RecordMap[pHash];
		delete this._HashMap[pHash];

		// Now put it back, fresh.
		return this.put(tmpNode.Datum, tmpNode.Hash);
	}

	// Expire a cached record based on hash
	expire(pHash)
	{
		if (!this._HashMap.hasOwnProperty(pHash))
		{
			return false;
		}

		let tmpNode = this._HashMap[pHash];

		// Remove it from the list of cached records
		tmpNode = this._List.remove(tmpNode);
		// Also remove it from the hashmap
		delete this._RecordMap[tmpNode.Hash];
		delete this._HashMap[tmpNode.Hash];

		// Return it in case the consumer wants to do anything with it
		return tmpNode;
	}

	// Prune records from the cached set based on maxAge
	pruneBasedOnExpiration(fComplete, pRemovedRecords)
	{
		let tmpRemovedRecords = (typeof(pRemovedRecords) === 'undefined') ? [] : pRemovedRecords;

		if (this.maxAge < 1)
		{
			return fComplete(tmpRemovedRecords);
		}

		// Now enumerate each record and remove any that are expired
		let tmpNow = +new Date();
		let tmpKeys = Object.keys(this._HashMap);

		for (let i = 0; i < tmpKeys.length; i++)
		{
			// Expire the node if it is older than max age milliseconds
			if (tmpNow - this._HashMap[tmpKeys[i]].Metadata.Created >= this.maxAge)
			{
				tmpRemovedRecords.push(this.expire(tmpKeys[i]));
			}
		}
		fComplete(tmpRemovedRecords);
	}

	// Prune records from the cached set based on maxLength
	pruneBasedOnLength(fComplete, pRemovedRecords)
	{
		let tmpRemovedRecords = (typeof(pRemovedRecords) === 'undefined') ? [] : pRemovedRecords;

		// Pop records off until we have reached maxLength unless it's 0
		if (this.maxLength > 0)
		{
			while (this._List.length > this.maxLength)
			{
				tmpRemovedRecords.push(this._List.pop());
			}
		}

		return fComplete(tmpRemovedRecords);
	}

	// Prune records from the cached set based on passed in pPruneFunction(pDatum, pHash, pNode) -- returning true expires it
	pruneCustom(fComplete, fPruneFunction, pRemovedRecords)
	{
		let tmpRemovedRecords = (typeof(pRemovedRecords) === 'undefined') ? [] : pRemovedRecords;

		let tmpKeys = Object.keys(this._HashMap);
		for (let i = 0; i < tmpKeys.length; i++)
		{
			let tmpNode = this._HashMap[tmpKeys[i]];
			// Expire the node if the passed in function returns true
			if (fPruneFunction(tmpNode.Datum, tmpNode.Hash, tmpNode))
			{
				tmpRemovedRecords.push(this.expire(tmpKeys[i]));
			}
		}
		fComplete(tmpRemovedRecords);
	}

	// Prune the list down to the asserted rules (max age then max length if still too long)
	prune(fComplete)
	{
		let tmpRemovedRecords = [];

		// If there are no cached records, we are done.
		if (this._List.length < 1)
		{
			return fComplete(tmpRemovedRecords);
		}

		// Now prune based on expiration time
		this.pruneBasedOnExpiration((fExpirationPruneComplete)=>
			{
				// Now prune based on length, then return the removed records in the callback.
				this.pruneBasedOnLength(fComplete, tmpRemovedRecords);
			}, tmpRemovedRecords);
	}

	// Get a low level node (including metadata statistics) by hash from the cache
	getNode(pHash)
	{
		if (!this._HashMap.hasOwnProperty(pHash))
			return false;

		return this._HashMap[pHash];
	}
}

module.exports = CashMoney;
},{"./LinkedList.js":24,"fable-serviceproviderbase":59}],23:[function(require,module,exports){
/**
* Double Linked List Node
*
* @author Steven Velozo <steven@velozo.com>
* @module CashMoney
*/

/**
* Linked List Node Prototype
*
* @class LinkedListNode
* @constructor
*/

class LinkedListNode
{
	constructor()
	{
		this.Hash = false;
		this.Datum = false;

		// This is where expiration and other elements are stored;
		this.Metadata = {};

		this.LeftNode = false;
		this.RightNode = false;

		// To allow safe specialty operations on nodes
		this.__ISNODE = true;
	}
}

module.exports = LinkedListNode;
},{}],24:[function(require,module,exports){
"use strict"
/**
* Simple double linked list to hold the cache entries in, in order.
*
* @author Steven Velozo <steven@velozo.com>
* @module FeeFiFo
*/

const libLinkedListNode = require('./LinkedList-Node.js');

/**
* Quality Cache Goodness
*
* @class CashMoney
* @constructor
*/

class LinkedList
{
	constructor()
	{
		// Total number of nodes ever processed by this ADT
		this.totalNodes = 0;

		// The length of the set of nodes currently in the list
		this.length = 0;

		this.head = false;
		this.tail = false;
	}

	// Create a node object.
	initializeNode(pDatum, pHash)
	{
		// Don't allow undefined to be added to the list because of reasons
		if (typeof(pDatum) === 'undefined')
			return false;

		this.totalNodes++;

		// Get (or create) a unique hash
		let tmpHash = (typeof(pHash) != 'undefined') ? pHash : `NODE[${this.totalNodes}]`;

		let tmpNode = new libLinkedListNode();

		tmpNode.Hash = tmpHash;
		tmpNode.Datum = pDatum;

		return tmpNode;
	}

	// Add a node to the end (right of tail) of the list.
	append(pDatum, pHash)
	{
		// TODO: Should we check if pDatum is actually a node and do the "right" thing?
		let tmpNode = this.initializeNode(pDatum, pHash);
		if (!tmpNode)
			return false;

		// The list just got longer!
		this.length++;

		// If the list was empty, create a new list from it (it isn't possible to have a tail with no head)
		if (this.length == 1)
		{
			this.head = tmpNode;
			this.tail = tmpNode;
			return tmpNode;
		}

		this.tail.RightNode = tmpNode;
		tmpNode.LeftNode = this.tail;
		this.tail = tmpNode;

		return tmpNode;
	}

	// Append to tail of list (FIFO)
	push(pDatum, pHash)
	{
		return this.append(pDatum, pHash);
	}

	// Add a node to the beginning (left of head) of the list.
	prepend(pDatum, pHash)
	{
		// TODO: Should we check if pDatum is actually a node and do the "right" thing?
		let tmpNode = this.initializeNode(pDatum, pHash);
		if (!tmpNode)
			return false;

		// The list just got longer!
		this.length++;

		// If the list was empty, create a new list from it (it isn't possible to have a tail with no head)
		if (this.length == 1)
		{
			this.head = tmpNode;
			this.tail = tmpNode;
			return tmpNode;
		}

		this.head.LeftNode = tmpNode;
		tmpNode.RightNode = this.head;
		this.head = tmpNode;
		return tmpNode;
	}

	// Remove a node from the list
	remove(pNode)
	{
		if (typeof(pNode) === 'undefined')
			return false;

		if (!pNode.__ISNODE)
			return false;

		this.length--;

		// Last element in list.  Empty it out.
		if (this.length < 1)
		{
			this.head = false;
			this.tail = false;
			return pNode;
		}

		// It's somewhere in the middle, surgically remove it.
		if (pNode.LeftNode && pNode.RightNode)
		{
			pNode.LeftNode.RightNode = pNode.RightNode;
			pNode.RightNode.LeftNode = pNode.LeftNode;

			pNode.RightNode = false;
			pNode.LeftNode = false;
			return pNode;
		}

		// It's the tail
		if (pNode.LeftNode)
		{
			pNode.LeftNode.RightNode = false;
			this.tail = pNode.LeftNode;
			pNode.LeftNode = false;
			return pNode;
		}

		// It must be the head
		pNode.RightNode.LeftNode = false;
		this.head = pNode.RightNode;
		pNode.RightNode = false;
		return pNode;
	}

	// Remove the head of the list (FIFO)
	pop()
	{
		return this.remove(this.head);
	}

	// Enumerate over each node IN ORDER, running the function fAction(pDatum, pHash, fCallback) then calling the function fComplete callback when done
	each(fAction, fComplete)
	{
		if (this.length < 1)
			return fComplete();

		let tmpNode = false;

		let fIterator = (pError)=>
		{
			// If the user passed in a callback with an error, call their callback with the error
			if (pError)
				return fComplete(pError);

			// If there is no node, this must be the initial run.
			if (!tmpNode)
				tmpNode = this.head;
			// Check if we are at the tail of the list
			else if (!tmpNode.RightNode)
				return fComplete();
			// Proceed to the next node
			else
				tmpNode = tmpNode.RightNode;

			// Call the actual action
			// I hate this pattern because long tails eventually cause stack overflows.
			fAction(tmpNode.Datum, tmpNode.Hash, fIterator);
		};

		// Now kick off the iterator
		return fIterator();
	}

	// Seek a specific node, 0 is the index of the first node.
	seek(pNodeIndex)
	{
		if (!pNodeIndex)
			return false;
		if (this.length < 1)
			return false;
		if (pNodeIndex >= this.length)
			return false;

		let tmpNode = this.head;
		for (let i = 0; i < pNodeIndex; i++)
		{
			tmpNode = tmpNode.RightNode;
		}

		return tmpNode;
	}
}

module.exports = LinkedList;
},{"./LinkedList-Node.js":23}],25:[function(require,module,exports){
'use strict';

var bind = require('function-bind');

var $apply = require('./functionApply');
var $call = require('./functionCall');
var $reflectApply = require('./reflectApply');

/** @type {import('./actualApply')} */
module.exports = $reflectApply || bind.call($call, $apply);

},{"./functionApply":26,"./functionCall":27,"./reflectApply":29,"function-bind":103}],26:[function(require,module,exports){
'use strict';

/** @type {import('./functionApply')} */
module.exports = Function.prototype.apply;

},{}],27:[function(require,module,exports){
'use strict';

/** @type {import('./functionCall')} */
module.exports = Function.prototype.call;

},{}],28:[function(require,module,exports){
'use strict';

var bind = require('function-bind');
var $TypeError = require('es-errors/type');

var $call = require('./functionCall');
var $actualApply = require('./actualApply');

/** @type {(args: [Function, thisArg?: unknown, ...args: unknown[]]) => Function} TODO FIXME, find a way to use import('.') */
module.exports = function callBindBasic(args) {
	if (args.length < 1 || typeof args[0] !== 'function') {
		throw new $TypeError('a function is required');
	}
	return $actualApply(bind, $call, args);
};

},{"./actualApply":25,"./functionCall":27,"es-errors/type":47,"function-bind":103}],29:[function(require,module,exports){
'use strict';

/** @type {import('./reflectApply')} */
module.exports = typeof Reflect !== 'undefined' && Reflect && Reflect.apply;

},{}],30:[function(require,module,exports){
'use strict';

var GetIntrinsic = require('get-intrinsic');

var callBindBasic = require('call-bind-apply-helpers');

/** @type {(thisArg: string, searchString: string, position?: number) => number} */
var $indexOf = callBindBasic([GetIntrinsic('%String.prototype.indexOf%')]);

/** @type {import('.')} */
module.exports = function callBoundIntrinsic(name, allowMissing) {
	/* eslint no-extra-parens: 0 */

	var intrinsic = /** @type {(this: unknown, ...args: unknown[]) => unknown} */ (GetIntrinsic(name, !!allowMissing));
	if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) {
		return callBindBasic(/** @type {const} */ ([intrinsic]));
	}
	return intrinsic;
};

},{"call-bind-apply-helpers":28,"get-intrinsic":104}],31:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseCookie = parseCookie;
exports.parse = parseCookie;
exports.stringifyCookie = stringifyCookie;
exports.stringifySetCookie = stringifySetCookie;
exports.serialize = stringifySetCookie;
exports.parseSetCookie = parseSetCookie;
exports.stringifySetCookie = stringifySetCookie;
exports.serialize = stringifySetCookie;
/**
 * RegExp to match cookie-name in RFC 6265 sec 4.1.1
 * This refers out to the obsoleted definition of token in RFC 2616 sec 2.2
 * which has been replaced by the token definition in RFC 7230 appendix B.
 *
 * cookie-name       = token
 * token             = 1*tchar
 * tchar             = "!" / "#" / "$" / "%" / "&" / "'" /
 *                     "*" / "+" / "-" / "." / "^" / "_" /
 *                     "`" / "|" / "~" / DIGIT / ALPHA
 *
 * Note: Allowing more characters - https://github.com/jshttp/cookie/issues/191
 * Allow same range as cookie value, except `=`, which delimits end of name.
 */
const cookieNameRegExp = /^[\u0021-\u003A\u003C\u003E-\u007E]+$/;
/**
 * RegExp to match cookie-value in RFC 6265 sec 4.1.1
 *
 * cookie-value      = *cookie-octet / ( DQUOTE *cookie-octet DQUOTE )
 * cookie-octet      = %x21 / %x23-2B / %x2D-3A / %x3C-5B / %x5D-7E
 *                     ; US-ASCII characters excluding CTLs,
 *                     ; whitespace DQUOTE, comma, semicolon,
 *                     ; and backslash
 *
 * Allowing more characters: https://github.com/jshttp/cookie/issues/191
 * Comma, backslash, and DQUOTE are not part of the parsing algorithm.
 */
const cookieValueRegExp = /^[\u0021-\u003A\u003C-\u007E]*$/;
/**
 * RegExp to match domain-value in RFC 6265 sec 4.1.1
 *
 * domain-value      = <subdomain>
 *                     ; defined in [RFC1034], Section 3.5, as
 *                     ; enhanced by [RFC1123], Section 2.1
 * <subdomain>       = <label> | <subdomain> "." <label>
 * <label>           = <let-dig> [ [ <ldh-str> ] <let-dig> ]
 *                     Labels must be 63 characters or less.
 *                     'let-dig' not 'letter' in the first char, per RFC1123
 * <ldh-str>         = <let-dig-hyp> | <let-dig-hyp> <ldh-str>
 * <let-dig-hyp>     = <let-dig> | "-"
 * <let-dig>         = <letter> | <digit>
 * <letter>          = any one of the 52 alphabetic characters A through Z in
 *                     upper case and a through z in lower case
 * <digit>           = any one of the ten digits 0 through 9
 *
 * Keep support for leading dot: https://github.com/jshttp/cookie/issues/173
 *
 * > (Note that a leading %x2E ("."), if present, is ignored even though that
 * character is not permitted, but a trailing %x2E ("."), if present, will
 * cause the user agent to ignore the attribute.)
 */
const domainValueRegExp = /^([.]?[a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?)([.][a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?)*$/i;
/**
 * RegExp to match path-value in RFC 6265 sec 4.1.1
 *
 * path-value        = <any CHAR except CTLs or ";">
 * CHAR              = %x01-7F
 *                     ; defined in RFC 5234 appendix B.1
 */
const pathValueRegExp = /^[\u0020-\u003A\u003D-\u007E]*$/;
/**
 * RegExp to match max-age-value in RFC 6265 sec 5.6.2
 */
const maxAgeRegExp = /^-?\d+$/;
const __toString = Object.prototype.toString;
const NullObject = /* @__PURE__ */ (() => {
    const C = function () { };
    C.prototype = Object.create(null);
    return C;
})();
/**
 * Parse a `Cookie` header.
 *
 * Parse the given cookie header string into an object
 * The object has the various cookies as keys(names) => values
 */
function parseCookie(str, options) {
    const obj = new NullObject();
    const len = str.length;
    // RFC 6265 sec 4.1.1, RFC 2616 2.2 defines a cookie name consists of one char minimum, plus '='.
    if (len < 2)
        return obj;
    const dec = options?.decode || decode;
    let index = 0;
    do {
        const eqIdx = eqIndex(str, index, len);
        if (eqIdx === -1)
            break; // No more cookie pairs.
        const endIdx = endIndex(str, index, len);
        if (eqIdx > endIdx) {
            // backtrack on prior semicolon
            index = str.lastIndexOf(";", eqIdx - 1) + 1;
            continue;
        }
        const key = valueSlice(str, index, eqIdx);
        // only assign once
        if (obj[key] === undefined) {
            obj[key] = dec(valueSlice(str, eqIdx + 1, endIdx));
        }
        index = endIdx + 1;
    } while (index < len);
    return obj;
}
/**
 * Stringifies an object into an HTTP `Cookie` header.
 */
function stringifyCookie(cookie, options) {
    const enc = options?.encode || encodeURIComponent;
    const cookieStrings = [];
    for (const name of Object.keys(cookie)) {
        const val = cookie[name];
        if (val === undefined)
            continue;
        if (!cookieNameRegExp.test(name)) {
            throw new TypeError(`cookie name is invalid: ${name}`);
        }
        const value = enc(val);
        if (!cookieValueRegExp.test(value)) {
            throw new TypeError(`cookie val is invalid: ${val}`);
        }
        cookieStrings.push(`${name}=${value}`);
    }
    return cookieStrings.join("; ");
}
function stringifySetCookie(_name, _val, _opts) {
    const cookie = typeof _name === "object"
        ? _name
        : { ..._opts, name: _name, value: String(_val) };
    const options = typeof _val === "object" ? _val : _opts;
    const enc = options?.encode || encodeURIComponent;
    if (!cookieNameRegExp.test(cookie.name)) {
        throw new TypeError(`argument name is invalid: ${cookie.name}`);
    }
    const value = cookie.value ? enc(cookie.value) : "";
    if (!cookieValueRegExp.test(value)) {
        throw new TypeError(`argument val is invalid: ${cookie.value}`);
    }
    let str = cookie.name + "=" + value;
    if (cookie.maxAge !== undefined) {
        if (!Number.isInteger(cookie.maxAge)) {
            throw new TypeError(`option maxAge is invalid: ${cookie.maxAge}`);
        }
        str += "; Max-Age=" + cookie.maxAge;
    }
    if (cookie.domain) {
        if (!domainValueRegExp.test(cookie.domain)) {
            throw new TypeError(`option domain is invalid: ${cookie.domain}`);
        }
        str += "; Domain=" + cookie.domain;
    }
    if (cookie.path) {
        if (!pathValueRegExp.test(cookie.path)) {
            throw new TypeError(`option path is invalid: ${cookie.path}`);
        }
        str += "; Path=" + cookie.path;
    }
    if (cookie.expires) {
        if (!isDate(cookie.expires) || !Number.isFinite(cookie.expires.valueOf())) {
            throw new TypeError(`option expires is invalid: ${cookie.expires}`);
        }
        str += "; Expires=" + cookie.expires.toUTCString();
    }
    if (cookie.httpOnly) {
        str += "; HttpOnly";
    }
    if (cookie.secure) {
        str += "; Secure";
    }
    if (cookie.partitioned) {
        str += "; Partitioned";
    }
    if (cookie.priority) {
        const priority = typeof cookie.priority === "string"
            ? cookie.priority.toLowerCase()
            : undefined;
        switch (priority) {
            case "low":
                str += "; Priority=Low";
                break;
            case "medium":
                str += "; Priority=Medium";
                break;
            case "high":
                str += "; Priority=High";
                break;
            default:
                throw new TypeError(`option priority is invalid: ${cookie.priority}`);
        }
    }
    if (cookie.sameSite) {
        const sameSite = typeof cookie.sameSite === "string"
            ? cookie.sameSite.toLowerCase()
            : cookie.sameSite;
        switch (sameSite) {
            case true:
            case "strict":
                str += "; SameSite=Strict";
                break;
            case "lax":
                str += "; SameSite=Lax";
                break;
            case "none":
                str += "; SameSite=None";
                break;
            default:
                throw new TypeError(`option sameSite is invalid: ${cookie.sameSite}`);
        }
    }
    return str;
}
/**
 * Deserialize a `Set-Cookie` header into an object.
 *
 * deserialize('foo=bar; httpOnly')
 *   => { name: 'foo', value: 'bar', httpOnly: true }
 */
function parseSetCookie(str, options) {
    const dec = options?.decode || decode;
    const len = str.length;
    const endIdx = endIndex(str, 0, len);
    const eqIdx = eqIndex(str, 0, endIdx);
    const setCookie = eqIdx === -1
        ? { name: "", value: dec(valueSlice(str, 0, endIdx)) }
        : {
            name: valueSlice(str, 0, eqIdx),
            value: dec(valueSlice(str, eqIdx + 1, endIdx)),
        };
    let index = endIdx + 1;
    while (index < len) {
        const endIdx = endIndex(str, index, len);
        const eqIdx = eqIndex(str, index, endIdx);
        const attr = eqIdx === -1
            ? valueSlice(str, index, endIdx)
            : valueSlice(str, index, eqIdx);
        const val = eqIdx === -1 ? undefined : valueSlice(str, eqIdx + 1, endIdx);
        switch (attr.toLowerCase()) {
            case "httponly":
                setCookie.httpOnly = true;
                break;
            case "secure":
                setCookie.secure = true;
                break;
            case "partitioned":
                setCookie.partitioned = true;
                break;
            case "domain":
                setCookie.domain = val;
                break;
            case "path":
                setCookie.path = val;
                break;
            case "max-age":
                if (val && maxAgeRegExp.test(val))
                    setCookie.maxAge = Number(val);
                break;
            case "expires":
                if (!val)
                    break;
                const date = new Date(val);
                if (Number.isFinite(date.valueOf()))
                    setCookie.expires = date;
                break;
            case "priority":
                if (!val)
                    break;
                const priority = val.toLowerCase();
                if (priority === "low" ||
                    priority === "medium" ||
                    priority === "high") {
                    setCookie.priority = priority;
                }
                break;
            case "samesite":
                if (!val)
                    break;
                const sameSite = val.toLowerCase();
                if (sameSite === "lax" ||
                    sameSite === "strict" ||
                    sameSite === "none") {
                    setCookie.sameSite = sameSite;
                }
                break;
        }
        index = endIdx + 1;
    }
    return setCookie;
}
/**
 * Find the `;` character between `min` and `len` in str.
 */
function endIndex(str, min, len) {
    const index = str.indexOf(";", min);
    return index === -1 ? len : index;
}
/**
 * Find the `=` character between `min` and `max` in str.
 */
function eqIndex(str, min, max) {
    const index = str.indexOf("=", min);
    return index < max ? index : -1;
}
/**
 * Slice out a value between startPod to max.
 */
function valueSlice(str, min, max) {
    let start = min;
    let end = max;
    do {
        const code = str.charCodeAt(start);
        if (code !== 0x20 /*   */ && code !== 0x09 /* \t */)
            break;
    } while (++start < end);
    while (end > start) {
        const code = str.charCodeAt(end - 1);
        if (code !== 0x20 /*   */ && code !== 0x09 /* \t */)
            break;
        end--;
    }
    return str.slice(start, end);
}
/**
 * URL-decode string value. Optimized to skip native call when no %.
 */
function decode(str) {
    if (str.indexOf("%") === -1)
        return str;
    try {
        return decodeURIComponent(str);
    }
    catch (e) {
        return str;
    }
}
/**
 * Determine if value is a Date.
 */
function isDate(val) {
    return __toString.call(val) === "[object Date]";
}

},{}],32:[function(require,module,exports){
!function(t,e){"object"==typeof exports&&"undefined"!=typeof module?module.exports=e():"function"==typeof define&&define.amd?define(e):(t="undefined"!=typeof globalThis?globalThis:t||self).dayjs=e()}(this,(function(){"use strict";var t=1e3,e=6e4,n=36e5,r="millisecond",i="second",s="minute",u="hour",a="day",o="week",c="month",f="quarter",h="year",d="date",l="Invalid Date",$=/^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/,y=/\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g,M={name:"en",weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_"),ordinal:function(t){var e=["th","st","nd","rd"],n=t%100;return"["+t+(e[(n-20)%10]||e[n]||e[0])+"]"}},m=function(t,e,n){var r=String(t);return!r||r.length>=e?t:""+Array(e+1-r.length).join(n)+t},v={s:m,z:function(t){var e=-t.utcOffset(),n=Math.abs(e),r=Math.floor(n/60),i=n%60;return(e<=0?"+":"-")+m(r,2,"0")+":"+m(i,2,"0")},m:function t(e,n){if(e.date()<n.date())return-t(n,e);var r=12*(n.year()-e.year())+(n.month()-e.month()),i=e.clone().add(r,c),s=n-i<0,u=e.clone().add(r+(s?-1:1),c);return+(-(r+(n-i)/(s?i-u:u-i))||0)},a:function(t){return t<0?Math.ceil(t)||0:Math.floor(t)},p:function(t){return{M:c,y:h,w:o,d:a,D:d,h:u,m:s,s:i,ms:r,Q:f}[t]||String(t||"").toLowerCase().replace(/s$/,"")},u:function(t){return void 0===t}},g="en",D={};D[g]=M;var p="$isDayjsObject",S=function(t){return t instanceof _||!(!t||!t[p])},w=function t(e,n,r){var i;if(!e)return g;if("string"==typeof e){var s=e.toLowerCase();D[s]&&(i=s),n&&(D[s]=n,i=s);var u=e.split("-");if(!i&&u.length>1)return t(u[0])}else{var a=e.name;D[a]=e,i=a}return!r&&i&&(g=i),i||!r&&g},O=function(t,e){if(S(t))return t.clone();var n="object"==typeof e?e:{};return n.date=t,n.args=arguments,new _(n)},b=v;b.l=w,b.i=S,b.w=function(t,e){return O(t,{locale:e.$L,utc:e.$u,x:e.$x,$offset:e.$offset})};var _=function(){function M(t){this.$L=w(t.locale,null,!0),this.parse(t),this.$x=this.$x||t.x||{},this[p]=!0}var m=M.prototype;return m.parse=function(t){this.$d=function(t){var e=t.date,n=t.utc;if(null===e)return new Date(NaN);if(b.u(e))return new Date;if(e instanceof Date)return new Date(e);if("string"==typeof e&&!/Z$/i.test(e)){var r=e.match($);if(r){var i=r[2]-1||0,s=(r[7]||"0").substring(0,3);return n?new Date(Date.UTC(r[1],i,r[3]||1,r[4]||0,r[5]||0,r[6]||0,s)):new Date(r[1],i,r[3]||1,r[4]||0,r[5]||0,r[6]||0,s)}}return new Date(e)}(t),this.init()},m.init=function(){var t=this.$d;this.$y=t.getFullYear(),this.$M=t.getMonth(),this.$D=t.getDate(),this.$W=t.getDay(),this.$H=t.getHours(),this.$m=t.getMinutes(),this.$s=t.getSeconds(),this.$ms=t.getMilliseconds()},m.$utils=function(){return b},m.isValid=function(){return!(this.$d.toString()===l)},m.isSame=function(t,e){var n=O(t);return this.startOf(e)<=n&&n<=this.endOf(e)},m.isAfter=function(t,e){return O(t)<this.startOf(e)},m.isBefore=function(t,e){return this.endOf(e)<O(t)},m.$g=function(t,e,n){return b.u(t)?this[e]:this.set(n,t)},m.unix=function(){return Math.floor(this.valueOf()/1e3)},m.valueOf=function(){return this.$d.getTime()},m.startOf=function(t,e){var n=this,r=!!b.u(e)||e,f=b.p(t),l=function(t,e){var i=b.w(n.$u?Date.UTC(n.$y,e,t):new Date(n.$y,e,t),n);return r?i:i.endOf(a)},$=function(t,e){return b.w(n.toDate()[t].apply(n.toDate("s"),(r?[0,0,0,0]:[23,59,59,999]).slice(e)),n)},y=this.$W,M=this.$M,m=this.$D,v="set"+(this.$u?"UTC":"");switch(f){case h:return r?l(1,0):l(31,11);case c:return r?l(1,M):l(0,M+1);case o:var g=this.$locale().weekStart||0,D=(y<g?y+7:y)-g;return l(r?m-D:m+(6-D),M);case a:case d:return $(v+"Hours",0);case u:return $(v+"Minutes",1);case s:return $(v+"Seconds",2);case i:return $(v+"Milliseconds",3);default:return this.clone()}},m.endOf=function(t){return this.startOf(t,!1)},m.$set=function(t,e){var n,o=b.p(t),f="set"+(this.$u?"UTC":""),l=(n={},n[a]=f+"Date",n[d]=f+"Date",n[c]=f+"Month",n[h]=f+"FullYear",n[u]=f+"Hours",n[s]=f+"Minutes",n[i]=f+"Seconds",n[r]=f+"Milliseconds",n)[o],$=o===a?this.$D+(e-this.$W):e;if(o===c||o===h){var y=this.clone().set(d,1);y.$d[l]($),y.init(),this.$d=y.set(d,Math.min(this.$D,y.daysInMonth())).$d}else l&&this.$d[l]($);return this.init(),this},m.set=function(t,e){return this.clone().$set(t,e)},m.get=function(t){return this[b.p(t)]()},m.add=function(r,f){var d,l=this;r=Number(r);var $=b.p(f),y=function(t){var e=O(l);return b.w(e.date(e.date()+Math.round(t*r)),l)};if($===c)return this.set(c,this.$M+r);if($===h)return this.set(h,this.$y+r);if($===a)return y(1);if($===o)return y(7);var M=(d={},d[s]=e,d[u]=n,d[i]=t,d)[$]||1,m=this.$d.getTime()+r*M;return b.w(m,this)},m.subtract=function(t,e){return this.add(-1*t,e)},m.format=function(t){var e=this,n=this.$locale();if(!this.isValid())return n.invalidDate||l;var r=t||"YYYY-MM-DDTHH:mm:ssZ",i=b.z(this),s=this.$H,u=this.$m,a=this.$M,o=n.weekdays,c=n.months,f=n.meridiem,h=function(t,n,i,s){return t&&(t[n]||t(e,r))||i[n].slice(0,s)},d=function(t){return b.s(s%12||12,t,"0")},$=f||function(t,e,n){var r=t<12?"AM":"PM";return n?r.toLowerCase():r};return r.replace(y,(function(t,r){return r||function(t){switch(t){case"YY":return String(e.$y).slice(-2);case"YYYY":return b.s(e.$y,4,"0");case"M":return a+1;case"MM":return b.s(a+1,2,"0");case"MMM":return h(n.monthsShort,a,c,3);case"MMMM":return h(c,a);case"D":return e.$D;case"DD":return b.s(e.$D,2,"0");case"d":return String(e.$W);case"dd":return h(n.weekdaysMin,e.$W,o,2);case"ddd":return h(n.weekdaysShort,e.$W,o,3);case"dddd":return o[e.$W];case"H":return String(s);case"HH":return b.s(s,2,"0");case"h":return d(1);case"hh":return d(2);case"a":return $(s,u,!0);case"A":return $(s,u,!1);case"m":return String(u);case"mm":return b.s(u,2,"0");case"s":return String(e.$s);case"ss":return b.s(e.$s,2,"0");case"SSS":return b.s(e.$ms,3,"0");case"Z":return i}return null}(t)||i.replace(":","")}))},m.utcOffset=function(){return 15*-Math.round(this.$d.getTimezoneOffset()/15)},m.diff=function(r,d,l){var $,y=this,M=b.p(d),m=O(r),v=(m.utcOffset()-this.utcOffset())*e,g=this-m,D=function(){return b.m(y,m)};switch(M){case h:$=D()/12;break;case c:$=D();break;case f:$=D()/3;break;case o:$=(g-v)/6048e5;break;case a:$=(g-v)/864e5;break;case u:$=g/n;break;case s:$=g/e;break;case i:$=g/t;break;default:$=g}return l?$:b.a($)},m.daysInMonth=function(){return this.endOf(c).$D},m.$locale=function(){return D[this.$L]},m.locale=function(t,e){if(!t)return this.$L;var n=this.clone(),r=w(t,e,!0);return r&&(n.$L=r),n},m.clone=function(){return b.w(this.$d,this)},m.toDate=function(){return new Date(this.valueOf())},m.toJSON=function(){return this.isValid()?this.toISOString():null},m.toISOString=function(){return this.$d.toISOString()},m.toString=function(){return this.$d.toUTCString()},M}(),k=_.prototype;return O.prototype=k,[["$ms",r],["$s",i],["$m",s],["$H",u],["$W",a],["$M",c],["$y",h],["$D",d]].forEach((function(t){k[t[1]]=function(e){return this.$g(e,t[0],t[1])}})),O.extend=function(t,e){return t.$i||(t(e,_,O),t.$i=!0),O},O.locale=w,O.isDayjs=S,O.unix=function(t){return O(1e3*t)},O.en=D[g],O.Ls=D,O.p={},O}));
},{}],33:[function(require,module,exports){
!function(e,t){"object"==typeof exports&&"undefined"!=typeof module?module.exports=t():"function"==typeof define&&define.amd?define(t):(e="undefined"!=typeof globalThis?globalThis:e||self).dayjs_plugin_advancedFormat=t()}(this,(function(){"use strict";return function(e,t){var r=t.prototype,n=r.format;r.format=function(e){var t=this,r=this.$locale();if(!this.isValid())return n.bind(this)(e);var s=this.$utils(),a=(e||"YYYY-MM-DDTHH:mm:ssZ").replace(/\[([^\]]+)]|Q|wo|ww|w|WW|W|zzz|z|gggg|GGGG|Do|X|x|k{1,2}|S/g,(function(e){switch(e){case"Q":return Math.ceil((t.$M+1)/3);case"Do":return r.ordinal(t.$D);case"gggg":return t.weekYear();case"GGGG":return t.isoWeekYear();case"wo":return r.ordinal(t.week(),"W");case"w":case"ww":return s.s(t.week(),"w"===e?1:2,"0");case"W":case"WW":return s.s(t.isoWeek(),"W"===e?1:2,"0");case"k":case"kk":return s.s(String(0===t.$H?24:t.$H),"k"===e?1:2,"0");case"X":return Math.floor(t.$d.getTime()/1e3);case"x":return t.$d.getTime();case"z":return"["+t.offsetName()+"]";case"zzz":return"["+t.offsetName("long")+"]";default:return e}}));return n.bind(this)(a)}}}));
},{}],34:[function(require,module,exports){
!function(e,t){"object"==typeof exports&&"undefined"!=typeof module?module.exports=t():"function"==typeof define&&define.amd?define(t):(e="undefined"!=typeof globalThis?globalThis:e||self).dayjs_plugin_isoWeek=t()}(this,(function(){"use strict";var e="day";return function(t,i,s){var a=function(t){return t.add(4-t.isoWeekday(),e)},d=i.prototype;d.isoWeekYear=function(){return a(this).year()},d.isoWeek=function(t){if(!this.$utils().u(t))return this.add(7*(t-this.isoWeek()),e);var i,d,n,o,r=a(this),u=(i=this.isoWeekYear(),d=this.$u,n=(d?s.utc:s)().year(i).startOf("year"),o=4-n.isoWeekday(),n.isoWeekday()>4&&(o+=7),n.add(o,e));return r.diff(u,"week")+1},d.isoWeekday=function(e){return this.$utils().u(e)?this.day()||7:this.day(this.day()%7?e:e-7)};var n=d.startOf;d.startOf=function(e,t){var i=this.$utils(),s=!!i.u(t)||t;return"isoweek"===i.p(e)?s?this.date(this.date()-(this.isoWeekday()-1)).startOf("day"):this.date(this.date()-1-(this.isoWeekday()-1)+7).endOf("day"):n.bind(this)(e,t)}}}));
},{}],35:[function(require,module,exports){
!function(r,e){"object"==typeof exports&&"undefined"!=typeof module?module.exports=e():"function"==typeof define&&define.amd?define(e):(r="undefined"!=typeof globalThis?globalThis:r||self).dayjs_plugin_relativeTime=e()}(this,(function(){"use strict";return function(r,e,t){r=r||{};var n=e.prototype,o={future:"in %s",past:"%s ago",s:"a few seconds",m:"a minute",mm:"%d minutes",h:"an hour",hh:"%d hours",d:"a day",dd:"%d days",M:"a month",MM:"%d months",y:"a year",yy:"%d years"};function i(r,e,t,o){return n.fromToBase(r,e,t,o)}t.en.relativeTime=o,n.fromToBase=function(e,n,i,d,u){for(var f,a,s,l=i.$locale().relativeTime||o,h=r.thresholds||[{l:"s",r:44,d:"second"},{l:"m",r:89},{l:"mm",r:44,d:"minute"},{l:"h",r:89},{l:"hh",r:21,d:"hour"},{l:"d",r:35},{l:"dd",r:25,d:"day"},{l:"M",r:45},{l:"MM",r:10,d:"month"},{l:"y",r:17},{l:"yy",d:"year"}],m=h.length,c=0;c<m;c+=1){var y=h[c];y.d&&(f=d?t(e).diff(i,y.d,!0):i.diff(e,y.d,!0));var p=(r.rounding||Math.round)(Math.abs(f));if(s=f>0,p<=y.r||!y.r){p<=1&&c>0&&(y=h[c-1]);var v=l[y.l];u&&(p=u(""+p)),a="string"==typeof v?v.replace("%d",p):v(p,n,y.l,s);break}}if(n)return a;var M=s?l.future:l.past;return"function"==typeof M?M(a):M.replace("%s",a)},n.to=function(r,e){return i(r,e,this,!0)},n.from=function(r,e){return i(r,e,this)};var d=function(r){return r.$u?t.utc():t()};n.toNow=function(r){return this.to(d(this),r)},n.fromNow=function(r){return this.from(d(this),r)}}}));
},{}],36:[function(require,module,exports){
!function(t,e){"object"==typeof exports&&"undefined"!=typeof module?module.exports=e():"function"==typeof define&&define.amd?define(e):(t="undefined"!=typeof globalThis?globalThis:t||self).dayjs_plugin_timezone=e()}(this,(function(){"use strict";var t={year:0,month:1,day:2,hour:3,minute:4,second:5},e={};return function(n,i,o){var r,a=function(t,n,i){void 0===i&&(i={});var o=new Date(t),r=function(t,n){void 0===n&&(n={});var i=n.timeZoneName||"short",o=t+"|"+i,r=e[o];return r||(r=new Intl.DateTimeFormat("en-US",{hour12:!1,timeZone:t,year:"numeric",month:"2-digit",day:"2-digit",hour:"2-digit",minute:"2-digit",second:"2-digit",timeZoneName:i}),e[o]=r),r}(n,i);return r.formatToParts(o)},u=function(e,n){for(var i=a(e,n),r=[],u=0;u<i.length;u+=1){var f=i[u],s=f.type,m=f.value,c=t[s];c>=0&&(r[c]=parseInt(m,10))}var d=r[3],l=24===d?0:d,h=r[0]+"-"+r[1]+"-"+r[2]+" "+l+":"+r[4]+":"+r[5]+":000",v=+e;return(o.utc(h).valueOf()-(v-=v%1e3))/6e4},f=i.prototype;f.tz=function(t,e){void 0===t&&(t=r);var n,i=this.utcOffset(),a=this.toDate(),u=a.toLocaleString("en-US",{timeZone:t}),f=Math.round((a-new Date(u))/1e3/60),s=15*-Math.round(a.getTimezoneOffset()/15)-f;if(!Number(s))n=this.utcOffset(0,e);else if(n=o(u,{locale:this.$L}).$set("millisecond",this.$ms).utcOffset(s,!0),e){var m=n.utcOffset();n=n.add(i-m,"minute")}return n.$x.$timezone=t,n},f.offsetName=function(t){var e=this.$x.$timezone||o.tz.guess(),n=a(this.valueOf(),e,{timeZoneName:t}).find((function(t){return"timezonename"===t.type.toLowerCase()}));return n&&n.value};var s=f.startOf;f.startOf=function(t,e){if(!this.$x||!this.$x.$timezone)return s.call(this,t,e);var n=o(this.format("YYYY-MM-DD HH:mm:ss:SSS"),{locale:this.$L});return s.call(n,t,e).tz(this.$x.$timezone,!0)},o.tz=function(t,e,n){var i=n&&e,a=n||e||r,f=u(+o(),a);if("string"!=typeof t)return o(t).tz(a);var s=function(t,e,n){var i=t-60*e*1e3,o=u(i,n);if(e===o)return[i,e];var r=u(i-=60*(o-e)*1e3,n);return o===r?[i,o]:[t-60*Math.min(o,r)*1e3,Math.max(o,r)]}(o.utc(t,i).valueOf(),f,a),m=s[0],c=s[1],d=o(m).utcOffset(c);return d.$x.$timezone=a,d},o.tz.guess=function(){return Intl.DateTimeFormat().resolvedOptions().timeZone},o.tz.setDefault=function(t){r=t}}}));
},{}],37:[function(require,module,exports){
!function(t,i){"object"==typeof exports&&"undefined"!=typeof module?module.exports=i():"function"==typeof define&&define.amd?define(i):(t="undefined"!=typeof globalThis?globalThis:t||self).dayjs_plugin_utc=i()}(this,(function(){"use strict";var t="minute",i=/[+-]\d\d(?::?\d\d)?/g,e=/([+-]|\d\d)/g;return function(s,f,n){var u=f.prototype;n.utc=function(t){var i={date:t,utc:!0,args:arguments};return new f(i)},u.utc=function(i){var e=n(this.toDate(),{locale:this.$L,utc:!0});return i?e.add(this.utcOffset(),t):e},u.local=function(){return n(this.toDate(),{locale:this.$L,utc:!1})};var r=u.parse;u.parse=function(t){t.utc&&(this.$u=!0),this.$utils().u(t.$offset)||(this.$offset=t.$offset),r.call(this,t)};var o=u.init;u.init=function(){if(this.$u){var t=this.$d;this.$y=t.getUTCFullYear(),this.$M=t.getUTCMonth(),this.$D=t.getUTCDate(),this.$W=t.getUTCDay(),this.$H=t.getUTCHours(),this.$m=t.getUTCMinutes(),this.$s=t.getUTCSeconds(),this.$ms=t.getUTCMilliseconds()}else o.call(this)};var a=u.utcOffset;u.utcOffset=function(s,f){var n=this.$utils().u;if(n(s))return this.$u?0:n(this.$offset)?a.call(this):this.$offset;if("string"==typeof s&&(s=function(t){void 0===t&&(t="");var s=t.match(i);if(!s)return null;var f=(""+s[0]).match(e)||["-",0,0],n=f[0],u=60*+f[1]+ +f[2];return 0===u?0:"+"===n?u:-u}(s),null===s))return this;var u=Math.abs(s)<=16?60*s:s;if(0===u)return this.utc(f);var r=this.clone();if(f)return r.$offset=u,r.$u=!1,r;var o=this.$u?this.toDate().getTimezoneOffset():-1*this.utcOffset();return(r=this.local().add(u+o,t)).$offset=u,r.$x.$localOffset=o,r};var h=u.format;u.format=function(t){var i=t||(this.$u?"YYYY-MM-DDTHH:mm:ss[Z]":"");return h.call(this,i)},u.valueOf=function(){var t=this.$utils().u(this.$offset)?0:this.$offset+(this.$x.$localOffset||this.$d.getTimezoneOffset());return this.$d.valueOf()-6e4*t},u.isUTC=function(){return!!this.$u},u.toISOString=function(){return this.toDate().toISOString()},u.toString=function(){return this.toDate().toUTCString()};var l=u.toDate;u.toDate=function(t){return"s"===t&&this.$offset?n(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate():l.call(this)};var c=u.diff;u.diff=function(t,i,e){if(t&&this.$u===t.$u)return c.call(this,t,i,e);var s=this.local(),f=n(t).local();return c.call(s,f,i,e)}}}));
},{}],38:[function(require,module,exports){
!function(e,t){"object"==typeof exports&&"undefined"!=typeof module?module.exports=t():"function"==typeof define&&define.amd?define(t):(e="undefined"!=typeof globalThis?globalThis:e||self).dayjs_plugin_weekOfYear=t()}(this,(function(){"use strict";var e="week",t="year";return function(i,n,r){var f=n.prototype;f.week=function(i){if(void 0===i&&(i=null),null!==i)return this.add(7*(i-this.week()),"day");var n=this.$locale().yearStart||1;if(11===this.month()&&this.date()>25){var f=r(this).startOf(t).add(1,t).date(n),s=r(this).endOf(e);if(f.isBefore(s))return 1}var a=r(this).startOf(t).date(n).startOf(e).subtract(1,"millisecond"),o=this.diff(a,e,!0);return o<0?r(this).startOf("week").week():Math.ceil(o)},f.weeks=function(e){return void 0===e&&(e=null),this.week(e)}}}));
},{}],39:[function(require,module,exports){
!function(e,t){"object"==typeof exports&&"undefined"!=typeof module?module.exports=t():"function"==typeof define&&define.amd?define(t):(e="undefined"!=typeof globalThis?globalThis:e||self).dayjs_plugin_weekday=t()}(this,(function(){"use strict";return function(e,t){t.prototype.weekday=function(e){var t=this.$locale().weekStart||0,i=this.$W,n=(i<t?i+7:i)-t;return this.$utils().u(e)?n:this.subtract(n,"day").add(e,"day")}}}));
},{}],40:[function(require,module,exports){
'use strict';

var callBind = require('call-bind-apply-helpers');
var gOPD = require('gopd');

var hasProtoAccessor;
try {
	// eslint-disable-next-line no-extra-parens, no-proto
	hasProtoAccessor = /** @type {{ __proto__?: typeof Array.prototype }} */ ([]).__proto__ === Array.prototype;
} catch (e) {
	if (!e || typeof e !== 'object' || !('code' in e) || e.code !== 'ERR_PROTO_ACCESS') {
		throw e;
	}
}

// eslint-disable-next-line no-extra-parens
var desc = !!hasProtoAccessor && gOPD && gOPD(Object.prototype, /** @type {keyof typeof Object.prototype} */ ('__proto__'));

var $Object = Object;
var $getPrototypeOf = $Object.getPrototypeOf;

/** @type {import('./get')} */
module.exports = desc && typeof desc.get === 'function'
	? callBind([desc.get])
	: typeof $getPrototypeOf === 'function'
		? /** @type {import('./get')} */ function getDunder(value) {
			// eslint-disable-next-line eqeqeq
			return $getPrototypeOf(value == null ? value : $Object(value));
		}
		: false;

},{"call-bind-apply-helpers":28,"gopd":109}],41:[function(require,module,exports){
'use strict';

/** @type {import('.')} */
var $defineProperty = Object.defineProperty || false;
if ($defineProperty) {
	try {
		$defineProperty({}, 'a', { value: 1 });
	} catch (e) {
		// IE 8 has a broken defineProperty
		$defineProperty = false;
	}
}

module.exports = $defineProperty;

},{}],42:[function(require,module,exports){
'use strict';

/** @type {import('./eval')} */
module.exports = EvalError;

},{}],43:[function(require,module,exports){
'use strict';

/** @type {import('.')} */
module.exports = Error;

},{}],44:[function(require,module,exports){
'use strict';

/** @type {import('./range')} */
module.exports = RangeError;

},{}],45:[function(require,module,exports){
'use strict';

/** @type {import('./ref')} */
module.exports = ReferenceError;

},{}],46:[function(require,module,exports){
'use strict';

/** @type {import('./syntax')} */
module.exports = SyntaxError;

},{}],47:[function(require,module,exports){
'use strict';

/** @type {import('./type')} */
module.exports = TypeError;

},{}],48:[function(require,module,exports){
'use strict';

/** @type {import('./uri')} */
module.exports = URIError;

},{}],49:[function(require,module,exports){
'use strict';

/** @type {import('.')} */
module.exports = Object;

},{}],50:[function(require,module,exports){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

'use strict';

var R = typeof Reflect === 'object' ? Reflect : null
var ReflectApply = R && typeof R.apply === 'function'
  ? R.apply
  : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
  }

var ReflectOwnKeys
if (R && typeof R.ownKeys === 'function') {
  ReflectOwnKeys = R.ownKeys
} else if (Object.getOwnPropertySymbols) {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target)
      .concat(Object.getOwnPropertySymbols(target));
  };
} else {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
  };
}

function ProcessEmitWarning(warning) {
  if (console && console.warn) console.warn(warning);
}

var NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
  return value !== value;
}

function EventEmitter() {
  EventEmitter.init.call(this);
}
module.exports = EventEmitter;
module.exports.once = once;

// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.prototype._events = undefined;
EventEmitter.prototype._eventsCount = 0;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var defaultMaxListeners = 10;

function checkListener(listener) {
  if (typeof listener !== 'function') {
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
  }
}

Object.defineProperty(EventEmitter, 'defaultMaxListeners', {
  enumerable: true,
  get: function() {
    return defaultMaxListeners;
  },
  set: function(arg) {
    if (typeof arg !== 'number' || arg < 0 || NumberIsNaN(arg)) {
      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
    }
    defaultMaxListeners = arg;
  }
});

EventEmitter.init = function() {

  if (this._events === undefined ||
      this._events === Object.getPrototypeOf(this)._events) {
    this._events = Object.create(null);
    this._eventsCount = 0;
  }

  this._maxListeners = this._maxListeners || undefined;
};

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
  if (typeof n !== 'number' || n < 0 || NumberIsNaN(n)) {
    throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
  }
  this._maxListeners = n;
  return this;
};

function _getMaxListeners(that) {
  if (that._maxListeners === undefined)
    return EventEmitter.defaultMaxListeners;
  return that._maxListeners;
}

EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
  return _getMaxListeners(this);
};

EventEmitter.prototype.emit = function emit(type) {
  var args = [];
  for (var i = 1; i < arguments.length; i++) args.push(arguments[i]);
  var doError = (type === 'error');

  var events = this._events;
  if (events !== undefined)
    doError = (doError && events.error === undefined);
  else if (!doError)
    return false;

  // If there is no 'error' event listener then throw.
  if (doError) {
    var er;
    if (args.length > 0)
      er = args[0];
    if (er instanceof Error) {
      // Note: The comments on the `throw` lines are intentional, they show
      // up in Node's output if this results in an unhandled exception.
      throw er; // Unhandled 'error' event
    }
    // At least give some kind of context to the user
    var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
    err.context = er;
    throw err; // Unhandled 'error' event
  }

  var handler = events[type];

  if (handler === undefined)
    return false;

  if (typeof handler === 'function') {
    ReflectApply(handler, this, args);
  } else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      ReflectApply(listeners[i], this, args);
  }

  return true;
};

function _addListener(target, type, listener, prepend) {
  var m;
  var events;
  var existing;

  checkListener(listener);

  events = target._events;
  if (events === undefined) {
    events = target._events = Object.create(null);
    target._eventsCount = 0;
  } else {
    // To avoid recursion in the case that type === "newListener"! Before
    // adding it to the listeners, first emit "newListener".
    if (events.newListener !== undefined) {
      target.emit('newListener', type,
                  listener.listener ? listener.listener : listener);

      // Re-assign `events` because a newListener handler could have caused the
      // this._events to be assigned to a new object
      events = target._events;
    }
    existing = events[type];
  }

  if (existing === undefined) {
    // Optimize the case of one listener. Don't need the extra array object.
    existing = events[type] = listener;
    ++target._eventsCount;
  } else {
    if (typeof existing === 'function') {
      // Adding the second element, need to change to array.
      existing = events[type] =
        prepend ? [listener, existing] : [existing, listener];
      // If we've already got an array, just append.
    } else if (prepend) {
      existing.unshift(listener);
    } else {
      existing.push(listener);
    }

    // Check for listener leak
    m = _getMaxListeners(target);
    if (m > 0 && existing.length > m && !existing.warned) {
      existing.warned = true;
      // No error code for this since it is a Warning
      // eslint-disable-next-line no-restricted-syntax
      var w = new Error('Possible EventEmitter memory leak detected. ' +
                          existing.length + ' ' + String(type) + ' listeners ' +
                          'added. Use emitter.setMaxListeners() to ' +
                          'increase limit');
      w.name = 'MaxListenersExceededWarning';
      w.emitter = target;
      w.type = type;
      w.count = existing.length;
      ProcessEmitWarning(w);
    }
  }

  return target;
}

EventEmitter.prototype.addListener = function addListener(type, listener) {
  return _addListener(this, type, listener, false);
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.prependListener =
    function prependListener(type, listener) {
      return _addListener(this, type, listener, true);
    };

function onceWrapper() {
  if (!this.fired) {
    this.target.removeListener(this.type, this.wrapFn);
    this.fired = true;
    if (arguments.length === 0)
      return this.listener.call(this.target);
    return this.listener.apply(this.target, arguments);
  }
}

function _onceWrap(target, type, listener) {
  var state = { fired: false, wrapFn: undefined, target: target, type: type, listener: listener };
  var wrapped = onceWrapper.bind(state);
  wrapped.listener = listener;
  state.wrapFn = wrapped;
  return wrapped;
}

EventEmitter.prototype.once = function once(type, listener) {
  checkListener(listener);
  this.on(type, _onceWrap(this, type, listener));
  return this;
};

EventEmitter.prototype.prependOnceListener =
    function prependOnceListener(type, listener) {
      checkListener(listener);
      this.prependListener(type, _onceWrap(this, type, listener));
      return this;
    };

// Emits a 'removeListener' event if and only if the listener was removed.
EventEmitter.prototype.removeListener =
    function removeListener(type, listener) {
      var list, events, position, i, originalListener;

      checkListener(listener);

      events = this._events;
      if (events === undefined)
        return this;

      list = events[type];
      if (list === undefined)
        return this;

      if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0)
          this._events = Object.create(null);
        else {
          delete events[type];
          if (events.removeListener)
            this.emit('removeListener', type, list.listener || listener);
        }
      } else if (typeof list !== 'function') {
        position = -1;

        for (i = list.length - 1; i >= 0; i--) {
          if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
          }
        }

        if (position < 0)
          return this;

        if (position === 0)
          list.shift();
        else {
          spliceOne(list, position);
        }

        if (list.length === 1)
          events[type] = list[0];

        if (events.removeListener !== undefined)
          this.emit('removeListener', type, originalListener || listener);
      }

      return this;
    };

EventEmitter.prototype.off = EventEmitter.prototype.removeListener;

EventEmitter.prototype.removeAllListeners =
    function removeAllListeners(type) {
      var listeners, events, i;

      events = this._events;
      if (events === undefined)
        return this;

      // not listening for removeListener, no need to emit
      if (events.removeListener === undefined) {
        if (arguments.length === 0) {
          this._events = Object.create(null);
          this._eventsCount = 0;
        } else if (events[type] !== undefined) {
          if (--this._eventsCount === 0)
            this._events = Object.create(null);
          else
            delete events[type];
        }
        return this;
      }

      // emit removeListener for all listeners on all events
      if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for (i = 0; i < keys.length; ++i) {
          key = keys[i];
          if (key === 'removeListener') continue;
          this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
      }

      listeners = events[type];

      if (typeof listeners === 'function') {
        this.removeListener(type, listeners);
      } else if (listeners !== undefined) {
        // LIFO order
        for (i = listeners.length - 1; i >= 0; i--) {
          this.removeListener(type, listeners[i]);
        }
      }

      return this;
    };

function _listeners(target, type, unwrap) {
  var events = target._events;

  if (events === undefined)
    return [];

  var evlistener = events[type];
  if (evlistener === undefined)
    return [];

  if (typeof evlistener === 'function')
    return unwrap ? [evlistener.listener || evlistener] : [evlistener];

  return unwrap ?
    unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
}

EventEmitter.prototype.listeners = function listeners(type) {
  return _listeners(this, type, true);
};

EventEmitter.prototype.rawListeners = function rawListeners(type) {
  return _listeners(this, type, false);
};

EventEmitter.listenerCount = function(emitter, type) {
  if (typeof emitter.listenerCount === 'function') {
    return emitter.listenerCount(type);
  } else {
    return listenerCount.call(emitter, type);
  }
};

EventEmitter.prototype.listenerCount = listenerCount;
function listenerCount(type) {
  var events = this._events;

  if (events !== undefined) {
    var evlistener = events[type];

    if (typeof evlistener === 'function') {
      return 1;
    } else if (evlistener !== undefined) {
      return evlistener.length;
    }
  }

  return 0;
}

EventEmitter.prototype.eventNames = function eventNames() {
  return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
};

function arrayClone(arr, n) {
  var copy = new Array(n);
  for (var i = 0; i < n; ++i)
    copy[i] = arr[i];
  return copy;
}

function spliceOne(list, index) {
  for (; index + 1 < list.length; index++)
    list[index] = list[index + 1];
  list.pop();
}

function unwrapListeners(arr) {
  var ret = new Array(arr.length);
  for (var i = 0; i < ret.length; ++i) {
    ret[i] = arr[i].listener || arr[i];
  }
  return ret;
}

function once(emitter, name) {
  return new Promise(function (resolve, reject) {
    function errorListener(err) {
      emitter.removeListener(name, resolver);
      reject(err);
    }

    function resolver() {
      if (typeof emitter.removeListener === 'function') {
        emitter.removeListener('error', errorListener);
      }
      resolve([].slice.call(arguments));
    };

    eventTargetAgnosticAddListener(emitter, name, resolver, { once: true });
    if (name !== 'error') {
      addErrorHandlerIfEventEmitter(emitter, errorListener, { once: true });
    }
  });
}

function addErrorHandlerIfEventEmitter(emitter, handler, flags) {
  if (typeof emitter.on === 'function') {
    eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
  }
}

function eventTargetAgnosticAddListener(emitter, name, listener, flags) {
  if (typeof emitter.on === 'function') {
    if (flags.once) {
      emitter.once(name, listener);
    } else {
      emitter.on(name, listener);
    }
  } else if (typeof emitter.addEventListener === 'function') {
    // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
      // IE does not have builtin `{ once: true }` support so we
      // have to do it manually.
      if (flags.once) {
        emitter.removeEventListener(name, wrapListener);
      }
      listener(arg);
    });
  } else {
    throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
  }
}

},{}],51:[function(require,module,exports){
module.exports={
  "_from": "fable-log@^3.0.18",
  "_id": "fable-log@3.0.18",
  "_inBundle": false,
  "_integrity": "sha512-VGLVuqpHGd2RzohnzwN7k1IAr5kSuhaNg3i2tC/4ibPnaYJ0ICpIXXoCsnw/WABGgmfq2ICJ4I7XlB654Du4nQ==",
  "_location": "/fable-log",
  "_phantomChildren": {},
  "_requested": {
    "type": "range",
    "registry": true,
    "raw": "fable-log@^3.0.18",
    "name": "fable-log",
    "escapedName": "fable-log",
    "rawSpec": "^3.0.18",
    "saveSpec": null,
    "fetchSpec": "^3.0.18"
  },
  "_requiredBy": [
    "/fable"
  ],
  "_resolved": "https://registry.npmjs.org/fable-log/-/fable-log-3.0.18.tgz",
  "_shasum": "4f9ceb33c01b53d380d15e12fe64aa90f1ddce8c",
  "_spec": "fable-log@^3.0.18",
  "_where": "/Users/jacksonpollard/pict/node_modules/fable",
  "author": {
    "name": "Steven Velozo",
    "email": "steven@velozo.com",
    "url": "http://velozo.com/"
  },
  "browser": {
    "./source/Fable-Log-DefaultProviders-Node.js": "./source/Fable-Log-DefaultProviders-Web.js"
  },
  "bugs": {
    "url": "https://github.com/stevenvelozo/fable-log/issues"
  },
  "bundleDependencies": false,
  "dependencies": {
    "fable-serviceproviderbase": "^3.0.19"
  },
  "deprecated": false,
  "description": "A simple logging wrapper.",
  "devDependencies": {
    "quackage": "^1.0.58"
  },
  "homepage": "https://github.com/stevenvelozo/fable-log",
  "keywords": [
    "logging"
  ],
  "license": "MIT",
  "main": "source/Fable-Log.js",
  "mocha": {
    "diff": true,
    "extension": [
      "js"
    ],
    "package": "./package.json",
    "reporter": "spec",
    "slow": "75",
    "timeout": "5000",
    "ui": "tdd",
    "watch-files": [
      "source/**/*.js",
      "test/**/*.js"
    ],
    "watch-ignore": [
      "lib/vendor"
    ]
  },
  "name": "fable-log",
  "repository": {
    "type": "git",
    "url": "git+https://github.com/stevenvelozo/fable-log.git"
  },
  "scripts": {
    "coverage": "npx quack coverage",
    "start": "node source/Fable-Log.js",
    "test": "npx quack test",
    "tests": "npx quack test -g"
  },
  "version": "3.0.18"
}

},{}],52:[function(require,module,exports){
/**
* Base Logger Class
*
*
* @author Steven Velozo <steven@velozo.com>
*/

const libFableServiceProviderBase = require('fable-serviceproviderbase').CoreServiceProviderBase;

class BaseLogger extends libFableServiceProviderBase
{
	constructor(pLogStreamSettings, pLogStreamHash)
	{
		super(pLogStreamSettings, pLogStreamHash);
		// This should not possibly be able to be instantiated without a settings object
		this._Settings = (typeof(pLogStreamSettings) == 'object') ? pLogStreamSettings : {};

		this.serviceType = 'Logging-Provider';

		// The base logger does nothing but associate a UUID with itself
		// We added this as the mechanism for tracking loggers to allow multiple simultaneous streams
		// to the same provider.
		this.loggerUUID = this.generateInsecureUUID();

		// Eventually we can use this array to ompute which levels the provider allows.
		// For now it's just used to precompute some string concatenations.
		this.levels = (
			[
				"trace",
				"debug",
				"info",
				"warn",
				"error",
				"fatal"
			]);
	}

	// This is meant to generate programmatically insecure UUIDs to identify loggers
	generateInsecureUUID()
	{
		let tmpDate = new Date().getTime();
		let tmpUUID = 'LOGSTREAM-xxxxxx-yxxxxx'.replace(/[xy]/g,
				(pCharacter) =>
				{
					// Funny algorithm from w3resource that is twister-ish without the deep math and security
					// ..but good enough for unique log stream identifiers
					let tmpRandomData = (tmpDate + Math.random()*16)%16 | 0;
					tmpDate = Math.floor(tmpDate/16);

					return (pCharacter =='x' ? tmpRandomData : (tmpRandomData&0x3|0x8)).toString(16);
				});
		return tmpUUID;
	}

	initialize()
	{
		// No operation.
	}

	trace(pLogText, pLogObject)
	{
		this.write("trace", pLogText, pLogObject);
	}

	debug(pLogText, pLogObject)
	{
		this.write("debug", pLogText, pLogObject);
	}

	info(pLogText, pLogObject)
	{
		this.write("info", pLogText, pLogObject);
	}

	warn(pLogText, pLogObject)
	{
		this.write("warn", pLogText, pLogObject);
	}

	error(pLogText, pLogObject)
	{
		this.write("error", pLogText, pLogObject);
	}

	fatal(pLogText, pLogObject)
	{
		this.write("fatal", pLogText, pLogObject);
	}

	write(pLogLevel, pLogText, pLogObject)
	{
		// The base logger does nothing.
		return true;
	}
}

module.exports = BaseLogger;

},{"fable-serviceproviderbase":59}],53:[function(require,module,exports){
/**
* Default Logger Provider Function
*
*
* @author Steven Velozo <steven@velozo.com>
*/

// Return the providers that are available without extensions loaded
var getDefaultProviders = () =>
{
	let tmpDefaultProviders = {};

	tmpDefaultProviders.console = require('./Fable-Log-Logger-Console.js');

	tmpDefaultProviders.default = tmpDefaultProviders.console;

	return tmpDefaultProviders;
}

module.exports = getDefaultProviders();
},{"./Fable-Log-Logger-Console.js":55}],54:[function(require,module,exports){
module.exports=[
    {
        "loggertype": "console",
        "streamtype": "console",
        "level": "trace"
    }
]
},{}],55:[function(require,module,exports){
let libBaseLogger = require('./Fable-Log-BaseLogger.js');

class ConsoleLogger extends libBaseLogger
{
	constructor(pLogStreamSettings, pFableLog)
	{
		super(pLogStreamSettings);

		this._ShowTimeStamps = ('showtimestamps' in this._Settings) ? (this._Settings.showtimestamps == true) : true;
		this._FormattedTimeStamps = ('formattedtimestamps' in this._Settings) ? (this._Settings.formattedtimestamps == true) : true;

		this._ContextMessage = ('Context' in this._Settings) ? `(${this._Settings.Context})` :
								('Product' in pFableLog._Settings) ? `(${pFableLog._Settings.Product})` :
								'Unnamed_Log_Context';

		// Allow the user to decide what gets output to the console
		this._OutputLogLinesToConsole = ('outputloglinestoconsole' in this._Settings) ? this._Settings.outputloglinestoconsole : true;
		this._OutputObjectsToConsole = ('outputobjectstoconsole' in this._Settings) ? this._Settings.outputobjectstoconsole : true;

		// Precompute the prefix for each level
		this.prefixCache = {};
		for (let i = 0; i <= this.levels.length; i++)
		{
			this.prefixCache[this.levels[i]] = `[${this.levels[i]}] ${this._ContextMessage}: `;

			if (this._ShowTimeStamps)
			{
				// If there is a timestamp we need a to prepend space before the prefixcache string, since the timestamp comes first
				this.prefixCache[this.levels[i]] = ' '+this.prefixCache[this.levels[i]];
			}
		}
	}

	write(pLevel, pLogText, pObject)
	{
		let tmpTimeStamp = '';
		if (this._ShowTimeStamps && this._FormattedTimeStamps)
		{
			tmpTimeStamp = (new Date()).toISOString();
		}
		else if (this._ShowTimeStamps)
		{
			tmpTimeStamp = +new Date();
		}

		let tmpLogLine = `${tmpTimeStamp}${this.prefixCache[pLevel]}${pLogText}`;

		if (this._OutputLogLinesToConsole)
		{
			console.log(tmpLogLine);
		}

		// Write out the object on a separate line if it is passed in
		if (this._OutputObjectsToConsole && (typeof(pObject) !== 'undefined'))
		{
			console.log(JSON.stringify(pObject, null, 2));
		}

		// Provide an easy way to be overridden and be consistent
		return tmpLogLine;
	}
}

module.exports = ConsoleLogger;
},{"./Fable-Log-BaseLogger.js":52}],56:[function(require,module,exports){
const libConsoleLog = require('./Fable-Log-Logger-Console.js');
const libFS = require('fs');
const libPath = require('path');

class SimpleFlatFileLogger extends libConsoleLog
{
	constructor(pLogStreamSettings, pFableLog)
	{
		super(pLogStreamSettings, pFableLog);

		// If a path isn't provided for the logfile, it tries to use the ProductName or Context
		this.logFileRawPath = (this._Settings.hasOwnProperty('path')) ? this._Settings.path : `./${this._ContextMessage}.log`;
		this.logFilePath = libPath.normalize(this.logFileRawPath);

		this.logFileStreamOptions = (this._Settings.hasOwnProperty('fileStreamoptions')) ? this._Settings.fileStreamOptions : (
			{
				"flags": "a",
				"encoding": "utf8"
			})

		this.fileWriter = libFS.createWriteStream(this.logFilePath, this.logFileStreamOptions);

		this.activelyWriting = false;

		this.logLineStrings = [];
		this.logObjectStrings = [];

		this.defaultWriteCompleteCallback = ()=>{};
		this.defaultBufferFlushCallback = ()=>{};
	}

	closeWriter(fCloseComplete)
	{
		let tmpCloseComplete = (typeof(fCloseComplete) == 'function') ? fCloseComplete : ()=>{};
		if (this.fileWriter)
		{
			this.fileWriter.end('\n');
			return this.fileWriter.once('finish', tmpCloseComplete.bind(this));
		}
	}

	completeBufferFlushToLogFile(fFlushComplete)
	{
		this.activelyWriting = false;
		let tmpFlushComplete = (typeof(fFlushComplete) == 'function') ? fFlushComplete : this.defaultBufferFlushCallback;

		if (this.logLineStrings.length > 0)
		{
			this.flushBufferToLogFile(tmpFlushComplete);
		}
		else
		{
			return tmpFlushComplete();
		}
	}

	flushBufferToLogFile(fFlushComplete)
	{
		if (!this.activelyWriting)
		{
			// Only want to be writing one thing at a time....
			this.activelyWriting = true;

			let tmpFlushComplete = (typeof(fFlushComplete) == 'function') ? fFlushComplete : this.defaultBufferFlushCallback;

			// Get the current buffer arrays.  These should always have matching number of elements.
			let tmpLineStrings = this.logLineStrings;
			let tmpObjectStrings = this.logObjectStrings;

			// Reset these to be filled while we process this queue...
			this.logLineStrings = [];
			this.logObjectStrings = [];

			// This is where we will put each line before writing it to the file...
			let tmpConstructedBufferOutputString = '';

			for (let i = 0; i < tmpLineStrings.length; i++)
			{
				// TODO: Windows Newline?   ....... yo no se!
				tmpConstructedBufferOutputString += `${tmpLineStrings[i]}\n`;
				if (tmpObjectStrings[i] !== false)
				{
					tmpConstructedBufferOutputString += `${tmpObjectStrings[i]}\n`;
				}
			}

			if (!this.fileWriter.write(tmpConstructedBufferOutputString, 'utf8'))
			{
				// If the streamwriter returns false, we need to wait for it to drain.
				this.fileWriter.once('drain', this.completeBufferFlushToLogFile.bind(this, tmpFlushComplete));
			}
			else
			{
				return this.completeBufferFlushToLogFile(tmpFlushComplete);
			}
		}
	}

	write(pLevel, pLogText, pObject)
	{
		let tmpLogLine = super.write(pLevel, pLogText, pObject);

		// Use a very simple array as the write buffer
		this.logLineStrings.push(tmpLogLine);

		// Write out the object on a separate line if it is passed in
		if (typeof(pObject) !== 'undefined')
		{
			this.logObjectStrings.push(JSON.stringify(pObject, null, 4));
		}
		else
		{
			this.logObjectStrings.push(false);
		}

		this.flushBufferToLogFile();
	}
}

module.exports = SimpleFlatFileLogger;
},{"./Fable-Log-Logger-Console.js":55,"fs":19,"path":138}],57:[function(require,module,exports){
/**
* Fable Logging Service
*/

const libFableServiceProviderBase = require('fable-serviceproviderbase').CoreServiceProviderBase;

const libPackage = require('../package.json');

class FableLog extends libFableServiceProviderBase
{
	constructor(pSettings, pServiceHash)
	{
		super(pSettings, pServiceHash);

		this.serviceType = 'Logging';
		/** @type {Object} */
		this._Package = libPackage;

		let tmpSettings = (typeof(pSettings) === 'object') ? pSettings : {}
		this._Settings = tmpSettings;

		this._Providers = require('./Fable-Log-DefaultProviders-Node.js');

		this._StreamDefinitions = (('LogStreams' in tmpSettings)) ? tmpSettings.LogStreams : require('./Fable-Log-DefaultStreams.json');

		this.logStreams = [];

		// This object gets decorated for one-time instantiated providers that
		//  have multiple outputs, such as bunyan.
		this.logProviders = {};

		// A hash list of the GUIDs for each log stream, so they can't be added to the set more than one time
		this.activeLogStreams = {};

		this.logStreamsTrace = [];
		this.logStreamsDebug = [];
		this.logStreamsInfo = [];
		this.logStreamsWarn = [];
		this.logStreamsError = [];
		this.logStreamsFatal = [];

		this.datumDecorator = (pDatum) => pDatum;

		this.uuid = (typeof(tmpSettings.Product) === 'string') ? tmpSettings.Product : 'Default';
	}

	addLogger(pLogger, pLevel)
	{
		// Bail out if we've already created one.
		if (pLogger.loggerUUID in this.activeLogStreams)
		{
			return false;
		}

		// Add it to the streams and to the mutex
		this.logStreams.push(pLogger);
		this.activeLogStreams[pLogger.loggerUUID] = true;

		// Make sure a kosher level was passed in
		switch (pLevel)
		{
			case 'trace':
				this.logStreamsTrace.push(pLogger);
			case 'debug':
				this.logStreamsDebug.push(pLogger);
			case 'info':
				this.logStreamsInfo.push(pLogger);
			case 'warn':
				this.logStreamsWarn.push(pLogger);
			case 'error':
				this.logStreamsError.push(pLogger);
			case 'fatal':
				this.logStreamsFatal.push(pLogger);
				break;
		}

		return true;
	}

	setDatumDecorator(fDatumDecorator)
	{
		if (typeof(fDatumDecorator) === 'function')
		{
			this.datumDecorator = fDatumDecorator;
		}
		else
		{
			this.datumDecorator = (pDatum) => pDatum;
		}
	}

	trace(pMessage, pDatum)
	{
		const tmpDecoratedDatum = this.datumDecorator(pDatum);
		for (let i = 0; i < this.logStreamsTrace.length; i++)
		{
			this.logStreamsTrace[i].trace(pMessage, tmpDecoratedDatum);
		}
	}

	debug(pMessage, pDatum)
	{
		const tmpDecoratedDatum = this.datumDecorator(pDatum);
		for (let i = 0; i < this.logStreamsDebug.length; i++)
		{
			this.logStreamsDebug[i].debug(pMessage, tmpDecoratedDatum);
		}
	}

	info(pMessage, pDatum)
	{
		const tmpDecoratedDatum = this.datumDecorator(pDatum);
		for (let i = 0; i < this.logStreamsInfo.length; i++)
		{
			this.logStreamsInfo[i].info(pMessage, tmpDecoratedDatum);
		}
	}

	warn(pMessage, pDatum)
	{
		const tmpDecoratedDatum = this.datumDecorator(pDatum);
		for (let i = 0; i < this.logStreamsWarn.length; i++)
		{
			this.logStreamsWarn[i].warn(pMessage, tmpDecoratedDatum);
		}
	}

	error(pMessage, pDatum)
	{
		const tmpDecoratedDatum = this.datumDecorator(pDatum);
		for (let i = 0; i < this.logStreamsError.length; i++)
		{
			this.logStreamsError[i].error(pMessage, tmpDecoratedDatum);
		}
	}

	fatal(pMessage, pDatum)
	{
		const tmpDecoratedDatum = this.datumDecorator(pDatum);
		for (let i = 0; i < this.logStreamsFatal.length; i++)
		{
			this.logStreamsFatal[i].fatal(pMessage, tmpDecoratedDatum);
		}
	}

	initialize()
	{
		// "initialize" each logger as defined in the logging parameters
		for (let i = 0; i < this._StreamDefinitions.length; i++)
		{
			let tmpStreamDefinition = Object.assign({loggertype:'default',streamtype:'console',level:'info'},this._StreamDefinitions[i]);

			if (!(tmpStreamDefinition.loggertype in this._Providers))
			{
				console.log(`Error initializing log stream: bad loggertype in stream definition ${JSON.stringify(tmpStreamDefinition)}`);
			}
			else
			{
				this.addLogger(new this._Providers[tmpStreamDefinition.loggertype](tmpStreamDefinition, this), tmpStreamDefinition.level);
			}
		}

		// Now initialize each one.
		for (let i = 0; i < this.logStreams.length; i++)
		{
			this.logStreams[i].initialize();
		}
	}

	logTime(pMessage, pDatum)
	{
		let tmpMessage = (typeof(pMessage) !== 'undefined') ? pMessage : 'Time';
		let tmpTime = new Date();
		this.info(`${tmpMessage} ${tmpTime} (epoch ${+tmpTime})`, pDatum);
	}

	// Get a timestamp
	getTimeStamp()
	{
		return +new Date();
	}

	getTimeDelta(pTimeStamp)
	{
		let tmpEndTime = +new Date();
		return tmpEndTime-pTimeStamp;
	}

	// Log the delta between a timestamp, and now with a message
	logTimeDelta(pTimeDelta, pMessage, pDatum)
	{
		let tmpMessage = (typeof(pMessage) !== 'undefined') ? pMessage : 'Time Measurement';
		let tmpDatum = (typeof(pDatum) === 'object') ? pDatum : {};

		let tmpEndTime = +new Date();

		this.info(`${tmpMessage} logged at (epoch ${+tmpEndTime}) took (${pTimeDelta}ms)`, pDatum);
	}

	logTimeDeltaHuman(pTimeDelta, pMessage, pDatum)
	{
		let tmpMessage = (typeof(pMessage) !== 'undefined') ? pMessage : 'Time Measurement';

		let tmpEndTime = +new Date();

		let tmpMs = parseInt(pTimeDelta%1000);
		let tmpSeconds = parseInt((pTimeDelta/1000)%60);
		let tmpMinutes = parseInt((pTimeDelta/(1000*60))%60);
		let tmpHours = parseInt(pTimeDelta/(1000*60*60));

		tmpMs = (tmpMs < 10) ? "00"+tmpMs : (tmpMs < 100) ? "0"+tmpMs : tmpMs;
		tmpSeconds = (tmpSeconds < 10) ? "0"+tmpSeconds : tmpSeconds;
		tmpMinutes = (tmpMinutes < 10) ? "0"+tmpMinutes : tmpMinutes;
		tmpHours = (tmpHours < 10) ? "0"+tmpHours : tmpHours;

		this.info(`${tmpMessage} logged at (epoch ${+tmpEndTime}) took (${pTimeDelta}ms) or (${tmpHours}:${tmpMinutes}:${tmpSeconds}.${tmpMs})`, pDatum);
	}

	logTimeDeltaRelative(pStartTime, pMessage, pDatum)
	{
		this.logTimeDelta(this.getTimeDelta(pStartTime), pMessage, pDatum);
	}

	logTimeDeltaRelativeHuman(pStartTime, pMessage, pDatum)
	{
		this.logTimeDeltaHuman(this.getTimeDelta(pStartTime), pMessage, pDatum);
	}
}

module.exports = FableLog;
module.exports.LogProviderBase = require('./Fable-Log-BaseLogger.js');
module.exports.LogProviderConsole = require('./Fable-Log-Logger-Console.js');
module.exports.LogProviderFlatfile = require('./Fable-Log-Logger-SimpleFlatFile.js');

},{"../package.json":51,"./Fable-Log-BaseLogger.js":52,"./Fable-Log-DefaultProviders-Node.js":53,"./Fable-Log-DefaultStreams.json":54,"./Fable-Log-Logger-Console.js":55,"./Fable-Log-Logger-SimpleFlatFile.js":56,"fable-serviceproviderbase":59}],58:[function(require,module,exports){
module.exports={
  "_from": "fable-serviceproviderbase@^3.0.19",
  "_id": "fable-serviceproviderbase@3.0.19",
  "_inBundle": false,
  "_integrity": "sha512-q/chQR1Z+sgfsDy4q0kHg09EEjUzYKLYHNUcLC0idTp08n3mzikU+ynKKDB56k2WkosZzhoAKg2YHRGi4/c3ig==",
  "_location": "/fable-serviceproviderbase",
  "_phantomChildren": {},
  "_requested": {
    "type": "range",
    "registry": true,
    "raw": "fable-serviceproviderbase@^3.0.19",
    "name": "fable-serviceproviderbase",
    "escapedName": "fable-serviceproviderbase",
    "rawSpec": "^3.0.19",
    "saveSpec": null,
    "fetchSpec": "^3.0.19"
  },
  "_requiredBy": [
    "/cachetrax",
    "/data-arithmatic",
    "/fable",
    "/fable-log",
    "/fable-settings",
    "/fable-uuid",
    "/manyfest",
    "/meadow-connection-dgraph",
    "/meadow-connection-manager",
    "/meadow-connection-mongodb",
    "/meadow-connection-mssql",
    "/meadow-connection-mysql",
    "/meadow-connection-postgresql",
    "/meadow-connection-solr",
    "/meadow-connection-sqlite",
    "/meadow-endpoints",
    "/meadow-integration",
    "/meadow-migrationmanager/pict-section-flow",
    "/orator",
    "/orator-authentication",
    "/orator-serviceserver-base",
    "/orator-static-server",
    "/pict-application",
    "/pict-docuserve",
    "/pict-provider",
    "/pict-section-flow",
    "/pict-section-form",
    "/pict-service-commandlineutility",
    "/pict-sessionmanager",
    "/pict-template",
    "/pict-terminalui",
    "/pict-view",
    "/retold-data-service",
    "/stricture/pict-terminalui"
  ],
  "_resolved": "https://registry.npmjs.org/fable-serviceproviderbase/-/fable-serviceproviderbase-3.0.19.tgz",
  "_shasum": "e04a7f953bbd658b5e37c0a38ebbb54348a2f1d4",
  "_spec": "fable-serviceproviderbase@^3.0.19",
  "_where": "/Users/jacksonpollard/pict/node_modules/cachetrax",
  "author": {
    "name": "Steven Velozo",
    "email": "steven@velozo.com",
    "url": "http://velozo.com/"
  },
  "bugs": {
    "url": "https://github.com/stevenvelozo/fable-serviceproviderbase/issues"
  },
  "bundleDependencies": false,
  "deprecated": false,
  "description": "Simple base classes for fable services.",
  "devDependencies": {
    "@types/mocha": "^10.0.10",
    "fable": "^3.1.62",
    "quackage": "^1.0.58",
    "typescript": "^5.9.3"
  },
  "homepage": "https://github.com/stevenvelozo/fable-serviceproviderbase",
  "keywords": [
    "entity",
    "behavior"
  ],
  "license": "MIT",
  "main": "source/Fable-ServiceProviderBase.js",
  "mocha": {
    "diff": true,
    "extension": [
      "js"
    ],
    "package": "./package.json",
    "reporter": "spec",
    "slow": "75",
    "timeout": "5000",
    "ui": "tdd",
    "watch-files": [
      "source/**/*.js",
      "test/**/*.js"
    ],
    "watch-ignore": [
      "lib/vendor"
    ]
  },
  "name": "fable-serviceproviderbase",
  "repository": {
    "type": "git",
    "url": "git+https://github.com/stevenvelozo/fable-serviceproviderbase.git"
  },
  "scripts": {
    "build": "npx quack build",
    "check": "tsc -p . --noEmit",
    "coverage": "npx quack coverage",
    "start": "node source/Fable-ServiceProviderBase.js",
    "test": "npx quack test",
    "tests": "npx quack test -g",
    "types": "tsc -p ./tsconfig.build.json"
  },
  "types": "types/source/Fable-ServiceProviderBase.d.ts",
  "version": "3.0.19"
}

},{}],59:[function(require,module,exports){
/**
* Fable Service Base
* @author <steven@velozo.com>
*/

const libPackage = require('../package.json');

class FableServiceProviderBase
{
	/**
	 * The constructor can be used in two ways:
	 * 1) With a fable, options object and service hash (the options object and service hash are optional)a
	 * 2) With an object or nothing as the first parameter, where it will be treated as the options object
	 *
	 * @param {import('fable')|Record<string, any>} [pFable] - (optional) The fable instance, or the options object if there is no fable
	 * @param {Record<string, any>|string} [pOptions] - (optional) The options object, or the service hash if there is no fable
	 * @param {string} [pServiceHash] - (optional) The service hash to identify this service instance
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		/** @type {import('fable')} */
		this.fable;
		/** @type {string} */
		this.UUID;
		/** @type {Record<string, any>} */
		this.options;
		/** @type {Record<string, any>} */
		this.services;
		/** @type {Record<string, any>} */
		this.servicesMap;

		// Check if a fable was passed in; connect it if so
		if ((typeof(pFable) === 'object') && pFable.isFable)
		{
			this.connectFable(pFable);
		}
		else
		{
			this.fable = false;
		}

		// Initialize the services map if it wasn't passed in
		/** @type {Record<string, any>} */
		this._PackageFableServiceProvider = libPackage;

		// initialize options and UUID based on whether the fable was passed in or not.
		if (this.fable)
		{
			this.UUID = pFable.getUUID();
			this.options = (typeof(pOptions) === 'object') ? pOptions
							: {};
		}
		else
		{
			// With no fable, check to see if there was an object passed into either of the first two
			// Parameters, and if so, treat it as the options object
			this.options = ((typeof(pFable) === 'object') && !pFable.isFable) ? pFable
							: (typeof(pOptions) === 'object') ? pOptions
							: {};
			this.UUID = `CORE-SVC-${Math.floor((Math.random() * (99999 - 10000)) + 10000)}`
		}

		// It's expected that the deriving class will set this
		this.serviceType = `Unknown-${this.UUID}`;

		// The service hash is used to identify the specific instantiation of the service in the services map
		this.Hash = (typeof(pServiceHash) === 'string') ? pServiceHash 
					: (!this.fable && (typeof(pOptions) === 'string')) ? pOptions
					: `${this.UUID}`;
	}

	/**
	 * @param {import('fable')} pFable
	 */
	connectFable(pFable)
	{
		if ((typeof(pFable) !== 'object') || (!pFable.isFable))
		{
			let tmpErrorMessage = `Fable Service Provider Base: Cannot connect to Fable, invalid Fable object passed in.  The pFable parameter was a [${typeof(pFable)}].}`;
			console.log(tmpErrorMessage);
			return new Error(tmpErrorMessage);
		}

		if (!this.fable)
		{
			this.fable = pFable;
		}

		if (!this.log)
		{
			this.log = this.fable.Logging;
		}
		if (!this.services)
		{
			this.services = this.fable.services;
		}

		if (!this.servicesMap)
		{
			this.servicesMap = this.fable.servicesMap;
		}

		return true;
	}

	static isFableService = true;
}

module.exports = FableServiceProviderBase;

// This is left here in case we want to go back to having different code/base class for "core" services
module.exports.CoreServiceProviderBase = FableServiceProviderBase;

},{"../package.json":58}],60:[function(require,module,exports){
module.exports={
  "_from": "fable-settings@^3.0.16",
  "_id": "fable-settings@3.0.16",
  "_inBundle": false,
  "_integrity": "sha512-GTcUdDdWHhhjN3c9JZPczmuTK/cbl3iJzWfkY8zkvyJjFt/b2gyTHR1jL0OBQaeVJ3xToZaH7QRFhfJxlr4mMQ==",
  "_location": "/fable-settings",
  "_phantomChildren": {},
  "_requested": {
    "type": "range",
    "registry": true,
    "raw": "fable-settings@^3.0.16",
    "name": "fable-settings",
    "escapedName": "fable-settings",
    "rawSpec": "^3.0.16",
    "saveSpec": null,
    "fetchSpec": "^3.0.16"
  },
  "_requiredBy": [
    "/fable"
  ],
  "_resolved": "https://registry.npmjs.org/fable-settings/-/fable-settings-3.0.16.tgz",
  "_shasum": "c576f75f4338a0fc4f37fe59444ce4f4124eb002",
  "_spec": "fable-settings@^3.0.16",
  "_where": "/Users/jacksonpollard/pict/node_modules/fable",
  "author": {
    "name": "Steven Velozo",
    "email": "steven@velozo.com",
    "url": "http://velozo.com/"
  },
  "bugs": {
    "url": "https://github.com/stevenvelozo/fable-settings/issues"
  },
  "bundleDependencies": false,
  "dependencies": {
    "fable-serviceproviderbase": "^3.0.19",
    "precedent": "^1.0.17"
  },
  "deprecated": false,
  "description": "A simple, tolerant configuration chain.",
  "devDependencies": {
    "quackage": "^1.0.58"
  },
  "homepage": "https://github.com/stevenvelozo/fable-settings",
  "keywords": [
    "configuration"
  ],
  "license": "MIT",
  "main": "source/Fable-Settings.js",
  "mocha": {
    "diff": true,
    "extension": [
      "js"
    ],
    "package": "./package.json",
    "reporter": "spec",
    "slow": "75",
    "timeout": "5000",
    "ui": "tdd",
    "watch-files": [
      "source/**/*.js",
      "test/**/*.js"
    ],
    "watch-ignore": [
      "lib/vendor"
    ]
  },
  "name": "fable-settings",
  "repository": {
    "type": "git",
    "url": "git+https://github.com/stevenvelozo/fable-settings.git"
  },
  "scripts": {
    "build": "npx quack build",
    "coverage": "npx quack coverage",
    "docker-dev-build-image": "docker build ./ -f Dockerfile_LUXURYCode -t retold/fable-settings:local",
    "docker-dev-run": "docker run -it -d --name retold-fable-settings-dev -p 30003:8080 -v \"$PWD/.config:/home/coder/.config\"  -v \"$PWD:/home/coder/fable-settings\" -u \"$(id -u):$(id -g)\" -e \"DOCKER_USER=$USER\" retold/fable-settings:local",
    "start": "node source/Fable-Settings.js",
    "test": "npx quack test"
  },
  "version": "3.0.16"
}

},{}],61:[function(require,module,exports){
module.exports={
	"Product": "ApplicationNameHere",
	"ProductVersion": "0.0.0",

	"ConfigFile": false,

	"LogStreams":
	[
		{
			"level": "trace"
		}
	]
}

},{}],62:[function(require,module,exports){
(function (process){(function (){
/**
* Fable Settings Template Processor
*
* This class allows environment variables to come in via templated expressions, and defaults to be set.
*
*
* @author Steven Velozo <steven@velozo.com>
* @module Fable Settings
*/
const libPrecedent = require('precedent');

class FableSettingsTemplateProcessor
{
	constructor(pDependencies)
	{
        // Use a no-dependencies templating engine to parse out environment variables
		this.templateProcessor = new libPrecedent();

        // TODO: Make the environment variable wrap expression demarcation characters configurable?
		this.templateProcessor.addPattern('${', '}',
			(pTemplateValue)=>
			{
				let tmpTemplateValue = pTemplateValue.trim();

				let tmpSeparatorIndex = tmpTemplateValue.indexOf('|');

				const tmpDefaultValue = tmpSeparatorIndex >= 0 ? tmpTemplateValue.substring(tmpSeparatorIndex+1) : '';

				let tmpEnvironmentVariableName = (tmpSeparatorIndex > -1) ? tmpTemplateValue.substring(0, tmpSeparatorIndex) : tmpTemplateValue;

				if (tmpEnvironmentVariableName in process.env)
				{
					return process.env[tmpEnvironmentVariableName];
				}
				else
				{
					return tmpDefaultValue;
				}
			});
    }

    parseSetting(pString)
    {
        return this.templateProcessor.parseString(pString);
    }
}

module.exports = FableSettingsTemplateProcessor;

}).call(this)}).call(this,require('_process'))

},{"_process":150,"precedent":147}],63:[function(require,module,exports){
/**
* Fable Settings Add-on
*
*
* @author Steven Velozo <steven@velozo.com>
* @module Fable Settings
*/

const libFableServiceProviderBase = require('fable-serviceproviderbase').CoreServiceProviderBase;

const libFableSettingsTemplateProcessor = require('./Fable-Settings-TemplateProcessor.js');

class FableSettings extends libFableServiceProviderBase
{
	constructor(pSettings, pServiceHash)
	{
		super(pSettings, pServiceHash);

		this.serviceType = 'SettingsManager';

		this._Package = require('../package.json');

		// Initialize the settings value template processor
		this.settingsTemplateProcessor = new libFableSettingsTemplateProcessor();

		// set straight away so anything that uses it respects the initial setting
		this._configureEnvTemplating(pSettings);

		this.default = this.buildDefaultSettings();

		// Construct a new settings object
		let tmpSettings = this.merge(pSettings, this.buildDefaultSettings());

		// The base settings object (what they were on initialization, before other actors have altered them)
		this.base = JSON.parse(JSON.stringify(tmpSettings));

		if (tmpSettings.DefaultConfigFile)
		{
			try
			{
				// If there is a DEFAULT configuration file, try to load and merge it.
				tmpSettings = this.merge(require(tmpSettings.DefaultConfigFile), tmpSettings);
			}
			catch (pException)
			{
				// Why this?  Often for an app we want settings to work out of the box, but
				// would potentially want to have a config file for complex settings.
				console.log('Fable-Settings Warning: Default configuration file specified but there was a problem loading it.  Falling back to base.');
				console.log('     Loading Exception: '+pException);
			}
		}

		if (tmpSettings.ConfigFile)
		{
			try
			{
				// If there is a configuration file, try to load and merge it.
				tmpSettings = this.merge(require(tmpSettings.ConfigFile), tmpSettings);
			}
			catch (pException)
			{
				// Why this?  Often for an app we want settings to work out of the box, but
				// would potentially want to have a config file for complex settings.
				console.log('Fable-Settings Warning: Configuration file specified but there was a problem loading it.  Falling back to base.');
				console.log('     Loading Exception: '+pException);
			}
		}

		this.settings = tmpSettings;
	}

	// Build a default settings object.  Use the JSON jimmy to ensure it is always a new object.
	buildDefaultSettings()
	{
		return JSON.parse(JSON.stringify(require('./Fable-Settings-Default')));
	}

	// Update the configuration for environment variable templating based on the current settings object
	_configureEnvTemplating(pSettings)
	{
		// default environment variable templating to on
		this._PerformEnvTemplating = !pSettings || pSettings.NoEnvReplacement !== true;
	}

	// Resolve (recursive) any environment variables found in settings object.
	_resolveEnv(pSettings)
	{
		for (const tmpKey in pSettings)
		{
			if (typeof(pSettings[tmpKey]) === 'object')
			{
				this._resolveEnv(pSettings[tmpKey]);
			}
			else if (typeof(pSettings[tmpKey]) === 'string')
			{
				pSettings[tmpKey] = this.settingsTemplateProcessor.parseSetting(pSettings[tmpKey]);
			}
		}
	}

	/**
	 * Check to see if a value is an object (but not an array).
	 */
	_isObject(value)
	{
		return typeof(value) === 'object' && !Array.isArray(value);
	}

	/**
	 * Merge two plain objects. Keys that are objects in both will be merged property-wise.
	 */
	_deepMergeObjects(toObject, fromObject)
	{
		if (!fromObject || !this._isObject(fromObject))
		{
			return;
		}
		Object.keys(fromObject).forEach((key) =>
		{
			const fromValue = fromObject[key];
			if (this._isObject(fromValue))
			{
				const toValue = toObject[key];
				if (toValue && this._isObject(toValue))
				{
					// both are objects, so do a recursive merge
					this._deepMergeObjects(toValue, fromValue);
					return;
				}
			}
			toObject[key] = fromValue;
		});
		return toObject;
	}

	// Merge some new object into the existing settings.
	merge(pSettingsFrom, pSettingsTo)
	{
		// If an invalid settings from object is passed in (e.g. object constructor without passing in anything) this should still work
		let tmpSettingsFrom = (typeof(pSettingsFrom) === 'object') ? pSettingsFrom : {};
		// Default to the settings object if none is passed in for the merge.
		let tmpSettingsTo = (typeof(pSettingsTo) === 'object') ? pSettingsTo : this.settings;

		// do not mutate the From object property values
		let tmpSettingsFromCopy = JSON.parse(JSON.stringify(tmpSettingsFrom));
		tmpSettingsTo = this._deepMergeObjects(tmpSettingsTo, tmpSettingsFromCopy);

		if (this._PerformEnvTemplating)
		{
			this._resolveEnv(tmpSettingsTo);
		}
		// Update env tempating config, since we just updated the config object, and it may have changed
		this._configureEnvTemplating(tmpSettingsTo);

		return tmpSettingsTo;
	}

	// Fill in settings gaps without overwriting settings that are already there
	fill(pSettingsFrom)
	{
		// If an invalid settings from object is passed in (e.g. object constructor without passing in anything) this should still work
		let tmpSettingsFrom = (typeof(pSettingsFrom) === 'object') ? pSettingsFrom : {};

		// do not mutate the From object property values
		let tmpSettingsFromCopy = JSON.parse(JSON.stringify(tmpSettingsFrom));

		this.settings = this._deepMergeObjects(tmpSettingsFromCopy, this.settings);

		return this.settings;
	}
};

// This is for backwards compatibility
function autoConstruct(pSettings)
{
	return new FableSettings(pSettings);
}

module.exports = FableSettings;
module.exports.new = autoConstruct;
},{"../package.json":60,"./Fable-Settings-Default":61,"./Fable-Settings-TemplateProcessor.js":62,"fable-serviceproviderbase":59}],64:[function(require,module,exports){
module.exports={
  "_from": "fable-uuid@^3.0.14",
  "_id": "fable-uuid@3.0.14",
  "_inBundle": false,
  "_integrity": "sha512-Jbr9I1/TCdxtvD9udNFsRpdoa0XIfcgx6IEo6oa8hiPEWsPdzb2MnQGGRAPqsft5kC0eEYBr/sf4P3LqeFK7Jw==",
  "_location": "/fable-uuid",
  "_phantomChildren": {},
  "_requested": {
    "type": "range",
    "registry": true,
    "raw": "fable-uuid@^3.0.14",
    "name": "fable-uuid",
    "escapedName": "fable-uuid",
    "rawSpec": "^3.0.14",
    "saveSpec": null,
    "fetchSpec": "^3.0.14"
  },
  "_requiredBy": [
    "/fable"
  ],
  "_resolved": "https://registry.npmjs.org/fable-uuid/-/fable-uuid-3.0.14.tgz",
  "_shasum": "41a4550f6245c980ab731d44fac999730e3f6678",
  "_spec": "fable-uuid@^3.0.14",
  "_where": "/Users/jacksonpollard/pict/node_modules/fable",
  "author": {
    "name": "Steven Velozo",
    "email": "steven@velozo.com",
    "url": "http://velozo.com/"
  },
  "browser": {
    "./source/Fable-UUID-Random.js": "./source/Fable-UUID-Random-Browser.js"
  },
  "bugs": {
    "url": "https://github.com/stevenvelozo/fable-uuid/issues"
  },
  "bundleDependencies": false,
  "dependencies": {
    "fable-serviceproviderbase": "^3.0.19"
  },
  "deprecated": false,
  "description": "A simple UUID Generator.",
  "devDependencies": {
    "pict-docuserve": "^0.1.5",
    "quackage": "^1.1.2"
  },
  "homepage": "https://github.com/stevenvelozo/fable-uuid",
  "keywords": [
    "logging"
  ],
  "license": "MIT",
  "main": "source/Fable-UUID.js",
  "mocha": {
    "diff": true,
    "extension": [
      "js"
    ],
    "package": "./package.json",
    "reporter": "spec",
    "slow": "75",
    "timeout": "5000",
    "ui": "tdd",
    "watch-files": [
      "source/**/*.js",
      "test/**/*.js"
    ],
    "watch-ignore": [
      "lib/vendor"
    ]
  },
  "name": "fable-uuid",
  "repository": {
    "type": "git",
    "url": "git+https://github.com/stevenvelozo/fable-uuid.git"
  },
  "scripts": {
    "build": "npx quack build",
    "coverage": "npx quack coverage",
    "docker-dev-build-image": "docker build ./ -f Dockerfile_LUXURYCode -t retold/fable-uuid:local",
    "docker-dev-run": "docker run -it -d --name retold-fable-uuid-dev -p 30002:8080 -v \"$PWD/.config:/home/coder/.config\"  -v \"$PWD:/home/coder/fable-uuid\" -u \"$(id -u):$(id -g)\" -e \"DOCKER_USER=$USER\" retold/fable-uuid:local",
    "start": "node source/Fable-UUID.js",
    "test": "npx quack test"
  },
  "version": "3.0.14"
}

},{}],65:[function(require,module,exports){
/**
* Random Byte Generator - Browser version
*
*
* @author Steven Velozo <steven@velozo.com>
*/

// Adapted from node-uuid (https://github.com/kelektiv/node-uuid)
// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection
class RandomBytes
{
	constructor()
	{

		// getRandomValues needs to be invoked in a context where "this" is a Crypto
		// implementation. Also, find the complete implementation of crypto on IE11.
		this.getRandomValues = (typeof(crypto) != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto)) ||
                      		(typeof(msCrypto) != 'undefined' && typeof window.msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto));
	}

	// WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
	generateWhatWGBytes()
	{
		let tmpBuffer = new Uint8Array(16); // eslint-disable-line no-undef

		this.getRandomValues(tmpBuffer);
		return tmpBuffer;
	}

	// Math.random()-based (RNG)
	generateRandomBytes()
	{
		// If all else fails, use Math.random().  It's fast, but is of unspecified
		// quality.
		let tmpBuffer = new Uint8Array(16); // eslint-disable-line no-undef

		for (let i = 0, tmpValue; i < 16; i++)
		{
			if ((i & 0x03) === 0)
			{
				tmpValue = Math.random() * 0x100000000;
			}

			tmpBuffer[i] = tmpValue >>> ((i & 0x03) << 3) & 0xff;
		}

		return tmpBuffer;
	}

	generate()
	{
		if (this.getRandomValues)
		{
			return this.generateWhatWGBytes();
		}
		else
		{
			return this.generateRandomBytes();
		}
	}
}

module.exports = RandomBytes;

},{}],66:[function(require,module,exports){
/**
* Fable UUID Generator
*/

const libFableServiceProviderBase = require('fable-serviceproviderbase').CoreServiceProviderBase;0

const libRandomByteGenerator = require('./Fable-UUID-Random.js')

const libPackage = require('../package.json');

class FableUUID extends libFableServiceProviderBase
{
	constructor(pSettings, pServiceHash)
	{
		super(pSettings, pServiceHash);

		this.serviceType = 'UUID';
		/** @type {Object} */
		this._Package = libPackage;

		// Determine if the module is in "Random UUID Mode" which means just use the random character function rather than the v4 random UUID spec.
		// Note this allows UUIDs of various lengths (including very short ones) although guaranteed uniqueness goes downhill fast.
		this._UUIDModeRandom = (typeof(pSettings) === 'object') && ('UUIDModeRandom' in pSettings) ? (pSettings.UUIDModeRandom == true) : false;
		// These two properties are only useful if we are in Random mode.  Otherwise it generates a v4 spec
		// Length for "Random UUID Mode" is set -- if not set it to 8
		this._UUIDLength = (typeof(pSettings) === 'object') && ('UUIDLength' in pSettings) ? (pSettings.UUIDLength + 0) : 8;
		// Dictionary for "Random UUID Mode"
		this._UUIDRandomDictionary = (typeof(pSettings) === 'object') && ('UUIDDictionary' in pSettings) ? (pSettings.UUIDDictionary + 0) : '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';

		this.randomByteGenerator = new libRandomByteGenerator();

		// Lookup table for hex codes
		this._HexLookup = [];
		for (let i = 0; i < 256; ++i)
		{
			this._HexLookup[i] = (i + 0x100).toString(16).substr(1);
		}
	}

	// Adapted from node-uuid (https://github.com/kelektiv/node-uuid)
	bytesToUUID(pBuffer)
	{
		let i = 0;
		// join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
		return ([
					this._HexLookup[pBuffer[i++]], this._HexLookup[pBuffer[i++]], 
					this._HexLookup[pBuffer[i++]], this._HexLookup[pBuffer[i++]], '-',
					this._HexLookup[pBuffer[i++]], this._HexLookup[pBuffer[i++]], '-',
					this._HexLookup[pBuffer[i++]], this._HexLookup[pBuffer[i++]], '-',
					this._HexLookup[pBuffer[i++]], this._HexLookup[pBuffer[i++]], '-',
					this._HexLookup[pBuffer[i++]], this._HexLookup[pBuffer[i++]], this._HexLookup[pBuffer[i++]], this._HexLookup[pBuffer[i++]], this._HexLookup[pBuffer[i++]], this._HexLookup[pBuffer[i++]]
				]).join('');
	}

	// Adapted from node-uuid (https://github.com/kelektiv/node-uuid)
	generateUUIDv4()
	{
		let tmpBuffer = new Array(16);
		var tmpRandomBytes = this.randomByteGenerator.generate();

		// Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
		tmpRandomBytes[6] = (tmpRandomBytes[6] & 0x0f) | 0x40;
		tmpRandomBytes[8] = (tmpRandomBytes[8] & 0x3f) | 0x80;

		return this.bytesToUUID(tmpRandomBytes);
	}

	// Simple random UUID generation
	generateRandom()
	{
		let tmpUUID = '';

		for (let i = 0; i < this._UUIDLength; i++)
		{
			tmpUUID += this._UUIDRandomDictionary.charAt(Math.floor(Math.random() * (this._UUIDRandomDictionary.length-1)));
		}

		return tmpUUID;
	}

	// Adapted from node-uuid (https://github.com/kelektiv/node-uuid)
	getUUID()
	{
		if (this._UUIDModeRandom)
		{
			return this.generateRandom();
		}
		else
		{
			return this.generateUUIDv4();
		}
	}
}

// This is for backwards compatibility
function autoConstruct(pSettings)
{
	return new FableUUID(pSettings);
}


module.exports = FableUUID;
module.exports.new = autoConstruct;

},{"../package.json":64,"./Fable-UUID-Random.js":65,"fable-serviceproviderbase":59}],67:[function(require,module,exports){
module.exports={
  "_from": "fable@^3.1.74",
  "_id": "fable@3.1.75",
  "_inBundle": false,
  "_integrity": "sha512-HHe53CNv5gXZZ0FEq2qoj0RqlF9TsIFQ1WX/V2CGj8POKJhM3JbUVIyxBcpZr5zHGbzZ+9PWZ0TUdxQWUYJ9zg==",
  "_location": "/fable",
  "_phantomChildren": {},
  "_requested": {
    "type": "range",
    "registry": true,
    "raw": "fable@^3.1.74",
    "name": "fable",
    "escapedName": "fable",
    "rawSpec": "^3.1.74",
    "saveSpec": null,
    "fetchSpec": "^3.1.74"
  },
  "_requiredBy": [
    "/",
    "/foxhound",
    "/meadow-endpoints",
    "/meadow-integration",
    "/meadow-migrationmanager",
    "/pict",
    "/pict-terminalui",
    "/pict-view",
    "/retold-data-service",
    "/stricture",
    "/stricture/pict-terminalui"
  ],
  "_resolved": "https://registry.npmjs.org/fable/-/fable-3.1.75.tgz",
  "_shasum": "1e61d5f1ee963e1b9810b5c28757fe1cfaff052a",
  "_spec": "fable@^3.1.74",
  "_where": "/Users/jacksonpollard/pict",
  "author": {
    "name": "Steven Velozo",
    "email": "steven@velozo.com",
    "url": "http://velozo.com/"
  },
  "browser": {
    "./source/service/Fable-Service-EnvironmentData.js": "./source/service/Fable-Service-EnvironmentData-Web.js",
    "./source/service/Fable-Service-FilePersistence.js": "./source/service/Fable-Service-FilePersistence-Web.js"
  },
  "bugs": {
    "url": "https://github.com/stevenvelozo/fable/issues"
  },
  "bundleDependencies": false,
  "dependencies": {
    "async.eachlimit": "^0.5.2",
    "async.waterfall": "^0.5.2",
    "big.js": "^7.0.1",
    "cachetrax": "^1.0.6",
    "cookie": "^1.1.1",
    "data-arithmatic": "^1.0.7",
    "dayjs": "^1.11.19",
    "fable-log": "^3.0.18",
    "fable-serviceproviderbase": "^3.0.19",
    "fable-settings": "^3.0.16",
    "fable-uuid": "^3.0.14",
    "manyfest": "^1.0.49",
    "simple-get": "^4.0.1"
  },
  "deprecated": false,
  "description": "A service dependency injection, configuration and logging library.",
  "devDependencies": {
    "pict-docuserve": "^1.3.2",
    "quackage": "^1.2.3"
  },
  "homepage": "https://github.com/stevenvelozo/fable",
  "keywords": [
    "entity",
    "behavior"
  ],
  "license": "MIT",
  "main": "source/Fable.js",
  "mocha": {
    "diff": true,
    "extension": [
      "js"
    ],
    "package": "./package.json",
    "reporter": "spec",
    "slow": "75",
    "timeout": "5000",
    "ui": "tdd",
    "watch-files": [
      "source/**/*.js",
      "test/**/*.js"
    ],
    "watch-ignore": [
      "lib/vendor"
    ]
  },
  "name": "fable",
  "repository": {
    "type": "git",
    "url": "git+https://github.com/stevenvelozo/fable.git"
  },
  "scripts": {
    "build": "npx quack build",
    "coverage": "npx quack coverage",
    "docker-dev-build": "docker build ./ -f Dockerfile_LUXURYCode -t fable-image:local",
    "docker-dev-run": "docker run -it -d --name fable-dev -p 30001:8080 -p 38086:8086 -v \"$PWD/.config:/home/coder/.config\"  -v \"$PWD:/home/coder/fable\" -u \"$(id -u):$(id -g)\" -e \"DOCKER_USER=$USER\" fable-image:local",
    "docker-dev-shell": "docker exec -it fable-dev /bin/bash",
    "prepublishOnly": "npx quack build",
    "start": "node source/Fable.js",
    "test": "npx quack test",
    "tests": "npx quack test -g"
  },
  "version": "3.1.75"
}

},{}],68:[function(require,module,exports){
/**
* Fable Application Services Support Library
* @author <steven@velozo.com>
*/
// Pre-init services
const libFableSettings = require('fable-settings');
const libFableUUID = require('fable-uuid');
const libFableLog = require('fable-log');

const libPackage = require('../package.json');

const libFableServiceBase = require('fable-serviceproviderbase');

class Fable extends libFableServiceBase.CoreServiceProviderBase
{
	constructor(pSettings)
	{
		super(pSettings);

		// Initialization Phase 0: Set up the lowest level state (fable is a utility service manager at heart)
		this.serviceType = 'ServiceManager';
		/** @type {Object} */
		this._Package = libPackage;

		// An array of the types of services available
		this.serviceTypes = [];
		// A map of instantiated services
		this.servicesMap = {};
		// A map of the default instantiated service by type
		this.services = {};

		// A map of class constructors for services
		this.serviceClasses = {};

		// If we need extra service initialization capabilities
		this.extraServiceInitialization = false;

		// Set how noisy the system is about signaling complexity
		this.LogNoisiness = 0;

		// Initialization Phase 1: Set up the core utility services
		// These are things like power, water, and sewage.  They are required for fable to run (e.g. logging, settings, etc)

		// Instantiate the default Settings Manager
		this.SettingsManager = new libFableSettings(pSettings);
		this.SettingsManager = this.SettingsManager;
		// Instantiate the UUID generator
		this.UUID = new libFableUUID(this.SettingsManager.settings);
		// Instantiate the logging system
		this.Logging = new libFableLog(this.SettingsManager.settings);
		this.Logging.initialize();

		// Initialization Phase 1.5: Instantiate the service manager
		// This is the start actual bootstrapping point for fable.
		// For consistency fable is treated as a service.
		this.ServiceManager = this;
		// TODO: Remove this when Orator and meadow-endpoints are shifted to this new pattern
		this.serviceManager = this;
		// END TODO
		this.connectFable(this);
		// --> Bootstrapping of fable into the Service Manager is complete

		// Initialization Phase 2: Map in the default services.
		// They will then be available in the Default service provider set as well.
		this.connectPreinitServiceProviderInstance(this.UUID);
		this.connectPreinitServiceProviderInstance(this.Logging);
		this.connectPreinitServiceProviderInstance(this.SettingsManager);

		// Initialize and instantiate the default baked-in Data Arithmatic service
		this.addAndInstantiateServiceType('EnvironmentData', require('./services/Fable-Service-EnvironmentData.js'));
		this.addServiceType('Template', require('./services/Fable-Service-Template.js'));
		this.addServiceType('MetaTemplate', require('./services/Fable-Service-MetaTemplate.js'));
		this.addServiceType('Anticipate', require('./services/Fable-Service-Anticipate.js'));
		this.addAndInstantiateServiceType('Dates', require('./services/Fable-Service-DateManipulation.js'));
		this.addAndInstantiateServiceType('DataFormat', require('./services/Fable-Service-DataFormat.js'));
		this.addAndInstantiateServiceType('DataGeneration', require('./services/Fable-Service-DataGeneration.js'));
		this.addAndInstantiateServiceType('Utility', require('./services/Fable-Service-Utility.js'));
		this.addAndInstantiateServiceType('Logic', require('./services/Fable-Service-Logic.js'));
		this.addAndInstantiateServiceType('Math', require('./services/Fable-Service-Math.js'));
		this.addServiceType('ExpressionParser', require('./services/Fable-Service-ExpressionParser.js'));
		this.addServiceType('RestClient', require('./services/Fable-Service-RestClient.js'));
		this.addServiceType('Manifest', require('manyfest'));
		this.addServiceType('ObjectCache', require('cachetrax'));
		this.addAndInstantiateServiceType('ProgressTime', require('./services/Fable-Service-ProgressTime.js'));
		this.addServiceType('ProgressTrackerSet', require('./services/Fable-Service-ProgressTrackerSet.js'));
		this.addServiceType('Operation', require('./services/Fable-Service-Operation.js'));
		this.addServiceType('CSVParser', require('./services/Fable-Service-CSVParser.js'));
		this.addServiceType('FilePersistence', require('./services/Fable-Service-FilePersistence.js'));
	}

	/* State Accessors */
	get isFable()
	{
		return true;
	}

	get settings()
	{
		return this.SettingsManager.settings;
	}

	get settingsManager()
	{
		return this.SettingsManager;
	}

	// For backwards compatibility
	getUUID()
	{
		return this.UUID.getUUID();
	}

	newAnticipate()
	{
		return this.instantiateServiceProviderWithoutRegistration('Anticipate');
	}

	newManyfest(pManifestDefinition)
	{
		return this.instantiateServiceProviderWithoutRegistration('Manifest', pManifestDefinition);
	}

	/* Service Manager Methods */
	addServiceType(pServiceType, pServiceClass)
	{
		if (pServiceType in this.servicesMap)
		{
			//this.log.warn(`Adding a service type [${pServiceType}] that already exists.  This will change the default class prototype for this service.`);
			// This broke command-line utilities that overrode services and wanted to strictly control log output
		}
		else
		{
			// Add the container for instantiated services to go in
			this.servicesMap[pServiceType] = {};

			// Add the type to the list of types
			this.serviceTypes.push(pServiceType);
		}

		// Using the static member of the class is a much more reliable way to check if it is a service class than instanceof
		if ((typeof(pServiceClass) == 'function') && (pServiceClass.isFableService))
		{
			// Add the class to the list of classes
			this.serviceClasses[pServiceType] = pServiceClass;
		}
		else
		{
			// Add the base class to the list of classes
			this.log.error(`Attempted to add service type [${pServiceType}] with an invalid class.  Using base service class, which will not crash but won't provide meaningful services.`);
			this.serviceClasses[pServiceType] = libFableServiceBase;
		}

		return this.serviceClasses[pServiceType];
	}

	addServiceTypeIfNotExists(pServiceType, pServiceClass)
	{
		if (!(pServiceType in this.servicesMap))
		{
			return this.addServiceType(pServiceType, pServiceClass);
		}
		else
		{
			return this.serviceClasses[pServiceType];
		}
	}

	// This is for the services that are meant to run mostly single-instance so need a default at initialization
	addAndInstantiateServiceType(pServiceType, pServiceClass)
	{
		this.addServiceType(pServiceType, pServiceClass);
		return this.instantiateServiceProvider(pServiceType, {}, `${pServiceType}-Default`);
	}

	addAndInstantiateServiceTypeIfNotExists(pServiceType, pServiceClass)
	{
		this.addServiceTypeIfNotExists(pServiceType, pServiceClass);

		if ((!(pServiceType in this.servicesMap)) || (!(pServiceType in this.fable)))
		{
			return this.instantiateServiceProvider(pServiceType, {}, `${pServiceType}-Default`);
		}
		else
		{
			return this[pServiceType];
		}
	}

	addAndInstantiateSingletonService(pServiceType, pOptions, pServiceClass)
	{
		this.addServiceTypeIfNotExists(pServiceType, pServiceClass);

		if ((!(pServiceType in this.servicesMap)) || (!(pServiceType in this.fable)))
		{
			return this.instantiateServiceProvider(pServiceType, {}, `${pServiceType}-Default`);
		}
		else
		{
			return this[pServiceType];
		}
	}

	// Some services expect to be overloaded / customized class.
	instantiateServiceProviderFromPrototype(pServiceType, pOptions, pCustomServiceHash, pServicePrototype)
	{
		// Instantiate the service
		let tmpService = new pServicePrototype(this, pOptions, pCustomServiceHash);

		if (this.extraServiceInitialization)
		{
			tmpService = this.extraServiceInitialization(tmpService);
		}

		// Add the service to the service map
		this.servicesMap[pServiceType][tmpService.Hash] = tmpService;

		// If this is the first service of this type, make it the default
		if (!(pServiceType in this.services))
		{
			this.setDefaultServiceInstantiation(pServiceType, tmpService.Hash)
		}

		return tmpService;
	}

	instantiateServiceProvider(pServiceType, pOptions, pCustomServiceHash)
	{
		// Instantiate the service
		let tmpService = this.instantiateServiceProviderWithoutRegistration(pServiceType, pOptions, pCustomServiceHash);

		// Add the service to the service map
		this.servicesMap[pServiceType][tmpService.Hash] = tmpService;

		// If this is the first service of this type, make it the default
		if (!(pServiceType in this.services))
		{
			this.setDefaultServiceInstantiation(pServiceType, tmpService.Hash)
		}

		return tmpService;
	}

	instantiateServiceProviderIfNotExists(pServiceType, pOptions, pCustomServiceHash)
	{
		if (pServiceType in this.services)
		{
			return this.services[pServiceType];
		}
		else
		{
			return this.instantiateServiceProvider(pServiceType, pOptions, pCustomServiceHash);
		}
	}

	// Create a service provider but don't register it to live forever in fable.services
	instantiateServiceProviderWithoutRegistration(pServiceType, pOptions, pCustomServiceHash)
	{
		// Instantiate the service
		let tmpService = new this.serviceClasses[pServiceType](this, pOptions, pCustomServiceHash);
		if (this.extraServiceInitialization)
		{
			tmpService = this.extraServiceInitialization(tmpService);
		}
		return tmpService;
	}

	// Connect an initialized service provider that came before Fable was initialized
	connectPreinitServiceProviderInstance(pServiceInstance)
	{
		let tmpServiceType = pServiceInstance.serviceType;
		let tmpServiceHash = pServiceInstance.Hash;

		// The service should already be instantiated, so just connect it to fable
		pServiceInstance.connectFable(this);

		// Add the service type to the map if it isn't there yet
		if (!(tmpServiceType in this.servicesMap))
		{
			// If the core service hasn't registered itself yet, create the service container for it.
			// This means you couldn't register another with this type unless it was later registered with a constructor class.
			this.servicesMap[tmpServiceType] = {};
		}
		// Add the service to the service map
		this.servicesMap[tmpServiceType][tmpServiceHash] = pServiceInstance;

		// If this is the first service of this type, make it the default
		if (!(tmpServiceType in this.services))
		{
			this.setDefaultServiceInstantiation(tmpServiceType, tmpServiceHash, false);
		}

		return pServiceInstance;
	}

	setDefaultServiceInstantiation(pServiceType, pServiceHash, pOverwriteService)
	{
		// Overwrite services by default, unless told not to
		let tmpOverwriteService = (typeof(pOverwriteService) === 'undefined') ? true : pOverwriteService;
		// Make sure the service exists
		if (pServiceHash in this.servicesMap[pServiceType])
		{
			if (!(pServiceType in this) || tmpOverwriteService)
			{
				this[pServiceType] = this.servicesMap[pServiceType][pServiceHash];
			}
			if (!(pServiceType in this.services) || tmpOverwriteService)
			{
				this.services[pServiceType] = this.servicesMap[pServiceType][pServiceHash];
			}
			return true;
		}

		return false;
	}

	/**
	 * Generate a safe string to use in filenames for a date.  Useful for log file uniqueness and temporary outputs.
	 *
	 * @static
	 * @param {Date} pDate - An optional javascript Date object to generate a datestamp for.
	 * @returns {string} - A string formatted as YYYY-MM-DD-HH-MM-SS
	 */
	static generateFileNameDateStamp(pDate)
	{
		const tmpDate = pDate || new Date();
		const tmpYear = tmpDate.getFullYear();
		const tmpMonth = String(tmpDate.getMonth() + 1).padStart(2, '0');
		const tmpDay = String(tmpDate.getDate()).padStart(2, '0');
		const tmpHour = String(tmpDate.getHours()).padStart(2, '0');
		const tmpMinute = String(tmpDate.getMinutes()).padStart(2, '0');
		const tmpSecond = String(tmpDate.getSeconds()).padStart(2, '0');
		return `${tmpYear}-${tmpMonth}-${tmpDay}-${tmpHour}-${tmpMinute}-${tmpSecond}`;
	}
}

// This is for backwards compatibility
function autoConstruct(pSettings)
{
	return new Fable(pSettings);
}

module.exports = Fable;
module.exports.new = autoConstruct;

module.exports.LogProviderBase = libFableLog.LogProviderBase;
module.exports.ServiceProviderBase = libFableServiceBase;
module.exports.CoreServiceProviderBase = libFableServiceBase.CoreServiceProviderBase;

module.exports.precedent = libFableSettings.precedent;

},{"../package.json":67,"./services/Fable-Service-Anticipate.js":69,"./services/Fable-Service-CSVParser.js":70,"./services/Fable-Service-DataFormat.js":71,"./services/Fable-Service-DataGeneration.js":73,"./services/Fable-Service-DateManipulation.js":74,"./services/Fable-Service-EnvironmentData.js":75,"./services/Fable-Service-ExpressionParser.js":76,"./services/Fable-Service-FilePersistence.js":87,"./services/Fable-Service-Logic.js":88,"./services/Fable-Service-Math.js":89,"./services/Fable-Service-MetaTemplate.js":90,"./services/Fable-Service-Operation.js":94,"./services/Fable-Service-ProgressTime.js":95,"./services/Fable-Service-ProgressTrackerSet.js":97,"./services/Fable-Service-RestClient.js":98,"./services/Fable-Service-Template.js":99,"./services/Fable-Service-Utility.js":100,"cachetrax":22,"fable-log":57,"fable-serviceproviderbase":59,"fable-settings":63,"fable-uuid":66,"manyfest":127}],69:[function(require,module,exports){
const libFableServiceBase = require('fable-serviceproviderbase');

class FableServiceAnticipate extends libFableServiceBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.serviceType = 'AsyncAnticipate';

		// The queue of operations waiting to run.
		this.operationQueue = [];
		this.erroredOperations = [];

		this.executingOperationCount = 0;
		this.completedOperationCount = 0;

		this.callDepth = 0;

		this.maxOperations = 1;

		this.lastError = undefined;
		this.waitingFunctions = [];
	}

	checkQueue()
	{
		// This could be combined with the last else if stanza but the logic for errors and non-errors would be blended and more complex to follow so keeping it unrolled.
		if (this.lastError)
		{
			// If there are no operations left, and we have waiting functions, call them.
			for (let i = 0; i < this.waitingFunctions.length; i++)
			{
				//this.log.trace('Calling waiting function.')
				this.waitingFunctions[i](this.lastError);
			}
			// Reset our state
			this.lastError = undefined;
			this.waitingFunctions = [];
		}
		// This checks to see if we need to start any operations.
		else if (this.operationQueue.length > 0 && this.executingOperationCount < this.maxOperations)
		{
			let tmpOperation = this.operationQueue.shift();
			this.executingOperationCount += 1;
			tmpOperation(this.buildAnticipatorCallback());
		}
		else if (this.waitingFunctions.length > 0 && this.executingOperationCount < 1)
		{
			// If there are no operations left, and we have waiting functions, call them.
			for (let i = 0; i < this.waitingFunctions.length; i++)
			{
				//this.log.trace('Calling waiting function.')
				this.waitingFunctions[i](this.lastError);
			}
			// Reset our state
			this.lastError = undefined;
			this.waitingFunctions = [];
		}
	}

	// Expects a function fAsynchronousFunction(fCallback)
	anticipate(fAsynchronousFunction)
	{
		//this.log.trace('Adding a function...')
		this.operationQueue.push(fAsynchronousFunction);
		this.checkQueue();
	}

	buildAnticipatorCallback()
	{
		// This uses closure-scoped state to track the callback state
		let tmpCallbackState = (
			{
				Called: false,
				Error: undefined,
				OperationSet: this
			});
		return hoistedCallback.bind(this);
		function hoistedCallback(pError)
		{
			if (tmpCallbackState.Called)
			{
				// If they call the callback twice, throw an error
				throw new Error("Anticipation async callback called twice...");
			}
			tmpCallbackState.Called = true;
			this.lastError = pError;

			tmpCallbackState.OperationSet.executingOperationCount -= 1;
			tmpCallbackState.OperationSet.completedOperationCount += 1;

			tmpCallbackState.OperationSet.callDepth++;

			// TODO: Figure out a better pattern for chaining templates so the call stack doesn't get abused.
			if (tmpCallbackState.OperationSet.callDepth > 400)
			{
				tmpCallbackState.OperationSet.callDepth = 0;
				setTimeout(tmpCallbackState.OperationSet.checkQueue.bind(this), 0);
			}
			else
			{
				tmpCallbackState.OperationSet.checkQueue();
			}
		}
	}

	wait(fCallback)
	{
		this.waitingFunctions.push(fCallback);
		this.checkQueue();
	}
}

module.exports = FableServiceAnticipate;
},{"fable-serviceproviderbase":59}],70:[function(require,module,exports){
const libFableServiceProviderBase = require('fable-serviceproviderbase');
/**
* Parsing CSVs.  Why?  Because it's a thing that needs to be done.
*
* 1. And the other node CSV parsers had issues with the really messy files we had.
*
*
* 2. None of the CSV parsers dealt with and multi-line quoted string columns
*	which are apparently a-ok according to the official spec.
* Plus a lot of them are asynchronous because apparently that's the best way to
* do anything; unfortunately some files have a sequence issue with that.
*
* @class CSVParser
*/
class CSVParser extends libFableServiceProviderBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.serviceType = 'CSVParser';

		this.Header = [];
		this.HeaderFieldNames = [];

		this.Delimiter = ',';
		this.QuoteCharacter = '"';

		this.CleanCharacters = ['\r'];

		this.HeaderLineIndex = 0;
		this.HasHeader = true;
		this.HasSetHeader = false;
		this.EmitHeader = false;

		this.EmitJSON = true;

		this.EscapedQuoteString = '&quot;';

		// Current Line Parsing State
		this.CurrentLine = '';
		this.CurrentRecord = [];

		this.InQuote = false;
		this.InEscapedQuote = false;

		this.LinesParsed = 0;
		this.RowsEmitted = 0;
	}

	marshalRowToJSON(pRowArray)
	{
		if (!Array.isArray(pRowArray))
		{
			return false;
		}

		for (let i = this.HeaderFieldNames.length; i < pRowArray.length; i++)
		{
			this.HeaderFieldNames[i] = `${i}`;
		}

		let tmpObject = {};

		for (let i = 0; i < pRowArray.length; i++)
		{
			tmpObject[this.HeaderFieldNames[i]] = pRowArray[i];
		}

		return tmpObject;
	}

	// Set the header data, for use in marshalling to JSON.
	setHeader (pHeaderArray)
	{
		this.Header = pHeaderArray;

		for (let i = 0; i < this.Header.length; i++)
		{
			if (typeof(this.Header[i]) == 'undefined')
			{
				this.HeaderFieldNames[i] = `${i}`;
			}
			else
			{
				this.HeaderFieldNames[i] = this.Header[i].toString().trim();
			}
		}
	}

	resetRowState()
	{
		this.CurrentRecord = [];
	}

	pushLine()
	{
		for (let i = 0; i < this.CleanCharacters.length; i++)
		{
			this.CurrentLine = this.CurrentLine.replace(this.CleanCharacters[i],'');
		}
		this.CurrentRecord.push(this.CurrentLine);
		this.CurrentLine = '';
	}

	emitRow(pFormatAsJSON)
	{
		let tmpFormatAsJSON = (typeof(pFormatAsJSON) == 'undefined') ? this.EmitJSON : pFormatAsJSON;

		this.RowsEmitted++;
		let tmpCompletedRecord = this.CurrentRecord;
		this.CurrentRecord = [];

		if (tmpFormatAsJSON)
		{
			return this.marshalRowToJSON(tmpCompletedRecord);
		}
		else
		{
			return tmpCompletedRecord;
		}
	}

	parseCSVLine (pLineString)
	{
		this.LinesParsed++;

		for (let i = 0; i < pLineString.length; i++)
		{
			if ((!this.InQuote) && (pLineString[i] == this.Delimiter))
			{
				this.pushLine();
			}
			else if (pLineString[i] == this.QuoteCharacter)
			{
				// If we are in the second part of an escaped quote, ignore it.
				if (this.InEscapedQuote)
				{
					this.InEscapedQuote = false;
				}
				// If we aren't in a quote, enter quote
				else if (!this.InQuote)
				{
					this.InQuote = true;
				}
				// We are in a quote, so peek forward to see if this is an "escaped" quote pair
				else if ((i < pLineString.length) && (pLineString[i+1] == this.QuoteCharacter))
				{
					this.CurrentLine += this.EscapedQuoteString;
					this.InEscapedQuote = true;
				}
				// We are in a quote, this isn't an "escaped" quote pair, so go out of quote mode
				else
				{
					this.InQuote = false;
				}
			}
			else
			{
				this.CurrentLine += pLineString[i];
			}
		}

		// See if we are in a multiline quoted entry -- if not, emit the row.
		if (!this.InQuote)
		{
			// Push the last remaining column from the buffer to the current line.
			this.pushLine();

			// Check to see if there is a header -- and if so, if this is the header row
			if (this.HasHeader && !this.HasSetHeader && (this.RowsEmitted == this.HeaderLineIndex))
			{
				this.HasSetHeader = true;
				// Override the format as json bit
				this.setHeader(this.emitRow(false));

				// No matter what, formatting this as JSON is silly and we don't want to go there anyway.
				if (this.EmitHeader)
				{
					return this.Header;
				}
				else
				{
					return false;
				}
			}
			else
			{
				return this.emitRow();
			}
		}
		else
		{
			return false;
		}
	};
}

module.exports = CSVParser;

},{"fable-serviceproviderbase":59}],71:[function(require,module,exports){
const libFableServiceProviderBase = require('fable-serviceproviderbase');
/**
* Data Formatting and Translation Functions
*
* @class DataFormat
*/
class DataFormat extends libFableServiceProviderBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.serviceType = 'DataArithmatic';

		// Regular Expressions (so they don't have to be recompiled every time)
		// These could be defined as static, but I'm not sure if that will work with browserify ... and specifically the QT browser.
		this._Regex_formatterInsertCommas = /.{1,3}/g;
		// Match Function:
		// function(pMatch, pSign, pZeros, pBefore, pDecimal, pAfter)
		// Thoughts about below:   /^([+-]?)(0*)(\d+)(\.(\d+))?$/;
		this._Regex_formatterAddCommasToNumber = /^([-+]?)(0?)(\d+)(.?)(\d+)$/g;
		this._Regex_formatterDollarsRemoveCommas = /,/gi;
		this._Regex_formatterCleanNonAlphaChar = /[^a-zA-Z]/gi;
		this._Regex_formatterCapitalizeEachWord = /([a-zA-Z]+)/g;
		this._Regex_matcherHTMLEntities = /&(#?[a-zA-Z0-9]+);/g;

		// TODO: Potentially pull these in from a configuration.
		// TODO: Use locale data for this if it's defaults all the way down.
		this._Value_MoneySign_Currency = '$';
		this._Value_NaN_Currency = '--';
		this._Value_GroupSeparator_Number = ',';

		this._Value_Prefix_StringHash = 'HSH';
		this._Value_Clean_formatterCleanNonAlpha = '';

		this._UseEngineStringStartsWith = (typeof(String.prototype.startsWith) === 'function');
		this._UseEngineStringEndsWith = (typeof(String.prototype.endsWith) === 'function');

		this._SanitizeObjectKeyRegex = /[^a-zA-Z0-9_]/gi;
		this._SanitizeObjectKeyReplacement = '_';
		this._SanitizeObjectKeyInvalid = 'INVALID';
	}

	/*************************************************************************
	 * String Manipulation and Comparison Functions
	 *-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*/

	/**
	 * Reverse a string
	 *
	 * @param {string} pString - The string to reverse
	 * @returns {string}
	 */
	stringReverse (pString)
	{
		// TODO: Benchmark if there are faster ways we want to do this with all the newer JS stuff
		//       ... and if it will work with browserify in a clean way.
		return pString.split('').reverse().join('');
	}

	/**
	 * Test if a string starts with a given substring.
	 *
	 * @param {*} pString
	 * @param {*} pSearchString
	 * @param {*} pStartIndex
	 * @returns {boolean}
	 */
	stringStartsWith (pString, pSearchString, pStartIndex)
	{
		if (this._UseEngineStringStartsWith)
		{
			return pString.startsWith(pSearchString, pStartIndex);
		}
		else
		{
			return this.stringStartsWith_Polyfill.call(pString, pSearchString, pStartIndex);
		}
	}

	/**
	 * Check if a string starts with a given substring.  This is a safe polyfill for the ES6 string.startsWith() function.
	 *
	 * @param {*} pSearchString - The string to search for
	 * @param {*} pStartIndex - The index to start the search at
	 * @returns {boolean}
	 */
	stringStartsWith_Polyfill (pSearchString, pStartIndex)
	{
		return this.slice(pStartIndex || 0, pSearchString.length) === pSearchString;
	}

	/**
	 * Test if a string starts with a given substring.
	 *
	 * @param {*} pString
	 * @param {*} pSearchString
	 * @param {*} pEndIndex
	 * @returns {*}
	 */
	stringEndsWith (pString, pSearchString, pEndIndex)
	{
		if (this._UseEngineStringEndsWith)
		{
			return pString.endsWith(pSearchString, pEndIndex);
		}
		else
		{
			return this.stringEndsWith_Polyfill.call(pString, pSearchString, pEndIndex);
		}
	}

	/**
	 * Check if a string starts with a given substring.  This is a safe polyfill for the ES6 string.startsWith() function.
	 *
	 * @param {*} pSearchString - The string to search for
	 * @param {*} pEndIndex - The index to end the search at
	 * @returns {boolean}
	 */
	stringEndsWith_Polyfill (pSearchString, pEndIndex)
	{
		// This works much better than >= because
		// it compensates for NaN:
		if (!(pEndIndex < this.length))
		{
			pEndIndex = this.length;
		}
		else
		{
			pEndIndex |= 0; // round position
		}
		return this.substr(pEndIndex - pSearchString.length, pSearchString.length) === pSearchString;
	}

	/**
	 * Generate an insecure string hash.  Not meant to be secure, just a quick way to generate a hash for a string.  This is not a cryptographic hash.  Additional warranty and disclaimer ... this is not for passwords!
	 *
	 * @param {string} pString
	 * @returns {string}
	 */
	insecureStringHash (pString)
	{
		let tmpHash = 0;
		let tmpStringLength = pString.length;
		let tmpCharacterIndex = 0;

		while (tmpCharacterIndex < tmpStringLength)
		{
			tmpHash = (tmpHash << 5) - tmpHash + pString.charCodeAt(tmpCharacterIndex++) | 0;
		}

		return `${this._Value_Prefix_StringHash}${tmpHash}`;
	}

	capitalizeEachWord (pString)
	{
		return pString.replace(this._Regex_formatterCapitalizeEachWord,
			(pMatch) =>
			{
				return pMatch.charAt(0).toUpperCase() + pMatch.substr(1);
			});
	}

	/**
	 * @param {string} pString - The string to resolve
	 * @return {string} - The input string with all HTML entities resolved to their character counterparts
	 */
	resolveHtmlEntities(pString)
	{
		if (typeof(pString) !== 'string')
		{
			return pString;
		}

		return pString.replace(this._Regex_matcherHTMLEntities, (pMatch, pEntity) =>
		{
			switch (pEntity)
			{
				case 'comma':
					return ',';
				case 'amp':
					return '&';
				case 'lt':
					return '<';
				case 'gt':
					return '>';
				case 'times':
					return '×';
				case 'divide':
					return '÷';
				case 'plus':
					return '+';
				case 'minus':
					return '-';
				case 'infin':
					return '∞';
				case 'ang':
					return '∠';
				case 'quot':
					return '"';
				case 'apos':
					return '\'';
				case 'nbsp':
					return ' ';
				case 'copy':
					return '©';
				case 'reg':
					return '®';
				case 'trade':
					return '™';
				case 'euro':
					return '€';
				default:
					if (!pEntity.startsWith('#'))
					{
						return pMatch;
					}
			}
			const tmpNumericalValue = parseInt(pEntity.substring(1), 10);
			return String.fromCharCode(tmpNumericalValue);
		});
	}

	/**
	 * Concatenate a list of strings together. Non-strings are excluded.
	 *
	 * @param {...string} pStrings - The strings to concatenate
	 * @return {string}
	 */
	concatenateStrings (...pStrings)
	{
		return this.joinStrings('', ...pStrings);
	}

	/**
	 * Concatenate a list of strings together. Non-strings are excluded.
	 *
	 * @param {...any} pParams - Any number of parameters
	 * @return {string}
	 */
	concatenateStringsInternal ()
	{
		const pParams = [ ...arguments ];
		const tmpFlattenedArrays = this.fable.Utility.flattenArrayOfSolverInputs(pParams);

		return this.concatenateStrings(...tmpFlattenedArrays);
	}

	/**
	 * Join a list of strings together. Non-strings are excluded.
	 *
	 * @param {string} pJoin - The string to join with
	 * @param {...string} pStrings - The strings to join
	 * @return {string}
	 */
	joinStrings (pJoin, ...pStrings)
	{
		return pStrings.filter((v) => typeof v === 'string' || typeof v === 'number').join(pJoin);
	}

	/**
	 * Joins a list of strings together. Non-strings are excluded.
	 *
	 * @param {string} pJoin - The string to join with
	 * @param {...any} pParams - Any number of parameters
	 * @return {string}
	 */
	joinStringsInternal()
	{
		const [ pJoinOn, ...pParams ] = arguments;
		const tmpFlattenedArrays = this.fable.Utility.flattenArrayOfSolverInputs(pParams);

		return this.joinStrings(pJoinOn, ...tmpFlattenedArrays);
	}


	/**
	 * Concatenate a list of values together into a string.
	 *
	 * @param {...any} pValues - The strings to concatenate
	 * @return {string}
	 */
	concatenateStringsRaw (...pValues)
	{
		return this.joinStringsRaw('', ...pValues);
	}

	/**
	 * Concatenate a list of values together into a string.
	 *
	 * @param {...any} pParams - Any number of parameters
	 * @return {string}
	 */
	concatenateStringsRawInternal (pValueObjectSetAddress)
	{
		const pParams = [ ...arguments ];
		const tmpFlattenedArrays = this.fable.Utility.flattenArrayOfSolverInputs(pParams);

		return this.concatenateStringsRaw(...tmpFlattenedArrays);
	}

	/**
	 * Join a list of values together into a string.
	 *
	 * @param {string} pJoin - The string to join with
	 * @param {...any} pValues - The strings to join
	 * @return {string}
	 */
	joinStringsRaw (pJoin, ...pValues)
	{
		return pValues.map(String).join(pJoin);
	}

	/**
	 * Joins a list of values together into a string.
	 *
	 * @param {string} pJoin - The string to join with
	 * @param {...any} pParams - Any number of parameters
	 * @return {string}
	 */
	joinStringsRawInternal ()
	{
		const [ pJoinOn, ...pParams ] = arguments;
		const tmpFlattenedArrays = this.fable.Utility.flattenArrayOfSolverInputs(pParams);

		return this.joinStringsRaw(pJoinOn, ...tmpFlattenedArrays);
	}

	/**
	 * Clean wrapping characters if they exist consistently around the string.  If they do not, the string is returned unchanged.
	 *
	 * @param {string} pWrapCharacter - The character expected as the wrapping character
	 * @param {string} pString - the string to clean
	 * @returns {string}
	 */
	cleanEnclosureWrapCharacters (pWrapCharacter, pString)
	{
		// # Use case from ManyFest DSL:
		//
		// When a boxed property is passed in, it should have quotes of some
		// kind around it.
		//
		// For instance:
		// 		MyValues['Name']
		// 		MyValues["Age"]
		// 		MyValues[`Cost`]
		//
		// This function is necessary to remove the wrapping quotes before object
		// resolution can occur.
		if (pString.startsWith(pWrapCharacter) && pString.endsWith(pWrapCharacter))
		{
			return pString.substring(1, pString.length - 1);
		}
		else
		{
			return pString;
		}
	}

	/**
	 * Clean a string of any non-alpha characters (including numbers)
	 *
	 * @param {*} pString
	 * @returns
	 */
	cleanNonAlphaCharacters (pString)
	{
		if ((typeof(pString) == 'string') && (pString != ''))
		{
			return pString.replace(this._Regex_formatterCleanNonAlphaChar, this._Value_Clean_formatterCleanNonAlpha);
		}

		return '';
	}

	/**
	 * Clean a string of any characters to create a consistent object key.
	 *
	 * @param {string} pString  The string to clean.
	 * @return {string} the cleaned string, or a placeholder if the input is invalid
	 */
	sanitizeObjectKey(pString)
	{
		if (typeof pString !== 'string' || pString.length < 1)
		{
			return this._SanitizeObjectKeyInvalid;
		}
		return pString.replace(this._SanitizeObjectKeyRegex, this._SanitizeObjectKeyReplacement);
	}


	/*************************************************************************
	 * Number Formatting Functions
	 *-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*/

	/**
	 * Insert commas every 3 characters from the right.  Used by formatterAddCommasToNumber().
	 *
	 * @param {*} pString
	 * @returns {*}
	 */
	formatterInsertCommas (pString)
	{
		// Reverse, because it's easier to do things from the left, given arbitrary digit counts
		let tmpReversed = this.stringReverse(pString);
		// Add commas every three characters
		let tmpReversedWithCommas = tmpReversed.match(this._Regex_formatterInsertCommas).join(',');
		// Reverse again (back to normal direction)
		return this.stringReverse(tmpReversedWithCommas);
	}

	processAddCommasToNumberRegex(pMatch, pSign, pZeros, pBefore, pDecimal, pAfter)
	{
		// If there was no decimal, the last capture grabs the final digit, so
		// we have to put it back together with the 'before' substring
		return pSign + (pDecimal ? this.formatterInsertCommas(pBefore) + pDecimal + pAfter : this.formatterInsertCommas(pBefore + pAfter));
	}

	/**
	 * Add Commas to a Number for readability.
	 *
	 * @param {*} pNumber
	 * @returns {string}
	 */
	formatterAddCommasToNumber (pNumber)
	{
		// If the regex doesn't match, `replace` returns the string unmodified
		return (pNumber.toString()).replace
		(
			this._Regex_formatterAddCommasToNumber,
			this.processAddCommasToNumberRegex.bind(this)
		);
	}

	/**
	 * This will take a number and format it as a dollar string.  It will also add commas to the number.  If the number is not a number, it will return '--'.
	 *
	 * @param {*} pValue
	 * @returns {string}
	 */
	formatterDollars (pValue, pPrecision, pRoundingMethod)
	{
		if (isNaN(pValue))
		{
			return this._Value_NaN_Currency;
		}

		if (pValue === null || pValue === undefined)
		{
			return this._Value_NaN_Currency;
		}

		let tmpDollarAmountArbitrary = this.fable.Math.parsePrecise(pValue);
		let tmpPrecision = (typeof(pPrecision) == 'undefined') ? 2 : pPrecision;
		let tmpDollarAmount = this.fable.Math.toFixedPrecise(tmpDollarAmountArbitrary, tmpPrecision, pRoundingMethod);

		// TODO: Get locale data and use that for this stuff.
		return `$${this.formatterAddCommasToNumber(tmpDollarAmount)}`;
	}

	/**
	 * Round a number to a certain number of digits.  If the number is not a number, it will return 0.  If no digits are specified, it will default to 2 significant digits.
	 *
	 * @param {*} pValue
	 * @param {number} pDigits
	 * @returns {string}
	 */
	formatterRoundNumber (pValue, pDigits)
	{
		let tmpDigits = (typeof(pDigits) == 'undefined') ? 2 : pDigits;

		if (isNaN(pValue))
		{
			let tmpZed = 0;
			return tmpZed.toFixed(tmpDigits);
		}

		if (pValue === null || pValue === undefined)
		{
			return '';
		}

		let tmpAmountArbitrary = this.fable.Utility.bigNumber(pValue);
		let tmpValue = tmpAmountArbitrary.toFixed(tmpDigits);

		if (isNaN(tmpValue))
		{
			let tmpZed = 0;
			return tmpZed.toFixed(tmpDigits);
		}
		else
		{
			return tmpValue;
		}
	}


	/**
	 * Generate a reapeating padding string to be appended before or after depending on
	 * which padding function it uses.
	 *
	 * @param {*} pString
	 * @param {number} pTargetLength
	 * @returns {string} pPadString
	 */
	stringGeneratePaddingString(pString, pTargetLength, pPadString)
	{
		let tmpTargetLength = pTargetLength >> 0;
		let tmpPadString = String((typeof pPadString !== 'undefined' ? pPadString : ' '));
		if (pString.length > pTargetLength)
		{
			// No padding string if the source string is already longer than the target length, return an empty string
			return '';
		}
		else
		{
			let tmpPadLength = pTargetLength - pString.length;
			if (tmpPadLength > tmpPadString.length)
			{
				tmpPadString += tmpPadString.repeat(tmpTargetLength / tmpPadString.length);
			}
			return tmpPadString.slice(0, tmpPadLength);
		}
	}

	/**
	 * Pad the start of a string.
	 *
	 * @param {*} pString
	 * @param {number} pTargetLength
	 * @returns {string} pPadString
	 */
	stringPadStart = function(pString, pTargetLength, pPadString)
	{
		let tmpString = pString.toString();
		return this.stringGeneratePaddingString(tmpString, pTargetLength, pPadString) + tmpString;
	}

	/**
	 * Pad the end of a string.
	 *
	 * @param {*} pString
	 * @param {number} pTargetLength
	 * @returns {string} pPadString
	 */
	stringPadEnd = function(pString, pTargetLength, pPadString)
	{
		let tmpString = pString.toString();
		return tmpString + this.stringGeneratePaddingString(tmpString, pTargetLength, pPadString);
	}

	/*************************************************************************
	 * Time Formatting Functions (milliseconds)
	 *-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*/

	/**
	 * Format a time length in milliseconds into a human readable string.
	 * @param {number} pTimeSpan
	 * @returns {string} - HH:MM:SS.mmm
	 */
	formatTimeSpan(pTimeSpan)
	{
		if (typeof(pTimeSpan) != 'number')
		{
			return '';
		}

		let tmpMs = parseInt(pTimeSpan%1000);
		let tmpSeconds = parseInt((pTimeSpan/1000)%60);
		let tmpMinutes = parseInt((pTimeSpan/(1000*60))%60);
		let tmpHours = parseInt(pTimeSpan/(1000*60*60));

		return `${this.stringPadStart(tmpHours,2,'0')}:${this.stringPadStart(tmpMinutes,2,'0')}:${this.stringPadStart(tmpSeconds,2,'0')}.${this.stringPadStart(tmpMs,3,'0')}`;
	}

	/**
	 * Format the time delta between two times in milliseconds into a human readable string.
	 *
	 * @param {number} pTimeStart
	 * @param {number} pTimeEnd
	 * @returns {string} - HH:MM:SS.mmm
	 */
	formatTimeDelta(pTimeStart, pTimeEnd)
	{
		if ((typeof(pTimeStart) != 'number') || (typeof(pTimeEnd) != 'number'))
		{
			return '';
		}

		return this.formatTimeSpan(pTimeEnd-pTimeStart);
	}

	// THE FOLLOWING TERRIBLE FUNCTIONS ARE FOR QT / WKHTMLTOPDF when luxon and moment don't work so well
	getMonthFromDate (pJavascriptDate)
	{
		var tmpMonths = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
		return tmpMonths[pJavascriptDate.getMonth()];
	}

	getMonthAbbreviatedFromDate (pJavascriptDate)
	{
		var tmpMonths = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
		return tmpMonths[pJavascriptDate.getMonth()];
	}

	formatMonthDayYearFromDate (pJavascriptDate, pStrict)
	{
		let tmpStrict = (typeof(pStrict) !== 'undefined') ? pStrict : false;

		let tmpMonth = pJavascriptDate.getMonth() + 1;
		let tmpDay = pJavascriptDate.getDate();
		let tmpYear = pJavascriptDate.getFullYear();

		if (tmpStrict)
		{
			tmpMonth = this.stringPadStart(tmpMonth, 2, '0');
			tmpDay = this.stringPadStart(tmpDay, 2, '0');
			tmpYear = this.stringPadStart(tmpYear, 4, '0');
		}

		return `${tmpMonth}/${tmpDay}/${tmpYear}`;
	}

	formatSortableStringFromDate (pDate)
	{
		return pDate.getFullYear()+this.stringPadStart(pDate.getMonth(),2,'0')+this.stringPadStart(pDate.getDate(),2,'0');
	}

	/*************************************************************************
	 * String Tokenization Functions
	 *-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*/

	/**
	 * Return the string before the matched substring.
	 *
	 * If the substring is not found, the entire string is returned.  This only deals with the *first* match.
	 *
	 * @param {string} pString
	 * @param {string} pMatch
	 * @returns {string}
	 */
	stringBeforeMatch (pString, pMatch)
	{
		return pString.split(pMatch)[0];
	}

	/**
	 * Return the string after the matched substring.
	 *
	 * If the substring is not found, an empty string is returned.  This only deals with the *first* match.
	 *
	 * @param {string} pString
	 * @param {string} pMatch
	 * @returns {string}
	 */
	stringAfterMatch (pString, pMatch)
	{
		let tmpStringSplitLocation = pString.indexOf(pMatch);

		if ((tmpStringSplitLocation < 0) || ((tmpStringSplitLocation + pMatch.length) >= pString.length))
		{
			return '';
		}

		return pString.substring(tmpStringSplitLocation + pMatch.length);
	}

	/**
	 * Count the number of segments in a string, respecting enclosures
	 *
	 * @param {string} pString
	 * @param {string} pSeparator
	 * @param {object} pEnclosureStartSymbolMap
	 * @param {object} pEnclosureEndSymbolMap
	 * @returns the count of segments in the string as a number
	 */
	stringCountSegments(pString, pSeparator, pEnclosureStartSymbolMap, pEnclosureEndSymbolMap)
	{
		let tmpString = (typeof(pString) == 'string') ? pString : '';

		let tmpSeparator = (typeof(pSeparator) == 'string') ? pSeparator : '.';

		let tmpEnclosureStartSymbolMap = (typeof(pEnclosureStartSymbolMap) == 'object') ? pEnclosureStart : { '{': 0, '[': 1, '(': 2 };
		let tmpEnclosureEndSymbolMap = (typeof(pEnclosureEndSymbolMap) == 'object') ? pEnclosureEnd : { '}': 0, ']': 1, ')': 2 };

		if (pString.length < 1)
		{
			return 0;
		}

		let tmpSegmentCount = 1;
		let tmpEnclosureStack = [];

		for (let i = 0; i < tmpString.length; i++)
		{
			// IF This is the start of a segment
			if ((tmpString[i] == tmpSeparator)
				// AND we are not in a nested portion of the string
				&& (tmpEnclosureStack.length == 0))
			{
				// Increment the segment count
				tmpSegmentCount++;
			}
			// IF This is the start of an enclosure
			else if (tmpString[i] in tmpEnclosureStartSymbolMap)
			{
				// Add it to the stack!
				tmpEnclosureStack.push(tmpEnclosureStartSymbolMap[tmpString[i]]);
			}
			// IF This is the end of an enclosure
			else if ((tmpString[i] in tmpEnclosureEndSymbolMap)
				// AND it matches the current nest level symbol
				&& tmpEnclosureEndSymbolMap[tmpString[i]] == tmpEnclosureStack[tmpEnclosureStack.length - 1])
			{
				// Pop it off the stack!
				tmpEnclosureStack.pop();
			}
		}

		return tmpSegmentCount;
	}

	/**
	 * Get all segments in a string, respecting enclosures
	 *
	 * @param {string} pString
	 * @param {string} pSeparator
	 * @param {object} pEnclosureStartSymbolMap
	 * @param {object} pEnclosureEndSymbolMap
	 * @returns the first segment in the string as a string
	 */
	stringGetSegments(pString, pSeparator, pEnclosureStartSymbolMap, pEnclosureEndSymbolMap)
	{
		let tmpString = (typeof(pString) == 'string') ? pString : '';

		let tmpSeparator = (typeof(pSeparator) == 'string') ? pSeparator : '.';

		let tmpEnclosureStartSymbolMap = (typeof(pEnclosureStartSymbolMap) == 'object') ? pEnclosureStart : { '{': 0, '[': 1, '(': 2, '"':3, "'":4 };
		let tmpEnclosureEndSymbolMap = (typeof(pEnclosureEndSymbolMap) == 'object') ? pEnclosureEnd : { '}': 0, ']': 1, ')': 2, '"':3, "'":4 };

		let tmpCurrentSegmentStart = 0;
		let tmpSegmentList = [];

		if (pString.length < 1)
		{
			return tmpSegmentList;
		}

		let tmpEnclosureStack = [];

		for (let i = 0; i < tmpString.length; i++)
		{
			// IF This is the start of a segment
			if ((tmpString[i] == tmpSeparator)
				// AND we are not in a nested portion of the string
				&& (tmpEnclosureStack.length == 0))
			{
				// Return the segment
				tmpSegmentList.push(tmpString.substring(tmpCurrentSegmentStart, i));
				tmpCurrentSegmentStart = i+1;
			}
			// IF This is the start of an enclosure
			else if (tmpString[i] in tmpEnclosureStartSymbolMap)
			{
				// Add it to the stack!
				tmpEnclosureStack.push(tmpEnclosureStartSymbolMap[tmpString[i]]);
			}
			// IF This is the end of an enclosure
			else if ((tmpString[i] in tmpEnclosureEndSymbolMap)
				// AND it matches the current nest level symbol
				&& tmpEnclosureEndSymbolMap[tmpString[i]] == tmpEnclosureStack[tmpEnclosureStack.length - 1])
			{
				// Pop it off the stack!
				tmpEnclosureStack.pop();
			}
		}

		if (tmpCurrentSegmentStart < tmpString.length)
		{
			tmpSegmentList.push(tmpString.substring(tmpCurrentSegmentStart));
		}

		return tmpSegmentList;
	}

	/**
	 * Get the first segment in a string, respecting enclosures
	 *
	 * @param {string} pString
	 * @param {string} pSeparator
	 * @param {object} pEnclosureStartSymbolMap
	 * @param {object} pEnclosureEndSymbolMap
	 * @returns the first segment in the string as a string
	 */
	stringGetFirstSegment(pString, pSeparator, pEnclosureStartSymbolMap, pEnclosureEndSymbolMap)
	{
		let tmpString = (typeof(pString) == 'string') ? pString : '';

		let tmpSeparator = (typeof(pSeparator) == 'string') ? pSeparator : '.';

		let tmpEnclosureStartSymbolMap = (typeof(pEnclosureStartSymbolMap) == 'object') ? pEnclosureStart : { '{': 0, '[': 1, '(': 2 };
		let tmpEnclosureEndSymbolMap = (typeof(pEnclosureEndSymbolMap) == 'object') ? pEnclosureEnd : { '}': 0, ']': 1, ')': 2 };

		if (pString.length < 1)
		{
			return 0;
		}

		let tmpEnclosureStack = [];

		for (let i = 0; i < tmpString.length; i++)
		{
			// IF This is the start of a segment
			if ((tmpString[i] == tmpSeparator)
				// AND we are not in a nested portion of the string
				&& (tmpEnclosureStack.length == 0))
			{
				// Return the segment
				return tmpString.substring(0, i);
			}
			// IF This is the start of an enclosure
			else if (tmpString[i] in tmpEnclosureStartSymbolMap)
			{
				// Add it to the stack!
				tmpEnclosureStack.push(tmpEnclosureStartSymbolMap[tmpString[i]]);
			}
			// IF This is the end of an enclosure
			else if ((tmpString[i] in tmpEnclosureEndSymbolMap)
				// AND it matches the current nest level symbol
				&& tmpEnclosureEndSymbolMap[tmpString[i]] == tmpEnclosureStack[tmpEnclosureStack.length - 1])
			{
				// Pop it off the stack!
				tmpEnclosureStack.pop();
			}
		}

		return tmpString;
	}

	/**
	 * Encodes a string using encodeURIComponent, returning the encoded string.
	 * If the input is not a string, returns the input unchanged.
	 *
	 * @param {string} pString - The string to encode.
	 * @returns {string|*} The encoded string, or the original input if it is not a string.
	 */
	stringEncodeURIComponent (pString)
	{
		if (typeof(pString) !== 'string')
		{
			return pString;
		}

		return encodeURIComponent(pString);
	}

	/**
	 * Safely decodes a URI component string using decodeURIComponent.
	 * If the input is not a string or decoding fails, returns the original input.
	 *
	 * @param {string} pString - The string to decode.
	 * @returns {string} The decoded string, or the original input if decoding fails.
	 */
	stringDecodeURIComponent (pString)
	{
		if (typeof(pString) !== 'string')
		{
			return pString;
		}

		try
		{
			return decodeURIComponent(pString);
		}
		catch (e)
		{
			this.fable.Log.error(`Failed to decode URI component: ${pString}`, e);
			return pString; // Return the original string if decoding fails
		}
	}

	/**
	 * Encodes a string so that it can be safely embedded in JavaScript code.
	 * Escapes special characters such as quotes, backslashes, and newlines.
	 *
	 * @param {string} pString - The input string to encode.
	 * @returns {string} The encoded string with special characters escaped.
	 */
	stringEncodeForJavascript (pString)
	{
		if (typeof(pString) !== 'string')
		{
			return pString;
		}

		//FIXME: missing regexp
		return pString.replace(this._Regex_matcherJavascriptEncode, (pMatch) =>
		{
			switch (pMatch)
			{
				case '"':
					return '\\"';
				case '\'':
					return '\\\'';
				case '\\':
					return '\\\\';
				case '\n':
					return '\\n';
				case '\r':
					return '\\r';
				default:
					return pMatch; // Return the original character if no encoding is needed
			}
		});
	}

	/**
	 * Decodes a JavaScript-escaped string by replacing common escape sequences
	 * (such as \" \\n \\r \\' and \\\\) with their actual character representations.
	 *
	 * @param {string} pString - The string to decode. If not a string, the input is returned as-is.
	 * @returns {string} The decoded string with escape sequences replaced, or the original input if not a string.
	 */
	stringDecodeForJavascript (pString)
	{
		if (typeof(pString) !== 'string')
		{
			return pString;
		}

		return pString.replace(this._Regex_matcherJavascriptDecode, (pMatch) =>
		{
			switch (pMatch)
			{
				case '\\"':
					return '"';
				case '\\\'':
					return '\'';
				case '\\\\':
					return '\\';
				case '\\n':
					return '\n';
				case '\\r':
					return '\r';
				default:
					return pMatch; // Return the original character if no decoding is needed
			}
		});
	}

	/**
	 * Count the number of enclosures in a string based on the start and end characters.
	 *
	 * If no start or end characters are specified, it will default to parentheses.  If the string is not a string, it will return 0.
	 *
	 * @param {string} pString
	 * @param {string} pEnclosureStart
	 * @param {string} pEnclosureEnd
	 * @returns the count of full in the string
	 */
	stringCountEnclosures (pString, pEnclosureStart, pEnclosureEnd)
	{
		let tmpString = (typeof(pString) == 'string') ? pString : '';
		let tmpEnclosureStart = (typeof(pEnclosureStart) == 'string') ? pEnclosureStart : '(';
		let tmpEnclosureEnd = (typeof(pEnclosureEnd) == 'string') ? pEnclosureEnd : ')';

		let tmpEnclosureCount = 0;
		let tmpEnclosureDepth = 0;
		for (let i = 0; i < tmpString.length; i++)
		{
			// This is the start of an enclosure
			if (tmpString[i] == tmpEnclosureStart)
			{
				if (tmpEnclosureDepth == 0)
				{
					tmpEnclosureCount++;
				}
				tmpEnclosureDepth++;
			}
			else if (tmpString[i] == tmpEnclosureEnd)
			{
				tmpEnclosureDepth--;
			}
		}

		return tmpEnclosureCount;
	}


	/**
	 * Get the value of the enclosure at the specified index.
	 *
	 * If the index is not a number, it will default to 0.  If the string is not a string, it will return an empty string.  If the enclosure is not found, it will return an empty string.  If the enclosure
	 *
	 * @param {string} pString
	 * @param {number} pEnclosureIndexToGet
	 * @param {string} pEnclosureStart
	 * @param {string}} pEnclosureEnd
	 * @returns {string}
	 */
	stringGetEnclosureValueByIndex (pString, pEnclosureIndexToGet, pEnclosureStart, pEnclosureEnd)
	{
		let tmpString = (typeof(pString) == 'string') ? pString : '';
		let tmpEnclosureIndexToGet = (typeof(pEnclosureIndexToGet) == 'number') ? pEnclosureIndexToGet : 0;
		let tmpEnclosureStart = (typeof(pEnclosureStart) == 'string') ? pEnclosureStart : '(';
		let tmpEnclosureEnd = (typeof(pEnclosureEnd) == 'string') ? pEnclosureEnd : ')';

		let tmpEnclosureCount = 0;
		let tmpEnclosureDepth = 0;

		let tmpMatchedEnclosureIndex = false;
		let tmpEnclosedValueStartIndex = 0;
		let tmpEnclosedValueEndIndex = 0;

		for (let i = 0; i < tmpString.length; i++)
		{
			// This is the start of an enclosure
			if (tmpString[i] == tmpEnclosureStart)
			{
				tmpEnclosureDepth++;

				// Only count enclosures at depth 1, but still this parses both pairs of all of them.
				if (tmpEnclosureDepth == 1)
				{
					tmpEnclosureCount++;
					if (tmpEnclosureIndexToGet == (tmpEnclosureCount - 1))
					{
						// This is the start of *the* enclosure
						tmpMatchedEnclosureIndex = true;
						tmpEnclosedValueStartIndex = i;
					}
				}
			}
			// This is the end of an enclosure
			else if (tmpString[i] == tmpEnclosureEnd)
			{
				tmpEnclosureDepth--;

				// Again, only count enclosures at depth 1, but still this parses both pairs of all of them.
				if ((tmpEnclosureDepth == 0) &&
					tmpMatchedEnclosureIndex &&
					(tmpEnclosedValueEndIndex <= tmpEnclosedValueStartIndex))
				{
					tmpEnclosedValueEndIndex = i;
					tmpMatchedEnclosureIndex = false;
				}
			}
		}

		if (tmpEnclosureCount <= tmpEnclosureIndexToGet)
		{
			// Return an empty string if the enclosure is not found
			return '';
		}

		if ((tmpEnclosedValueEndIndex > 0) && (tmpEnclosedValueEndIndex > tmpEnclosedValueStartIndex))
		{
			return tmpString.substring(tmpEnclosedValueStartIndex+1, tmpEnclosedValueEndIndex);
		}
		else
		{
			return tmpString.substring(tmpEnclosedValueStartIndex+1);
		}
	}


	/**
	 * Remove an enclosure from a string based on the index of the enclosure.
	 *
	 * @param {string} pString
	 * @param {number} pEnclosureIndexToRemove
	 * @param {number} pEnclosureStart
	 * @param {number} pEnclosureEnd
	 * @returns {string}
	 */
	stringRemoveEnclosureByIndex (pString, pEnclosureIndexToRemove, pEnclosureStart, pEnclosureEnd)
	{
		let tmpString = (typeof(pString) == 'string') ? pString : '';
		let tmpEnclosureIndexToRemove = (typeof(pEnclosureIndexToRemove) == 'number') ? pEnclosureIndexToRemove : 0;
		let tmpEnclosureStart = (typeof(pEnclosureStart) == 'string') ? pEnclosureStart : '(';
		let tmpEnclosureEnd = (typeof(pEnclosureEnd) == 'string') ? pEnclosureEnd : ')';

		let tmpEnclosureCount = 0;
		let tmpEnclosureDepth = 0;

		let tmpMatchedEnclosureIndex = false;
		let tmpEnclosureStartIndex = 0;
		let tmpEnclosureEndIndex = 0;

		for (let i = 0; i < tmpString.length; i++)
		{
			// This is the start of an enclosure
			if (tmpString[i] == tmpEnclosureStart)
			{
				tmpEnclosureDepth++;

				if (tmpEnclosureDepth == 1)
				{
					tmpEnclosureCount++;
					if (tmpEnclosureIndexToRemove == (tmpEnclosureCount - 1))
					{
						tmpMatchedEnclosureIndex = true;
						tmpEnclosureStartIndex = i;
					}
				}
			}
			else if (tmpString[i] == tmpEnclosureEnd)
			{
				tmpEnclosureDepth--;

				if ((tmpEnclosureDepth == 0) &&
					tmpMatchedEnclosureIndex &&
					(tmpEnclosureEndIndex <= tmpEnclosureStartIndex))
				{
					tmpEnclosureEndIndex = i;
					tmpMatchedEnclosureIndex = false;
				}
			}
		}

		if (tmpEnclosureCount <= tmpEnclosureIndexToRemove)
		{
			return tmpString;
		}

		let tmpReturnString = '';

		if (tmpEnclosureStartIndex > 1)
		{
			tmpReturnString = tmpString.substring(0, tmpEnclosureStartIndex);
		}

		if ((tmpString.length > (tmpEnclosureEndIndex + 1)) && (tmpEnclosureEndIndex > tmpEnclosureStartIndex))
		{
			tmpReturnString += tmpString.substring(tmpEnclosureEndIndex+1);
		}

		return tmpReturnString;
	}
}

module.exports = DataFormat;

},{"fable-serviceproviderbase":59}],72:[function(require,module,exports){
module.exports={
	"DefaultIntegerMinimum": 0,
	"DefaultIntegerMaximum": 9999999,

	"DefaultNumericStringLength": 10,

	"MonthSet": ["January","February","March","April","May","June","July","August","September","October","November","December"],

	"WeekDaySet":["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],

	"ColorSet": 
		[
			"Red", "Orange", "Yellow", "Green", "Blue", "Indigo", "Violet", "Pink", "Purple", "Turquoise", "Gold",
			"Lime", "Maroon", "Navy", "Coral", "Teal", "Brown", "White", "Black", "Sky", "Berry",
			"Grey", "Straw", "Silver", "Sapphire"
		],

	"SurNameSet":
		[
			"Smith", "Johnson", "Williams", "Brown", "Jones", "Miller", "Davis", "Garcia", "Rodriguez", "Wilson",
			"Martinez", "Anderson", "Taylor", "Thomas", "Hernandez", "Moore", "Martin", "Jackson", "Thompson", "White",
			"Lopez", "Lee", "Gonzalez", "Harris", "Clark", "Lewis", "Robinson", "Walker", "Perez", "Hall",
			"Young", "Allen", "Sanchez", "Wright", "King", "Scott", "Green", "Baker", "Adams", "Nelson",
			"Hill", "Ramirez", "Campbell", "Mitchell", "Roberts", "Carter", "Phillips", "Evans", "Turner", "Torres",
			"Parker", "Collins", "Edwards", "Stewart", "Flores", "Morris", "Nguyen", "Murphy", "Rivera", "Cook",
			"Rogers", "Morgan", "Peterson", "Cooper", "Reed", "Bailey", "Bell", "Gomez", "Kelly", "Howard",
			"Ward", "Cox", "Diaz", "Richardson", "Wood", "Watson", "Brooks", "Bennett", "Gray", "James",
			"Reyes", "Cruz", "Hughes", "Price", "Myers", "Long", "Foster", "Sanders", "Ross", "Morales",
			"Powell", "Sullivan", "Russell", "Ortiz", "Jenkins", "Gutierrez", "Perry", "Butler", "Barnes", "Fisher"
		],

	"NameSet":
		[
			"Mary", "Patricia", "Jennifer", "Linda", "Elizabeth", "Barbara", "Susan", "Jessica", "Sarah", "Karen",
			"Lisa", "Nancy", "Betty", "Sandra", "Margaret", "Ashley", "Kimberly", "Emily", "Donna", "Michelle",
			"Carol", "Amanda", "Melissa", "Deborah", "Stephanie", "Dorothy", "Rebecca", "Sharon", "Laura", "Cynthia",
			"Amy", "Kathleen", "Angela", "Shirley", "Brenda", "Emma", "Anna", "Pamela", "Nicole", "Samantha",
			"Katherine", "Christine", "Helen", "Debra", "Rachel", "Carolyn", "Janet", "Maria", "Catherine", "Heather",
			"Diane", "Olivia", "Julie", "Joyce", "Victoria", "Ruth", "Virginia", "Lauren", "Kelly", "Christina",
			"Joan", "Evelyn", "Judith", "Andrea", "Hannah", "Megan", "Cheryl", "Jacqueline", "Martha", "Madison",
			"Teresa", "Gloria", "Sara", "Janice", "Ann", "Kathryn", "Abigail", "Sophia", "Frances", "Jean",
			"Alice", "Judy", "Isabella", "Julia", "Grace", "Amber", "Denise", "Danielle", "Marilyn", "Beverly",
			"Charlotte", "Natalie", "Theresa", "Diana", "Brittany", "Doris", "Kayla", "Alexis", "Lori", "Marie",
			"James", "Robert", "John", "Michael", "David", "William", "Richard", "Joseph", "Thomas", "Christopher",
			"Charles", "Daniel", "Matthew", "Anthony", "Mark", "Donald", "Steven", "Andrew", "Paul", "Joshua",
			"Kenneth", "Kevin", "Brian", "George", "Timothy", "Ronald", "Jason", "Edward", "Jeffrey", "Ryan",
			"Jacob", "Gary", "Nicholas", "Eric", "Jonathan", "Stephen", "Larry", "Justin", "Scott", "Brandon",
			"Benjamin", "Samuel", "Gregory", "Alexander", "Patrick", "Frank", "Raymond", "Jack", "Dennis", "Jerry",
			"Tyler", "Aaron", "Jose", "Adam", "Nathan", "Henry", "Zachary", "Douglas", "Peter", "Kyle",
			"Noah", "Ethan", "Jeremy", "Walter", "Christian", "Keith", "Roger", "Terry", "Austin", "Sean",
			"Gerald", "Carl", "Harold", "Dylan", "Arthur", "Lawrence", "Jordan", "Jesse", "Bryan", "Billy",
			"Bruce", "Gabriel", "Joe", "Logan", "Alan", "Juan", "Albert", "Willie", "Elijah", "Wayne",
			"Randy", "Vincent", "Mason", "Roy", "Ralph", "Bobby", "Russell", "Bradley", "Philip", "Eugene"
		]
}
},{}],73:[function(require,module,exports){
const libFableServiceBase = require('fable-serviceproviderbase');

/**
 * FableServiceDataGeneration class provides various methods for generating random data.
 *
 * @extends libFableServiceBase
 */
class FableServiceDataGeneration extends libFableServiceBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.serviceType = 'DataGeneration';

		this.defaultData = require('./Fable-Service-DataGeneration-DefaultValues.json');
	}

	/**
	 * Generates a random integer between the specified minimum and maximum values.
	 *
	 * @param {number} pMinimum - The minimum value (inclusive).
	 * @param {number} pMaximum - The maximum value (exclusive).
	 * @returns {number} A random integer between pMinimum and pMaximum.
	 */
	randomIntegerBetween(pMinimum, pMaximum)
	{
		try
		{
			let tmpMinimum = parseInt(pMinimum, 10);
			let tmpMaximum = parseInt(pMaximum, 10);
			return Math.floor(Math.random() * (tmpMaximum - tmpMinimum)) + tmpMinimum;
		}
		catch (pError)
		{
			this.fable.log.error('Error in randomIntegerBetween', pError, { 'Minimum': pMinimum, 'Maximum': pMaximum });
			return NaN;
		}
	}

	/**
	 * Generates a random integer between 0 (inclusive) and the specified maximum value (exclusive).
	 *
	 * @param {number} pMaximum - The maximum value (exclusive).
	 * @returns {number} A random integer between 0 and pMaximum.
	 */
	randomIntegerUpTo(pMaximum)
	{
		return this.randomIntegerBetween(0, pMaximum);
	}

	/**
	 * Generates a random integer between 0 (inclusive) and the default maximum value.
	 *
	 * @returns {number} A random integer between 0 and the default maximum value.
	 */
	randomInteger()
	{
		return Math.floor(Math.random() * this.defaultData.DefaultIntegerMaximum);
	}

	/**
	 * Generates a random float between the specified minimum and maximum values.
	 *
	 * @param {number} pMinimum - The minimum value (inclusive).
	 * @param {number} pMaximum - The maximum value (exclusive).
	 * @returns {number} A random float between pMinimum and pMaximum.
	 */
	randomFloatBetween(pMinimum, pMaximum)
	{
		try
		{
			let tmpMinimum = parseFloat(pMinimum);
			let tmpMaximum = parseFloat(pMaximum);
			return this.fable.Math.addPrecise(this.fable.Math.multiplyPrecise(Math.random(), this.fable.Math.subtractPrecise(tmpMaximum, tmpMinimum)), tmpMinimum);
		}
		catch (pError)
		{
			this.fable.log.error('Error in randomFloatBetween', pError, { 'Minimum': pMinimum, 'Maximum': pMaximum });
			return NaN;
		}
	}

	/**
	 * Generates a random float between 0 (inclusive) and the specified maximum value (exclusive).
	 *
	 * @param {number} pMaximum - The maximum value (exclusive).
	 * @returns {number} A random float between 0 and pMaximum.
	 */
	randomFloatUpTo(pMaximum)
	{
		return this.randomFloatBetween(0, pMaximum);
	}

	/**
	 * Generates a random float between 0 (inclusive) and 1 (exclusive).
	 *
	 * @returns {number} A random float between 0 and 1.
	 */
	randomFloat()
	{
		return Math.random();
	}

	/**
	 * Generates a random numeric string of the specified length.
	 *
	 * @param {number} pLength - The length of the numeric string.
	 * @param {number} pMaxNumber - The maximum number to generate.
	 * @returns {string} A random numeric string of the specified length.
	 */
	randomNumericString(pLength, pMaxNumber)
	{
		let tmpLength = (typeof(pLength) === 'undefined') ? 10 : pLength;
		let tmpMaxNumber = (typeof(pMaxNumber) === 'undefined') ? 9999999999 : pMaxNumber;

		return this.services.DataFormat.stringPadStart(this.randomIntegerUpTo(tmpMaxNumber), pLength, '0');
	}

	/**
	 * Generates a random month from the default month set.
	 *
	 * @returns {string} A random month.
	 */
	randomMonth()
	{
		return this.defaultData.MonthSet[this.randomIntegerUpTo(this.defaultData.MonthSet.length - 1)];
	}

	/**
	 * Generates a random day of the week from the default week day set.
	 *
	 * @returns {string} A random day of the week.
	 */
	randomDayOfWeek()
	{
		return this.defaultData.WeekDaySet[this.randomIntegerUpTo(this.defaultData.WeekDaySet.length - 1)];
	}

	/**
	 * Generates a random color from the default color set.
	 *
	 * @returns {string} A random color.
	 */
	randomColor()
	{
		return this.defaultData.ColorSet[this.randomIntegerUpTo(this.defaultData.ColorSet.length - 1)];
	}

	/**
	 * Generates a random name from the default name set.
	 *
	 * @returns {string} A random name.
	 */
	randomName()
	{
		return this.defaultData.NameSet[this.randomIntegerUpTo(this.defaultData.NameSet.length - 1)];
	}

	/**
	 * Generates a random surname from the default surname set.
	 *
	 * @returns {string} A random surname.
	 */
	randomSurname()
	{
		return this.defaultData.SurNameSet[this.randomIntegerUpTo(this.defaultData.SurNameSet.length - 1)];
	}
}

module.exports = FableServiceDataGeneration;

},{"./Fable-Service-DataGeneration-DefaultValues.json":72,"fable-serviceproviderbase":59}],74:[function(require,module,exports){
const libFableServiceProviderBase = require('fable-serviceproviderbase');
/**
* Date management a la Moment using days.js
*
* @class DateManipulation
*/
class DateManipulation extends libFableServiceProviderBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash)

		this.serviceType = 'Dates';

		this.dayJS = require('dayjs');

		// Include the `weekOfYear` plugin
		this.plugin_weekOfYear = require('dayjs/plugin/weekOfYear');
		this.dayJS.extend(this.plugin_weekOfYear);
		// Include the `weekday` plugin
		this.plugin_weekday = require('dayjs/plugin/weekday');
		this.dayJS.extend(this.plugin_weekday);
		// Include the `isoWeek` plugin
		this.plugin_isoWeek = require('dayjs/plugin/isoWeek');
		this.dayJS.extend(this.plugin_isoWeek);
		// Include the `timezone` plugin
		this.plugin_timezone = require('dayjs/plugin/timezone');
		this.dayJS.extend(this.plugin_timezone);
		// Include the `relativetime` plugin
		this.plugin_relativetime = require('dayjs/plugin/relativeTime');
		this.dayJS.extend(this.plugin_relativetime);
		// Include the `utc` plugin
		this.plugin_utc = require('dayjs/plugin/utc');
		this.dayJS.extend(this.plugin_utc);
		// Include the `advancedFormat` plugin
		this.plugin_advancedFormat = require('dayjs/plugin/advancedFormat');
		this.dayJS.extend(this.plugin_advancedFormat);

		// A developer can include locales if they want
		// You would do the following:
		// const localeDE = require('dayjs/locale/de');
		// _Fable.Dates.dayJS.locale('de');
	}

	/**
	 * Calculates the difference in milliseconds between two dates.
	 *
	 * @param {string|Date|number} pDateStart - The start date. Can be a string, Date object, or timestamp.
	 * @param {string|Date|number} pDateEnd - The end date. Can be a string, Date object, or timestamp. Defaults to the current date if not provided.
	 * @param {boolean} pRequireEndDate - If true, the end date must be provided; otherwise, it defaults to the current date.
	 * @returns {number} The difference in milliseconds between the start and end dates. Returns NaN if the start date is invalid.
	 */
	dateMillisecondDifference(pDateStart, pDateEnd, pRequireEndDate = false)
	{
		if ((pDateStart === undefined) || (pDateStart === null) || (pDateStart === ''))
		{
			return NaN;
		}
		if ((pRequireEndDate || (pRequireEndDate == 1) || (pRequireEndDate == '1')) && ((pDateEnd === undefined) || (pDateEnd === null) || (pDateEnd === '')))
		{
			return NaN;
		}
		let tmpStartDate = this.dayJS(pDateStart);
		let tmpEndDate = this.dayJS(pDateEnd);
		return tmpEndDate.diff(tmpStartDate, 'millisecond');
	}

	/**
	 * Calculates the difference in seconds between two dates.
	 *
	 * @param {string|Date|number} pDateStart - The start date. Can be a string, Date object, or timestamp.
	 * @param {string|Date|number} pDateEnd - The end date. Can be a string, Date object, or timestamp. Defaults to the current date if not provided.
	 * @param {boolean} pRequireEndDate - If true, the end date must be provided; otherwise, it defaults to the current date.
	 * @returns {number} The difference in seconds between the start and end dates. Returns NaN if the start date is invalid.
	 */
	dateSecondDifference(pDateStart, pDateEnd, pRequireEndDate = false)
	{
		if ((pDateStart === undefined) || (pDateStart === null) || (pDateStart === ''))
		{
			return NaN;
		}
		if ((pRequireEndDate || (pRequireEndDate == 1) || (pRequireEndDate == '1')) && ((pDateEnd === undefined) || (pDateEnd === null) || (pDateEnd === '')))
		{
			return NaN;
		}
		let tmpStartDate = this.dayJS(pDateStart);
		let tmpEndDate = this.dayJS(pDateEnd);
		return tmpEndDate.diff(tmpStartDate, 'second');
	}

	/**
	 * Calculates the difference in minutes between two dates.
	 *
	 * @param {string|Date|number} pDateStart - The start date. Can be a string, Date object, or timestamp.
	 * @param {string|Date|number} pDateEnd - The end date. Can be a string, Date object, or timestamp. Defaults to the current date if not provided.
	 * @param {boolean} pRequireEndDate - If true, the end date must be provided; otherwise, it defaults to the current date.
	 * @returns {number} The difference in minutes between the start and end dates. Returns NaN if the start date is invalid.
	 */
	dateMinuteDifference(pDateStart, pDateEnd, pRequireEndDate = false)
	{
		if ((pDateStart === undefined) || (pDateStart === null) || (pDateStart === ''))
		{
			return NaN;
		}
		if ((pRequireEndDate || (pRequireEndDate == 1) || (pRequireEndDate == '1')) && ((pDateEnd === undefined) || (pDateEnd === null) || (pDateEnd === '')))
		{
			return NaN;
		}
		let tmpStartDate = this.dayJS(pDateStart);
		let tmpEndDate = this.dayJS(pDateEnd);
		return tmpEndDate.diff(tmpStartDate, 'minute');
	}

	/**
	 * Calculates the difference in hours between two dates.
	 *
	 * @param {string|Date|number} pDateStart - The start date. Can be a string, Date object, or timestamp.
	 * @param {string|Date|number} pDateEnd - The end date. Can be a string, Date object, or timestamp. Defaults to the current date if not provided.
	 * @param {boolean} pRequireEndDate - If true, the end date must be provided; otherwise, it defaults to the current date.
	 * @returns {number} The difference in hours between the start and end dates. Returns NaN if the start date is invalid.
	 */
	dateHourDifference(pDateStart, pDateEnd, pRequireEndDate = false)
	{
		if ((pDateStart === undefined) || (pDateStart === null) || (pDateStart === ''))
		{
			return NaN;
		}
		if ((pRequireEndDate || (pRequireEndDate == 1) || (pRequireEndDate == '1')) && ((pDateEnd === undefined) || (pDateEnd === null) || (pDateEnd === '')))
		{
			return NaN;
		}
		let tmpStartDate = this.dayJS(pDateStart);
		let tmpEndDate = this.dayJS(pDateEnd);
		return tmpEndDate.diff(tmpStartDate, 'hour');
	}

	/**
	 * Calculates the difference in days between two dates.
	 *
	 * @param {string|Date|number} pDateStart - The start date. Can be a string, Date object, or timestamp.
	 * @param {string|Date|number} pDateEnd - The end date. Can be a string, Date object, or timestamp. Defaults to the current date if not provided.
	 * @param {boolean} pRequireEndDate - If true, the end date must be provided; otherwise, it defaults to the current date.
	 * @returns {number} The difference in days between the start and end dates. Returns NaN if the start date is invalid.
	 */
	dateDayDifference(pDateStart, pDateEnd, pRequireEndDate = false)
	{
		if ((pDateStart === undefined) || (pDateStart === null) || (pDateStart === ''))
		{
			return NaN;
		}
		if ((pRequireEndDate || (pRequireEndDate == 1) || (pRequireEndDate == '1')) && ((pDateEnd === undefined) || (pDateEnd === null) || (pDateEnd === '')))
		{
			return NaN;
		}
		let tmpStartDate = this.dayJS(pDateStart);
		let tmpEndDate = this.dayJS(pDateEnd);
		return tmpEndDate.diff(tmpStartDate, 'day');
	}

	/**
	 * Calculates the difference in weeks between two dates.
	 *
	 * @param {string|Date|number} pDateStart - The start date. Can be a string, Date object, or timestamp.
	 * @param {string|Date|number} pDateEnd - The end date. Can be a string, Date object, or timestamp. Defaults to the current date if not provided.
	 * @param {boolean} pRequireEndDate - If true, the end date must be provided; otherwise, it defaults to the current date.
	 * @returns {number} The difference in weeks between the two dates. Returns NaN if the start date is invalid.
	 */
	dateWeekDifference(pDateStart, pDateEnd, pRequireEndDate = false)
	{
		if ((pDateStart === undefined) || (pDateStart === null) || (pDateStart === ''))
		{
			return NaN;
		}
		if ((pRequireEndDate || (pRequireEndDate == 1) || (pRequireEndDate == '1')) && ((pDateEnd === undefined) || (pDateEnd === null) || (pDateEnd === '')))
		{
			return NaN;
		}
		let tmpStartDate = this.dayJS(pDateStart);
		let tmpEndDate = this.dayJS(pDateEnd);
		return tmpEndDate.diff(tmpStartDate, 'week');
	}

	/**
	 * Calculates the difference in months between two dates.
	 *
	 * @param {string|Date|number} pDateStart - The start date. Can be a string, Date object, or timestamp.
	 * @param {string|Date|number} pDateEnd - The end date. Can be a string, Date object, or timestamp. Defaults to the current date if not provided.
	 * @param {boolean} pRequireEndDate - If true, the end date must be provided; otherwise, it defaults to the current date.
	 * @returns {number} The difference in months between the two dates. Returns NaN if the start date is invalid.
	 */
	dateMonthDifference(pDateStart, pDateEnd, pRequireEndDate = false)
	{
		if ((pDateStart === undefined) || (pDateStart === null) || (pDateStart === ''))
		{
			return NaN;
		}
		if ((pRequireEndDate || (pRequireEndDate == 1) || (pRequireEndDate == '1')) && ((pDateEnd === undefined) || (pDateEnd === null) || (pDateEnd === '')))
		{
			return NaN;
		}
		let tmpStartDate = this.dayJS(pDateStart);
		let tmpEndDate = this.dayJS(pDateEnd);
		return tmpEndDate.diff(tmpStartDate, 'month');
	}

	/**
	 * Calculates the difference in years between two dates.
	 *
	 * @param {string|Date|number} pDateStart - The start date. Can be a string, Date object, or timestamp.
	 * @param {string|Date|number} pDateEnd - The end date. Can be a string, Date object, or timestamp. Defaults to the current date if not provided.
	 * @param {boolean} pRequireEndDate - If true, the end date must be provided; otherwise, it defaults to the current date.
	 * @returns {number} The difference in years between the two dates. Returns NaN if the start date is invalid.
	 */
	dateYearDifference(pDateStart, pDateEnd, pRequireEndDate = false)
	{
		if ((pDateStart === undefined) || (pDateStart === null) || (pDateStart === ''))
		{
			return NaN;
		}
		if ((pRequireEndDate || (pRequireEndDate == 1) || (pRequireEndDate == '1')) && ((pDateEnd === undefined) || (pDateEnd === null) || (pDateEnd === '')))
		{
			return NaN;
		}
		let tmpStartDate = this.dayJS(pDateStart);
		let tmpEndDate = this.dayJS(pDateEnd);
		return tmpEndDate.diff(tmpStartDate, 'year');
	}

	dateAddMilliseconds(pDate, pAmount)
	{
		return this.dateMath(pDate, pAmount, 'millisecond', 'add');
	}

	dateAddSeconds(pDate, pAmount)
	{
		return this.dateMath(pDate, pAmount, 'second', 'add');
	}

	dateAddMinutes(pDate, pAmount)
	{
		return this.dateMath(pDate, pAmount, 'minute', 'add');
	}

	dateAddHours(pDate, pAmount)
	{
		return this.dateMath(pDate, pAmount, 'hour', 'add');
	}

	dateAddDays(pDate, pAmount)
	{
		return this.dateMath(pDate, pAmount, 'day', 'add');
	}

	dateAddWeeks(pDate, pAmount)
	{
		return this.dateMath(pDate, pAmount, 'week', 'add');
	}

	dateAddMonths(pDate, pAmount)
	{
		return this.dateMath(pDate, pAmount, 'month', 'add');
	}

	dateAddYears(pDate, pAmount)
	{
		return this.dateMath(pDate, pAmount, 'year', 'add');
	}

	dateMath(pDate, pAmount, pUnit, pOperation)
	{
		try
		{
			let tmpDate = this.dayJS.utc(pDate);

			if (pOperation === 'add')
			{
				tmpDate = tmpDate.add(pAmount, pUnit);
			}
			else if (pOperation === 'subtract')
			{
				tmpDate = tmpDate.subtract(pAmount, pUnit);
			}
			return this.dayJS.utc(tmpDate).toISOString();
		}
		catch (pError)
		{
			return undefined;
		}
	}

	dateFromParts(pYear, pMonth, pDay, pHour = 0, pMinute = 0, pSecond = 0, pMillisecond = 0)
	{
		try
		{
			let tmpDate = this.dayJS.utc().year(pYear).month(pMonth - 1).date(pDay).hour(pHour).minute(pMinute).second(pSecond).millisecond(pMillisecond);
			return tmpDate.toISOString();
		}
		catch (pError)
		{
			return undefined;
		}
	}
}

module.exports = DateManipulation;

},{"dayjs":32,"dayjs/plugin/advancedFormat":33,"dayjs/plugin/isoWeek":34,"dayjs/plugin/relativeTime":35,"dayjs/plugin/timezone":36,"dayjs/plugin/utc":37,"dayjs/plugin/weekOfYear":38,"dayjs/plugin/weekday":39,"fable-serviceproviderbase":59}],75:[function(require,module,exports){
const libFableServiceBase = require('fable-serviceproviderbase');

class FableServiceEnvironmentData extends libFableServiceBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.serviceType = 'EnvironmentData';

		this.Environment = `node.js`;
	}
}

module.exports = FableServiceEnvironmentData;

},{"fable-serviceproviderbase":59}],76:[function(require,module,exports){
const libFableServiceBase = require('fable-serviceproviderbase');

/* Trying a different pattern for this service ...
 *
 * This service is a simple expression parser that can handle math expressions, with magic(tm) lookup of addresses with a manifest.
 *
 * Each method works multiple ways.
 *
 * 1. You can pass in a results object, and, it will put the state for that step outcome into the results object.
 * 2. It always returns the state, and works without the results object.
 *
 *
 * Learned a lot from this npm package: https://www.npmjs.com/package/math-expression-evaluator
 * And its related code at github: https://github.com/bugwheels94/math-expression-evaluator
 *
 * There were two problems with the codebase above...
 *
 * First, the code was very unreadable and determining it was correct or extending it
 * was out of the question.
 *
 * Second, and this is a larger issue, is that we need the expressions to be parsed as
 * arbitrary precision.  When I determined that extending the library to use string-based
 * numbers and an arbitrary precision library as the back-end would have taken a significantly
 * longer amount of time than just writing the parser from scratch... et voila.
 */

class FableServiceExpressionParser extends libFableServiceBase
{
	/**
	 * Constructs a new instance of the ExpressionParser service.
	 * @param {Object} pFable - The Fable object.
	 * @param {Object} pOptions - The options for the service.
	 * @param {string} pServiceHash - The hash of the service.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('../Fable.js') & { Math: import('./Fable-Service-Math.js') }} */
		this.fable;
		/** @type {any} */
		this.log;

		// The configuration for tokens that the solver recognizes, with precedence and friendly names.
		// Clone the JSON so each instance gets its own tokenMap (require() caches and returns the same object reference).
		this.tokenMap = JSON.parse(JSON.stringify(require('./Fable-Service-ExpressionParser/Fable-Service-ExpressionParser-TokenMap.json')));

		// Keep track of maximum token precedence
		this.tokenMaxPrecedence = 4;
		// This isn't exactly a radix tree but close enough.  It's a map of the first character of the token to the token.
		this.tokenRadix = {};
		let tmpTokenKeys = Object.keys(this.tokenMap);
		for (let i = 0; i < tmpTokenKeys.length; i++)
		{
			let tmpTokenKey = tmpTokenKeys[i];
			let tmpToken = this.tokenMap[tmpTokenKey];

			tmpToken.Token = tmpTokenKey;
			tmpToken.Length = tmpTokenKey.length;

			let tmpTokenStartCharacter = tmpToken.Token[0];
			if (!(tmpTokenStartCharacter in this.tokenRadix))
			{
				// With a token count of 1 and a literal of true, we can assume it being in the radix is the token.
				this.tokenRadix[tmpTokenStartCharacter] = (
					{
						TokenCount: 0,
						Literal: false,
						TokenKeys: [],
						TokenMap: {}
					});
			}

			this.tokenRadix[tmpTokenStartCharacter].TokenCount++;
			if (tmpTokenKey == tmpTokenStartCharacter)
			{
				this.tokenRadix[tmpTokenStartCharacter].Literal = true;
			}
			this.tokenRadix[tmpTokenStartCharacter].TokenMap[tmpToken.Token] = tmpToken;
			this.tokenRadix[tmpTokenStartCharacter].TokenKeys.push(tmpTokenKey);
			this.tokenRadix[tmpTokenStartCharacter].TokenKeys.sort((pLeft, pRight) => pRight.length - pLeft.length);

			if (this.tokenMaxPrecedence < tmpToken.Precedence)
			{
				this.tokenMaxPrecedence = tmpToken.Precedence;
			}
		}

		// The configuration for which functions are available to the solver.
		// Clone the JSON so each instance gets its own functionMap (require() caches and returns the same object reference).
		this.functionMap = JSON.parse(JSON.stringify(require('./Fable-Service-ExpressionParser/Fable-Service-ExpressionParser-FunctionMap.json')));

		this.serviceType = 'ExpressionParser';

		// These are sub-services for the tokenizer, linter, compiler, marshaler and solver.
		this.fable.addServiceTypeIfNotExists('ExpressionParser-Tokenizer', require('./Fable-Service-ExpressionParser/Fable-Service-ExpressionParser-ExpressionTokenizer.js'));
		this.fable.addServiceTypeIfNotExists('ExpressionParser-TokenizerDirectiveMutation', require('./Fable-Service-ExpressionParser/Fable-Service-ExpressionParser-ExpressionTokenizer-DirectiveMutation.js'));
		this.fable.addServiceTypeIfNotExists('ExpressionParser-Linter', require('./Fable-Service-ExpressionParser/Fable-Service-ExpressionParser-Linter.js'));
		this.fable.addServiceTypeIfNotExists('ExpressionParser-Postfix', require('./Fable-Service-ExpressionParser/Fable-Service-ExpressionParser-Postfix.js'));
		this.fable.addServiceTypeIfNotExists('ExpressionParser-ValueMarshal', require('./Fable-Service-ExpressionParser/Fable-Service-ExpressionParser-ValueMarshal.js'));
		this.fable.addServiceTypeIfNotExists('ExpressionParser-Solver', require('./Fable-Service-ExpressionParser/Fable-Service-ExpressionParser-SolvePostfixedExpression.js'));
		// And the sub-service for the friendly user messaging
		this.fable.addServiceTypeIfNotExists('ExpressionParser-Messaging', require('./Fable-Service-ExpressionParser/Fable-Service-ExpressionParser-Messaging.js'));


		// This code instantitates these fable services to child objects of this service, but does not pollute the main fable with them.
		this.Tokenizer = this.fable.instantiateServiceProviderWithoutRegistration('ExpressionParser-Tokenizer');
		this.Tokenizer.TokenizerDirectiveMutation = this.fable.instantiateServiceProviderWithoutRegistration('ExpressionParser-TokenizerDirectiveMutation');
		this.Linter = this.fable.instantiateServiceProviderWithoutRegistration('ExpressionParser-Linter');
		this.Postfix = this.fable.instantiateServiceProviderWithoutRegistration('ExpressionParser-Postfix');
		this.ValueMarshal = this.fable.instantiateServiceProviderWithoutRegistration('ExpressionParser-ValueMarshal');
		this.Solver = this.fable.instantiateServiceProviderWithoutRegistration('ExpressionParser-Solver');
		this.Messaging = this.fable.instantiateServiceProviderWithoutRegistration('ExpressionParser-Messaging');

		// Wire each sub service into this instance of the solver.
		this.Tokenizer.connectExpressionParser(this);
		this.Tokenizer.TokenizerDirectiveMutation.connectExpressionParser(this);
		this.Linter.connectExpressionParser(this);
		this.Postfix.connectExpressionParser(this);
		this.ValueMarshal.connectExpressionParser(this);
		this.Solver.connectExpressionParser(this);
		this.Messaging.connectExpressionParser(this);

		this.GenericManifest = this.fable.newManyfest();

		// This will look for a LogNoisiness on fable (or one that falls in from pict) and if it doesn't exist, set one for this service.
		this.LogNoisiness = ('LogNoisiness' in this.fable) ? this.fable.LogNoisiness : 0;
	}

	/**
	 * Tokenizes the given mathematical expression string.
	 *
	 * @param {string} pExpression - The expression to tokenize.
	 * @param {object} pResultObject - The result object to store the tokenized expression.
	 * @returns {object} - The tokenized expression.
	 */
	tokenize(pExpression, pResultObject)
	{
		return this.Tokenizer.tokenize(pExpression, pResultObject);
	}

	/**
	 * Recompose an expression string from an array of token strings.
	 *
	 * @param {Array<string>} pTokens - The array of token strings to recompose.
	 * @returns {string} - The recomposed expression string.
	 */
	recompose(pTokens)
	{
		return this.Tokenizer.recompose(pTokens);
	}

	/**
	 * Lints a tokenized expression.
	 *
	 * @param {Array} pTokenizedExpression - The tokenized expression to lint.
	 * @param {Object} pResultObject - The result object where we store the linting result.
	 * @returns {Object} - The linting result object.
	 */
	lintTokenizedExpression(pTokenizedExpression, pResultObject)
	{
		return this.Linter.lintTokenizedExpression(pTokenizedExpression, pResultObject);
	}

	/**
	 * Builds a postfix solve list for the given tokenized expression and result object.
	 *
	 * @param {Array} pTokenizedExpression - The tokenized expression.
	 * @param {Object} pResultObject - The result object where the algorithm "shows its work".
	 * @returns {Array} The postfix solve list.
	 */
	buildPostfixedSolveList(pTokenizedExpression, pResultObject)
	{
		return this.Postfix.buildPostfixedSolveList(pTokenizedExpression, pResultObject);
	}

	/**
	 * Substitutes values in tokenized objects.
	 *
	 * This means marshaling data from pDataSource into the array of objects with the passed in Manifest (or a generic manifest) to prepare for solving.
	 *
	 * @param {Array} pTokenizedObjects - The array of tokenized objects.
	 * @param {Object} pDataSource - The data source object.
	 * @param {Object} pResultObject - The result object.
	 * @param {Object} pManifest - The manifest object.
	 * @returns {Object} - The updated result object.
	 */
	substituteValuesInTokenizedObjects(pTokenizedObjects, pDataSource, pResultObject, pManifest)
	{
		return this.ValueMarshal.substituteValuesInTokenizedObjects(pTokenizedObjects, pDataSource, pResultObject, pManifest);
	}

	/**
	 * Solves a postfixed expression Array.
	 *
	 * @param {Array} pPostfixedExpression - The postfixed expression to solve.
	 * @param {object} pDataDestinationObject - The data destination object where data gets marshaled to after solving.
	 * @param {object} pResultObject - The result object where the algorithm "shows its work".
	 * @param {object} pManifest - The manifest object.
	 * @returns {any} The result of the solved expression.
	 */
	solvePostfixedExpression(pPostfixedExpression, pDataDestinationObject, pResultObject, pManifest)
	{
		return this.Solver.solvePostfixedExpression(pPostfixedExpression, pDataDestinationObject, pResultObject, pManifest);
	}

	/**
	 * Add a function to the solver.
	 *
	 * @param {string} pFunctionName
	 * @param {string} pFunctionAddress
	 * @param {string} pFunctionComment
	 * @param {Array<number>} [pAddressParameterIndices] - Optional array of parameter indices that contain addresses/hashes.
	 */
	addSolverFunction(pFunctionName, pFunctionAddress, pFunctionComment, pAddressParameterIndices)
	{
		let tmpFunctionName = (pFunctionName || '').trim().toLowerCase();
		if (this.functionMap.hasOwnProperty(tmpFunctionName))
		{
			this.log.warn(`PictDynamicFormsInformary: Function ${tmpFunctionName} already exists in the solver, overwriting with address [${pFunctionAddress}].`);
			//return false;
		}
		let tmpFunctionEntry = (
		{
			Name: pFunctionComment || `Autogenerated function ${tmpFunctionName}`,
			Address: pFunctionAddress,
		});
		if (Array.isArray(pAddressParameterIndices) && pAddressParameterIndices.length > 0)
		{
			tmpFunctionEntry.AddressParameterIndices = pAddressParameterIndices;
		}
		this.functionMap[tmpFunctionName] = tmpFunctionEntry;
	}

	/**
	 * Prepares the parameters for a SERIES directive by substituting values and applying defaults.
	 *
	 * @param {Array} pParameters
	 * @param {Array} pDefaults
	 * @param {Object} pResultObject
	 * @param {Object} pDataSourceObject
	 * @param {import('manyfest')} [pManifest]
	 */
	_prepareDirectiveParameters(pParameters, pDefaults, pResultObject, pDataSourceObject, pManifest)
	{
		const tmpResults = [];
		for (let i = 0; i < pParameters.length; i++)
		{
			const tmpParameter = pParameters[i];
			let tmpValue = this.fable.Math.parsePrecise(tmpParameter, NaN);
			if (isNaN(tmpValue) && typeof tmpParameter === 'string' && tmpParameter.length > 0)
			{
				const tmpToken = this.fable.ExpressionParser.Postfix.getTokenContainerObject(tmpParameter, 'Token.Symbol');
				this.substituteValuesInTokenizedObjects([tmpToken], pDataSourceObject, pResultObject, pManifest);
				if (tmpToken.Resolved)
				{
					tmpValue = tmpToken.Value;
				}
			}
			if (isNaN(tmpValue) && pDefaults.length > i)
			{
				tmpValue = pDefaults[i];
			}
			tmpResults.push(tmpValue);
		}
		return tmpResults;
	}

	/**
	 * Solves the given expression using the provided data and manifest.
	 *
	 * @param {string} pExpression - The expression to solve.
	 * @param {Record<string, any>} [pDataSourceObject] - (optional) The data source object (e.g. AppData).
	 * @param {Record<string, any>} [pResultObject] - (optional) The result object containing the full postfix expression list, internal variables and solver history.
	 * @param {import('manyfest')} [pManifest] - (optional) The manifest object for dereferencing variables.
	 * @param {Record<string, any>} [pDataDestinationObject] - (optional) The data destination object for where to marshal the result into.
	 * @returns {any} - The result of solving the expression.
	 */
	solve(pExpression, pDataSourceObject, pResultObject, pManifest, pDataDestinationObject)
	{
		let tmpResultsObject = (typeof(pResultObject) === 'object') ? pResultObject : {};
		let tmpDataSourceObject = (typeof(pDataSourceObject) === 'object') ? pDataSourceObject : {};
		let tmpDataDestinationObject = (typeof(pDataDestinationObject) === 'object') ? pDataDestinationObject : {};

		// This is technically a "pre-compile" and we can keep this Results Object around to reuse for better performance.  Not required.
		this.tokenize(pExpression, tmpResultsObject);

		// Lint the tokenized expression to make sure it's valid
		this.lintTokenizedExpression(tmpResultsObject.RawTokens, tmpResultsObject);
		this.buildPostfixedSolveList(tmpResultsObject.RawTokens, tmpResultsObject);

		const tmpManifest = (typeof(pManifest) === 'object') ? pManifest : this.fable.newManyfest();
		if (tmpResultsObject.SolverDirectives.Code == 'SERIES')
		{
			const [ tmpStep , tmpFrom, tmpTo] = this._prepareDirectiveParameters([
				tmpResultsObject.SolverDirectives.Step,
				tmpResultsObject.SolverDirectives.From,
				tmpResultsObject.SolverDirectives.To,
			], [ '1' ], tmpResultsObject, tmpDataSourceObject, tmpManifest);

			if (isNaN(tmpFrom) || isNaN(tmpTo))
			{
				tmpResultsObject.ExpressionParserLog.push(`ExpressionParser.solve detected invalid SERIES directive parameters.  FROM, TO must be numeric.`);
				this.log.warn(tmpResultsObject.ExpressionParserLog[tmpResultsObject.ExpressionParserLog.length-1]);
				return null;
			}

			// Make sure from/to are not equal
			if (this.fable.Math.comparePrecise(tmpFrom, tmpTo) == 0)
			{
				tmpResultsObject.ExpressionParserLog.push(`ExpressionParser.solve detected invalid SERIES directive parameters.  FROM and TO cannot be equal.`);
				this.log.warn(tmpResultsObject.ExpressionParserLog[tmpResultsObject.ExpressionParserLog.length-1]);
				return null;
			}

			// Make sure that Step is the correct positive/negative based on From and To
			if (this.fable.Math.comparePrecise(tmpStep, '0') == 0)
			{
				tmpResultsObject.ExpressionParserLog.push(`ExpressionParser.solve detected invalid SERIES directive parameters.  STEP cannot be zero.`);
				this.log.warn(tmpResultsObject.ExpressionParserLog[tmpResultsObject.ExpressionParserLog.length-1]);
				return null;
			}
			if (this.fable.Math.comparePrecise(tmpFrom, tmpTo) < 0)
			{
				// From < To so Step must be positive
				if (this.fable.Math.comparePrecise(tmpStep, '0') < 0)
				{
					tmpResultsObject.ExpressionParserLog.push(`ExpressionParser.solve detected invalid SERIES directive parameters.  STEP must be positive when FROM < TO.`);
					this.log.warn(tmpResultsObject.ExpressionParserLog[tmpResultsObject.ExpressionParserLog.length-1]);
					return null;
				}
			}
			else
			{
				// From >= To so Step must be negative
				if (this.fable.Math.comparePrecise(tmpStep, '0') > 0)
				{
					tmpResultsObject.ExpressionParserLog.push(`ExpressionParser.solve detected invalid SERIES directive parameters.  STEP must be negative when FROM >= TO.`);
					this.log.warn(tmpResultsObject.ExpressionParserLog[tmpResultsObject.ExpressionParserLog.length-1]);
					return null;
				}
			}

			// Get the number of iterations we need to perform
			let tmpIterations = parseInt(this.fable.Math.floorPrecise(this.fable.Math.dividePrecise(this.fable.Math.subtractPrecise(tmpTo, tmpFrom), tmpStep)));

			let tmpValueArray = [];

			for (let i = 0; i <= tmpIterations; i++)
			{
				const tmpCurrentValueOfN = this.fable.Math.addPrecise(tmpFrom, this.fable.Math.multiplyPrecise(tmpStep, i.toString()));
				const tmpPreviousValueOfN = (i == 0) ? 'false' : this.fable.Math.addPrecise(tmpFrom, this.fable.Math.multiplyPrecise(tmpStep, (i - 1).toString()));

				// Jimmy up the data source with the current N value, stepIndex and all the other data from the source object
				// This generates a data source object every time on purpose so we can remarshal in values that changed in the destination
				let tmpSeriesStepDataSourceObject = Object.assign({}, tmpDataSourceObject);
				tmpSeriesStepDataSourceObject.n = tmpCurrentValueOfN;
				tmpSeriesStepDataSourceObject.prev_n = tmpPreviousValueOfN;
				tmpSeriesStepDataSourceObject.stepIndex = i;

				let tmpMutatedValues = this.substituteValuesInTokenizedObjects(tmpResultsObject.PostfixTokenObjects, tmpSeriesStepDataSourceObject, tmpResultsObject, tmpManifest);

				tmpValueArray.push( this.solvePostfixedExpression( tmpResultsObject.PostfixSolveList, tmpDataDestinationObject, tmpResultsObject, tmpManifest) );

				for (let j = 0; j < tmpMutatedValues.length; j++)
				{
					tmpMutatedValues[j].Resolved = false;
				}
			}

			// Do the assignment
			let tmpAssignmentManifestHash = tmpResultsObject.PostfixedAssignmentAddress;
			if ((tmpResultsObject.OriginalRawTokens[1] === '=') && (typeof(tmpResultsObject.OriginalRawTokens[0]) === 'string') && (tmpResultsObject.OriginalRawTokens[0].length > 0))
			{
				tmpAssignmentManifestHash = tmpResultsObject.OriginalRawTokens[0];
			}

			tmpManifest.setValueByHash(tmpDataDestinationObject, tmpAssignmentManifestHash, tmpValueArray);

			return tmpValueArray;
		}
		else if (tmpResultsObject.SolverDirectives.Code == 'MAP')
		{
			// The values to pull in -- this could be a map but affords better flexibility broken out like this.
			const tmpDirectiveValues = tmpResultsObject.SolverDirectives.Values;
			const tmpDirectiveValueKeys = tmpResultsObject.SolverDirectives.ValueKeys;
			let tmpValueArray = [];

			for (let i = 0; i < tmpDirectiveValueKeys.length; i++)
			{
				const tmpVariableKey = tmpDirectiveValueKeys[i];
				const tmpVariableDescription = tmpDirectiveValues[tmpVariableKey];

				// Get the actual value for this variable's address
				tmpVariableDescription.Value = tmpManifest.getValueByHash(tmpDataSourceObject, tmpVariableDescription.Address);
			}

			// If the first value doesn't have keys, don't do the map.
			if ((tmpDirectiveValueKeys.length < 1) || (tmpDirectiveValues[tmpDirectiveValueKeys[0]].Value == null) || (!Array.isArray(tmpDirectiveValues[tmpDirectiveValueKeys[0]].Value)))
			{
				tmpResultsObject.ExpressionParserLog.push(`ExpressionParser.solve detected invalid MAP directive parameters.  The first variable's address must resolve to an array.`);
				this.log.warn(tmpResultsObject.ExpressionParserLog[tmpResultsObject.ExpressionParserLog.length-1]);
				return undefined;
			}

			let tmpControllingSet = tmpDirectiveValues[tmpDirectiveValueKeys[0]].Value;

			for (let i = 0; i < tmpControllingSet.length; i++)
			{
				// Jimmy up the data source with the current N value, stepIndex and all the other data from the source object
				// This generates a data source object every time on purpose so we can remarshal in values that changed in the destination
				let tmpSeriesStepDataSourceObject = Object.assign({}, tmpDataSourceObject);
				tmpSeriesStepDataSourceObject.stepIndex = i;

				for (let j = 0; j < tmpDirectiveValueKeys.length; j++)
				{
					const tmpVariableKey = tmpDirectiveValueKeys[j];
					if (!Array.isArray(tmpDirectiveValues[tmpVariableKey].Value) || (tmpDirectiveValues[tmpVariableKey].Value.length <= i))
					{
						tmpSeriesStepDataSourceObject[tmpVariableKey] = 0;
					}
					else
					{
						tmpSeriesStepDataSourceObject[tmpVariableKey] = tmpDirectiveValues[tmpVariableKey].Value[i];
					}
					const tmpPreviousValueKey = `prev_${tmpVariableKey}`;
					if (!Array.isArray(tmpDirectiveValues[tmpVariableKey].Value) || (tmpDirectiveValues[tmpVariableKey].Value.length <= i))
					{
						tmpSeriesStepDataSourceObject[tmpPreviousValueKey] = 0;
					}
					else if (i == 0)
					{
						tmpSeriesStepDataSourceObject[tmpPreviousValueKey] = 'false';
					}
					else
					{
						tmpSeriesStepDataSourceObject[tmpPreviousValueKey] = tmpDirectiveValues[tmpVariableKey].Value[i - 1];
					}
				}

				let tmpMutatedValues = this.substituteValuesInTokenizedObjects(tmpResultsObject.PostfixTokenObjects, tmpSeriesStepDataSourceObject, tmpResultsObject, tmpManifest);

				tmpValueArray.push( this.solvePostfixedExpression( tmpResultsObject.PostfixSolveList, tmpDataDestinationObject, tmpResultsObject, tmpManifest) );

				for (let j = 0; j < tmpMutatedValues.length; j++)
				{
					tmpMutatedValues[j].Resolved = false;
				}
			}

			// Do the assignment
			let tmpAssignmentManifestHash = tmpResultsObject.PostfixedAssignmentAddress;
			if ((tmpResultsObject.OriginalRawTokens[1] === '=') && (typeof(tmpResultsObject.OriginalRawTokens[0]) === 'string') && (tmpResultsObject.OriginalRawTokens[0].length > 0))
			{
				tmpAssignmentManifestHash = tmpResultsObject.OriginalRawTokens[0];
			}

			tmpManifest.setValueByHash(tmpDataDestinationObject, tmpAssignmentManifestHash, tmpValueArray);

			return tmpValueArray;
		}
		else if (tmpResultsObject.SolverDirectives.Code == 'MULTIROWMAP')
		{
			// MULTIROWMAP iterates over an array of objects (rows), allowing each expression to reference
			// the current row and any number of previous/future rows via configurable offsets.
			// Optional SERIESSTART and SERIESSTEP control which rows are iterated and in what direction.
			const tmpDirectiveValues = tmpResultsObject.SolverDirectives.Values;
			const tmpDirectiveValueKeys = tmpResultsObject.SolverDirectives.ValueKeys;
			const tmpRowsAddress = tmpResultsObject.SolverDirectives.RowsAddress;
			let tmpValueArray = [];

			// Resolve the rows array from the data source
			let tmpRows = null;
			if (tmpRowsAddress)
			{
				tmpRows = tmpManifest.getValueByHash(tmpDataSourceObject, tmpRowsAddress);
			}

			if (!Array.isArray(tmpRows) || tmpRows.length < 1)
			{
				tmpResultsObject.ExpressionParserLog.push(`ExpressionParser.solve detected invalid MULTIROWMAP directive parameters.  ROWS FROM address must resolve to a non-empty array.`);
				this.log.warn(tmpResultsObject.ExpressionParserLog[tmpResultsObject.ExpressionParserLog.length-1]);
				return undefined;
			}

			// Resolve SeriesStart: default to 0 (first row).  Negative values count from end.
			let tmpSeriesStart = 0;
			if (tmpResultsObject.SolverDirectives.SeriesStart !== null)
			{
				tmpSeriesStart = parseInt(tmpResultsObject.SolverDirectives.SeriesStart);
				if (isNaN(tmpSeriesStart))
				{
					// Try to resolve as a variable from the data source
					let tmpStartToken = this.fable.ExpressionParser.Postfix.getTokenContainerObject(tmpResultsObject.SolverDirectives.SeriesStart, 'Token.Symbol');
					this.substituteValuesInTokenizedObjects([tmpStartToken], tmpDataSourceObject, tmpResultsObject, tmpManifest);
					if (tmpStartToken.Resolved)
					{
						tmpSeriesStart = parseInt(tmpStartToken.Value);
					}
					if (isNaN(tmpSeriesStart))
					{
						tmpSeriesStart = 0;
					}
				}
			}
			// Handle negative start (count from end)
			if (tmpSeriesStart < 0)
			{
				tmpSeriesStart = tmpRows.length + tmpSeriesStart;
			}
			// Clamp to valid range
			tmpSeriesStart = Math.max(0, Math.min(tmpSeriesStart, tmpRows.length - 1));

			// Resolve SeriesStep: default to 1
			let tmpSeriesStep = 1;
			if (tmpResultsObject.SolverDirectives.SeriesStep !== null)
			{
				tmpSeriesStep = parseInt(tmpResultsObject.SolverDirectives.SeriesStep);
				if (isNaN(tmpSeriesStep))
				{
					// Try to resolve as a variable from the data source
					let tmpStepToken = this.fable.ExpressionParser.Postfix.getTokenContainerObject(tmpResultsObject.SolverDirectives.SeriesStep, 'Token.Symbol');
					this.substituteValuesInTokenizedObjects([tmpStepToken], tmpDataSourceObject, tmpResultsObject, tmpManifest);
					if (tmpStepToken.Resolved)
					{
						tmpSeriesStep = parseInt(tmpStepToken.Value);
					}
					if (isNaN(tmpSeriesStep))
					{
						tmpSeriesStep = 1;
					}
				}
			}
			if (tmpSeriesStep === 0)
			{
				tmpResultsObject.ExpressionParserLog.push(`ExpressionParser.solve detected invalid MULTIROWMAP directive parameters.  SERIESSTEP cannot be zero.`);
				this.log.warn(tmpResultsObject.ExpressionParserLog[tmpResultsObject.ExpressionParserLog.length-1]);
				return undefined;
			}

			let tmpStepCounter = 0;
			for (let i = tmpSeriesStart; (tmpSeriesStep > 0) ? (i < tmpRows.length) : (i >= 0); i += tmpSeriesStep)
			{
				// Build the data source for this iteration with the mapped variables
				let tmpRowStepDataSourceObject = Object.assign({}, tmpDataSourceObject);
				tmpRowStepDataSourceObject.stepIndex = tmpStepCounter;
				tmpRowStepDataSourceObject.rowIndex = i;

				for (let j = 0; j < tmpDirectiveValueKeys.length; j++)
				{
					const tmpVariableKey = tmpDirectiveValueKeys[j];
					const tmpVariableDescription = tmpDirectiveValues[tmpVariableKey];
					const tmpTargetRowIndex = i + tmpVariableDescription.RowOffset;

					// Check if the target row index is within bounds
					if (tmpTargetRowIndex < 0 || tmpTargetRowIndex >= tmpRows.length)
					{
						// Out of bounds -- use the default value
						tmpRowStepDataSourceObject[tmpVariableKey] = tmpVariableDescription.Default;
					}
					else
					{
						const tmpTargetRow = tmpRows[tmpTargetRowIndex];
						if (tmpVariableDescription.Property === null)
						{
							// No property specified, use the whole row
							tmpRowStepDataSourceObject[tmpVariableKey] = tmpTargetRow;
						}
						else
						{
							// Look up the property on the target row
							let tmpValue = tmpManifest.getValueByHash(tmpTargetRow, tmpVariableDescription.Property);
							if (tmpValue == null)
							{
								tmpValue = tmpVariableDescription.Default;
							}
							tmpRowStepDataSourceObject[tmpVariableKey] = tmpValue;
						}
					}
				}

				let tmpMutatedValues = this.substituteValuesInTokenizedObjects(tmpResultsObject.PostfixTokenObjects, tmpRowStepDataSourceObject, tmpResultsObject, tmpManifest);

				tmpValueArray.push( this.solvePostfixedExpression( tmpResultsObject.PostfixSolveList, tmpDataDestinationObject, tmpResultsObject, tmpManifest) );

				for (let j = 0; j < tmpMutatedValues.length; j++)
				{
					tmpMutatedValues[j].Resolved = false;
				}

				tmpStepCounter++;
			}

			// Do the assignment
			let tmpAssignmentManifestHash = tmpResultsObject.PostfixedAssignmentAddress;
			if ((tmpResultsObject.OriginalRawTokens[1] === '=') && (typeof(tmpResultsObject.OriginalRawTokens[0]) === 'string') && (tmpResultsObject.OriginalRawTokens[0].length > 0))
			{
				tmpAssignmentManifestHash = tmpResultsObject.OriginalRawTokens[0];
			}

			tmpManifest.setValueByHash(tmpDataDestinationObject, tmpAssignmentManifestHash, tmpValueArray);

			return tmpValueArray;
		}
		else if (tmpResultsObject.SolverDirectives.Code == 'MONTECARLO')
		{
			const [ tmpSampleCount ] = this._prepareDirectiveParameters([
				tmpResultsObject.SolverDirectives.SampleCount
			], [ '1' ], tmpResultsObject, tmpDataSourceObject, tmpManifest);

			if (isNaN(tmpSampleCount))
			{
				tmpResultsObject.ExpressionParserLog.push(`ExpressionParser.solve detected invalid MONTECARLO directive parameters.  SAMPLECOUNT must be numeric.`);
				this.log.warn(tmpResultsObject.ExpressionParserLog[tmpResultsObject.ExpressionParserLog.length-1]);
				return null;
			}

			let tmpMonteCarloOutput = JSON.parse(JSON.stringify(tmpResultsObject.SolverDirectives));
			tmpMonteCarloOutput.Samples = [];

			// Now go through each variable and prepare its object of values
			let tmpVariableKeys = Object.keys(tmpMonteCarloOutput.Values);
			for (let i = 0; i < tmpVariableKeys.length; i++)
			{
				let tmpVariableKey = tmpVariableKeys[i];
				let tmpVariableDescription = tmpMonteCarloOutput.Values[tmpVariableKey];

				// For each variable, generate its array of sampled values
				tmpVariableDescription.Distribution = {};
				tmpVariableDescription.ValueSequence = [];

				// Resolve the points if they are tokenized expressions
				const tmpResolvedPoints = [];
				for (let j = 0; j < tmpVariableDescription.Points.length; j++)
				{
					let tmpPointToken = tmpVariableDescription.Points[j];
					let tmpPointValue = this.fable.Math.parsePrecise(tmpPointToken, NaN);
					if (isNaN(tmpPointValue) && typeof tmpPointToken === 'string' && tmpPointToken.length > 0)
					{
						tmpPointValue = tmpManifest.getValueByHash(tmpDataSourceObject, tmpPointToken);
						if (!tmpPointValue || (tmpPointValue == null))
						{
							//TODO: Warn?
						}
						else
						{
							tmpResolvedPoints.push(tmpPointValue);
						}

					}
					else
					{
						tmpResolvedPoints.push(tmpPointToken);
					}
				}
				// Now sort the resolved points
				tmpResolvedPoints.sort((a, b) => this.fable.Math.comparePrecise(a, b));
				tmpVariableDescription.ResolvedPoints = tmpResolvedPoints;

				// Just simple linear until we add more easing types in a separate library (refactoring the below out)
				tmpVariableDescription.FirstPoint = tmpVariableDescription.ResolvedPoints[0];
				tmpVariableDescription.DomainRangeStart = tmpVariableDescription.FirstPoint;
				if (tmpVariableDescription.ResolvedPoints.length < 2)
				{
					tmpVariableDescription.LastPoint = tmpVariableDescription.FirstPoint;
				}
				else
				{
					tmpVariableDescription.LastPoint = this.fable.Math.parsePrecise(tmpVariableDescription.ResolvedPoints[tmpVariableDescription.ResolvedPoints.length - 1], NaN);
					if (isNaN(tmpVariableDescription.LastPoint))
					{
						tmpVariableDescription.LastPoint = tmpVariableDescription.FirstPoint;
					}
				}
				tmpVariableDescription.DomainLength = this.fable.Math.subtractPrecise(tmpVariableDescription.LastPoint, tmpVariableDescription.FirstPoint);
				//this.fable.log.trace(`Monte Carlo variable ${tmpVariableKey} has first point ${tmpVariableDescription.FirstPoint}, last point ${tmpVariableDescription.LastPoint}, domain length ${tmpVariableDescription.DomainLength}`);

				// // This generation of data based on the resolved points (and easing type) should be abstracted.  Most require the same rules.
				// tmpVariableDescription.ResolvedPointDomainStarts = [];
				// tmpVariableDescription.DomainTranslationAmount = [];

				// // Get the length of each domain segment and the multiplier for them
				// tmpVariableDescription.DomainLength = this.fable.Math.subtractPrecise(tmpVariableDescription.ResolvedPoints[tmpVariableDescription.ResolvedPoints.length - 1], tmpVariableDescription.ResolvedPoints[0]);
				// tmpVariableDescription.DomainChunkCount = tmpVariableDescription.ResolvedPoints.length;
				// tmpVariableDescription.DomainStart = tmpVariableDescription.ResolvedPoints[0];

				// let tmpCurrentDomainPosition = tmpVariableDescription.DomainStart;
				// let tmpPreviousDomainTranslationAmount = '0';
				// for (let j = 0; j < tmpVariableDescription.ResolvedPoints.length; j++)
				// {
				// 	let tmpResolvedPointValue = tmpVariableDescription.ResolvedPoints[j];
				// 	// Set the resolved point domain start
				// 	tmpVariableDescription.DomainTranslationAmount.push(this.fable.Math.dividePrecise(tmpResolvedPointValue, tmpVariableDescription.DomainLength));
				// 	// Push the previous translation amount as the start of this domain
				// 	tmpVariableDescription.ResolvedPointDomainStarts.push(tmpPreviousDomainTranslationAmount);
				// 	// Calculate the translation amount, for the start of the next domain
				// 	tmpPreviousDomainTranslationAmount = this.fable.Math.addPrecise(tmpPreviousDomainTranslationAmount, tmpVariableDescription.DomainLength);
				// }
			}

			for (let i = 0; i <= Number(tmpSampleCount) - 1; i++)
			{
				// Jimmy up the data source with the current N value, stepIndex and all the other data from the source object
				// This generates a data source object every time on purpose so we can remarshal in values that changed in the destination
				let tmpSeriesStepDataSourceObject = Object.assign({}, tmpDataSourceObject);
				tmpSeriesStepDataSourceObject.stepIndex = i;

				// Generate each value from the array of values
				for (let j = 0; j < tmpVariableKeys.length; j++)
				{
					let tmpPointManifestHash = tmpVariableKeys[j];
					let tmpPointManifest = tmpMonteCarloOutput.Values[tmpPointManifestHash];

					// Generate the value for this sample variable
					let tmpPointValue = this.fable.Math.generateValueFromEasingDescription(tmpPointManifest);
					tmpSeriesStepDataSourceObject[tmpVariableKeys[j]] = tmpPointValue;
					tmpPointManifest.ValueSequence.push(tmpPointValue);

					// We keep track of a distribution of generated values here for analysis later
					let tmpDistributionRoundPrecision = tmpPointManifest.DistributionRoundPrecision || 0;
					// Log the value out
					//this.fable.log.info(`Monte Carlo variable ${tmpPointManifestHash} generated value ${tmpPointValue}`);
					let tmpDistributionPointValue = this.fable.Math.roundPrecise(tmpPointValue, tmpDistributionRoundPrecision);
					if (!(tmpDistributionPointValue in tmpPointManifest.Distribution))
					{
						tmpPointManifest.Distribution[tmpDistributionPointValue] = 0;
					}
					tmpPointManifest.Distribution[tmpDistributionPointValue] = tmpPointManifest.Distribution[tmpDistributionPointValue] + 1;
				}

				let tmpMutatedValues = this.substituteValuesInTokenizedObjects(tmpResultsObject.PostfixTokenObjects, tmpSeriesStepDataSourceObject, tmpResultsObject, tmpManifest);
				tmpMonteCarloOutput.Samples.push( this.solvePostfixedExpression( tmpResultsObject.PostfixSolveList, tmpDataDestinationObject, tmpResultsObject, tmpManifest ) );

				for (let j = 0; j < tmpMutatedValues.length; j++)
				{
					tmpMutatedValues[j].Resolved = false;
				}
			}

			// Do the assignment
			let tmpAssignmentManifestHash = tmpResultsObject.PostfixedAssignmentAddress;
			if ((tmpResultsObject.OriginalRawTokens[1] === '=') && (typeof(tmpResultsObject.OriginalRawTokens[0]) === 'string') && (tmpResultsObject.OriginalRawTokens[0].length > 0))
			{
				tmpAssignmentManifestHash = tmpResultsObject.OriginalRawTokens[0];
			}

			tmpManifest.setValueByHash(tmpDataDestinationObject, tmpAssignmentManifestHash, tmpMonteCarloOutput);

			return tmpMonteCarloOutput;
		}
		else // For 'SOLVE' or anything else that didn't work
		{
			// This is where the data from variables gets marshaled into their symbols (from AppData or the like)
			this.substituteValuesInTokenizedObjects(tmpResultsObject.PostfixTokenObjects, tmpDataSourceObject, tmpResultsObject, pManifest);
			// Finally this is the expr solving method, which returns a string and also marshals it into tmpDataDestinationObject
			return this.solvePostfixedExpression(tmpResultsObject.PostfixSolveList, tmpDataDestinationObject, tmpResultsObject, pManifest);
		}
	}
}

module.exports = FableServiceExpressionParser;

},{"./Fable-Service-ExpressionParser/Fable-Service-ExpressionParser-ExpressionTokenizer-DirectiveMutation.js":78,"./Fable-Service-ExpressionParser/Fable-Service-ExpressionParser-ExpressionTokenizer.js":79,"./Fable-Service-ExpressionParser/Fable-Service-ExpressionParser-FunctionMap.json":80,"./Fable-Service-ExpressionParser/Fable-Service-ExpressionParser-Linter.js":81,"./Fable-Service-ExpressionParser/Fable-Service-ExpressionParser-Messaging.js":82,"./Fable-Service-ExpressionParser/Fable-Service-ExpressionParser-Postfix.js":83,"./Fable-Service-ExpressionParser/Fable-Service-ExpressionParser-SolvePostfixedExpression.js":84,"./Fable-Service-ExpressionParser/Fable-Service-ExpressionParser-TokenMap.json":85,"./Fable-Service-ExpressionParser/Fable-Service-ExpressionParser-ValueMarshal.js":86,"fable-serviceproviderbase":59}],77:[function(require,module,exports){
const libFableServiceProviderBase = require('fable-serviceproviderbase');

class ExpressionParserOperationBase extends libFableServiceProviderBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.serviceType = 'ExpressionParserOperationBase';

		this.numberTest = /^-{0,1}\d*\.{0,1}\d+$/;

		this.ExpressionParser = false;
	}

	connectExpressionParser(pExpressionParser)
	{
		this.ExpressionParser = pExpressionParser;
	}

	getTokenType(pToken)
	{
		if (pToken in this.ExpressionParser.tokenMap)
		{
			return `Token.${this.ExpressionParser.tokenMap[pToken].Type}`;
		}
		else if ((pToken.length > 2) && (pToken[0] === '{') && (pToken[pToken.length-1] === '}'))
		{
			return 'Token.StateAddress';
		}
		else if ((pToken.length > 1) && (pToken[0] === '"') && (pToken[pToken.length-1] === '"'))
		{
			return 'Token.String';
		}
		else if (this.numberTest.test(pToken))
		{
			return 'Token.Constant';
		}
		else
		{
			return 'Token.Symbol';
		}
		// Just for documentation sake:
		// There is a fifth token type, VirtualSymbol
		// This is a value that's added during solve and looked up by address in the VirtualSymbol object.
	}

	getTokenContainerObject(pToken, pTokenType)
	{
		return (
			{
				Token: pToken,
				Type: (typeof(pTokenType) === 'undefined') ? this.getTokenType(pToken) : pTokenType,
				Descriptor: (pToken in this.ExpressionParser.tokenMap) ? this.ExpressionParser.tokenMap[pToken] : false
			});
	}
}

module.exports = ExpressionParserOperationBase;
},{"fable-serviceproviderbase":59}],78:[function(require,module,exports){
const libExpressionParserOperationBase = require('./Fable-Service-ExpressionParser-Base.js');

class ExpressionTokenizerDirectiveMutation extends libExpressionParserOperationBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		this.serviceType = 'ExpressionParser-TokenizerDirectiveMutation';

		this.directiveTypes = (
			{
				'SOLVE': { Name: 'Solve Expression', Code: 'SOLVE' },
				'SERIES': { Name: 'Series', Code: 'SERIES', From: null, To: null, Step: null },
				'MONTECARLO': { Name: 'Monte Carlo Simulation', SampleCount: '1', Code: 'MONTECARLO', Values: {} },
				'MAP': { Name: 'Map', Code: 'MAP', Values: {}, ValueKeys: [] },
				'MULTIROWMAP': { Name: 'Multi-Row Map', Code: 'MULTIROWMAP', RowsAddress: null, SeriesStart: null, SeriesStep: null, Values: {}, ValueKeys: [] },
			});

		this.defaultDirective = this.directiveTypes.SOLVE;
	}

	parseSeriesDirective(pTokens)
	{
		// This isn't a fancy real parse it's just taking words and stealing values after them.
		let tmpNewSeriesDirectiveDescription = JSON.parse(JSON.stringify(this.directiveTypes.SERIES));

		for (let i = 0; i < pTokens.length; i++)
		{
			let tmpToken = pTokens[i].toUpperCase();
			switch(tmpToken)
			{
				case 'FROM':
					if ((i + 1) < pTokens.length)
					{
						tmpNewSeriesDirectiveDescription.From = pTokens[i + 1];
					}
					break;

				case 'TO':
					if ((i + 1) < pTokens.length)
					{
						tmpNewSeriesDirectiveDescription.To = pTokens[i + 1];
					}
					break;

				case 'STEP':
					if ((i + 1) < pTokens.length)
					{
						tmpNewSeriesDirectiveDescription.Step = pTokens[i + 1];
					}
					break;

				default:
					// Ignore other tokens
					break;
			}
		}

		return tmpNewSeriesDirectiveDescription;
	}

	parseMonteCarloDirective(pTokens)
	{
		// This isn't a fancy real parse it's just taking words and stealing values after them.
		let tmpNewMonteCarloDirectiveDescription = JSON.parse(JSON.stringify(this.directiveTypes.MONTECARLO));

		for (let i = 0; i < pTokens.length; i++)
		{
			let tmpToken = pTokens[i].toUpperCase();
			switch(tmpToken)
			{
				case 'SAMPLECOUNT':
					if ((i + 1) < pTokens.length)
					{
						tmpNewMonteCarloDirectiveDescription.SampleCount = pTokens[i + 1];
					}
					i = i + 1;
					break;

				case 'VARIABLE':
				case 'VAR':
				case 'V':
					if ((i + 1) < pTokens.length)
					{
						let tmpVariableToken = pTokens[i + 1];
						if (typeof(tmpVariableToken) === 'string' && (tmpVariableToken.length > 0))
						{
							tmpNewMonteCarloDirectiveDescription.Values[tmpVariableToken] =
							{
								Token: tmpVariableToken,
								Easing: 'Linear', // could be parametric, logarithmic, bezier, uniform, normal, etc.
								Points: [] // array of values for points to generate between.
							}
						}
					}
					i = i + 1;
					break;

				case 'POINT':
				case 'PT':
				case 'P':
					if (pTokens.length < i + 2)
					{
						continue;
					}

					let tmpTokenIndexSkip = 2;
					let tmpVariableToken = pTokens[i + 1];
					if (tmpVariableToken in tmpNewMonteCarloDirectiveDescription.Values)
					{
						let tmpVariableValueString = pTokens[i + 2];
						if ((tmpVariableValueString == '-') || (tmpVariableValueString == '+'))
						{
							if (pTokens.length < i + 3)
							{
								continue;
							}
							tmpVariableValueString = tmpVariableValueString + pTokens[i + 3];
							tmpTokenIndexSkip = 3;
						}
						let tmpVariableValue = this.fable.Math.parsePrecise(tmpVariableValueString, NaN);
						if (!isNaN(tmpVariableValue))
						{
							tmpNewMonteCarloDirectiveDescription.Values[tmpVariableToken].Points.push(tmpVariableValue);
						}
					}
					i = i + tmpTokenIndexSkip;
					break;

				case 'EASING':
					if (pTokens.length < i + 2)
					{
						continue;
					}

					tmpVariableToken = pTokens[i + 1];
					let tmpEasingType = pTokens[i + 2].toUpperCase();
					if (tmpVariableToken in tmpNewMonteCarloDirectiveDescription.Values)
					{
						tmpNewMonteCarloDirectiveDescription.Values[tmpVariableToken].Easing = tmpEasingType;
					}
					i = i + 2;
					break;

				default:
					// Ignore other tokens
					break;
			}
		}

		return tmpNewMonteCarloDirectiveDescription;
	}

	parseMapDirective(pTokens)
	{
		// This isn't a fancy real parse it's just taking words and stealing values after them.
		let tmpNewMapDirectiveDescription = JSON.parse(JSON.stringify(this.directiveTypes.MAP));

		for (let i = 0; i < pTokens.length; i++)
		{
			let tmpToken = pTokens[i].toUpperCase();
			switch(tmpToken)
			{
				case 'VARIABLE':
				case 'VAR':
				case 'V':
					if (((i + 3) < pTokens.length) && (pTokens[i+2].toUpperCase() == 'FROM'))
					{
						let tmpVariableToken = pTokens[i + 1];
						if (typeof(tmpVariableToken) === 'string' && (tmpVariableToken.length > 0))
						{
							tmpNewMapDirectiveDescription.ValueKeys.push(tmpVariableToken);
							tmpNewMapDirectiveDescription.Values[tmpVariableToken] =
							{
								Token: tmpVariableToken,
								Address: pTokens[i + 3],
							}
						}
						i = i + 3;
					}
					break;

				default:
					// Ignore other tokens
					break;
			}
		}

		return tmpNewMapDirectiveDescription;
	}

	parseMultiRowMapDirective(pTokens)
	{
		// Parse MULTIROWMAP directive tokens.
		// Syntax: MULTIROWMAP ROWS FROM <address> [SERIESSTART <n>] [SERIESSTEP <n>] VAR <name> FROM <property> OFFSET <n> DEFAULT <defaultValue> ...
		// OFFSET defaults to 0 (current row) if not specified.
		// DEFAULT defaults to '0' if not specified.
		// OFFSET 0 = current row, OFFSET -1 = previous row, OFFSET -2 = two rows back, etc.
		// Positive OFFSET values look forward (e.g., OFFSET 1 = next row, OFFSET 2 = two rows ahead).
		// SERIESSTART defaults to 0 (first row). Negative values count from the end (e.g., -2 = second-to-last row).
		// SERIESSTEP defaults to 1. Use -1 to iterate backwards through rows.
		let tmpNewDirectiveDescription = JSON.parse(JSON.stringify(this.directiveTypes.MULTIROWMAP));

		for (let i = 0; i < pTokens.length; i++)
		{
			let tmpToken = pTokens[i].toUpperCase();
			switch(tmpToken)
			{
				case 'ROWS':
					// Expect ROWS FROM <address>
					if (((i + 2) < pTokens.length) && (pTokens[i + 1].toUpperCase() === 'FROM'))
					{
						tmpNewDirectiveDescription.RowsAddress = pTokens[i + 2];
						i = i + 2;
					}
					break;

				case 'SERIESSTART':
					if ((i + 1) < pTokens.length)
					{
						// Handle negative values which get tokenized as separate - and number tokens
						let tmpStartValue = pTokens[i + 1];
						if ((tmpStartValue === '-') && ((i + 2) < pTokens.length))
						{
							tmpStartValue = '-' + pTokens[i + 2];
							i = i + 2;
						}
						else
						{
							i = i + 1;
						}
						tmpNewDirectiveDescription.SeriesStart = tmpStartValue;
					}
					break;

				case 'SERIESSTEP':
					if ((i + 1) < pTokens.length)
					{
						// Handle negative values which get tokenized as separate - and number tokens
						let tmpStepValue = pTokens[i + 1];
						if ((tmpStepValue === '-') && ((i + 2) < pTokens.length))
						{
							tmpStepValue = '-' + pTokens[i + 2];
							i = i + 2;
						}
						else
						{
							i = i + 1;
						}
						tmpNewDirectiveDescription.SeriesStep = tmpStepValue;
					}
					break;

				case 'VARIABLE':
				case 'VAR':
				case 'V':
					// Expect: VAR <name> FROM <property> [OFFSET <n>] [DEFAULT <defaultValue>]
					if (((i + 3) < pTokens.length) && (pTokens[i + 2].toUpperCase() === 'FROM'))
					{
						let tmpVariableName = pTokens[i + 1];
						let tmpProperty = pTokens[i + 3];

						if (typeof(tmpVariableName) === 'string' && (tmpVariableName.length > 0))
						{
							let tmpVariableDescriptor = {
								Token: tmpVariableName,
								Property: tmpProperty,
								RowOffset: 0,
								Default: '0',
							};

							let tmpCurrentIndex = i + 3;

							// Scan forward for OFFSET and DEFAULT in any order
							while (tmpCurrentIndex + 1 < pTokens.length)
							{
								let tmpNextToken = pTokens[tmpCurrentIndex + 1].toUpperCase();
								if (tmpNextToken === 'OFFSET')
								{
									if (tmpCurrentIndex + 2 < pTokens.length)
									{
										// Handle negative offsets which get tokenized as separate - and number tokens
										let tmpOffsetValue = pTokens[tmpCurrentIndex + 2];
										if ((tmpOffsetValue === '-') && (tmpCurrentIndex + 3 < pTokens.length))
										{
											tmpOffsetValue = '-' + pTokens[tmpCurrentIndex + 3];
											tmpCurrentIndex = tmpCurrentIndex + 3;
										}
										else
										{
											tmpCurrentIndex = tmpCurrentIndex + 2;
										}
										tmpVariableDescriptor.RowOffset = parseInt(tmpOffsetValue);
										if (isNaN(tmpVariableDescriptor.RowOffset))
										{
											tmpVariableDescriptor.RowOffset = 0;
										}
									}
								}
								else if (tmpNextToken === 'DEFAULT')
								{
									if (tmpCurrentIndex + 2 < pTokens.length)
									{
										// Handle negative defaults which get tokenized as separate - and number tokens
										let tmpDefaultValue = pTokens[tmpCurrentIndex + 2];
										if ((tmpDefaultValue === '-') && (tmpCurrentIndex + 3 < pTokens.length))
										{
											tmpDefaultValue = '-' + pTokens[tmpCurrentIndex + 3];
											tmpCurrentIndex = tmpCurrentIndex + 3;
										}
										else
										{
											tmpCurrentIndex = tmpCurrentIndex + 2;
										}
										tmpVariableDescriptor.Default = tmpDefaultValue;
									}
								}
								else
								{
									// Not a recognized sub-keyword for this variable; stop scanning
									break;
								}
							}

							i = tmpCurrentIndex;

							tmpNewDirectiveDescription.ValueKeys.push(tmpVariableName);
							tmpNewDirectiveDescription.Values[tmpVariableName] = tmpVariableDescriptor;
						}
					}
					break;

				default:
					// Ignore other tokens
					break;
			}
		}

		return tmpNewDirectiveDescription;
	}

	rewriteTernaryOperators(pResultObject)
	{
		let tmpTokens = pResultObject.RawTokens;

		// Scan right-to-left so nested ternaries (innermost first) are handled correctly.
		for (let i = tmpTokens.length - 1; i >= 0; i--)
		{
			if (tmpTokens[i] !== '?')
			{
				continue;
			}

			// Found a ? token at index i.
			// Walk left to find the start of the condition expression.
			// The condition starts after the previous comma, open parenthesis, assignment operator, or beginning of tokens.
			let tmpConditionStart = 0;
			let tmpParenDepth = 0;
			for (let j = i - 1; j >= 0; j--)
			{
				if (tmpTokens[j] === ')')
				{
					tmpParenDepth++;
				}
				else if (tmpTokens[j] === '(')
				{
					if (tmpParenDepth > 0)
					{
						tmpParenDepth--;
					}
					else
					{
						// We hit an unmatched open paren — condition starts after it
						tmpConditionStart = j + 1;
						break;
					}
				}
				else if (tmpParenDepth === 0)
				{
					let tmpTokenDescriptor = this.ExpressionParser.tokenMap[tmpTokens[j]];
					if (tmpTokenDescriptor && (tmpTokenDescriptor.Type === 'Assignment' || tmpTokens[j] === ','))
					{
						tmpConditionStart = j + 1;
						break;
					}
				}
			}

			// Walk right from ? to find the matching :: at the same parenthesis depth.
			let tmpSeparatorIndex = -1;
			tmpParenDepth = 0;
			for (let j = i + 1; j < tmpTokens.length; j++)
			{
				if (tmpTokens[j] === '(')
				{
					tmpParenDepth++;
				}
				else if (tmpTokens[j] === ')')
				{
					if (tmpParenDepth > 0)
					{
						tmpParenDepth--;
					}
					else
					{
						// Hit closing paren at our depth — no :: found in this group
						break;
					}
				}
				else if (tmpTokens[j] === '::' && tmpParenDepth === 0)
				{
					tmpSeparatorIndex = j;
					break;
				}
			}

			if (tmpSeparatorIndex === -1)
			{
				pResultObject.ExpressionParserLog.push(`ExpressionParser.rewriteTernaryOperators found a ? at token index ${i} with no matching :: separator.`);
				this.log.warn(pResultObject.ExpressionParserLog[pResultObject.ExpressionParserLog.length - 1]);
				continue;
			}

			// Walk right from :: to find the end of the false branch.
			// The false branch ends at the next comma, close parenthesis, or end of tokens at the same depth.
			let tmpFalseBranchEnd = tmpTokens.length;
			tmpParenDepth = 0;
			for (let j = tmpSeparatorIndex + 1; j < tmpTokens.length; j++)
			{
				if (tmpTokens[j] === '(')
				{
					tmpParenDepth++;
				}
				else if (tmpTokens[j] === ')')
				{
					if (tmpParenDepth > 0)
					{
						tmpParenDepth--;
					}
					else
					{
						// Unmatched close paren — false branch ends here
						tmpFalseBranchEnd = j;
						break;
					}
				}
				else if (tmpParenDepth === 0)
				{
					if (tmpTokens[j] === ',')
					{
						tmpFalseBranchEnd = j;
						break;
					}
				}
			}

			// Extract the three segments
			let tmpConditionTokens = tmpTokens.slice(tmpConditionStart, i);
			let tmpTrueBranchTokens = tmpTokens.slice(i + 1, tmpSeparatorIndex);
			let tmpFalseBranchTokens = tmpTokens.slice(tmpSeparatorIndex + 1, tmpFalseBranchEnd);

			// Build the replacement: ternary((condition), trueBranch, falseBranch)
			// The condition is wrapped in its own parentheses to ensure correct
			// precedence grouping when arithmetic appears on both sides of a comparison.
			let tmpReplacementTokens = ['ternary', '(', '('];
			tmpReplacementTokens = tmpReplacementTokens.concat(tmpConditionTokens);
			tmpReplacementTokens.push(')');
			tmpReplacementTokens.push(',');
			tmpReplacementTokens = tmpReplacementTokens.concat(tmpTrueBranchTokens);
			tmpReplacementTokens.push(',');
			tmpReplacementTokens = tmpReplacementTokens.concat(tmpFalseBranchTokens);
			tmpReplacementTokens.push(')');

			// Splice the replacement into the token array
			tmpTokens.splice(tmpConditionStart, tmpFalseBranchEnd - tmpConditionStart, ...tmpReplacementTokens);

			// Adjust i to re-scan from the start of what we just inserted (in case of nested ternaries in the condition)
			i = tmpConditionStart;
		}
	}

	parseDirectives(pResultObject)
	{
		let tmpResults = (typeof(pResultObject) === 'object') ? pResultObject : { ExpressionParserLog: [] };

		// Rewrite ternary operators before directive parsing
		this.rewriteTernaryOperators(tmpResults);

		tmpResults.SolverDirectives = this.defaultDirective;
		tmpResults.SolverDirectiveTokens = [];

		if (tmpResults.RawTokens.length < 2)
		{
			tmpResults.ExpressionParserLog.push(`ExpressionParser.tokenizeDirectiveMutation postprocessor received insufficient tokens to process directives.`);
			this.log.warn(tmpResults.ExpressionParserLog[tmpResults.ExpressionParserLog.length-1]);
			return tmpResults.SolverDirectives;
		}

		// Enumerate each of the tmpResults.RawTokens to see if one of the values in the directiveTypeMap exists and is either at the beginning or after the assignment (= or ?=) operator
		for (let i = 0; i < tmpResults.RawTokens.length; i++)
		{
			let tmpToken = tmpResults.RawTokens[i].toUpperCase();
			if (tmpToken in this.directiveTypes)
			{
				// Check if it's at the beginning or after an assignment operator
				// FIXME: This is hard coded assignment operators which is bad juju
				if ((i === 0) || (tmpResults.RawTokens[i-1] === '=') || (tmpResults.RawTokens[i-1] === '?='))
				{
					// We have a directive!
					tmpResults.SolverDirectives.Type = this.directiveTypes[tmpToken];

					tmpResults.ExpressionParserLog.push(`ExpressionParser.tokenizeDirectiveMutation identified solver directive: ${tmpToken}`);
					//this.log.info(tmpResults.ExpressionParserLog[tmpResults.ExpressionParserLog.length-1]);

					// Extract the Directive name and everything else from it up until the : token
					let tmpDirectiveTokenStartIndex = i;
					let tmpDirectiveTokenEndIndex = -1;
					for (let j = tmpDirectiveTokenStartIndex + 1; j < tmpResults.RawTokens.length; j++)
					{
						if (tmpResults.RawTokens[j] === ':')
						{
							tmpDirectiveTokenEndIndex = j;
							break;
						}
					}

					// If the directive token end is not in the expression we don't know what to do
					if (tmpDirectiveTokenEndIndex === -1)
					{
						tmpResults.ExpressionParserLog.push(`ExpressionParser.tokenizeDirectiveMutation could not find the end of the directive token set for directive: ${tmpToken}`);
						this.log.warn(tmpResults.ExpressionParserLog[tmpResults.ExpressionParserLog.length-1]);
						continue;
					}

					// Set the tmpResults.SolverDirectiveTokens to the slice of tokens that represent the directive
					tmpResults.SolverDirectiveTokens = tmpResults.RawTokens.slice(tmpDirectiveTokenStartIndex, tmpDirectiveTokenEndIndex);

					// Remove the directive tokens and the assignment to the left of it from the array of raw tokens
					// the colonoscopy if you will
					tmpResults.RawTokens.splice(0, tmpDirectiveTokenEndIndex + 1);

					// Further parsing based on directive type could go here
					// e.g. parseSeriesDirective for SERIES, etc.
					switch(tmpToken)
					{
						case 'SERIES':
							tmpResults.SolverDirectives = this.parseSeriesDirective(tmpResults.SolverDirectiveTokens);
							break;
						case 'MONTECARLO':
							tmpResults.SolverDirectives = this.parseMonteCarloDirective(tmpResults.SolverDirectiveTokens);
							break;
						case 'MAP':
							tmpResults.SolverDirectives = this.parseMapDirective(tmpResults.SolverDirectiveTokens);
							break;
						case 'MULTIROWMAP':
							tmpResults.SolverDirectives = this.parseMultiRowMapDirective(tmpResults.SolverDirectiveTokens);
							break;
						default:
							// No further parsing needed
							break;
					}
				}
			}
		}

		return tmpResults.SolverDirectives;
	}
}

module.exports = ExpressionTokenizerDirectiveMutation;

},{"./Fable-Service-ExpressionParser-Base.js":77}],79:[function(require,module,exports){
const libExpressionParserOperationBase = require('./Fable-Service-ExpressionParser-Base.js');

class ExpressionTokenizer extends libExpressionParserOperationBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		this.serviceType = 'ExpressionParser-Tokenizer';
	}

	/**
	 * Recompose an expression string from an array of tokens.
	 *
	 * This is the inverse of tokenize -- it takes an array of token strings
	 * and reconstructs a valid expression string with appropriate spacing.
	 *
	 * @param {Array<string>} pTokens - The array of token strings to recompose.
	 * @return {string} The recomposed expression string.
	 */
	recompose(pTokens)
	{
		if (!Array.isArray(pTokens) || pTokens.length === 0)
		{
			return '';
		}

		let tmpResult = '';

		for (let i = 0; i < pTokens.length; i++)
		{
			let tmpToken = pTokens[i];

			if (i > 0)
			{
				let tmpPreviousToken = pTokens[i - 1];

				// Determine if we need a space before this token
				let tmpNeedSpace = true;

				// No space after opening paren
				if (tmpPreviousToken === '(')
				{
					tmpNeedSpace = false;
				}
				// No space before closing paren
				if (tmpToken === ')')
				{
					tmpNeedSpace = false;
				}
				// No space before opening paren when it follows a function name (not an operator or closing paren)
				if (tmpToken === '(' && !(tmpPreviousToken in this.ExpressionParser.tokenMap))
				{
					tmpNeedSpace = false;
				}
				// No space before comma
				if (tmpToken === ',')
				{
					tmpNeedSpace = false;
				}

				if (tmpNeedSpace)
				{
					tmpResult += ' ';
				}
			}

			tmpResult += tmpToken;
		}

		return tmpResult;
	}

	tokenize(pExpression, pResultObject)
	{
		let tmpResults = (typeof(pResultObject) === 'object') ? pResultObject : { ExpressionParserLog: [] };

		tmpResults.RawExpression = pExpression;
		tmpResults.SolverDirectives = {};
		tmpResults.RawTokens = [];
		tmpResults.ExpressionParserLog = [];

		if (typeof(pExpression) !== 'string')
		{
			this.log.warn('ExpressionParser.tokenize was passed a non-string expression.');
			return tmpResults.RawTokens;
		}

		/* Tokenize the expression
		 *
		 * Current token types:
		 * 	- Value
		 *    : could be a symbol representation e.g. "x", "depth", "Cost", etc. --- symbol representations are looked up first as manifest hashes
		 *    : could be a number e.g. "5", "3.14159", etc.
		 *    : could be a function name e.g. sin(x), sqrt(3+5) where sin or sqrt are known function names
		 *  - StateAddress
		 *    : these are always wrapped in squiggly brackets
		 *    : e.g. {Moisture.Percentage}, {Ending.Temperature.Fahrenheit}, {AppData.Download.Size}, etc.
		 *  - Token
		 *    : could be an operator e.g. "+", "-", "*", "/"
		 *    : could be a parenthesis e.g. "(", ")"
		 *  - String
		 *    : Wrapped in double quotes e.g. "Hello World", "This is a test", etc.
		 */
		/** @type {any} */
		let tmpCurrentTokenType = false;
		let tmpCurrentToken = '';
		for (let i = 0; i < pExpression.length; i++)
		{
			let tmpCharacter = pExpression[i];

			// [ WHITESPACE ]
			// 1. Space breaks tokens except when we're in an address that's been scoped by a {} or ""
			if ((tmpCharacter === ' ' || tmpCharacter === '\t') && ((tmpCurrentTokenType !== 'StateAddress') && (tmpCurrentTokenType !== 'String')))
			{
				if (tmpCurrentToken.length > 0)
				{
					tmpResults.RawTokens.push(tmpCurrentToken);
				}
				tmpCurrentToken = '';
				tmpCurrentTokenType = false;
				continue;
			}

			// [ STATE ADDRESS AND STRING BLOCKS ]
			// 2. If we're in an address, we keep going until we hit the closing brace
			if ((tmpCurrentTokenType === 'StateAddress') && (tmpCharacter !== '}'))
			{
				tmpCurrentToken += tmpCharacter;
				continue;
			}
			if ((tmpCurrentTokenType === 'String') && (tmpCharacter !== '"'))
			{
				tmpCurrentToken += tmpCharacter;
				continue;
			}
			// 3. If we're in an address and we hit the closing brace, we close the token, push it and reset
			if ((tmpCurrentTokenType === 'StateAddress') && (tmpCharacter === '}'))
			{
				tmpCurrentToken += tmpCharacter;
				tmpResults.RawTokens.push(tmpCurrentToken);
				tmpCurrentToken = '';
				tmpCurrentTokenType = false;
				continue;
			}
			if ((tmpCurrentTokenType === 'String') && (tmpCharacter === '"'))
			{
				tmpCurrentToken += tmpCharacter;
				tmpResults.RawTokens.push(tmpCurrentToken);
				tmpCurrentToken = '';
				tmpCurrentTokenType = false;
				continue;
			}
			// 4. If we're not in an address and we hit a closing brace it's a problem
			//    TODO: Should we just ignore it?  We do at the moment.
			if (tmpCharacter == '}')
			{
				if (tmpCurrentToken.length > 0)
				{
					tmpResults.RawTokens.push(tmpCurrentToken);
				}
				tmpCurrentToken = '';
				tmpCurrentTokenType = false;
				tmpResults.ExpressionParserLog.push(`ExpressionParser.tokenize found a closing brace without an opening brace in the expression: ${pExpression} at character index ${i}`);
				this.log.warn(tmpResults.ExpressionParserLog[tmpResults.ExpressionParserLog.length-1]);
				continue;
			}
			// 5. If we're not in an address and we hit an opening brace, we start an address
			if (tmpCharacter == '{')
			{
				if (tmpCurrentToken.length > 0)
				{
					tmpResults.RawTokens.push(tmpCurrentToken);
				}
				tmpCurrentToken = '';
				tmpCurrentTokenType = 'StateAddress';
				tmpCurrentToken = tmpCharacter;
				continue;
			}
			if ((tmpCurrentTokenType !== 'String') && (tmpCharacter == '"'))
			{
				if (tmpCurrentToken.length > 0)
				{
					tmpResults.RawTokens.push(tmpCurrentToken);
				}
				tmpCurrentToken = '';
				tmpCurrentTokenType = 'String';
				tmpCurrentToken = tmpCharacter;
				continue;
			}

			// [ TOKENS ]
			if (tmpCharacter in this.ExpressionParser.tokenRadix)
			{
				let tmpTokenRadix = this.ExpressionParser.tokenRadix[tmpCharacter];
				// If the token is a literal and has only one entry, it is a single character token and we can just safely add it.
				if (tmpTokenRadix.TokenCount == 1 && tmpTokenRadix.Literal)
				{
					if (tmpCurrentToken.length > 0)
					{
						tmpResults.RawTokens.push(tmpCurrentToken);
					}
					tmpCurrentToken = '';
					tmpCurrentTokenType = false;
					tmpResults.RawTokens.push(tmpCharacter);
					continue;
				}
				else
				{
					// This one has multiple options, so literals don't matter.  We need to check the token map.
					// The token radix TokenKeys array is sorted longest to shortest
					for (let j = 0; j < tmpTokenRadix.TokenKeys.length; j++)
					{
						let tmpTokenKey = tmpTokenRadix.TokenKeys[j];
						if (pExpression.substr(i, tmpTokenKey.length) == tmpTokenKey)
						{
							if (tmpCurrentToken.length > 0)
							{
								tmpResults.RawTokens.push(tmpCurrentToken);
							}
							tmpCurrentToken = '';
							tmpCurrentTokenType = false;
							tmpResults.RawTokens.push(tmpTokenKey);
							i += tmpTokenKey.length - 1;
							break;
						}
					}
					continue;
				}
			}

			// If it's not an operator, it's a number or address.
			// At the moment we aren't going to gate it on whether it's a valid address or not
			// Just treat anything not a known token on its own as a value identifier

			/* Per this stack overflow article: https://stackoverflow.com/questions/4434076/best-way-to-alphanumeric-check-in-javascript
			 * We could use a regex but it is slower than the charCodeAt method.
			 * This also doesn't solve the problem of unicode characters, but we won't support those for now.
			 */
			// if (pExpression.charAt(i) == '.')
			// {
			// 	console.log('Found a period')
			// }
			// let tmpCharCode = pExpression.charCodeAt(i);
			// // Match that the character code is any of...
			// if (
			// 	// Number [0-9]
			// 	(tmpCharCode > 47 && tmpCharCode < 58)
			// 	// Upper Case
			// 	|| (tmpCharCode > 64 && tmpCharCode < 91)
			// 	// LOWER CASE
			// 	|| (tmpCharCode > 96 && tmpCharCode < 123)
			// 	)
			// {

				// NOTE: Not having this guard makes a lot of interesting things possible.
			tmpCurrentTokenType = 'Value';
			tmpCurrentToken += tmpCharacter;
			// 	continue;
			// }

			// tmpResults.ExpressionParserLog.push(`ExpressionParser.tokenize found an unknown character code ${tmpCharCode} character ${tmpCharacter} in the expression: ${pExpression} at index ${i}`);
			// this.log.warn(tmpResults.ExpressionParserLog[tmpResults.ExpressionParserLog.length-1]);
		}

		if ((tmpCurrentTokenType) && (tmpCurrentToken.length > 0))
		{
			tmpResults.RawTokens.push(tmpCurrentToken);
		}

		tmpResults.OriginalRawTokens = Array.from(tmpResults.RawTokens);

		// Potentially mutate the tokens based on directives in the tokenized expression
		this.TokenizerDirectiveMutation.parseDirectives(tmpResults);

		return tmpResults.RawTokens;
	}
}

module.exports = ExpressionTokenizer;

},{"./Fable-Service-ExpressionParser-Base.js":77}],80:[function(require,module,exports){
module.exports={
	"sqrt": {
		"Name": "Square Root",
		"Address": "fable.Math.sqrtPrecise"
	},

	"percent": {
		"Name": "Compute Percent (in IS over OF format)",
		"Address": "fable.Math.percentagePrecise"
	},

	"compare": {
		"Name": "Compare",
		"Address": "fable.Math.comparePrecise"
	},

	"abs": {
		"Name": "Absolute Value",
		"Address": "fable.Math.absPrecise"
	},
	"floor": {
		"Name": "Floor Value",
		"Address": "fable.Math.floorPrecise"
	},
	"ceil": {
		"Name": "Ceiling Value",
		"Address": "fable.Math.ceilPrecise"
	},

	"rad": {
		"Name": "Degrees to Radians",
		"Address": "fable.Math.radPrecise"
	},

	"pi": {
		"Name": "Pi",
		"Address": "fable.Math.piPrecise"
	},
	"euler": {
		"Name": "Euler",
		"Address": "fable.Math.eulerPrecise"
	},

	"log": {
		"Name": "Logarithm",
		"Address": "fable.Math.logPrecise"
	},
	"exp": {
		"Name": "Eulers Number to the Power Of N",
		"Address": "fable.Math.expPrecise"
	},


	"sin": {
		"Name": "Sine",
		"Address": "fable.Math.sin"
	},
	"cos": {
		"Name": "Cosine",
		"Address": "fable.Math.cos"
	},
	"tan": {
		"Name": "Tangent",
		"Address": "fable.Math.tan"
	},

	"count": {
		"Name": "Count Set Elements",
		"Address": "fable.Math.countSetElements"
	},
	"countset": {
		"Name": "Count Set Elements",
		"Address": "fable.Math.countSetElements"
	},
	"sortset": {
		"Name": "Sort Set",
		"Address": "fable.Math.sortSetPrecise"
	},
	"bucketset": {
		"Name": "Bucket Set",
		"Address": "fable.Math.bucketSetPrecise"
	},
	"sorthistogram": {
		"Name": "Sort Histogram",
		"Address": "fable.Math.sortHistogramPrecise"
	},
	"sorthistogrambykeys": {
		"Name": "Sort Histogram by Keys",
		"Address": "fable.Math.sortHistogramByKeys"
	},

	"max": {
		"Name": "Maximum",
		"Address": "fable.Math.maxPrecise"
	},
	"min": {
		"Name": "Minimum",
		"Address": "fable.Math.minPrecise"
	},

	"sum": {
		"Name": "Sum",
		"Address": "fable.Math.sumPrecise"
	},

	"avg": {
		"Name": "Average",
		"Address": "fable.Math.averagePrecise"
	},
	"mean": {
		"Name": "Mean",
		"Address": "fable.Math.meanPrecise"
	},
	"median": {
		"Name": "Median",
		"Address": "fable.Math.medianPrecise"
	},
	"mode": {
		"Name": "Mode",
		"Address": "fable.Math.modePrecise"
	},
	"var": {
		"Name": "Variance (Sample)",
		"Address": "fable.Math.variancePrecise"
	},
	"vara": {
		"Name": "Variance (Sample)",
		"Address": "fable.Math.variancePrecise"
	},
	"varp": {
		"Name": "Variance (Population)",
		"Address": "fable.Math.populationVariancePrecise"
	},
	"stdev": {
		"Name": "Standard Deviation (Sample)",
		"Address": "fable.Math.standardDeviationPrecise"
	},
	"stdeva": {
		"Name": "Standard Deviation (Sample)",
		"Address": "fable.Math.standardDeviationPrecise"
	},
	"stdevp": {
		"Name": "Standard Deviation (Population)",
		"Address": "fable.Math.populationStandardDeviationPrecise"
	},
	"round": {
		"Name": "Round",
		"Address": "fable.Math.roundPrecise"
	},
	"tofixed": {
		"Name": "To Fixed",
		"Address": "fable.Math.toFixedPrecise"
	},

	"cumulativesummation": {
		"Name": "Sum each value in a Histogram or Value Map cumulatively, creating or setting a property with the result on each row",
		"Address": "fable.Math.cumulativeSummation"
	},

	"subtractingsummation": {
		"Name": "Subtract each subsequent value in a Histogram or Value Map cumulatively (by default from the first row), creating or setting a property with the result on each row.",
		"Address": "fable.Math.subtractingSummation"
	},

	"iterativeseries": {
		"Name": "Perform an Iterative Series of Mathematical Operations on Set Elements",
		"Address": "fable.Math.iterativeSeries"
	},

	"countsetelements": {
		"Name": "Count Set Elements in a Histogram or Value Map",
		"Address": "fable.Math.countSetElements"
	},

	"getvalue": {
		"Name": "Get Value from Application State or Services (AppData, etc.)",
		"Address": "fable.Utility.getInternalValueByHash",
		"AddressParameterIndices": [0]
	},

	"setvalue": {
		"Name": "Set Value to Application State or Services (AppData, etc.)",
		"Address": "fable.Utility.setInternalValueByHash",
		"AddressParameterIndices": [0]
	},

	"objectkeystoarray": {
		"Name": "Get Array of an Object's keys",
		"Address": "fable.Utility.objectKeysToArray"
	},
	"objectvaluestoarray": {
		"Name": "Get Array of an Object's values",
		"Address": "fable.Utility.objectValuesToArray"
	},
	"generatearrayofobjectsfromsets": {
		"Name": "Generate Array of Objects from Sets",
		"Address": "fable.Utility.generateArrayOfObjectsFromSets"
	},
	"objectvaluessortbyexternalobjectarray": {
		"Name": "Get Array of an Object's values sorted by an external array",
		"Address": "fable.Utility.objectValuesSortByExternalArray"
	},
	"setkeystoarray": {
		"Name": "Get Array of an Object's keys",
		"Address": "fable.Utility.objectKeysToArray"
	},
	"setvaluestoarray": {
		"Name": "Get Array of an Object's values",
		"Address": "fable.Utility.objectValuesToArray"
	},
	"histogramkeystoarray": {
		"Name": "Get Array of an Object's keys",
		"Address": "fable.Utility.objectKeysToArray"
	},
	"histogramvaluestoarray": {
		"Name": "Get Array of an Object's values",
		"Address": "fable.Utility.objectValuesToArray"
	},

	"createarrayfromabsolutevalues": {
		"Name": "Create Array from Absolute Values",
		"Address": "fable.Utility.createArrayFromAbsoluteValues"
	},

	"flatten": {
		"Name": "flatten an array of values",
		"Address": "fable.Utility.flattenArrayOfSolverInputs"
	},

	"findfirstvaluebyexactmatch": {
		"Name": "find + map on array of objects",
		"Address": "fable.Utility.findFirstValueByExactMatchInternal",
		"AddressParameterIndices": [0, 1, 3]
	},

	"findfirstvaluebystringincludes": {
		"Name": "find + map on array of objects",
		"Address": "fable.Utility.findFirstValueByStringIncludesInternal",
		"AddressParameterIndices": [0, 1, 3]
	},

	"match": {
		"Name": "Implementation of sheets MATCH() function",
		"Address": "fable.Utility.findIndexInternal",
		"AddressParameterIndices": [1]
	},

	"resolvehtmlentities": {
		"Name": "resolve HTML entities",
		"Address": "fable.DataFormat.resolveHtmlEntities"
	},

	"concat": {
		"Name": "concatenate an array of values and output a string",
		"Address": "fable.DataFormat.concatenateStringsInternal"
	},

	"concatraw": {
		"Name": "concatenate an array of values and output a string",
		"Address": "fable.DataFormat.concatenateStringsRawInternal"
	},

	"arrayconcat": {
		"Name": "concatenate two or more arrays generating a single output array",
		"Address": "fable.Utility.concatenateArrays"
	},

	"join": {
		"Name": "join an array of values and output a string",
		"Address": "fable.DataFormat.joinStringsInternal"
	},

	"joinraw": {
		"Name": "join an array of values and output a string",
		"Address": "fable.DataFormat.joinStringsRawInternal"
	},

	"if": {
		"Name": "perform a conditional operator on two values, and choose one of two outcomes based on the result",
		"Address": "fable.Logic.checkIf"
	},

	"when": {
		"Name": "perform a 'truthy' check on one value, and return one of two outcomes based on the result",
		"Address": "fable.Logic.when"
	},

	"ternary": {
		"Name": "numeric-aware ternary selection (used by ? :: operator desugaring)",
		"Address": "fable.Logic.ternary"
	},

	"entryinset": {
		"Name": "Entry in Set",
		"Address": "fable.Math.entryInSet"
	},
	"smallestinset": {
		"Name": "Smallest in Set",
		"Address": "fable.Math.smallestInSet"
	},
	"largestinset": {
		"Name": "Largest in Set",
		"Address": "fable.Math.largestInSet"
	},

	"aggregationhistogram": {
		"Name": "Generate a Histogram by Exact Value Aggregation",
		"Address": "fable.Math.histogramAggregationByExactValueFromInternalState"
	},
	"aggregationhistogrambyobject": {
		"Name": "Generate a Histogram by Exact Value Aggregation from Object Property",
		"Address": "fable.Math.histogramAggregationByExactValue"
	},
	"distributionhistogram": {
		"Name": "Generate a Histogram Based on Value Distribution",
		"Address": "fable.Math.histogramDistributionByExactValueFromInternalState"
	},
	"distributionhistogrambyobject": {
		"Name": "Generate a Histogram Based on Value Distribution from Object Property",
		"Address": "fable.Math.histogramDistributionByExactValue"
	},

	"setconcatenate": {
		"Name": "Set Concatenate",
		"Address": "fable.Math.setConcatenate"
	},

	"getvaluearray": {
		"Name": "Get Value Array from Application State or Services (AppData, etc.)",
		"Address": "fable.Utility.createValueArrayByHashParametersFromInternal",
		"AddressParameterIndices": [0, 1, 2, 3, 4, 5, 6, 7, 8, 9]
	},
	"getvalueobject": {
		"Name": "Get Value Object from Application State or Services (AppData, etc.)",
		"Address": "fable.Utility.createValueObjectByHashParametersFromInternal",
		"AddressParameterIndices": [0, 1, 2, 3, 4, 5, 6, 7, 8, 9]
	},

	"cleanvaluearray": {
		"Name": "Clean Value Array",
		"Address": "fable.Math.cleanValueArray"
	},
	"cleanvalueobject": {
		"Name": "Clean Value Object",
		"Address": "fable.Math.cleanValueObject"
	},

	"polynomialregression": {
		"Name": "Perform an nth degree Polynomial Regression on a Set of X and Y Values",
		"Address": "fable.Math.polynomialRegression"
	},

	"randominteger": {
		"Name": "Random Integer",
		"Address": "fable.DataGeneration.randomInteger"
	},
	"randomintegerbetween": {
		"Name": "Random Integer Between Two Numbers",
		"Address": "fable.DataGeneration.randomIntegerBetween"
	},
	"randomintegerupto": {
		"Name": "Random Integer",
		"Address": "fable.DataGeneration.randomIntegerUpTo"
	},
	"randomfloat": {
		"Name": "Random Float",
		"Address": "fable.DataGeneration.randomFloat"
	},
	"randomfloatbetween": {
		"Name": "Random Float",
		"Address": "fable.DataGeneration.randomFloatBetween"
	},
	"randomfloatupto": {
		"Name": "Random Float",
		"Address": "fable.DataGeneration.randomFloatUpTo"
	},

	"datemilliseconddifference": {
		"Name": "Date Difference in Milliseconds",
		"Address": "fable.Dates.dateMillisecondDifference"
	},
	"dateseconddifference": {
		"Name": "Date Difference in Seconds",
		"Address": "fable.Dates.dateSecondDifference"
	},
	"dateminutedifference": {
		"Name": "Date Difference in Minutes",
		"Address": "fable.Dates.dateMinuteDifference"
	},
	"datehourdifference": {
		"Name": "Date Difference in Hours",
		"Address": "fable.Dates.dateHourDifference"
	},
	"datedaydifference": {
		"Name": "Date Difference in Days",
		"Address": "fable.Dates.dateDayDifference"
	},
	"dateweekdifference": {
		"Name": "Date Difference in Weeks",
		"Address": "fable.Dates.dateWeekDifference"
	},
	"datemonthdifference": {
		"Name": "Date Difference in Months",
		"Address": "fable.Dates.dateMonthDifference"
	},
	"dateyeardifference": {
		"Name": "Date Difference in Years",
		"Address": "fable.Dates.dateYearDifference"
	},

	"datemathadd": {
		"Name": "Date Math Add",
		"Address": "fable.Dates.dateMath"
	},
	"dateaddmilliseconds": {
		"Name": "Date Add Milliseconds",
		"Address": "fable.Dates.dateAddMilliseconds"
	},
	"dateaddseconds": {
		"Name": "Date Add Seconds",
		"Address": "fable.Dates.dateAddSeconds"
	},
	"dateaddminutes": {
		"Name": "Date Add Minutes",
		"Address": "fable.Dates.dateAddMinutes"
	},
	"dateaddhours": {
		"Name": "Date Add Hours",
		"Address": "fable.Dates.dateAddHours"
	},
	"dateadddays": {
		"Name": "Date Add Days",
		"Address": "fable.Dates.dateAddDays"
	},
	"dateaddweeks": {
		"Name": "Date Add Weeks",
		"Address": "fable.Dates.dateAddWeeks"
	},
	"dateaddmonths": {
		"Name": "Date Add Months",
		"Address": "fable.Dates.dateAddMonths"
	},
	"dateaddyears": {
		"Name": "Date Add Years",
		"Address": "fable.Dates.dateAddYears"
	},

	"datefromparts": {
		"Name": "Date From Parts",
		"Address": "fable.Dates.dateFromParts"
	},

	"slice": {
		"Name": "Slice Array",
		"Address": "fable.Utility.slice"
	},

	"createvalueobjectbyhashes": {
		"Name": "Create Value Object by Hashes",
		"Address": "fable.Utility.createValueObjectByHashes",
		"AddressParameterIndices": [0, 1, 2, 3, 4, 5, 6, 7, 8, 9]
	},

	"slope": {
		"Name": "Slope of Linear Regression Line (Excel SLOPE equivalent)",
		"Address": "fable.Math.slopePrecise"
	},
	"intercept": {
		"Name": "Y-Intercept of Linear Regression Line (Excel INTERCEPT equivalent)",
		"Address": "fable.Math.interceptPrecise"
	},

	"leastsquares": {
		"Name": "Perform a Least Squares Regression on a Set of Independent Variable Vectors and a Dependent Variable Vector",
		"Address": "fable.Math.leastSquares"
	},
	"linest": {
		"Name": "Perform a Least Squares Regression on a Set of Independent Variable Vectors and a Dependent Variable Vector",
		"Address": "fable.Math.leastSquares"
	},

	"matrixtranspose": {
		"Name": "Transpose a Matrix",
		"Address": "fable.Math.matrixTranspose"
	},
	"matrixmultiply": {
		"Name": "Multiply Two Matrices",
		"Address": "fable.Math.matrixMultiply"
	},
	"matrixvectormultiply": {
		"Name": "Multiply a Matrix by a Vector",
		"Address": "fable.Math.matrixVectorMultiply"
	},
	"matrixinverse": {
		"Name": "Inverse a Matrix",
		"Address": "fable.Math.matrixInverse"
	},
	"gaussianelimination": {
		"Name": "Solve a System of Linear Equations using Gaussian Elimination",
		"Address": "fable.Math.gaussianElimination"
	},
	"predict": {
		"Name": "Predict Y Values from X Values using a Regression Model",
		"Address": "fable.Math.predictFromRegressionModel"
	},

	"stringcountsegments": {
		"Name": "Count Segments in a String",
		"Address": "fable.DataFormat.stringCountSegments"
	},
	"stringgetsegments": {
		"Name": "Get Segments from a String",
		"Address": "fable.DataFormat.stringGetSegments"
	},

	"bezierpoint": {
		"Name": "Evaluate a Point on a Cubic Bezier Curve at Parameter t",
		"Address": "fable.Math.bezierPoint"
	},
	"beziercurvefit": {
		"Name": "Fit a Cubic Bezier Curve to a Set of Data Points",
		"Address": "fable.Math.bezierCurveFit"
	},

	"generateguid": {
		"Name": "Generate a GUID string",
		"Address": "fable.getUUID"
	}
}

},{}],81:[function(require,module,exports){
const libExpressionParserOperationBase = require('./Fable-Service-ExpressionParser-Base.js');

class ExpressionParserLinter extends libExpressionParserOperationBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		this.serviceType = 'ExpressionParser-Linter';
	}

	lintTokenizedExpression(pTokenizedExpression, pResultObject)
	{
		let tmpResults = (typeof(pResultObject) === 'object') ? pResultObject : { ExpressionParserLog: [] };

		tmpResults.LinterResults = [];

		// Guard against bad data being passed in
		if (!Array.isArray(pTokenizedExpression))
		{
			tmpResults.ExpressionParserLog.push(`ERROR: ExpressionParser.lintTokenizedExpression was passed a non-array tokenized expression.`);
			tmpResults.LinterResults.push(tmpResults.ExpressionParserLog[tmpResults.ExpressionParserLog.length-1]);
			this.log.error(tmpResults.ExpressionParserLog[tmpResults.ExpressionParserLog.length-1]);
			return pTokenizedExpression;
		}
		if (pTokenizedExpression.length < 1)
		{
			tmpResults.ExpressionParserLog.push(`ERROR: ExpressionParser.lintTokenizedExpression was passed an empty tokenized expression.`);
			tmpResults.LinterResults.push(tmpResults.ExpressionParserLog[tmpResults.ExpressionParserLog.length-1]);
			this.log.error(tmpResults.ExpressionParserLog[tmpResults.ExpressionParserLog.length-1]);
			return pTokenizedExpression;
		}

		// 1. Check for balanced parenthesis
		let tmpParenthesisDepth = 0;
		// If it is in a state address, we don't care about the parenthesis
		// State addresses are between squiggly brackets
		let tmpInStateAddress = false;
		for (let i = 0; i < pTokenizedExpression.length; i++)
		{
			if ((pTokenizedExpression[i] === '(') && (!tmpInStateAddress))
			{
				tmpParenthesisDepth++;
			}
			if ((pTokenizedExpression[i] === ')') && (!tmpInStateAddress))
			{
				tmpParenthesisDepth--;
			}

			if (pTokenizedExpression[i] === '{')
			{
				tmpInStateAddress = true;
			}
			if (pTokenizedExpression[i] === '}')
			{
				tmpInStateAddress = false;
			}

			if (tmpParenthesisDepth < 0)
			{
				tmpResults.ExpressionParserLog.push(`ERROR: ExpressionParser.lintTokenizedExpression found an unbalanced parenthesis in the tokenized expression at token index ${i}`);
				tmpResults.LinterResults.push(tmpResults.ExpressionParserLog[tmpResults.ExpressionParserLog.length-1]);
				this.log.error(tmpResults.ExpressionParserLog[tmpResults.ExpressionParserLog.length-1]);
			}
		}
		if (tmpParenthesisDepth > 0)
		{
			// TODO: Should we add the closing parenthesis?
			tmpResults.ExpressionParserLog.push(`WARNING: ExpressionParser.lintTokenizedExpression found an unbalanced parenthesis in the tokenized expression (ended without closing last set of parenthesis) -- appropriate closing parenthesis will be added.`);
			tmpResults.LinterResults.push(tmpResults.ExpressionParserLog[tmpResults.ExpressionParserLog.length-1]);
			this.log.warn(tmpResults.ExpressionParserLog[tmpResults.ExpressionParserLog.length-1]);
		}

		// 2. Check for balanced squiggly braces
		tmpInStateAddress = false;

		for (let i = 0; i < pTokenizedExpression.length; i++)
		{
			if (pTokenizedExpression[i] === '{')
			{
				tmpInStateAddress = true;
			}
			if ((pTokenizedExpression[i] === '}') && (tmpInStateAddress))
			{
				tmpInStateAddress = false;
			}
			if ((pTokenizedExpression[i] === '}') && (!tmpInStateAddress))
			{
				tmpResults.ExpressionParserLog.push(`ERROR: ExpressionParser.lintTokenizedExpression found an unbalanced closing squiggly brace "}" in the tokenized expression at token index ${i}`);
				tmpResults.LinterResults.push(tmpResults.ExpressionParserLog[tmpResults.ExpressionParserLog.length-1]);
				this.log.error(tmpResults.ExpressionParserLog[tmpResults.ExpressionParserLog.length-1]);
			}

			if (tmpInStateAddress)
			{
				tmpResults.ExpressionParserLog.push(`WARNING: ExpressionParser.lintTokenizedExpression found an open squiggly brace in the tokenized expression at index ${i}`);
				tmpResults.LinterResults.push(tmpResults.ExpressionParserLog[tmpResults.ExpressionParserLog.length-1]);
				this.log.warn(tmpResults.ExpressionParserLog[tmpResults.ExpressionParserLog.length-1]);
			}
		}

		// 3. Check for an equality assignment
		let tmpEqualityAssignmentCount = 0;
		let tmpEqualityAssignmentIndex = false;
		for (let i = 0; i < pTokenizedExpression.length; i++)
		{
			if ((this.ExpressionParser.tokenMap[pTokenizedExpression[i]]) && (this.ExpressionParser.tokenMap[pTokenizedExpression[i]].Type === 'Assignment'))
			{
				tmpEqualityAssignmentCount++;
				tmpEqualityAssignmentIndex = i;

				if (tmpEqualityAssignmentCount > 1)
				{
					tmpResults.ExpressionParserLog.push(`ERROR: ExpressionParser.lintTokenizedExpression found multiple equality assignments in the tokenized expression; equality assignment #${tmpEqualityAssignmentCount} operator '${pTokenizedExpression[i]}' at token index ${i}.`);
					tmpResults.LinterResults.push(tmpResults.ExpressionParserLog[tmpResults.ExpressionParserLog.length-1]);
					this.log.error(tmpResults.ExpressionParserLog[tmpResults.ExpressionParserLog.length-1]);
				}
			}
		}
		if (tmpEqualityAssignmentCount < 1)
		{
			tmpResults.ExpressionParserLog.push(`WARNING: ExpressionParser.lintTokenizedExpression found no equality assignment in the tokenized expression.  One called Result will be added automatically.`);
			tmpResults.LinterResults.push(tmpResults.ExpressionParserLog[tmpResults.ExpressionParserLog.length-1]);
			//this.log.warn(tmpResults.ExpressionParserLog[tmpResults.ExpressionParserLog.length-1]);
		}

		// 4. Make sure the equality assignment only has a single value on the other side of it
		//    (no, this is not a magical algebraic solver, do your own simplification)
		//    IF there is only one equality assignment (otherwise we don't even lint this because it's syntax errors all the way down)
		if (tmpEqualityAssignmentCount === 1)
		{
			// If there are exactly three tokens, make sure at least one is an assignable-ish address
			// This can still fail, but we aren't linting all the way into the manifest here; just the expression
			if (pTokenizedExpression.length === 3)
			{
				if (
					// The first token in our expression is a potentially assignable symbol
					(this.getTokenType(pTokenizedExpression[0]) === 'Token.StateAddress') || (this.getTokenType(pTokenizedExpression[2]) === 'Token.Symbol')
					// NOTE: For now we are only going to support assignment to the first symbol in the expression, which seems okay.
					// OR the last token in our expression is a potentially assignable symbol
					//|| (this.getTokenType(pTokenizedExpression[2]) === 'Token.StateAddress') || (this.getTokenType(pTokenizedExpression[0]) === 'Token.Symbol')
					)
				{
					tmpResults.ExpressionParserLog.push(`WARNING: ExpressionParser.lintTokenizedExpression found a single equality assignment in the tokenized expression with no assignable address on the left side of the assignment.`);
					tmpResults.LinterResults.push(tmpResults.ExpressionParserLog[tmpResults.ExpressionParserLog.length-1]);
					this.log.warn(tmpResults.ExpressionParserLog[tmpResults.ExpressionParserLog.length-1]);
				}
			}
		}

		// 5. Check that there are no operators adjacent to each other
		//    This is a simple lint check, not a full-blown syntax check
		let tmpTokenPrevious = false;
		for (let i = 0; i < pTokenizedExpression.length - 1; i++)
		{
			if ((pTokenizedExpression[i] in this.ExpressionParser.tokenMap) && (this.ExpressionParser.tokenMap[pTokenizedExpression[i]].Type != 'Parenthesis') && !tmpTokenPrevious)
			{
				tmpTokenPrevious = true;
			}
			else if ((pTokenizedExpression[i] in this.ExpressionParser.tokenMap) && (this.ExpressionParser.tokenMap[pTokenizedExpression[i]].Type != 'Parenthesis'))
			{
				// If this isn't a + or - positivity/negativity multiplier, it's an error.
				if ((pTokenizedExpression[i] !== '+') && (pTokenizedExpression[i] !== '-'))
				{
					tmpResults.ExpressionParserLog.push(`ERROR: ExpressionParser.lintTokenizedExpression found an ${pTokenizedExpression[i]} operator adjacent to another operator in the tokenized expression at token index ${i}`);
					tmpResults.LinterResults.push(tmpResults.ExpressionParserLog[tmpResults.ExpressionParserLog.length-1]);
					this.log.error(tmpResults.ExpressionParserLog[tmpResults.ExpressionParserLog.length-1]);
				}
			}
			else
			{
				tmpTokenPrevious = false;
			}
		}

		return tmpResults.LinterResults;
	}
}

module.exports = ExpressionParserLinter;

},{"./Fable-Service-ExpressionParser-Base.js":77}],82:[function(require,module,exports){
const { PE } = require('big.js');
const libExpressionParserOperationBase = require('./Fable-Service-ExpressionParser-Base.js');

/**
 * Represents a user-friendly messaging service for the ExpressionParser compiler output.
 * @class ExpressionParserMessaging
 * @extends libExpressionParserOperationBase
 */
class ExpressionParserMessaging extends libExpressionParserOperationBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		this.serviceType = 'ExpressionParser-Messaging';
	}

	getOperationVirtualSymbolName(pOperationToken)
	{
		return (pOperationToken && ('VirtualSymbolName' in pOperationToken)) ? pOperationToken.VirtualSymbolName 
			: (pOperationToken.Type === 'Token.VirtualSymbol') ? pOperationToken.Token
			: 'NO_VIRTUAL_SYMBOL_NAME_FOUND';
	}

	getVirtualTokenValue(pToken, pOperationResults)
	{
		let tmpVirtualSymbol = this.getOperationVirtualSymbolName(pToken);

		if ((pToken.Type == 'Token.Symbol' || pToken.Type == 'Token.Constant') && (pToken.Value))
		{
			return pToken.Value.toString();
		}

		let tmpVirtualSymbolData = ('VirtualSymbols' in pOperationResults) ? pOperationResults.VirtualSymbols : {};

		if (this.ExpressionParser.GenericManifest.checkAddressExists(tmpVirtualSymbolData, tmpVirtualSymbol))
		{
			let tmpValue = this.ExpressionParser.GenericManifest.getValueAtAddress(tmpVirtualSymbolData, tmpVirtualSymbol);

			if (typeof(tmpValue) === 'object')
			{
				return `{${Object.keys(tmpValue).length} values}`;
			}
			if (Array.isArray(tmpValue))
			{
				return `[${Object.keys(tmpValue).length} values]`;
			}
			return tmpValue;
		}

		return 'NO_VALUE_FOUND';
	}

	getTokenAddressString(pToken)
	{
		return pExpression.Token;
	}

	getTokenSymbolString(pExpressionToken)
	{
		return pExpressionToken.Token;
	}

	getOperationSymbolMessage(pOperation)
	{
		if (!pOperation)
		{
			return 'INVALID_OPERATION';
		}
		let tmpOperationVirtualSymbol = this.getOperationVirtualSymbolName(pOperation);
		let tmpOperationLeftValue = this.getTokenSymbolString(pOperation.LeftValue);
		let tmpOperationSymbol = this.getTokenSymbolString(pOperation.Operation);
		let tmpOperationRightValue = this.getTokenSymbolString(pOperation.RightValue);

		let tmpVirtualSymbolPrefix = tmpOperationVirtualSymbol.substring(0, 3);

		if (tmpOperationSymbol === '=')
		{
			// Assignment operators are special
			return `${tmpOperationVirtualSymbol} = ${tmpOperationLeftValue}`;
		}

		if (tmpVirtualSymbolPrefix === 'VFE')
		{
			// Virtual Function Expression
			return `${tmpOperationVirtualSymbol} = ${tmpOperationSymbol}(${tmpOperationLeftValue})`;
		}

		return `${tmpOperationVirtualSymbol} = ${tmpOperationLeftValue} ${tmpOperationSymbol} ${tmpOperationRightValue}`;
	}

	getOperationValueMessage(pOperation, pResultObject)
	{
		if (!pOperation)
		{
			return 'INVALID_OPERATION';
		}
		let tmpOperationVirtualSymbol = this.getOperationVirtualSymbolName(pOperation);
		let tmpOperationLeftValue = this.getVirtualTokenValue(pOperation.LeftValue, pResultObject);
		let tmpOperationSymbol = this.getTokenSymbolString(pOperation.Operation);
		let tmpOperationRightValue = this.getVirtualTokenValue(pOperation.RightValue, pResultObject);

		let tmpVirtualSymbolPrefix = tmpOperationVirtualSymbol.substring(0, 3);

		if (tmpOperationSymbol === '=')
		{
			// Assignment operators are special
			return `${tmpOperationVirtualSymbol} = ${tmpOperationLeftValue}`;
		}

		if (tmpVirtualSymbolPrefix === 'VFE')
		{
			// Virtual Function Expression
			return `${tmpOperationVirtualSymbol} = ${tmpOperationSymbol}(${tmpOperationLeftValue})`;
		}

		return `${tmpOperationVirtualSymbol} = ${tmpOperationLeftValue} ${tmpOperationSymbol} ${tmpOperationRightValue}`;
	}

	getOperationOutcomeMessage(pToken, pOperationResults)
	{
		if (!pToken)
		{
			return 'INVALID_TOKEN';
		}
		let tmpOperationVirtualSymbol = this.getOperationVirtualSymbolName(pToken);
		let tmpOperationOutcomeValue = this.getVirtualTokenValue(pToken, pOperationResults);

		return `${tmpOperationVirtualSymbol} = ${tmpOperationOutcomeValue}`;
	}

	logFunctionOutcome(pResultObject)
	{
		if (typeof(pResultObject) !== 'object')
		{
			this.log.error(`Solver results object was not an object.  Cannot log outcome.`);
			return;
		}
		let tmpAssignmentAddress = ('PostfixedAssignmentAddress' in pResultObject) ? pResultObject.PostfixedAssignmentAddress : 'NO_ASSIGNMENT_ADDRESS_FOUND';
		let tmpRawExpression = ('RawExpression' in pResultObject) ? pResultObject.RawExpression : 'NO_EXPRESSION_FOUND';
		let tmpRawResult = ('RawResult' in pResultObject) ? pResultObject.RawResult : 'NO_RESULT_FOUND';

		this.log.info(`Solved f(${tmpAssignmentAddress}) = {${tmpRawExpression}}`);
		for (let i = 0; i < pResultObject.PostfixSolveList.length; i++)
		{
			let tmpToken = pResultObject.PostfixSolveList[i];
			let tmpTokenSymbolMessage = this.getOperationSymbolMessage(tmpToken);
			this.log.info(`${i} Symbols: ${tmpTokenSymbolMessage}`);
			let tmpTokenValueMessage = this.getOperationValueMessage(tmpToken, pResultObject);
			this.log.info(`${i}  Values: ${tmpTokenValueMessage}`);
			let tmpTokenOutcome = this.getOperationOutcomeMessage(tmpToken, pResultObject);
			this.log.info(`${i} Outcome: ${tmpTokenOutcome}`);
		}
		this.log.info(`{${tmpRawExpression}} = ${tmpRawResult}`);
	}

	logFunctionSolve(pResultObject)
	{
		if (typeof(pResultObject) !== 'object')
		{
			this.log.error(`Solver results object was not an object.  Cannot log the solve.`);
			return;
		}
		if (!('PostfixSolveList' in pResultObject) || !Array.isArray(pResultObject.PostfixSolveList))
		{
			this.log.error(`Solver results object did not contain a PostfixSolveList array.  Cannot log the solve.`);
			return;
		}

		for (let i = 0; i < pResultObject.PostfixSolveList.length; i++)
		{
			let tmpToken = pResultObject.PostfixSolveList[i];
			console.log(`${i}: ${tmpToken.VirtualSymbolName} = (${tmpToken.LeftValue.Token}::${tmpToken.LeftValue.Value})  ${tmpToken.Operation.Token}  (${tmpToken.RightValue.Token}::${tmpToken.RightValue.Value}) `)
		}

		this.logFunctionOutcome(pResultObject);
	}
}

module.exports = ExpressionParserMessaging;

},{"./Fable-Service-ExpressionParser-Base.js":77,"big.js":17}],83:[function(require,module,exports){
const libExpressionParserOperationBase = require('./Fable-Service-ExpressionParser-Base.js');

class ExpressionParserPostfix extends libExpressionParserOperationBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		this.serviceType = 'ExpressionParser-Postfix';
	}

	getPosfixSolveListOperation(pOperation, pLeftValue, pRightValue, pDepthSolveList, pDepthSolveIndex)
	{
		let tmpOperation = ({
			VirtualSymbolName: pOperation.VirtualSymbolName,
			Operation: pOperation,
			LeftValue: pLeftValue,
			RightValue: pRightValue
		});

		let tmpDepthSolveList = Array.isArray(pDepthSolveList) ? pDepthSolveList : false;

		/* These two if blocks are very complex -- they basically provide a
		 * way to deal with recursion that can be expressed to the user in
		 * a meaningful way.
		 * 
		 * The reason we are doing it as such is to show exactly how the
		 * solver resolves the passed-in tokens into a solvable expression.
		 */
		if (!tmpOperation.LeftValue.VirtualSymbolName)
		{
			tmpOperation.LeftValue.VirtualSymbolName = tmpOperation.VirtualSymbolName;
		}
		else
		{
			// We need to set the left value to a virtual symbol instead of the looked up value if it's already used in another operation
			if ('LeftVirtualSymbolName' in tmpOperation.Operation)
			{
				tmpOperation.LeftValue = this.getTokenContainerObject(tmpOperation.Operation.LeftVirtualSymbolName, 'Token.VirtualSymbol');
			}
			else
			{
				tmpOperation.LeftValue = this.getTokenContainerObject(tmpOperation.LeftValue.VirtualSymbolName, 'Token.VirtualSymbol');
			}
		}
		if (!tmpOperation.RightValue.VirtualSymbolName)
		{
			tmpOperation.RightValue.VirtualSymbolName = tmpOperation.VirtualSymbolName;
		}
		else
		{
			// We need to set the right value to a virtual symbol instead of the looked up value if it's already used in another operation
			//if ('LeftVirtualSymbolName' in tmpOperation.RightValue)
			if ('RightVirtualSymbolName' in tmpOperation.Operation)
			{
				tmpOperation.RightValue = this.getTokenContainerObject(tmpOperation.Operation.RightVirtualSymbolName, 'Token.VirtualSymbol');
			}
			else
			{
				tmpOperation.RightValue = this.getTokenContainerObject(tmpOperation.RightValue.VirtualSymbolName, 'Token.VirtualSymbol');
			}
		}

		tmpOperation.Operation.Parsed = true;

		return tmpOperation;
	}

	buildPostfixedSolveList(pTokenizedExpression, pResultObject)
	{
		let tmpResults = (typeof(pResultObject) === 'object') ? pResultObject : { ExpressionParserLog: [] };

		tmpResults.PostfixedAssignmentAddress = 'Result'
		tmpResults.PostfixedAssignmentOperator = this.ExpressionParser.tokenMap['=']; // This is the default assignment operator
		tmpResults.PostfixTokenObjects = [];
		tmpResults.PostfixSolveList = [];

		if (pTokenizedExpression.length < 3)
		{
			tmpResults.ExpressionParserLog.push(`ERROR: ExpressionParser.buildPostfixedSolveList was passed a tokenized expression with less than three tokens.`);
			this.log.error(tmpResults.ExpressionParserLog[tmpResults.ExpressionParserLog.length-1]);
			return tmpResults.PostfixTokenObjects;
		}

		// 1. Figure out the Equality Assignment
		let tmpEqualsIndex = -1;
		for (let i = 0; i < pTokenizedExpression.length; i++)
		{
			if ((this.ExpressionParser.tokenMap[pTokenizedExpression[i]]) && (this.ExpressionParser.tokenMap[pTokenizedExpression[i]].Type === 'Assignment'))
			{
				if (tmpEqualsIndex < 0)
				{
					tmpEqualsIndex = i;
					tmpResults.PostfixedAssignmentOperator = this.ExpressionParser.tokenMap[pTokenizedExpression[i]];
				}
				else
				{
					tmpResults.ExpressionParserLog.push(`ERROR: ExpressionParser.buildPostfixedSolveList found multiple assignment operators in the tokenized expression; assignment operator '${pTokenizedExpression[i]}' #${tmpEqualsIndex} at token index ${i}.`);
					this.log.error(tmpResults.ExpressionParserLog[tmpResults.ExpressionParserLog.length-1]);
					return tmpResults.PostfixTokenObjects;
				}
			}
		}

		if (tmpEqualsIndex == -1)
		{
			tmpResults.ExpressionParserLog.push(`WARNING: ExpressionParser.buildPostfixedSolveList found no equality assignment in the tokenized expression; defaulting to Result`);
			//this.log.warn(tmpResults.ExpressionParserLog[tmpResults.ExpressionParserLog.length-1]);
		}
		else if (tmpEqualsIndex > 1)
		{
			tmpResults.ExpressionParserLog.push(`WARNING: ExpressionParser.buildPostfixedSolveList found an equality assignment in the tokenized expression at an unexpected location (token index ${tmpEqualsIndex}); the expression cannot be parsed.`);
			this.log.warn(tmpResults.ExpressionParserLog[tmpResults.ExpressionParserLog.length-1]);
		}
		else if (tmpEqualsIndex === 0)
		{
			// This is an implicit function -- just go to result and return the value.
			// That is... the user entered something like "= 5 + 3" so we should just return 8, and use the default Result quietly.
		}
		else
		{
			tmpResults.PostfixedAssignmentAddress = pTokenizedExpression[0];
		}

		// 2. Categorize tokens in the expression, put them in the "expression list" as a token object
		for (let i = tmpEqualsIndex + 1; i < pTokenizedExpression.length; i++)
		{
			tmpResults.PostfixTokenObjects.push(this.getTokenContainerObject(pTokenizedExpression[i]));
		}

		// 3. Decorate mathematical parsing depth and detect functions at the same time
		//    Having written this a few times now, it's easier to detect functions *while* parsing depth.
		//    Especially if we want our system to be able to communicate with the user when there is an issue.
		let tmpDepth = 0;
		// The virtual symbol index is used for the abstract interim values that are generated at each step of the solve
		let tmpVirtualParenthesisIndex = 0;
		let tmpSolveLayerStack = [];
		// Kick off the solve layer stack with the first solve set identifier
		tmpSolveLayerStack.push(`SolveSet_${tmpVirtualParenthesisIndex}_D_${tmpDepth}`);
		for (let i = 0; i < tmpResults.PostfixTokenObjects.length; i++)
		{
			// 1. If it's an open parenthesis, set the parenthesis at the current depth and increment the depth
			if (tmpResults.PostfixTokenObjects[i].Token === '(')
			{
				// Set the depth of the open parenthesis to the current solution depth
				tmpResults.PostfixTokenObjects[i].Depth = tmpDepth;
				// Generate the virtual symbol name for user output
				tmpResults.PostfixTokenObjects[i].VirtualSymbolName = `Pr_${tmpVirtualParenthesisIndex}_D_${tmpDepth}`;

				// 1a. Detect if this parenthesis is signaling a function
				//     If the previous token is a Symbol (e.g. it say sin(x) or sqrt(3+5) or something) then the parser will interpret it as a function
				if (i > 0)
				{
					if (tmpResults.PostfixTokenObjects[i-1].Type === 'Token.Symbol')
					{
						// Set the type of this to be a function
						tmpResults.PostfixTokenObjects[i-1].Type = 'Token.Function';
					}
				}

				// Parenthesis manage the solve layer stack
				// For adding a new parenthesis solve layer, we put the parenthesis in the stack we are in and then make all the contained tokens be within the stack of the parenthesis
				tmpResults.PostfixTokenObjects[i].SolveLayerStack = tmpSolveLayerStack[tmpSolveLayerStack.length-1];
				tmpSolveLayerStack.push(tmpResults.PostfixTokenObjects[i].VirtualSymbolName);

				tmpVirtualParenthesisIndex++;
				tmpDepth++;
			}

			// 2. If it's a closed parenthesis, decrease the depth
			else if (tmpResults.PostfixTokenObjects[i].Token === ')')
			{
				tmpDepth--;

				tmpResults.PostfixTokenObjects[i].Depth = tmpDepth;

				// Check to see that the depth of the closed parenthesis is greater than 0
				if (tmpDepth < 0)
				{
					tmpResults.ExpressionParserLog.push(`ERROR: ExpressionParser.buildPostfixedSolveList found a closing parenthesis at token index ${i} with no corresponding opening parenthesis.`);
					this.log.error(tmpResults.ExpressionParserLog[tmpResults.ExpressionParserLog.length-1]);
				}

				// Parenthesis manage the solve layer stack
				// For closing parenthesis solve layer with a close paren, we put it in the same stack as the opening parenthesis.
				// Give the closing parenthesis the same virtual symbol name as the opening parenthesis
				// (do the both above at the same time)
				tmpResults.PostfixTokenObjects[i].VirtualSymbolName = tmpSolveLayerStack.pop();
				tmpResults.PostfixTokenObjects[i].SolveLayerStack = tmpSolveLayerStack[tmpSolveLayerStack.length-1];
			}
			else
			{
				tmpResults.PostfixTokenObjects[i].Depth = tmpDepth;
				tmpResults.PostfixTokenObjects[i].SolveLayerStack = tmpSolveLayerStack[tmpSolveLayerStack.length-1];
			}
		}

		// 4. Walk through the decorated symbols and generate the postfix solve list
		//    We are going to start by creating a map of the solve layers:
		let tmpSolveLayerMap = {};
		let tmpSolveLayerMaxDepth = 0;
		for (let i = 0; i < tmpResults.PostfixTokenObjects.length; i++)
		{
			if (!(tmpResults.PostfixTokenObjects[i].SolveLayerStack in tmpSolveLayerMap))
			{
				tmpSolveLayerMap[tmpResults.PostfixTokenObjects[i].SolveLayerStack] = [];
			}
			tmpSolveLayerMap[tmpResults.PostfixTokenObjects[i].SolveLayerStack].push(tmpResults.PostfixTokenObjects[i]);

			// See what our max depth is.  This is super important to the postfix operation
			// The programmer in me thinks it would be funny to not track this and just use the map key length as the max size, which would work (logically impossible to have a depth > key length) but it would be quite a bit more confusing to grok the algorithm.
			if (tmpResults.PostfixTokenObjects[i].Depth > tmpSolveLayerMaxDepth)
			{
				tmpSolveLayerMaxDepth = tmpResults.PostfixTokenObjects[i].Depth;
			}
		}

		let tmpSolveLayerKeys = Object.keys(tmpSolveLayerMap);
		// Reset the virtual symbol index -- it was used above for uniquenes when creating abstract symbols for parenthesis and layer stacks.
		let tmpVirtualSymbolIndex = 0;
		tmpSolveLayerKeys.sort(
			// Sort the solve layers by depth.
			(pLeftLayer, pRightLayer)=>
			{
				// It is impossible to have a layer with no entries in it.  
				// If that ever happens, the bug is actually above and we actively want this to blow up.
				if (tmpSolveLayerMap[pLeftLayer][0].Depth < tmpSolveLayerMap[pRightLayer][0].Depth)
				{
					return 1;
				}
				if (tmpSolveLayerMap[pLeftLayer][0].Depth > tmpSolveLayerMap[pRightLayer][0].Depth)
				{
					return -1;
				}
				return 0;
			});

		// 5. Generate the postfix solve list
		//    The most important thing is going backwards in the depth order (a la reverse polish).
		//    Specifically not using shunting yard to provide in-depth "show your work" notes
		//    Yes it is possible to do a somewhat similar thing with shunting yard but the code is almost unreadable

		// 5.1 Build the Virtual Symbol Names
		// This maps layer stack addresses (which match parenthesis virtual symbol names) to the resultant value for that layer stack.
		// These values change as it solves but the last assignment is the proper assignment because math only reads forward in a line
		tmpResults.PostfixLayerstackMap = {};
		//FIXME: vet these - do we need a suffix version?
		const unaryEligibleOperationTokens = [ '+', '-' ];
		const unaryOperationPrefixTriggerTypes = [ 'Token.Operator', 'Token.Assignment' ];
		for (let tmpSolveLayerIndex = 0; tmpSolveLayerIndex < tmpSolveLayerKeys.length; tmpSolveLayerIndex++)
		{
			let tmpSolveLayerTokens = tmpSolveLayerMap[tmpSolveLayerKeys[tmpSolveLayerIndex]];
			// For each precedence (this isn't strictly required here but makes the outcome for the user more readable)
			for (let tmpPrecedence = 0; tmpPrecedence <= this.ExpressionParser.tokenMaxPrecedence; tmpPrecedence++)
			{
				// Enumerate all tokens in a layer's expression.
				// There is a recursive way to do this, but given the short length of even the most complex equations we're favoring readability.
				for (let i = 0; i < tmpSolveLayerTokens.length; i++)
				{
					const tmpToken = tmpSolveLayerTokens[i];
					if (unaryEligibleOperationTokens.includes(tmpToken.Token) &&
					// promote to unary if:
					// 1. we are the first token in our group
					// 2. we are prefixed by a token type that is incompatible with us being binary
						(i == 0 || unaryOperationPrefixTriggerTypes.includes(tmpSolveLayerTokens[i - 1].Type)))
					{
						//FIXME: slow, but don't break the static data
						tmpToken.Descriptor = JSON.parse(JSON.stringify(tmpToken.Descriptor));
						tmpToken.Descriptor.Precedence = 1;
					}
					//FIXME: handle operators with dynamic precedence (ex. unary vs. bunary + and -)
					// If the token is an operator and at the current precedence, add it to the postfix solve list and mutate the array.
					if ((tmpSolveLayerTokens[i].Type === 'Token.Operator') &&
						(tmpToken.Descriptor.Precedence === tmpPrecedence))
					{
						// If there is a token and nothing else in this layer, then it's an error.
						if (tmpSolveLayerTokens.length === 1)
						{
							tmpResults.ExpressionParserLog.push(`ERROR: ExpressionParser.buildPostfixedSolveList found a single operator in a solve layer expression at token index ${i}`);
							this.log.error(tmpResults.ExpressionParserLog[tmpResults.ExpressionParserLog.length-1]);
							return tmpResults.PostfixSolveList;
						}
						// The - at the beginning of an expression is a number line orientation modifier
						else if ((i == 0) && (tmpToken.Token == '-' || tmpToken.Token == '+'))
						{
							tmpToken.VirtualSymbolName = `VNLO_${tmpVirtualSymbolIndex}`;
							tmpResults.PostfixLayerstackMap[tmpToken.SolveLayerStack] = tmpToken.VirtualSymbolName;
							tmpVirtualSymbolIndex++;
						}
						// If the token is at the beginning of the expression and not a number line orientation modifier, it's an error.
						else if ((i == 0) && ((tmpToken.Token != '+') || (tmpToken.Token != '-')))
						{
							tmpResults.ExpressionParserLog.push(`ERROR: ExpressionParser.buildPostfixedSolveList found an operator at the beginning of a solve layer expression at token index ${i}`);
							this.log.error(tmpResults.ExpressionParserLog[tmpResults.ExpressionParserLog.length-1]);
							return tmpResults.PostfixSolveList;
						}
						// If the token is at the end of the expression, it is an error.
						else if (i == tmpSolveLayerTokens.length - 1)
						{
							tmpResults.ExpressionParserLog.push(`ERROR: ExpressionParser.buildPostfixedSolveList found an operator at the end of a solve layer expression at token index ${i}`);
							this.log.error(tmpResults.ExpressionParserLog[tmpResults.ExpressionParserLog.length-1]);
							return tmpResults.PostfixSolveList;
						}

						// The - after an operator or an open parenthesis is also a number line orientation modifier
						else if ((i > 0) && (tmpToken.Token == '-') && ((tmpSolveLayerTokens[i-1].Type === 'Token.Operator') || (tmpSolveLayerTokens[i-1].Token === '(')))
						{
							// The number line negation operator is a special case that generates a virtual constant (-1.0) and multiplies it by the next token
							tmpToken.VirtualSymbolName = `VNLO_${tmpVirtualSymbolIndex}`;
							tmpVirtualSymbolIndex++;
						}
						// The + at the beginning is also a number line orientation modifier ... THAT WE IGNORE
						else if ((i == 0) && (tmpToken.Token == '+'))
						{
							continue;
						}
						// The + after an operator or a parenthesis is also a number line orientation modifier ... THAT WE IGNORE
						else if ((i > 0) && (tmpToken.Token == '+') && ((tmpSolveLayerTokens[i-1].Type === 'Token.Operator') || (tmpSolveLayerTokens[i-1].Token === '(')))
						{
							continue;
						}

						// If the token is next to another operator it's a parsing error
						else if (((tmpSolveLayerTokens[i-1].Type === 'Token.Operator') || (tmpSolveLayerTokens[i+1].Type === 'Token.Operator')) &&
								(tmpSolveLayerTokens[i+1].Token != '-' && tmpSolveLayerTokens[i+1].Token != '+'))
						{
							tmpResults.ExpressionParserLog.push(`ERROR: ExpressionParser.buildPostfixedSolveList found an operator at token index ${i} that is not surrounded by two values.`);
							this.log.error(tmpResults.ExpressionParserLog[tmpResults.ExpressionParserLog.length-1]);
							return tmpResults.PostfixSolveList;
						}

						// Finally add a virtual symbol name to the dang thing.
						else
						{
							tmpToken.VirtualSymbolName = `V_${tmpVirtualSymbolIndex}`;
							tmpResults.PostfixLayerstackMap[tmpToken.SolveLayerStack] = tmpToken.VirtualSymbolName;
							tmpVirtualSymbolIndex++;
						}
					}
					else if ((tmpSolveLayerTokens[i].Type === 'Token.Function') && (tmpPrecedence === 0))
					{
						let tmpToken = tmpSolveLayerTokens[i];
						tmpToken.VirtualSymbolName = `VFE_${tmpVirtualSymbolIndex}`;
						tmpVirtualSymbolIndex++;
						tmpResults.PostfixLayerstackMap[tmpToken.SolveLayerStack] = tmpToken.VirtualSymbolName;
					}
				}
			}
		}

		// 5.15 Generate Virtual Symbol Clusters for Functions and Parenthesis
		//      ... this gets funny because of precedence of operations surrounding them, parenthesis and functions.
		let tmpFunctionCacheLIFOStack = [];
		for (let i = 0; i < tmpResults.PostfixTokenObjects.length; i++)
		{
			let tmpPostfixTokenObject = tmpResults.PostfixTokenObjects[i];

			if (tmpPostfixTokenObject.Type === 'Token.Parenthesis')
			{
				// This is just to track the parenthesis stack level for User feedback
				tmpPostfixTokenObject.ParenthesisStack = tmpPostfixTokenObject.VirtualSymbolName;

				// At the beginning of the  expression, this must be an open parenthesis to be legal.
				if (i == 0)
				{
					tmpPostfixTokenObject.IsFunction = false;
					let tmpVirtualSymbolName = tmpResults.PostfixLayerstackMap[tmpPostfixTokenObject.VirtualSymbolName];
					if (!tmpVirtualSymbolName)
					{
						// ... this parenthesis group has no operators in it; make a virtual symbol name.
						tmpVirtualSymbolName = `VP_${tmpVirtualSymbolIndex}`;
						tmpVirtualSymbolIndex++;
					}
					tmpPostfixTokenObject.VirtualSymbolName = tmpVirtualSymbolName;
					tmpFunctionCacheLIFOStack.push(tmpPostfixTokenObject);
				}
				// If it's an open parenthesis
				else if (tmpPostfixTokenObject.Token === '(')
				{
					// ... supporting a function
					if (tmpResults.PostfixTokenObjects[i-1].Type === 'Token.Function')
					{
						tmpPostfixTokenObject.IsFunction = true;
						tmpPostfixTokenObject.Function = tmpResults.PostfixTokenObjects[i-1];
						let tmpVirtualSymbolName = tmpResults.PostfixLayerstackMap[tmpPostfixTokenObject.VirtualSymbolName];
						if (!tmpVirtualSymbolName)
						{
							// ... this parenthesis group has no operators in it; make a virtual symbol name.
							tmpVirtualSymbolName = `VFP_${tmpVirtualSymbolIndex}`;
							tmpVirtualSymbolIndex++;
						}
						tmpPostfixTokenObject.VirtualSymbolName = tmpVirtualSymbolName;
					}
					else
					{
						tmpPostfixTokenObject.IsFunction = false;
						let tmpVirtualSymbolName = tmpResults.PostfixLayerstackMap[tmpPostfixTokenObject.VirtualSymbolName];
						if (!tmpVirtualSymbolName)
						{
							// This is a parenthesis group with no operators in it; make a virtual symbol name.
							tmpVirtualSymbolName = `VP_${tmpVirtualSymbolIndex}`;
							tmpVirtualSymbolIndex++;
						}
						tmpPostfixTokenObject.VirtualSymbolName = tmpVirtualSymbolName;
					}
					tmpFunctionCacheLIFOStack.push(tmpPostfixTokenObject);
				}
				else if (tmpPostfixTokenObject.Token === ')')
				{
					let tmpOpenParenthesis = tmpFunctionCacheLIFOStack.pop();
					if (!tmpOpenParenthesis)
					{
						tmpResults.ExpressionParserLog.push(`ERROR: ExpressionParser.buildPostfixedSolveList found a closing parenthesis at token index ${i} with no corresponding opening parenthesis.`);
						continue;
					}

					if (tmpOpenParenthesis.IsFunction)
					{
						tmpPostfixTokenObject.IsFunction = true;
						tmpPostfixTokenObject.VirtualSymbolName = tmpOpenParenthesis.Function.VirtualSymbolName;
					}
					else
					{
						tmpPostfixTokenObject.IsFunction = false;
						tmpPostfixTokenObject.VirtualSymbolName = tmpOpenParenthesis.VirtualSymbolName
					}
				}
			}
		}

		// X. Postprocess the parenthesis groups to ensure they respect the order of operations for their boundaries
		for (let tmpSolveLayerIndex = 0; tmpSolveLayerIndex < tmpSolveLayerKeys.length; tmpSolveLayerIndex++)
		{
			let tmpParenthesisStack = [];
			let tmpLastOperator = false;

			let tmpSolveLayerTokens = tmpSolveLayerMap[tmpSolveLayerKeys[tmpSolveLayerIndex]];
			for (let i = 0; i < tmpSolveLayerTokens.length; i++)
			{
				let tmpPostfixTokenObject = tmpSolveLayerTokens[i];

				// Keep track of the last operator
				if (tmpPostfixTokenObject.Type === 'Token.Operator')
				{
					tmpLastOperator = tmpPostfixTokenObject;
				}

				// This is only important to do at the close parenthesis.
				if (tmpPostfixTokenObject.Type === 'Token.Function')
				{
					tmpPostfixTokenObject.PreviousOperator = tmpLastOperator;
				}
				else if ((tmpPostfixTokenObject.Type === 'Token.Parenthesis') && (tmpPostfixTokenObject.Token === '(') && tmpPostfixTokenObject.IsFunction)
				{
					tmpParenthesisStack.push(tmpPostfixTokenObject);
					if (tmpPostfixTokenObject.Function.PreviousOperator)
					{
						tmpPostfixTokenObject.PreviousOperator = tmpPostfixTokenObject.Function.PreviousOperator;
					}
				}
				else if ((tmpPostfixTokenObject.Type === 'Token.Parenthesis') && (tmpPostfixTokenObject.Token === '('))
				{
					tmpPostfixTokenObject.PreviousOperator = tmpLastOperator;
					tmpParenthesisStack.push(tmpPostfixTokenObject);
				}
				else if ((tmpPostfixTokenObject.Type === 'Token.Parenthesis') && (tmpPostfixTokenObject.Token === ')'))
				{
					// This is ultra complex, and binds the order of operations logic to the open parenthesis for the group
					let tmpOpenParenthesis = tmpParenthesisStack.pop();
					if (i < tmpSolveLayerTokens.length - 1)
					{
						for (let j = i + 1; j < tmpSolveLayerTokens.length; j++)
						{
							if (tmpSolveLayerTokens[j].Type === 'Token.Operator')
							{
								tmpOpenParenthesis.NextOperator = tmpSolveLayerTokens[j];
								break;
							}
						}
					}
					if (!tmpOpenParenthesis)
					{
						tmpResults.ExpressionParserLog.push(`ERROR: ExpressionParser.buildPostfixedSolveList found a closing parenthesis at token index ${i} with no corresponding opening parenthesis.`);
						continue;
					}

					if (tmpOpenParenthesis.PreviousOperator && tmpOpenParenthesis.NextOperator)
					{
						if (tmpOpenParenthesis.PreviousOperator.Descriptor.Precedence <= tmpOpenParenthesis.NextOperator.Descriptor.Precedence)
						{
							tmpOpenParenthesis.NextOperator.LeftVirtualSymbolName = tmpOpenParenthesis.PreviousOperator.VirtualSymbolName;
						}
						else
						{
							tmpOpenParenthesis.PreviousOperator.RightVirtualSymbolName = tmpOpenParenthesis.NextOperator.VirtualSymbolName;
						}
					}
				}
				else
				{
					if (!('SolveLayerStack' in tmpPostfixTokenObject))
					{
						// Decorate the solve layer stack for the token
						if (tmpParenthesisStack.length > 0)
						{
							tmpPostfixTokenObject.SolveLayerStack = tmpParenthesisStack[tmpParenthesisStack.length-1].SolveLayerStack;
						}
						else
						{
							tmpPostfixTokenObject.SolveLayerStack = 'Expression_Root';
						}
					}
				}
			}
		}

		// 5.2.9: Make sure the affinity of operators is respecting order of operations.
		//        Walk backwards and forwards, hoisting same value precedence backwards/forwards
		//        across each layer... the precedence change needs to be decreasing to matter
		for (let tmpSolveLayerIndex = 0; tmpSolveLayerIndex < tmpSolveLayerKeys.length; tmpSolveLayerIndex++)
		{
			let tmpLastPrecedence = false;
			let tmpFinalChainToken = false;
			let tmpSolveLayerTokens = tmpSolveLayerMap[tmpSolveLayerKeys[tmpSolveLayerIndex]];

			for (let i = tmpSolveLayerTokens.length-1; i >= 0; i--)
			{
				let tmpToken = tmpSolveLayerTokens[i];

				if (tmpToken.Type === 'Token.Operator')
				{
					if (!tmpFinalChainToken)
					{
						tmpFinalChainToken = tmpToken;
					}
					else if (tmpToken.Descriptor.Precedence > tmpLastPrecedence)
					{
						// This is less imporant than the last precedence, so hoist back the virtual value
						tmpToken.RightVirtualSymbolName = tmpFinalChainToken.VirtualSymbolName;
						//console.log(`Hoisting ${tmpToken.Token} back to ${tmpFinalChainToken.Token}`);
						tmpFinalChainToken = tmpToken;
					}
					else if (tmpToken.Descriptor.Precedence < tmpLastPrecedence)
					{
						tmpFinalChainToken = tmpToken;
					}
					tmpLastPrecedence = tmpToken.Descriptor.Precedence;
				}
			}
			let tmpDecreasingPrecedenceStack = [];
			let tmpLastToken = false;
			for (let i = tmpSolveLayerTokens.length-1; i >= 0; i--)
			{
				let tmpToken = tmpSolveLayerTokens[i];

				if (tmpToken.Type === 'Token.Operator')
				{
					if (!tmpLastToken)
					{
						tmpLastToken = tmpToken;
					}
					else if (tmpToken.Descriptor.Precedence > tmpLastPrecedence)
					{
						// Check and see if this needs to be resolved in the stack
						if (tmpDecreasingPrecedenceStack.length > 0)
						{
							for (let j = tmpDecreasingPrecedenceStack.length-1; j >= 0; j--)
							{
								if (tmpDecreasingPrecedenceStack[j].Descriptor.Precedence >= tmpToken.Descriptor.Precedence)
								{
									//console.log(`Hoisting ${tmpDecreasingPrecedenceStack[j].Token} up to ${tmpToken.Token}`);
									tmpDecreasingPrecedenceStack[j].LeftVirtualSymbolName = tmpToken.VirtualSymbolName;
									tmpDecreasingPrecedenceStack.slice(j, 1);
									break;
								}
							}
						}
						tmpLastToken = tmpToken;
					}
					else if (tmpToken.Descriptor.Precedence < tmpLastPrecedence)
					{
						tmpDecreasingPrecedenceStack.push(tmpLastToken);
						tmpLastToken = tmpToken;
					}
					tmpLastPrecedence = tmpToken.Descriptor.Precedence;
				}
			}
		}

		// 5.3: Generate the Postfix Solve List
		for (let tmpSolveLayerIndex = 0; tmpSolveLayerIndex < tmpSolveLayerKeys.length; tmpSolveLayerIndex++)
		{
			let tmpSolveLayerTokens = tmpSolveLayerMap[tmpSolveLayerKeys[tmpSolveLayerIndex]];

			// If this is a layer with one value, presume it's an assignment.
			if (tmpSolveLayerTokens.length === 1)
			{
				// TODO: I think this is correct but with the addition of multiple assignment operators it's less clear.
				let tmpAbstractAssignToken = this.getTokenContainerObject('=');
				tmpAbstractAssignToken.VirtualSymbolName = tmpResults.PostfixLayerstackMap[tmpSolveLayerTokens[0].SolveLayerStack];
				// If this doesn't have a matching solvelayerstack, get the virtual symbol name from the parenthesis group it's in
				if (!tmpAbstractAssignToken.VirtualSymbolName)
				{
					for (let i = 0; i < tmpResults.PostfixTokenObjects.length; i++)
					{
						if (tmpResults.PostfixTokenObjects[i].ParenthesisStack === tmpSolveLayerTokens[0].SolveLayerStack)
						{
							tmpAbstractAssignToken.VirtualSymbolName = tmpResults.PostfixTokenObjects[i].VirtualSymbolName;
							break;
						}
					}
				}
				if (!tmpAbstractAssignToken.VirtualSymbolName)
				{
					tmpAbstractAssignToken.VirtualSymbolName = `V_SingleValue_${tmpVirtualSymbolIndex}`;
					tmpVirtualSymbolIndex++;
				}
				tmpResults.PostfixSolveList.push(this.getPosfixSolveListOperation(tmpAbstractAssignToken, tmpSolveLayerTokens[0], this.getTokenContainerObject('0.0')));
				continue;
			}

			// For each precedence level in the layer
			for (let tmpPrecedence = 0; tmpPrecedence <= this.ExpressionParser.tokenMaxPrecedence; tmpPrecedence++)
			{
				// Enumerate all tokens in a layer's expression.
				// There is a recursive way to do this, but given the short length of even the most complex equations we're favoring readability.
				for (let i = 0; i < tmpSolveLayerTokens.length; i++)
				{
					// If the token is an operator and at the current precedence, add it to the postfix solve list and mutate the array.
					if ((tmpSolveLayerTokens[i].Type === 'Token.Operator') &&
						(tmpSolveLayerTokens[i].Descriptor.Precedence === tmpPrecedence))
					{
						let tmpToken = tmpSolveLayerTokens[i];
						// The - at the beginning of an expression is a number line orientation modifier
						if ((i == 0) && (tmpToken.Token == '-'))
						{
							// The number line negation operator is a special case that generates a virtual constant (-1.0) and multiplies it by the next token
							// This is an abstract operation that isn't in the expression.
							let tmpAbstractMultiplyToken = this.getTokenContainerObject('*');
							tmpAbstractMultiplyToken.VirtualSymbolName = tmpToken.VirtualSymbolName;
							tmpResults.PostfixSolveList.push(this.getPosfixSolveListOperation(tmpAbstractMultiplyToken, this.getTokenContainerObject('-1.0'), tmpSolveLayerTokens[i+1]));
						}
						// The - after an operator or an open parenthesis is also a number line orientation modifier
						else if ((i > 0) && (tmpToken.Token == '-') && ((tmpSolveLayerTokens[i-1].Type === 'Token.Operator') || (tmpSolveLayerTokens[i-1].Token === '(')))
						{
							// The number line negation operator is a special case that generates a virtual constant (-1.0) and multiplies it by the next token
							let tmpAbstractMultiplyToken = this.getTokenContainerObject('*');
							tmpAbstractMultiplyToken.VirtualSymbolName = tmpToken.VirtualSymbolName;
							tmpResults.PostfixSolveList.push(this.getPosfixSolveListOperation(tmpAbstractMultiplyToken, this.getTokenContainerObject('-1.0'), tmpSolveLayerTokens[i+1]));
						}
						// The + at the beginning is also a number line orientation modifier ... THAT WE IGNORE
						else if ((i == 0) && (tmpToken.Token == '+'))
						{
							continue;
						}
						// The + after an operator or a parenthesis is also a number line orientation modifier ... THAT WE IGNORE
						else if ((i > 0) && (tmpToken.Token == '+') && ((tmpSolveLayerTokens[i-1].Type === 'Token.Operator') || (tmpSolveLayerTokens[i-1].Token === '(')))
						{
							continue;
						}

						// Finally add the dang thing.
						else
						{
							tmpResults.PostfixSolveList.push(this.getPosfixSolveListOperation(tmpToken, tmpSolveLayerTokens[i-1], tmpSolveLayerTokens[i+1], tmpSolveLayerTokens, i));
						}
					}
					else if ((tmpSolveLayerTokens[i].Type === 'Token.Function') && (tmpPrecedence === 0))
					{
						let tmpToken = tmpSolveLayerTokens[i];
						tmpResults.PostfixSolveList.push(this.getPosfixSolveListOperation(tmpToken, tmpSolveLayerTokens[i+1], this.getTokenContainerObject('0.0')));
					}
				}
			}
		}

		// 7. Lastly set the assignment address.
		let tmpAbstractAssignToken = ('PostfixedAssignmentOperator' in tmpResults) ? this.getTokenContainerObject(tmpResults.PostfixedAssignmentOperator.Token) : this.getTokenContainerObject('=');
		// The address we are assigning to
		tmpAbstractAssignToken.VirtualSymbolName = tmpResults.PostfixedAssignmentAddress;
		// The address it's coming from
		let tmpSolveResultToken = this.getTokenContainerObject('Result', 'Token.LastResult');
		let tmpFinalAssignmentInstruction = this.getPosfixSolveListOperation(tmpAbstractAssignToken, tmpSolveResultToken, this.getTokenContainerObject('SolverMarshal', 'Token.SolverMarshal'));
		tmpResults.PostfixSolveList.push(tmpFinalAssignmentInstruction);

		return tmpResults.PostfixSolveList;
	}
}

module.exports = ExpressionParserPostfix;

},{"./Fable-Service-ExpressionParser-Base.js":77}],84:[function(require,module,exports){
const libExpressionParserOperationBase = require('./Fable-Service-ExpressionParser-Base.js');
const libSetConcatArray = require('../Fable-SetConcatArray.js');

class ExpressionParserSolver extends libExpressionParserOperationBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		this.serviceType = 'ExpressionParser-Solver';
	}

	solvePostfixedExpression(pPostfixedExpression, pDataDestinationObject, pResultObject, pManifest)
	{
		let tmpResults = (typeof(pResultObject) === 'object') ? pResultObject : { ExpressionParserLog: [] };

		let tmpManifest = (typeof(pManifest) === 'object') ? pManifest : this.fable.newManyfest();

		let tmpDataDestinationObject = (typeof(pDataDestinationObject) === 'object') ? pDataDestinationObject : {};

		// If there was a fable passed in (e.g. the results object was a service or such), we won't decorate
		let tmpPassedInFable = ('fable' in tmpResults);
		if (!tmpPassedInFable)
		{
			tmpResults.fable = this.fable;
		}

		if (!Array.isArray(pPostfixedExpression))
		{
			tmpResults.ExpressionParserLog.push(`ERROR: ExpressionParser.solvePostfixedExpression was passed a non-array postfixed expression.`);
			this.log.error(tmpResults.ExpressionParserLog[tmpResults.ExpressionParserLog.length-1]);
			return false;
		}
		if (pPostfixedExpression.length < 1)
		{
			tmpResults.ExpressionParserLog.push(`ERROR: ExpressionParser.solvePostfixedExpression was passed an empty postfixed expression.`);
			this.log.error(tmpResults.ExpressionParserLog[tmpResults.ExpressionParserLog.length-1]);
			return false;
		}

		// This is how the user communication magic happens.
		tmpResults.VirtualSymbols = {};

		for (let i = 0; i < pPostfixedExpression.length; i++)
		{
			// X = SUM(15, SUM(SIN(25), 10), (5 + 2), 3)
			if (pPostfixedExpression[i].Operation.Type === 'Token.SolverInstruction')
			{
				continue;
			}
			let tmpStepResultObject = { ExpressionStep: pPostfixedExpression[i], ExpressionStepIndex: i, ResultsObject: tmpResults, Manifest: tmpManifest};

			if (tmpStepResultObject.ExpressionStep.LeftValue.Type === 'Token.LastResult')
			{
				tmpStepResultObject.ExpressionStep.LeftValue.Value = tmpResults.LastResult;
			}
			if (tmpStepResultObject.ExpressionStep.RightValue.Type === 'Token.LastResult')
			{
				tmpStepResultObject.ExpressionStep.RightValue.Value = tmpResults.LastResult;
			}

			if (tmpStepResultObject.ExpressionStep.LeftValue.Type === 'Token.VirtualSymbol')
			{
				tmpStepResultObject.ExpressionStep.LeftValue.Value = tmpManifest.getValueAtAddress(tmpResults.VirtualSymbols, tmpStepResultObject.ExpressionStep.LeftValue.Token);
			}
			if (tmpStepResultObject.ExpressionStep.RightValue.Type === 'Token.VirtualSymbol')
			{
				tmpStepResultObject.ExpressionStep.RightValue.Value = tmpManifest.getValueAtAddress(tmpResults.VirtualSymbols, tmpStepResultObject.ExpressionStep.RightValue.Token);
			}

			// Resolve the parenthesis to their actual values
			if (tmpStepResultObject.ExpressionStep.LeftValue.Type === 'Token.Parenthesis')
			{
				tmpStepResultObject.ExpressionStep.LeftValue.Value = tmpManifest.getValueAtAddress(tmpResults.VirtualSymbols, tmpStepResultObject.ExpressionStep.LeftValue.VirtualSymbolName);
			}
			if (tmpStepResultObject.ExpressionStep.RightValue.Type === 'Token.Parenthesis')
			{
				tmpStepResultObject.ExpressionStep.RightValue.Value = tmpManifest.getValueAtAddress(tmpResults.VirtualSymbols, tmpStepResultObject.ExpressionStep.RightValue.VirtualSymbolName);
			}

			// Virtual Constants
			if (tmpStepResultObject.ExpressionStep.LeftValue.Type === 'Token.Constant' && !('Value' in tmpStepResultObject.ExpressionStep.LeftValue))
			{
				tmpStepResultObject.ExpressionStep.LeftValue.Value = tmpStepResultObject.ExpressionStep.LeftValue.Token;
			}
			if (tmpStepResultObject.ExpressionStep.RightValue.Type === 'Token.Constant' && !('Value' in tmpStepResultObject.ExpressionStep.RightValue))
			{
				tmpStepResultObject.ExpressionStep.RightValue.Value = tmpStepResultObject.ExpressionStep.RightValue.Token;
			}

			if (tmpStepResultObject.ExpressionStep.Operation.Type = 'Operator')
			{
				// TODO: This can be optimized.   A lot.  If necessary.  Seems pretty fast honestly for even thousands of operations.  Slowest part is arbitrary precision.
				// An operator always has a left and right value.
				let tmpFunctionAddress;
				// Note: There are easier, passive ways of managing this state.  But this is complex.
				let tmpIsFunction = false;
				if (tmpStepResultObject.ExpressionStep.Operation.Token in this.ExpressionParser.tokenMap)
				{
					tmpFunctionAddress = `ResultsObject.${tmpStepResultObject.ExpressionStep.Operation.Descriptor.Function}`;
				}
				else if (tmpStepResultObject.ExpressionStep.Operation.Token.toLowerCase() in this.ExpressionParser.functionMap)
				{
					tmpIsFunction = true;
					tmpFunctionAddress = `ResultsObject.${this.ExpressionParser.functionMap[tmpStepResultObject.ExpressionStep.Operation.Token.toLowerCase()].Address}`;
				}

				if (tmpIsFunction)
				{
					try
					{
						let tmpResult;
						const tmpFunction = tmpManifest.getValueAtAddress(tmpStepResultObject, tmpFunctionAddress);
						if (typeof tmpFunction === 'function')
						{
							let tmpFunctionBinding = null;
							if (tmpFunctionAddress.includes('.'))
							{
								tmpFunctionBinding = tmpManifest.getValueAtAddress(tmpStepResultObject, tmpFunctionAddress.split('.').slice(0, -1).join('.'));
							}
							let tmpArguments = tmpStepResultObject.ExpressionStep.LeftValue.Value;
							if (!(tmpArguments instanceof libSetConcatArray))
							{
								tmpArguments = [ tmpArguments ];
							}
							else
							{
								tmpArguments = tmpArguments.values;
							}
							tmpResult = tmpFunction.apply(tmpFunctionBinding, tmpArguments);
						}
						tmpManifest.setValueAtAddress(tmpResults.VirtualSymbols, tmpStepResultObject.ExpressionStep.VirtualSymbolName, tmpResult);
						tmpResults.LastResult = tmpManifest.getValueAtAddress(tmpResults.VirtualSymbols, tmpStepResultObject.ExpressionStep.VirtualSymbolName);
						//this.log.trace(`   ---> Step ${i}: ${tmpResults.VirtualSymbols[tmpStepResultObject.ExpressionStep.VirtualSymbolName]}`)
					}
					catch (pError)
					{
						tmpResults.ExpressionParserLog.push(`ERROR: ExpressionParser.solvePostfixedExpression failed to solve step ${i} with function ${tmpStepResultObject.ExpressionStep.Operation.Token}: ${pError}`);
						this.log.error(tmpResults.ExpressionParserLog[tmpResults.ExpressionParserLog.length-1], { Stack: pError.stack });
						return false;
					}
				}
				else
				{
					try
					{
						//this.log.trace(`Solving Step ${i} [${tmpStepResultObject.ExpressionStep.VirtualSymbolName}] --> [${tmpStepResultObject.ExpressionStep.Operation.Token}]: ( ${tmpStepResultObject.ExpressionStep.LeftValue.Value} , ${tmpStepResultObject.ExpressionStep.RightValue.Value} )`);
						tmpManifest.setValueAtAddress(tmpResults.VirtualSymbols, tmpStepResultObject.ExpressionStep.VirtualSymbolName, tmpManifest.getValueAtAddress(tmpStepResultObject, `${tmpFunctionAddress}(ExpressionStep.LeftValue.Value,ExpressionStep.RightValue.Value)`));
						tmpResults.LastResult = tmpManifest.getValueAtAddress(tmpResults.VirtualSymbols, tmpStepResultObject.ExpressionStep.VirtualSymbolName);
						//this.log.trace(`   ---> Step ${i}: ${tmpResults.VirtualSymbols[tmpStepResultObject.ExpressionStep.VirtualSymbolName]}`)
					}
					catch (pError)
					{
						tmpResults.ExpressionParserLog.push(`ERROR: ExpressionParser.solvePostfixedExpression failed to solve step ${i} with function ${tmpStepResultObject.ExpressionStep.Operation.Token}: ${pError}`);
						this.log.error(tmpResults.ExpressionParserLog[tmpResults.ExpressionParserLog.length-1], { Stack: pError.stack });
						return false;
					}
				}

				// Equations don't always solve in virtual symbol order.
				tmpResults.SolverFinalVirtualSymbol = tmpStepResultObject.ExpressionStep.VirtualSymbolName;
			}
		}

		let tmpSolverResultValue = tmpManifest.getValueAtAddress(tmpResults, `VirtualSymbols.${tmpResults.SolverFinalVirtualSymbol}`);

		// Now deal with final assignment(s)
		for (let i = 0; i < pPostfixedExpression.length; i++)
		{
			if (pPostfixedExpression[i].RightValue.Type === 'Token.SolverMarshal')
			{
				// Set the result in the virtual symbols
				tmpManifest.setValueAtAddress(tmpResults.VirtualSymbols, pPostfixedExpression[i].VirtualSymbolName, tmpSolverResultValue);
				// Set the value in the destination object
				if (pPostfixedExpression[i].Operation.Descriptor.OnlyEmpty)
				{
					// If it is only on "empty" values, check if the value is empty before assigning
					if (this.fable.Utility.addressIsNullOrEmpty(tmpDataDestinationObject, pPostfixedExpression[i].VirtualSymbolName))
					{
						tmpManifest.setValueByHash(tmpDataDestinationObject, pPostfixedExpression[i].VirtualSymbolName, tmpSolverResultValue);
					}
				}
				else
				{
					// Otherwise, just assign it.
					tmpManifest.setValueByHash(tmpDataDestinationObject, pPostfixedExpression[i].VirtualSymbolName, tmpSolverResultValue);
				}
			}
		}
		tmpResults.RawResult = tmpSolverResultValue;

		// Clean up the fable reference if we added it to the object.
		if (!tmpPassedInFable)
		{
			delete tmpResults.fable;
		}

		if (typeof(tmpSolverResultValue) === 'object')
		{
			return tmpSolverResultValue;
		}
		else if (typeof(tmpSolverResultValue) !== 'undefined')
		{
			return tmpSolverResultValue.toString();
		}
		else
		{
			return tmpSolverResultValue;
		}
	}
}

module.exports = ExpressionParserSolver;

},{"../Fable-SetConcatArray.js":101,"./Fable-Service-ExpressionParser-Base.js":77}],85:[function(require,module,exports){
module.exports={
	"=":
		{
			"Name": "Assign Value",
			"Token": "=",
			"Function": "fable.Math.assignValue",
			"Precedence": 0,
			"Type": "Assignment"
		},

	":":
		{
			"Name": "Expression Begin",
			"Token": ":",
			"Function": "fable.Math.expressionBegin",
			"Precedence": 0,
			"Type": "Assignment"
		},

	"?=":
		{
			"Name": "Null or Empty Coalescing Assign Value",
			"Token": "?=",
			"Function": "fable.Math.assignValue",
			"OnlyEmpty": true,
			"Precedence": 0,
			"Type": "Assignment"
		},

	"(":
		{
			"Name": "Left Parenthesis",
			"Token": "(",
			"Precedence": 0,
			"Type": "Parenthesis"
		},
	")":
		{
			"Name": "Right Parenthesis",
			"Token": ")",
			"Precedence": 0,
			"Type": "Parenthesis"
		},
	",":
		{
			"Name": "Set Concatenate",
			"Token": ",",
			"Function": "fable.Math.setConcatenate",
			"Precedence": 6,
			"Type": "Operator"
		},

	"*":
		{
			"Name": "Multiply",
			"Token": "*",
			"Function": "fable.Math.multiplyPrecise",
			"Precedence": 3,
			"Type": "Operator"
		},
	"/":
		{
			"Name": "Divide",
			"Token": "/",
			"Function": "fable.Math.dividePrecise",
			"Precedence": 3,
			"Type": "Operator"
		},

	"^":
		{
			"Name": "Exponent",
			"Token": "^",
			"Function": "fable.Math.powerPrecise",
			"Precedence": 2,
			"Type": "Operator"
		},
	"%":
		{
			"Name": "Modulus",
			"Token": "%",
			"Function": "fable.Math.modPrecise",
			"Precedence": 3,
			"Type": "Operator"
		},

	"+":
		{
			"Name": "Add",
			"Token": "+",
			"Function": "fable.Math.addPrecise",
			"Precedence": 4,
			"Type": "Operator"
		},
	"-":
		{
			"Name": "Subtract",
			"Token": "-",
			"Function": "fable.Math.subtractPrecise",
			"Precedence": 4,
			"Type": "Operator"
		},

	">":
		{
			"Name": "Greater Than",
			"Token": ">",
			"Function": "fable.Math.greaterThanOperator",
			"Precedence": 5,
			"Type": "Operator"
		},
	">=":
		{
			"Name": "Greater Than or Equal",
			"Token": ">=",
			"Function": "fable.Math.greaterThanOrEqualOperator",
			"Precedence": 5,
			"Type": "Operator"
		},
	"<":
		{
			"Name": "Less Than",
			"Token": "<",
			"Function": "fable.Math.lessThanOperator",
			"Precedence": 5,
			"Type": "Operator"
		},
	"<=":
		{
			"Name": "Less Than or Equal",
			"Token": "<=",
			"Function": "fable.Math.lessThanOrEqualOperator",
			"Precedence": 5,
			"Type": "Operator"
		},
	"==":
		{
			"Name": "Equal",
			"Token": "==",
			"Function": "fable.Math.equalOperator",
			"Precedence": 5,
			"Type": "Operator"
		},
	"!=":
		{
			"Name": "Not Equal",
			"Token": "!=",
			"Function": "fable.Math.notEqualOperator",
			"Precedence": 5,
			"Type": "Operator"
		},

	"?":
		{
			"Name": "Ternary Condition",
			"Token": "?",
			"Precedence": 0,
			"Type": "Ternary"
		},
	"::":
		{
			"Name": "Ternary Separator",
			"Token": "::",
			"Precedence": 0,
			"Type": "Ternary"
		}
}

},{}],86:[function(require,module,exports){
const libExpressionParserOperationBase = require('./Fable-Service-ExpressionParser-Base.js');

class ExpressionParserValueMarshal extends libExpressionParserOperationBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		this.serviceType = 'ExpressionParser-ValueMarshal';
	}

	/**
	 * Substitutes values in tokenized objects based on the provided data source and manifest.
	 *
	 * TODO: Move this to its own file in the "Fable-Service-ExpressionParser" directory.
	 *
	 * @param {Array} pTokenizedObjects - The array of tokenized objects.
	 * @param {Object} pDataSource - The data source object where we pull values from.
	 * @param {Object} pResultObject - The result object where the algorithm shows its work.
	 * @param {Object} pManifest - The manifest object to use for hash resolution.
	 * @returns {Array} - The modified tokenized objects array.
	 */
	substituteValuesInTokenizedObjects(pTokenizedObjects, pDataSource, pResultObject, pManifest)
	{
		let tmpResults = (typeof(pResultObject) === 'object') ? pResultObject : { ExpressionParserLog: [] };

		if (!Array.isArray(pTokenizedObjects))
		{
			tmpResults.ExpressionParserLog.push(`ERROR: ExpressionParser.substituteValuesInTokenizedObjects was passed a non-array tokenized object list.`);
			this.log.error(tmpResults.ExpressionParserLog[tmpResults.ExpressionParserLog.length-1]);
			return pTokenizedObjects;
		}
		if (typeof(pDataSource) !== 'object')
		{
			tmpResults.ExpressionParserLog.push(`ERROR: ExpressionParser.substituteValuesInTokenizedObjects either was passed no data source, or was passed a non-object data source.`);
			this.log.error(tmpResults.ExpressionParserLog[tmpResults.ExpressionParserLog.length-1]);
			return pTokenizedObjects;
		}

		let tmpDataSource = pDataSource;

		let tmpManifest = (typeof(pManifest) == 'object') ? pManifest : this.fable.newManyfest(pManifest);

		for (let i = 0; i < pTokenizedObjects.length; i++)
		{
			if (typeof(pTokenizedObjects[i]) !== 'object')
			{
				tmpResults.ExpressionParserLog.push(`WARNING: ExpressionParser.substituteValuesInTokenizedObjects found a non-object tokenized object at index ${i}`);
				this.log.warn(tmpResults.ExpressionParserLog[tmpResults.ExpressionParserLog.length-1]);
				continue;
			}
			let tmpToken = pTokenizedObjects[i];
			if ((pTokenizedObjects[i].Type === 'Token.Symbol') && !tmpToken.Resolved)
			{
				// Symbols always look up values by hash first
				let tmpValue = tmpManifest.getValueByHash(tmpDataSource, tmpToken.Token);
				// if (!tmpValue)
				// {
				// 	// If no hash resolves, try by address.
				// 	tmpValue = tmpManifest.getValueAtAddress(tmpToken.Token, tmpDataSource);
				// }
				if (tmpValue == null)
				{
					tmpToken.Value = tmpValue;
					tmpToken.Resolve = true;
					tmpResults.ExpressionParserLog.push(`WARNING: ExpressionParser.substituteValuesInTokenizedObjects found no value for the symbol hash or address ${tmpToken.Token} at index ${i}`);
					if (this.LogNoisiness > 1) this.log.warn(tmpResults.ExpressionParserLog[tmpResults.ExpressionParserLog.length-1]);
					continue;
				}
				else
				{
					tmpResults.ExpressionParserLog.push(`INFO: ExpressionParser.substituteValuesInTokenizedObjects found a value [${tmpValue}] for the state address ${tmpToken.Token} at index ${i}`);
					if (this.LogNoisiness > 1) this.log.info(tmpResults.ExpressionParserLog[tmpResults.ExpressionParserLog.length-1]);
					if (typeof tmpValue === 'object') // this encapsulates POJOs and arrays
					{
						// this must be checked first, which works around an edge case where bigNumber turns single-element arrays into numbers, which we never want
						tmpToken.Resolved = true;
						tmpToken.Value = tmpValue;
					}
					else
					{
						try
						{
							const tmpValueParsed = new this.fable.Utility.bigNumber(tmpValue);
							tmpToken.Resolved = true;
							tmpToken.Value = tmpValueParsed.toString();
						}
						catch(pError)
						{
							// TODO: Should we allow this to be a function?  Good god the complexity and beauty of that...
							tmpToken.Resolved = true;
							tmpToken.Value = tmpValue;
							tmpResults.ExpressionParserLog.push(`INFO: ExpressionParser.substituteValuesInTokenizedObjects found a non-numeric value for the state address ${tmpToken.Token} at index ${i}; using raw value.`);
							//this.log.warn(tmpResults.ExpressionParserLog[tmpResults.ExpressionParserLog.length-1]);
						}
					}
				}
			}
			if ((pTokenizedObjects[i].Type === 'Token.StateAddress') && !tmpToken.Resolved)
			{
				// Symbols are always hashes.  This gracefully works for simple shallow objects because hashes default to the address in Manyfest.
				// Sometimes the token is wrapped in {} to indicate it's a direct address reference... we need to strip those off.
				// e.g., {0x1234abcd...}
				// So we need to strip off the {} if they exist.
				let tmpAddress = tmpToken.Token;
				if ((tmpAddress.startsWith('{')) && (tmpAddress.endsWith('}')))
				{
					tmpAddress = tmpAddress.substring(1, tmpAddress.length-1);
				}
				let tmpValue = tmpManifest.getValueAtAddress(tmpDataSource, tmpAddress);
				if (tmpValue == null)
				{
					tmpResults.ExpressionParserLog.push(`WARNING: ExpressionParser.substituteValuesInTokenizedObjects found no value for the state address ${tmpToken.Token} at index ${i}`);
					//this.log.warn(tmpResults.ExpressionParserLog[tmpResults.ExpressionParserLog.length-1]);
					continue;
				}
				else
				{
					//tmpResults.ExpressionParserLog.push(`INFO: ExpressionParser.substituteValuesInTokenizedObjects found a value [${tmpValue}] for the state address ${tmpToken.Token} at index ${i}`);
					//this.log.info(tmpResults.ExpressionParserLog[tmpResults.ExpressionParserLog.length-1]);
					try
					{
						let tmpValueParsed = new this.fable.Utility.bigNumber(tmpValue);
						tmpToken.Resolved = true;
						tmpToken.Value = tmpValueParsed.toString();
					}
					catch(pError)
					{
						// TODO: Should we allow this to be a function?  Good god the complexity and beauty of that...
						tmpToken.Resolved = true;
						tmpToken.Value = tmpValue;
						tmpResults.ExpressionParserLog.push(`INFO: ExpressionParser.substituteValuesInTokenizedObjects found a non-numeric value for the state address ${tmpToken.Token} at index ${i}; using raw value.`);
						//this.log.warn(tmpResults.ExpressionParserLog[tmpResults.ExpressionParserLog.length-1]);
					}
				}
			}
			if ((pTokenizedObjects[i].Type === 'Token.String') && !tmpToken.Resolved)
			{
				tmpResults.ExpressionParserLog.push(`INFO: ExpressionParser.substituteValuesInTokenizedObjects found a value [${tmpToken.Token}] for the string ${tmpToken.Token} at index ${i}`);
				if (this.LogNoisiness > 1) this.log.info(tmpResults.ExpressionParserLog[tmpResults.ExpressionParserLog.length-1]);
				tmpToken.Resolved = true;
				// Take the quotes off the string
				tmpToken.Value = tmpToken.Token.substring(1, tmpToken.Token.length-1);
			}
			if ((pTokenizedObjects[i].Type === 'Token.Constant') && !tmpToken.Resolved)
			{
				tmpResults.ExpressionParserLog.push(`INFO: ExpressionParser.substituteValuesInTokenizedObjects found a value [${tmpToken.Token}] for the constant ${tmpToken.Token} at index ${i}`);
				if (this.LogNoisiness > 1) this.log.info(tmpResults.ExpressionParserLog[tmpResults.ExpressionParserLog.length-1]);
				try
				{
					let tmpValueParsed = new this.fable.Utility.bigNumber(tmpToken.Token);
					tmpToken.Resolved = true;
					tmpToken.Value = tmpValueParsed.toString();
				}
				catch(pError)
				{
					// This constant has the right symbols but apparently isn't a parsable number.
					tmpResults.ExpressionParserLog.push(`ERROR: ExpressionParser.substituteValuesInTokenizedObjects found a non-numeric value for the state address ${tmpToken.Token} at index ${i}`);
					//this.log.error(tmpResults.ExpressionParserLog[tmpResults.ExpressionParserLog.length-1]);
					tmpToken.Resolved = false;
				}
			}
		}

		return pTokenizedObjects;
	}
}

module.exports = ExpressionParserValueMarshal;

},{"./Fable-Service-ExpressionParser-Base.js":77}],87:[function(require,module,exports){
(function (process){(function (){
const libFableServiceBase = require('fable-serviceproviderbase');

const libFS = require('fs');
const libPath = require('path');
const libReadline = require('readline');


class FableServiceFilePersistence extends libFableServiceBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.serviceType = 'FilePersistence';

		if (!('Mode' in this.options))
		{
			this.options.Mode = parseInt('0777', 8) & ~process.umask();
		}

		this.libFS = libFS;
		this.libPath = libPath;
		this.libReadline = libReadline;
	}

	joinPath(...pPathArray)
	{
		// TODO: Fix anything that's using this before changing this to the new true node join
		// return libPath.join(...pPathArray);
		return libPath.resolve(...pPathArray);
	}

	resolvePath(...pPathArray)
	{
		return libPath.resolve(...pPathArray);
	}

	existsSync(pPath)
	{
		return libFS.existsSync(pPath);
	}

	exists(pPath, fCallback)
	{
		let tmpFileExists = this.existsSync(pPath);
		return fCallback(null, tmpFileExists);
	}

	deleteFileSync(pFileName)
	{
		return libFS.unlinkSync(pFileName);
	}

	deleteFolderSync(pFileName)
	{
		return libFS.rmdirSync(pFileName);
	}

	readFileSync(pFilePath, pOptions)
	{
		let tmpOptions = (typeof(pOptions) === 'undefined') ? 'utf8' : pOptions;
		return libFS.readFileSync(pFilePath, tmpOptions);
	}

	readFile(pFilePath, pOptions, fCallback)
	{
		let tmpOptions = (typeof(pOptions) === 'undefined') ? 'utf8' : pOptions;
		return libFS.readFile(pFilePath, tmpOptions, fCallback);
	}

	readFileCSV(pFilePath, pOptions, fRecordFunction, fCompleteFunction, fErrorFunction)
	{
		let tmpCSVParser = this.fable.instantiateServiceProviderWithoutRegistration('CSVParser', pOptions);
		let tmpRecordFunction = (typeof(fRecordFunction) === 'function') ? fRecordFunction :
			(pRecord) =>
			{
				this.fable.log.trace(`CSV Reader received line ${pRecord}`);
			};
		let tmpCompleteFunction = (typeof(fCompleteFunction) === 'function') ? fCompleteFunction :
			() =>
			{
				this.fable.log.info(`CSV Read of ${pFilePath} complete.`);
			};
		let tmpErrorFunction = (typeof(fErrorFunction) === 'function') ? fErrorFunction :
			(pError) =>
			{
				this.fable.log.error(`CSV Read of ${pFilePath} Error: ${pError}`, pError);
			};

		return this.lineReaderFactory(pFilePath,
			(pLine) =>
			{
				let tmpRecord = tmpCSVParser.parseCSVLine(pLine);
				if (tmpRecord)
				{
					tmpRecordFunction(tmpRecord, pLine);
				}
			}, tmpCompleteFunction, tmpErrorFunction);
	}

	appendFileSync(pFileName, pAppendContent, pOptions)
	{
		let tmpOptions = (typeof(pOptions) === 'undefined') ? 'utf8' : pOptions;
		return libFS.appendFileSync(pFileName, pAppendContent, tmpOptions);
	}

	writeFileSync(pFileName, pFileContent, pOptions)
	{
		let tmpOptions = (typeof(pOptions) === 'undefined') ? 'utf8' : pOptions;
		return libFS.writeFileSync(pFileName, pFileContent, tmpOptions);
	}

	writeFileSyncFromObject(pFileName, pObject)
	{
		return this.writeFileSync(pFileName, JSON.stringify(pObject, null, 4));
	}

	writeFileSyncFromArray(pFileName, pFileArray)
	{
		if (!Array.isArray(pFileArray))
		{
			this.log.error(`File Persistence Service attempted to write ${pFileName} from array but the expected array was not an array (it was a ${typeof(pFileArray)}).`);
			return Error('Attempted to write ${pFileName} from array but the expected array was not an array (it was a ${typeof(pFileArray)}).');
		}
		else
		{
			for (let i = 0; i < pFileArray.length; i++)
			{
				return this.appendFileSync(pFileName, `${pFileArray[i]}\n`);
			}
		}
	}

	writeFile(pFileName, pFileContent, pOptions, fCallback)
	{
		let tmpOptions = (typeof(pOptions) === 'undefined') ? 'utf8' : pOptions;
		return libFS.writeFile(pFileName, pFileContent, tmpOptions, fCallback);
	}

	lineReaderFactory(pFilePath, fOnLine, fOnComplete, fOnError)
	{
		let tmpLineReader = {};

		if (typeof(pFilePath) != 'string')
		{
			return false;
		}

		tmpLineReader.filePath = pFilePath;

		tmpLineReader.fileStream = libFS.createReadStream(tmpLineReader.filePath);

		tmpLineReader.reader = libReadline.createInterface({ input: tmpLineReader.fileStream, crlfDelay: Infinity });

		if (typeof(fOnError) === 'function')
		{
			tmpLineReader.reader.on('error', fOnError);
		}

		tmpLineReader.reader.on('line', (typeof(fOnLine) === 'function') ? fOnLine : () => {});

		if (typeof(fOnComplete) === 'function')
		{
			tmpLineReader.reader.on('close', fOnComplete);
		}

		return tmpLineReader;
	}

	// Folder management
	makeFolderRecursive(pParameters, fCallback)
	{
		let tmpParameters = pParameters;

		if (typeof(pParameters) == 'string')
		{
			tmpParameters = { Path: pParameters };
		}
		else if (typeof(pParameters) !== 'object')
		{
			fCallback(new Error('Parameters object or string not properly passed to recursive folder create.'));
			return false;
		}

		if ((typeof(tmpParameters.Path) !== 'string'))
		{
			fCallback(new Error('Parameters object needs a path to run the folder create operation.'));
			return false;
		}

		if (!('Mode' in tmpParameters))
		{
			tmpParameters.Mode = this.options.Mode;
		}

		// Check if we are just starting .. if so, build the initial state for our recursive function
		if (typeof(tmpParameters.CurrentPathIndex) === 'undefined')
		{
			// Build the tools to start recursing
			tmpParameters.ActualPath = libPath.normalize(tmpParameters.Path);
			tmpParameters.ActualPathParts = tmpParameters.ActualPath.split(libPath.sep);
			tmpParameters.CurrentPathIndex = 0;
			tmpParameters.CurrentPath = '';
		}
		else
		{
			// This is not our first run, so we will continue the recursion.
			// Build the new base path
			if (tmpParameters.CurrentPath == libPath.sep)
			{
				tmpParameters.CurrentPath = tmpParameters.CurrentPath + tmpParameters.ActualPathParts[tmpParameters.CurrentPathIndex];
			}
			else
			{
				tmpParameters.CurrentPath = tmpParameters.CurrentPath + libPath.sep + tmpParameters.ActualPathParts[tmpParameters.CurrentPathIndex];
			}

			// Increment the path index
			tmpParameters.CurrentPathIndex++;
		}

		// Check if the path is fully complete
		if (tmpParameters.CurrentPathIndex >= tmpParameters.ActualPathParts.length)
		{
			return fCallback(null);
		}

		// Check if the path exists (and is a folder)
		libFS.open(tmpParameters.CurrentPath + libPath.sep + tmpParameters.ActualPathParts[tmpParameters.CurrentPathIndex], 'r',
			(pError, pFileDescriptor)=>
			{
				if (pFileDescriptor)
				{
					libFS.closeSync(pFileDescriptor);
				}

				if (pError && pError.code=='ENOENT')
				{
					/* Path doesn't exist, create it */
					libFS.mkdir(tmpParameters.CurrentPath + libPath.sep + tmpParameters.ActualPathParts[tmpParameters.CurrentPathIndex], tmpParameters.Mode,
						(pCreateError) =>
						{
							if (!pCreateError)
							{
								// We have now created our folder and there was no error -- continue.
								return this.makeFolderRecursive(tmpParameters, fCallback);
							}
							else if (pCreateError.code =='EEXIST')
							{
								// The folder exists -- our dev might be running this in parallel/async/whatnot.
								return this.makeFolderRecursive(tmpParameters, fCallback);
							}
							else
							{
								console.log(pCreateError.code);
								return fCallback(pCreateError);
							}
						});
				}
				else
				{
					return this.makeFolderRecursive(tmpParameters, fCallback);
				}
			});
	}
}

module.exports = FableServiceFilePersistence;

}).call(this)}).call(this,require('_process'))

},{"_process":150,"fable-serviceproviderbase":59,"fs":19,"path":138,"readline":19}],88:[function(require,module,exports){
const libFableServiceBase = require('fable-serviceproviderbase');

class FableServiceLogic extends libFableServiceBase
{
	/**
	 * @param {import('../Fable.js')} pFable - The fable object
	 * @param {Record<string, any>} [pOptions] - The options object
	 * @param {string} [pServiceHash] - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
	}

	/**
	 * Find the first value in an object that contains a specific value
	 *
	 * @param {string|number} pLeft - The left value to check
	 * @param {string} pComparisonOperator - The comparison operator to use
	 * @param {string|number} pRight - The right value to check
	 * @param {any} pOnTrue - The value to return if the comparison is true
	 * @param {any} [pOnFalse = ''] - The value to return if the comparison is false
	 * @return {any} - The selected value
	 */
	checkIf(pLeft, pComparisonOperator, pRight, pOnTrue, pOnFalse)
	{
		// precise numeric
		// string (non-numeric)
		let tmpMathLeft = this.fable.Math.parsePrecise(pLeft, null);
		let tmpMathRight = this.fable.Math.parsePrecise(pRight, null);
		let tmpCheckResult = false;
		if (tmpMathLeft === null || tmpMathRight === null)
		{
			if (typeof pOnFalse === 'undefined')
			{
				pOnFalse = '';
			}
			switch (pComparisonOperator)
			{
				case '<':
				case 'LT':
					tmpCheckResult = pLeft < pRight;
					break;
				case '<=':
				case 'LTE':
					tmpCheckResult = pLeft <= pRight;
					break;
				case '>':
				case 'GT':
					tmpCheckResult = pLeft > pRight;
					break;
				case '>=':
				case 'GTE':
					tmpCheckResult = pLeft >= pRight;
					break;
				case '==':
					tmpCheckResult = pLeft == pRight;
					break;
				case '===':
					tmpCheckResult = pLeft === pRight;
					break;
				default:
					this.fable.log.warn(`[FableServiceLogic.checkIf] Invalid comparison operator: ${pComparisonOperator}`);
					tmpCheckResult = pLeft == pRight;
			}
		}
		else
		{
			if (typeof pOnFalse === 'undefined')
			{
				pOnFalse = '0';
			}
			switch (pComparisonOperator)
			{
				case '<':
				case 'LT':
					tmpCheckResult = this.fable.Math.ltPrecise(tmpMathLeft, tmpMathRight);
					break;
				case '<=':
				case 'LTE':
					tmpCheckResult = this.fable.Math.ltePrecise(tmpMathLeft, tmpMathRight);
					break;
				case '>':
				case 'GT':
					tmpCheckResult = this.fable.Math.gtPrecise(tmpMathLeft, tmpMathRight);
					break;
				case '>=':
				case 'GTE':
					tmpCheckResult = this.fable.Math.gtePrecise(tmpMathLeft, tmpMathRight);
					break;
				case '==':
					tmpCheckResult = this.fable.Math.comparePreciseWithin(tmpMathLeft, tmpMathRight, '0.000001') == 0;
					break;
				case '===':
					tmpCheckResult = this.fable.Math.comparePrecise(tmpMathLeft, tmpMathRight) == 0;
					break;
				default:
					this.fable.log.warn(`[FableServiceLogic.checkIf] Invalid comparison operator: ${pComparisonOperator}`);
					tmpCheckResult = pLeft == pRight ? pOnTrue : pOnFalse;
			}
		}
		return tmpCheckResult ? pOnTrue : pOnFalse;
	}

	/**
	 * Find the first value in an object that contains a specific value
	 *
	 * @param {any} pCheckForTruthy - The object to check
	 * @param {any} pOnTrue - The value to return if the object is truthy
	 * @param {any} [pOnFalse = ''] - The value to return if the object is falsy
	 * @return {any} - The value from the object
	 */
	when(pCheckForTruthy, pOnTrue, pOnFalse = '')
	{
		if (!pCheckForTruthy)
		{
			return pOnFalse;
		}
		if (Array.isArray(pCheckForTruthy) && pCheckForTruthy.length < 1)
		{
			return pOnFalse;
		}
		if (typeof pCheckForTruthy === 'object' && Object.keys(pCheckForTruthy).length < 1)
		{
			return pOnFalse;
		}
		return pOnTrue;
	}

	/**
	 * Numeric-aware ternary selection for the expression parser.
	 * Treats 0, "0", "", null, undefined, false, NaN, empty arrays, and empty objects as falsy.
	 * Used by the ternary operator desugaring (condition ? trueVal :: falseVal).
	 *
	 * @param {any} pCondition - The condition to evaluate
	 * @param {any} pOnTrue - The value to return if the condition is truthy
	 * @param {any} [pOnFalse = ''] - The value to return if the condition is falsy
	 * @return {any} - The selected value
	 */
	ternary(pCondition, pOnTrue, pOnFalse = '')
	{
		// Standard JS falsy check
		if (!pCondition)
		{
			return pOnFalse;
		}
		// Numeric zero as a string (from comparison operators returning "0")
		if (pCondition === '0')
		{
			return pOnFalse;
		}
		if (Array.isArray(pCondition) && pCondition.length < 1)
		{
			return pOnFalse;
		}
		if (typeof pCondition === 'object' && Object.keys(pCondition).length < 1)
		{
			return pOnFalse;
		}
		return pOnTrue;
	}
}

module.exports = FableServiceLogic;

},{"fable-serviceproviderbase":59}],89:[function(require,module,exports){
/**
 * @file Fable-Service-Math.js
 * @description This file contains the implementation of the FableServiceMath class, which provides simple functions for performing arbitrary precision math operations.
 * @module FableServiceMath
 * @extends libFableServiceBase
 */
const libFableServiceBase = require('fable-serviceproviderbase');
const libSetConcatArray = require('./Fable-SetConcatArray.js');

/**
 * Arbitrary Precision Math Operations
 * @author      Steven Velozo <steven@velozo.com>
 * @description Simple functions that perform arbitrary precision math operations and return string resultant values.  Wraps big.js
 * @class FableServiceMath
 * @extends libFableServiceBase
 */
class FableServiceMath extends libFableServiceBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.serviceType = 'Math';

		this.pi = '3.1415926535897932384626433832795028841971693993751058209749445923078164062862089986280348253421170679';
		// From NASA: https://apod.nasa.gov/htmltest/gifcity/e.2mil
		this.euler = '2.7182818284590452353602874713526624977572470936999595749669676277240766303535475945713821785251664';
		this.errorReturnValue = NaN;

		//		this.manifest = this.fable.newManyfest();
		this.bigNumber = this.fable.Utility.bigNumber;

		this.ln2Cache = new Map();
	}

	/*
		Pass-through Rounding Method Constants

		Property	   Value   BigDecimal Equiv   Description
		----------     -----   ----------------   -----------
		roundDown      0       ROUND_DOWN         Rounds towards zero. (_I.e. truncate, no rounding._)
		roundHalfUp    1       ROUND_HALF_UP      Rounds towards nearest neighbour. (_If equidistant, rounds away from zero._)
		roundHalfEven  2       ROUND_HALF_EVEN    Rounds towards nearest neighbour. (_If equidistant, rounds towards even neighbour._)
		roundUp        3       ROUND_UP           Rounds positively away from zero. (_Always round up._)
	*/
	get roundDown() { return this.bigNumber.roundDown; }
	get roundHalfUp() { return this.bigNumber.roundHalfUp; }
	get roundHalfEven() { return this.bigNumber.roundHalfEven; }
	get roundUp() { return this.bigNumber.roundUp; }

	/**
	 * Parses a precise number value.
	 *
	 * @param {number} pValue - The value to parse.
	 * @param {any} pNonNumberValue - The value to use if parsing fails.
	 * @returns {string} - The parsed number as a string.
	 */
	parsePrecise(pValue, pNonNumberValue)
	{
		let tmpNumber;

		try
		{
			tmpNumber = new this.bigNumber(pValue);
		}
		catch (pError)
		{
			// TODO: This seems more correct -- we can add a silent or noisy parameter if we want this to export.
			//       Reason: Currently this is absolutely obliterating logs in the data integrations from bad data sources.
			//this.log.warn(`Error parsing number (type ${typeof (pValue)}): ${pError}`);
			tmpNumber = (typeof (pNonNumberValue) === 'undefined') ? "0.0" : pNonNumberValue;
		}

		return tmpNumber ? tmpNumber.toString() : tmpNumber;
	}

	/**
	 * Assigns the given value.  For equals operations in the solver.
	 * @param {*} pValue - The value to be assigned.
	 * @returns {*} The assigned value.
	 */
	assignValue(pValue)
	{
		return pValue;
	}

	/**
	 * Begins an expression with the given value. For performing colon operations in the solver.
	 * @param {*} pValue - The value to begin the expression with.
	 * @returns {*} The begun expression value.
	 */
	expressionBegin(pValue)
	{
		return pValue;
	}

	/**
	 * Calculates the precise percentage of a given value compared to another value.
	 *
	 * @param {number} pIs - The value to calculate the percentage of.
	 * @param {number} pOf - The value to calculate the percentage against.
	 * @returns {string} The precise percentage as a string.
	 */
	percentagePrecise(pIs, pOf)
	{
		let tmpLeftValue = isNaN(pIs) ? 0 : pIs;
		let tmpRightValue = isNaN(pOf) ? 0 : pOf;

		if (tmpRightValue == 0)
		{
			return '0';
		}

		let tmpLeftArbitraryValue = new this.bigNumber(tmpLeftValue);
		let tmpResult = tmpLeftArbitraryValue.div(tmpRightValue);
		tmpResult = tmpResult.times(100);
		return tmpResult.toString();
	}

	/**
	 * Concatenates two value sets and returns the result as a string.
	 *
	 * Value sets are comma separated.
	 *
	 * Used for arbitrary precision set generation.
	 *
	 * @param {any} pLeftValue - The left value to append.
	 * @param {any} pRightValue - The right value to append.
	 * @returns {InstanceType<libSetConcatArray>} The concatenated string of the left and right values.
	 */
	setConcatenate(pLeftValue, pRightValue)
	{
		return new libSetConcatArray(pLeftValue, pRightValue);
	}

	/**
	 * Rounds a value to a specified number of decimal places using a specified rounding method.
	 *
	 * @param {number} pValue - The value to be rounded.
	 * @param {number} pDecimals - The number of decimal places to round to.
	 * @param {function} [pRoundingMethod] - The rounding method to use. Defaults to `this.roundHalfUp`.
	 * @returns {string} - The rounded value as a string.
	 */
	roundPrecise(pValue, pDecimals, pRoundingMethod)
	{
		let tmpValue = pValue === false || isNaN(pValue) ? 0 : pValue;
		let tmpDecimals = isNaN(pDecimals) ? 0 : parseInt(pDecimals, 10);
		let tmpRoundingMethod = (typeof (pRoundingMethod) === 'undefined') ? this.roundHalfUp : parseInt(pRoundingMethod, 10);

		try
		{
			let tmpArbitraryValue = new this.bigNumber(tmpValue);
			let tmpResult = tmpArbitraryValue.round(tmpDecimals, tmpRoundingMethod);
			return tmpResult.toString();
		}
		catch
		{
			return this.errorReturnValue;
		}
	}

	/**
	 * Returns a string representation of a number with a specified number of decimals.
	 *
	 * @param {number} pValue - The number to be formatted.
	 * @param {number} pDecimals - The number of decimals to include in the formatted string.
	 * @param {string} [pRoundingMethod] - The rounding method to use. Defaults to 'roundHalfUp'.
	 * @returns {string} - The formatted number as a string.
	 */
	toFixedPrecise(pValue, pDecimals, pRoundingMethod)
	{
		let tmpValue = pValue === false || isNaN(pValue) ? 0 : pValue;
		let tmpDecimals = isNaN(pDecimals) ? 0 : parseInt(pDecimals, 10);
		let tmpRoundingMethod = (typeof (pRoundingMethod) === 'undefined') ? this.roundHalfUp : pRoundingMethod;

		try
		{
			let tmpArbitraryValue = new this.bigNumber(tmpValue);
			let tmpResult = tmpArbitraryValue.toFixed(tmpDecimals, tmpRoundingMethod);
			return tmpResult.toString();
		}
		catch
		{
			return this.errorReturnValue;
		}
	}

	/**
	 * Adds two values precisely.
	 * @param {number|string} pLeftValue - The left value to be added.
	 * @param {number|string} pRightValue - The right value to be added.
	 * @returns {string} - The result of adding the two values as a string.
	 */
	addPrecise(pLeftValue, pRightValue)
	{
		let tmpLeftValue = isNaN(pLeftValue) ? 0 : pLeftValue;
		let tmpRightValue = isNaN(pRightValue) ? 0 : pRightValue;

		let tmpLeftArbitraryValue = new this.bigNumber(tmpLeftValue);
		let tmpResult = tmpLeftArbitraryValue.plus(tmpRightValue);
		return tmpResult.toString();
	}

	/**
	 * Subtracts two values precisely.
	 *
	 * @param {number|string} pLeftValue - The left value to subtract.
	 * @param {number|string} pRightValue - The right value to subtract.
	 * @returns {string} The result of the subtraction as a string.
	 */
	subtractPrecise(pLeftValue, pRightValue)
	{
		let tmpLeftValue = isNaN(pLeftValue) ? 0 : pLeftValue;
		let tmpRightValue = isNaN(pRightValue) ? 0 : pRightValue;

		let tmpLeftArbitraryValue = new this.bigNumber(tmpLeftValue);
		let tmpResult = tmpLeftArbitraryValue.minus(tmpRightValue);
		return tmpResult.toString();
	}

	/**
	 * Calculates the precise power of two numbers.
	 *
	 * @param {number} pLeftValue - The base value.
	 * @param {number} pRightValue - The exponent value.
	 * @returns {string} The result of raising the base value to the exponent value.
	 */
	powerPrecise(pLeftValue, pRightValue)
	{
		let tmpLeftValue = isNaN(pLeftValue) ? 0 : pLeftValue;
		let tmpRightValue = isNaN(pRightValue) ? 0 : parseInt(pRightValue);
		let tmpResult;
		if (tmpRightValue == Number(pRightValue))
		{
			const tmpLeftArbitraryValue = new this.bigNumber(tmpLeftValue);
			tmpResult = tmpLeftArbitraryValue.pow(tmpRightValue);
		}
		else
		{
			//FIXME: big.js shits itself on non-integer exponents........................
			tmpResult = Math.pow(tmpLeftValue, Number(pRightValue));
		}

		return tmpResult.toString();
	}

	/**
	 * Multiplies two values precisely.
	 *
	 * @param {number|string} pLeftValue - The left value to multiply.
	 * @param {number|string} pRightValue - The right value to multiply.
	 * @returns {string} The result of the multiplication as a string.
	 */
	multiplyPrecise(pLeftValue, pRightValue)
	{
		let tmpLeftValue = isNaN(pLeftValue) ? 0 : pLeftValue;
		let tmpRightValue = isNaN(pRightValue) ? 0 : pRightValue;

		let tmpLeftArbitraryValue = new this.bigNumber(tmpLeftValue);
		let tmpResult = tmpLeftArbitraryValue.times(tmpRightValue);
		return tmpResult.toString();
	}

	/**
	 * Divides two values precisely.
	 *
	 * @param {number|string} pLeftValue - The left value to be divided.
	 * @param {number|string} pRightValue - The right value to divide by.
	 * @returns {string} The result of the division as a string.
	 */
	dividePrecise(pLeftValue, pRightValue)
	{
		let tmpLeftValue = isNaN(pLeftValue) ? 0 : pLeftValue;
		let tmpRightValue = isNaN(pRightValue) ? 0 : pRightValue;

		let tmpLeftArbitraryValue = new this.bigNumber(tmpLeftValue);
		let tmpResult = tmpLeftArbitraryValue.div(tmpRightValue);
		return tmpResult.toString();
	}

	/**
	 * Calculates the modulus of two values with precision.
	 *
	 * @param {number|string} pLeftValue - The left value.
	 * @param {number|string} pRightValue - The right value.
	 * @returns {string} The result of the modulus operation as a string.
	 */
	modPrecise(pLeftValue, pRightValue)
	{
		let tmpLeftValue = isNaN(pLeftValue) ? 0 : pLeftValue;
		let tmpRightValue = isNaN(pRightValue) ? 0 : pRightValue;

		let tmpLeftArbitraryValue = new this.bigNumber(tmpLeftValue);
		let tmpResult = tmpLeftArbitraryValue.mod(tmpRightValue);
		return tmpResult.toString();
	}

	/**
	 * Calculates the square root of a number with precise decimal places.
	 *
	 * @param {number|string} pValue - The number to calculate the square root of.
	 * @returns {string} The square root of the input number as a string.
	 */
	sqrtPrecise(pValue)
	{
		let tmpValue = isNaN(pValue) ? 0 : pValue;

		let tmpLeftArbitraryValue = new this.bigNumber(tmpValue);
		let tmpResult = tmpLeftArbitraryValue.sqrt();
		return tmpResult.toString();
	}

	/**
	 * Calculates the absolute value of a number precisely.
	 *
	 * @param {number|string} pValue - The number to calculate the absolute value of.
	 * @returns {string} The absolute value of the input number as a string.
	 */
	absPrecise(pValue)
	{
		let tmpValue = isNaN(pValue) ? 0 : pValue;

		let tmpLeftArbitraryValue = new this.bigNumber(tmpValue);
		let tmpResult = tmpLeftArbitraryValue.abs();
		return tmpResult.toString();
	}

	/**
	 * Calculates the floor of a number precisely.
	 *
	 * @param {string|number} pValue - The number to calculate the floor value of.
	 * @returns {string} The floor value of the input number as a string.
	 */
	floorPrecise(pValue)
	{
		let tmpValue = isNaN(pValue) ? 0 : pValue;

		let tmpResult = Math.floor(tmpValue);
		return tmpResult.toString();
	}

	/**
	 * Calculates the ceiling of a number precisely.
	 *
	 * @param {number|string} pValue - The number to calculate the ceiling value of.
	 * @returns {string} The ceiling value of the input number as a string.
	 */
	ceilPrecise(pValue)
	{
		let tmpValue = isNaN(pValue) ? 0 : pValue;

		let tmpResult = Math.ceil(tmpValue);
		return tmpResult.toString();
	}

	/**
	 * Compares two values precisely.
	 *
	 * @param {number|string} pLeftValue - The left value to compare.
	 * @param {number|string} pRightValue - The right value to compare.
	 * @returns {number} - Returns the result of the comparison.
	 */
	comparePrecise(pLeftValue, pRightValue)
	{
		let tmpLeftValue = isNaN(pLeftValue) ? 0 : pLeftValue;
		let tmpRightValue = isNaN(pRightValue) ? 0 : pRightValue;

		let tmpLeftArbitraryValue = new this.bigNumber(tmpLeftValue);
		return tmpLeftArbitraryValue.cmp(tmpRightValue);
	}

	/**
	 * Compares two values precisely within a tolerance.
	 *
	 * @param {number|string} pLeftValue - The left value to compare.
	 * @param {number|string} pRightValue - The right value to compare.
	 * @param {number|string} pEpsilon - The epsilon value for comparison.
	 * @returns {number} - Returns the result of the comparison.
	 */
	comparePreciseWithin(pLeftValue, pRightValue, pEpsilon)
	{
		let tmpLeftValue = isNaN(pLeftValue) ? 0 : pLeftValue;
		let tmpRightValue = isNaN(pRightValue) ? 0 : pRightValue;

		let tmpLeftArbitraryValue = new this.bigNumber(tmpLeftValue);
		const diff = tmpLeftArbitraryValue.minus(tmpRightValue).abs();
		if (diff.lte(pEpsilon))
		{
			return 0;
		}
		if (tmpLeftArbitraryValue.lt(tmpRightValue))
		{
			return -1;
		}
		return 1;
	}

	/**
	 * Determines if the left value is greater than the right value precisely.
	 *
	 * @param {number|string} pLeftValue - The left value to compare.
	 * @param {number|string} pRightValue - The right value to compare.
	 * @returns {boolean} - Returns true if the left value is greater than the right value, otherwise returns false.
	 */
	gtPrecise(pLeftValue, pRightValue)
	{
		let tmpLeftValue = isNaN(pLeftValue) ? 0 : pLeftValue;
		let tmpRightValue = isNaN(pRightValue) ? 0 : pRightValue;

		let tmpLeftArbitraryValue = new this.bigNumber(tmpLeftValue);
		return tmpLeftArbitraryValue.gt(tmpRightValue);
	}

	/**
	 * Checks if the left value is greater than or equal to the right value.
	 * If either value is not a number, it is treated as 0.
	 *
	 * @param {number|string} pLeftValue - The left value to compare.
	 * @param {number|string} pRightValue - The right value to compare.
	 * @returns {boolean} - True if the left value is greater than or equal to the right value, false otherwise.
	 */
	gtePrecise(pLeftValue, pRightValue)
	{
		let tmpLeftValue = isNaN(pLeftValue) ? 0 : pLeftValue;
		let tmpRightValue = isNaN(pRightValue) ? 0 : pRightValue;

		let tmpLeftArbitraryValue = new this.bigNumber(tmpLeftValue);
		return tmpLeftArbitraryValue.gte(tmpRightValue);
	}

	/**
	 * Determines if the left value is less than the right value precisely.
	 *
	 * @param {number|string} pLeftValue - The left value to compare.
	 * @param {number|string} pRightValue - The right value to compare.
	 * @returns {boolean} - Returns true if the left value is less than the right value, otherwise returns false.
	 */
	ltPrecise(pLeftValue, pRightValue)
	{
		let tmpLeftValue = isNaN(pLeftValue) ? 0 : pLeftValue;
		let tmpRightValue = isNaN(pRightValue) ? 0 : pRightValue;

		let tmpLeftArbitraryValue = new this.bigNumber(tmpLeftValue);
		return tmpLeftArbitraryValue.lt(tmpRightValue);
	}

	/**
	 * Determines if the left value is less than or equal to the right value.
	 *
	 * @param {number|string} pLeftValue - The left value to compare.
	 * @param {number|string} pRightValue - The right value to compare.
	 * @returns {boolean} - Returns true if the left value is less than or equal to the right value, otherwise returns false.
	 */
	ltePrecise(pLeftValue, pRightValue)
	{
		let tmpLeftValue = isNaN(pLeftValue) ? 0 : pLeftValue;
		let tmpRightValue = isNaN(pRightValue) ? 0 : pRightValue;

		let tmpLeftArbitraryValue = new this.bigNumber(tmpLeftValue);
		return tmpLeftArbitraryValue.lte(tmpRightValue);
	}

	/**
	 * Comparison operator: returns "1" if left > right, "0" otherwise.
	 * For use as an infix operator in the expression parser.
	 *
	 * @param {number|string} pLeftValue - The left value to compare.
	 * @param {number|string} pRightValue - The right value to compare.
	 * @returns {string} - "1" if left > right, "0" otherwise.
	 */
	greaterThanOperator(pLeftValue, pRightValue)
	{
		return this.gtPrecise(pLeftValue, pRightValue) ? '1' : '0';
	}

	/**
	 * Comparison operator: returns "1" if left >= right, "0" otherwise.
	 * For use as an infix operator in the expression parser.
	 *
	 * @param {number|string} pLeftValue - The left value to compare.
	 * @param {number|string} pRightValue - The right value to compare.
	 * @returns {string} - "1" if left >= right, "0" otherwise.
	 */
	greaterThanOrEqualOperator(pLeftValue, pRightValue)
	{
		return this.gtePrecise(pLeftValue, pRightValue) ? '1' : '0';
	}

	/**
	 * Comparison operator: returns "1" if left < right, "0" otherwise.
	 * For use as an infix operator in the expression parser.
	 *
	 * @param {number|string} pLeftValue - The left value to compare.
	 * @param {number|string} pRightValue - The right value to compare.
	 * @returns {string} - "1" if left < right, "0" otherwise.
	 */
	lessThanOperator(pLeftValue, pRightValue)
	{
		return this.ltPrecise(pLeftValue, pRightValue) ? '1' : '0';
	}

	/**
	 * Comparison operator: returns "1" if left <= right, "0" otherwise.
	 * For use as an infix operator in the expression parser.
	 *
	 * @param {number|string} pLeftValue - The left value to compare.
	 * @param {number|string} pRightValue - The right value to compare.
	 * @returns {string} - "1" if left <= right, "0" otherwise.
	 */
	lessThanOrEqualOperator(pLeftValue, pRightValue)
	{
		return this.ltePrecise(pLeftValue, pRightValue) ? '1' : '0';
	}

	/**
	 * Comparison operator: returns "1" if left == right, "0" otherwise.
	 * For use as an infix operator in the expression parser.
	 *
	 * @param {number|string} pLeftValue - The left value to compare.
	 * @param {number|string} pRightValue - The right value to compare.
	 * @returns {string} - "1" if left == right, "0" otherwise.
	 */
	equalOperator(pLeftValue, pRightValue)
	{
		return this.comparePrecise(pLeftValue, pRightValue) == 0 ? '1' : '0';
	}

	/**
	 * Comparison operator: returns "1" if left != right, "0" otherwise.
	 * For use as an infix operator in the expression parser.
	 *
	 * @param {number|string} pLeftValue - The left value to compare.
	 * @param {number|string} pRightValue - The right value to compare.
	 * @returns {string} - "1" if left != right, "0" otherwise.
	 */
	notEqualOperator(pLeftValue, pRightValue)
	{
		return this.comparePrecise(pLeftValue, pRightValue) != 0 ? '1' : '0';
	}

	/**
	 * Converts degrees to radians with arbitrary precision.
	 *
	 * @param {number|string} pDegrees - The degrees to convert to radians.
	 * @returns {string} - The converted radians as a string.
	 */
	radPrecise(pDegrees)
	{
		let tmpDegrees = isNaN(pDegrees) ? 0 : pDegrees;

		let tmpDegreesArbitraryValue = new this.bigNumber(tmpDegrees);
		// TODO: Const for pi in arbitrary precision?
		let tmpResult = tmpDegreesArbitraryValue.times(Math.PI).div(180);
		return tmpResult.toString();
	}

	/**
	 * Calculates the value of pi with the specified precision.
	 * If no precision is provided, returns 100 digits after the decimal.
	 *
	 * @param {number|string} [pPrecision] - The precision to use for calculating pi.
	 * @returns {number} - The calculated value of pi.
	 */
	piPrecise(pPrecision)
	{
		if (typeof (pPrecision) === 'undefined')
		{
			return this.pi;
		}
		else
		{
			return this.roundPrecise(this.pi, pPrecision);
		}
	}

	/**
	 * Calculates the value of euler with the specified precision.
	 *
	 * @param {number|string} [pPrecision] - The precision to use for calculating E.
	 * @returns {string} - The calculated value of E.
	 */
	eulerPrecise(pPrecision)
	{
		if (typeof (pPrecision) === 'undefined')
		{
			return this.euler;
		}
		else
		{
			return this.roundPrecise(this.euler, pPrecision);
		}
	}

	/**
	 * Calculates the sine of the given angle in radians.
	 *
	 * @param {number} pRadians - The angle in radians.
	 * @returns {number} The sine of the angle.
	 */
	sin(pRadians)
	{
		let tmpRadians = isNaN(pRadians) ? 0 : pRadians;
		return Math.sin(tmpRadians);
	}

	/**
	 * Calculates the cosine of the given angle in radians.
	 *
	 * @param {number} pRadians - The angle in radians.
	 * @returns {number} The cosine of the angle.
	 */
	cos(pRadians)
	{
		let tmpRadians = isNaN(pRadians) ? 0 : pRadians;
		return Math.cos(tmpRadians);
	}

	/**
	 * Calculates the tangent of an angle in radians.
	 *
	 * @param {number} pRadians - The angle in radians.
	 * @returns {number} The tangent of the angle.
	 */
	tan(pRadians)
	{
		let tmpRadians = isNaN(pRadians) ? 0 : pRadians;
		return Math.tan(tmpRadians);
	}

	/* * * * * * * * * * * * * * * *
	 * Set functions
	 * These are meant to work fine with arrays and more complex set descriptions returned by Manyfest.
	 * Manyfest sometimes returns values as arrays and sometimes as a map of addresses with values depending
	 * on what was requested.
	 *
	 * The following functions will likely be broken into their own service.
	 */

	/**
	 * Counts the number of elements in a set.
	 *
	 * @param {Array|Object|any} pValueSet - The set to count the elements of.
	 * @returns {number} The number of elements in the set.
	 */
	countSetElements(pValueSet)
	{
		if (Array.isArray(pValueSet))
		{
			return pValueSet.length;
		}
		else if (typeof (pValueSet) === 'object')
		{
			return Object.keys(pValueSet).length;
		}
		else if (pValueSet)
		{
			// This is controversial.  Discuss with colleagues!
			return 1;
		}
		return 0;
	}

	/**
	 * Sorts the elements in the given value set in ascending order using the precise parsing and comparison.
	 *
	 * @param {Array|Object} pValueSet - The value set to be sorted.
	 * @returns {Array} - The sorted value set.
	 */
	sortSetPrecise(pValueSet)
	{
		let tmpSortedSet = [];
		if (Array.isArray(pValueSet))
		{
			for (let i = 0; i < pValueSet.length; i++)
			{
				tmpSortedSet.push(this.parsePrecise(pValueSet[i], NaN));
			}
		}
		else if (typeof (pValueSet) === 'object')
		{
			let tmpKeys = Object.keys(pValueSet);
			for (let i = 0; i < tmpKeys.length; i++)
			{
				tmpSortedSet.push(this.parsePrecise(pValueSet[tmpKeys[i]], NaN));
			}
		}

		tmpSortedSet.sort((pLeft, pRight) => { return this.comparePrecise(pLeft, pRight); });

		return tmpSortedSet;
	}

	/**
	 * Bucketizes a set of values based on a specified bucket size.
	 *
	 * @param {Array|Object} pValueSet - The set of values to be bucketized.
	 * @param {number} [pBucketSize] - The size of each bucket. Optional - If NaN, the values will be bucketized by their value.
	 * @returns {Object} - The bucketized set of values.
	 */
	bucketSetPrecise(pValueSet, pBucketSize)
	{
		let tmpBucketedSet = {};
		let tmpBucketSize = this.parsePrecise(pBucketSize, NaN);

		if (Array.isArray(pValueSet))
		{
			for (let i = 0; i < pValueSet.length; i++)
			{
				let tmpValue = this.parsePrecise(pValueSet[i], NaN);
				let tmpBucket = tmpValue.toString();
				if (!isNaN(tmpBucketSize))
				{
					tmpBucket = this.dividePrecise(pValueSet[i], tmpBucketSize);
				}
				if (!(tmpBucket in tmpBucketedSet))
				{
					tmpBucketedSet[tmpBucket] = 0;
				}
				tmpBucketedSet[tmpBucket] = tmpBucketedSet[tmpBucket] + 1;
			}
		}
		else if (typeof (pValueSet) === 'object')
		{
			let tmpKeys = Object.keys(pValueSet);
			for (let i = 0; i < tmpKeys.length; i++)
			{
				let tmpValue = this.parsePrecise(pValueSet[tmpKeys[i]], NaN);
				let tmpBucket = tmpValue.toString();
				if (!isNaN(tmpBucketSize))
				{
					tmpBucket = this.dividePrecise(pValueSet[i], tmpBucketSize);
				}
				if (!(tmpBucket in tmpBucketedSet))
				{
					tmpBucketedSet[tmpBucket] = 0;
				}
				tmpBucketedSet[tmpBucket] = tmpBucketedSet[tmpBucket] + 1;
			}
		}

		return tmpBucketedSet;
	}

	/**
	 * Calculates the histogram using precise bucket set for the given pValueSet.
	 *
	 * @param {Array<number>} pValueSet - The array of p-values.
	 * @returns {Array<number>} The histogram of the p-values.
	 */
	histogramPrecise(pValueSet)
	{
		return this.bucketSetPrecise(pValueSet);
	}

	/**
	 * Sorts the histogram object in ascending order based on the frequencies of the buckets.
	 *
	 * @param {Object} pHistogram - The histogram object to be sorted.
	 * @returns {Object} - The sorted histogram object.
	 */
	sortHistogramPrecise(pHistogram)
	{
		let tmpSortedHistogram = {};
		let tmpKeys = Object.keys(pHistogram);

		tmpKeys.sort((pLeft, pRight) => { return pHistogram[pLeft] - pHistogram[pRight]; });

		for (let i = 0; i < tmpKeys.length; i++)
		{
			tmpSortedHistogram[tmpKeys[i]] = pHistogram[tmpKeys[i]];
		}

		return tmpSortedHistogram;
	}

	/**
	 * Sorts the histogram object in ascending order based on the keys.
	 *
	 * @param {Object} pHistogram - The histogram object to be sorted.
	 * @returns {Object} - The sorted histogram object.
	 */
	sortHistogramByKeys(pHistogram, pDescending)
	{
		let tmpSortedHistogram = {};
		let tmpKeys = Object.keys(pHistogram);
		let tmpDescending = (typeof (pDescending) === 'undefined') ? false : pDescending;

		// Sort tmpKeys by the string comparison
		tmpKeys.sort();

		if (tmpDescending)
		{
			tmpKeys = tmpKeys.reverse();
		}

		for (let i = 0; i < tmpKeys.length; i++)
		{
			tmpSortedHistogram[tmpKeys[i]] = pHistogram[tmpKeys[i]];
		}

		return tmpSortedHistogram;
	}

	cleanValueArray(pValueArray, pRemoveZeroes)
	{
		let tmpRemoveZeroes = (typeof (pRemoveZeroes) === 'undefined') ? false : pRemoveZeroes;

		if (!Array.isArray(pValueArray))
		{
			return [];
		}

		let tmpCleanedArray = [];
		for (let i = 0; i < pValueArray.length; i++)
		{
			let tmpValue = this.parsePrecise(pValueArray[i], NaN);
			if (!isNaN(tmpValue) && (!tmpRemoveZeroes || (tmpValue != "0")))
			{
				tmpCleanedArray.push(tmpValue);
			}
		}
		return tmpCleanedArray;
	}

	/**
	 * Calculate the natural log of 2 to a specific precision, for use in the Taylor series.
	 * Cache outcome so it only runs once per precision.
	 * @param {number} pPrecision - The decimal precision to calculate ln(2) to.
	 * @returns
	 */
	arbitraryNaturalLogOfTwo(pPrecision)
	{
		const tmpPrecisionKey = pPrecision | 0;
		const tmpPrecision = new this.bigNumber(tmpPrecisionKey);
		if (this.ln2Cache.has(tmpPrecisionKey))
		{
			return this.ln2Cache.get(tmpPrecisionKey);
		}

		const tmpTwoConstant = new this.bigNumber(2);
		const y = tmpTwoConstant.minus(1).div(tmpTwoConstant.plus(1)); // 1/3
		const y2 = y.mul(y);
		let tmpSummation = new this.bigNumber(0);
		let tmpTermination = y;
		let tmpDenominator = 1;

		// Use a slightly larger precision for this to prevent numeric drift for larger log requirements
		const tmpEpsilon = this.powerPrecise(10, -(tmpPrecision.add(8))); // target tail < 10^-(precision+8)

		for (let i = 0; i < 200000; i++)
		{
			tmpSummation = tmpSummation.plus(tmpTermination.div(tmpDenominator));
			tmpTermination = tmpTermination.mul(y2);
			tmpDenominator += 2;
			if (tmpTermination.abs().div(tmpDenominator).lt(tmpEpsilon))
			{
				break;
			}
		}
		const tmpNaturalLogOfTwo = tmpSummation.mul(2);
		this.ln2Cache.set(tmpPrecisionKey, tmpNaturalLogOfTwo);
		return tmpNaturalLogOfTwo;
	}

	/**
	 * Calculate the natural log of a number to a specific precision using arbitrary precision numbers.
	 * @param {number} pNumberToCompute
	 * @param {number} pPrecision
	 * @returns
	 */
	arbitraryNaturalLog(pNumberToCompute, pPrecision)
	{
		let tmpNumberToCompute = new this.bigNumber(pNumberToCompute);
		let tmpPrecision = new this.bigNumber(pPrecision);

		if (tmpNumberToCompute.lte(0)) throw new Error('ln undefined for non-positive values.');
		if (tmpNumberToCompute.eq(1)) return new this.bigNumber(0);

		// Reduce x to m in ~[0.75, 1.5] by multiplying/dividing by 2
		const TWO = new this.bigNumber(2);
		let k = 0;
		let m = tmpNumberToCompute;

		const tmpUpperBounds = new this.bigNumber('1.5');
		const tmpLowerBounds = new this.bigNumber('0.75');

		while (m.gt(tmpUpperBounds))
		{
			m = m.div(TWO); k += 1;
		}
		while (m.lt(tmpLowerBounds))
		{
			m = m.mul(TWO); k -= 1;
		}

		// ln(m) via atanh/Taylor
		const y = m.minus(1).div(m.plus(1)); // |y| < 1
		const y2 = y.mul(y);

		let tmpSummation = new this.bigNumber(0);
		let tmpSeriesTermination = y; // y^(2j+1)
		let tmpDenominator = 1;

		const tmpEpsilon = this.powerPrecise(10, -(tmpPrecision.add(6))); // target tail < 10^-(precision+6)

		// Iterate until next term contribution is below eps
		for (let i = 0; i < 200000; i++)
		{
			tmpSummation = tmpSummation.plus(tmpSeriesTermination.div(tmpDenominator));
			tmpSeriesTermination = tmpSeriesTermination.mul(y2);
			tmpDenominator += 2;
			// Stop when |tmpSeriesTermination|/tmpDenominator < eps
			if (tmpSeriesTermination.abs().div(tmpDenominator).lt(tmpEpsilon))
			{
				break;
			}
		}
		const tmpNaturalLog = tmpSummation.mul(2);

		// ln(2) once per precision via same series with m=2 (y = 1/3 ==> for faster convergence)
		const tmpPrecisionNaturalLog = this.arbitraryNaturalLogOfTwo(tmpPrecision);

		return tmpNaturalLog.plus(tmpPrecisionNaturalLog.mul(k));
	}

	/**
	 * High-precision natural log using:
	 *  - Argument reduction by powers of 2: x = m * 2^k with m ~ 1
	 *  - atanh series: ln(m) = 2 * sum_{j>=0} y^(2j+1)/(2j+1), y=(m-1)/(m+1), |y|<1
	 *
	 * Converges rapidly when m is close to 1 with arbitrary precision numbers.
	 *
	 * @param {number} pNumberToGenerateLogarithmFor - The number to generate the logarithm for.
	 * @param {number} [pBase] - The base of the logarithm. Defaults to 10.
	 * @param {number} [pPrecision] - The precision of the result. Defaults to 9 decimal places.
	 * @returns {string} - The logarithm of the number to the specified base and precision.
	 */
	logPrecise(pNumberToGenerateLogarithmFor, pBase, pPrecision)
	{
		let tmpBase = (typeof (pBase) === 'undefined') ? this.bigNumber(10) : this.bigNumber(pBase);
		// Default precision is 9 decimal places -- matches Excel's default for LOG function
		const tmpPrecision = (typeof (pPrecision) === 'undefined') ? 9 : pPrecision;
		// Extra precision to avoid rounding errors since we are using a series
		const tmpExtraPrecision = 8;
		const tmpWorkingPrecision = tmpPrecision + tmpExtraPrecision;

		// Store existing precision since this function integrates on a its own precision terms
		const tmpSavedBigDecimalPrecision = this.bigNumber.DP;
		const tmpSavedBigRoundingMethod = this.bigNumber.RM;

		this.bigNumber.DP = tmpWorkingPrecision;
		this.bigNumber.RM = 1; // round half up for the Taylor series

		const N = this.bigNumber(pNumberToGenerateLogarithmFor);
		const B = this.bigNumber(tmpBase);

		// Run domain checks, which Excel also does
		if (N.lte(0))
		{
			this.log.error(`Fable logPrecise Error: Number must be greater than 0; number was ${pNumberToGenerateLogarithmFor}.`);
			return NaN;
		}
		if (B.lte(0) || B.eq(1))
		{
			this.log.error(`Fable logPrecise Error: Base must be greater than 0 and not equal to 1 -- base ${Base} was passed in.`);
			return NaN;
		}

		const tmpNaturalLogOfN = this.arbitraryNaturalLog(N, tmpPrecision);
		const tmpNaturalLogOfB = this.arbitraryNaturalLog(B, tmpPrecision);

		const tmpResult = tmpNaturalLogOfN.div(tmpNaturalLogOfB);

		// Final rounding to requested precision
		let finalResult = tmpResult.toFixed(tmpPrecision);
		this.bigNumber.DP = tmpSavedBigDecimalPrecision;
		this.bigNumber.RM = tmpSavedBigRoundingMethod;
		return finalResult;
	}

	expPrecise(pValue, pDecimalPrecision)
	{
		let tmpValue = isNaN(pValue) ? this.bigNumber(1) : this.bigNumber(pValue);

		// Constants & thresholds (Excel / IEEE-754 double limits) -- this is required to match Excel's behavior
		const tmpDecimalPrecision = (typeof (pDecimalPrecision) === 'undefined') ? 9 : parseInt(pDecimalPrecision, 10);
		const tmpSavedBigDecimalPrecision = this.bigNumber.DP;
		this.bigNumber.DP = tmpDecimalPrecision + 10; // a bit of extra precision for rounding safety (this makes it match excel)

		// ln(2), min/max natural logs before double overflow/underflow
		const tmpNaturalLogOfTwo = new this.bigNumber('0.693147180559945309417232121458176568'); // This is hilarious that we can compute the value above but this is what Excel uses.
		const tmpNaturalLogMaxDouble = new this.bigNumber('709.782712893384'); // ln(1.7976931348623157e308)
		const tmpNaturalLogMinimumValue = new this.bigNumber('-744.4400719213812'); // ln(5e-324)

		// 1. Guard for Overflow / underflow behavior to match Excel
		if (tmpValue.gt(tmpNaturalLogMaxDouble))
		{
			this.bigNumber.DP = tmpSavedBigDecimalPrecision;
			return NaN; // Excel shows #NUM! when result overflows we will use NaN
		}
		if (tmpValue.lt(tmpNaturalLogMinimumValue))
		{
			this.bigNumber.DP = tmpSavedBigDecimalPrecision;
			return new this.bigNumber(0); // Excel underflows to 0
		}

		// 2. Perform Range reduction: x = k*ln2 + r, with r small
		// k = floor(x / ln2)
		let k;
		try
		{
			k = tmpValue.div(tmpNaturalLogOfTwo).round(0, 0 /* RoundDown toward -infinity */); // floor for positives & negatives
		}
		catch(pErrorRounding)
		{
			this.log.error(`Fable expPrecise Error: Rounding error during range reduction for value of ${pValue}.  Error: ${pErrorRounding}`);
			this.bigNumber.DP = tmpSavedBigDecimalPrecision;
			return NaN;
		}
		const r = tmpValue.minus(k.times(tmpNaturalLogOfTwo));

		// Compute exp(r) via Taylor series with Big arithmetic
		// exp(r) = Summation of r^n / n!, n=0..infinity
		// Sum until termination is below tolerance based on decimal precision
		const tmpTolerance = new this.bigNumber(10).pow(-(tmpDecimalPrecision + 2));
		let tmpTermination = new this.bigNumber(1); // r^0/0! = 1
		let tmpSummation = new this.bigNumber(1);
		let n = 1;

		// 3. Multiply incrementally: term *= r / n
		// SOOOOO close to a fractal!
		while (true)
		{
			tmpTermination = tmpTermination.times(r).div(n);
			if (tmpTermination.abs().lt(tmpTolerance)) break;
			tmpSummation = tmpSummation.plus(tmpTermination);
			n++;
			// Hard safety cap for pathological inputs (shouldn’t be possible with step 2's range reduction):
			if (n > 2000)
			{
				this.log.warn(`Fable expPrecise warning: Taylor series failed to converge after 2000 iterations for value of ${pValue}.`);
				break;
			}
		}

		// 4. Recompose: exp(x) = 2^k * exp(r)
		const tmpTwo = new this.bigNumber(2);
		const tmpAbsoluteValueOfK = k.abs().toNumber(); // k is integer; big.js pow requires a JS integer
		let tmpTwoToThePowerOfAbsoluteK = tmpAbsoluteValueOfK === 0 ? new this.bigNumber(1) : tmpTwo.pow(tmpAbsoluteValueOfK);
		const tmpResult = k.gte(0) ? tmpSummation.times(tmpTwoToThePowerOfAbsoluteK) : tmpSummation.div(tmpTwoToThePowerOfAbsoluteK);

		// 5. Restore global decimal precision
		this.bigNumber.DP = tmpSavedBigDecimalPrecision;
		return tmpResult.round(tmpDecimalPrecision).toString();
	}

	cleanValueObject(pValueObject)
	{
		if (typeof (pValueObject) !== 'object')
		{
			return {};
		}

		//TODO: is this right?
		let tmpCleanedObject = {};
		let tmpKeys = Object.keys(pValueObject);
		for (let i = 0; i < tmpKeys.length; i++)
		{
			let tmpValue = this.parsePrecise(pValueObject[tmpKeys[i]], NaN);
			if (!isNaN(tmpValue))
			{
				tmpCleanedObject[tmpKeys[i]] = tmpValue;
			}
		}
		return tmpCleanedObject;
	}

	/**
	 * Make a histogram of representative counts for exact values (.tostring() is the keys to count)
	 * @param {Array} pValueSet
	 * @param {string} pValueAddress
	 */
	histogramDistributionByExactValue(pValueObjectSet, pValueAddress, pManifest)
	{
		if (!Array.isArray(pValueObjectSet))
		{
			return pValueObjectSet;
		}

		if (!pValueAddress)
		{
			return {};
		}

		let tmpHistogram = {};
		for (let i = 0; i < pValueObjectSet.length; i++)
		{
			let tmpValue = this.fable.Utility.getValueByHash(pValueObjectSet[i], pValueAddress, pManifest).toString();

			if (!(tmpValue in tmpHistogram))
			{
				tmpHistogram[tmpValue] = 0;
			}
			tmpHistogram[tmpValue] = tmpHistogram[tmpValue] + 1;
		}

		return tmpHistogram;
	}

	histogramDistributionByExactValueFromInternalState(pValueObjectSetAddress, pValueAddress)
	{
		if (!pValueObjectSetAddress)
		{
			return {};
		}

		let tmpValueObjectSet = this.fable.Utility.getInternalValueByHash(pValueObjectSetAddress);
		return this.histogramDistributionByExactValue(tmpValueObjectSet, pValueAddress);
	}

	/**
	 * Make a histogram of representative counts for exact values (.tostring() is the keys to count)
	 * @param {Array} pValueSet
	 * @param {string} pValueAddress
	 */
	histogramAggregationByExactValue(pValueObjectSet, pValueAddress, pValueAmountAddress, pManifest)
	{
		if (!Array.isArray(pValueObjectSet))
		{
			return pValueObjectSet;
		}

		if (!pValueAddress || !pValueAmountAddress)
		{
			return {};
		}

		let tmpHistogram = {};
		for (let i = 0; i < pValueObjectSet.length; i++)
		{
			let tmpValue = this.fable.Utility.getValueByHash(pValueObjectSet[i], pValueAddress, pManifest);
			if (typeof(tmpValue) === undefined)
			{
				continue;
			}
			let tmpAmount = this.parsePrecise(this.fable.Utility.getValueByHash(pValueObjectSet[i], pValueAmountAddress, pManifest), NaN);

			if (!(tmpValue in tmpHistogram))
			{
				tmpHistogram[tmpValue] = 0;
			}

			if (!isNaN(tmpAmount))
			{
				tmpHistogram[tmpValue] = this.addPrecise(tmpHistogram[tmpValue], tmpAmount);
			}
		}

		return tmpHistogram;
	}

	/**
	 * Aggregates a histogram by exact value from an internal state object.
	 *
	 * @param {string} pValueObjectSetAddress - The address of the internal value object set.
	 * @param {string} pValueAddress - The address of the value to aggregate by.
	 * @param {string} pValueAmountAddress - The address of the amount to aggregate.
	 * @returns {Object} The aggregated histogram object. Returns an empty object if the value object set address is not provided.
	 */
	histogramAggregationByExactValueFromInternalState(pValueObjectSetAddress, pValueAddress, pValueAmountAddress)
	{
		if (!pValueObjectSetAddress)
		{
			return {};
		}

		let tmpValueObjectSet = this.fable.Utility.getInternalValueByHash(pValueObjectSetAddress);
		return this.histogramAggregationByExactValue(tmpValueObjectSet, pValueAddress, pValueAmountAddress);
	}

	/**
	 * Given a value object set (an array of objects), find a specific entry when
	 * sorted by a specific value address.  Supports -1 syntax for last entry.
	 * @param {Array} pValueObjectSet
	 * @param {string} pValueAddress
	 * @param {Object} pManifest
	 */
	entryInSet(pValueObjectSet, pValueAddress, pEntryIndex)
	{
		const tmpEntryIndex = typeof pEntryIndex === 'number' ? pEntryIndex : parseInt(pEntryIndex);
		if (!Array.isArray(pValueObjectSet))
		{
			return pValueObjectSet;
		}

		if (!pValueAddress)
		{
			return false;
		}

		if (isNaN(tmpEntryIndex) || tmpEntryIndex >= pValueObjectSet.length)
		{
			return false;
		}

		let tmpValueArray = pValueObjectSet.toSorted((pLeft, pRight) => { return this.comparePrecise(pLeft[pValueAddress], pRight[pValueAddress]); });
		let tmpIndex = (tmpEntryIndex < 0) ? tmpValueArray.length + tmpEntryIndex : tmpEntryIndex;
		return tmpValueArray[tmpIndex];
	}

	/**
	 * Finds the smallest value in a set of objects based on a specified value address.
	 *
	 * @param {Object[]} pValueObjectSet - An array of objects to search through.
	 * @param {string} pValueAddress - The key or path used to access the value within each object.
	 * @returns {*} The smallest value found in the set at the specified value address.
	 */
	smallestInSet(pValueObjectSet, pValueAddress)
	{
		return this.entryInSet(pValueObjectSet, pValueAddress, 0);
	}

	/**
	 * Finds the largest value in a set of objects based on a specified value address.
	 *
	 * @param {Object[]} pValueObjectSet - An array of objects to search through.
	 * @param {string} pValueAddress - The address (key or path) within each object to compare values.
	 * @returns {*} The largest value found at the specified address in the set of objects.
	 */
	largestInSet(pValueObjectSet, pValueAddress)
	{
		return this.entryInSet(pValueObjectSet, pValueAddress, -1);
	}

	/**
	 * Expects an array of objects, and an address in each object to sum.  Expects
	 * an address to put the cumulative summation as well.
	 *
	 * @param {Array} pValueObjectSet - The array of objects to perform a cumulative summation on
	 * @param {string} pValueAddress - The address of the column in each object to sum
	 * @param {string} pCumulationResultAddress - The address in each object to put the cumulative summation result
	 * @param {Object} pManifest - The manifest to use for value retrieval and setting
	 * @returns {Array} The updated value object set with cumulative summation results.
	 */
	cumulativeSummation(pValueObjectSet, pValueAddress, pCumulationResultAddress, pManifest)
	{
		return this.iterativeSeries(pValueObjectSet, pValueAddress, pCumulationResultAddress, "1.0", "add", "0.0", true, pManifest);
	}

	/**
	 * Expects an array of objects, and an address in each object to sum.  Expects
	 * an address to put the cumulative summation as well.
	 *
	 * @param {Array} pValueObjectSet - The array of objects to perform a cumulative summation on
	 * @param {string} pValueAddress - The address of the column in each object to sum
	 * @param {string} pCumulationResultAddress - The address in each object to put the cumulative summation result
	 * @param {string} pStartingValue - The (optional) address of the value to start with
	 * @param {Object} pManifest - The manifest to use for value retrieval and setting
	 * @returns {Array} The updated value object set with cumulative summation results.
	 */
	subtractingSummation(pValueObjectSet, pValueAddress, pCumulationResultAddress, pStartingValue, pManifest)
	{
		let tmpProcessFirstRow = true;
		// If the starting value comes from somewhere else, we want to subtract the first row from it.
		if (typeof (pStartingValue) === 'undefined' || pStartingValue === null)
		{
			tmpProcessFirstRow = false;
		}
		return this.iterativeSeries(pValueObjectSet, pValueAddress, pCumulationResultAddress, "1.0", "subtract", pStartingValue, tmpProcessFirstRow, pManifest);
	}

	/**
	 * Expects an array of objects, and an address in each object to perform an iterative mathematical operation on.

	 * @param {Array} pValueObjectSet - The array of objects to perform a cumulative summation on
	 * @param {string} pValueAddress - The address of the column in each object to sum
	 * @param {string} pValueMultiplier - The multiplier to apply to each value before summation
	 * @param {string} pSummationOperation - The operation to perform for summation: +, -, *, / (and some textual equivalents)
	 * @param {string} pCumulationResultAddress - The address in each object to put the cumulative summation result
	 * @param {string} pStartingValue - The address of the value to process from; defaults to the first row
	 * @param {boolean} pProcessFirstRowWithAValue - Whether to process the first row's value from all subsequent rows
	 * @param {Object} pManifest - The manifest to
	 * @returns {Array} The updated value object set with cumulative summation results.
	 */
	iterativeSeries(pValueObjectSet, pValueAddress, pCumulationResultAddress, pValueMultiplier, pSummationOperation, pStartingValue, pProcessFirstRowWithAValue, pManifest)
	{
		if (!Array.isArray(pValueObjectSet))
		{
			return pValueObjectSet;
		}

		if (!pValueAddress || !pCumulationResultAddress)
		{
			return pValueObjectSet;
		}

		// By default don't subtract the first row from the value
		let tmpProcessFirstRow = (typeof(pProcessFirstRowWithAValue) === 'undefined') ? false : pProcessFirstRowWithAValue;

		let tmpValueMultiplier;
		if (pValueMultiplier && pValueMultiplier !== '')
		{
			tmpValueMultiplier = this.parsePrecise(pValueMultiplier);
		}
		if (isNaN(tmpValueMultiplier))
		{
			tmpValueMultiplier = this.parsePrecise("1.0");
		}

		// Default to start from the current value address
		let tmpSummationValue;
		// This logic ensures we don't default to 0 when pStartingValue is an empty string
		if (pStartingValue || (pStartingValue !== ''))
		{
			tmpSummationValue = this.parsePrecise(pStartingValue);
		}
		if (isNaN(tmpSummationValue) || typeof(pStartingValue) === 'undefined' || pStartingValue === null)
		{
			tmpSummationValue = '';
		}

		for (let i = 0; i < pValueObjectSet.length; i++)
		{
			let tmpValue = this.parsePrecise(this.fable.Utility.getValueByHash(pValueObjectSet[i], pValueAddress, pManifest));
			// Since summation might start on a row after the first,
			let tmpFirstRowWithValue = false;
			if ((tmpSummationValue === '') && tmpValue && !isNaN(tmpSummationValue))
			{
				// Try to grab the summation value from the first row with a value
				tmpSummationValue = tmpValue;
				tmpFirstRowWithValue = true;
			}

			// Continue on with the values as they are if the current row doesn't have a change
			if (isNaN(tmpValue))
			{
				this.fable.Utility.setValueByHash(pValueObjectSet[i], pCumulationResultAddress, tmpSummationValue, pManifest);
				continue;
			}

			tmpValue = this.multiplyPrecise(tmpValue, tmpValueMultiplier);

			// Now perform the operation
			if (!tmpFirstRowWithValue || tmpProcessFirstRow)
			{
				switch (pSummationOperation)
				{
					case '+':
					case 'add':
					case 'plus':
					case 'addition':
						tmpSummationValue = this.addPrecise(tmpSummationValue, tmpValue);
						break;

					case '-':
					case 'sub':
					case 'minus':
					case 'subtract':
						tmpSummationValue = this.subtractPrecise(tmpSummationValue, tmpValue);
						break;

					case '*':
					case 'mul':
					case 'times':
					case 'multiply':
						tmpSummationValue = this.multiplyPrecise(tmpSummationValue, tmpValue);
						break;

					case '-':
					case 'div':
					case 'over':
					case 'divide':
						tmpSummationValue = this.dividePrecise(tmpSummationValue, tmpValue);
						break;
				}
			}
			this.fable.Utility.setValueByHash(pValueObjectSet[i], pCumulationResultAddress, tmpSummationValue, pManifest);
		}

		return pValueObjectSet;
	}

	/**
	 * Finds the maximum value from a set of precise values.
	 *
	 * @param {Array|Object} pValueSet - The set of values to find the maximum from.
	 * @returns {number} - The maximum value from the set.
	 */
	maxPrecise(pValueSet)
	{
		let tmpMaxValue = NaN;
		if (Array.isArray(pValueSet))
		{
			for (let i = 0; i < pValueSet.length; i++)
			{
				if (!tmpMaxValue)
				{
					tmpMaxValue = this.parsePrecise(pValueSet[i], NaN);
				}
				else
				{
					let tmpComparisonValue = this.parsePrecise(pValueSet[i], NaN);
					if (this.gtPrecise(tmpComparisonValue, tmpMaxValue))
					{
						tmpMaxValue = tmpComparisonValue;
					}
				}
			}
		}
		else if (typeof (pValueSet) === 'object')
		{
			let tmpKeys = Object.keys(pValueSet);
			for (let i = 0; i < tmpKeys.length; i++)
			{
				if (!tmpMaxValue)
				{
					tmpMaxValue = this.parsePrecise(pValueSet[tmpKeys[i]], NaN);
				}
				else
				{
					let tmpComparisonValue = this.parsePrecise(pValueSet[tmpKeys[i]], NaN);
					if (this.gtPrecise(tmpComparisonValue, tmpMaxValue))
					{
						tmpMaxValue = tmpComparisonValue;
					}
				}
			}
		}
		return tmpMaxValue;
	}

	/**
	 * Finds the minimum value from a set of values.
	 *
	 * @param {Array|Object} pValueSet - The set of values to find the minimum from.
	 * @returns {number} The minimum value from the set.
	 */
	minPrecise(pValueSet)
	{
		let tmpMinValue = NaN;
		if (Array.isArray(pValueSet))
		{
			for (let i = 0; i < pValueSet.length; i++)
			{
				if (!tmpMinValue)
				{
					tmpMinValue = this.parsePrecise(pValueSet[i], NaN);
				}
				else
				{
					let tmpComparisonValue = this.parsePrecise(pValueSet[i], NaN);
					if (!isNaN(tmpComparisonValue) && this.ltPrecise(tmpComparisonValue, tmpMinValue))
					{
						tmpMinValue = tmpComparisonValue;
					}
				}
			}
		}
		else if (typeof (pValueSet) === 'object')
		{
			let tmpKeys = Object.keys(pValueSet);
			for (let i = 0; i < tmpKeys.length; i++)
			{
				if (!tmpMinValue)
				{
					tmpMinValue = this.parsePrecise(pValueSet[tmpKeys[i]], NaN);
				}
				else
				{
					let tmpComparisonValue = this.parsePrecise(pValueSet[tmpKeys[i]], NaN);
					if (!isNaN(tmpComparisonValue) && this.ltPrecise(tmpComparisonValue, tmpMinValue))
					{
						tmpMinValue = tmpComparisonValue;
					}
				}
			}
		}
		return tmpMinValue;
	}

	/**
	 * Calculates the precise sum of values in the given value set.
	 *
	 * @param {Array|Object} pValueSet - The value set to calculate the sum from.
	 * @returns {string} The precise sum value as a string.
	 */
	sumPrecise(pValueSet)
	{
		let tmpSumValue = "0.0";
		if (Array.isArray(pValueSet))
		{
			for (let i = 0; i < pValueSet.length; i++)
			{
				let tmpComparisonValue = this.parsePrecise(pValueSet[i], NaN);
				if (!isNaN(tmpComparisonValue))
				{
					tmpSumValue = this.addPrecise(tmpSumValue, tmpComparisonValue);
				}
			}
		}
		else if (typeof (pValueSet) === 'object')
		{
			let tmpKeys = Object.keys(pValueSet);
			for (let i = 0; i < tmpKeys.length; i++)
			{
				let tmpComparisonValue = this.parsePrecise(pValueSet[tmpKeys[i]], NaN);
				if (!isNaN(tmpComparisonValue))
				{
					tmpSumValue = this.addPrecise(tmpSumValue, tmpComparisonValue);
				}
			}
		}
		return tmpSumValue;
	}

	/**
	 * Calculates the precise mean of a given value set.
	 *
	 * @param {Array<string|number>} pValueSet - The array of values to calculate the mean.
	 * @returns {string} The precise mean value as a string.
	 */
	meanPrecise(pValueSet)
	{
		let tmpSumValue = this.sumPrecise(pValueSet);
		let tmpCount = this.countSetElements(pValueSet);
		if (tmpCount == 0)
		{
			return '0.0';
		}
		return this.dividePrecise(tmpSumValue, tmpCount);
	}

	/**
	 * Calculates the average of an array of values precisely.
	 *
	 * @param {Array<string|number>} pValueSet - The array of values to calculate the average of.
	 * @returns {string} The precise average of the values.
	 */
	averagePrecise(pValueSet)
	{
		return this.meanPrecise(pValueSet);
	}

	/**
	 * Calculates the precise median value of a given value set.
	 *
	 * @param {Array<number>} pValueSet - The array of values to calculate the median from.
	 * @returns {number|string} - The median value of the given value set. If the value set is empty, returns '0.0'.
	 */
	medianPrecise(pValueSet)
	{
		let tmpCount = this.countSetElements(pValueSet);
		// If there are no elements, return 0 ... should this be NaN?
		if (tmpCount == 0)
		{
			return '0.0';
		}

		let tmpSortedValueSet = this.sortSetPrecise(pValueSet);
		let tmpMiddleElement = Math.floor(tmpCount / 2);

		// If the count is odd, return the middle element
		if (tmpCount % 2 == 1)
		{
			return tmpSortedValueSet[tmpMiddleElement];
		}
		// If the count is even, return the average of the two middle elements
		else
		{
			let tmpLeftMiddleValue = tmpSortedValueSet[tmpMiddleElement - 1];
			let tmpRightMiddleValue = tmpSortedValueSet[tmpMiddleElement];
			return this.dividePrecise(this.addPrecise(tmpLeftMiddleValue, tmpRightMiddleValue), 2);
		}
	}

	/**
	 * Calculates the mode (most frequently occurring value) of a given value set using precise mode calculation.
	 *
	 * @param {Array} pValueSet - The array of values to calculate the mode from.
	 * @returns {Array} - An array containing the mode value(s) from the given value set.
	 */
	modePrecise(pValueSet)
	{
		let tmpHistogram = this.bucketSetPrecise(pValueSet);
		let tmpMaxCount = 0;

		// Philosophical question about whether the values should be returned sorted.
		let tmpHistogramValueSet = Object.keys(tmpHistogram);

		let tmpModeValueSet = [];

		for (let i = 0; i < tmpHistogramValueSet.length; i++)
		{
			if (tmpHistogram[tmpHistogramValueSet[i]] > tmpMaxCount)
			{
				tmpMaxCount = tmpHistogram[tmpHistogramValueSet[i]];
				tmpModeValueSet = [tmpHistogramValueSet[i]];
			}
			else if (tmpHistogram[tmpHistogramValueSet[i]] == tmpMaxCount)
			{
				tmpModeValueSet.push(tmpHistogramValueSet[i]);
			}
		}

		return tmpModeValueSet;
	}

	/**
	 * Calculates the variance of a given value set using precise mode calculation.
	 *
	 * @param {Array<string|number>} pValueSet - The array of values to calculate the variance from.
	 * @param {boolean} [pIsPopulation=false] - Whether to calculate population variance (true) or sample variance (false).
	 *
	 * @return {string} - The variance of the given value set.
	 */
	variancePrecise(pValueSet, pIsPopulation = false)
	{
		let tmpValueSet = pValueSet;
		if (!Array.isArray(tmpValueSet) && typeof tmpValueSet === 'object')
		{
			tmpValueSet = Object.keys(tmpValueSet).map((pKey) => tmpValueSet[pKey]);
		}
		const tmpMeanValue = this.meanPrecise(tmpValueSet);
		const tmpVarianceSum = tmpValueSet.reduce((pAccumulator, pValue) =>
		{
			const tmpDiff = this.subtractPrecise(pValue, tmpMeanValue);
			const tmpSquaredDiff = this.multiplyPrecise(tmpDiff, tmpDiff);
			return this.addPrecise(pAccumulator, tmpSquaredDiff);
		}, '0.0');
		return this.dividePrecise(tmpVarianceSum, pIsPopulation ? tmpValueSet.length : tmpValueSet.length - 1);
	}

	/**
	 * Calculates the variance of a given population of values using precise mode calculation.
	 *
	 * @param {Array<string|number>} pValueSet - The array of values to calculate the variance from.
	 *
	 * @return {string} - The variance of the given value set.
	 */
	populationVariancePrecise(pValueSet)
	{
		return this.variancePrecise(pValueSet, true);
	}

	/**
	 * Calculates the standard deviation of a given value set using precise mode calculation.
	 *
	 * @param {Array<string|number>} pValueSet - The array of values to calculate the standard deviation from.
	 * @param {boolean} [pIsPopulation=false] - Whether to calculate population variance (true) or sample variance (false).
	 *
	 * @return {string} - The standard deviation of the given value set.
	 */
	standardDeviationPrecise(pValueSet, pIsPopulation = false)
	{
		return this.sqrtPrecise(this.variancePrecise(pValueSet, pIsPopulation));
	}

	/**
	 * Calculates the standard deviation of a given population of values using precise mode calculation.
	 *
	 * @param {Array<string|number>} pValueSet - The array of values to calculate the standard deviation from.
	 *
	 * @return {string} - The standard deviation of the given value set.
	 */
	populationStandardDeviationPrecise(pValueSet)
	{
		return this.standardDeviationPrecise(pValueSet, true);
	}

	/**
	 * Performs an nth degree polynomial regression on the given data points.
	 *
	 * @param {Array<number|string>} pXVector - The x-coordinates of the data points.
	 * @param {Array<number|string>} pYVector - The y-coordinates of the data points.
	 * @param {number} [pDegree=2] - The degree of the polynomial to fit.
	 *
	 * @return {Array<number|string>} The coefficients of the fitted polynomial, starting from the constant term.
	 */
	polynomialRegression(pXVector, pYVector, pDegree = 2)
	{
		const n = pDegree;
		const tmpXMatrix = [];
		const tmpYVector = pYVector;

		// Build Vandermonde matrix
		for (let i = 0; i < pXVector.length; ++i)
		{
			const row = [];
			for (let j = 0; j <= n; j++)
			{
				row.push(this.powerPrecise(pXVector[i], j));
			}
			tmpXMatrix.push(row);
		}

		// Compute coefficients
		const X_T = this.matrixTranspose(tmpXMatrix);
		const XTX = this.matrixMultiply(X_T, tmpXMatrix);
		const XTY = this.matrixMultiply(X_T, tmpYVector.map(v => [v]));
		const XTX_inv = this.matrixInverse(XTX);
		const A = this.matrixMultiply(XTX_inv, XTY);

		// Flatten coefficients
		return A.map((row) => row[0]);
	}

	/**
	 * Compute least squares regression coefficients for multivariable linear interpolation.
	 *
	 * @param {Array<Array<number|string>> | Array<number|string> | string} pIndependentVariableVectors - array of arrays [[x11, x12, ...], [x21, x22, ...], ...] or single array for single variable.
	 * @param {Array<number|string>|string} pDependentVariableVector - array of target values [y1, y2, ...]
	 *
	 * @return {Array<number|string>} - linear coefficients [b0, b1, ..., bn] where y = b0 + b1*x1 + b2*x2 + ... + bn*xn
	 */
	leastSquares(pIndependentVariableVectors, pDependentVariableVector)
	{
		const tmpIndependentVariableVectors = Array.isArray(pIndependentVariableVectors) ? (Array.isArray(pIndependentVariableVectors[0]) ? this.matrixTranspose(pIndependentVariableVectors) : pIndependentVariableVectors.map(value => [value])) : [ [ pIndependentVariableVectors ] ];
		const tmpDependentVariableVector = Array.isArray(pDependentVariableVector) ? pDependentVariableVector : [ pDependentVariableVector ];
		if (tmpIndependentVariableVectors.length  === 1)
		{
			// degenerate case: only one independent variable value, result is just a y-intercept
			return [ tmpDependentVariableVector[0], '0.0' ];
		}
		// Add bias term (intercept)
		const tmpIndependentVariableMatrixWithBiasTerm = tmpIndependentVariableVectors.map(row => [1, ...row]);

		// Compute X^T * X
		const tmpIndependentTermTranpose = this.matrixTranspose(tmpIndependentVariableMatrixWithBiasTerm);
		const tmpDependentTransposeMultiplication = this.matrixMultiply(tmpIndependentTermTranpose, tmpIndependentVariableMatrixWithBiasTerm);

		// Compute X^T * y
		const tmpIndependentTransposeMultiplication = this.matrixVectorMultiply(tmpIndependentTermTranpose, tmpDependentVariableVector);

		// Solve (XtX) * beta = Xty
		const tmpLinearCoefficients = this.gaussianElimination(tmpDependentTransposeMultiplication, tmpIndependentTransposeMultiplication);

		return tmpLinearCoefficients;
	}

	/**
	 * Helper function to transpose a matrix
	 *
	 * @param {Array<Array<number|string>>} pInputMatrix - matrix to transpose
	 *
	 * @return {Array<Array<number|string>>} - transposed matrix
	 */
	matrixTranspose(pInputMatrix)
	{
		return pInputMatrix[0].map((_, i) => pInputMatrix.map((row) => row[i]));
	}

	matrixMultiply(pLHSMatrix, pRHSMatrix)
	{
		const result = Array(pLHSMatrix.length)
			.fill(0)
			.map(() => Array(pRHSMatrix[0].length).fill(0));
		for (let i = 0; i < pLHSMatrix.length; ++i)
		{
			for (let j = 0; j < pRHSMatrix[0].length; ++j)
			{
				for (let k = 0; k < pRHSMatrix.length; ++k)
				{
					result[i][j] = this.addPrecise(result[i][j], this.multiplyPrecise(pLHSMatrix[i][k], pRHSMatrix[k][j]));
				}
			}
		}
		return result;
	}

	/**
	 * @param {Array<Array<number|string>>} pMatrix - matrix to multiply
	 * @param {Array<number|string>} pVector - vector to multiply
	 *
	 * @return {Array<number|string>} - result vector
	 */
	matrixVectorMultiply(pMatrix, pVector)
	{
		const result = Array(pMatrix.length).fill(0);
		for (let i = 0; i < pMatrix.length; ++i)
		{
			for (let j = 0; j < pMatrix[0].length; ++j)
			{
				result[i] = this.addPrecise(result[i], this.multiplyPrecise(pMatrix[i][j], pVector[j]));
			}
		}
		return result;
	}

	/**
	 * Matrix inverse (using Gaussian elimination)
	 *
	 * @param {Array<Array<number|string>>} pMatrix - matrix to invert
	 *
	 * @return {Array<Array<number|string>>} - inverted matrix
	 */
	matrixInverse(pMatrix)
	{
		const n = pMatrix.length;
		const tmpIdentityMatrix = pMatrix.map((row, i) => row.map((_, j) => (i === j ? 1 : 0)));
		const tmpAugmentedMatrix = pMatrix.map((row, i) => row.concat(tmpIdentityMatrix[i]));

		for (let i = 0; i < n; ++i)
		{
			// Pivot
			let maxRow = i;
			for (let k = i + 1; k < n; ++k)
			{
				if (this.gtPrecise(this.absPrecise(tmpAugmentedMatrix[k][i]), this.absPrecise(tmpAugmentedMatrix[maxRow][i])))
				{
					maxRow = k;
				}
			}
			[tmpAugmentedMatrix[i], tmpAugmentedMatrix[maxRow]] = [tmpAugmentedMatrix[maxRow], tmpAugmentedMatrix[i]];

			// divide by pivot
			const tmpPivotValue = tmpAugmentedMatrix[i][i];
			for (let j = 0; j < 2 * n; ++j)
			{
				tmpAugmentedMatrix[i][j] = this.dividePrecise(tmpAugmentedMatrix[i][j], tmpPivotValue);
			}

			// Eliminate other rows
			for (let k = 0; k < n; ++k)
			{
				if (k === i)
				{
					continue;
				}
				const tmpFactor = tmpAugmentedMatrix[k][i];
				for (let j = 0; j < 2 * n; ++j)
				{
					tmpAugmentedMatrix[k][j] = this.subtractPrecise(tmpAugmentedMatrix[k][j], this.multiplyPrecise(tmpFactor, tmpAugmentedMatrix[i][j]));
				}
			}
		}

		// Extract right half (inverse)
		return tmpAugmentedMatrix.map((row) => row.slice(n));
	}


	/**
	 * Compute solution to linear system using Gaussian elimination.
	 *
	 * @param {Array<Array<number|string>>} pCoefficientMatrix - Coefficient matrix
	 * @param {Array<number|string>} pVector - Right-hand side vector
	 *
	 * @return {Array<number|string>} - Solution vector x
	 */
	gaussianElimination(pCoefficientMatrix, pVector)
	{
		// Solve A*x = b using Gaussian elimination
		const n = pCoefficientMatrix.length;
		const tmpAugmentedMatrix = pCoefficientMatrix.map((row, i) => [...row, pVector[i]]);

		for (let i = 0; i < n; ++i)
		{
			// Pivot
			let maxRow = i;
			for (let k = i + 1; k < n; ++k)
			{
				if (this.gtPrecise(this.absPrecise(tmpAugmentedMatrix[k][i]), this.absPrecise(tmpAugmentedMatrix[maxRow][i])))
				{
					maxRow = k;
				}
			}
			const tmpSwapValue = tmpAugmentedMatrix[i];
			tmpAugmentedMatrix[i] = tmpAugmentedMatrix[maxRow];
			tmpAugmentedMatrix[maxRow] = tmpSwapValue;

			// Normalize pivot row
			const tmpPivotValue = tmpAugmentedMatrix[i][i];
			if (this.comparePrecise(tmpPivotValue, 0) == 0)
			{
				throw new Error('Matrix not invertible');
			}
			for (let j = i; j <= n; ++j)
			{
				tmpAugmentedMatrix[i][j] = this.dividePrecise(tmpAugmentedMatrix[i][j], tmpPivotValue);
			}

			// Eliminate other rows
			for (let k = 0; k < n; ++k)
			{
				if (k === i)
				{
					continue;
				}
				const tmpFactor = tmpAugmentedMatrix[k][i];
				for (let j = i; j <= n; ++j)
				{
					tmpAugmentedMatrix[k][j] = this.subtractPrecise(tmpAugmentedMatrix[k][j], this.multiplyPrecise(tmpFactor, tmpAugmentedMatrix[i][j]));
				}
			}
		}

		// Extract solution
		return tmpAugmentedMatrix.map((row) => row[n]);
	}

	generateValueFromEasingDescription(pEasingConfiguration)
	{
		// Branch based on type
		switch (pEasingConfiguration.Easing)
		{
			case 'LINEAR':
			default:
				let tmpDomainRange = pEasingConfiguration.DomainLength;

				if (this.comparePrecise(tmpDomainRange, 0) == 0)
				{
					return this.parsePrecise(pEasingConfiguration.DomainRangeStart);
				}

				// Now, generate a random number and then multiply it to fit in the domain length
				let tmpRandomFraction = Math.random();
				// Scale it to the domain
				let tmpScaledValue = this.multiplyPrecise(tmpRandomFraction, tmpDomainRange);
				// Shift it to the range start
				return this.addPrecise(pEasingConfiguration.DomainRangeStart, tmpScaledValue);
		}
	}

	/**
	 * Predicts the dependent variable using a regression model.
	 *
	 * @param {Array<number|string>} pRegressionCoefficients - The regression coefficients [b0, b1, ..., bn].
	 * @param {Array<number|string>|number|string} pIndependentVariableVector - The independent variable values [x1, x2, ..., xn] or single value for single variable.
	 *
	 * @return {number|string} - The predicted dependent variable value.
	 */
	predictFromRegressionModel(pRegressionCoefficients, pIndependentVariableVector)
	{
		let tmpIndependentVariableVector = pIndependentVariableVector;
		if (!Array.isArray(pIndependentVariableVector))
		{
			tmpIndependentVariableVector = [ pIndependentVariableVector ];
		}
		return pRegressionCoefficients.slice(1).reduce((sum, b, i) =>
			{
				return this.addPrecise(sum, this.multiplyPrecise(b, tmpIndependentVariableVector[i]));
			}, pRegressionCoefficients[0]);
	}

	/**
	 * Resolves paired Y/X value arrays from flexible argument patterns.
	 *
	 * The expression parser's SetConcatArray spreads comma-separated arguments
	 * as individual function parameters.  This helper normalizes three calling
	 * conventions into a clean paired-value result:
	 *
	 *   1. Two arrays:  SLOPE(yArray, xArray)
	 *   2. Spread scalars:  SLOPE(y1,y2,...,yN, x1,x2,...,xN) — split in half
	 *   3. One flat array:  SLOPE([y1,...,yN,x1,...,xN]) — split in half
	 *
	 * Non-numeric values are filtered; only pairs where both Y and X parse
	 * are kept.
	 *
	 * @param {...*} pArguments - Flexible: (yArr, xArr) | (y1,y2,...,x1,x2,...) | (flatArr)
	 *
	 * @return {Object} { cleanX, cleanY, n }
	 */
	cleanPairedValues(...pArguments)
	{
		let tmpYValues;
		let tmpXValues;

		if (pArguments.length === 2 && Array.isArray(pArguments[0]) && Array.isArray(pArguments[1]))
		{
			// Two arrays: SLOPE(yArray, xArray)
			tmpYValues = pArguments[0];
			tmpXValues = pArguments[1];
		}
		else if (pArguments.length === 1 && Array.isArray(pArguments[0]))
		{
			// Single flat array — split in half
			let tmpFlat = pArguments[0];
			let tmpHalf = Math.floor(tmpFlat.length / 2);
			tmpYValues = tmpFlat.slice(0, tmpHalf);
			tmpXValues = tmpFlat.slice(tmpHalf);
		}
		else if (pArguments.length > 2)
		{
			// Many spread scalars from expression parser — split in half
			let tmpHalf = Math.floor(pArguments.length / 2);
			tmpYValues = pArguments.slice(0, tmpHalf);
			tmpXValues = pArguments.slice(tmpHalf);
		}
		else
		{
			// Two scalars or other degenerate input
			tmpYValues = Array.isArray(pArguments[0]) ? pArguments[0] : [pArguments[0]];
			tmpXValues = Array.isArray(pArguments[1]) ? pArguments[1] : [pArguments[1]];
		}

		let tmpPairCount = Math.min(tmpYValues.length, tmpXValues.length);

		let tmpCleanX = [];
		let tmpCleanY = [];

		for (let i = 0; i < tmpPairCount; i++)
		{
			let tmpX = this.parsePrecise(tmpXValues[i], NaN);
			let tmpY = this.parsePrecise(tmpYValues[i], NaN);
			if (!isNaN(tmpX) && !isNaN(tmpY))
			{
				tmpCleanX.push(tmpX);
				tmpCleanY.push(tmpY);
			}
		}

		return { cleanX: tmpCleanX, cleanY: tmpCleanY, n: tmpCleanX.length };
	}

	/**
	 * Calculates the slope of a linear regression line through paired data points.
	 * Equivalent to Excel's SLOPE function.
	 *
	 * Formula: slope = (n * Σ(xy) - Σx * Σy) / (n * Σ(x²) - (Σx)²)
	 *
	 * Calling conventions (all work through the expression parser):
	 *   SLOPE(yArray, xArray)                — two resolved arrays
	 *   SLOPE(y1,y2,...,yN, x1,x2,...,xN)    — inline scalars, split in half
	 *
	 * @param {...*} pArguments - Y values followed by X values (see cleanPairedValues).
	 *
	 * @return {string} The slope of the regression line.
	 */
	slopePrecise(...pArguments)
	{
		let tmpPaired = this.cleanPairedValues(...pArguments);

		if (tmpPaired.n < 2)
		{
			return '0';
		}

		let tmpSumX = '0';
		let tmpSumY = '0';
		let tmpSumXY = '0';
		let tmpSumX2 = '0';

		for (let i = 0; i < tmpPaired.n; i++)
		{
			tmpSumX = this.addPrecise(tmpSumX, tmpPaired.cleanX[i]);
			tmpSumY = this.addPrecise(tmpSumY, tmpPaired.cleanY[i]);
			tmpSumXY = this.addPrecise(tmpSumXY, this.multiplyPrecise(tmpPaired.cleanX[i], tmpPaired.cleanY[i]));
			tmpSumX2 = this.addPrecise(tmpSumX2, this.multiplyPrecise(tmpPaired.cleanX[i], tmpPaired.cleanX[i]));
		}

		// slope = (n * Σ(xy) - Σx * Σy) / (n * Σ(x²) - (Σx)²)
		let tmpNumerator = this.subtractPrecise(this.multiplyPrecise(tmpPaired.n, tmpSumXY), this.multiplyPrecise(tmpSumX, tmpSumY));
		let tmpDenominator = this.subtractPrecise(this.multiplyPrecise(tmpPaired.n, tmpSumX2), this.multiplyPrecise(tmpSumX, tmpSumX));

		if (this.comparePrecise(tmpDenominator, 0) == 0)
		{
			return '0';
		}

		return this.dividePrecise(tmpNumerator, tmpDenominator);
	}

	/**
	 * Calculates the y-intercept of a linear regression line through paired data points.
	 * Equivalent to Excel's INTERCEPT function.
	 *
	 * Formula: intercept = ȳ - slope * x̄
	 *
	 * Calling conventions (all work through the expression parser):
	 *   INTERCEPT(yArray, xArray)                — two resolved arrays
	 *   INTERCEPT(y1,y2,...,yN, x1,x2,...,xN)    — inline scalars, split in half
	 *
	 * @param {...*} pArguments - Y values followed by X values (see cleanPairedValues).
	 *
	 * @return {string} The y-intercept of the regression line.
	 */
	interceptPrecise(...pArguments)
	{
		let tmpPaired = this.cleanPairedValues(...pArguments);

		let tmpSlope = this.slopePrecise(tmpPaired.cleanY, tmpPaired.cleanX);
		let tmpMeanY = this.meanPrecise(tmpPaired.cleanY);
		let tmpMeanX = this.meanPrecise(tmpPaired.cleanX);

		// intercept = ȳ - slope * x̄
		return this.subtractPrecise(tmpMeanY, this.multiplyPrecise(tmpSlope, tmpMeanX));
	}

	/**
	 * Evaluate a point on a cubic bezier curve at parameter t.
	 *
	 * B(t) = (1-t)^3*P0 + 3*(1-t)^2*t*P1 + 3*(1-t)*t^2*P2 + t^3*P3
	 *
	 * @param {number|string} pP0 - First control point value
	 * @param {number|string} pP1 - Second control point value
	 * @param {number|string} pP2 - Third control point value
	 * @param {number|string} pP3 - Fourth control point value
	 * @param {number|string} pT - Parameter t in [0,1]
	 *
	 * @return {string} - The bezier curve value at parameter t
	 */
	bezierPoint(pP0, pP1, pP2, pP3, pT)
	{
		let tmpT = this.parsePrecise(pT, 0);
		let tmpOneMinusT = this.subtractPrecise(1, tmpT);

		// (1-t)^3 * P0
		let tmpTerm0 = this.multiplyPrecise(this.powerPrecise(tmpOneMinusT, 3), pP0);
		// 3 * (1-t)^2 * t * P1
		let tmpTerm1 = this.multiplyPrecise(this.multiplyPrecise(this.multiplyPrecise(3, this.powerPrecise(tmpOneMinusT, 2)), tmpT), pP1);
		// 3 * (1-t) * t^2 * P2
		let tmpTerm2 = this.multiplyPrecise(this.multiplyPrecise(this.multiplyPrecise(3, tmpOneMinusT), this.powerPrecise(tmpT, 2)), pP2);
		// t^3 * P3
		let tmpTerm3 = this.multiplyPrecise(this.powerPrecise(tmpT, 3), pP3);

		return this.addPrecise(this.addPrecise(tmpTerm0, tmpTerm1), this.addPrecise(tmpTerm2, tmpTerm3));
	}

	/**
	 * Fit a cubic bezier curve to a set of data points using least-squares optimization.
	 *
	 * Given arrays of X and Y values representing data points, this function finds the four
	 * control points (P0, P1, P2, P3) of a cubic bezier curve that best fits the data.
	 *
	 * The first and last control points are pinned to the first and last data points.
	 * The interior control points (P1, P2) are found by least-squares minimization of
	 * the squared distances between the data points and the curve.
	 *
	 * Parameter t values are assigned by chord-length parameterization: each data point
	 * gets a t value proportional to its cumulative distance along the polyline.
	 *
	 * @param {Array<number|string>} pXValues - Array of x coordinates
	 * @param {Array<number|string>} pYValues - Array of y coordinates
	 *
	 * @return {Array<Array<string>>} - Four control points as [[x0,y0], [x1,y1], [x2,y2], [x3,y3]]
	 */
	bezierCurveFit(pXValues, pYValues)
	{
		if (!Array.isArray(pXValues) || !Array.isArray(pYValues))
		{
			this.log.warn('bezierCurveFit: pXValues and pYValues must be arrays');
			return [[0, 0], [0, 0], [0, 0], [0, 0]];
		}

		let tmpN = Math.min(pXValues.length, pYValues.length);

		if (tmpN < 2)
		{
			this.log.warn('bezierCurveFit: need at least 2 data points');
			return [[0, 0], [0, 0], [0, 0], [0, 0]];
		}

		// Pin P0 and P3 to the first and last data points
		let tmpP0x = this.parsePrecise(pXValues[0], 0);
		let tmpP0y = this.parsePrecise(pYValues[0], 0);
		let tmpP3x = this.parsePrecise(pXValues[tmpN - 1], 0);
		let tmpP3y = this.parsePrecise(pYValues[tmpN - 1], 0);

		if (tmpN === 2)
		{
			// With only two points, place control points at 1/3 and 2/3 along the line
			let tmpP1x = this.addPrecise(tmpP0x, this.dividePrecise(this.subtractPrecise(tmpP3x, tmpP0x), 3));
			let tmpP1y = this.addPrecise(tmpP0y, this.dividePrecise(this.subtractPrecise(tmpP3y, tmpP0y), 3));
			let tmpP2x = this.addPrecise(tmpP0x, this.multiplyPrecise(this.dividePrecise(this.subtractPrecise(tmpP3x, tmpP0x), 3), 2));
			let tmpP2y = this.addPrecise(tmpP0y, this.multiplyPrecise(this.dividePrecise(this.subtractPrecise(tmpP3y, tmpP0y), 3), 2));
			return [
				[tmpP0x.toString(), tmpP0y.toString()],
				[tmpP1x.toString(), tmpP1y.toString()],
				[tmpP2x.toString(), tmpP2y.toString()],
				[tmpP3x.toString(), tmpP3y.toString()]
			];
		}

		// Compute chord-length parameterization for t values
		let tmpDistances = [0];
		for (let i = 1; i < tmpN; i++)
		{
			let tmpDx = this.subtractPrecise(pXValues[i], pXValues[i - 1]);
			let tmpDy = this.subtractPrecise(pYValues[i], pYValues[i - 1]);
			let tmpDist = this.sqrtPrecise(this.addPrecise(this.multiplyPrecise(tmpDx, tmpDx), this.multiplyPrecise(tmpDy, tmpDy)));
			tmpDistances.push(this.addPrecise(tmpDistances[i - 1], tmpDist));
		}

		let tmpTotalLength = tmpDistances[tmpN - 1];
		let tmpTValues = [];
		for (let i = 0; i < tmpN; i++)
		{
			if (this.comparePrecise(tmpTotalLength, 0) == 0)
			{
				tmpTValues.push(this.dividePrecise(i, tmpN - 1));
			}
			else
			{
				tmpTValues.push(this.dividePrecise(tmpDistances[i], tmpTotalLength));
			}
		}

		// Build the least-squares system for interior control points P1 and P2.
		// For each data point i with parameter t_i:
		//   B(t_i) = (1-t)^3*P0 + 3*(1-t)^2*t*P1 + 3*(1-t)*t^2*P2 + t^3*P3
		//
		// We want to minimize sum of |DataPoint_i - B(t_i)|^2 over P1 and P2.
		// Let A1(t) = 3*(1-t)^2*t and A2(t) = 3*(1-t)*t^2.
		// Then: A1(t)*P1 + A2(t)*P2 = DataPoint - (1-t)^3*P0 - t^3*P3
		//
		// This gives a 2x2 linear system (solved independently for x and y).

		let tmpC11 = 0, tmpC12 = 0, tmpC22 = 0;
		let tmpRx1 = 0, tmpRx2 = 0;
		let tmpRy1 = 0, tmpRy2 = 0;

		for (let i = 0; i < tmpN; i++)
		{
			let tmpT = tmpTValues[i];
			let tmpOneMinusT = this.subtractPrecise(1, tmpT);

			// Basis functions for P1 and P2
			let tmpA1 = this.multiplyPrecise(this.multiplyPrecise(3, this.powerPrecise(tmpOneMinusT, 2)), tmpT);
			let tmpA2 = this.multiplyPrecise(this.multiplyPrecise(3, tmpOneMinusT), this.powerPrecise(tmpT, 2));

			// Build normal equations: C * [P1; P2] = R
			tmpC11 = this.addPrecise(tmpC11, this.multiplyPrecise(tmpA1, tmpA1));
			tmpC12 = this.addPrecise(tmpC12, this.multiplyPrecise(tmpA1, tmpA2));
			tmpC22 = this.addPrecise(tmpC22, this.multiplyPrecise(tmpA2, tmpA2));

			// Right-hand side: DataPoint - (1-t)^3*P0 - t^3*P3
			let tmpB0 = this.powerPrecise(tmpOneMinusT, 3);
			let tmpB3 = this.powerPrecise(tmpT, 3);

			let tmpResidualX = this.subtractPrecise(this.subtractPrecise(pXValues[i], this.multiplyPrecise(tmpB0, tmpP0x)), this.multiplyPrecise(tmpB3, tmpP3x));
			let tmpResidualY = this.subtractPrecise(this.subtractPrecise(pYValues[i], this.multiplyPrecise(tmpB0, tmpP0y)), this.multiplyPrecise(tmpB3, tmpP3y));

			tmpRx1 = this.addPrecise(tmpRx1, this.multiplyPrecise(tmpA1, tmpResidualX));
			tmpRx2 = this.addPrecise(tmpRx2, this.multiplyPrecise(tmpA2, tmpResidualX));
			tmpRy1 = this.addPrecise(tmpRy1, this.multiplyPrecise(tmpA1, tmpResidualY));
			tmpRy2 = this.addPrecise(tmpRy2, this.multiplyPrecise(tmpA2, tmpResidualY));
		}

		// Solve the 2x2 system: [[C11, C12], [C12, C22]] * [P1, P2] = [R1, R2]
		let tmpDet = this.subtractPrecise(this.multiplyPrecise(tmpC11, tmpC22), this.multiplyPrecise(tmpC12, tmpC12));

		let tmpP1x, tmpP1y, tmpP2x, tmpP2y;

		if (this.comparePrecise(this.absPrecise(tmpDet), '1e-20') < 0)
		{
			// Degenerate case: place control points at 1/3 and 2/3 along the line
			tmpP1x = this.addPrecise(tmpP0x, this.dividePrecise(this.subtractPrecise(tmpP3x, tmpP0x), 3));
			tmpP1y = this.addPrecise(tmpP0y, this.dividePrecise(this.subtractPrecise(tmpP3y, tmpP0y), 3));
			tmpP2x = this.addPrecise(tmpP0x, this.multiplyPrecise(this.dividePrecise(this.subtractPrecise(tmpP3x, tmpP0x), 3), 2));
			tmpP2y = this.addPrecise(tmpP0y, this.multiplyPrecise(this.dividePrecise(this.subtractPrecise(tmpP3y, tmpP0y), 3), 2));
		}
		else
		{
			tmpP1x = this.dividePrecise(this.subtractPrecise(this.multiplyPrecise(tmpC22, tmpRx1), this.multiplyPrecise(tmpC12, tmpRx2)), tmpDet);
			tmpP1y = this.dividePrecise(this.subtractPrecise(this.multiplyPrecise(tmpC22, tmpRy1), this.multiplyPrecise(tmpC12, tmpRy2)), tmpDet);
			tmpP2x = this.dividePrecise(this.subtractPrecise(this.multiplyPrecise(tmpC11, tmpRx2), this.multiplyPrecise(tmpC12, tmpRx1)), tmpDet);
			tmpP2y = this.dividePrecise(this.subtractPrecise(this.multiplyPrecise(tmpC11, tmpRy2), this.multiplyPrecise(tmpC12, tmpRy1)), tmpDet);
		}

		return [
			[tmpP0x.toString(), tmpP0y.toString()],
			[tmpP1x.toString(), tmpP1y.toString()],
			[tmpP2x.toString(), tmpP2y.toString()],
			[tmpP3x.toString(), tmpP3y.toString()]
		];
	}
}

module.exports = FableServiceMath;

},{"./Fable-SetConcatArray.js":101,"fable-serviceproviderbase":59}],90:[function(require,module,exports){
const libFableServiceBase = require('fable-serviceproviderbase');

/**
* Precedent Meta-Templating
* @author      Steven Velozo <steven@velozo.com>
* @description Process text stream trie and postfix tree, parsing out meta-template expression functions.
*/
const libWordTree = require(`./Fable-Service-MetaTemplate/MetaTemplate-WordTree.js`);
const libStringParser = require(`./Fable-Service-MetaTemplate/MetaTemplate-StringParser.js`);


class FableServiceMetaTemplate extends libFableServiceBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.serviceType = 'MetaTemplate';

		this.WordTree = new libWordTree();

		this.StringParser = new libStringParser(this.fable);

		this.ParseTree = this.WordTree.ParseTree;
	}


	addPattern(pPatternStart, pPatternEnd, pParser, pParserContext)
	{
		return this.WordTree.addPattern(pPatternStart, pPatternEnd, pParser, pParserContext);
	}

	addPatternBoth(pPatternStart, pPatternEnd, pParser, pParserPromise, pParserContext)
	{
		return this.WordTree.addPatternBoth(pPatternStart, pPatternEnd, pParser, pParserPromise, pParserContext);
	}

	/**
	 * Parse a string with the existing parse tree
	 * @method parseString
	 * @param {string} pString - The string to parse
	 * @param {object} pData - Data to pass in as the second argument
	 * @param {function} fCallback - The callback function to call when a pattern is matched
	 * @param {array} pDataContext - The history of data objects already passed in
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 * @return {string} The result from the parser
	 */
	parseString(pString, pData, fCallback, pDataContext, pScope, pState)
	{
		if (this.LogNoisiness > 4)
		{
			this.fable.log.trace(`Metatemplate parsing template string [${pString}] where the callback is a ${typeof(fCallback)}`, {TemplateData:pData});
		}
		return this.StringParser.parseString(pString, this.ParseTree, pData, fCallback, pDataContext, pScope, pState);
	}
}

module.exports = FableServiceMetaTemplate;

},{"./Fable-Service-MetaTemplate/MetaTemplate-StringParser.js":91,"./Fable-Service-MetaTemplate/MetaTemplate-WordTree.js":92,"fable-serviceproviderbase":59}],91:[function(require,module,exports){
/**
* String Parser
* @author      Steven Velozo <steven@velozo.com>
* @description Parse a string, properly processing each matched token in the word tree.
*/

class StringParser
{
	/**
	 * StringParser Constructor
	 */
	constructor(pFable)
	{
		this.fable = pFable;
	}

	/**
	 * Create a fresh parsing state object to work with.
	 * @method newParserState
	 * @param {Object} pParseTree - A node on the parse tree to begin parsing from (usually root)
	 * @return {Object} A new parser state object for running a character parser on
	 * @private
	 */
	newParserState (pParseTree)
	{
		return (
		{
			ParseTree: pParseTree,

			Asynchronous: false,

			Output: '',
			OutputBuffer: '',

			Pattern: {},

			PatternMatch: false,
			PatternMatchEnd: false
		});
	}

	/**
	 * Append a character to the output buffer in the parser state.
	 * This output buffer is used when a potential match is being explored, or a match is being explored.
	 * @method appendOutputBuffer
	 * @param {string} pCharacter - The character to append
	 * @param {Object} pParserState - The state object for the current parsing task
	 * @private
	 */
	appendOutputBuffer (pCharacter, pParserState)
	{
		pParserState.OutputBuffer += pCharacter;
	}

	/**
	 * Flush the output buffer to the output and clear it.
	 * @method flushOutputBuffer
	 * @param {Object} pParserState - The state object for the current parsing task
	 * @private
	 */
	flushOutputBuffer (pParserState)
	{
		pParserState.Output += pParserState.OutputBuffer;
		pParserState.OutputBuffer = '';
	}

	resetOutputBuffer (pParserState)
	{
		// Flush the output buffer.
		this.flushOutputBuffer(pParserState);
		// End pattern mode
		pParserState.Pattern = false;
		pParserState.PatternStartNode = false;
		pParserState.StartPatternMatchComplete = false;
		pParserState.EndPatternMatchBegan = false;
		pParserState.PatternMatch = false;

		return true;
	}

	/**
	 * Parse a character in the buffer.
	 * @method parseCharacter
	 * @param {string} pCharacter - The character to append
	 * @param {Object} pParserState - The state object for the current parsing task
	 * @param {any} pData - The data available to the template
	 * @param {Array<any>} pDataContext - The history of data objects/context already passed in
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 * @private
	 */
	parseCharacter (pCharacter, pParserState, pData, pDataContext, pScope, pState)
	{
		// If we are already in a pattern match traversal
		if (pParserState.PatternMatch)
		{
			// If the pattern is still matching the start and we haven't passed the buffer
			if (!pParserState.StartPatternMatchComplete && (pCharacter in pParserState.Pattern))
			{
				pParserState.Pattern = pParserState.Pattern[pCharacter];
				this.appendOutputBuffer(pCharacter, pParserState);
			}
			else if (pParserState.EndPatternMatchBegan)
			{
				if (pCharacter in pParserState.Pattern.PatternEnd)
				{
					// This leaf has a PatternEnd tree, so we will wait until that end is met.
					pParserState.Pattern = pParserState.Pattern.PatternEnd[pCharacter];
					// Flush the output buffer.
					this.appendOutputBuffer(pCharacter, pParserState);
					// If this last character is the end of the pattern, parse it.
					// Run the function
					let tmpFunctionContext = ('ParserContext' in pParserState.Pattern) ? pParserState.Pattern.ParserContext : false;
					if (tmpFunctionContext)
					{
						pParserState.OutputBuffer = pParserState.Pattern.Parse.call(tmpFunctionContext, pParserState.OutputBuffer.substr(pParserState.Pattern.PatternStartString.length, pParserState.OutputBuffer.length - (pParserState.Pattern.PatternStartString.length+pParserState.Pattern.PatternEndString.length)), pData, pDataContext, pScope, pState);
					}
					else
					{
						pParserState.OutputBuffer = pParserState.Pattern.Parse(pParserState.OutputBuffer.substr(pParserState.Pattern.PatternStartString.length, pParserState.OutputBuffer.length - (pParserState.Pattern.PatternStartString.length+pParserState.Pattern.PatternEndString.length)), pData, pDataContext, pScope, pState);
					}
					return this.resetOutputBuffer(pParserState);
				}
				else if (pCharacter in pParserState.PatternStartNode.PatternEnd)
				{
					// We broke out of the end -- see if this is a new start of the end.
					pParserState.Pattern = pParserState.PatternStartNode.PatternEnd[pCharacter];
					this.appendOutputBuffer(pCharacter, pParserState);
				}
				else
				{
					// Partial end-pattern match aborted -- roll Pattern back to the start node so
					// subsequent characters scan for the end pattern from the beginning again.
					pParserState.EndPatternMatchBegan = false;
					pParserState.Pattern = pParserState.PatternStartNode;
					this.appendOutputBuffer(pCharacter, pParserState);
				}
			}
			else if ('PatternEnd' in pParserState.Pattern)
			{
				if (!pParserState.StartPatternMatchComplete)
				{
					pParserState.StartPatternMatchComplete = true;
					pParserState.PatternStartNode = pParserState.Pattern;
				}

				this.appendOutputBuffer(pCharacter, pParserState);

				if (pCharacter in pParserState.Pattern.PatternEnd)
				{
					// This is the first character of the end pattern.
					pParserState.EndPatternMatchBegan = true;
					// This leaf has a PatternEnd tree, so we will wait until that end is met.
					pParserState.Pattern = pParserState.Pattern.PatternEnd[pCharacter];
					// If this last character is the end of the pattern, parse it.
					if ('Parse' in pParserState.Pattern)
					{
						// Run the t*mplate function
						let tmpFunctionContext = ('ParserContext' in pParserState.Pattern) ? pParserState.Pattern.ParserContext : false;
						if (tmpFunctionContext)
						{
							pParserState.OutputBuffer = pParserState.Pattern.Parse.call(tmpFunctionContext, pParserState.OutputBuffer.substr(pParserState.Pattern.PatternStartString.length, pParserState.OutputBuffer.length - (pParserState.Pattern.PatternStartString.length+pParserState.Pattern.PatternEndString.length)), pData, pDataContext, pScope, pState);
						}
						else
						{
							pParserState.OutputBuffer = pParserState.Pattern.Parse(pParserState.OutputBuffer.substr(pParserState.Pattern.PatternStartString.length, pParserState.OutputBuffer.length - (pParserState.Pattern.PatternStartString.length+pParserState.Pattern.PatternEndString.length)), pData, pDataContext, pScope, pState);
						}
						return this.resetOutputBuffer(pParserState);
					}
				}
			}
			else
			{
				// We are in a pattern start but didn't match one; reset and start trying again from this character.
				this.resetOutputBuffer(pParserState);
			}
		}
		// If we aren't in a pattern match or pattern, and this isn't the start of a new pattern (RAW mode)....
		if (!pParserState.PatternMatch)
		{
			// This may be the start of a new pattern....
			if (pCharacter in pParserState.ParseTree)
			{
				// ... assign the root node as the matched node.
				this.resetOutputBuffer(pParserState);
				this.appendOutputBuffer(pCharacter, pParserState);
				pParserState.Pattern = pParserState.ParseTree[pCharacter];
				pParserState.PatternMatch = true;
				return true;
			}
			else
			{
				this.appendOutputBuffer(pCharacter, pParserState);
			}
		}
		return false;
	}

	/**
	 * @param {Object} pParserState - The state object for the current parsing task
	 * @param {Object} pData - The data to pass to the function as a second parameter
	 * @param {function} fCallback - The callback function to call when the parse is complete
	 * @param {array} pDataContext - The history of data objects/context already passed in
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 */
	executePatternAsync(pParserState, pData, fCallback, pDataContext, pScope, pState)
	{
		// ... this is the end of a pattern, cut off the end tag and parse it.
		// Trim the start and end tags off the output buffer now
		if (pParserState.Pattern.isAsync)
		{
			// Run the function
			let tmpFunctionContext = ('ParserContext' in pParserState.Pattern) ? pParserState.Pattern.ParserContext : false;
			if (tmpFunctionContext)
			{
				return pParserState.Pattern.ParseAsync.call(tmpFunctionContext, pParserState.OutputBuffer.substr(pParserState.Pattern.PatternStartString.length, pParserState.OutputBuffer.length - (pParserState.Pattern.PatternStartString.length+pParserState.Pattern.PatternEndString.length)), pData,
					(pError, pAsyncOutput) =>
					{
						if (pError)
						{
							this.fable.log.info(`Precedent ERROR: Async template error happened parsing ${pParserState.Pattern.PatternStart} ... ${pParserState.Pattern.PatternEnd}: ${pError}`);
						}

						pParserState.OutputBuffer = pAsyncOutput;
						this.resetOutputBuffer(pParserState);
						return fCallback();
					}, pDataContext, pScope, pState);
			}
			else
			{
				return pParserState.Pattern.ParseAsync(pParserState.OutputBuffer.substr(pParserState.Pattern.PatternStartString.length, pParserState.OutputBuffer.length - (pParserState.Pattern.PatternStartString.length+pParserState.Pattern.PatternEndString.length)), pData,
					(pError, pAsyncOutput) =>
					{
						if (pError)
						{
							this.fable.log.info(`Precedent ERROR: Async template error happened parsing ${pParserState.Pattern.PatternStart} ... ${pParserState.Pattern.PatternEnd}: ${pError}`);
						}

						pParserState.OutputBuffer = pAsyncOutput;
						this.resetOutputBuffer(pParserState);
						return fCallback();
					}, pDataContext, pScope, pState);
			}
		}
		else
		{
			// Run the t*mplate function
			let tmpFunctionContext = ('ParserContext' in pParserState.Pattern) ? pParserState.Pattern.ParserContext : false;
			if (tmpFunctionContext)
			{
				pParserState.OutputBuffer = pParserState.Pattern.Parse.call(tmpFunctionContext, pParserState.OutputBuffer.substr(pParserState.Pattern.PatternStartString.length, pParserState.OutputBuffer.length - (pParserState.Pattern.PatternStartString.length+pParserState.Pattern.PatternEndString.length)), pData, pDataContext, pScope, pState);
			}
			else
			{
				pParserState.OutputBuffer = pParserState.Pattern.Parse(pParserState.OutputBuffer.substr(pParserState.Pattern.PatternStartString.length, pParserState.OutputBuffer.length - (pParserState.Pattern.PatternStartString.length+pParserState.Pattern.PatternEndString.length)), pData, pDataContext, pScope, pState);
			}
			this.resetOutputBuffer(pParserState);
			return fCallback();
		}
	}


	/**
	 * Parse a character in the buffer.
	 * @method parseCharacterAsync
	 * @param {string} pCharacter - The character to append
	 * @param {Object} pParserState - The state object for the current parsing task
	 * @param {Object} pData - The data to pass to the function as a second parameter
	 * @param {function} fCallback - The callback function to call when the parse is complete
	 * @param {array} pDataContext - The history of data objects/context already passed in
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 * @private
	 */
	parseCharacterAsync (pCharacter, pParserState, pData, fCallback, pDataContext, pScope, pState)
	{
		// If we are already in a pattern match traversal
		if (pParserState.PatternMatch)
		{
			// If the pattern is still matching the start and we haven't passed the buffer
			if (!pParserState.StartPatternMatchComplete && (pCharacter in pParserState.Pattern))
			{
				pParserState.Pattern = pParserState.Pattern[pCharacter];
				this.appendOutputBuffer(pCharacter, pParserState);
			}
			else if (pParserState.EndPatternMatchBegan)
			{
				if (pCharacter in pParserState.Pattern.PatternEnd)
				{
					// This leaf has a PatternEnd tree, so we will wait until that end is met.
					pParserState.Pattern = pParserState.Pattern.PatternEnd[pCharacter];
					// Flush the output buffer.
					this.appendOutputBuffer(pCharacter, pParserState);
					// If this last character is the end of the pattern, parse it.
					if ('Parse' in pParserState.Pattern)
					{
						return this.executePatternAsync(pParserState, pData, fCallback, pDataContext, pScope, pState);
					}
				}
				else if (pCharacter in pParserState.PatternStartNode.PatternEnd)
				{
					// We broke out of the end -- see if this is a new start of the end.
					pParserState.Pattern = pParserState.PatternStartNode.PatternEnd[pCharacter];
					this.appendOutputBuffer(pCharacter, pParserState);
				}
				else
				{
					// Partial end-pattern match aborted -- roll Pattern back to the start node so
					// subsequent characters scan for the end pattern from the beginning again.
					pParserState.EndPatternMatchBegan = false;
					pParserState.Pattern = pParserState.PatternStartNode;
					this.appendOutputBuffer(pCharacter, pParserState);
				}
			}
			else if ('PatternEnd' in pParserState.Pattern)
			{
				if (!pParserState.StartPatternMatchComplete)
				{
					pParserState.StartPatternMatchComplete = true;
					pParserState.PatternStartNode = pParserState.Pattern;
				}

				this.appendOutputBuffer(pCharacter, pParserState);

				if (pCharacter in pParserState.Pattern.PatternEnd)
				{
					// This is the first character of the end pattern.
					pParserState.EndPatternMatchBegan = true;
					// This leaf has a PatternEnd tree, so we will wait until that end is met.
					pParserState.Pattern = pParserState.Pattern.PatternEnd[pCharacter];
					// If this last character is the end of the pattern, parse it.
					if ('Parse' in pParserState.Pattern)
					{
						return this.executePatternAsync(pParserState, pData, fCallback, pDataContext, pScope, pState);
					}
				}
			}
			else
			{
				// We are in a pattern start but didn't match one; reset and start trying again from this character.
				this.resetOutputBuffer(pParserState);
			}
		}
		// If we aren't in a pattern match or pattern, and this isn't the start of a new pattern (RAW mode)....
		else
		{
			// This may be the start of a new pattern....
			if (pCharacter in pParserState.ParseTree)
			{
				// ... assign the root node as the matched node.
				this.resetOutputBuffer(pParserState);
				this.appendOutputBuffer(pCharacter, pParserState);
				pParserState.Pattern = pParserState.ParseTree[pCharacter];
				pParserState.PatternMatch = true;
			}
			else
			{
				this.appendOutputBuffer(pCharacter, pParserState);
			}
		}
		// Without this, templates of all sizes work fine in node.  They do not in the browser.
		// Trying this out without the timout on non asynchronous template flips.
		return fCallback();
	}

	/**
	 * Parse a string for matches, and process any template segments that occur.
	 * @method parseString
	 * @param {string} pString - The string to parse.
	 * @param {Object} pParseTree - The parse tree to begin parsing from (usually root)
	 * @param {Object} pData - The data to pass to the function as a second parameter
	 * @param {function} fCallback - The callback function to call when the parse is complete
	 * @param {array} pDataContext - The history of data objects/context already passed in
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 */
	parseString (pString, pParseTree, pData, fCallback, pDataContext, pScope, pState)
	{
		// TODO: There is danger here if a template function attempts to functionally recurse and doesn't pass this in.
		let tmpPreviousDataContext = (Array.isArray(pDataContext)) ? pDataContext : [];
		let tmpDataContext = Array.from(tmpPreviousDataContext);
		tmpDataContext.push(pData)

		if (typeof(fCallback) !== 'function')
		{
			let tmpParserState = this.newParserState(pParseTree);

			for (var i = 0; i < pString.length; i++)
			{
				// TODO: This is not fast.
				this.parseCharacter(pString[i], tmpParserState, pData, tmpDataContext, pScope, pState);
			}

			this.flushOutputBuffer(tmpParserState);

			return tmpParserState.Output;
		}
		else
		{
			// This is the async mode
			let tmpParserState = this.newParserState(pParseTree);
			tmpParserState.Asynchronous = true;

			let tmpAnticipate = this.fable.instantiateServiceProviderWithoutRegistration('Anticipate');

			for (let i = 0; i < pString.length; i++)
			{
				tmpAnticipate.anticipate(
					(fCallback) =>
					{
						this.parseCharacterAsync(pString[i], tmpParserState, pData, fCallback, tmpDataContext, pScope, pState);
					});
			}

			tmpAnticipate.wait(
				(pError) =>
				{
					// Flush the remaining data
					this.flushOutputBuffer(tmpParserState);
					return fCallback(pError, tmpParserState.Output);
				});
		}
	}
}

module.exports = StringParser;

},{}],92:[function(require,module,exports){
/**
* Word Tree
* @author      Steven Velozo <steven@velozo.com>
* @description Create a tree (directed graph) of Javascript objects, one character per object.
*/

class WordTree
{
	/**
	 * WordTree Constructor
	 */
	constructor()
	{
		this.ParseTree = {};
	}

	/**
	 * Add a child character to a Parse Tree node
	 * @method addChild
	 * @param {Object} pTree - A parse tree to push the characters into
	 * @param {string} pPattern - The string to add to the tree
	 * @returns {Object} The resulting leaf node that was added (or found)
	 * @private
	 */
	addChild (pTree, pPattern)
	{
		if (!(pPattern in pTree))
		{
			pTree[pPattern] = {};
		}

		return pTree[pPattern];
	}

	/**
	 * Add a child character to a Parse Tree PatternEnd subtree
	 * @method addChild
	 * @param {Object} pTree - A parse tree to push the characters into
	 * @param {string} pPattern - The string to add to the tree
	 * @returns {Object} The resulting leaf node that was added (or found)
	 * @private
	 */
	addEndChild (pTree, pPattern)
	{
		if (!('PatternEnd' in pTree))
		{
			pTree.PatternEnd = {};
		}

		pTree.PatternEnd[pPattern] = {};

		return pTree.PatternEnd[pPattern];
	}

	/** Add a Pattern to the Parse Tree with both function parameter types
	 * @method addPatternAll
	 * @param {Object} pPatternStart - The starting string for the pattern (e.g. "${")
	 * @param {string} pPatternEnd - The ending string for the pattern (e.g. "}")
	 * @param {function} fParser - The function to parse if this is the matched pattern, once the Pattern End is met.  If this is a string, a simple replacement occurs.
	 * @param {function} fParserAsync - The function to parse if this is the matched pattern, once the Pattern End is met.  If this is a string, a simple replacement occurs.
	 * @param {Object} pParserContext - The context to pass to the parser function
	 * @return {Object} The leaf parser from the tree
	 */
	addPatternBoth (pPatternStart, pPatternEnd, fParser, fParserAsync, pParserContext)
	{
		if (pPatternStart.length < 1)
		{
			return false;
		}

		if ((typeof(pPatternEnd) === 'string') && (pPatternEnd.length < 1))
		{
			return false;
		}

		let tmpLeaf = this.ParseTree;

		// Add the tree of leaves iteratively
		for (var i = 0; i < pPatternStart.length; i++)
		{
			tmpLeaf = this.addChild(tmpLeaf, pPatternStart[i], i);
		}

		if (!('PatternEnd' in tmpLeaf))
		{
			tmpLeaf.PatternEnd = {};
		}

		let tmpPatternEnd = (typeof(pPatternEnd) === 'string') ? pPatternEnd : pPatternStart;
		for (let i = 0; i < tmpPatternEnd.length; i++)
		{
			tmpLeaf = this.addEndChild(tmpLeaf, tmpPatternEnd[i], i);
		}

		tmpLeaf.PatternStartString = pPatternStart;
		tmpLeaf.PatternEndString = tmpPatternEnd;
		tmpLeaf.Parse = (typeof(fParser) === 'function') ? fParser :
						(typeof(fParser) === 'string') ? (pHash, pData) => { return fParser; } :
						(pHash, pData) => { return pHash; };

		tmpLeaf.ParseAsync = (typeof(fParserAsync) === 'function') ? fParserAsync :
						(typeof(fParserAsync) === 'string') ? (pHash, pData, fCallback) => { return fCallback(null, fParserAsync); } :
						(pHash, pData, fCallback) => { return fCallback(null, tmpLeaf.Parse(pHash, pData)); }

		// A "this" for every object
		if (pParserContext)
		{
			tmpLeaf.ParserContext = pParserContext;
		}

		tmpLeaf.isAsync = true;

		return tmpLeaf;
	}

	/** Add a Pattern to the Parse Tree with both function parameter types
	 * @method addPatternAll
	 * @param {Object} pPatternStart - The starting string for the pattern (e.g. "${")
	 * @param {string} pPatternEnd - The ending string for the pattern (e.g. "}")
	 * @param {function} fParser - The function to parse if this is the matched pattern, once the Pattern End is met.  If this is a string, a simple replacement occurs.
	 * @param {Object} pParserContext - The context to pass to the parser function
	 */
	addPattern (pPatternStart, pPatternEnd, fParser, pParserContext)
	{
		return this.addPatternBoth(pPatternStart, pPatternEnd, fParser, null, pParserContext);
	}
}

module.exports = WordTree;

},{}],93:[function(require,module,exports){
module.exports = (
	{
		"Metadata": {
			"UUID": false,
			"Hash": false,

			"Name": "",
			"Summary": "",

			"Version": 0
		},
		"Status": {
			"Completed": false,
			"StepCount": 1
		},
		"Steps": [],
		"Errors": [],
		"Log": []
	}
);
},{}],94:[function(require,module,exports){
const { PE } = require('big.js');
const libFableServiceBase = require('fable-serviceproviderbase');

const _OperationStatePrototypeString = JSON.stringify(require('./Fable-Service-Operation-DefaultSettings.js'));

class FableOperation extends libFableServiceBase
{

	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		// Timestamps will just be the long ints
		this.timeStamps = {};

		this.serviceType = 'PhasedOperation';

		this.state = JSON.parse(_OperationStatePrototypeString);

		this.stepMap = {};
		this.stepFunctions = {};

		// Match the service instantiation to the operation.
		this.state.Metadata.Hash = this.Hash;
		this.state.Metadata.UUID = this.UUID;

		this.state.Metadata.Name = (typeof(this.options.Name) == 'string') ? this.options.Name : `Unnamed Operation ${this.state.Metadata.UUID}`;
		this.name = this.state.Metadata.Name;

		this.progressTrackerSet = this.fable.instantiateServiceProviderWithoutRegistration('ProgressTrackerSet');

		this.state.OverallProgressTracker = this.progressTrackerSet.createProgressTracker(`Overall-${this.state.Metadata.UUID}`);

		// This is here to use the pass-through logging functions in the operation itself.
		this.log = this;
	}

	execute(fExecutionCompleteCallback)
	{
		// TODO: Should the same operation be allowed to execute more than one time?
		if (this.state.OverallProgressTracker.StartTimeStamp > 0)
		{
			return fExecutionCompleteCallback(new Error(`Operation [${this.state.Metadata.UUID}] ${this.state.Metadata.Name} has already been executed!`));
		}

		let tmpAnticipate = this.fable.instantiateServiceProviderWithoutRegistration('Anticipate');

		this.progressTrackerSet.setProgressTrackerTotalOperations(this.state.OverallProgressTracker.Hash, this.state.Status.StepCount);
		this.progressTrackerSet.startProgressTracker(this.state.OverallProgressTracker.Hash);
		this.info(`Operation [${this.state.Metadata.UUID}] ${this.state.Metadata.Name} starting...`);

		for (let i = 0; i < this.state.Steps.length; i++)
		{
			tmpAnticipate.anticipate(
				function(fNext)
				{
					this.fable.log.info(`Step #${i} [${this.state.Steps[i].GUIDStep}] ${this.state.Steps[i].Name} starting...`);
					this.progressTrackerSet.startProgressTracker(this.state.Steps[i].ProgressTracker.Hash);
					return fNext();
				}.bind(this));
			// Steps are executed in a custom context with
			tmpAnticipate.anticipate(this.stepFunctions[this.state.Steps[i].GUIDStep].bind(
				{
					log:this,
					fable:this.fable,
					options:this.state.Steps[i].Metadata,
					metadata:this.state.Steps[i].Metadata,
					ProgressTracker:this.progressTrackerSet.getProgressTracker(this.state.Steps[i].ProgressTracker.Hash),
					logProgressTrackerStatus: function()
						{
							return this.log.info(`Step #${i} [${this.state.Steps[i].GUIDStep}]: ${this.progressTrackerSet.getProgressTrackerStatusString(this.state.Steps[i].ProgressTracker.Hash)}`);
						}.bind(this),
					OperationState:this.state,
					StepState:this.state.Steps[i]
				}));
			tmpAnticipate.anticipate(
				function(fNext)
				{
					this.progressTrackerSet.endProgressTracker(this.state.Steps[i].ProgressTracker.Hash);
					let tmpStepTimingMessage = this.progressTrackerSet.getProgressTrackerStatusString(this.state.Steps[i].ProgressTracker.Hash);
					this.fable.log.info(`Step #${i} [${this.state.Steps[i].GUIDStep}] ${this.state.Steps[i].Name} complete.`);
					this.fable.log.info(`Step #${i} [${this.state.Steps[i].GUIDStep}] ${this.state.Steps[i].Name} ${tmpStepTimingMessage}.`);

					this.progressTrackerSet.incrementProgressTracker(this.state.OverallProgressTracker.Hash, 1);
					let tmpOperationTimingMessage = this.progressTrackerSet.getProgressTrackerStatusString(this.state.OverallProgressTracker.Hash);
					this.fable.log.info(`Operation [${this.state.Metadata.UUID}] ${tmpOperationTimingMessage}.`);
					return fNext();
				}.bind(this));
		}

		// Wait for the anticipation to complete
		tmpAnticipate.wait(
			(pError) =>
			{
				if (pError)
				{
					this.fable.log.error(`Operation [${this.state.Metadata.UUID}] ${this.state.Metadata.Name} had an error: ${pError}`, pError);
					return fExecutionCompleteCallback(pError);
				}
				this.info(`Operation [${this.state.Metadata.UUID}] ${this.state.Metadata.Name} complete.`);
				let tmpOperationTimingMessage = this.progressTrackerSet.getProgressTrackerStatusString(this.state.OverallProgressTracker.Hash);
				this.progressTrackerSet.endProgressTracker(this.state.OverallProgressTracker.Hash);
				this.fable.log.info(`Operation [${this.state.Metadata.UUID}] ${tmpOperationTimingMessage}.`);
				return fExecutionCompleteCallback();
			});
	}

	// There are three ways to add steps:
	// 1. As a basic javascript function
	//    --
	//    This is the most basic, java"script" way to add a step.  It will
	//    setup a "this" context that has the following properties:
	//    - log: A reference to the operation's log object

	addStep(fStepFunction, pStepMetadata, pStepName, pStepDescription, pGUIDStep)
	{
		let tmpStep = {};

		// GUID is optional
		tmpStep.GUIDStep = (typeof(pGUIDStep) !== 'undefined') ? pGUIDStep : `STEP-${this.state.Steps.length}-${this.fable.DataGeneration.randomNumericString()}`;


		// Name is optional
		tmpStep.Name = (typeof(pStepName) !== 'undefined') ? pStepName : `Step [${tmpStep.GUIDStep}]`;
		tmpStep.Description = (typeof(pStepDescription) !== 'undefined') ? pStepDescription : `Step execution of ${tmpStep.Name}.`;

		tmpStep.ProgressTracker = this.progressTrackerSet.createProgressTracker(tmpStep.GUIDStep);

		tmpStep.Metadata = (typeof(pStepMetadata) === 'object') ? pStepMetadata : {};

		// There is an array of steps, in the Operation State itself ... push a step there
		this.state.Steps.push(tmpStep);

		this.stepMap[tmpStep.GUIDStep] = tmpStep;

		this.stepFunctions[tmpStep.GUIDStep] = typeof(fStepFunction) == 'function' ? fStepFunction : function (fDone) { return fDone(); };

		this.state.Status.StepCount++;

		return tmpStep;
	}

	setStepTotalOperations(pGUIDStep, pTotalOperationCount)
	{
		if (!(pGUIDStep in this.stepMap))
		{
			return new Error(`Step [${pGUIDStep}] does not exist in operation [${this.state.Metadata.UUID}] ${this.state.Metadata.Name} when attempting to set total operations to ${pTotalOperationCount}.`);
		}

		this.progressTrackerSet.setProgressTrackerTotalOperations(this.stepMap[pGUIDStep].ProgressTracker.Hash, pTotalOperationCount);
	}

	writeOperationLog(pLogLevel, pLogText, pLogObject)
	{
		this.state.Log.push(`[${new Date().toUTCString()}]-[${pLogLevel}]: ${pLogText}`);

		if (typeof(pLogObject) == 'object')
		{
			this.state.Log.push(JSON.stringify(pLogObject));
		}
	}

	writeOperationErrors(pLogText, pLogObject)
	{
		this.state.Errors.push(`${pLogText}`);

		if (typeof(pLogObject) == 'object')
		{
			this.state.Errors.push(JSON.stringify(pLogObject));
		}
	}

	trace(pLogText, pLogObject)
	{
		this.writeOperationLog('TRACE', pLogText, pLogObject);
		this.fable.log.trace(pLogText, pLogObject);
	}

	debug(pLogText, pLogObject)
	{
		this.writeOperationLog('DEBUG', pLogText, pLogObject);
		this.fable.log.debug(pLogText, pLogObject);
	}

	info(pLogText, pLogObject)
	{
		this.writeOperationLog('INFO', pLogText, pLogObject);
		this.fable.log.info(pLogText, pLogObject);
	}

	warn(pLogText, pLogObject)
	{
		this.writeOperationLog('WARN', pLogText, pLogObject);
		this.fable.log.warn(pLogText, pLogObject);
	}

	error(pLogText, pLogObject)
	{
		this.writeOperationLog('ERROR', pLogText, pLogObject);
		this.writeOperationErrors(pLogText, pLogObject);
		this.fable.log.error(pLogText, pLogObject);
	}

	fatal(pLogText, pLogObject)
	{
		this.writeOperationLog('FATAL', pLogText, pLogObject);
		this.writeOperationErrors(pLogText, pLogObject);
		this.fable.log.fatal(pLogText, pLogObject);
	}
}

module.exports = FableOperation;

},{"./Fable-Service-Operation-DefaultSettings.js":93,"big.js":17,"fable-serviceproviderbase":59}],95:[function(require,module,exports){
const libFableServiceBase = require('fable-serviceproviderbase');

class FableServiceProgressTime extends libFableServiceBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.serviceType = 'ProgressTime';

		this.timeStamps = {};
	}

	formatTimeDuration(pTimeDurationInMilliseconds)
	{
		let tmpTimeDuration = typeof(pTimeDurationInMilliseconds) == 'number' ? pTimeDurationInMilliseconds : 0;

		if (pTimeDurationInMilliseconds < 0)
		{
			return 'unknown';
		}

		let tmpTimeDurationString = '';
		if (tmpTimeDuration > 3600000)
		{
			tmpTimeDurationString += Math.floor(tmpTimeDuration/3600000)+'h ';
			tmpTimeDuration = tmpTimeDuration % 3600000;
		}
		if (tmpTimeDuration > 60000)
		{
			tmpTimeDurationString += Math.floor(tmpTimeDuration/60000)+'m ';
			tmpTimeDuration = tmpTimeDuration % 60000;
		}
		if (tmpTimeDuration > 1000)
		{
			tmpTimeDurationString += Math.floor(tmpTimeDuration/1000)+'s ';
			tmpTimeDuration = tmpTimeDuration % 1000;
		}
		tmpTimeDurationString += Math.round(tmpTimeDuration)+'ms';

		return tmpTimeDurationString;
	}

	createTimeStamp(pTimeStampHash)
	{
		let tmpTimeStampHash = (typeof(pTimeStampHash) == 'string') ? pTimeStampHash : 'Default';
		this.timeStamps[tmpTimeStampHash] = +new Date();
		return this.timeStamps[tmpTimeStampHash];
	}

	getTimeStampValue(pTimeStampHash)
	{
		let tmpTimeStampHash = (typeof(pTimeStampHash) == 'string') ? pTimeStampHash : 'Default';
		return (tmpTimeStampHash in this.timeStamps) ? this.timeStamps[tmpTimeStampHash] : -1;
	}

	updateTimeStampValue(pTimeStampHash, pReferenceTime)
	{
		let tmpTimeStampHash = (typeof(pTimeStampHash) == 'string') ? pTimeStampHash : 'Default';
		let tmpReferenceTime = false;

		// This function allows the user to pass in either a reference time in ms, or, a hash of a timestamp.
		if (typeof(pReferenceTime) == 'string')
		{
			tmpReferenceTime = (tmpReference in this.timeStamps) ? this.timeStamps[tmpReference] : false;
		}
		else if (typeof(pReferenceTime) == 'number')
		{
			tmpReferenceTime = pReferenceTime;
		}
		else
		{
			tmpReferenceTime = +new Date();
		}

		if ((tmpTimeStampHash in this.timeStamps) && tmpReferenceTime)
		{
			this.timeStamps[tmpTimeStampHash] = tmpReferenceTime;
			return this.timeStamps[tmpTimeStampHash];
		}
		else
		{
			return -1;
		}
	}

	removeTimeStamp(pTimeStampHash)
	{
		let tmpTimeStampHash = (typeof(pTimeStampHash) == 'string') ? pTimeStampHash : 'Default';
		if (tmpTimeStampHash in this.timeStamps)
		{
			delete this.timeStamps[tmpTimeStampHash];
			return true;
		}
		else
		{
			return false;
		}
	}

	getTimeStampDelta(pTimeStampHash, pReferenceTime)
	{
		let tmpTimeStampHash = (typeof(pTimeStampHash) == 'string') ? pTimeStampHash : 'Default';
		let tmpReferenceTime = false;

		// This function allows the user to pass in either a reference time in ms, or, a hash of a timestamp.
		if (typeof(pReferenceTime) == 'string')
		{
			tmpReferenceTime = (tmpReference in this.timeStamps) ? this.timeStamps[tmpReference] : false;
		}
		else if (typeof(pReferenceTime) == 'number')
		{
			tmpReferenceTime = pReferenceTime;
		}
		else
		{
			tmpReferenceTime = +new Date();
		}

		if ((tmpTimeStampHash in this.timeStamps) && tmpReferenceTime)
		{
			return tmpReferenceTime-this.timeStamps[tmpTimeStampHash];
		}
		else
		{
			return -1;
		}
	}

	getDurationBetweenTimestamps(pTimeStampHashStart, pTimeStampHashEnd)
	{
		let tmpTimeStampHashStart = (typeof(pTimeStampHashStart) == 'string') ? pTimeStampHashStart : 'Default';
		let tmpTimeStampHashEnd = (typeof(pTimeStampHashEnd) == 'string') ? pTimeStampHashEnd : 'Default';
		if ((tmpTimeStampHashStart in this.timeStamps) && (tmpTimeStampHashEnd in this.timeStamps))
		{
			return this.timeStamps[tmpTimeStampHashEnd]-this.timeStamps[tmpTimeStampHashStart];
		}
		else
		{
			return -1;
		}
	}

	getTimeStampDeltaMessage(pTimeStampHash, pMessage, pReferenceTime)
	{
		let tmpTimeStampHash = (typeof(pTimeStampHash) == 'string') ? pTimeStampHash : 'Default';
		let tmpMessage = (typeof(pMessage) !== 'undefined') ? pMessage : `Elapsed for ${tmpTimeStampHash}: `;
		let tmpOperationTime = this.getTimeStampDelta(tmpTimeStampHash, pReferenceTime);

		return `${tmpMessage} ${this.formatTimeDuration(tmpOperationTime)}`;
	}

	logTimeStampDelta(pTimeStampHash, pMessage, pReferenceTime)
	{
		this.fable.log.info(this.getTimeStampDeltaMessage(pTimeStampHash, pMessage, pReferenceTime));
	}
}

module.exports = FableServiceProgressTime;

},{"fable-serviceproviderbase":59}],96:[function(require,module,exports){
class ProgressTracker
{
	constructor(pProgressTrackerSet, pProgressTrackerHash)
	{
		this.progressTrackerSet = pProgressTrackerSet;
		this.progressTrackerHash = pProgressTrackerHash;

		this.data = this.progressTrackerSet.getProgressTrackerData(this.progressTrackerHash);
	}

	updateProgressTracker(pProgressAmount)
	{
		return this.progressTrackerSet.updateProgressTracker(this.progressTrackerHash, pProgressAmount);
	}

	incrementProgressTracker(pProgressIncrementAmount)
	{
		return this.progressTrackerSet.incrementProgressTracker(this.progressTrackerHash, pProgressIncrementAmount);
	}

	setProgressTrackerTotalOperations(pTotalOperationCount)
	{
		return this.progressTrackerSet.setProgressTrackerTotalOperations(this.progressTrackerHash, pTotalOperationCount);
	}

	getProgressTrackerStatusString()
	{
		return this.progressTrackerSet.getProgressTrackerStatusString(this.progressTrackerHash);
	}
}

module.exports = ProgressTracker;
},{}],97:[function(require,module,exports){
const libFableServiceBase = require('fable-serviceproviderbase');

const libProgressTrackerClass = require('./Fable-Service-ProgressTracker/ProgressTracker.js');

class FableServiceProgressTrackerSet extends libFableServiceBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.serviceType = 'ProgressTrackerSet';

		this.progressTrackers = {};

		// Create an internal PorgressTime service to track timestamps
		this.progressTimes = this.fable.instantiateServiceProviderWithoutRegistration('ProgressTime');

		// This timestamp is used and updated by *all* progress trackers.
		this.progressTimes.createTimeStamp('CurrentTime');
	}

	getProgressTracker(pProgressTrackerHash)
	{
		let tmpProgressTrackerHash = (typeof(pProgressTrackerHash) == 'string') ? pProgressTrackerHash : 'Default';

		if (!(tmpProgressTrackerHash in this.progressTrackers))
		{
			this.fable.log.warn(`ProgressTracker ${tmpProgressTrackerHash} does not exist!  Creating a new tracker...`);
			this.createProgressTracker(tmpProgressTrackerHash, 100);
		}

		return new libProgressTrackerClass(this, pProgressTrackerHash);
	}

	getProgressTrackerData(pProgressTrackerHash)
	{
		let tmpProgressTrackerHash = (typeof(pProgressTrackerHash) == 'string') ? pProgressTrackerHash : 'Default';

		if (!(tmpProgressTrackerHash in this.progressTrackers))
		{
			this.fable.log.warn(`ProgressTracker ${tmpProgressTrackerHash} does not exist!  Creating a new tracker...`);
			this.createProgressTracker(tmpProgressTrackerHash, 100);
		}

		return this.progressTrackers[tmpProgressTrackerHash];
	}

	createProgressTracker(pProgressTrackerHash, pTotalOperations)
	{
		let tmpProgressTrackerHash = (typeof(pProgressTrackerHash) == 'string') ? pProgressTrackerHash : 'Default';
		let tmpTotalOperations = (typeof(pTotalOperations) == 'number') ? pTotalOperations : 100;

		let tmpProgressTracker = (
			{
				Hash: tmpProgressTrackerHash,

				StartTimeHash: `${tmpProgressTrackerHash}-Start`,
				StartTimeStamp: -1,
				CurrentTimeStamp: -1,
				EndTimeHash: `${tmpProgressTrackerHash}-End`,
				EndTimeStamp: -1,

				PercentComplete: -1,
				// If this is set to true, PercentComplete will be calculated as CurrentCount / TotalCount even if it goes over 100%
				AllowTruePercentComplete: false,

				ElapsedTime: -1,
				AverageOperationTime: -1,
				EstimatedCompletionTime: -1,

				TotalCount: tmpTotalOperations,

				CurrentCount:-1
			});

		if (tmpProgressTrackerHash in this.progressTrackers)
		{
			this.fable.log.warn(`ProgressTracker ${tmpProgressTrackerHash} already exists!  Overwriting with a new tracker...`);
			this.progressTimes.removeTimeStamp(tmpProgressTracker.StartTimeHash);
			this.progressTimes.removeTimeStamp(tmpProgressTracker.EndTimeHash);
		}

		this.progressTrackers[tmpProgressTrackerHash] = tmpProgressTracker;

		return tmpProgressTracker;
	}

	setProgressTrackerTotalOperations(pProgressTrackerHash, pTotalOperations)
	{
		let tmpProgressTrackerHash = (typeof(pProgressTrackerHash) == 'string') ? pProgressTrackerHash : 'Default';
		let tmpTotalOperations = (typeof(pTotalOperations) == 'number') ? pTotalOperations : 100;

		if (!(tmpProgressTrackerHash in this.progressTrackers))
		{
			this.fable.log.warn(`Attempted to set the total operations of ProgressTracker ${tmpProgressTrackerHash} but it does not exist!  Creating a new tracker...`);
			this.createProgressTracker(tmpProgressTrackerHash, tmpTotalOperations);
		}

		this.progressTrackers[tmpProgressTrackerHash].TotalCount = tmpTotalOperations;

		return this.progressTrackers[tmpProgressTrackerHash];
	}

	startProgressTracker(pProgressTrackerHash)
	{
		let tmpProgressTrackerHash = (typeof(pProgressTrackerHash) == 'string') ? pProgressTrackerHash : 'Default';

		// This is the only method to lazily create ProgressTrackers now
		if (!(tmpProgressTrackerHash in this.progressTrackers))
		{
			this.createProgressTracker(tmpProgressTrackerHash, 100);
		}

		let tmpProgressTracker = this.progressTrackers[tmpProgressTrackerHash];

		this.progressTimes.createTimeStamp(this.progressTrackers[tmpProgressTrackerHash].StartTimeHash);
		tmpProgressTracker.StartTimeStamp = this.progressTimes.getTimeStampValue(this.progressTrackers[tmpProgressTrackerHash].StartTimeHash);
		if (tmpProgressTracker.CurrentCount < 0)
		{
			tmpProgressTracker.CurrentCount = 0;
		}

		return this.solveProgressTrackerStatus(tmpProgressTrackerHash);
	}

	endProgressTracker(pProgressTrackerHash)
	{
		let tmpProgressTrackerHash = (typeof(pProgressTrackerHash) == 'string') ? pProgressTrackerHash : 'Default';

		if (!(tmpProgressTrackerHash in this.progressTrackers))
		{
			this.fable.log.error(`Attempted to end ProgressTracker ${tmpProgressTrackerHash} that does not exist!`);
			return false;
		}

		let tmpProgressTracker = this.progressTrackers[tmpProgressTrackerHash];

		this.progressTimes.createTimeStamp(this.progressTrackers[tmpProgressTrackerHash].EndTimeHash);
		tmpProgressTracker.EndTimeStamp = this.progressTimes.getTimeStampValue(this.progressTrackers[tmpProgressTrackerHash].EndTimeHash);

		return this.solveProgressTrackerStatus(tmpProgressTrackerHash);
	}

	solveProgressTrackerStatus(pProgressTrackerHash)
	{
		let tmpProgressTrackerHash = (typeof(pProgressTrackerHash) == 'string') ? pProgressTrackerHash : 'Default';

		if (!(tmpProgressTrackerHash in this.progressTrackers))
		{
			this.fable.log.error(`Attempted to solve ProgressTracker ${tmpProgressTrackerHash} that does not exist!`);
			return false;
		}

		let tmpProgressTracker = this.progressTrackers[tmpProgressTrackerHash];

		if ((tmpProgressTracker.TotalCount < 1) || isNaN(tmpProgressTracker.TotalCount))
		{
			this.fable.log.error(`ProgressTracker ${tmpProgressTracker.Hash} has an invalid total count of operations (${tmpProgressTracker.TotalCount}!  Setting it to the default of 100...`);
			tmpProgressTracker.TotalCount = 100;
		}

		// Compute the percentage of progress that is complete.
		if (tmpProgressTracker.CurrentCount < 1)
		{
			tmpProgressTracker.PercentComplete = 0;
		}
		else
		{
			tmpProgressTracker.PercentComplete = (tmpProgressTracker.CurrentCount / tmpProgressTracker.TotalCount) * 100.0;
		}

		if (!tmpProgressTracker.AllowTruePercentComplete && (tmpProgressTracker.PercentComplete > 100))
		{
			tmpProgressTracker.PercentComplete = 100;
		}

		// Compute the average time per operation
		this.progressTimes.updateTimeStampValue('CurrentTime');
		tmpProgressTracker.CurrentTimeStamp = this.progressTimes.getTimeStampValue('CurrentTime');
		tmpProgressTracker.ElapsedTime = tmpProgressTracker.CurrentTimeStamp - tmpProgressTracker.StartTimeStamp;

		if (tmpProgressTracker.EndTimeStamp > 0)
		{
			tmpProgressTracker.ElapsedTime = tmpProgressTracker.EndTimeStamp - tmpProgressTracker.StartTimeStamp;
		}

		if (tmpProgressTracker.CurrentCount > 0)
		{
			tmpProgressTracker.AverageOperationTime = (tmpProgressTracker.CurrentTimeStamp-tmpProgressTracker.StartTimeStamp) / tmpProgressTracker.CurrentCount;
		}
		else
		{
			tmpProgressTracker.AverageOperationTime = -1;
		}

		// Compute the estimated completion
		if (tmpProgressTracker.AverageOperationTime > 0)
		{
			tmpProgressTracker.EstimatedCompletionTime = Math.max((tmpProgressTracker.TotalCount - tmpProgressTracker.CurrentCount), 0) * tmpProgressTracker.AverageOperationTime;
		}
		else
		{
			tmpProgressTracker.EstimatedCompletionTime = -1;
		}

		return tmpProgressTracker;
	}

	updateProgressTracker(pProgressTrackerHash, pCurrentOperations)
	{
		let tmpProgressTrackerHash = (typeof(pProgressTrackerHash) == 'string') ? pProgressTrackerHash : 'Default';
		let tmpCurrentOperations = parseInt(pCurrentOperations);

		if (isNaN(tmpCurrentOperations))
		{
			this.fable.log.warn(`Attempted to update ProgressTracker ${tmpProgressTrackerHash} with an invalid number of operations!`)
			return false;
		}

		if (!(tmpProgressTrackerHash in this.progressTrackers))
		{
			this.createProgressTracker(100, tmpProgressTrackerHash);
		}

		this.progressTrackers[tmpProgressTrackerHash].CurrentCount = tmpCurrentOperations;

		return this.solveProgressTrackerStatus(tmpProgressTrackerHash);
	}

	incrementProgressTracker(pProgressTrackerHash, pOperationIncrementAmount)
	{
		let tmpProgressTrackerHash = (typeof(pProgressTrackerHash) == 'string') ? pProgressTrackerHash : 'Default';
		let tmpOperationIncrementAmount = parseInt(pOperationIncrementAmount);

		if (isNaN(tmpOperationIncrementAmount))
		{
			tmpOperationIncrementAmount = 1;
		}

		if (!(tmpProgressTrackerHash in this.progressTrackers))
		{
			this.fable.log.warn(`Attempted to increment ProgressTracker ${tmpProgressTrackerHash} but it did not exist.`);
			return false;
		}

		if (this.progressTrackers[tmpProgressTrackerHash].StartTimeStamp < 1)
		{
			this.fable.log.warn(`Attempted to increment ProgressTracker ${tmpProgressTrackerHash} but it was not started.. starting now.`);
			this.startProgressTracker(tmpProgressTrackerHash);
		}

		this.progressTrackers[tmpProgressTrackerHash].CurrentCount = this.progressTrackers[tmpProgressTrackerHash].CurrentCount + tmpOperationIncrementAmount;

		return this.solveProgressTrackerStatus(tmpProgressTrackerHash);
	}

	getProgressTrackerCompletedOperationCountString(pProgressTrackerHash)
	{
		let tmpProgressTrackerHash = (typeof(pProgressTrackerHash) == 'string') ? pProgressTrackerHash : 'Default';

		// This call here can mean if we add operations and then immediately get the string, this function runs twice.
		const tmpProgressTracker = this.progressTrackers[tmpProgressTrackerHash];

		// The states of a progress tracker:
		if (tmpProgressTracker.CurrentCount < 0)
		{
			return `none`;
		}
		else if (tmpProgressTracker.CurrentCount < 1)
		{
			return `0`;
		}
		else
		{
			return `${tmpProgressTracker.CurrentCount}`;
		}
	}

	getProgressTrackerPercentCompleteString(pProgressTrackerHash)
	{
		let tmpProgressTrackerHash = (typeof(pProgressTrackerHash) == 'string') ? pProgressTrackerHash : 'Default';

		// This call here can mean if we add operations and then immediately get the string, this function runs twice.
		// TODO: Is there a pattern to avoid this double call that's worth putting in?
		this.solveProgressTrackerStatus(tmpProgressTrackerHash);

		if (!(tmpProgressTrackerHash in this.progressTrackers))
		{
			return `ProgressTracker ${tmpProgressTrackerHash} does not exist!  No stats to display.`;
		}
		else
		{
			const tmpProgressTracker = this.progressTrackers[tmpProgressTrackerHash];

			// The states of a progress tracker:
			// 1. Not started
			if (tmpProgressTracker.StartTimeStamp < 1)
			{
				return `0%`;
			}
			// 2. Started, but no operations completed

			if (tmpProgressTracker.CurrentCount < 1)
			{
				return `0%`;
			}
			// 3. Started, some operations completed
			else if (tmpProgressTracker.EndTimeStamp < 1)
			{
				return `${tmpProgressTracker.PercentComplete.toFixed(3)}%`;
			}
			// 4. Done
			else
			{
				return `${tmpProgressTracker.PercentComplete.toFixed(3)}%`;
			}
		}
	}

	getProgressTrackerStatusString(pProgressTrackerHash)
	{
		let tmpProgressTrackerHash = (typeof(pProgressTrackerHash) == 'string') ? pProgressTrackerHash : 'Default';

		// This call here can mean if we add operations and then immediately get the string, this function runs twice.
		// TODO: Is there a pattern to avoid this double call that's worth putting in?
		this.solveProgressTrackerStatus(tmpProgressTrackerHash);

		if (!(tmpProgressTrackerHash in this.progressTrackers))
		{
			return `ProgressTracker ${tmpProgressTrackerHash} does not exist!  No stats to display.`;
		}
		else
		{
			const tmpProgressTracker = this.progressTrackers[tmpProgressTrackerHash];

			// The states of a progress tracker:
			// 1. Not started
			if (tmpProgressTracker.StartTimeStamp < 1)
			{
				return `ProgressTracker ${tmpProgressTracker.Hash} has not been started yet.`;
			}
			// 2. Started, but no operations completed

			if ((tmpProgressTracker.CurrentCount < 1) && (tmpProgressTracker.EndTimeStamp < 1))
			{
				return `ProgressTracker ${tmpProgressTracker.Hash} has no completed operations.  ${this.progressTimes.formatTimeDuration(tmpProgressTracker.ElapsedTime)} have elapsed since it was started.`;
			}
			// 3. Started, some operations completed
			else if (tmpProgressTracker.EndTimeStamp < 1)
			{
				return `ProgressTracker ${tmpProgressTracker.Hash} is ${tmpProgressTracker.PercentComplete.toFixed(3)}% completed - ${tmpProgressTracker.CurrentCount} / ${tmpProgressTracker.TotalCount} operations over ${this.progressTimes.formatTimeDuration(tmpProgressTracker.ElapsedTime)} (median ${this.progressTimes.formatTimeDuration(tmpProgressTracker.AverageOperationTime)} per).  Estimated completion: ${this.progressTimes.formatTimeDuration(tmpProgressTracker.EstimatedCompletionTime)}`;			}
			// 4. Done
			else
			{
				return `ProgressTracker ${tmpProgressTracker.Hash} is done.  ${tmpProgressTracker.CurrentCount} / ${tmpProgressTracker.TotalCount} operations were completed in ${this.progressTimes.formatTimeDuration(tmpProgressTracker.ElapsedTime)} (median ${this.progressTimes.formatTimeDuration(tmpProgressTracker.AverageOperationTime)} per).`;
			}
		}
	}

	logProgressTrackerStatus(pProgressTrackerHash)
	{
		this.fable.log.info(this.getProgressTrackerStatusString(pProgressTrackerHash));
	}
}

module.exports = FableServiceProgressTrackerSet;
},{"./Fable-Service-ProgressTracker/ProgressTracker.js":96,"fable-serviceproviderbase":59}],98:[function(require,module,exports){
(function (Buffer){(function (){
const libFableServiceBase = require('fable-serviceproviderbase');

const libSimpleGet = require('simple-get');
const libCookie = require('cookie');
const libHttp = require('http');
const libHttps = require('https');

class FableServiceRestClient extends libFableServiceBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.TraceLog = false;
		if (this.options.TraceLog || this.fable.TraceLog)
		{
			this.TraceLog = true;
		}

		this.dataFormat = this.fable.services.DataFormat;

		this.serviceType = 'RestClient';

		this.cookie = false;

		// This is a function that can be overridden, to allow the management
		// of the request options before they are passed to the request library.
		this.prepareRequestOptions = (pOptions) => { return pOptions; };

		// Default per-request timeout (ms). Applied in preRequest when a caller
		// does not supply their own. Node 20+ installs a ~5s socket timeout on
		// http.globalAgent that aborts legitimately long-running requests; any
		// explicit `timeout` on the request options takes that default out of
		// play. See the "Request Timeout" test suite for the behaviors covered.
		if (typeof this.options.RequestTimeout === 'number')
		{
			this.defaultRequestTimeout = this.options.RequestTimeout;
		}
		else if (typeof this.fable.settings.RestClientRequestTimeout === 'number')
		{
			this.defaultRequestTimeout = this.fable.settings.RestClientRequestTimeout;
		}
		else
		{
			this.defaultRequestTimeout = 60000;
		}

		// Always install our own http/https agents so every request bypasses
		// http.globalAgent (and its Node 20+ mystery socket timeout). The
		// KeepAlive flag only controls whether keepAlive is enabled on our own
		// agents, not whether we have agents at all. Additional tuning
		// (maxSockets, agent timeout, etc.) flows through KeepAliveAgentOptions.
		let tmpKeepAlive = Boolean(this.options.KeepAlive || this.fable.settings.RestClientKeepAlive);
		let tmpAgentOptions = Object.assign({}, this.options.KeepAliveAgentOptions);
		if (tmpKeepAlive)
		{
			tmpAgentOptions.keepAlive = true;
		}
		this._installHttpAgents(tmpAgentOptions);
	}

	/**
	 * Initialize HTTP keep-alive agents and wire them into prepareRequestOptions.
	 * Back-compat entry point: always forces keepAlive on. Prefer configuring
	 * the RestClient via the KeepAlive / KeepAliveAgentOptions constructor
	 * options instead of calling this method directly.
	 *
	 * @param {Object} [pAgentOptions] - Additional options passed to the Http/Https Agent constructors (e.g. timeout).
	 */
	initializeKeepAliveAgent(pAgentOptions)
	{
		let tmpAgentOptions = Object.assign({ keepAlive: true }, pAgentOptions);
		this._installHttpAgents(tmpAgentOptions);
	}

	/**
	 * Construct http/https Agents from the given options and wire them into
	 * prepareRequestOptions so every request carries an explicit agent.
	 *
	 * @param {Object} pAgentOptions - Options passed directly to the Http/Https Agent constructors.
	 * @private
	 */
	_installHttpAgents(pAgentOptions)
	{
		this.httpAgent = new libHttp.Agent(pAgentOptions);
		this.httpsAgent = new libHttps.Agent(pAgentOptions);

		// Capture any previously set prepareRequestOptions so we can chain
		let tmpPreviousPrepareRequestOptions = this.prepareRequestOptions;

		this.prepareRequestOptions = (pOptions) =>
		{
			// Mirror simple-get's protocol decision exactly: it routes through
			// the https module if and only if the parsed URL protocol is
			// exactly 'https:'. Everything else — http: URLs, relative URLs
			// (which simple-get treats as no-host http requests), and option
			// objects with no .url at all — goes through the http module.
			// Stamping an httpsAgent on an http request makes Node throw
			// ERR_INVALID_PROTOCOL when http.request validates agent.protocol.
			if (typeof pOptions.url === 'string' && pOptions.url.startsWith('https:'))
			{
				pOptions.agent = this.httpsAgent;
			}
			else
			{
				pOptions.agent = this.httpAgent;
			}
			return tmpPreviousPrepareRequestOptions(pOptions);
		};
	}

	get simpleGet()
	{
		return libSimpleGet;
	}

	prepareCookies(pRequestOptions)
	{
		if (this.cookie)
		{
			let tmpCookieObject = this.cookie;
			if (!('headers' in pRequestOptions))
			{
				pRequestOptions.headers = {};
			}
			let tmpCookieKeys = Object.keys(tmpCookieObject);
			if (tmpCookieKeys.length > 0)
			{
				// Only grab the first for now.
				pRequestOptions.headers.cookie = libCookie.serialize(tmpCookieKeys[0], tmpCookieObject[tmpCookieKeys[0]]);
			}
		}
		return pRequestOptions;
	}

	preRequest(pOptions)
	{
		// Validate the options object
		let tmpOptions = this.prepareCookies(pOptions);

		// Prepend a string to the URL if it exists in the Fable Config
		if ('RestClientURLPrefix' in this.fable.settings)
		{
			tmpOptions.url = this.fable.settings.RestClientURLPrefix + tmpOptions.url;
		}

		// Apply the default request timeout when the caller hasn't supplied
		// one. Setting any numeric value (including 0) suppresses the Node 20+
		// http.globalAgent ~5s socket timeout.
		if (typeof tmpOptions.timeout !== 'number')
		{
			tmpOptions.timeout = this.defaultRequestTimeout;
		}

		return this.prepareRequestOptions(tmpOptions);
	}

	/**
	 * Extract the hostname from a URL string. Returns null for relative URLs
	 * or anything else that doesn't parse cleanly.
	 *
	 * @private
	 * @param {string} pUrl
	 * @return {string|null}
	 */
	_parseHostname(pUrl)
	{
		if (typeof pUrl !== 'string')
		{
			return null;
		}
		try
		{
			return new URL(pUrl).hostname || null;
		}
		catch (e)
		{
			return null;
		}
	}

	/**
	 * Resolve a Location header against the URL of the request that produced
	 * it. Handles absolute Locations (returned as-is) and RFC 7231-compliant
	 * relative Locations (resolved against the current URL).
	 *
	 * @private
	 * @param {string} pCurrentURL - The URL of the request that produced the redirect.
	 * @param {string} pLocation - The Location header value.
	 * @return {string}
	 */
	_resolveRedirectURL(pCurrentURL, pLocation)
	{
		if (typeof pLocation !== 'string' || pLocation.length === 0)
		{
			return pLocation;
		}
		try
		{
			return new URL(pLocation, pCurrentURL).toString();
		}
		catch (e)
		{
			// Either pCurrentURL is itself relative or pLocation is malformed.
			// Fall back to passing it through verbatim — simple-get's parser
			// will give the next hop a final say.
			return pLocation;
		}
	}

	/**
	 * Build the options object for the next hop of a redirect chain. Applies
	 * the same hop-rewrite rules simple-get does, plus an RFC-correct relative
	 * Location resolution that simple-get itself doesn't do:
	 *   - Resolve the Location against the current URL (absolute or relative).
	 *   - Strip simple-get's URL-derived state (protocol/hostname/port/path/auth)
	 *     so the next hop re-parses the URL cleanly.
	 *   - Drop the host header (re-derived from the new URL by simple-get).
	 *   - Cross-origin: drop cookie + authorization to prevent leak.
	 *   - 301/302 + POST: switch to GET, drop body and content headers.
	 *
	 * @private
	 * @param {Object} pOptions - The options used for the previous hop (post-simple-get mutation).
	 * @param {import('http').IncomingMessage} pResponse - The 3xx response.
	 * @param {string|undefined} pOriginalURL - The URL of the previous hop, captured before simple-get deleted it.
	 * @param {string|null} pOriginalHost - The hostname of the previous hop, for cross-origin detection.
	 * @return {Object}
	 */
	_buildRedirectedOptions(pOptions, pResponse, pOriginalURL, pOriginalHost)
	{
		const tmpNew = Object.assign({}, pOptions);
		tmpNew.url = this._resolveRedirectURL(pOriginalURL, pResponse.headers.location);

		// Strip simple-get's own URL-derived fields so the next call re-parses cleanly.
		delete tmpNew.protocol;
		delete tmpNew.hostname;
		delete tmpNew.port;
		delete tmpNew.path;
		delete tmpNew.auth;

		// We set followRedirects=false on the previous hop to disable
		// simple-get's auto-follow; that's our own internal flag, not caller
		// intent. Drop it so the recursive _executeWithRedirects entry treats
		// the next hop as another redirect-following call.
		delete tmpNew.followRedirects;

		// Headers — clone (don't mutate the caller's) and prune.
		if (tmpNew.headers)
		{
			tmpNew.headers = Object.assign({}, tmpNew.headers);
			delete tmpNew.headers.host;
		}

		// Cross-origin redirect: drop cookie and authorization to prevent leak (matches simple-get #73).
		const tmpRedirectHost = this._parseHostname(tmpNew.url);
		if (tmpRedirectHost !== null && tmpRedirectHost !== pOriginalHost && tmpNew.headers)
		{
			delete tmpNew.headers.cookie;
			delete tmpNew.headers.authorization;
		}

		// 301/302 + POST → GET (matches simple-get #35 and RFC 7231 §6.4.2/6.4.3).
		// Body and content headers come off; 307/308 preserve method/body so we leave them alone.
		if (tmpNew.method === 'POST' && (pResponse.statusCode === 301 || pResponse.statusCode === 302))
		{
			tmpNew.method = 'GET';
			if (tmpNew.headers)
			{
				delete tmpNew.headers['content-length'];
				delete tmpNew.headers['content-type'];
			}
			delete tmpNew.body;
			delete tmpNew.form;
		}

		return tmpNew;
	}

	/**
	 * Dispatch a request via simple-get, transparently following 3xx redirects
	 * until a non-redirect response or hard error.
	 *
	 * Why we drive the loop ourselves: simple-get's own redirect path
	 * (index.js lines 50-69) recurses with the original opts.agent intact, so
	 * an http→https redirect ends up calling https.request with an httpAgent
	 * (or vice versa) and Node throws ERR_INVALID_PROTOCOL synchronously.
	 * By disabling simple-get's auto-follow and running prepareRequestOptions
	 * on each hop, the agent gets re-picked to match the new URL's protocol.
	 *
	 * Caller can opt out by setting `followRedirects: false` on options
	 * (matches simple-get's contract) — in that case we hand the 3xx straight
	 * back without following.
	 *
	 * @private
	 * @param {Object} pOptions - Already passed through preRequest on the first call; on recursion, already passed through prepareRequestOptions.
	 * @param {(err?: Error, res?: import('http').IncomingMessage) => void} fCallback
	 */
	_executeWithRedirects(pOptions, fCallback)
	{
		if (pOptions.followRedirects === false)
		{
			return libSimpleGet(pOptions, fCallback);
		}

		// Disable simple-get's own redirect loop — we own it from here.
		pOptions.followRedirects = false;
		const tmpOriginalURL = pOptions.url;
		const tmpOriginalHost = this._parseHostname(tmpOriginalURL);

		return libSimpleGet(pOptions, (pError, pResponse) =>
		{
			if (pError)
			{
				return fCallback(pError, pResponse);
			}

			if (pResponse.statusCode < 300 || pResponse.statusCode >= 400 || !pResponse.headers.location)
			{
				return fCallback(null, pResponse);
			}

			// 3xx with Location — drain and follow.
			pResponse.resume();

			let tmpRedirectsRemaining = (typeof pOptions.maxRedirects === 'number') ? pOptions.maxRedirects : 10;
			if (tmpRedirectsRemaining <= 0)
			{
				return fCallback(new Error('too many redirects'));
			}

			const tmpNextOptions = this._buildRedirectedOptions(pOptions, pResponse, tmpOriginalURL, tmpOriginalHost);
			tmpNextOptions.maxRedirects = tmpRedirectsRemaining - 1;

			// Re-run the agent picker so the next hop's agent matches the
			// (possibly different) protocol of the redirect target. We do
			// NOT re-run preRequest in full — RestClientURLPrefix and
			// prepareCookies are first-call-only.
			const tmpPreparedNext = this.prepareRequestOptions(tmpNextOptions);

			if (this.TraceLog)
			{
				this.fable.log.debug(`--> redirect ${pResponse.statusCode} to ${tmpPreparedNext.url}`);
			}
			return this._executeWithRedirects(tmpPreparedNext, fCallback);
		});
	}

	executeChunkedRequest(pOptions, fCallback)
	{
		let tmpOptions = this.preRequest(pOptions);

		tmpOptions.RequestStartTime = this.fable.log.getTimeStamp();

		if (this.TraceLog)
		{
			this.fable.log.debug(`Beginning ${tmpOptions.method} request to ${tmpOptions.url} at ${tmpOptions.RequestStartTime}`);
		}

		return this._executeWithRedirects(tmpOptions,
			(pError, pResponse)=>
			{
				if (pError)
				{
					return fCallback(pError, pResponse);
				}

				if (this.TraceLog)
				{
					let tmpConnectTime = this.fable.log.getTimeStamp();
					this.fable.log.debug(`--> ${tmpOptions.method} connected in ${this.dataFormat.formatTimeDelta(tmpOptions.RequestStartTime, tmpConnectTime)}ms code ${pResponse.statusCode}`);
				}

				let tmpData = '';

				pResponse.on('data', (pChunk) =>
					{
						// For JSON, the chunk is the serialized object.
						if (this.TraceLog)
						{
							let tmpChunkTime = this.fable.log.getTimeStamp();
							this.fable.log.debug(`--> ${tmpOptions.method} data chunk size ${pChunk.length}b received in ${this.dataFormat.formatTimeDelta(tmpOptions.RequestStartTime, tmpChunkTime)}ms`);
						}
						tmpData += pChunk;
					});

				pResponse.on('end', ()=>
					{
						if (this.TraceLog)
						{
							let tmpCompletionTime = this.fable.log.getTimeStamp();
							this.fable.log.debug(`==> ${tmpOptions.method} completed data size ${tmpData.length}b received in ${this.dataFormat.formatTimeDelta(tmpOptions.RequestStartTime, tmpCompletionTime)}ms`);
						}
						return fCallback(pError, pResponse, tmpData);
					});
			});
	}

	executeChunkedRequestBinary(pOptions, fCallback)
	{
		let tmpOptions = this.preRequest(pOptions);

		tmpOptions.RequestStartTime = this.fable.log.getTimeStamp();

		if (this.TraceLog)
		{
			this.fable.log.debug(`Beginning ${tmpOptions.method} request to ${tmpOptions.url} at ${tmpOptions.RequestStartTime}`);
		}

		tmpOptions.json = false;
		tmpOptions.encoding = null;

		return this._executeWithRedirects(tmpOptions,
			(pError, pResponse)=>
			{
				if (pError)
				{
					return fCallback(pError, pResponse);
				}

				if (this.TraceLog)
				{
					let tmpConnectTime = this.fable.log.getTimeStamp();
					this.fable.log.debug(`--> ${tmpOptions.method} connected in ${this.dataFormat.formatTimeDelta(tmpOptions.RequestStartTime, tmpConnectTime)}ms code ${pResponse.statusCode}`);
				}

				let tmpDataBuffer = false;

				pResponse.on('data', (pChunk) =>
					{
						// For JSON, the chunk is the serialized object.
						if (this.TraceLog)
						{
							let tmpChunkTime = this.fable.log.getTimeStamp();
							this.fable.log.debug(`--> ${tmpOptions.method} data chunk size ${pChunk.length}b received in ${this.dataFormat.formatTimeDelta(tmpOptions.RequestStartTime, tmpChunkTime)}ms`);
						}
						// TODO: Potentially create a third option that streams this to a file?  So it doesn't have to hold it all in memory.
						if (!tmpDataBuffer)
						{
							tmpDataBuffer = Buffer.from(pChunk);
						}
						else
						{
							tmpDataBuffer = Buffer.concat([tmpDataBuffer, pChunk]);
						}
					});

				pResponse.on('end', ()=>
					{
						if (this.TraceLog)
						{
							let tmpCompletionTime = this.fable.log.getTimeStamp();
							this.fable.log.debug(`==> ${tmpOptions.method} completed data size ${tmpDataBuffer.length}b received in ${this.dataFormat.formatTimeDelta(tmpOptions.RequestStartTime, tmpCompletionTime)}ms`);
						}
						return fCallback(pError, pResponse, tmpDataBuffer);
					});
			});
	}

	executeJSONRequest(pOptions, fCallback)
	{
		pOptions.json = true;

		let tmpOptions = this.preRequest(pOptions);

		if (!('headers' in tmpOptions))
		{
			tmpOptions.headers = {};
		}
		/* Automated headers break some APIs
		if (!('Content-Type' in tmpOptions.headers))
		{
			tmpOptions.headers['Content-Type'] = 'application/json';
		}
		*/

		tmpOptions.RequestStartTime = this.fable.log.getTimeStamp();

		if (this.TraceLog)
		{
			this.fable.log.debug(`Beginning ${tmpOptions.method} JSON request to ${tmpOptions.url} at ${tmpOptions.RequestStartTime}`);
		}

		return this._executeWithRedirects(tmpOptions,
			(pError, pResponse)=>
			{
				if (pError)
				{
					return fCallback(pError, pResponse);
				}

				if (this.TraceLog)
				{
					let tmpConnectTime = this.fable.log.getTimeStamp();
					this.fable.log.debug(`--> JSON ${tmpOptions.method} connected in ${this.dataFormat.formatTimeDelta(tmpOptions.RequestStartTime, tmpConnectTime)}ms code ${pResponse.statusCode}`);
				}

				let tmpJSONData = '';

				pResponse.on('data', (pChunk) =>
					{
						if (this.TraceLog)
						{
							let tmpChunkTime = this.fable.log.getTimeStamp();
							this.fable.log.debug(`--> JSON ${tmpOptions.method} data chunk size ${pChunk.length}b received in ${this.dataFormat.formatTimeDelta(tmpOptions.RequestStartTime, tmpChunkTime)}ms`);
						}
						tmpJSONData += pChunk;
					});

				pResponse.on('end', ()=>
					{
						if (this.TraceLog)
						{
							let tmpCompletionTime = this.fable.log.getTimeStamp();
							this.fable.log.debug(`==> JSON ${tmpOptions.method} completed - received in ${this.dataFormat.formatTimeDelta(tmpOptions.RequestStartTime, tmpCompletionTime)}ms`);
						}
						let tmpParsedJSON;
						try
						{
							tmpParsedJSON = JSON.parse(tmpJSONData);
						}
						catch (pParseError)
						{
							let tmpStatusCode = pResponse ? pResponse.statusCode : 'unknown';
							return fCallback(new Error(`JSON parse failed (HTTP ${tmpStatusCode}): ${tmpJSONData.substring(0, 200)}`), pResponse, null);
						}
						return fCallback(pError, pResponse, tmpParsedJSON);
					});
			});
	}

	getJSON(pOptionsOrURL, fCallback)
	{
		let tmpRequestOptions = (typeof(pOptionsOrURL) == 'object') ? pOptionsOrURL : {};
		if (typeof(pOptionsOrURL) == 'string')
		{
			tmpRequestOptions.url = pOptionsOrURL;
		}

		tmpRequestOptions.method = 'GET';

		return this.executeJSONRequest(tmpRequestOptions, fCallback);
	}

	putJSON(pOptions, fCallback)
	{
		if (typeof(pOptions.body) != 'object')
		{
			return fCallback(new Error(`PUT JSON Error Invalid options object`));
		}

		pOptions.method = 'PUT';

		return this.executeJSONRequest(pOptions, fCallback);
	}

	postJSON(pOptions, fCallback)
	{
		if (typeof(pOptions.body) != 'object')
		{
			return fCallback(new Error(`POST JSON Error Invalid options object`));
		}

		pOptions.method = 'POST';

		return this.executeJSONRequest(pOptions, fCallback);
	}

	patchJSON(pOptions, fCallback)
	{
		if (typeof(pOptions.body) != 'object')
		{
			return fCallback(new Error(`PATCH JSON Error Invalid options object`));
		}

		pOptions.method = 'PATCH';

		return this.executeJSONRequest(pOptions, fCallback);
	}

	headJSON(pOptions, fCallback)
	{
		if (typeof(pOptions.body) != 'object')
		{
			return fCallback(new Error(`HEAD JSON Error Invalid options object`));
		}

		pOptions.method = 'HEAD';

		return this.executeJSONRequest(pOptions, fCallback);
	}

	delJSON(pOptions, fCallback)
	{
		pOptions.method = 'DELETE';

		return this.executeJSONRequest(pOptions, fCallback);
	}

	/**
	 * Upload binary data via POST.
	 *
	 * Accepts Buffer, Blob, or File as the body. In the browser, Blob/File
	 * bodies are converted to Buffer (via ArrayBuffer) before being passed
	 * to simple-get so the stream-http shim can send them correctly.
	 *
	 * The response body is read as a string (servers typically return JSON
	 * status for upload endpoints).
	 *
	 * @param {Record<string, any>} pOptions - Request options (url, body, headers, method)
	 * @param {(pError?: Error, pResponse: any, pBody?: any) => void} fCallback - Callback (pError, pResponse, pBody)
	 * @param {(pProgress: number) => void} [fOnProgress] - Optional progress callback (0.0 to 1.0); called with 1.0 on completion
	 */
	executeBinaryUpload(pOptions, fCallback, fOnProgress)
	{
		// Blob/File → Buffer conversion for simple-get compatibility
		let tmpBody = pOptions.body;

		if (typeof Blob !== 'undefined' && tmpBody instanceof Blob)
		{
			let tmpSelf = this;
			tmpBody.arrayBuffer()
				.then(
					(pArrayBuffer) =>
					{
						pOptions.body = Buffer.from(pArrayBuffer);
						tmpSelf._executeBinaryUploadInternal(pOptions, fCallback, fOnProgress);
					})
				.catch(
					(pError) =>
					{
						return fCallback(pError);
					});
			return;
		}

		// Already a Buffer, string, or stream — proceed directly
		return this._executeBinaryUploadInternal(pOptions, fCallback, fOnProgress);
	}

	/**
	 * Internal binary upload implementation using simple-get.
	 *
	 * @param {Record<string, any>} pOptions - Request options with body already as Buffer
	 * @param {(pError?: Error, pResponse: any, pBody?: any) => void} fCallback - Callback (pError, pResponse, pBody)
	 * @param {(pProgress: number) => void} [fOnProgress] - Optional progress callback (0.0 to 1.0); called with 1.0 on completion
	 * @private
	 */
	_executeBinaryUploadInternal(pOptions, fCallback, fOnProgress)
	{
		let tmpOptions = this.preRequest(pOptions);

		tmpOptions.RequestStartTime = this.fable.log.getTimeStamp();

		if (this.TraceLog)
		{
			this.fable.log.debug(`Beginning ${tmpOptions.method} binary upload to ${tmpOptions.url} at ${tmpOptions.RequestStartTime}`);
		}

		tmpOptions.json = false;

		return this._executeWithRedirects(tmpOptions,
			(pError, pResponse) =>
			{
				if (pError)
				{
					return fCallback(pError, pResponse);
				}

				if (this.TraceLog)
				{
					let tmpConnectTime = this.fable.log.getTimeStamp();
					this.fable.log.debug(`--> Binary upload ${tmpOptions.method} connected in ${this.dataFormat.formatTimeDelta(tmpOptions.RequestStartTime, tmpConnectTime)}ms code ${pResponse.statusCode}`);
				}

				let tmpData = '';

				pResponse.on('data', (pChunk) =>
					{
						if (this.TraceLog)
						{
							let tmpChunkTime = this.fable.log.getTimeStamp();
							this.fable.log.debug(`--> Binary upload ${tmpOptions.method} response chunk size ${pChunk.length}b received in ${this.dataFormat.formatTimeDelta(tmpOptions.RequestStartTime, tmpChunkTime)}ms`);
						}
						tmpData += pChunk;
					});

				pResponse.on('end', () =>
					{
						if (this.TraceLog)
						{
							let tmpCompletionTime = this.fable.log.getTimeStamp();
							this.fable.log.debug(`==> Binary upload ${tmpOptions.method} completed in ${this.dataFormat.formatTimeDelta(tmpOptions.RequestStartTime, tmpCompletionTime)}ms`);
						}
						// Signal completion via progress callback
						if (typeof fOnProgress === 'function')
						{
							fOnProgress(1.0);
						}
						return fCallback(pError, pResponse, tmpData);
					});
			});
	}

	getRawText(pOptionsOrURL, fCallback)
	{
		let tmpRequestOptions = (typeof(pOptionsOrURL) == 'object') ? pOptionsOrURL : {};
		if (typeof(pOptionsOrURL) == 'string')
		{
			tmpRequestOptions.url = pOptionsOrURL;
		}

		tmpRequestOptions.method = 'GET';

		return this.executeChunkedRequest(tmpRequestOptions, fCallback);
	}
}

module.exports = FableServiceRestClient;

}).call(this)}).call(this,require("buffer").Buffer)

},{"buffer":20,"cookie":31,"fable-serviceproviderbase":59,"http":166,"https":113,"simple-get":165}],99:[function(require,module,exports){
const libFableServiceBase = require('fable-serviceproviderbase');

class FableServiceTemplate extends libFableServiceBase
{
	// Underscore and lodash have a behavior, _.template, which compiles a
	// string-based template with code snippets into simple executable pieces,
	// with the added twist of returning a precompiled function ready to go.
	//
	// NOTE: This does not implement underscore escape expressions
	// NOTE: This does not implement underscore magic browser variable assignment
	//
	// This is an implementation of that.
	// TODO: Make this use precedent, add configuration, add debugging.
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.serviceType = 'Template';

		// These are the exact regex's used in lodash/underscore
		// TODO: Switch this to precedent
		this.Matchers = (
			{
				Evaluate: /<%([\s\S]+?)%>/g,
				Interpolate: /<%=([\s\S]+?)%>/g,
				Escaper: /\\|'|\r|\n|\t|\u2028|\u2029/g,
				Unescaper: /\\(\\|'|r|n|t|u2028|u2029)/g,
				// This is how underscore does it, so we are keeping it for now.
				GuaranteedNonMatch: /.^/
			});

		// This is a helper for the escaper and unescaper functions.
		// Right now we are going to keep what underscore is doing, but, not forever.
		this.templateEscapes = {
			'\\': '\\',
			"'": "'",
			'r': '\r',
			'\r': 'r',
			'n': '\n',
			'\n': 'n',
			't': '\t',
			'\t': 't',
			'u2028': '\u2028',
			'\u2028': 'u2028',
			'u2029': '\u2029',
			'\u2029': 'u2029'
		};

		// This is defined as such to underscore that it is a dynamic programming
		// function on this class.
		this.renderFunction = false;
		this.templateString = false;
	}

	renderTemplate(pData)
	{
		return this.renderFunction(pData);
	}

	templateFunction()
	{
		let fRenderTemplateBound = this.renderTemplate.bind(this);
		return fRenderTemplateBound;
	}

	buildTemplateFunction(pTemplateText, pData)
	{
		// For now this is being kept in a weird form ... this is to mimic the old
		// underscore code until this is rewritten using precedent.
		this.TemplateSource = "__p+='" + pTemplateText
			.replace(this.Matchers.Escaper,
				(pMatch)=>
				{
					return `\\${this.templateEscapes[pMatch]}`;
				})
			.replace(this.Matchers.Interpolate || this.Matchers.GuaranteedNonMatch,
				(pMatch, pCode) =>
				{
					return `'+\n(${decodeURIComponent(pCode)})+\n'`;
				})
			.replace(this.Matchers.Evaluate || this.Matchers.GuaranteedNonMatch,
				(pMatch, pCode) =>
				{
					return `';\n${decodeURIComponent(pCode)}\n;__p+='`;
				}) + `';\n`;


		this.TemplateSource = `with(pTemplateDataObject||{}){\n${this.TemplateSource}}\n`;
		this.TemplateSource = `var __p='';var print=function(){__p+=Array.prototype.join.call(arguments, '')};\n${this.TemplateSource}return __p;\n`;

		this.renderFunction = new Function('pTemplateDataObject', this.TemplateSource);

		if (typeof(pData) != 'undefined')
		{
			return this.renderFunction(pData);
		}

		// Provide the compiled function source as a convenience for build time
		// precompilation.
		this.TemplateSourceCompiled = 'function(obj){\n' + this.TemplateSource + '}';

		return this.templateFunction();
	}
}

module.exports = FableServiceTemplate;

},{"fable-serviceproviderbase":59}],100:[function(require,module,exports){
const libFableServiceBase = require('fable-serviceproviderbase');

// TODO: These are still pretty big -- consider the smaller polyfills
const libAsyncWaterfall = require('async.waterfall');
const libAsyncEachLimit = require('async.eachlimit');

const libBigNumber = require('big.js');

class FableServiceUtility extends libFableServiceBase
{
	// Underscore and lodash have a behavior, _.template, which compiles a
	// string-based template with code snippets into simple executable pieces,
	// with the added twist of returning a precompiled function ready to go.
	//
	// NOTE: This does not implement underscore escape expressions
	// NOTE: This does not implement underscore magic browser variable assignment
	//
	// This is an implementation of that.
	// TODO: Make this use precedent, add configuration, add debugging.
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.templates = {};

		// These two functions are used extensively throughout
		this.waterfall = libAsyncWaterfall;
		this.eachLimit = libAsyncEachLimit;

		this.bigNumber = libBigNumber;
	}

	// Underscore and lodash have a behavior, _.extend, which merges objects.
	// Now that es6 gives us this, use the native thingy.
	// Nevermind, the native thing is not stable enough across environments
	// Basic shallow copy
	extend(pDestinationObject, ...pSourceObjects)
	{
		for (let i = 0; i < pSourceObjects.length; i++)
		{
			let tmpSourceObject = pSourceObjects[i];
			if (typeof(tmpSourceObject) === 'object')
			{
				let tmpObjectProperties = Object.keys(tmpSourceObject);
				for (let k = 0; k < tmpObjectProperties.length; k++)
				{
					pDestinationObject[tmpObjectProperties[k]] = tmpSourceObject[tmpObjectProperties[k]];
				}
			}
		}
		return pDestinationObject;
	}

	// Underscore and lodash have a behavior, _.template, which compiles a
	// string-based template with code snippets into simple executable pieces,
	// with the added twist of returning a precompiled function ready to go.
	template(pTemplateText, pData)
	{
		let tmpTemplate = this.fable.instantiateServiceProviderWithoutRegistration('Template');
		return tmpTemplate.buildTemplateFunction(pTemplateText, pData);
	}

	// Build a template function from a template hash, and, register it with the service provider
	buildHashedTemplate(pTemplateHash, pTemplateText, pData)
	{
		let tmpTemplate = this.fable.instantiateServiceProvider('Template', {}, pTemplateHash);
		this.templates[pTemplateHash] = tmpTemplate.buildTemplateFunction(pTemplateText, pData);
		return this.templates[pTemplateHash];
	}

	// This is a safe, modern version of chunk from underscore
	// Algorithm pulled from a mix of these two polyfills:
	// https://github.com/you-dont-need/You-Dont-Need-Lodash-Underscore#_chunk
	// https://youmightnotneed.com/lodash
	// This implementation was most tolerant in browsers.  Uglify can fix the rest.
	chunk (pInput, pChunkSize, pChunkCache)
	{
		let tmpInputArray = [...pInput];
		// Note lodash defaults to 1, underscore defaults to 0
		let tmpChunkSize = (typeof(pChunkSize) == 'number') ? pChunkSize : 0;
		let tmpChunkCache = (typeof(pChunkCache) != 'undefined') ? pChunkCache : [];

		if (tmpChunkSize <= 0)
		{
			return tmpChunkCache;
		}

		while (tmpInputArray.length)
		{
			tmpChunkCache.push(tmpInputArray.splice(0, tmpChunkSize));
		}

		return tmpChunkCache;
	}

	/**
	 * Get a value from fable/pict by hash/address
	 * @param {string} pValueAddress - The manyfest hash/address of the value to get
	 */
	getInternalValueByHash(pValueAddress)
	{
		// Get the value from the internal manifest and return it
		return this.getValueByHash(this.fable, pValueAddress);
	}

	/**
	 * Set a value from fable/pict by hash/address
	 *
	 * @param {string} pValueAddress - The manyfest hash/address of the value to get
	 * @param {any} pValue - The value to set
	 */
	setInternalValueByHash(pValueAddress, pValue)
	{
		// Get the value from the internal manifest and return it
		return this.setValueByHash(this.fable, pValueAddress, pValue);
	}

	/**
	 * Get a value from an object by hash/address
	 * @param {object} pObject - The object to get the value from
	 * @param {string} pValueAddress - The manyfest hash/address of the value to get
	 * @param {object} [pManifest] - The manyfest object to use; constructs one inline if not provided
	 * @returns {object} - The value from the object
	 */
	getValueByHash(pObject, pValueAddress, pManifest)
	{
		let tmpManifest = pManifest;

		if (typeof(tmpManifest) == 'undefined')
		{
			// Lazily create a manifest if it doesn't exist
			if (!this.manifest)
			{
				this.manifest = this.fable.newManyfest();
			}
			tmpManifest = this.manifest;
		}

		// Get the value from the internal manifest and return it
		return tmpManifest.getValueByHash(pObject, pValueAddress);
	}

	/**
	 * Set a value to an object by hash/address
	 * @param {object} pObject - The object to get the value from
	 * @param {string} pValueAddress - The manyfest hash/address of the value to get
	 * @param {object} pValue - The value to set
	 * @param {object} [pManifest] - The manyfest object to use; constructs one inline if not provided
	 * @returns {object} - The value from the object
	 */
	setValueByHash(pObject, pValueAddress, pValue, pManifest)
	{
		let tmpManifest = pManifest;

		if (typeof(tmpManifest) == 'undefined')
		{
			// Lazily create a manifest if it doesn't exist
			if (!this.manifest)
			{
				this.manifest = this.fable.newManyfest();
			}
			tmpManifest = this.manifest;
		}

		// Get the value from the internal manifest and return it
		return tmpManifest.setValueByHash(pObject, pValueAddress, pValue);
	}

	/**
	 * Get a value array from an object by hash/address list
	 * @param {object} pObject - The object to get the value from
	 * @param {string} pValueAddress - The manyfest hash/address of the value to get
	 * @param {object} [pManifest] - The manyfest object to use; constructs one inline if not provided
	 * @returns {Array} - The value array built from the hash list
	 */
	createValueArrayByHashes(pObject, pValueHashes, pManifest)
	{
		let tmpManifest = pManifest;

		if (typeof(tmpManifest) == 'undefined')
		{
			// Lazily create a manifest if it doesn't exist
			if (!this.manifest)
			{
				this.manifest = this.fable.newManyfest();
			}
			tmpManifest = this.manifest;
		}

		if (!Array.isArray(pValueHashes))
		{
			return [];
		}

		let tmpValueArray = [];
		for (let i = 0; i < pValueHashes.length; i++)
		{
			tmpValueArray.push(tmpManifest.getValueByHash(pObject, pValueHashes[i]));
		}

		// Get the value from the internal manifest and return it
		return tmpValueArray;
	}

	slice(pValueArray, pStartIndex, pEndIndex)
	{
		if (!Array.isArray(pValueArray))
		{
			this.fable.log.error('Fable.Math.slice called with non-array value', { pValueArray });
			return [];
		}
		const tmpStartIndex = Number(this.fable.Math.parsePrecise(pStartIndex, '0'));
		const tmpEndIndex = Number(this.fable.Math.parsePrecise(pEndIndex, pValueArray.length.toString()));
		return pValueArray.slice(tmpStartIndex, tmpEndIndex);
	}

	/**
	 * Get a value array by hash/address list from the internal fable/pict state
	 * @param {string} pValueHashes - The manyfest hash/address of the value to get
	 * @param {object} [pManifest] - The manyfest object to use; constructs one inline if not provided
	 * @returns {Array} - The value array built from the hash list
	 */
	createValueArrayByHashesFromInternal(pValueHashes, pManifest)
	{
		return this.createValueArrayByHashes(this.fable, pValueHashes, pManifest);
	}

	createValueArrayByHashParametersFromInternal()
	{
		if (arguments.length < 2)
		{
			return [];
		}

		let tmpValueHashes = Array.prototype.slice.call(arguments);
		return this.createValueArrayByHashes(this.fable, tmpValueHashes);
	}

	/**
	 * Get a value object from a list of hash/addressese
	 * @param {object} pObject - The object to get the value from
	 * @param {string} pValueHashes - The manyfest hash/address of the value to get
	 * @param {object} [pManifest] - The manyfest object to use; constructs one inline if not provided
	 * @returns {object} - The value object built from the hash list
	 */
	createValueObjectByHashes(pObject, pValueHashes, pManifest)
	{
		let tmpManifest = pManifest;

		if (typeof(tmpManifest) == 'undefined')
		{
			// Lazily create a manifest if it doesn't exist
			if (!this.manifest)
			{
				this.manifest = this.fable.newManyfest();
			}
			tmpManifest = this.manifest;
		}

		if (!Array.isArray(pValueHashes))
		{
			return {};
		}

		let tmpValueObject = {};
		for (let i = 0; i < pValueHashes.length; i++)
		{
			tmpValueObject[pValueHashes[i]] = tmpManifest.getValueByHash(pObject, pValueHashes[i]);
		}

		// Get the value from the internal manifest and return it
		return tmpValueObject;
	}

	/**
	 * Get a value object by hash/address list from the internal fable/pict state
	 * @param {string} pValueAddress - The manyfest hash/address of the value to get
	 * @param {object} [pManifest] - The manyfest object to use; constructs one inline if not provided
	 * @returns {object} - The value object built from the hash list
	 */
	createValueObjectByHashesFromInternal(pValueHashes, pManifest)
	{
		return this.createValueObjectByHashes(this.fable, pValueHashes, pManifest);
	}

	/**
	 * Get a value object by hash/address list as parameters from the internal fable/pict state
	 * @returns {Array} - The value array built from the hash list
	 */
	createValueObjectByHashParametersFromInternal()
	{
		let tmpValueHashes = Array.prototype.slice.call(arguments);
		return this.createValueObjectByHashes(this.fable, tmpValueHashes);
	}


	/**
	 * Check if a value is null or empty
	 * @param {object} pObject - The object to check
	 * @param {string} pValueAddress - The manyfest hash/address to check
	 */
	addressIsNullOrEmpty(pObject, pValueAddress)
	{
		// Lazily create a manifest if it doesn't exist
		if (!this.manifest)
		{
			this.manifest = this.fable.newManyfest();
		}

		// If it doesn't exist, it is null or empty.
		if (!this.manifest.checkAddressExists(pObject, pValueAddress))
		{
			return true;
		}

		// Get the value from the internal manifest and return it
		let tmpValue = this.manifest.getValueByHash(pObject, pValueAddress);
		if (tmpValue === null || tmpValue === '')
		{
			return true;
		}

		return false;
	}

	// Convert objects to arrays of labels or values for solvers
	objectKeysToArray(pObject)
	{
		return Object.keys(pObject);
	}

	// Convert object values to an array of values
	objectValuesToArray(pObject)
	{
		if ((typeof(pObject) !== 'object') || (pObject === null))
		{
			return [];
		}
		let tmpKeys = Object.keys(pObject);
		let tmpValues = [];

		for (let i = 0; i < tmpKeys.length; i++)
		{
			tmpValues.push(pObject[tmpKeys[i]]);
		}

		return tmpValues;
	}

	objectValuesSortByExternalArray(pArray, pObjectArray, pDescending, pSearchAddress)
	{
		let tmpDescending = (typeof(pDescending) == 'boolean') ? pDescending :
							((typeof(pDescending) == 'number') && (pDescending == 1)) ? true :
							((typeof(pDescending) == 'string') && (pDescending == '1')) ? true :
							false;
		let tmpManifest = this.fable.newManyfest();

		let tmpSearchAddresses = pSearchAddress;

		if (typeof(tmpSearchAddresses) != 'string')
		{
			// Defaulting to "label"...
			tmpSearchAddresses = 'label';
		}

		let tmpSortHelperArray = [];

		for (let i = 0; i < pArray.length; i++)
		{
			tmpSortHelperArray.push(
				{
					Value: pArray[i],
					SortValue: tmpManifest.getValueByHash(pObjectArray[i], tmpSearchAddresses),
					SortObject: pObjectArray[i]
				});
		}

		let tmpSortedArray = tmpSortHelperArray.sort((pLeft, pRight) =>
		{
			if (pLeft.SortValue < pRight.SortValue)
			{
				return tmpDescending ? 1 : -1;
			}
			if (pLeft.SortValue > pRight.SortValue)
			{
				return tmpDescending ? -1 : 1;
			}
			return 0;
		}).map((pSortHelperArrayObject) => { return pSortHelperArrayObject.Value; });

		return tmpSortedArray;
	}

	// Convert an ISO string to a javascript date object
	// Adapted from https://stackoverflow.com/a/54751179
	//
	// Takes strings like: 2022-11-04T11:34:45.000Z
	//                and: 1986-06-11T09:34:46.012Z+0200
	// ... and converts them into javascript timestamps, following the directions of the timezone stuff.
	//
	// This is not meant to replace the more complex libraries such as moment or luxon.
	// This *is* meant to be a simple, small, and fast way to convert ISO strings to dates in engines
	// with ultra limited JS capabilities where those don't work.
	isoStringToDate (pISOString)
	{
		if (!('Dates' in this.fable))
		{
			this.fable.instantiateServiceProvider('Dates');
		}

		let tmpDate = false;

		try
		{
			tmpDate = this.fable.Dates.dayJS.utc(pISOString);
		}
		catch(pError)
		{
			// TODO: Should this throw?  Doubtful.
			this.fable.log.error(`Could not parse date string ${pISOString} with dayJS.`);
			return false;
		}

		if (tmpDate)
		{
			return tmpDate.toDate();
		}
		else
		{
			return false;
		}
	}

	/**
	 * Find the first value in an object that contains a specific value
	 * @param {array} pObjectArray - The array of objects to search
	 * @param {string} pValueToMatchAddress - The manyfest hash/address of the value to match
	 * @param {string} pValueToMatch - The value to match
	 * @param {string} pValueAddress - The manyfest hash/address of the value to return
	 * @returns {any} - The value from the object
	 */
	findFirstValueByStringIncludes(pObjectArray, pValueToMatchAddress, pValueToMatch, pValueAddress)
	{
		// Lazily create a manifest if it doesn't exist
		if (!this.manifest)
		{
			this.manifest = this.fable.newManyfest();
		}

		if (!Array.isArray(pObjectArray))
		{
			return undefined;
		}
		for (let i = 0; i < pObjectArray.length; i++)
		{
			let tmpValueToMatch = this.manifest.getValueByHash(pObjectArray[i], pValueToMatchAddress);
			if (tmpValueToMatch && (tmpValueToMatch.includes(pValueToMatch)))
			{
				return this.manifest.getValueByHash(pObjectArray[i], pValueAddress);
			}
		}

		return undefined;
	}

	/**
	 * Find the first value in an object that contains a specific value
	 * @param {string} pFableAddress - The address in the fable object to pull the value from
	 * @param {string} pValueToMatchAddress - The manyfest hash/address of the value to match
	 * @param {string} pValueToMatch - The value to match
	 * @param {string} pValueAddress - The manyfest hash/address of the value to return
	 * @returns {any} - The value from the object
	 */
	findFirstValueByStringIncludesInternal(pFableAddress, pValueToMatchAddress, pValueToMatch, pValueAddress)
	{
		// Lazily create a manifest if it doesn't exist
		if (!this.manifest)
		{
			this.manifest = this.fable.newManyfest();
		}

		if (typeof(pFableAddress) != 'string')
		{
			return undefined;
		}
		let tmpObjectArray = this.manifest.getValueByHash(this.fable, pFableAddress);

		return this.findFirstValueByStringIncludes(tmpObjectArray, pValueToMatchAddress, pValueToMatch, pValueAddress);
	}

	/**
	 * Find the first value in an object that contains a specific value
	 * @param {array} pObjectArray - The array of objects to search
	 * @param {string} pValueToMatchAddress - The manyfest hash/address of the value to match
	 * @param {string} pValueToMatch - The value to match
	 * @param {string} pValueAddress - The manyfest hash/address of the value to return
	 * @returns {any} - The value from the object
	 */
	findFirstValueByExactMatch(pObjectArray, pValueToMatchAddress, pValueToMatch, pValueAddress)
	{
		// Lazily create a manifest if it doesn't exist
		if (!this.manifest)
		{
			this.manifest = this.fable.newManyfest();
		}

		if (!Array.isArray(pObjectArray))
		{
			return undefined;
		}
		for (let i = 0; i < pObjectArray.length; i++)
		{
			let tmpValueToMatch = this.manifest.getValueByHash(pObjectArray[i], pValueToMatchAddress);
			if (tmpValueToMatch && (tmpValueToMatch == pValueToMatch))
			{
				return this.manifest.getValueByHash(pObjectArray[i], pValueAddress);
			}
		}

		return undefined;
	}

	/**
	 * Find the first value in an object that contains a specific value
	 * @param {string} pFableAddress - The address in the fable object to pull the value from
	 * @param {string} pValueToMatchAddress - The manyfest hash/address of the value to match
	 * @param {string} pValueToMatch - The value to match
	 * @param {string} pValueAddress - The manyfest hash/address of the value to return
	 * @returns {any} - The value from the object
	 */
	findFirstValueByExactMatchInternal(pFableAddress, pValueToMatchAddress, pValueToMatch, pValueAddress)
	{
		// Lazily create a manifest if it doesn't exist
		if (!this.manifest)
		{
			this.manifest = this.fable.newManyfest();
		}

		if (typeof(pFableAddress) != 'string')
		{
			return undefined;
		}
		let tmpObjectArray = this.manifest.getValueByHash(this.fable, pFableAddress);

		return this.findFirstValueByExactMatch(tmpObjectArray, pValueToMatchAddress, pValueToMatch, pValueAddress);
	}

	/**
	 * Find the index of a value in an array, using the specified search mode.
	 *
	 * @param {any} pValueToFind - The value to find.
	 * @param {Array<any>|string} pSearchArray - The array to search, or the address of such an array.
	 * @param {string|number} [pSearchMode='1'] - The search mode ('0' for exact match, '1' (or default) for searching sorted sets and finding the first value >= the specifid value. '-1' is the same behavior as '1' but sorted descending.
	 *
	 * @returns {number} - The index of the found value, or -1 if not found.
	 */
	findIndexInternal(pValueToFind, pSearchArray, pSearchMode = '1')
	{
		let tmpSearchArray = pSearchArray;
		if (typeof (pSearchArray) === 'string')
		{
			if (!this.manifest)
			{
				this.manifest = this.fable.newManyfest();
			}
			tmpSearchArray = this.manifest.getValueByHash(this.fable, pSearchArray);
		}

		if (!Array.isArray(tmpSearchArray))
		{
			this.fable.log.error('findIndexInternal called with non-array search array.');
			return -1;
		}

		const tmpIsNumericSearch = this.fable.Math.parsePrecise(pValueToFind, null) !== null;
		let tmpMatchIndex = -1;
		let tmpComparisonFunction;
		if (Number(pSearchMode) === 0)
		{
			// Exact match
			if (tmpIsNumericSearch)
			{
				tmpComparisonFunction = (pCandidate) => this.fable.Math.comparePrecise(pCandidate, pValueToFind) === 0;
			}
			else
			{
				tmpComparisonFunction = (pCandidate) => pCandidate === pValueToFind;
			}
		}
		else if (Number(pSearchMode) === -1)
		{
			// Sorted descending
			if (tmpIsNumericSearch)
			{
				tmpComparisonFunction = (pCandidate) => this.fable.Math.ltePrecise(pCandidate, pValueToFind);
			}
			else
			{
				tmpComparisonFunction = (pCandidate) => pCandidate <= pValueToFind;
			}
		}
		else
		{
			// Sorted ascending
			if (tmpIsNumericSearch)
			{
				tmpComparisonFunction = (pCandidate) => this.fable.Math.gtePrecise(pCandidate, pValueToFind);
			}
			else
			{
				tmpComparisonFunction = (pCandidate) => pCandidate >= pValueToFind;
			}
		}
		for (let i = 0; i < tmpSearchArray.length; i++)
		{
			if (tmpComparisonFunction(tmpSearchArray[i]))
			{
				return i;
			}
		}
		return -1;
	}

	/**
	 * Flatten an array of solver inputs into a single array
	 *
	 * @param {Array<any>} pInputArray - The array of inputs to flatten
	 * @return {Array<any>} - The flattened array
	 */
	flattenArrayOfSolverInputs(pInputArray)
	{
		if (!Array.isArray(pInputArray))
		{
			if (typeof pInputArray === 'object')
			{
				pInputArray = Object.values(pInputArray);
			}
			if (!pInputArray)
			{
				return [];
			}
		}
		const tmpArrayFlattener = (p) =>
		{
			if (Array.isArray(p))
			{
				return p; // .flatMap(tmpArrayFlattener);
			}
			if (typeof p === 'object')
			{
				return Object.values(p);
			}
			return [ p ];
		};
		return pInputArray.flatMap(tmpArrayFlattener);
	}

	generateArrayOfObjectsFromSets()
	{
		// For each argument pair, map data to an array of objects with the first parameter of the pairs as the property name and the second parameter as the array of values
		let tmpResultArray = [];
		if (arguments.length % 2 != 0)
		{
			// Must be pairs
			return tmpResultArray;
		}

		let tmpPropertyNames = [];
		let tmpValueArrays = [];

		for (let i = 0; i < arguments.length; i += 2)
		{
			tmpPropertyNames.push(arguments[i]);
			tmpValueArrays.push(this.objectValuesToArray(arguments[i + 1]));
		}

		for (let h = 0; h < tmpValueArrays.length; h++)
		{
			let tmpValueArray = tmpValueArrays[h];
			let tmpPropertyName = tmpPropertyNames[h];
			if (!Array.isArray(tmpValueArray))
			{
				continue;
			}
			for (let i = 0; i < tmpValueArray.length; i++)
			{
				if (tmpResultArray.length <= i)
				{
					tmpResultArray.push({});
				}

				let tmpObject = tmpResultArray[i];
				if (!tmpObject)
				{
					// This shouldn't be possible
					continue;
				}

				tmpObject[tmpPropertyName] = tmpValueArray[i];
			}
		}

		return tmpResultArray;
	}

	/**
	 * Take a set of arbitrary parameters and build an array from them
	 * @returns {Array} - An array built from the absolute values of the parameters
	 */
	createArrayFromAbsoluteValues()
	{
		let tmpArray = [];
		for (let i = 0; i < arguments.length; i++)
		{
			tmpArray.push(arguments[i]);
		}
		return tmpArray;
	}

	/**
	 * Concatenate multiple arrays into a single array
	 *
	 * @return {Array<any>} - The concatenated array
	 */
	concatenateArrays()
	{
		let tmpResultArray = [];
		for (let i = 0; i < arguments.length; ++i)
		{
			let tmpArray = arguments[i];
			if (Array.isArray(tmpArray))
			{
				tmpResultArray = tmpResultArray.concat(tmpArray);
			}
			else
			{
				this.fable.log.error('Fable.Service.Utility.concatenateArrays called with non-array argument', { index: i, value: tmpArray });
			}
		}
		return tmpResultArray;
	}
}

module.exports = FableServiceUtility;

},{"async.eachlimit":1,"async.waterfall":15,"big.js":17,"fable-serviceproviderbase":59}],101:[function(require,module,exports){

class SetConcatArray
{
	/**
	 * @param {Array<any>|SetConcatArray} pLeftValue - The left value to concatenate.
	 * @param {Array<any>|SetConcatArray} pRightValue - The right value to concatenate.
	 */
	constructor(pLeftValue, pRightValue)
	{
		if (pLeftValue instanceof SetConcatArray)
		{
			this.values = pLeftValue.values.concat([ pRightValue ]);
		}
		else if (pRightValue instanceof SetConcatArray)
		{
			this.values = [ pLeftValue ].concat(pRightValue.values);
		}
		else
		{
			this.values = [ pLeftValue, pRightValue ];
		}
	}
}

module.exports = SetConcatArray;

},{}],102:[function(require,module,exports){
'use strict';

/* eslint no-invalid-this: 1 */

var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var toStr = Object.prototype.toString;
var max = Math.max;
var funcType = '[object Function]';

var concatty = function concatty(a, b) {
    var arr = [];

    for (var i = 0; i < a.length; i += 1) {
        arr[i] = a[i];
    }
    for (var j = 0; j < b.length; j += 1) {
        arr[j + a.length] = b[j];
    }

    return arr;
};

var slicy = function slicy(arrLike, offset) {
    var arr = [];
    for (var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1) {
        arr[j] = arrLike[i];
    }
    return arr;
};

var joiny = function (arr, joiner) {
    var str = '';
    for (var i = 0; i < arr.length; i += 1) {
        str += arr[i];
        if (i + 1 < arr.length) {
            str += joiner;
        }
    }
    return str;
};

module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || toStr.apply(target) !== funcType) {
        throw new TypeError(ERROR_MESSAGE + target);
    }
    var args = slicy(arguments, 1);

    var bound;
    var binder = function () {
        if (this instanceof bound) {
            var result = target.apply(
                this,
                concatty(args, arguments)
            );
            if (Object(result) === result) {
                return result;
            }
            return this;
        }
        return target.apply(
            that,
            concatty(args, arguments)
        );

    };

    var boundLength = max(0, target.length - args.length);
    var boundArgs = [];
    for (var i = 0; i < boundLength; i++) {
        boundArgs[i] = '$' + i;
    }

    bound = Function('binder', 'return function (' + joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);

    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }

    return bound;
};

},{}],103:[function(require,module,exports){
'use strict';

var implementation = require('./implementation');

module.exports = Function.prototype.bind || implementation;

},{"./implementation":102}],104:[function(require,module,exports){
'use strict';

var undefined;

var $Object = require('es-object-atoms');

var $Error = require('es-errors');
var $EvalError = require('es-errors/eval');
var $RangeError = require('es-errors/range');
var $ReferenceError = require('es-errors/ref');
var $SyntaxError = require('es-errors/syntax');
var $TypeError = require('es-errors/type');
var $URIError = require('es-errors/uri');

var abs = require('math-intrinsics/abs');
var floor = require('math-intrinsics/floor');
var max = require('math-intrinsics/max');
var min = require('math-intrinsics/min');
var pow = require('math-intrinsics/pow');
var round = require('math-intrinsics/round');
var sign = require('math-intrinsics/sign');

var $Function = Function;

// eslint-disable-next-line consistent-return
var getEvalledConstructor = function (expressionSyntax) {
	try {
		return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
	} catch (e) {}
};

var $gOPD = require('gopd');
var $defineProperty = require('es-define-property');

var throwTypeError = function () {
	throw new $TypeError();
};
var ThrowTypeError = $gOPD
	? (function () {
		try {
			// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
			arguments.callee; // IE 8 does not throw here
			return throwTypeError;
		} catch (calleeThrows) {
			try {
				// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
				return $gOPD(arguments, 'callee').get;
			} catch (gOPDthrows) {
				return throwTypeError;
			}
		}
	}())
	: throwTypeError;

var hasSymbols = require('has-symbols')();

var getProto = require('get-proto');
var $ObjectGPO = require('get-proto/Object.getPrototypeOf');
var $ReflectGPO = require('get-proto/Reflect.getPrototypeOf');

var $apply = require('call-bind-apply-helpers/functionApply');
var $call = require('call-bind-apply-helpers/functionCall');

var needsEval = {};

var TypedArray = typeof Uint8Array === 'undefined' || !getProto ? undefined : getProto(Uint8Array);

var INTRINSICS = {
	__proto__: null,
	'%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
	'%Array%': Array,
	'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
	'%ArrayIteratorPrototype%': hasSymbols && getProto ? getProto([][Symbol.iterator]()) : undefined,
	'%AsyncFromSyncIteratorPrototype%': undefined,
	'%AsyncFunction%': needsEval,
	'%AsyncGenerator%': needsEval,
	'%AsyncGeneratorFunction%': needsEval,
	'%AsyncIteratorPrototype%': needsEval,
	'%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
	'%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
	'%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
	'%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
	'%Boolean%': Boolean,
	'%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
	'%Date%': Date,
	'%decodeURI%': decodeURI,
	'%decodeURIComponent%': decodeURIComponent,
	'%encodeURI%': encodeURI,
	'%encodeURIComponent%': encodeURIComponent,
	'%Error%': $Error,
	'%eval%': eval, // eslint-disable-line no-eval
	'%EvalError%': $EvalError,
	'%Float16Array%': typeof Float16Array === 'undefined' ? undefined : Float16Array,
	'%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
	'%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
	'%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
	'%Function%': $Function,
	'%GeneratorFunction%': needsEval,
	'%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
	'%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
	'%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
	'%isFinite%': isFinite,
	'%isNaN%': isNaN,
	'%IteratorPrototype%': hasSymbols && getProto ? getProto(getProto([][Symbol.iterator]())) : undefined,
	'%JSON%': typeof JSON === 'object' ? JSON : undefined,
	'%Map%': typeof Map === 'undefined' ? undefined : Map,
	'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Map()[Symbol.iterator]()),
	'%Math%': Math,
	'%Number%': Number,
	'%Object%': $Object,
	'%Object.getOwnPropertyDescriptor%': $gOPD,
	'%parseFloat%': parseFloat,
	'%parseInt%': parseInt,
	'%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
	'%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
	'%RangeError%': $RangeError,
	'%ReferenceError%': $ReferenceError,
	'%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
	'%RegExp%': RegExp,
	'%Set%': typeof Set === 'undefined' ? undefined : Set,
	'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Set()[Symbol.iterator]()),
	'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
	'%String%': String,
	'%StringIteratorPrototype%': hasSymbols && getProto ? getProto(''[Symbol.iterator]()) : undefined,
	'%Symbol%': hasSymbols ? Symbol : undefined,
	'%SyntaxError%': $SyntaxError,
	'%ThrowTypeError%': ThrowTypeError,
	'%TypedArray%': TypedArray,
	'%TypeError%': $TypeError,
	'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
	'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
	'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
	'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
	'%URIError%': $URIError,
	'%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
	'%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
	'%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,

	'%Function.prototype.call%': $call,
	'%Function.prototype.apply%': $apply,
	'%Object.defineProperty%': $defineProperty,
	'%Object.getPrototypeOf%': $ObjectGPO,
	'%Math.abs%': abs,
	'%Math.floor%': floor,
	'%Math.max%': max,
	'%Math.min%': min,
	'%Math.pow%': pow,
	'%Math.round%': round,
	'%Math.sign%': sign,
	'%Reflect.getPrototypeOf%': $ReflectGPO
};

if (getProto) {
	try {
		null.error; // eslint-disable-line no-unused-expressions
	} catch (e) {
		// https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
		var errorProto = getProto(getProto(e));
		INTRINSICS['%Error.prototype%'] = errorProto;
	}
}

var doEval = function doEval(name) {
	var value;
	if (name === '%AsyncFunction%') {
		value = getEvalledConstructor('async function () {}');
	} else if (name === '%GeneratorFunction%') {
		value = getEvalledConstructor('function* () {}');
	} else if (name === '%AsyncGeneratorFunction%') {
		value = getEvalledConstructor('async function* () {}');
	} else if (name === '%AsyncGenerator%') {
		var fn = doEval('%AsyncGeneratorFunction%');
		if (fn) {
			value = fn.prototype;
		}
	} else if (name === '%AsyncIteratorPrototype%') {
		var gen = doEval('%AsyncGenerator%');
		if (gen && getProto) {
			value = getProto(gen.prototype);
		}
	}

	INTRINSICS[name] = value;

	return value;
};

var LEGACY_ALIASES = {
	__proto__: null,
	'%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
	'%ArrayPrototype%': ['Array', 'prototype'],
	'%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
	'%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
	'%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
	'%ArrayProto_values%': ['Array', 'prototype', 'values'],
	'%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
	'%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
	'%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
	'%BooleanPrototype%': ['Boolean', 'prototype'],
	'%DataViewPrototype%': ['DataView', 'prototype'],
	'%DatePrototype%': ['Date', 'prototype'],
	'%ErrorPrototype%': ['Error', 'prototype'],
	'%EvalErrorPrototype%': ['EvalError', 'prototype'],
	'%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
	'%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
	'%FunctionPrototype%': ['Function', 'prototype'],
	'%Generator%': ['GeneratorFunction', 'prototype'],
	'%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
	'%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
	'%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
	'%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
	'%JSONParse%': ['JSON', 'parse'],
	'%JSONStringify%': ['JSON', 'stringify'],
	'%MapPrototype%': ['Map', 'prototype'],
	'%NumberPrototype%': ['Number', 'prototype'],
	'%ObjectPrototype%': ['Object', 'prototype'],
	'%ObjProto_toString%': ['Object', 'prototype', 'toString'],
	'%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
	'%PromisePrototype%': ['Promise', 'prototype'],
	'%PromiseProto_then%': ['Promise', 'prototype', 'then'],
	'%Promise_all%': ['Promise', 'all'],
	'%Promise_reject%': ['Promise', 'reject'],
	'%Promise_resolve%': ['Promise', 'resolve'],
	'%RangeErrorPrototype%': ['RangeError', 'prototype'],
	'%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
	'%RegExpPrototype%': ['RegExp', 'prototype'],
	'%SetPrototype%': ['Set', 'prototype'],
	'%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
	'%StringPrototype%': ['String', 'prototype'],
	'%SymbolPrototype%': ['Symbol', 'prototype'],
	'%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
	'%TypedArrayPrototype%': ['TypedArray', 'prototype'],
	'%TypeErrorPrototype%': ['TypeError', 'prototype'],
	'%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
	'%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
	'%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
	'%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
	'%URIErrorPrototype%': ['URIError', 'prototype'],
	'%WeakMapPrototype%': ['WeakMap', 'prototype'],
	'%WeakSetPrototype%': ['WeakSet', 'prototype']
};

var bind = require('function-bind');
var hasOwn = require('hasown');
var $concat = bind.call($call, Array.prototype.concat);
var $spliceApply = bind.call($apply, Array.prototype.splice);
var $replace = bind.call($call, String.prototype.replace);
var $strSlice = bind.call($call, String.prototype.slice);
var $exec = bind.call($call, RegExp.prototype.exec);

/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
var stringToPath = function stringToPath(string) {
	var first = $strSlice(string, 0, 1);
	var last = $strSlice(string, -1);
	if (first === '%' && last !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
	} else if (last === '%' && first !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
	}
	var result = [];
	$replace(string, rePropName, function (match, number, quote, subString) {
		result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : number || match;
	});
	return result;
};
/* end adaptation */

var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
	var intrinsicName = name;
	var alias;
	if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
		alias = LEGACY_ALIASES[intrinsicName];
		intrinsicName = '%' + alias[0] + '%';
	}

	if (hasOwn(INTRINSICS, intrinsicName)) {
		var value = INTRINSICS[intrinsicName];
		if (value === needsEval) {
			value = doEval(intrinsicName);
		}
		if (typeof value === 'undefined' && !allowMissing) {
			throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
		}

		return {
			alias: alias,
			name: intrinsicName,
			value: value
		};
	}

	throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
};

module.exports = function GetIntrinsic(name, allowMissing) {
	if (typeof name !== 'string' || name.length === 0) {
		throw new $TypeError('intrinsic name must be a non-empty string');
	}
	if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
		throw new $TypeError('"allowMissing" argument must be a boolean');
	}

	if ($exec(/^%?[^%]*%?$/, name) === null) {
		throw new $SyntaxError('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
	}
	var parts = stringToPath(name);
	var intrinsicBaseName = parts.length > 0 ? parts[0] : '';

	var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
	var intrinsicRealName = intrinsic.name;
	var value = intrinsic.value;
	var skipFurtherCaching = false;

	var alias = intrinsic.alias;
	if (alias) {
		intrinsicBaseName = alias[0];
		$spliceApply(parts, $concat([0, 1], alias));
	}

	for (var i = 1, isOwn = true; i < parts.length; i += 1) {
		var part = parts[i];
		var first = $strSlice(part, 0, 1);
		var last = $strSlice(part, -1);
		if (
			(
				(first === '"' || first === "'" || first === '`')
				|| (last === '"' || last === "'" || last === '`')
			)
			&& first !== last
		) {
			throw new $SyntaxError('property names with quotes must have matching quotes');
		}
		if (part === 'constructor' || !isOwn) {
			skipFurtherCaching = true;
		}

		intrinsicBaseName += '.' + part;
		intrinsicRealName = '%' + intrinsicBaseName + '%';

		if (hasOwn(INTRINSICS, intrinsicRealName)) {
			value = INTRINSICS[intrinsicRealName];
		} else if (value != null) {
			if (!(part in value)) {
				if (!allowMissing) {
					throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
				}
				return void undefined;
			}
			if ($gOPD && (i + 1) >= parts.length) {
				var desc = $gOPD(value, part);
				isOwn = !!desc;

				// By convention, when a data property is converted to an accessor
				// property to emulate a data property that does not suffer from
				// the override mistake, that accessor's getter is marked with
				// an `originalValue` property. Here, when we detect this, we
				// uphold the illusion by pretending to see that original data
				// property, i.e., returning the value rather than the getter
				// itself.
				if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
					value = desc.get;
				} else {
					value = value[part];
				}
			} else {
				isOwn = hasOwn(value, part);
				value = value[part];
			}

			if (isOwn && !skipFurtherCaching) {
				INTRINSICS[intrinsicRealName] = value;
			}
		}
	}
	return value;
};

},{"call-bind-apply-helpers/functionApply":26,"call-bind-apply-helpers/functionCall":27,"es-define-property":41,"es-errors":43,"es-errors/eval":42,"es-errors/range":44,"es-errors/ref":45,"es-errors/syntax":46,"es-errors/type":47,"es-errors/uri":48,"es-object-atoms":49,"function-bind":103,"get-proto":107,"get-proto/Object.getPrototypeOf":105,"get-proto/Reflect.getPrototypeOf":106,"gopd":109,"has-symbols":110,"hasown":112,"math-intrinsics/abs":128,"math-intrinsics/floor":129,"math-intrinsics/max":131,"math-intrinsics/min":132,"math-intrinsics/pow":133,"math-intrinsics/round":134,"math-intrinsics/sign":135}],105:[function(require,module,exports){
'use strict';

var $Object = require('es-object-atoms');

/** @type {import('./Object.getPrototypeOf')} */
module.exports = $Object.getPrototypeOf || null;

},{"es-object-atoms":49}],106:[function(require,module,exports){
'use strict';

/** @type {import('./Reflect.getPrototypeOf')} */
module.exports = (typeof Reflect !== 'undefined' && Reflect.getPrototypeOf) || null;

},{}],107:[function(require,module,exports){
'use strict';

var reflectGetProto = require('./Reflect.getPrototypeOf');
var originalGetProto = require('./Object.getPrototypeOf');

var getDunderProto = require('dunder-proto/get');

/** @type {import('.')} */
module.exports = reflectGetProto
	? function getProto(O) {
		// @ts-expect-error TS can't narrow inside a closure, for some reason
		return reflectGetProto(O);
	}
	: originalGetProto
		? function getProto(O) {
			if (!O || (typeof O !== 'object' && typeof O !== 'function')) {
				throw new TypeError('getProto: not an object');
			}
			// @ts-expect-error TS can't narrow inside a closure, for some reason
			return originalGetProto(O);
		}
		: getDunderProto
			? function getProto(O) {
				// @ts-expect-error TS can't narrow inside a closure, for some reason
				return getDunderProto(O);
			}
			: null;

},{"./Object.getPrototypeOf":105,"./Reflect.getPrototypeOf":106,"dunder-proto/get":40}],108:[function(require,module,exports){
'use strict';

/** @type {import('./gOPD')} */
module.exports = Object.getOwnPropertyDescriptor;

},{}],109:[function(require,module,exports){
'use strict';

/** @type {import('.')} */
var $gOPD = require('./gOPD');

if ($gOPD) {
	try {
		$gOPD([], 'length');
	} catch (e) {
		// IE 8 has a broken gOPD
		$gOPD = null;
	}
}

module.exports = $gOPD;

},{"./gOPD":108}],110:[function(require,module,exports){
'use strict';

var origSymbol = typeof Symbol !== 'undefined' && Symbol;
var hasSymbolSham = require('./shams');

/** @type {import('.')} */
module.exports = function hasNativeSymbols() {
	if (typeof origSymbol !== 'function') { return false; }
	if (typeof Symbol !== 'function') { return false; }
	if (typeof origSymbol('foo') !== 'symbol') { return false; }
	if (typeof Symbol('bar') !== 'symbol') { return false; }

	return hasSymbolSham();
};

},{"./shams":111}],111:[function(require,module,exports){
'use strict';

/** @type {import('./shams')} */
/* eslint complexity: [2, 18], max-statements: [2, 33] */
module.exports = function hasSymbols() {
	if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
	if (typeof Symbol.iterator === 'symbol') { return true; }

	/** @type {{ [k in symbol]?: unknown }} */
	var obj = {};
	var sym = Symbol('test');
	var symObj = Object(sym);
	if (typeof sym === 'string') { return false; }

	if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
	if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }

	// temp disabled per https://github.com/ljharb/object.assign/issues/17
	// if (sym instanceof Symbol) { return false; }
	// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
	// if (!(symObj instanceof Symbol)) { return false; }

	// if (typeof Symbol.prototype.toString !== 'function') { return false; }
	// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }

	var symVal = 42;
	obj[sym] = symVal;
	for (var _ in obj) { return false; } // eslint-disable-line no-restricted-syntax, no-unreachable-loop
	if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }

	if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }

	var syms = Object.getOwnPropertySymbols(obj);
	if (syms.length !== 1 || syms[0] !== sym) { return false; }

	if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }

	if (typeof Object.getOwnPropertyDescriptor === 'function') {
		// eslint-disable-next-line no-extra-parens
		var descriptor = /** @type {PropertyDescriptor} */ (Object.getOwnPropertyDescriptor(obj, sym));
		if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
	}

	return true;
};

},{}],112:[function(require,module,exports){
'use strict';

var call = Function.prototype.call;
var $hasOwn = Object.prototype.hasOwnProperty;
var bind = require('function-bind');

/** @type {import('.')} */
module.exports = bind.call(call, $hasOwn);

},{"function-bind":103}],113:[function(require,module,exports){
var http = require('http')
var url = require('url')

var https = module.exports

for (var key in http) {
  if (http.hasOwnProperty(key)) https[key] = http[key]
}

https.request = function (params, cb) {
  params = validateParams(params)
  return http.request.call(this, params, cb)
}

https.get = function (params, cb) {
  params = validateParams(params)
  return http.get.call(this, params, cb)
}

function validateParams (params) {
  if (typeof params === 'string') {
    params = url.parse(params)
  }
  if (!params.protocol) {
    params.protocol = 'https:'
  }
  if (params.protocol !== 'https:') {
    throw new Error('Protocol "' + params.protocol + '" not supported. Expected "https:"')
  }
  return params
}

},{"http":166,"url":188}],114:[function(require,module,exports){
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}

},{}],115:[function(require,module,exports){
if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
      ctor.super_ = superCtor
      ctor.prototype = Object.create(superCtor.prototype, {
        constructor: {
          value: ctor,
          enumerable: false,
          writable: true,
          configurable: true
        }
      })
    }
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
      ctor.super_ = superCtor
      var TempCtor = function () {}
      TempCtor.prototype = superCtor.prototype
      ctor.prototype = new TempCtor()
      ctor.prototype.constructor = ctor
    }
  }
}

},{}],116:[function(require,module,exports){
// When a boxed property is passed in, it should have quotes of some
// kind around it.
//
// For instance:
// 		MyValues['Name']
// 		MyValues["Age"]
// 		MyValues[`Cost`]
//
// This function removes the wrapping quotes.
//
// Please note it *DOES NOT PARSE* template literals, so backticks just
// end up doing the same thing as other quote types.
//
// TODO: Should template literals be processed?  If so what state do they have access to?  That should happen here if so.
// TODO: Make a simple class include library with these
/**
 * @param {string} pCharacter - The character to remove from the start and end of the string
 * @param {string} pString - The string to clean
 *
 * @return {string} The cleaned string
 */
const cleanWrapCharacters = (pCharacter, pString) =>
{
	if (pString.startsWith(pCharacter) && pString.endsWith(pCharacter))
	{
		return pString.substring(1, pString.length - 1);
	}
	else
	{
		return pString;
	}
};

module.exports = cleanWrapCharacters;

},{}],117:[function(require,module,exports){
/**
* @author <steven@velozo.com>
*/
let libSimpleLog = require('./Manyfest-LogToConsole.js');

/**
* Hash Translation
*
* This is a very simple translation table for hashes, which allows the same schema to resolve
* differently based on a loaded translation table.
*
* This is to prevent the requirement for mutating schemas over and over again when we want to
* reuse the structure but look up data elements by different addresses.
*
* One side-effect of this is that a translation table can "override" the built-in hashes, since
* this is always used to resolve hashes before any of the functionCallByHash(pHash, ...) perform
* their lookups by hash.
*
* @class ManyfestHashTranslation
*/
class ManyfestHashTranslation
{
    /**
     * @param {function} [pInfoLog] - (optional) A logging function for info messages
     * @param {function} [pErrorLog] - (optional) A logging function for error messages
     */
	constructor(pInfoLog, pErrorLog)
	{
		// Wire in logging
		this.logInfo = (typeof(pInfoLog) === 'function') ? pInfoLog : libSimpleLog;
		this.logError = (typeof(pErrorLog) === 'function') ? pErrorLog : libSimpleLog;

        this.translationTable = {};
	}

    /**
     * @return {number} The number of translations in the table
     */
    translationCount()
    {
        return Object.keys(this.translationTable).length;
    }

    /**
     * @param {object} pTranslation - An object containing source:destination hash pairs to add to the translation table
     */
    addTranslation(pTranslation)
    {
        // This adds a translation in the form of:
        // { "SourceHash": "DestinationHash", "SecondSourceHash":"SecondDestinationHash" }
        if (typeof(pTranslation) != 'object')
        {
            this.logError(`Hash translation addTranslation expected a translation be type object but was passed in ${typeof(pTranslation)}`);
            return false;
        }

        let tmpTranslationSources = Object.keys(pTranslation)

        tmpTranslationSources.forEach(
            (pTranslationSource) =>
            {
                if (typeof(pTranslation[pTranslationSource]) != 'string')
                {
                    this.logError(`Hash translation addTranslation expected a translation destination hash for [${pTranslationSource}] to be a string but the referrant was a ${typeof(pTranslation[pTranslationSource])}`);
                }
                else
                {
                    this.translationTable[pTranslationSource] = pTranslation[pTranslationSource];
                }
            });
    }

    /**
     * @param {string} pTranslationHash - The source hash to remove from the translation table
     */
    removeTranslationHash(pTranslationHash)
    {
        delete this.translationTable[pTranslationHash];
    }

    /**
     * This removes translations.
     * If passed a string, just removes the single one.
     * If passed an object, it does all the source keys.
     *
     * @param {string|object} pTranslation - Either a source hash string to remove, or an object containing source:destination hash pairs to remove
     *
     * @return {boolean} True if the removal was successful, false otherwise
     */
    removeTranslation(pTranslation)
    {
        if (typeof(pTranslation) == 'string')
        {
            this.removeTranslationHash(pTranslation);
            return true;
        }
        else if (typeof(pTranslation) == 'object')
        {
            let tmpTranslationSources = Object.keys(pTranslation)

            tmpTranslationSources.forEach(
                (pTranslationSource) =>
                {
                    this.removeTranslation(pTranslationSource);
                });
            return true;
        }
        else
        {
            this.logError(`Hash translation removeTranslation expected either a string or an object but the passed-in translation was type ${typeof(pTranslation)}`);
            return false;
        }
    }

    clearTranslations()
    {
        this.translationTable = {};
    }

    /**
     * @param {string} pTranslation - The source hash to translate
     *
     * @return {string} The translated hash, or the original if no translation exists
     */
    translate(pTranslation)
    {
        if (pTranslation in this.translationTable)
        {
            return this.translationTable[pTranslation];
        }
        else
        {
            return pTranslation;
        }
    }
}

module.exports = ManyfestHashTranslation;

},{"./Manyfest-LogToConsole.js":118}],118:[function(require,module,exports){
/**
* @author <steven@velozo.com>
*/

/**
* Manyfest simple logging shim (for browser and dependency-free running)
*/

const logToConsole = (pLogLine, pLogObject) =>
{
    let tmpLogLine = (typeof(pLogLine) === 'string') ? pLogLine : '';

    console.log(`[Manyfest] ${tmpLogLine}`);

    if (pLogObject) console.log(JSON.stringify(pLogObject));
};

module.exports = logToConsole;
},{}],119:[function(require,module,exports){
/**
* @author <steven@velozo.com>
*/
const libSimpleLog = require('./Manyfest-LogToConsole.js');
// This is for resolving functions mid-address
const libGetObjectValue = require('./Manyfest-ObjectAddress-GetValue.js');

const fCleanWrapCharacters = require('./Manyfest-CleanWrapCharacters.js');

// TODO: Just until this is a fable service.
let _MockFable = { DataFormat: require('./Manyfest-ObjectAddress-Parser.js') };

/**
* Object Address Resolver
*
* IMPORTANT NOTE: This code is intentionally more verbose than necessary, to
*                 be extremely clear what is going on in the recursion for
*                 each of the three address resolution functions.
*
*                 Although there is some opportunity to repeat ourselves a
*                 bit less in this codebase (e.g. with detection of arrays
*                 versus objects versus direct properties), it can make
*                 debugging.. challenging.  The minified version of the code
*                 optimizes out almost anything repeated in here.  So please
*                 be kind and rewind... meaning please keep the codebase less
*                 terse and more verbose so humans can comprehend it.
*
*
* @class ManyfestObjectAddressResolverCheckAddressExists
*/
class ManyfestObjectAddressResolverCheckAddressExists
{
	/**
	 * @param {function} [pInfoLog] - (optional) Function to use for info logging
	 * @param {function} [pErrorLog] - (optional) Function to use for error logging
	 */
	constructor(pInfoLog, pErrorLog)
	{
		// Wire in logging
		this.logInfo = (typeof(pInfoLog) == 'function') ? pInfoLog : libSimpleLog;
		this.logError = (typeof(pErrorLog) == 'function') ? pErrorLog : libSimpleLog;

		this.getObjectValueClass = new libGetObjectValue(this.logInfo, this.logError);
		this.cleanWrapCharacters = fCleanWrapCharacters;
	}

	/**
	 * Check if an address exists.
	 *
	 * This is necessary because the getValueAtAddress function is ambiguous on
	 * whether the element/property is actually there or not (it returns
	 * undefined whether the property exists or not).  This function checks for
	 * existance and returns true or false dependent.
	 *
	 * @param {object} pObject - The object to check within
	 * @param {string} pAddress - The address to check for
	 * @param {object} [pRootObject] - (optional) The root object for function resolution context
	 *
	 * @return {boolean} - True if the address exists, false if it does not
	 */
	checkAddressExists(pObject, pAddress, pRootObject)
	{
		// TODO: Should these throw an error?
		// Make sure pObject is an object
		if (typeof(pObject) != 'object') return false;
		// Make sure pAddress is a string
		if (typeof(pAddress) != 'string') return false;

		// Set the root object to the passed-in object if it isn't set yet.  This is expected to be the root object.
		// NOTE: This was added to support functions mid-stream
		let tmpRootObject = (typeof(pRootObject) == 'undefined') ? pObject : pRootObject;

		// DONE: Make this work for things like SomeRootObject.Metadata["Some.People.Use.Bad.Object.Property.Names"]
		let tmpAddressPartBeginning = _MockFable.DataFormat.stringGetFirstSegment(pAddress);

		// This is the terminal address string (no more dots so the RECUSION ENDS IN HERE somehow)
		if (tmpAddressPartBeginning.length == pAddress.length)
		{
			// Check if the address refers to a boxed property
			let tmpBracketStartIndex = pAddress.indexOf('[');
			let tmpBracketStopIndex = pAddress.indexOf(']');

			// Check if there is a function somewhere in the address... parenthesis start should only be in a function
			let tmpFunctionStartIndex = pAddress.indexOf('(');

			// NOTE THAT FUNCTIONS MUST RESOLVE FIRST
			// Functions look like this
			// 		MyFunction()
			// 		MyFunction(Some.Address)
			// 		MyFunction(Some.Address,Some.Other.Address)
			// 		MyFunction(Some.Address,Some.Other.Address,Some.Third.Address)
			//
			// This could be enhanced to allow purely numeric and string values to be passed to the function.  For now,
			// To heck with that.  This is a simple function call.
			//
			// The requirements to detect a function are:
			//    1) The start bracket is after character 0
			if ((tmpFunctionStartIndex > 0)
			//    2) The end bracket is after the start bracket
				&& (_MockFable.DataFormat.stringCountEnclosures(pAddress) > 0))
			{
				let tmpFunctionAddress = pAddress.substring(0, tmpFunctionStartIndex).trim();

				if (((tmpFunctionAddress in pObject)) && (typeof(pObject[tmpFunctionAddress]) == 'function'))
				{
					return true;
				}
				else
				{
					// The address suggests it is a function, but it is not.
					return false;
				}
			}
			// Boxed elements look like this:
			// 		MyValues[10]
			// 		MyValues['Name']
			// 		MyValues["Age"]
			// 		MyValues[`Cost`]
			//
			// When we are passed SomeObject["Name"] this code below recurses as if it were SomeObject.Name
			// The requirements to detect a boxed element are:
			//    1) The start bracket is after character 0
			else if ((tmpBracketStartIndex > 0)
			//    2) The end bracket has something between them
				&& (tmpBracketStopIndex > tmpBracketStartIndex)
			//    3) There is data
				&& (tmpBracketStopIndex - tmpBracketStartIndex > 1))
			{
				// The "Name" of the Object contained too the left of the bracket
				let tmpBoxedPropertyName = pAddress.substring(0, tmpBracketStartIndex).trim();

				// If the subproperty doesn't test as a proper Object, none of the rest of this is possible.
				// This is a rare case where Arrays testing as Objects is useful
				if (typeof(pObject[tmpBoxedPropertyName]) !== 'object')
				{
					return false;
				}

				// The "Reference" to the property within it, either an array element or object property
				let tmpBoxedPropertyReference = pAddress.substring(tmpBracketStartIndex+1, tmpBracketStopIndex).trim();
				// Attempt to parse the reference as a number, which will be used as an array element
				let tmpBoxedPropertyNumber = parseInt(tmpBoxedPropertyReference, 10);

				// Guard: If the referrant is a number and the boxed property is not an array, or vice versa, return undefined.
				//        This seems confusing to me at first read, so explaination:
				//        Is the Boxed Object an Array?  TRUE
				//        And is the Reference inside the boxed Object not a number? TRUE
				//        -->  So when these are in agreement, it's an impossible access state
				if (Array.isArray(pObject[tmpBoxedPropertyName]) == isNaN(tmpBoxedPropertyNumber))
				{
					return false;
				}

				//    4) If the middle part is *only* a number (no single, double or backtick quotes) it is an array element,
				//       otherwise we will try to treat it as a dynamic object property.
				if (isNaN(tmpBoxedPropertyNumber))
				{
					// This isn't a number ... let's treat it as a dynamic object property.
					// We would expect the property to be wrapped in some kind of quotes so strip them
					tmpBoxedPropertyReference = this.cleanWrapCharacters('"', tmpBoxedPropertyReference);
					tmpBoxedPropertyReference = this.cleanWrapCharacters('`', tmpBoxedPropertyReference);
					tmpBoxedPropertyReference = this.cleanWrapCharacters("'", tmpBoxedPropertyReference);

					// Check if the property exists.
					return (tmpBoxedPropertyReference in pObject[tmpBoxedPropertyName]);
				}
				else
				{
					// Use the new in operator to see if the element is in the array
					return (tmpBoxedPropertyNumber in pObject[tmpBoxedPropertyName]);
				}
			}
			else
			{
				// Check if the property exists
				return (pAddress in pObject);
			}
		}
		else
		{
			let tmpSubObjectName = tmpAddressPartBeginning;
			let tmpNewAddress = pAddress.substring(tmpAddressPartBeginning.length+1);

			// Test if the tmpNewAddress is an array or object
			// Check if it's a boxed property
			let tmpBracketStartIndex = tmpSubObjectName.indexOf('[');
			let tmpBracketStopIndex = tmpSubObjectName.indexOf(']');

			// Check if there is a function somewhere in the address... parenthesis start should only be in a function
			let tmpFunctionStartIndex = tmpSubObjectName.indexOf('(');

			// NOTE THAT FUNCTIONS MUST RESOLVE FIRST
			// Functions look like this
			// 		MyFunction()
			// 		MyFunction(Some.Address)
			// 		MyFunction(Some.Address,Some.Other.Address)
			// 		MyFunction(Some.Address,Some.Other.Address,Some.Third.Address)
			//
			// This could be enhanced to allow purely numeric and string values to be passed to the function.  For now,
			// To heck with that.  This is a simple function call.
			//
			// The requirements to detect a function are:
			//    1) The start bracket is after character 0
			if ((tmpFunctionStartIndex > 0)
			//    2) The end bracket is after the start bracket
				&& (_MockFable.DataFormat.stringCountEnclosures(tmpSubObjectName) > 0))
			{
				let tmpFunctionAddress = tmpSubObjectName.substring(0, tmpFunctionStartIndex).trim();
				//tmpParentAddress = `${tmpParentAddress}${(tmpParentAddress.length > 0) ? '.' : ''}${tmpSubObjectName}`;

				if (typeof pObject[tmpFunctionAddress] !== 'function')
				{
					// The address suggests it is a function, but it is not.
					return false;
				}

				// Now see if the function has arguments.
				// Implementation notes: * ARGUMENTS MUST SHARE THE SAME ROOT OBJECT CONTEXT *
				let tmpFunctionArguments = _MockFable.DataFormat.stringGetSegments(_MockFable.DataFormat.stringGetEnclosureValueByIndex(tmpSubObjectName.substring(tmpFunctionAddress.length), 0), ',');
				if ((tmpFunctionArguments.length == 0) || (tmpFunctionArguments[0] == ''))
				{
					// No arguments... just call the function (bound to the scope of the object it is contained withing)
					if (tmpFunctionAddress in pObject)
					{
						try
						{
							return this.checkAddressExists(pObject[tmpFunctionAddress].apply(pObject), tmpNewAddress, tmpRootObject);
						}
						catch(pError)
						{
							// The function call failed, so the address doesn't exist
							libSimpleLog(`Error calling function ${tmpFunctionAddress} (address [${pAddress}]): ${pError.message}`);
							return false;
						}
					}
					else
					{
						// The function doesn't exist, so the address doesn't exist
						libSimpleLog(`Function ${tmpFunctionAddress} does not exist (address [${pAddress}])`);
						return false;
					}
				}
				else
				{
					let tmpArgumentValues = [];



					// Now get the value for each argument
					for (let i = 0; i < tmpFunctionArguments.length; i++)
					{
						// Resolve the values for each subsequent entry
						// NOTE: This is where the resolves get really tricky.  Recursion within recursion.  Programming gom jabbar, yo.
						tmpArgumentValues.push(this.getObjectValueClass.getValueAtAddress(tmpRootObject, tmpFunctionArguments[i]));
					}

					//return this.checkAddressExists(pObject[tmpFunctionAddress].apply(pObject, tmpArgumentValues), tmpNewAddress, tmpRootObject);
					if (tmpFunctionAddress in pObject)
					{
						try
						{
							return this.checkAddressExists(pObject[tmpFunctionAddress].apply(pObject, tmpArgumentValues), tmpNewAddress, tmpRootObject);
						}
						catch(pError)
						{
							// The function call failed, so the address doesn't exist
							libSimpleLog(`Error calling function ${tmpFunctionAddress} (address [${pAddress}]): ${pError.message}`);
							return false;
						}
					}
					else
					{
						// The function doesn't exist, so the address doesn't exist
						libSimpleLog(`Function ${tmpFunctionAddress} does not exist (address [${pAddress}])`);
						return false;
					}
				}
			}
			// Boxed elements look like this:
			// 		MyValues[42]
			// 		MyValues['Color']
			// 		MyValues["Weight"]
			// 		MyValues[`Diameter`]
			//
			// When we are passed SomeObject["Name"] this code below recurses as if it were SomeObject.Name
			// The requirements to detect a boxed element are:
			//    1) The start bracket is after character 0
			else if ((tmpBracketStartIndex > 0)
			//    2) The end bracket has something between them
				&& (tmpBracketStopIndex > tmpBracketStartIndex)
			//    3) There is data
				&& (tmpBracketStopIndex - tmpBracketStartIndex > 1))
			{
				let tmpBoxedPropertyName = tmpSubObjectName.substring(0, tmpBracketStartIndex).trim();

				let tmpBoxedPropertyReference = tmpSubObjectName.substring(tmpBracketStartIndex+1, tmpBracketStopIndex).trim();

				let tmpBoxedPropertyNumber = parseInt(tmpBoxedPropertyReference, 10);

				// Guard: If the referrant is a number and the boxed property is not an array, or vice versa, return undefined.
				//        This seems confusing to me at first read, so explaination:
				//        Is the Boxed Object an Array?  TRUE
				//        And is the Reference inside the boxed Object not a number? TRUE
				//        -->  So when these are in agreement, it's an impossible access state
				// This could be a failure in the recursion chain because they passed something like this in:
				//    StudentData.Sections.Algebra.Students[1].Tardy
				//       BUT
				//         StudentData.Sections.Algebra.Students is an object, so the [1].Tardy is not possible to access
				// This could be a failure in the recursion chain because they passed something like this in:
				//    StudentData.Sections.Algebra.Students["JaneDoe"].Grade
				//       BUT
				//         StudentData.Sections.Algebra.Students is an array, so the ["JaneDoe"].Grade is not possible to access
				// TODO: Should this be an error or something?  Should we keep a log of failures like this?
				if (Array.isArray(pObject[tmpBoxedPropertyName]) == isNaN(tmpBoxedPropertyNumber))
				{
					// Because this is an impossible address, the property doesn't exist
					// TODO: Should we throw an error in this condition?
					return false;
				}

				//This is a bracketed value
				//    4) If the middle part is *only* a number (no single, double or backtick quotes) it is an array element,
				//       otherwise we will try to reat it as a dynamic object property.
				if (isNaN(tmpBoxedPropertyNumber))
				{
					// This isn't a number ... let's treat it as a dynanmic object property.
					tmpBoxedPropertyReference = this.cleanWrapCharacters('"', tmpBoxedPropertyReference);
					tmpBoxedPropertyReference = this.cleanWrapCharacters('`', tmpBoxedPropertyReference);
					tmpBoxedPropertyReference = this.cleanWrapCharacters("'", tmpBoxedPropertyReference);

					// Recurse directly into the subobject
					return this.checkAddressExists(pObject[tmpBoxedPropertyName][tmpBoxedPropertyReference], tmpNewAddress, tmpRootObject);
				}
				else
				{
					// We parsed a valid number out of the boxed property name, so recurse into the array
					return this.checkAddressExists(pObject[tmpBoxedPropertyName][tmpBoxedPropertyNumber], tmpNewAddress, tmpRootObject);
				}
			}

			// If there is an object property already named for the sub object, but it isn't an object
			// then the system can't set the value in there.  Error and abort!
			if ((tmpSubObjectName in pObject) && typeof(pObject[tmpSubObjectName]) !== 'object')
			{
				return false;
			}
			else if (tmpSubObjectName in pObject)
			{
				// If there is already a subobject pass that to the recursive thingy
				return this.checkAddressExists(pObject[tmpSubObjectName], tmpNewAddress, tmpRootObject);
			}
			else
			{
				// The sub-object doesn't exist, so the address doesn't exist
				return false;
			}
		}
	}
}

module.exports = ManyfestObjectAddressResolverCheckAddressExists;

},{"./Manyfest-CleanWrapCharacters.js":116,"./Manyfest-LogToConsole.js":118,"./Manyfest-ObjectAddress-GetValue.js":121,"./Manyfest-ObjectAddress-Parser.js":122}],120:[function(require,module,exports){
/**
* @author <steven@velozo.com>
*/
let libSimpleLog = require('./Manyfest-LogToConsole.js');
let fCleanWrapCharacters = require('./Manyfest-CleanWrapCharacters.js');
let fParseConditionals = require(`../source/Manyfest-ParseConditionals.js`)

let _MockFable = { DataFormat: require('./Manyfest-ObjectAddress-Parser.js') };

/**
* Object Address Resolver - DeleteValue
*
* IMPORTANT NOTE: This code is intentionally more verbose than necessary, to
*                 be extremely clear what is going on in the recursion for
*                 each of the three address resolution functions.
*
*                 Although there is some opportunity to repeat ourselves a
*                 bit less in this codebase (e.g. with detection of arrays
*                 versus objects versus direct properties), it can make
*                 debugging.. challenging.  The minified version of the code
*                 optimizes out almost anything repeated in here.  So please
*                 be kind and rewind... meaning please keep the codebase less
*                 terse and more verbose so humans can comprehend it.
*
* TODO: Once we validate this pattern is good to go, break these out into
*       three separate modules.
*
* @class ManyfestObjectAddressResolverDeleteValue
*/
class ManyfestObjectAddressResolverDeleteValue
{
	/**
	 * @param {function} [pInfoLog] - (optional) A logging function for info messages
	 * @param {function} [pErrorLog] - (optional) A logging function for error messages
	 */
	constructor(pInfoLog, pErrorLog)
	{
		// Wire in logging
		this.logInfo = (typeof(pInfoLog) == 'function') ? pInfoLog : libSimpleLog;
		this.logError = (typeof(pErrorLog) == 'function') ? pErrorLog : libSimpleLog;

		this.cleanWrapCharacters = fCleanWrapCharacters;
	}

	// TODO: Dry me
	/**
	 * @param {string} pAddress - The address being evaluated
	 * @param {object} pRecord - The record being evaluated
	 *
	 * @return {boolean} True if the record passes the filters, false if it does not
	 */
	checkRecordFilters(pAddress, pRecord)
	{
		return fParseConditionals(this, pAddress, pRecord);
	}

	/**
	 * Delete the value of an element at an address
	 *
	 * @param {object} pObject - The object to delete the value from
	 * @param {string} pAddress - The address to delete the value at
	 * @param {string} [pParentAddress] - (optional) The parent address for recursion
	 *
	 * @return {boolean|object|undefined} - True if the value was deleted, false if it could not be deleted, undefined on error
	 */
	deleteValueAtAddress (pObject, pAddress, pParentAddress)
	{
		// Make sure pObject (the object we are meant to be recursing) is an object (which could be an array or object)
		if (typeof(pObject) != 'object') return undefined;
		// Make sure pAddress (the address we are resolving) is a string
		if (typeof(pAddress) != 'string') return undefined;
		// Stash the parent address for later resolution
		let tmpParentAddress = "";
		if (typeof(pParentAddress) == 'string')
		{
			tmpParentAddress = pParentAddress;
		}

		// Use enclosure-aware parser to find the first segment separator
		let tmpAddressPartBeginning = _MockFable.DataFormat.stringGetFirstSegment(pAddress);

		// This is the terminal address string (no more dots so the RECUSION ENDS IN HERE somehow)
		if (tmpAddressPartBeginning.length == pAddress.length)
		{
			// Check if the address refers to a boxed property
			let tmpBracketStartIndex = pAddress.indexOf('[');
			let tmpBracketStopIndex = pAddress.indexOf(']');

			// Check for the Object Set Type marker.
			// Note this will not work with a bracket in the same address box set
			let tmpObjectTypeMarkerIndex = pAddress.indexOf('{}');

			// Boxed elements look like this:
			// 		MyValues[10]
			// 		MyValues['Name']
			// 		MyValues["Age"]
			// 		MyValues[`Cost`]
			//
			// When we are passed SomeObject["Name"] this code below recurses as if it were SomeObject.Name
			// The requirements to detect a boxed element are:
			//    1) The start bracket is after character 0
			if ((tmpBracketStartIndex > 0)
			//    2) The end bracket has something between them
				&& (tmpBracketStopIndex > tmpBracketStartIndex)
			//    3) There is data
				&& (tmpBracketStopIndex - tmpBracketStartIndex > 1))
			{
				// The "Name" of the Object contained too the left of the bracket
				let tmpBoxedPropertyName = pAddress.substring(0, tmpBracketStartIndex).trim();

				// If the subproperty doesn't test as a proper Object, none of the rest of this is possible.
				// This is a rare case where Arrays testing as Objects is useful
				if (typeof(pObject[tmpBoxedPropertyName]) !== 'object')
				{
					return false;
				}

				// The "Reference" to the property within it, either an array element or object property
				let tmpBoxedPropertyReference = pAddress.substring(tmpBracketStartIndex+1, tmpBracketStopIndex).trim();
				// Attempt to parse the reference as a number, which will be used as an array element
				let tmpBoxedPropertyNumber = parseInt(tmpBoxedPropertyReference, 10);

				// Guard: If the referrant is a number and the boxed property is not an array, or vice versa, return undefined.
				//        This seems confusing to me at first read, so explaination:
				//        Is the Boxed Object an Array?  TRUE
				//        And is the Reference inside the boxed Object not a number? TRUE
				//        -->  So when these are in agreement, it's an impossible access state
				if (Array.isArray(pObject[tmpBoxedPropertyName]) == isNaN(tmpBoxedPropertyNumber))
				{
					return false;
				}

				//    4) If the middle part is *only* a number (no single, double or backtick quotes) it is an array element,
				//       otherwise we will try to treat it as a dynamic object property.
				if (isNaN(tmpBoxedPropertyNumber))
				{
					// This isn't a number ... let's treat it as a dynamic object property.
					// We would expect the property to be wrapped in some kind of quotes so strip them
					tmpBoxedPropertyReference = this.cleanWrapCharacters('"', tmpBoxedPropertyReference);
					tmpBoxedPropertyReference = this.cleanWrapCharacters('`', tmpBoxedPropertyReference);
					tmpBoxedPropertyReference = this.cleanWrapCharacters("'", tmpBoxedPropertyReference);

					// Return the value in the property
					delete pObject[tmpBoxedPropertyName][tmpBoxedPropertyReference];
					return true;
				}
				else
				{
					delete pObject[tmpBoxedPropertyName][tmpBoxedPropertyNumber];
					return true;
				}
			}
			// The requirements to detect a boxed set element are:
			//    1) The start bracket is after character 0
			else if ((tmpBracketStartIndex > 0)
			//    2) The end bracket is after the start bracket
				&& (tmpBracketStopIndex > tmpBracketStartIndex)
			//    3) There is nothing in the brackets
				&& (tmpBracketStopIndex - tmpBracketStartIndex == 1))
			{
				let tmpBoxedPropertyName = pAddress.substring(0, tmpBracketStartIndex).trim();

				if (!Array.isArray(pObject[tmpBoxedPropertyName]))
				{
					// We asked for a set from an array but it isnt' an array.
					return false;
				}

				let tmpInputArray = pObject[tmpBoxedPropertyName];
				// Count from the end to the beginning so splice doesn't %&%#$ up the array
				for (let i = tmpInputArray.length - 1; i >= 0; i--)
				{
					// The filtering is complex but allows config-based metaprogramming directly from schema
					let tmpKeepRecord = this.checkRecordFilters(pAddress, tmpInputArray[i]);
					if (tmpKeepRecord)
					{
						// Delete elements end to beginning
						tmpInputArray.splice(i, 1);
					}
				}
				return true;
			}
			// The object has been flagged as an object set, so treat it as such
			else if (tmpObjectTypeMarkerIndex > 0)
			{
				let tmpObjectPropertyName = pAddress.substring(0, tmpObjectTypeMarkerIndex).trim();

				if (typeof(pObject[tmpObjectPropertyName]) != 'object')
				{
					// We asked for a set from an array but it isnt' an array.
					return false;
				}

				delete pObject[tmpObjectPropertyName];
				return true;
			}
			else
			{
				// Now is the point in recursion to return the value in the address
				delete pObject[pAddress];
				return true;
			}
		}
		else
		{
			let tmpSubObjectName = tmpAddressPartBeginning;
			let tmpNewAddress = pAddress.substring(tmpAddressPartBeginning.length+1);

			// BOXED ELEMENTS
			// Test if the tmpNewAddress is an array or object
			// Check if it's a boxed property
			let tmpBracketStartIndex = tmpSubObjectName.indexOf('[');
			let tmpBracketStopIndex = tmpSubObjectName.indexOf(']');
			// Boxed elements look like this:
			// 		MyValues[42]
			// 		MyValues['Color']
			// 		MyValues["Weight"]
			// 		MyValues[`Diameter`]
			//
			// When we are passed SomeObject["Name"] this code below recurses as if it were SomeObject.Name
			// The requirements to detect a boxed element are:
			//    1) The start bracket is after character 0
			if ((tmpBracketStartIndex > 0)
			//    2) The end bracket has something between them
				&& (tmpBracketStopIndex > tmpBracketStartIndex)
			//    3) There is data
				&& (tmpBracketStopIndex - tmpBracketStartIndex > 1))
			{
				let tmpBoxedPropertyName = tmpSubObjectName.substring(0, tmpBracketStartIndex).trim();

				let tmpBoxedPropertyReference = tmpSubObjectName.substring(tmpBracketStartIndex+1, tmpBracketStopIndex).trim();

				let tmpBoxedPropertyNumber = parseInt(tmpBoxedPropertyReference, 10);

				// Guard: If the referrant is a number and the boxed property is not an array, or vice versa, return undefined.
				//        This seems confusing to me at first read, so explaination:
				//        Is the Boxed Object an Array?  TRUE
				//        And is the Reference inside the boxed Object not a number? TRUE
				//        -->  So when these are in agreement, it's an impossible access state
				// This could be a failure in the recursion chain because they passed something like this in:
				//    StudentData.Sections.Algebra.Students[1].Tardy
				//       BUT
				//         StudentData.Sections.Algebra.Students is an object, so the [1].Tardy is not possible to access
				// This could be a failure in the recursion chain because they passed something like this in:
				//    StudentData.Sections.Algebra.Students["JaneDoe"].Grade
				//       BUT
				//         StudentData.Sections.Algebra.Students is an array, so the ["JaneDoe"].Grade is not possible to access
				// TODO: Should this be an error or something?  Should we keep a log of failures like this?
				if (Array.isArray(pObject[tmpBoxedPropertyName]) == isNaN(tmpBoxedPropertyNumber))
				{
					return false;
				}
				// Check if the boxed property is an object.
				if (typeof(pObject[tmpBoxedPropertyName]) != 'object')
				{
					return false;
				}
				//This is a bracketed value
				//    4) If the middle part is *only* a number (no single, double or backtick quotes) it is an array element,
				//       otherwise we will try to reat it as a dynamic object property.
				if (isNaN(tmpBoxedPropertyNumber))
				{
					// This isn't a number ... let's treat it as a dynanmic object property.
					tmpBoxedPropertyReference = this.cleanWrapCharacters('"', tmpBoxedPropertyReference);
					tmpBoxedPropertyReference = this.cleanWrapCharacters('`', tmpBoxedPropertyReference);
					tmpBoxedPropertyReference = this.cleanWrapCharacters("'", tmpBoxedPropertyReference);

					// Continue to manage the parent address for recursion
					tmpParentAddress = `${tmpParentAddress}${(tmpParentAddress.length > 0) ? '.' : ''}${tmpSubObjectName}`;
					// Recurse directly into the subobject
					return this.deleteValueAtAddress(pObject[tmpBoxedPropertyName][tmpBoxedPropertyReference], tmpNewAddress, tmpParentAddress);
				}
				else
				{
					// Continue to manage the parent address for recursion
					tmpParentAddress = `${tmpParentAddress}${(tmpParentAddress.length > 0) ? '.' : ''}${tmpSubObjectName}`;
					// We parsed a valid number out of the boxed property name, so recurse into the array
					return this.deleteValueAtAddress(pObject[tmpBoxedPropertyName][tmpBoxedPropertyNumber], tmpNewAddress, tmpParentAddress);
				}
			}
			// The requirements to detect a boxed set element are:
			//    1) The start bracket is after character 0
			else if ((tmpBracketStartIndex > 0)
			//    2) The end bracket is after the start bracket
				&& (tmpBracketStopIndex > tmpBracketStartIndex)
			//    3) There is nothing in the brackets
				&& (tmpBracketStopIndex - tmpBracketStartIndex == 1))
			{
				let tmpBoxedPropertyName = pAddress.substring(0, tmpBracketStartIndex).trim();

				if (!Array.isArray(pObject[tmpBoxedPropertyName]))
				{
					// We asked for a set from an array but it isnt' an array.
					return false;
				}

				// We need to enumerate the array and grab the addresses from there.
				let tmpArrayProperty = pObject[tmpBoxedPropertyName];
				// Managing the parent address is a bit more complex here -- the box will be added for each element.
				tmpParentAddress = `${tmpParentAddress}${(tmpParentAddress.length > 0) ? '.' : ''}${tmpBoxedPropertyName}`;
				// The container object is where we have the "Address":SOMEVALUE pairs
				let tmpContainerObject = {};
				for (let i = 0; i < tmpArrayProperty.length; i++)
				{
					let tmpPropertyParentAddress = `${tmpParentAddress}[${i}]`;
					let tmpValue = this.deleteValueAtAddress(pObject[tmpBoxedPropertyName][i], tmpNewAddress, tmpPropertyParentAddress);

					tmpContainerObject[`${tmpPropertyParentAddress}.${tmpNewAddress}`] = tmpValue;
				}

				return tmpContainerObject;
			}

			// OBJECT SET
			// Note this will not work with a bracket in the same address box set
			let tmpObjectTypeMarkerIndex = pAddress.indexOf('{}');
			if (tmpObjectTypeMarkerIndex > 0)
			{
				let tmpObjectPropertyName = pAddress.substring(0, tmpObjectTypeMarkerIndex).trim();

				if (typeof(pObject[tmpObjectPropertyName]) != 'object')
				{
					// We asked for a set from an array but it isnt' an array.
					return false;
				}

				// We need to enumerate the Object and grab the addresses from there.
				let tmpObjectProperty = pObject[tmpObjectPropertyName];
				let tmpObjectPropertyKeys = Object.keys(tmpObjectProperty);
				// Managing the parent address is a bit more complex here -- the box will be added for each element.
				tmpParentAddress = `${tmpParentAddress}${(tmpParentAddress.length > 0) ? '.' : ''}${tmpObjectPropertyName}`;
				// The container object is where we have the "Address":SOMEVALUE pairs
				let tmpContainerObject = {};
				for (let i = 0; i < tmpObjectPropertyKeys.length; i++)
				{
					let tmpPropertyParentAddress = `${tmpParentAddress}.${tmpObjectPropertyKeys[i]}`;
					let tmpValue = this.deleteValueAtAddress(pObject[tmpObjectPropertyName][tmpObjectPropertyKeys[i]], tmpNewAddress, tmpPropertyParentAddress);

					// The filtering is complex but allows config-based metaprogramming directly from schema
					let tmpKeepRecord = this.checkRecordFilters(pAddress, tmpValue);
					if (tmpKeepRecord)
					{
						tmpContainerObject[`${tmpPropertyParentAddress}.${tmpNewAddress}`] = tmpValue;
					}
				}

				return tmpContainerObject;
			}

			// If there is an object property already named for the sub object, but it isn't an object
			// then the system can't set the value in there.  Error and abort!
			if ((tmpSubObjectName in pObject) && typeof(pObject[tmpSubObjectName]) !== 'object')
			{
				return undefined;
			}
			else if (tmpSubObjectName in pObject)
			{
				// If there is already a subobject pass that to the recursive thingy
				// Continue to manage the parent address for recursion
				tmpParentAddress = `${tmpParentAddress}${(tmpParentAddress.length > 0) ? '.' : ''}${tmpSubObjectName}`;
				return this.deleteValueAtAddress(pObject[tmpSubObjectName], tmpNewAddress, tmpParentAddress);
			}
			else
			{
				// Create a subobject and then pass that
				// Continue to manage the parent address for recursion
				tmpParentAddress = `${tmpParentAddress}${(tmpParentAddress.length > 0) ? '.' : ''}${tmpSubObjectName}`;
				pObject[tmpSubObjectName] = {};
				return this.deleteValueAtAddress(pObject[tmpSubObjectName], tmpNewAddress, tmpParentAddress);
			}
		}
	}
};

module.exports = ManyfestObjectAddressResolverDeleteValue;

},{"../source/Manyfest-ParseConditionals.js":125,"./Manyfest-CleanWrapCharacters.js":116,"./Manyfest-LogToConsole.js":118,"./Manyfest-ObjectAddress-Parser.js":122}],121:[function(require,module,exports){
/**
* @author <steven@velozo.com>
*/
let libSimpleLog = require('./Manyfest-LogToConsole.js');
let fCleanWrapCharacters = require('./Manyfest-CleanWrapCharacters.js');
let fParseConditionals = require(`../source/Manyfest-ParseConditionals.js`);

let _MockFable = { DataFormat: require('./Manyfest-ObjectAddress-Parser.js') };

/**
* Object Address Resolver - GetValue
*
* IMPORTANT NOTE: This code is intentionally more verbose than necessary, to
*                 be extremely clear what is going on in the recursion for
*                 each of the three address resolution functions.
*
*                 Although there is some opportunity to repeat ourselves a
*                 bit less in this codebase (e.g. with detection of arrays
*                 versus objects versus direct properties), it can make
*                 debugging.. challenging.  The minified version of the code
*                 optimizes out almost anything repeated in here.  So please
*                 be kind and rewind... meaning please keep the codebase less
*                 terse and more verbose so humans can comprehend it.
*
* TODO: Once we validate this pattern is good to go, break these out into
*       three separate modules.
*
* @class ManyfestObjectAddressResolverGetValue
*/
class ManyfestObjectAddressResolverGetValue
{
	/**
	 * @param {function} [pInfoLog] - (optional) A logging function for info messages
	 * @param {function} [pErrorLog] - (optional) A logging function for error messages
	 */
	constructor(pInfoLog, pErrorLog)
	{
		// Wire in logging
		this.logInfo = (typeof(pInfoLog) == 'function') ? pInfoLog : libSimpleLog;
		this.logError = (typeof(pErrorLog) == 'function') ? pErrorLog : libSimpleLog;

		this.cleanWrapCharacters = fCleanWrapCharacters;
	}

	/**
	 * @param {string} pAddress - The address of the record to check
	 * @param {object} pRecord - The record to check against the filters
	 *
	 * @return {boolean} - True if the record passes the filters, false otherwise
	 */
	checkRecordFilters(pAddress, pRecord)
	{
		return fParseConditionals(this, pAddress, pRecord);
	}

	/**
	 * Get the value of an element at an address
	 *
	 * @param {object} pObject - The object to resolve the address against
	 * @param {string} pAddress - The address to resolve
	 * @param {string} [pParentAddress] - (optional) The parent address for back-navigation
	 * @param {object} [pRootObject] - (optional) The root object for function argument resolution
	 *
	 * @return {any} The value at the address, or undefined if not found
	 */
	getValueAtAddress (pObject, pAddress, pParentAddress, pRootObject)
	{
		// Make sure pObject (the object we are meant to be recursing) is an object (which could be an array or object)
		if (typeof(pObject) != 'object')
		{
			return undefined;
		}
		if (pObject === null)
		{
			return undefined;
		}
		// Make sure pAddress (the address we are resolving) is a string
		if (typeof(pAddress) != 'string')
		{
			return undefined;
		}
		// Stash the parent address for later resolution
		let tmpParentAddress = "";
		if (typeof(pParentAddress) == 'string')
		{
			tmpParentAddress = pParentAddress;
		}

		// Set the root object to the passed-in object if it isn't set yet.  This is expected to be the root object.
		let tmpRootObject = (typeof(pRootObject) == 'undefined') ? pObject : pRootObject;

		// DONE: Make this work for things like SomeRootObject.Metadata["Some.People.Use.Bad.Object.Property.Names"]
		let tmpAddressPartBeginning = _MockFable.DataFormat.stringGetFirstSegment(pAddress);

		// Adding simple back-navigation in objects
		if (tmpAddressPartBeginning == '')
		{
			// Given an address of "Bundle.Contract.IDContract...Project.IDProject" the ... would be interpreted as two back-navigations from IDContract.
			// When the address is passed in, though, the first . is already eliminated.  So we can count the dots.
			let tmpParentAddressParts = _MockFable.DataFormat.stringGetSegments(tmpParentAddress);

			let tmpBackNavigationCount = 0;

			// Count the number of dots
			for (let i = 0; i < pAddress.length; i++)
			{
				if (pAddress.charAt(i) != '.')
				{
					break;
				}
				tmpBackNavigationCount++;
			}

			let tmpParentAddressLength = tmpParentAddressParts.length - tmpBackNavigationCount;

			if (tmpParentAddressLength < 0)
			{
				// We are trying to back navigate more than we can.
				// TODO: Should this be undefined or should we bank out at the bottom and try to go forward?
				// This seems safest for now.
				return undefined;
			}
			else
			{
				// We are trying to back navigate to a parent object.
				// Recurse with the back-propagated parent address, and, the new address without the back-navigation dots.
				let tmpRecurseAddress = pAddress.slice(tmpBackNavigationCount);
				if (tmpParentAddressLength > 0)
				{
					tmpRecurseAddress = `${tmpParentAddressParts.slice(0, tmpParentAddressLength).join('.')}.${tmpRecurseAddress}`;
				}
				this.logInfo(`Back-navigation detected.  Recursing back to address [${tmpRecurseAddress}]`);
				return this.getValueAtAddress(tmpRootObject, tmpRecurseAddress);
			}
		}

		// This is the terminal address string (no more dots so the RECUSION ENDS IN HERE somehow)
		if (tmpAddressPartBeginning.length == pAddress.length)
		{
			// TODO: Optimize this by having these calls only happen when the previous fails.
			// TODO: Alternatively look for all markers in one pass?
			// Check if the address refers to a boxed property
			let tmpBracketStartIndex = pAddress.indexOf('[');
			let tmpBracketStopIndex = pAddress.indexOf(']');

			// Check for the Object Set Type marker.
			// Note this will not work with a bracket in the same address box set
			let tmpObjectTypeMarkerIndex = pAddress.indexOf('{}');


			// Check if there is a function somewhere in the address... parenthesis start should only be in a function
			let tmpFunctionStartIndex = pAddress.indexOf('(');

			// NOTE THAT FUNCTIONS MUST RESOLVE FIRST
			// Functions look like this
			// 		MyFunction()
			// 		MyFunction(Some.Address)
			// 		MyFunction(Some.Address,Some.Other.Address)
			// 		MyFunction(Some.Address,Some.Other.Address,Some.Third.Address)
			//
			// This could be enhanced to allow purely numeric and string values to be passed to the function.  For now,
			// To heck with that.  This is a simple function call.
			//
			// The requirements to detect a function are:
			//    1) The start bracket is after character 0
			if ((tmpFunctionStartIndex > 0)
			//    2) The end bracket is after the start bracket
				&& (_MockFable.DataFormat.stringCountEnclosures(pAddress) > 0))
			{
				let tmpFunctionAddress = pAddress.substring(0, tmpFunctionStartIndex).trim();

				if (typeof pObject[tmpFunctionAddress] !== 'function')
				{
					// The address suggests it is a function, but it is not.
					return false;
				}

				// Now see if the function has arguments.
				// Implementation notes: * ARGUMENTS MUST SHARE THE SAME ROOT OBJECT CONTEXT *
				let tmpFunctionArguments = _MockFable.DataFormat.stringGetSegments(_MockFable.DataFormat.stringGetEnclosureValueByIndex(pAddress.substring(tmpFunctionAddress.length), 0), ',');
				if ((tmpFunctionArguments.length == 0) || (tmpFunctionArguments[0] == ''))
				{
					// No arguments... just call the function (bound to the scope of the object it is contained withing)
					if (tmpFunctionAddress in pObject)
					{
						try
						{
							return pObject[tmpFunctionAddress].apply(pObject);
						}
						catch(pError)
						{
							// The function call failed, so the address doesn't exist
							console.log(`Error in getValueAtAddress calling function ${tmpFunctionAddress} (address [${pAddress}]): ${pError.message}`);
							return false;
						}
					}
					else
					{
						// The function doesn't exist, so the address doesn't exist
						console.log(`Function ${tmpFunctionAddress} does not exist (address [${pAddress}])`);
						return false;
					}
				}
				else
				{
					let tmpArgumentValues = [];

					// Now get the value for each argument
					for (let i = 0; i < tmpFunctionArguments.length; i++)
					{
						// Trim whitespace from the argument (e.g. after comma separation: `Book`, `List` --> ` `List``)
						let tmpArgument = tmpFunctionArguments[i].trim();
						// Resolve the values for each subsequent entry
						// Check if the argument value is a string literal or a reference to an address
						if ((tmpArgument.length >= 2)
							&&
							((tmpArgument.charAt(0) == '"')
							|| (tmpArgument.charAt(0) == "'")
							|| (tmpArgument.charAt(0) == "`"))
							&&
							((tmpArgument.charAt(tmpArgument.length-1) == '"')
							|| (tmpArgument.charAt(tmpArgument.length-1) == "'")
							|| (tmpArgument.charAt(tmpArgument.length-1) == "`")))
						{
							// This is a string literal
							tmpArgumentValues.push(tmpArgument.substring(1, tmpArgument.length-1));
						}
						else
						{
							// This is a hash address
							tmpArgumentValues.push(this.getValueAtAddress(tmpRootObject, tmpArgument));
						}
					}

					if (tmpFunctionAddress in pObject)
					{
						try
						{
							return pObject[tmpFunctionAddress].apply(pObject, tmpArgumentValues);
						}
						catch(pError)
						{
							// The function call failed, so the address doesn't exist
							console.log(`Error in getValueAtAddress calling function ${tmpFunctionAddress} (address [${pAddress}]): ${pError.message}`);
							return false;
						}
					}
					else
					{
						// The function doesn't exist, so the address doesn't exist
						console.log(`Function ${tmpFunctionAddress} does not exist (address [${pAddress}])`);
						return false;
					}
				}
			}
			// Boxed elements look like this:
			// 		MyValues[10]
			// 		MyValues['Name']
			// 		MyValues["Age"]
			// 		MyValues[`Cost`]
			//
			// When we are passed SomeObject["Name"] this code below recurses as if it were SomeObject.Name
			// The requirements to detect a boxed element are:
			//    1) The start bracket is after character 0
			else if ((tmpBracketStartIndex > 0)
			//    2) The end bracket has something between them
				&& (tmpBracketStopIndex > tmpBracketStartIndex)
			//    3) There is data
				&& (tmpBracketStopIndex - tmpBracketStartIndex > 1))
			{
				// The "Name" of the Object contained too the left of the bracket
				let tmpBoxedPropertyName = pAddress.substring(0, tmpBracketStartIndex).trim();

				// If the subproperty doesn't test as a proper Object, none of the rest of this is possible.
				// This is a rare case where Arrays testing as Objects is useful
				if (typeof(pObject[tmpBoxedPropertyName]) !== 'object')
				{
					return undefined;
				}

				// The "Reference" to the property within it, either an array element or object property
				let tmpBoxedPropertyReference = pAddress.substring(tmpBracketStartIndex+1, tmpBracketStopIndex).trim();
				// Attempt to parse the reference as a number, which will be used as an array element
				let tmpBoxedPropertyNumber = parseInt(tmpBoxedPropertyReference, 10);

				// Guard: If the referrant is a number and the boxed property is not an array, or vice versa, return undefined.
				//        This seems confusing to me at first read, so explaination:
				//        Is the Boxed Object an Array?  TRUE
				//        And is the Reference inside the boxed Object not a number? TRUE
				//        -->  So when these are in agreement, it's an impossible access state
				if (Array.isArray(pObject[tmpBoxedPropertyName]) == isNaN(tmpBoxedPropertyNumber))
				{
					return undefined;
				}

				//    4) If the middle part is *only* a number (no single, double or backtick quotes) it is an array element,
				//       otherwise we will try to treat it as a dynamic object property.
				if (isNaN(tmpBoxedPropertyNumber))
				{
					// This isn't a number ... let's treat it as a dynamic object property.
					// We would expect the property to be wrapped in some kind of quotes so strip them
					tmpBoxedPropertyReference = this.cleanWrapCharacters('"', tmpBoxedPropertyReference);
					tmpBoxedPropertyReference = this.cleanWrapCharacters('`', tmpBoxedPropertyReference);
					tmpBoxedPropertyReference = this.cleanWrapCharacters("'", tmpBoxedPropertyReference);

					// Return the value in the property
					return pObject[tmpBoxedPropertyName][tmpBoxedPropertyReference];
				}
				else
				{
					return pObject[tmpBoxedPropertyName][tmpBoxedPropertyNumber];
				}
			}
			// The requirements to detect a boxed set element are:
			//    1) The start bracket is after character 0
			else if ((tmpBracketStartIndex > 0)
			//    2) The end bracket is after the start bracket
				&& (tmpBracketStopIndex > tmpBracketStartIndex)
			//    3) There is nothing in the brackets
				&& (tmpBracketStopIndex - tmpBracketStartIndex == 1))
			{
				let tmpBoxedPropertyName = pAddress.substring(0, tmpBracketStartIndex).trim();

				if (!Array.isArray(pObject[tmpBoxedPropertyName]))
				{
					// We asked for a set from an array but it isnt' an array.
					return false;
				}

				let tmpInputArray = pObject[tmpBoxedPropertyName];
				let tmpOutputArray = [];
				for (let i = 0; i < tmpInputArray.length; i++)
				{
					// The filtering is complex but allows config-based metaprogramming directly from schema
					let tmpKeepRecord = this.checkRecordFilters(pAddress, tmpInputArray[i]);
					if (tmpKeepRecord)
					{
						tmpOutputArray.push(tmpInputArray[i]);

					}
				}

				return tmpOutputArray;
			}
			// The object has been flagged as an object set, so treat it as such
			else if (tmpObjectTypeMarkerIndex > 0)
			{
				let tmpObjectPropertyName = pAddress.substring(0, tmpObjectTypeMarkerIndex).trim();

				if (typeof(pObject[tmpObjectPropertyName]) != 'object')
				{
					// We asked for a set from an array but it isnt' an array.
					return false;
				}

				return pObject[tmpObjectPropertyName];
			}
			else
			{
				// Now is the point in recursion to return the value in the address
				if (typeof(pObject[pAddress]) != 'undefined')
				{
					return pObject[pAddress];
				}
				else
				{
					return undefined;
				}
			}
		}
		else
		{
			//let tmpSubObjectName = pAddress.substring(0, tmpSeparatorIndex);
			//let tmpNewAddress = pAddress.substring(tmpSeparatorIndex+1);
			let tmpSubObjectName = tmpAddressPartBeginning;
			let tmpNewAddress = pAddress.substring(tmpAddressPartBeginning.length+1);

			// BOXED ELEMENTS
			// Test if the tmpNewAddress is an array or object
			// Check if it's a boxed property
			let tmpBracketStartIndex = tmpSubObjectName.indexOf('[');
			let tmpBracketStopIndex = tmpSubObjectName.indexOf(']');

			// Check if there is a function somewhere in the address... parenthesis start should only be in a function
			let tmpFunctionStartIndex = tmpSubObjectName.indexOf('(');

			// NOTE THAT FUNCTIONS MUST RESOLVE FIRST
			// Functions look like this
			// 		MyFunction()
			// 		MyFunction(Some.Address)
			// 		MyFunction(Some.Address,Some.Other.Address)
			// 		MyFunction(Some.Address,Some.Other.Address,Some.Third.Address)
			//
			// This could be enhanced to allow purely numeric and string values to be passed to the function.  For now,
			// To heck with that.  This is a simple function call.
			//
			// The requirements to detect a function are:
			//    1) The start bracket is after character 0
			if ((tmpFunctionStartIndex > 0)
			//    2) The end bracket is after the start bracket
				&& (_MockFable.DataFormat.stringCountEnclosures(tmpSubObjectName) > 0))
			{
				let tmpFunctionAddress = tmpSubObjectName.substring(0, tmpFunctionStartIndex).trim();
				tmpParentAddress = `${tmpParentAddress}${(tmpParentAddress.length > 0) ? '.' : ''}${tmpSubObjectName}`;

				if (typeof pObject[tmpFunctionAddress] !== 'function')
				{
					// The address suggests it is a function, but it is not.
					return false;
				}

				// Now see if the function has arguments.
				// Implementation notes: * ARGUMENTS MUST SHARE THE SAME ROOT OBJECT CONTEXT *
				let tmpFunctionArguments = _MockFable.DataFormat.stringGetSegments(_MockFable.DataFormat.stringGetEnclosureValueByIndex(tmpSubObjectName.substring(tmpFunctionAddress.length), 0), ',');
				if ((tmpFunctionArguments.length == 0) || (tmpFunctionArguments[0] == ''))
				{
					// No arguments... just call the function (bound to the scope of the object it is contained withing)
					if (tmpFunctionAddress in pObject)
					{
						try
						{
							return this.getValueAtAddress(pObject[tmpFunctionAddress].apply(pObject), tmpNewAddress, tmpParentAddress, tmpRootObject);
						}
						catch(pError)
						{
							// The function call failed, so the address doesn't exist
							console.log(`Error in getValueAtAddress calling function ${tmpFunctionAddress} (address [${pAddress}]): ${pError.message}`);
							return false;
						}
					}
					else
					{
						// The function doesn't exist, so the address doesn't exist
						console.log(`Function ${tmpFunctionAddress} does not exist (address [${pAddress}])`);
						return false;
					}
				}
				else
				{
					let tmpArgumentValues = [];

					// Now get the value for each argument
					for (let i = 0; i < tmpFunctionArguments.length; i++)
					{
						// Trim whitespace from the argument (e.g. after comma separation: `Book`, `List` --> ` `List``)
						let tmpArgument = tmpFunctionArguments[i].trim();
						// Resolve the values for each subsequent entry
						// Check if the argument value is a string literal or a reference to an address
						if ((tmpArgument.length >= 2)
							&&
							((tmpArgument.charAt(0) == '"')
							|| (tmpArgument.charAt(0) == "'")
							|| (tmpArgument.charAt(0) == "`"))
							&&
							((tmpArgument.charAt(tmpArgument.length-1) == '"')
							|| (tmpArgument.charAt(tmpArgument.length-1) == "'")
							|| (tmpArgument.charAt(tmpArgument.length-1) == "`")))
						{
							// This is a string literal
							tmpArgumentValues.push(tmpArgument.substring(1, tmpArgument.length-1));
						}
						else
						{
							// This is a hash address
							tmpArgumentValues.push(this.getValueAtAddress(tmpRootObject, tmpArgument));
						}
					}

					if (tmpFunctionAddress in pObject)
					{
						try
						{
							return this.getValueAtAddress(pObject[tmpFunctionAddress].apply(pObject, tmpArgumentValues), tmpNewAddress, tmpParentAddress, tmpRootObject);
						}
						catch(pError)
						{
							// The function call failed, so the address doesn't exist
							console.log(`Error in getValueAtAddress calling function ${tmpFunctionAddress} (address [${pAddress}]): ${pError.message}`);
							return false;
						}
					}
					else
					{
						// The function doesn't exist, so the address doesn't exist
						console.log(`Function ${tmpFunctionAddress} does not exist (address [${pAddress}])`);
						return false;
					}
				}
			}
			// Boxed elements look like this:
			// 		MyValues[42]
			// 		MyValues['Color']
			// 		MyValues["Weight"]
			// 		MyValues[`Diameter`]
			//
			// When we are passed SomeObject["Name"] this code below recurses as if it were SomeObject.Name
			// The requirements to detect a boxed element are:
			//    1) The start bracket is after character 0
			else if ((tmpBracketStartIndex > 0)
			//    2) The end bracket has something between them
				&& (tmpBracketStopIndex > tmpBracketStartIndex)
			//    3) There is data
				&& (tmpBracketStopIndex - tmpBracketStartIndex > 1))
			{
				let tmpBoxedPropertyName = tmpSubObjectName.substring(0, tmpBracketStartIndex).trim();

				let tmpBoxedPropertyReference = tmpSubObjectName.substring(tmpBracketStartIndex+1, tmpBracketStopIndex).trim();

				let tmpBoxedPropertyNumber = parseInt(tmpBoxedPropertyReference, 10);

				// Guard: If the referrant is a number and the boxed property is not an array, or vice versa, return undefined.
				//        This seems confusing to me at first read, so explaination:
				//        Is the Boxed Object an Array?  TRUE
				//        And is the Reference inside the boxed Object not a number? TRUE
				//        -->  So when these are in agreement, it's an impossible access state
				// This could be a failure in the recursion chain because they passed something like this in:
				//    StudentData.Sections.Algebra.Students[1].Tardy
				//       BUT
				//         StudentData.Sections.Algebra.Students is an object, so the [1].Tardy is not possible to access
				// This could be a failure in the recursion chain because they passed something like this in:
				//    StudentData.Sections.Algebra.Students["JaneDoe"].Grade
				//       BUT
				//         StudentData.Sections.Algebra.Students is an array, so the ["JaneDoe"].Grade is not possible to access
				// TODO: Should this be an error or something?  Should we keep a log of failures like this?
				if (Array.isArray(pObject[tmpBoxedPropertyName]) == isNaN(tmpBoxedPropertyNumber))
				{
					return undefined;
				}
				// Check if the boxed property is an object.
				if (typeof(pObject[tmpBoxedPropertyName]) != 'object')
				{
					return undefined;
				}


				//This is a bracketed value
				//    4) If the middle part is *only* a number (no single, double or backtick quotes) it is an array element,
				//       otherwise we will try to reat it as a dynamic object property.
				if (isNaN(tmpBoxedPropertyNumber))
				{
					// This isn't a number ... let's treat it as a dynanmic object property.
					tmpBoxedPropertyReference = this.cleanWrapCharacters('"', tmpBoxedPropertyReference);
					tmpBoxedPropertyReference = this.cleanWrapCharacters('`', tmpBoxedPropertyReference);
					tmpBoxedPropertyReference = this.cleanWrapCharacters("'", tmpBoxedPropertyReference);

					// Continue to manage the parent address for recursion
					tmpParentAddress = `${tmpParentAddress}${(tmpParentAddress.length > 0) ? '.' : ''}${tmpSubObjectName}`;
					// Recurse directly into the subobject
					return this.getValueAtAddress(pObject[tmpBoxedPropertyName][tmpBoxedPropertyReference], tmpNewAddress, tmpParentAddress, tmpRootObject);
				}
				else
				{
					// Continue to manage the parent address for recursion
					tmpParentAddress = `${tmpParentAddress}${(tmpParentAddress.length > 0) ? '.' : ''}${tmpSubObjectName}`;
					// We parsed a valid number out of the boxed property name, so recurse into the array
					return this.getValueAtAddress(pObject[tmpBoxedPropertyName][tmpBoxedPropertyNumber], tmpNewAddress, tmpParentAddress, tmpRootObject);
				}
			}
			// The requirements to detect a boxed set element are:
			//    1) The start bracket is after character 0
			else if ((tmpBracketStartIndex > 0)
			//    2) The end bracket is after the start bracket
				&& (tmpBracketStopIndex > tmpBracketStartIndex)
			//    3) There is nothing in the brackets
				&& (tmpBracketStopIndex - tmpBracketStartIndex == 1))
			{
				let tmpBoxedPropertyName = pAddress.substring(0, tmpBracketStartIndex).trim();

				if (!Array.isArray(pObject[tmpBoxedPropertyName]))
				{
					// We asked for a set from an array but it isnt' an array.
					return false;
				}

				// We need to enumerate the array and grab the addresses from there.
				let tmpArrayProperty = pObject[tmpBoxedPropertyName];
				// Managing the parent address is a bit more complex here -- the box will be added for each element.
				tmpParentAddress = `${tmpParentAddress}${(tmpParentAddress.length > 0) ? '.' : ''}${tmpBoxedPropertyName}`;
				// The container object is where we have the "Address":SOMEVALUE pairs
				let tmpContainerObject = {};
				for (let i = 0; i < tmpArrayProperty.length; i++)
				{
					let tmpPropertyParentAddress = `${tmpParentAddress}[${i}]`;
					let tmpValue = this.getValueAtAddress(pObject[tmpBoxedPropertyName][i], tmpNewAddress, tmpPropertyParentAddress, tmpRootObject);

					tmpContainerObject[`${tmpPropertyParentAddress}.${tmpNewAddress}`] = tmpValue;
				}

				return tmpContainerObject;
			}

			// OBJECT SET
			// Note this will not work with a bracket in the same address box set
			let tmpObjectTypeMarkerIndex = pAddress.indexOf('{}');
			if (tmpObjectTypeMarkerIndex > 0)
			{
				let tmpObjectPropertyName = pAddress.substring(0, tmpObjectTypeMarkerIndex).trim();

				if (typeof(pObject[tmpObjectPropertyName]) != 'object')
				{
					// We asked for a set from an array but it isnt' an array.
					return false;
				}

				// We need to enumerate the Object and grab the addresses from there.
				let tmpObjectProperty = pObject[tmpObjectPropertyName];
				let tmpObjectPropertyKeys = Object.keys(tmpObjectProperty);
				// Managing the parent address is a bit more complex here -- the box will be added for each element.
				tmpParentAddress = `${tmpParentAddress}${(tmpParentAddress.length > 0) ? '.' : ''}${tmpObjectPropertyName}`;
				// The container object is where we have the "Address":SOMEVALUE pairs
				let tmpContainerObject = {};
				for (let i = 0; i < tmpObjectPropertyKeys.length; i++)
				{
					let tmpPropertyParentAddress = `${tmpParentAddress}.${tmpObjectPropertyKeys[i]}`;
					let tmpValue = this.getValueAtAddress(pObject[tmpObjectPropertyName][tmpObjectPropertyKeys[i]], tmpNewAddress, tmpPropertyParentAddress, tmpRootObject);

					// The filtering is complex but allows config-based metaprogramming directly from schema
					let tmpKeepRecord = this.checkRecordFilters(pAddress, tmpValue);
					if (tmpKeepRecord)
					{
						tmpContainerObject[`${tmpPropertyParentAddress}.${tmpNewAddress}`] = tmpValue;
					}
				}

				return tmpContainerObject;
			}

			// If there is an object property already named for the sub object, but it isn't an object
			// then the system can't set the value in there.  Error and abort!
			if ((tmpSubObjectName in pObject) && typeof(pObject[tmpSubObjectName]) !== 'object')
			{
				return undefined;
			}
			else if (tmpSubObjectName in pObject)
			{
				// If there is already a subobject pass that to the recursive thingy
				// Continue to manage the parent address for recursion
				tmpParentAddress = `${tmpParentAddress}${(tmpParentAddress.length > 0) ? '.' : ''}${tmpSubObjectName}`;
				return this.getValueAtAddress(pObject[tmpSubObjectName], tmpNewAddress, tmpParentAddress, tmpRootObject);
			}
			else
			{
				// Create a subobject and then pass that
				// Continue to manage the parent address for recursion
				tmpParentAddress = `${tmpParentAddress}${(tmpParentAddress.length > 0) ? '.' : ''}${tmpSubObjectName}`;
				pObject[tmpSubObjectName] = {};
				return this.getValueAtAddress(pObject[tmpSubObjectName], tmpNewAddress, tmpParentAddress, tmpRootObject);
			}
		}
	}
};

module.exports = ManyfestObjectAddressResolverGetValue;

},{"../source/Manyfest-ParseConditionals.js":125,"./Manyfest-CleanWrapCharacters.js":116,"./Manyfest-LogToConsole.js":118,"./Manyfest-ObjectAddress-Parser.js":122}],122:[function(require,module,exports){
// TODO: This is an inelegant solution to delay the rewrite of Manyfest.

// Fable 3.0 has a service for data formatting that deals well with nested enclosures.

// The Manyfest library predates fable 3.0 and the services structure of it, so the functions
// are more or less pure javascript and as functional as they can be made to be.

// Until we shift Manyfest to be a fable service, these three functions were pulled out of
// fable to aid in parsing functions with nested enclosures.

const DEFAULT_START_SYMBOL_MAP = { '{': 0, '[': 1, '(': 2 };
const DEFAULT_END_SYMBOL_MAP = { '}': 0, ']': 1, ')': 2 };

module.exports = {
	/**
	 * Count the number of segments in a string, respecting enclosures
	 *
	 * @param {string} pString
	 * @param {string} [pSeparator]
	 * @param {Record<string, number>} [pEnclosureStartSymbolMap]
	 * @param {Record<string, number>} [pEnclosureEndSymbolMap]
	 *
	 * @return {number} - The number of segments in the string
	 */
	stringCountSegments: (pString, pSeparator, pEnclosureStartSymbolMap, pEnclosureEndSymbolMap) =>
	{
		let tmpString = (typeof(pString) == 'string') ? pString : '';

		let tmpSeparator = (typeof(pSeparator) == 'string') ? pSeparator : '.';

		let tmpEnclosureStartSymbolMap = (typeof(pEnclosureStartSymbolMap) == 'object') ? pEnclosureStartSymbolMap : DEFAULT_START_SYMBOL_MAP;
		let tmpEnclosureEndSymbolMap = (typeof(pEnclosureEndSymbolMap) == 'object') ? pEnclosureEndSymbolMap : DEFAULT_END_SYMBOL_MAP;

		if (tmpString.length < 1)
		{
			return 0;
		}

		let tmpSegmentCount = 1;
		let tmpEnclosureStack = [];

		for (let i = 0; i < tmpString.length; i++)
		{
			// IF This is the start of a segment
			if ((tmpString[i] == tmpSeparator)
				// AND we are not in a nested portion of the string
				&& (tmpEnclosureStack.length == 0))
			{
				// Increment the segment count
				tmpSegmentCount++;
			}
			// IF This is the start of an enclosure
			else if (tmpString[i] in tmpEnclosureStartSymbolMap)
			{
				// Add it to the stack!
				tmpEnclosureStack.push(tmpEnclosureStartSymbolMap[tmpString[i]]);
			}
			// IF This is the end of an enclosure
			else if ((tmpString[i] in tmpEnclosureEndSymbolMap)
				// AND it matches the current nest level symbol
				&& tmpEnclosureEndSymbolMap[tmpString[i]] == tmpEnclosureStack[tmpEnclosureStack.length - 1])
			{
				// Pop it off the stack!
				tmpEnclosureStack.pop();
			}
		}

		return tmpSegmentCount;
	},

	/**
	 * Get the first segment in a string, respecting enclosures
	 *
	 * @param {string} pString
	 * @param {string} [pSeparator]
	 * @param {Record<string, number>} [pEnclosureStartSymbolMap]
	 * @param {Record<string, number>} [pEnclosureEndSymbolMap]
	 *
	 * @return {string} - the first segment in the string as a string
	 */
	stringGetFirstSegment: (pString, pSeparator, pEnclosureStartSymbolMap, pEnclosureEndSymbolMap) =>
	{
		let tmpString = (typeof(pString) == 'string') ? pString : '';

		let tmpSeparator = (typeof(pSeparator) == 'string') ? pSeparator : '.';

		let tmpEnclosureStartSymbolMap = (typeof(pEnclosureStartSymbolMap) == 'object') ? pEnclosureStartSymbolMap : DEFAULT_START_SYMBOL_MAP;
		let tmpEnclosureEndSymbolMap = (typeof(pEnclosureEndSymbolMap) == 'object') ? pEnclosureEndSymbolMap : DEFAULT_END_SYMBOL_MAP;

		if (tmpString.length < 1)
		{
			return '';
		}

		let tmpEnclosureStack = [];

		for (let i = 0; i < tmpString.length; i++)
		{
			// IF This is the start of a segment
			if ((tmpString[i] == tmpSeparator)
				// AND we are not in a nested portion of the string
				&& (tmpEnclosureStack.length == 0))
			{
				// Return the segment
				return tmpString.substring(0, i);
			}
			// IF This is the start of an enclosure
			else if (tmpString[i] in tmpEnclosureStartSymbolMap)
			{
				// Add it to the stack!
				tmpEnclosureStack.push(tmpEnclosureStartSymbolMap[tmpString[i]]);
			}
			// IF This is the end of an enclosure
			else if ((tmpString[i] in tmpEnclosureEndSymbolMap)
				// AND it matches the current nest level symbol
				&& tmpEnclosureEndSymbolMap[tmpString[i]] == tmpEnclosureStack[tmpEnclosureStack.length - 1])
			{
				// Pop it off the stack!
				tmpEnclosureStack.pop();
			}
		}

		return tmpString;
	},

	/**
	 * Get all segments in a string, respecting enclosures
	 *
	 * @param {string} pString
	 * @param {string} [pSeparator]
	 * @param {Record<string, number>} [pEnclosureStartSymbolMap]
	 * @param {Record<string, number>} [pEnclosureEndSymbolMap]
	 *
	 * @return {Array<string>} - the segments in the string as an array of strings
	 */
	stringGetSegments: (pString, pSeparator, pEnclosureStartSymbolMap, pEnclosureEndSymbolMap) =>
	{
		let tmpString = (typeof(pString) == 'string') ? pString : '';

		let tmpSeparator = (typeof(pSeparator) == 'string') ? pSeparator : '.';

		let tmpEnclosureStartSymbolMap = (typeof(pEnclosureStartSymbolMap) == 'object') ? pEnclosureStartSymbolMap : DEFAULT_START_SYMBOL_MAP;
		let tmpEnclosureEndSymbolMap = (typeof(pEnclosureEndSymbolMap) == 'object') ? pEnclosureEndSymbolMap : DEFAULT_END_SYMBOL_MAP;

		let tmpCurrentSegmentStart = 0;
		let tmpSegmentList = [];

		if (tmpString.length < 1)
		{
			return tmpSegmentList;
		}

		let tmpEnclosureStack = [];

		for (let i = 0; i < tmpString.length; i++)
		{
			// IF This is the start of a segment
			if ((tmpString[i] == tmpSeparator)
				// AND we are not in a nested portion of the string
				&& (tmpEnclosureStack.length == 0))
			{
				// Return the segment
				tmpSegmentList.push(tmpString.substring(tmpCurrentSegmentStart, i));
				tmpCurrentSegmentStart = i+1;
			}
			// IF This is the start of an enclosure
			else if (tmpString[i] in tmpEnclosureStartSymbolMap)
			{
				// Add it to the stack!
				tmpEnclosureStack.push(tmpEnclosureStartSymbolMap[tmpString[i]]);
			}
			// IF This is the end of an enclosure
			else if ((tmpString[i] in tmpEnclosureEndSymbolMap)
				// AND it matches the current nest level symbol
				&& tmpEnclosureEndSymbolMap[tmpString[i]] == tmpEnclosureStack[tmpEnclosureStack.length - 1])
			{
				// Pop it off the stack!
				tmpEnclosureStack.pop();
			}
		}

		if (tmpCurrentSegmentStart < tmpString.length)
		{
			tmpSegmentList.push(tmpString.substring(tmpCurrentSegmentStart));
		}

		return tmpSegmentList;
	},

	/**
	 * Count the number of enclosures in a string based on the start and end characters.
	 *
	 * If no start or end characters are specified, it will default to parentheses.  If the string is not a string, it will return 0.
	 *
	 * @param {string} pString
	 * @param {string} [pEnclosureStart]
	 * @param {string} [pEnclosureEnd]
	 * @returns the count of full in the string
	 */
	stringCountEnclosures: (pString, pEnclosureStart, pEnclosureEnd) =>
	{
		let tmpString = (typeof(pString) == 'string') ? pString : '';
		let tmpEnclosureStart = (typeof(pEnclosureStart) == 'string') ? pEnclosureStart : '(';
		let tmpEnclosureEnd = (typeof(pEnclosureEnd) == 'string') ? pEnclosureEnd : ')';

		let tmpEnclosureCount = 0;
		let tmpEnclosureDepth = 0;
		for (let i = 0; i < tmpString.length; i++)
		{
			// This is the start of an enclosure
			if (tmpString[i] == tmpEnclosureStart)
			{
				if (tmpEnclosureDepth == 0)
				{
					tmpEnclosureCount++;
				}
				tmpEnclosureDepth++;
			}
			else if (tmpString[i] == tmpEnclosureEnd)
			{
				tmpEnclosureDepth--;
			}
		}

		return tmpEnclosureCount;
	},


	/**
	 * Get the value of the enclosure at the specified index.
	 *
	 * If the index is not a number, it will default to 0.  If the string is not a string, it will return an empty string.  If the enclosure is not found, it will return an empty string.  If the enclosure
	 *
	 * @param {string} pString
	 * @param {number} pEnclosureIndexToGet
	 * @param {string} [pEnclosureStart]
	 * @param {string} [pEnclosureEnd]
	 *
	 * @return {string} - The value of the enclosure at the specified index
	 */
	stringGetEnclosureValueByIndex: (pString, pEnclosureIndexToGet, pEnclosureStart, pEnclosureEnd) =>
	{
		let tmpString = (typeof(pString) == 'string') ? pString : '';
		let tmpEnclosureIndexToGet = (typeof(pEnclosureIndexToGet) == 'number') ? pEnclosureIndexToGet : 0;
		let tmpEnclosureStart = (typeof(pEnclosureStart) == 'string') ? pEnclosureStart : '(';
		let tmpEnclosureEnd = (typeof(pEnclosureEnd) == 'string') ? pEnclosureEnd : ')';

		let tmpEnclosureCount = 0;
		let tmpEnclosureDepth = 0;

		let tmpMatchedEnclosureIndex = false;
		let tmpEnclosedValueStartIndex = 0;
		let tmpEnclosedValueEndIndex = 0;

		for (let i = 0; i < tmpString.length; i++)
		{
			// This is the start of an enclosure
			if (tmpString[i] == tmpEnclosureStart)
			{
				tmpEnclosureDepth++;

				// Only count enclosures at depth 1, but still this parses both pairs of all of them.
				if (tmpEnclosureDepth == 1)
				{
					tmpEnclosureCount++;
					if (tmpEnclosureIndexToGet == (tmpEnclosureCount - 1))
					{
						// This is the start of *the* enclosure
						tmpMatchedEnclosureIndex = true;
						tmpEnclosedValueStartIndex = i;
					}
				}
			}
			// This is the end of an enclosure
			else if (tmpString[i] == tmpEnclosureEnd)
			{
				tmpEnclosureDepth--;

				// Again, only count enclosures at depth 1, but still this parses both pairs of all of them.
				if ((tmpEnclosureDepth == 0) &&
					tmpMatchedEnclosureIndex &&
					(tmpEnclosedValueEndIndex <= tmpEnclosedValueStartIndex))
				{
					tmpEnclosedValueEndIndex = i;
					tmpMatchedEnclosureIndex = false;
				}
			}
		}

		if (tmpEnclosureCount <= tmpEnclosureIndexToGet)
		{
			// Return an empty string if the enclosure is not found
			return '';
		}

		if ((tmpEnclosedValueEndIndex > 0) && (tmpEnclosedValueEndIndex > tmpEnclosedValueStartIndex))
		{
			return tmpString.substring(tmpEnclosedValueStartIndex+1, tmpEnclosedValueEndIndex);
		}
		else
		{
			return tmpString.substring(tmpEnclosedValueStartIndex+1);
		}
	}
}

},{}],123:[function(require,module,exports){
/**
* @author <steven@velozo.com>
*/
let libSimpleLog = require('./Manyfest-LogToConsole.js');
let fCleanWrapCharacters = require('./Manyfest-CleanWrapCharacters.js');

let _MockFable = { DataFormat: require('./Manyfest-ObjectAddress-Parser.js') };

/**
* Object Address Resolver - SetValue
*
* IMPORTANT NOTE: This code is intentionally more verbose than necessary, to
*                 be extremely clear what is going on in the recursion for
*                 each of the three address resolution functions.
*
*                 Although there is some opportunity to repeat ourselves a
*                 bit less in this codebase (e.g. with detection of arrays
*                 versus objects versus direct properties), it can make
*                 debugging.. challenging.  The minified version of the code
*                 optimizes out almost anything repeated in here.  So please
*                 be kind and rewind... meaning please keep the codebase less
*                 terse and more verbose so humans can comprehend it.
*
*
* @class ManyfestObjectAddressSetValue
*/
class ManyfestObjectAddressSetValue
{
	/**
	 * @param {function} [pInfoLog] - (optional) A logging function for info messages
	 * @param {function} [pErrorLog] - (optional) A logging function for error messages
	 */
	constructor(pInfoLog, pErrorLog)
	{
		// Wire in logging
		this.logInfo = (typeof(pInfoLog) == 'function') ? pInfoLog : libSimpleLog;
		this.logError = (typeof(pErrorLog) == 'function') ? pErrorLog : libSimpleLog;

		this.cleanWrapCharacters = fCleanWrapCharacters;
	}

	/**
	 * Set the value of an element at an address
	 *
	 * @param {object} pObject - The object to set the value in
	 * @param {string} pAddress - The address to set the value at
	 * @param {any} pValue - The value to set at the address
	 *
	 * @return {boolean} True if the value was set, false otherwise
	 */
	setValueAtAddress (pObject, pAddress, pValue)
	{
		// Make sure pObject is an object
		if (typeof(pObject) != 'object') return false;
		// Make sure pAddress is a string
		if (typeof(pAddress) != 'string') return false;

		// Use enclosure-aware parser to find the first segment separator
		let tmpAddressPartBeginning = _MockFable.DataFormat.stringGetFirstSegment(pAddress);

		if (tmpAddressPartBeginning.length == pAddress.length)
		{
			// Check if it's a boxed property
			let tmpBracketStartIndex = pAddress.indexOf('[');
			let tmpBracketStopIndex = pAddress.indexOf(']');
			// Boxed elements look like this:
			// 		MyValues[10]
			// 		MyValues['Name']
			// 		MyValues["Age"]
			// 		MyValues[`Cost`]
			//
			// When we are passed SomeObject["Name"] this code below recurses as if it were SomeObject.Name
			//
			// Chained bracket elements look like this:
			// 		MyValues[SubObject]['Property']
			// 		MyValues[0]['Name']
			//
			// When we encounter chained brackets, resolve the first bracket pair and recurse with the remainder.
			//
			// Bracket-at-zero elements look like this (from chained bracket recursion):
			// 		['Property']
			// 		[0]
			//
			// The requirements to detect a boxed element are:
			//    1) The start bracket exists
			if ((tmpBracketStartIndex >= 0)
			//    2) The end bracket has something between them
				&& (tmpBracketStopIndex > tmpBracketStartIndex)
			//    3) There is data
				&& (tmpBracketStopIndex - tmpBracketStartIndex > 1))
			{
				// Check for any remaining address after the closing bracket (chained brackets or dot paths)
				let tmpRemainingAddress = pAddress.substring(tmpBracketStopIndex + 1);
				if (tmpRemainingAddress.length > 0 && tmpRemainingAddress.charAt(0) === '.')
				{
					// Strip leading dot separator (e.g. [SubObject].Property --> Property)
					tmpRemainingAddress = tmpRemainingAddress.substring(1);
				}

				// The "Reference" to the property within it, either an array element or object property
				let tmpBoxedPropertyReference = pAddress.substring(tmpBracketStartIndex+1, tmpBracketStopIndex).trim();
				// Attempt to parse the reference as a number, which will be used as an array element
				let tmpBoxedPropertyNumber = parseInt(tmpBoxedPropertyReference, 10);
				let tmpIndexIsNumeric = !isNaN(tmpBoxedPropertyNumber);

				// When the bracket is at position 0, there is no property name prefix -- we are
				// accessing a property or index directly on the current object.  This happens when
				// chained bracket resolution recurses with a remainder like ['Property'].
				if (tmpBracketStartIndex === 0)
				{
					if (tmpIndexIsNumeric)
					{
						// Array access at position 0: [0], [1], etc.
						if (!Array.isArray(pObject))
						{
							return false;
						}
						while (pObject.length < (tmpBoxedPropertyNumber + 1))
						{
							pObject.push({});
						}
						if (tmpRemainingAddress.length > 0)
						{
							return this.setValueAtAddress(pObject[tmpBoxedPropertyNumber], tmpRemainingAddress, pValue);
						}
						pObject[tmpBoxedPropertyNumber] = pValue;
						return true;
					}
					else
					{
						// Named property access at position 0: ['Property'], ["Name"], etc.
						tmpBoxedPropertyReference = this.cleanWrapCharacters('"', tmpBoxedPropertyReference);
						tmpBoxedPropertyReference = this.cleanWrapCharacters('`', tmpBoxedPropertyReference);
						tmpBoxedPropertyReference = this.cleanWrapCharacters("'", tmpBoxedPropertyReference);

						if (tmpRemainingAddress.length > 0)
						{
							if (!(tmpBoxedPropertyReference in pObject) || typeof(pObject[tmpBoxedPropertyReference]) !== 'object')
							{
								pObject[tmpBoxedPropertyReference] = {};
							}
							return this.setValueAtAddress(pObject[tmpBoxedPropertyReference], tmpRemainingAddress, pValue);
						}
						pObject[tmpBoxedPropertyReference] = pValue;
						return true;
					}
				}

				// The "Name" of the Object contained to the left of the bracket
				let tmpBoxedPropertyName = pAddress.substring(0, tmpBracketStartIndex).trim();

				if (pObject[tmpBoxedPropertyName] == null)
				{
					if (tmpIndexIsNumeric)
					{
						pObject[tmpBoxedPropertyName] = [];
					}
					else
					{
						pObject[tmpBoxedPropertyName] = {};
					}
				}

				// If the subproperty doesn't test as a proper Object, none of the rest of this is possible.
				// This is a rare case where Arrays testing as Objects is useful
				if (typeof(pObject[tmpBoxedPropertyName]) !== 'object')
				{
					return false;
				}

				// Guard: If the referrant is a number and the boxed property is not an array, or vice versa, return undefined.
				//        This seems confusing to me at first read, so explaination:
				//        Is the Boxed Object an Array?  TRUE
				//        And is the Reference inside the boxed Object not a number? TRUE
				//        -->  So when these are in agreement, it's an impossible access state
				if (Array.isArray(pObject[tmpBoxedPropertyName]) == isNaN(tmpBoxedPropertyNumber))
				{
					return false;
				}

				//    4) If the middle part is *only* a number (no single, double or backtick quotes) it is an array element,
				//       otherwise we will try to treat it as a dynamic object property.
				if (isNaN(tmpBoxedPropertyNumber))
				{
					// This isn't a number ... let's treat it as a dynamic object property.
					// We would expect the property to be wrapped in some kind of quotes so strip them
					tmpBoxedPropertyReference = this.cleanWrapCharacters('"', tmpBoxedPropertyReference);
					tmpBoxedPropertyReference = this.cleanWrapCharacters('`', tmpBoxedPropertyReference);
					tmpBoxedPropertyReference = this.cleanWrapCharacters("'", tmpBoxedPropertyReference);

					if (!(tmpBoxedPropertyReference in pObject[tmpBoxedPropertyName]))
					{
						// If the subobject doesn't exist, create it
						pObject[tmpBoxedPropertyName][tmpBoxedPropertyReference] = {};
					}

					// If there is remaining address after this bracket pair, recurse into the resolved subobject
					if (tmpRemainingAddress.length > 0)
					{
						return this.setValueAtAddress(pObject[tmpBoxedPropertyName][tmpBoxedPropertyReference], tmpRemainingAddress, pValue);
					}

					// No remaining address -- set the value directly
					pObject[tmpBoxedPropertyName][tmpBoxedPropertyReference] = pValue;
					return true;
				}
				else
				{
					while(pObject[tmpBoxedPropertyName].length < (tmpBoxedPropertyNumber + 1))
					{
						// If the subobject doesn't exist, create it
						pObject[tmpBoxedPropertyName].push({});
					}

					// If there is remaining address after this bracket pair, recurse into the resolved element
					if (tmpRemainingAddress.length > 0)
					{
						return this.setValueAtAddress(pObject[tmpBoxedPropertyName][tmpBoxedPropertyNumber], tmpRemainingAddress, pValue);
					}

					pObject[tmpBoxedPropertyName][tmpBoxedPropertyNumber] = pValue;
					return true;
				}
			}
			else
			{
				// Now is the time in recursion to set the value in the object
				pObject[pAddress] = pValue;
				return true;
			}
		}
		else
		{
			let tmpSubObjectName = tmpAddressPartBeginning;
			let tmpNewAddress = pAddress.substring(tmpAddressPartBeginning.length+1);

			// Test if the tmpNewAddress is an array or object
			// Check if it's a boxed property
			let tmpBracketStartIndex = tmpSubObjectName.indexOf('[');
			let tmpBracketStopIndex = tmpSubObjectName.indexOf(']');
			// Boxed elements look like this:
			// 		MyValues[42]
			// 		MyValues['Color']
			// 		MyValues["Weight"]
			// 		MyValues[`Diameter`]
			//
			// When we are passed SomeObject["Name"] this code below recurses as if it were SomeObject.Name
			// The requirements to detect a boxed element are:
			//    1) The start bracket exists
			if ((tmpBracketStartIndex >= 0)
			//    2) The end bracket has something between them
				&& (tmpBracketStopIndex > tmpBracketStartIndex)
			//    3) There is data
				&& (tmpBracketStopIndex - tmpBracketStartIndex > 1))
			{
				// When the bracket is at position 0, there is no property name prefix -- we are
				// accessing a property or index directly on the current object.  This happens when
				// chained bracket resolution recurses with a segment like ['Nested'].
				if (tmpBracketStartIndex === 0)
				{
					let tmpBoxedPropertyReference = tmpSubObjectName.substring(1, tmpBracketStopIndex).trim();
					let tmpBoxedPropertyNumber = parseInt(tmpBoxedPropertyReference, 10);

					if (!isNaN(tmpBoxedPropertyNumber))
					{
						// Array access: [0], [1], etc.
						if (!Array.isArray(pObject))
						{
							return false;
						}
						while (pObject.length < (tmpBoxedPropertyNumber + 1))
						{
							pObject.push({});
						}
						return this.setValueAtAddress(pObject[tmpBoxedPropertyNumber], tmpNewAddress, pValue);
					}
					else
					{
						// Named property access: ['Nested'], ["Name"], etc.
						tmpBoxedPropertyReference = this.cleanWrapCharacters('"', tmpBoxedPropertyReference);
						tmpBoxedPropertyReference = this.cleanWrapCharacters('`', tmpBoxedPropertyReference);
						tmpBoxedPropertyReference = this.cleanWrapCharacters("'", tmpBoxedPropertyReference);

						if (!(tmpBoxedPropertyReference in pObject) || typeof(pObject[tmpBoxedPropertyReference]) !== 'object')
						{
							pObject[tmpBoxedPropertyReference] = {};
						}
						return this.setValueAtAddress(pObject[tmpBoxedPropertyReference], tmpNewAddress, pValue);
					}
				}

				let tmpBoxedPropertyName = tmpSubObjectName.substring(0, tmpBracketStartIndex).trim();

				let tmpBoxedPropertyReference = tmpSubObjectName.substring(tmpBracketStartIndex+1, tmpBracketStopIndex).trim();

				let tmpBoxedPropertyNumber = parseInt(tmpBoxedPropertyReference, 10);
				let tmpIndexIsNumeric = !isNaN(tmpBoxedPropertyNumber);

				// Check for chained brackets within this segment (e.g. _Object[SubObject]['Nested'])
				// Any remaining address after the first ] within the segment name needs to be
				// prepended to tmpNewAddress so it is not lost during recursion.
				let tmpSegmentRemainder = tmpSubObjectName.substring(tmpBracketStopIndex + 1);
				if (tmpSegmentRemainder.length > 0)
				{
					// Prepend the remainder to the new address
					// e.g. if segment was _Object[SubObject]['Nested'] and newAddress was Deep,
					//      then combined address becomes ['Nested'].Deep
					if (tmpNewAddress.length > 0)
					{
						tmpNewAddress = tmpSegmentRemainder + '.' + tmpNewAddress;
					}
					else
					{
						tmpNewAddress = tmpSegmentRemainder;
					}
					// Strip leading dot if present
					if (tmpNewAddress.charAt(0) === '.')
					{
						tmpNewAddress = tmpNewAddress.substring(1);
					}
				}

				//if (typeof(pObject[tmpBoxedPropertyName]) !== 'object')
				if (pObject[tmpBoxedPropertyName] == null)
				{
					if (tmpIndexIsNumeric)
					{
						pObject[tmpBoxedPropertyName] = [];
					}
					else
					{
						pObject[tmpBoxedPropertyName] = {};
					}
				}

				// Guard: If the referrant is a number and the boxed property is not an array, or vice versa, return undefined.
				//        This seems confusing to me at first read, so explaination:
				//        Is the Boxed Object an Array?  TRUE
				//        And is the Reference inside the boxed Object not a number? TRUE
				//        -->  So when these are in agreement, it's an impossible access state
				// This could be a failure in the recursion chain because they passed something like this in:
				//    StudentData.Sections.Algebra.Students[1].Tardy
				//       BUT
				//         StudentData.Sections.Algebra.Students is an object, so the [1].Tardy is not possible to access
				// This could be a failure in the recursion chain because they passed something like this in:
				//    StudentData.Sections.Algebra.Students["JaneDoe"].Grade
				//       BUT
				//         StudentData.Sections.Algebra.Students is an array, so the ["JaneDoe"].Grade is not possible to access
				// TODO: Should this be an error or something?  Should we keep a log of failures like this?
				if (Array.isArray(pObject[tmpBoxedPropertyName]) != tmpIndexIsNumeric)
				{
					return false;
				}

				//This is a bracketed value
				//    4) If the middle part is *only* a number (no single, double or backtick quotes) it is an array element,
				//       otherwise we will try to reat it as a dynamic object property.
				if (isNaN(tmpBoxedPropertyNumber))
				{
					// This isn't a number ... let's treat it as a dynanmic object property.
					tmpBoxedPropertyReference = this.cleanWrapCharacters('"', tmpBoxedPropertyReference);
					tmpBoxedPropertyReference = this.cleanWrapCharacters('`', tmpBoxedPropertyReference);
					tmpBoxedPropertyReference = this.cleanWrapCharacters("'", tmpBoxedPropertyReference);

					if (!(tmpBoxedPropertyReference in pObject[tmpBoxedPropertyName]))
					{
						// If the subobject doesn't exist, create it
						pObject[tmpBoxedPropertyName][tmpBoxedPropertyReference] = {};
					}

					// Recurse directly into the subobject
					return this.setValueAtAddress(pObject[tmpBoxedPropertyName][tmpBoxedPropertyReference], tmpNewAddress, pValue);
				}
				else
				{
					while(pObject[tmpBoxedPropertyName].length < (tmpBoxedPropertyNumber + 1))
					{
						// If the subobject doesn't exist, create it
						pObject[tmpBoxedPropertyName].push({});
					}

					// We parsed a valid number out of the boxed property name, so recurse into the array
					return this.setValueAtAddress(pObject[tmpBoxedPropertyName][tmpBoxedPropertyNumber], tmpNewAddress, pValue);
				}
			}

			// If there is an object property already named for the sub object, but it isn't an object
			// then the system can't set the value in there.  Error and abort!
			if ((tmpSubObjectName in pObject) && typeof(pObject[tmpSubObjectName]) !== 'object')
			{
				if (!('__ERROR' in pObject))
					pObject['__ERROR'] = {};
				// Put it in an error object so data isn't lost
				pObject['__ERROR'][pAddress] = pValue;
				return false;
			}
			else if (tmpSubObjectName in pObject)
			{
				// If there is already a subobject pass that to the recursive thingy
				return this.setValueAtAddress(pObject[tmpSubObjectName], tmpNewAddress, pValue);
			}
			else
			{
				// Create a subobject and then pass that
				pObject[tmpSubObjectName] = {};
				return this.setValueAtAddress(pObject[tmpSubObjectName], tmpNewAddress, pValue);
			}
		}
	}
};

module.exports = ManyfestObjectAddressSetValue;

},{"./Manyfest-CleanWrapCharacters.js":116,"./Manyfest-LogToConsole.js":118,"./Manyfest-ObjectAddress-Parser.js":122}],124:[function(require,module,exports){
/**
* @author <steven@velozo.com>
*/
let libSimpleLog = require('./Manyfest-LogToConsole.js');

/**
* Object Address Generation
*
* Automagically generate addresses and properties based on a passed-in object,
* to be used for easy creation of schemas.  Meant to simplify the lives of
* developers wanting to create schemas without typing a bunch of stuff.
*
* IMPORTANT NOTE: This code is intentionally more verbose than necessary, to
*                 be extremely clear what is going on in the recursion for
*                 each of the three address resolution functions.
*
*                 Although there is some opportunity to repeat ourselves a
*                 bit less in this codebase (e.g. with detection of arrays
*                 versus objects versus direct properties), it can make
*                 debugging.. challenging.  The minified version of the code
*                 optimizes out almost anything repeated in here.  So please
*                 be kind and rewind... meaning please keep the codebase less
*                 terse and more verbose so humans can comprehend it.
*
*
* @class ManyfestObjectAddressGeneration
*/
class ManyfestObjectAddressGeneration
{
	/**
	 * @param {function} [pInfoLog] - (optional) A logging function for info messages
	 * @param {function} [pErrorLog] - (optional) A logging function for error messages
	 */
	constructor(pInfoLog, pErrorLog)
	{
		// Wire in logging
		this.logInfo = (typeof(pInfoLog) == 'function') ? pInfoLog : libSimpleLog;
		this.logError = (typeof(pErrorLog) == 'function') ? pErrorLog : libSimpleLog;
	}

	/**
	 * generateAddressses
	 *
	 * This flattens an object into a set of key:value pairs for *EVERY SINGLE
	 * POSSIBLE ADDRESS* in the object.  It can get ... really insane really
	 * quickly.  This is not meant to be used directly to generate schemas, but
	 * instead as a starting point for scripts or UIs.
	 *
	 * This will return a mega set of key:value pairs with all possible schema
	 * permutations and default values (when not an object) and everything else.
	 *
	 * @param {any} pObject - The object to generate addresses for
	 * @param {string} [pBaseAddress] - (optional) The base address to start from
	 * @param {object} [pSchema] - (optional) The schema object to append to
	 *
	 * @return {object} The generated schema object
	 */
	generateAddressses (pObject, pBaseAddress, pSchema)
	{
		let tmpBaseAddress = (typeof(pBaseAddress) == 'string') ? pBaseAddress : '';
		let tmpSchema = (typeof(pSchema) == 'object') ? pSchema : {};

		let tmpObjectType = typeof(pObject);

		let tmpSchemaObjectEntry = (
			{
				Address: tmpBaseAddress,
				Hash: tmpBaseAddress,
				Name: tmpBaseAddress,
				// This is so scripts and UI controls can force a developer to opt-in.
				InSchema: false
			}
		)

		if ((tmpObjectType == 'object') && (pObject == null))
		{
			tmpObjectType = 'undefined';
		}

		switch(tmpObjectType)
		{
			case 'string':
				tmpSchemaObjectEntry.DataType = 'String';
				tmpSchemaObjectEntry.Default = pObject;
				tmpSchema[tmpBaseAddress] = tmpSchemaObjectEntry;
				break;
			case 'number':
			case 'bigint':
				tmpSchemaObjectEntry.DataType = 'Number';
				tmpSchemaObjectEntry.Default = pObject;
				tmpSchema[tmpBaseAddress] = tmpSchemaObjectEntry;
				break;
			case 'undefined':
				tmpSchemaObjectEntry.DataType = 'Any';
				tmpSchemaObjectEntry.Default = pObject;
				tmpSchema[tmpBaseAddress] = tmpSchemaObjectEntry;
				break;
			case 'object':
				if (Array.isArray(pObject))
				{
					tmpSchemaObjectEntry.DataType = 'Array';
					if (tmpBaseAddress != '')
					{
						tmpSchema[tmpBaseAddress] = tmpSchemaObjectEntry;
					}

					for (let i = 0; i < pObject.length; i++)
					{
						this.generateAddressses(pObject[i], `${tmpBaseAddress}[${i}]`, tmpSchema);
					}
				}
				else
				{
					tmpSchemaObjectEntry.DataType = 'Object';
					if (tmpBaseAddress != '')
					{
						tmpSchema[tmpBaseAddress] = tmpSchemaObjectEntry;
						tmpBaseAddress += '.';
					}

					let tmpObjectProperties = Object.keys(pObject);

					for (let i = 0; i < tmpObjectProperties.length; i++)
					{
						this.generateAddressses(pObject[tmpObjectProperties[i]], `${tmpBaseAddress}${tmpObjectProperties[i]}`, tmpSchema);
					}
				}
				break;
			case 'symbol':
			case 'function':
				// Symbols and functions neither recurse nor get added to the schema
				break;
		}

		return tmpSchema;
	}
};

module.exports = ManyfestObjectAddressGeneration;

},{"./Manyfest-LogToConsole.js":118}],125:[function(require,module,exports){
// Given a string, parse out any conditional expressions and set whether or not to keep the record.
//
// For instance:
// 		'files[]<<~?format,==,Thumbnail?~>>'
//      'files[]<<~?format,==,Metadata?~>>'
//      'files[]<<~?size,>,4000?~>>'
//
// The wrapping parts are the <<~? and ?~>> megabrackets.
//
// The function does not need to alter the string -- just check the conditionals within.

// TODO: Consider making this an es6 class

// Let's use indexOf since it is apparently the fastest.
const _ConditionalStanzaStart = '<<~?';
const _ConditionalStanzaStartLength = _ConditionalStanzaStart.length;
const _ConditionalStanzaEnd = '?~>>';
const _ConditionalStanzaEndLength = _ConditionalStanzaEnd.length;

// Ugh dependency injection.  Can't wait to make these all fable services.
//let libObjectAddressCheckAddressExists = new (require('./Manyfest-ObjectAddress-CheckAddressExists.js'))();

// Test the condition of a value in a record
const testCondition = (pManyfest, pRecord, pSearchAddress, pSearchComparator, pValue) =>
{
	switch(pSearchComparator)
	{
		case 'TRUE':
			return (pManyfest.getValueAtAddress(pRecord, pSearchAddress) === true);
		case 'FALSE':
			return (pManyfest.getValueAtAddress(pRecord, pSearchAddress) === false);
		case 'LNGT':
		case 'LENGTH_GREATER_THAN':
			switch(typeof(pManyfest.getValueAtAddress(pRecord, pSearchAddress)))
			{
				case 'string':
					return (pManyfest.getValueAtAddress(pRecord, pSearchAddress).length > pValue);
				case 'object':
					return (pManyfest.getValueAtAddress(pRecord, pSearchAddress).length > pValue);
				default:
					return false;
					break;
			}
			break;
		case 'LNLT':
		case 'LENGTH_LESS_THAN':
			switch(typeof(pManyfest.getValueAtAddress(pRecord, pSearchAddress)))
			{
				case 'string':
					return (pManyfest.getValueAtAddress(pRecord, pSearchAddress).length < pValue);
				case 'object':
					return (pManyfest.getValueAtAddress(pRecord, pSearchAddress).length < pValue);
				default:
					return false;
					break;
			}
			break;
		// TODO: Welcome to dependency hell.  This fixes itself when we move to fable services.
		// case 'EX':
		// case 'EXISTS':
		// 	return libObjectAddressCheckAddressExists.checkAddressExists(pRecord, pSearchAddress);
		// 	break;
		// case 'DNEX':
		// case 'DOES_NOT_EXIST':
		// 	return !libObjectAddressCheckAddressExists.checkAddressExists(pRecord, pSearchAddress);
		// 	break;
		case '!=':
			return (pManyfest.getValueAtAddress(pRecord, pSearchAddress) != pValue);
		case '<':
			return (pManyfest.getValueAtAddress(pRecord, pSearchAddress) < pValue);
		case '>':
			return (pManyfest.getValueAtAddress(pRecord, pSearchAddress) > pValue);
		case '<=':
			return (pManyfest.getValueAtAddress(pRecord, pSearchAddress) <= pValue);
		case '>=':
			return (pManyfest.getValueAtAddress(pRecord, pSearchAddress) >= pValue);
		case '===':
			return (pManyfest.getValueAtAddress(pRecord, pSearchAddress) === pValue);
		case '==':
		default:
			return (pManyfest.getValueAtAddress(pRecord, pSearchAddress) == pValue);
	}
};

const parseConditionals = (pManyfest, pAddress, pRecord) =>
{
	let tmpKeepRecord = true;

	/*
		Algorithm is simple:

		1.  Enuerate start points
		2.  Find stop points within each start point
		3. Check the conditional
	*/
	let tmpStartIndex = pAddress.indexOf(_ConditionalStanzaStart);

	while (tmpStartIndex != -1)
	{
		let tmpStopIndex = pAddress.indexOf(_ConditionalStanzaEnd, tmpStartIndex+_ConditionalStanzaStartLength);

		if (tmpStopIndex != -1)
		{
			let tmpMagicComparisonPatternSet = pAddress.substring(tmpStartIndex+_ConditionalStanzaStartLength, tmpStopIndex).split(',');

			// The address to search for
			let tmpSearchAddress = tmpMagicComparisonPatternSet[0];

			// The copmparison expression (EXISTS as default)
			let tmpSearchComparator = 'EXISTS';
			if (tmpMagicComparisonPatternSet.length > 1)
			{
				tmpSearchComparator = tmpMagicComparisonPatternSet[1];
			}

			// The value to search for
			let tmpSearchValue = false;
			if (tmpMagicComparisonPatternSet.length > 2)
			{
				tmpSearchValue = tmpMagicComparisonPatternSet[2];
			}

			// Process the piece
			tmpKeepRecord = tmpKeepRecord && testCondition(pManyfest, pRecord, tmpSearchAddress, tmpSearchComparator, tmpSearchValue);
			tmpStartIndex = pAddress.indexOf(_ConditionalStanzaStart, tmpStopIndex+_ConditionalStanzaEndLength);
		}
		else
		{
			tmpStartIndex = -1;
		}

	}

	return tmpKeepRecord;
}

module.exports = parseConditionals;

},{}],126:[function(require,module,exports){
/**
* @author <steven@velozo.com>
*/
let libSimpleLog = require('./Manyfest-LogToConsole.js');

/**
* Schema Manipulation Functions
*
* @class ManyfestSchemaManipulation
*/
class ManyfestSchemaManipulation
{
	/**
	 * @param {function} [pInfoLog] - (optional) A logging function for info messages
	 * @param {function} [pErrorLog] - (optional) A logging function for error messages
	 */
	constructor(pInfoLog, pErrorLog)
	{
		// Wire in logging
		this.logInfo = (typeof(pInfoLog) === 'function') ? pInfoLog : libSimpleLog;
		this.logError = (typeof(pErrorLog) === 'function') ? pErrorLog : libSimpleLog;
	}

	/**
     * This translates the default address mappings to something different.
     *
     * For instance you can pass in manyfest schema descriptor object:
     * 	{
	 *	  "Address.Of.a": { "Hash": "a", "Type": "Number" },
	 *	  "Address.Of.b": { "Hash": "b", "Type": "Number" }
	 *  }
     *
     *
     * And then an address mapping (basically a Hash->Address map)
     *  {
     *    "a": "New.Address.Of.a",
     *    "b": "New.Address.Of.b"
     *  }
     *
     * NOTE: This mutates the schema object permanently, altering the base hash.
     *       If there is a collision with an existing address, it can lead to overwrites.
     * TODO: Discuss what should happen on collisions.
	 *
	 * @param {object} pManyfestSchemaDescriptors - The manyfest schema descriptors to resolve address mappings for
	 * @param {object} pAddressMapping - The address mapping object to use for remapping
	 *
	 * @return {boolean} True if successful, false if there was an error
	 */
	resolveAddressMappings(pManyfestSchemaDescriptors, pAddressMapping)
	{
		if (typeof(pManyfestSchemaDescriptors) != 'object')
		{
			this.logError(`Attempted to resolve address mapping but the descriptor was not an object.`);
			return false;
		}

		if (typeof(pAddressMapping) != 'object')
		{
			// No mappings were passed in
			return true;
		}

		// Get the arrays of both the schema definition and the hash mapping
		let tmpManyfestAddresses = Object.keys(pManyfestSchemaDescriptors);
		let tmpHashMapping = {};
		tmpManyfestAddresses.forEach(
			(pAddress) =>
			{
				if ('Hash' in pManyfestSchemaDescriptors[pAddress])
				{
					tmpHashMapping[pManyfestSchemaDescriptors[pAddress].Hash] = pAddress;
				}
			});

		let tmpAddressMappingSet = Object.keys(pAddressMapping);

		tmpAddressMappingSet.forEach(
			(pInputAddress) =>
			{
				let tmpNewDescriptorAddress = pAddressMapping[pInputAddress];
				let tmpOldDescriptorAddress = null;
				let tmpDescriptor;

				// See if there is a matching descriptor either by Address directly or Hash
				if (pInputAddress in pManyfestSchemaDescriptors)
				{
					tmpOldDescriptorAddress = pInputAddress;
				}
				else if (pInputAddress in tmpHashMapping)
				{
					tmpOldDescriptorAddress = tmpHashMapping[pInputAddress];
				}

				// If there was a matching descriptor in the manifest, store it in the temporary descriptor
				if (tmpOldDescriptorAddress)
				{
					tmpDescriptor = pManyfestSchemaDescriptors[tmpOldDescriptorAddress];
					delete pManyfestSchemaDescriptors[tmpOldDescriptorAddress];
				}
				else
				{
					// Create a new descriptor!  Map it to the input address.
					tmpDescriptor = { Hash:pInputAddress };
				}

				// Now re-add the descriptor to the manyfest schema
				pManyfestSchemaDescriptors[tmpNewDescriptorAddress] = tmpDescriptor;
			});

		return true;
	}

	/**
	 * @param {object} pManyfestSchemaDescriptors - The manyfest schema descriptors to resolve address mappings for
	 * @param {object} pAddressMapping - The address mapping object to use for remapping
	 *
	 * @return {object} A new object containing the remapped schema descriptors
	 */
	safeResolveAddressMappings(pManyfestSchemaDescriptors, pAddressMapping)
	{
		// This returns the descriptors as a new object, safely remapping without mutating the original schema Descriptors
		let tmpManyfestSchemaDescriptors = JSON.parse(JSON.stringify(pManyfestSchemaDescriptors));
		this.resolveAddressMappings(tmpManyfestSchemaDescriptors, pAddressMapping);
		return tmpManyfestSchemaDescriptors;
	}

	/**
	 * @param {object} pManyfestSchemaDescriptorsDestination - The destination manyfest schema descriptors
	 * @param {object} pManyfestSchemaDescriptorsSource - The source manyfest schema descriptors
	 *
	 * @return {object} A new object containing the merged schema descriptors
	 */
	mergeAddressMappings(pManyfestSchemaDescriptorsDestination, pManyfestSchemaDescriptorsSource)
	{
		if ((typeof(pManyfestSchemaDescriptorsSource) != 'object') || (typeof(pManyfestSchemaDescriptorsDestination) != 'object'))
		{
			this.logError(`Attempted to merge two schema descriptors but both were not objects.`);
			return false;
		}

		let tmpSource = JSON.parse(JSON.stringify(pManyfestSchemaDescriptorsSource));
		let tmpNewManyfestSchemaDescriptors = JSON.parse(JSON.stringify(pManyfestSchemaDescriptorsDestination));

		// The first passed-in set of descriptors takes precedence.
		let tmpDescriptorAddresses = Object.keys(tmpSource);

		tmpDescriptorAddresses.forEach(
			(pDescriptorAddress) =>
			{
				if (!(pDescriptorAddress in tmpNewManyfestSchemaDescriptors))
				{
					tmpNewManyfestSchemaDescriptors[pDescriptorAddress] = tmpSource[pDescriptorAddress];
				}
			});

		return tmpNewManyfestSchemaDescriptors;
	}
}

module.exports = ManyfestSchemaManipulation;

},{"./Manyfest-LogToConsole.js":118}],127:[function(require,module,exports){
/**
* @author <steven@velozo.com>
*/
const libFableServiceProviderBase = require('fable-serviceproviderbase');

let libSimpleLog = require('./Manyfest-LogToConsole.js');

let libHashTranslation = require('./Manyfest-HashTranslation.js');
let libObjectAddressCheckAddressExists = require('./Manyfest-ObjectAddress-CheckAddressExists.js');
let libObjectAddressGetValue = require('./Manyfest-ObjectAddress-GetValue.js');
let libObjectAddressSetValue = require('./Manyfest-ObjectAddress-SetValue.js');
let libObjectAddressDeleteValue = require('./Manyfest-ObjectAddress-DeleteValue.js');
let libObjectAddressGeneration = require('./Manyfest-ObjectAddressGeneration.js');
let libSchemaManipulation = require('./Manyfest-SchemaManipulation.js');

const _DefaultConfiguration = { Scope:'DEFAULT', Descriptors: {} }

/**
 * @typedef {{
 *   Hash?: string,
 *   Name?: string,
 *   DataType?: string,
 *   Required?: boolean,
 *   Address?: string,
 *   Description?: string,
 *   [key: string]: any,
 * }} ManifestDescriptor
 */

/**
* Manyfest object address-based descriptions and manipulations.
*
* @class Manyfest
*/
class Manyfest extends libFableServiceProviderBase
{
	constructor(pFable, pManifest, pServiceHash)
	{
		if (pFable === undefined)
		{
			super({});
		}
		else
		{
			super(pFable, pManifest, pServiceHash);
		}

		/** @type {import('fable')} */
		this.fable;
		/** @type {Record<string, any>} */
		this.options;
		/** @type {string} */
		this.Hash;
		/** @type {string} */
		this.UUID;

        this.serviceType = 'Manifest';

		// Wire in logging
		this.logInfo = libSimpleLog;
		this.logError = libSimpleLog;

		// Create an object address resolver and map in the functions
		this.objectAddressCheckAddressExists = new libObjectAddressCheckAddressExists(this.logInfo, this.logError);
		this.objectAddressGetValue = new libObjectAddressGetValue(this.logInfo, this.logError);
		this.objectAddressSetValue = new libObjectAddressSetValue(this.logInfo, this.logError);
		this.objectAddressDeleteValue = new libObjectAddressDeleteValue(this.logInfo, this.logError);

		if (!('defaultValues' in this.options))
		{
			this.options.defaultValues = (
				{
					"String": "",
					"Number": 0,
					"Float": 0.0,
					"Integer": 0,
					"PreciseNumber": "0.0",
					"Boolean": false,
					"Binary": 0,
					"DateTime": 0,
					"Array": [],
					"Object": {},
					"Null": null
				});
		}
		if (!('strict' in this.options))
		{
			this.options.strict = false;
		}

		/** @type {string} */
		this.scope = undefined;
		/** @type {Array<string>} */
		this.elementAddresses = undefined;
		/** @type {Record<string, string>} */
		this.elementHashes = undefined;
		/** @type {Record<string, ManifestDescriptor>} */
		this.elementDescriptors = undefined;

		this.reset();

		if (typeof(this.options) === 'object')
		{
			this.loadManifest(this.options);
		}

		this.schemaManipulations = new libSchemaManipulation(this.logInfo, this.logError);
		this.objectAddressGeneration = new libObjectAddressGeneration(this.logInfo, this.logError);

		this.hashTranslations = new libHashTranslation(this.logInfo, this.logError);

		this.numberRegex = /^[+-]?(\d+(\.\d*)?|\.\d+)([eE][+-]?\d+)?$/;
	}

	/*************************************************************************
	 * Schema Manifest Loading, Reading, Manipulation and Serialization Functions
	 */

	// Reset critical manifest properties
	reset()
	{
		this.scope = 'DEFAULT';
		this.elementAddresses = [];
		this.elementHashes = {};
		this.elementDescriptors = {};
	}

	clone()
	{
		// Make a copy of the options in-place
		let tmpNewOptions = JSON.parse(JSON.stringify(this.options));

		let tmpNewManyfest = new Manyfest(this.fable, tmpNewOptions, this.Hash);
		tmpNewManyfest.logInfo = this.logInfo;
		tmpNewManyfest.logError = this.logError;
		//FIXME: mostly written by co-pilot
		const { Scope, Descriptors, HashTranslations } = this.getManifest();
		tmpNewManyfest.scope = Scope;
		tmpNewManyfest.elementDescriptors = Descriptors;
		tmpNewManyfest.elementAddresses = Object.keys(Descriptors);
		// Rebuild the element hashes
		for (let i = 0; i < tmpNewManyfest.elementAddresses.length; i++)
		{
			let tmpAddress = tmpNewManyfest.elementAddresses[i];
			let tmpDescriptor = tmpNewManyfest.elementDescriptors[tmpAddress];
			tmpNewManyfest.elementHashes[tmpAddress] = tmpAddress;
			if ('Hash' in tmpDescriptor)
			{
				tmpNewManyfest.elementHashes[tmpDescriptor.Hash] = tmpAddress;
			}
		}

		// Import the hash translations
		tmpNewManyfest.hashTranslations.addTranslation(this.hashTranslations.translationTable);

		return tmpNewManyfest;
	}

	// Deserialize a Manifest from a string
	/**
	 * @param {string} pManifestString - The manifest string to deserialize
	 *
	 * @return {Manyfest} The deserialized manifest
	 */
	deserialize(pManifestString)
	{
		// TODO: Add guards for bad manifest string
		this.loadManifest(JSON.parse(pManifestString));
		return this;
	}

	// Load a manifest from an object
	loadManifest(pManifest)
	{
		if (typeof(pManifest) !== 'object')
		{
			this.logError(`(${this.scope}) Error loading manifest; expecting an object but parameter was type ${typeof(pManifest)}.`);
		}

		let tmpManifest = (typeof(pManifest) == 'object') ? pManifest : {};

		let tmpDescriptorKeys = Object.keys(_DefaultConfiguration);

		for (let i = 0; i < tmpDescriptorKeys.length; i++)
		{
			if (!(tmpDescriptorKeys[i] in tmpManifest))
			{
				tmpManifest[tmpDescriptorKeys[i]] = JSON.parse(JSON.stringify(_DefaultConfiguration[tmpDescriptorKeys[i]]));
			}
		}

		if ('Scope' in tmpManifest)
		{
			if (typeof(tmpManifest.Scope) === 'string')
			{
				this.scope = tmpManifest.Scope;
			}
			else
			{
				this.logError(`(${this.scope}) Error loading scope from manifest; expecting a string but property was type ${typeof(tmpManifest.Scope)}.`, tmpManifest);
			}
		}
		else
		{
			this.logError(`(${this.scope}) Error loading scope from manifest object.  Property "Scope" does not exist in the root of the object.`, tmpManifest);
		}

		if ('Descriptors' in tmpManifest)
		{
			if (typeof(tmpManifest.Descriptors) === 'object')
			{
				let tmpDescriptionAddresses = Object.keys(tmpManifest.Descriptors);
				for (let i = 0; i < tmpDescriptionAddresses.length; i++)
				{
					this.addDescriptor(tmpDescriptionAddresses[i], tmpManifest.Descriptors[tmpDescriptionAddresses[i]]);
				}
			}
			else
			{
				this.logError(`(${this.scope}) Error loading description object from manifest object.  Expecting an object in 'Manifest.Descriptors' but the property was type ${typeof(tmpManifest.Descriptors)}.`, tmpManifest);
			}
		}
		else
		{
			this.logError(`(${this.scope}) Error loading object description from manifest object.  Property "Descriptors" does not exist in the root of the Manifest object.`, tmpManifest);
		}

		if ('HashTranslations' in tmpManifest)
		{
			if (typeof(tmpManifest.HashTranslations) === 'object')
			{
				// HashTranslations is serialized as a plain object of source:target pairs
				this.hashTranslations.addTranslation(tmpManifest.HashTranslations);
			}
		}
	}

	/**
	 * Serialize the Manifest to a string
	 *
	 * @return {string} - The serialized manifest
	 */
	serialize()
	{
		return JSON.stringify(this.getManifest());
	}

	/**
	 * @return {{ Scope: string, Descriptors: Record<string, ManifestDescriptor>, HashTranslations: Record<string, string> }} - A copy of the manifest state.
	 */
	getManifest()
	{
		return (
			{
				Scope: this.scope,
				Descriptors: JSON.parse(JSON.stringify(this.elementDescriptors)),
				HashTranslations: JSON.parse(JSON.stringify(this.hashTranslations.translationTable))
			});
	}

	/**
	 * Add a descriptor to the manifest
	 *
	 * @param {string} pAddress - The address of the element to add the descriptor for.
	 * @param {ManifestDescriptor} pDescriptor - The descriptor object to add.
	 */
	addDescriptor(pAddress, pDescriptor)
	{
		if (typeof(pDescriptor) === 'object')
		{
			// Add the Address into the Descriptor if it doesn't exist:
			if (!('Address' in pDescriptor))
			{
				pDescriptor.Address = pAddress;
			}

			if (!(pAddress in this.elementDescriptors))
			{
				this.elementAddresses.push(pAddress);
			}

			// Add the element descriptor to the schema
			this.elementDescriptors[pAddress] = pDescriptor;

			// Always add the address as a hash
			this.elementHashes[pAddress] = pAddress;

			if ('Hash' in pDescriptor)
			{
				// TODO: Check if this is a good idea or not..
				//       Collisions are bound to happen with both representations of the address/hash in here and developers being able to create their own hashes.
				this.elementHashes[pDescriptor.Hash] = pAddress;
			}
			else
			{
				pDescriptor.Hash = pAddress;
			}

			return true;
		}
		else
		{
			this.logError(`(${this.scope}) Error loading object descriptor for address '${pAddress}' from manifest object.  Expecting an object but property was type ${typeof(pDescriptor)}.`);
			return false;
		}
	}

	/**
	 * @param {string} pHash - The hash of the address to resolve.
	 *
	 * @return {ManifestDescriptor} The descriptor for the address
	 */
	getDescriptorByHash(pHash)
	{
		return this.getDescriptor(this.resolveHashAddress(pHash));
	}

	/**
	 * @param {string} pAddress - The address of the element to get the descriptor for.
	 *
	 * @return {ManifestDescriptor} The descriptor for the address
	 */
	getDescriptor(pAddress)
	{
		return this.elementDescriptors[pAddress];
	}

	/**
	 * execute an action function for each descriptor
	 * @param {(d: ManifestDescriptor) => void} fAction - The action function to execute for each descriptor.
	 */
	eachDescriptor(fAction)
	{
        let tmpDescriptorAddresses = Object.keys(this.elementDescriptors);
        for (let i = 0; i < tmpDescriptorAddresses.length; i++)
        {
            fAction(this.elementDescriptors[tmpDescriptorAddresses[i]]);
        }

	}

	/*************************************************************************
	 * Beginning of Object Manipulation (read & write) Functions
	 */
	// Check if an element exists by its hash
	checkAddressExistsByHash (pObject, pHash)
	{
		return this.checkAddressExists(pObject,this.resolveHashAddress(pHash));
	}

	// Check if an element exists at an address
	checkAddressExists (pObject, pAddress)
	{
		return this.objectAddressCheckAddressExists.checkAddressExists(pObject, pAddress);
	}

	/**
	 * Check what role a string plays in this manifest -- whether it is a Hash, an Address, both or neither.
	 *
	 * @param {string} pString - The string to check.
	 *
	 * @return {{ IsHash: boolean, IsAddress: boolean, ResolvedAddress: string|undefined }} The role of the string.
	 */
	checkStringRole(pString)
	{
		if (typeof(pString) !== 'string' || pString.length === 0)
		{
			return { IsHash: false, IsAddress: false, ResolvedAddress: undefined };
		}

		let tmpIsAddress = (pString in this.elementDescriptors);
		let tmpIsHash = (pString in this.elementHashes);
		let tmpResolvedAddress = tmpIsHash ? this.elementHashes[pString] : undefined;

		return (
			{
				IsHash: tmpIsHash,
				IsAddress: tmpIsAddress,
				ResolvedAddress: tmpResolvedAddress
			});
	}

	// Turn a hash into an address, factoring in the translation table.
	resolveHashAddress(pHash)
	{
		let tmpAddress = undefined;

		let tmpInElementHashTable = (pHash in this.elementHashes);
		let tmpInTranslationTable = (pHash in this.hashTranslations.translationTable);

		// The most straightforward: the hash exists, no translations.
		if (tmpInElementHashTable && !tmpInTranslationTable)
		{
			tmpAddress = this.elementHashes[pHash];
		}
		// There is a translation from one hash to another, and, the elementHashes contains the pointer end
		else if (tmpInTranslationTable && (this.hashTranslations.translate(pHash) in this.elementHashes))
		{
			tmpAddress = this.elementHashes[this.hashTranslations.translate(pHash)];
		}
		// Use the level of indirection only in the Translation Table
		else if (tmpInTranslationTable)
		{
			tmpAddress = this.hashTranslations.translate(pHash);
		}
		// Just treat the hash as an address.
		// TODO: Discuss this ... it is magic but controversial
		else
		{
			tmpAddress = pHash;
		}

		return tmpAddress;
	}

	// Get the value of an element by its hash
	getValueByHash (pObject, pHash)
	{
		let tmpValue = this.getValueAtAddress(pObject, this.resolveHashAddress(pHash));

		if (typeof(tmpValue) == 'undefined')
		{
			// Try to get a default if it exists
			tmpValue = this.getDefaultValue(this.getDescriptorByHash(pHash));
		}

		return tmpValue;
	}

	lintAddress(pAddress)
	{
		// Guard against non-string input
		if (typeof(pAddress) != 'string')
		{
			return '';
		}
		let tmpLintedAddress = pAddress.trim();
		// Check for a single trailing . (but not a ..) at the end of the address and remove it.
		// We must not strip '..' because that is back-navigation syntax.
		if (tmpLintedAddress.endsWith('.') && !tmpLintedAddress.endsWith('..'))
		{
			tmpLintedAddress = tmpLintedAddress.slice(0, -1);
		}

		return tmpLintedAddress;
	}

	// Get the value of an element at an address
	getValueAtAddress (pObject, pAddress)
	{
		let tmpLintedAddress = this.lintAddress(pAddress);
		if (tmpLintedAddress == '')
		{
			this.logError(`(${this.scope}) Error getting value at address; address is an empty string.`, pObject);
			return undefined;
		}
		let tmpValue = this.objectAddressGetValue.getValueAtAddress(pObject, tmpLintedAddress);

		if (typeof(tmpValue) == 'undefined')
		{
			// Try to get a default if it exists
			tmpValue = this.getDefaultValue(this.getDescriptor(tmpLintedAddress));
		}

		return tmpValue;
	}

	// Set the value of an element by its hash
	setValueByHash(pObject, pHash, pValue)
	{
		return this.setValueAtAddress(pObject, this.resolveHashAddress(pHash), pValue);
	}

	// Set the value of an element at an address
	setValueAtAddress (pObject, pAddress, pValue)
	{
		let tmpLintedAddress = this.lintAddress(pAddress);
		return this.objectAddressSetValue.setValueAtAddress(pObject, tmpLintedAddress, pValue);
	}

	// Delete the value of an element by its hash
	deleteValueByHash(pObject, pHash)
	{
		return this.deleteValueAtAddress(pObject, this.resolveHashAddress(pHash));
	}

	// Delete the value of an element at an address
	deleteValueAtAddress (pObject, pAddress)
	{
		let tmpLintedAddress = this.lintAddress(pAddress);
		return this.objectAddressDeleteValue.deleteValueAtAddress(pObject, tmpLintedAddress);
	}

	// Validate the consistency of an object against the schema
	validate(pObject)
	{
		let tmpValidationData =
		{
			Error: null,
			Errors: [],
			MissingElements:[]
		};

		if (typeof(pObject) !== 'object')
		{
			tmpValidationData.Error = true;
			tmpValidationData.Errors.push(`Expected passed in object to be type object but was passed in ${typeof(pObject)}`);
		}

		let addValidationError = (pAddress, pErrorMessage) =>
		{
			tmpValidationData.Error = true;
			tmpValidationData.Errors.push(`Element at address "${pAddress}" ${pErrorMessage}.`);
		};

		// Now enumerate through the values and check for anomalies based on the schema
		for (let i = 0; i < this.elementAddresses.length; i++)
		{
			let tmpDescriptor = this.getDescriptor(this.elementAddresses[i]);
			let tmpValueExists = this.checkAddressExists(pObject, tmpDescriptor.Address);
			let tmpValue = this.getValueAtAddress(pObject, tmpDescriptor.Address);

			if ((typeof(tmpValue) == 'undefined') || !tmpValueExists)
			{
				// This will technically mean that `Object.Some.Value = undefined` will end up showing as "missing"
				// TODO: Do we want to do a different message based on if the property exists but is undefined?
				tmpValidationData.MissingElements.push(tmpDescriptor.Address);
				if (tmpDescriptor.Required || this.options.strict)
				{
					addValidationError(tmpDescriptor.Address, 'is flagged REQUIRED but is not set in the object');
				}
			}

			// Now see if there is a data type specified for this element
			if (tmpDescriptor.DataType)
			{
				let tmpElementType = typeof(tmpValue);
				switch(tmpDescriptor.DataType.toString().trim().toLowerCase())
				{
					case 'string':
						if (tmpElementType != 'string')
						{
							addValidationError(tmpDescriptor.Address, `has a DataType ${tmpDescriptor.DataType} but is of the type ${tmpElementType}`);
						}
						break;

					case "precisenumber":
						if (tmpElementType != 'string')
						{
							addValidationError(tmpDescriptor.Address, `has a DataType ${tmpDescriptor.DataType} but is of the type ${tmpElementType}`);
						}
						else if (!this.numberRegex.test(tmpValue))
						{
							addValidationError(tmpDescriptor.Address, `has a DataType ${tmpDescriptor.DataType} but is not a valid number`);
						}
						break;

					case 'number':
						if (tmpElementType != 'number')
						{
							addValidationError(tmpDescriptor.Address, `has a DataType ${tmpDescriptor.DataType} but is of the type ${tmpElementType}`);
						}
						break;

					case 'integer':
						if (tmpElementType != 'number')
						{
							addValidationError(tmpDescriptor.Address, `has a DataType ${tmpDescriptor.DataType} but is of the type ${tmpElementType}`);
						}
						else
						{
							let tmpValueString = tmpValue.toString();
							if (tmpValueString.indexOf('.') > -1)
							{
								// TODO: Is this an error?
								addValidationError(tmpDescriptor.Address, `has a DataType ${tmpDescriptor.DataType} but has a decimal point in the number.`);
							}
						}
						break;

					case 'float':
						if (tmpElementType != 'number')
						{
							addValidationError(tmpDescriptor.Address, `has a DataType ${tmpDescriptor.DataType} but is of the type ${tmpElementType}`);
						}
						break;

					case 'boolean':
						if (tmpElementType != 'boolean')
						{
							addValidationError(tmpDescriptor.Address, `has a DataType ${tmpDescriptor.DataType} but is of the type ${tmpElementType}`);
						}
						break;

					case 'datetime':
						let tmpValueDate = new Date(tmpValue);
						if (tmpValueDate.toString() == 'Invalid Date')
						{
							addValidationError(tmpDescriptor.Address, `has a DataType ${tmpDescriptor.DataType} but is not parsable as a Date by Javascript`);
						}
						break;

					default:
						// Check if this is a string, in the default case
						// Note this is only when a DataType is specified and it is an unrecognized data type.
						if (tmpElementType != 'string')
						{
							addValidationError(tmpDescriptor.Address, `has a DataType ${tmpDescriptor.DataType} (which auto-converted to String because it was unrecognized) but is of the type ${tmpElementType}`);
						}
						break;
				}
			}
		}

		return tmpValidationData;
	}

	/**
	 * Returns a default value, or, the default value for the data type (which is overridable with configuration)
	 *
	 * @param {ManifestDescriptor} pDescriptor - The descriptor definition.
	 */
	getDefaultValue(pDescriptor)
	{
		if (typeof(pDescriptor) != 'object')
		{
			return undefined;
		}

		if ('Default' in pDescriptor)
		{
			return pDescriptor.Default;
		}
		else
		{
			// Default to a null if it doesn't have a type specified.
			// This will ensure a placeholder is created but isn't misinterpreted.
			let tmpDataType = ('DataType' in pDescriptor) ? pDescriptor.DataType : 'String';
			if (tmpDataType in this.options.defaultValues)
			{
				let tmpDefaultValue = this.options.defaultValues[tmpDataType];
				// Return a copy of mutable defaults (Array and Object) to prevent shared state
				if (typeof(tmpDefaultValue) == 'object' && tmpDefaultValue !== null)
				{
					return JSON.parse(JSON.stringify(tmpDefaultValue));
				}
				return tmpDefaultValue;
			}
			else
			{
				// give up and return null
				return null;
			}
		}
	}

	// Enumerate through the schema and populate default values if they don't exist.
	populateDefaults(pObject, pOverwriteProperties)
	{
		return this.populateObject(pObject, pOverwriteProperties,
			// This just sets up a simple filter to see if there is a default set.
			(pDescriptor) =>
			{
				return ('Default' in pDescriptor);
			});
	}

	// Forcefully populate all values even if they don't have defaults.
	// Based on type, this can do unexpected things.
	populateObject(pObject, pOverwriteProperties, fFilter)
	{
		// Automatically create an object if one isn't passed in.
		let tmpObject = (typeof(pObject) === 'object') ? pObject : {};
		// Default to *NOT OVERWRITING* properties
		let tmpOverwriteProperties = (typeof(pOverwriteProperties) == 'undefined') ? false : pOverwriteProperties;
		// This is a filter function, which is passed the schema and allows complex filtering of population
		// The default filter function just returns true, populating everything.
		let tmpFilterFunction = (typeof(fFilter) == 'function') ? fFilter : (pDescriptor) => { return true; };

		this.elementAddresses.forEach(
			(pAddress) =>
			{
				let tmpDescriptor = this.getDescriptor(pAddress);
				// Check the filter function to see if this is an address we want to set the value for.
				if (tmpFilterFunction(tmpDescriptor))
				{
					// If we are overwriting properties OR the property does not exist
					if (tmpOverwriteProperties || !this.checkAddressExists(tmpObject, pAddress))
					{
						this.setValueAtAddress(tmpObject, pAddress, this.getDefaultValue(tmpDescriptor));
					}
				}
			});

		return tmpObject;
	}
};

module.exports = Manyfest;

},{"./Manyfest-HashTranslation.js":117,"./Manyfest-LogToConsole.js":118,"./Manyfest-ObjectAddress-CheckAddressExists.js":119,"./Manyfest-ObjectAddress-DeleteValue.js":120,"./Manyfest-ObjectAddress-GetValue.js":121,"./Manyfest-ObjectAddress-SetValue.js":123,"./Manyfest-ObjectAddressGeneration.js":124,"./Manyfest-SchemaManipulation.js":126,"fable-serviceproviderbase":59}],128:[function(require,module,exports){
'use strict';

/** @type {import('./abs')} */
module.exports = Math.abs;

},{}],129:[function(require,module,exports){
'use strict';

/** @type {import('./floor')} */
module.exports = Math.floor;

},{}],130:[function(require,module,exports){
'use strict';

/** @type {import('./isNaN')} */
module.exports = Number.isNaN || function isNaN(a) {
	return a !== a;
};

},{}],131:[function(require,module,exports){
'use strict';

/** @type {import('./max')} */
module.exports = Math.max;

},{}],132:[function(require,module,exports){
'use strict';

/** @type {import('./min')} */
module.exports = Math.min;

},{}],133:[function(require,module,exports){
'use strict';

/** @type {import('./pow')} */
module.exports = Math.pow;

},{}],134:[function(require,module,exports){
'use strict';

/** @type {import('./round')} */
module.exports = Math.round;

},{}],135:[function(require,module,exports){
'use strict';

var $isNaN = require('./isNaN');

/** @type {import('./sign')} */
module.exports = function sign(number) {
	if ($isNaN(number) || number === 0) {
		return number;
	}
	return number < 0 ? -1 : +1;
};

},{"./isNaN":130}],136:[function(require,module,exports){
(function (global){(function (){
var hasMap = typeof Map === 'function' && Map.prototype;
var mapSizeDescriptor = Object.getOwnPropertyDescriptor && hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, 'size') : null;
var mapSize = hasMap && mapSizeDescriptor && typeof mapSizeDescriptor.get === 'function' ? mapSizeDescriptor.get : null;
var mapForEach = hasMap && Map.prototype.forEach;
var hasSet = typeof Set === 'function' && Set.prototype;
var setSizeDescriptor = Object.getOwnPropertyDescriptor && hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, 'size') : null;
var setSize = hasSet && setSizeDescriptor && typeof setSizeDescriptor.get === 'function' ? setSizeDescriptor.get : null;
var setForEach = hasSet && Set.prototype.forEach;
var hasWeakMap = typeof WeakMap === 'function' && WeakMap.prototype;
var weakMapHas = hasWeakMap ? WeakMap.prototype.has : null;
var hasWeakSet = typeof WeakSet === 'function' && WeakSet.prototype;
var weakSetHas = hasWeakSet ? WeakSet.prototype.has : null;
var hasWeakRef = typeof WeakRef === 'function' && WeakRef.prototype;
var weakRefDeref = hasWeakRef ? WeakRef.prototype.deref : null;
var booleanValueOf = Boolean.prototype.valueOf;
var objectToString = Object.prototype.toString;
var functionToString = Function.prototype.toString;
var $match = String.prototype.match;
var $slice = String.prototype.slice;
var $replace = String.prototype.replace;
var $toUpperCase = String.prototype.toUpperCase;
var $toLowerCase = String.prototype.toLowerCase;
var $test = RegExp.prototype.test;
var $concat = Array.prototype.concat;
var $join = Array.prototype.join;
var $arrSlice = Array.prototype.slice;
var $floor = Math.floor;
var bigIntValueOf = typeof BigInt === 'function' ? BigInt.prototype.valueOf : null;
var gOPS = Object.getOwnPropertySymbols;
var symToString = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? Symbol.prototype.toString : null;
var hasShammedSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'object';
// ie, `has-tostringtag/shams
var toStringTag = typeof Symbol === 'function' && Symbol.toStringTag && (typeof Symbol.toStringTag === hasShammedSymbols ? 'object' : 'symbol')
    ? Symbol.toStringTag
    : null;
var isEnumerable = Object.prototype.propertyIsEnumerable;

var gPO = (typeof Reflect === 'function' ? Reflect.getPrototypeOf : Object.getPrototypeOf) || (
    [].__proto__ === Array.prototype // eslint-disable-line no-proto
        ? function (O) {
            return O.__proto__; // eslint-disable-line no-proto
        }
        : null
);

function addNumericSeparator(num, str) {
    if (
        num === Infinity
        || num === -Infinity
        || num !== num
        || (num && num > -1000 && num < 1000)
        || $test.call(/e/, str)
    ) {
        return str;
    }
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === 'number') {
        var int = num < 0 ? -$floor(-num) : $floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $slice.call(str, intStr.length + 1);
            return $replace.call(intStr, sepRegex, '$&_') + '.' + $replace.call($replace.call(dec, /([0-9]{3})/g, '$&_'), /_$/, '');
        }
    }
    return $replace.call(str, sepRegex, '$&_');
}

var utilInspect = require('./util.inspect');
var inspectCustom = utilInspect.custom;
var inspectSymbol = isSymbol(inspectCustom) ? inspectCustom : null;

var quotes = {
    __proto__: null,
    'double': '"',
    single: "'"
};
var quoteREs = {
    __proto__: null,
    'double': /(["\\])/g,
    single: /(['\\])/g
};

module.exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};

    if (has(opts, 'quoteStyle') && !has(quotes, opts.quoteStyle)) {
        throw new TypeError('option "quoteStyle" must be "single" or "double"');
    }
    if (
        has(opts, 'maxStringLength') && (typeof opts.maxStringLength === 'number'
            ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity
            : opts.maxStringLength !== null
        )
    ) {
        throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    }
    var customInspect = has(opts, 'customInspect') ? opts.customInspect : true;
    if (typeof customInspect !== 'boolean' && customInspect !== 'symbol') {
        throw new TypeError('option "customInspect", if provided, must be `true`, `false`, or `\'symbol\'`');
    }

    if (
        has(opts, 'indent')
        && opts.indent !== null
        && opts.indent !== '\t'
        && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)
    ) {
        throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    }
    if (has(opts, 'numericSeparator') && typeof opts.numericSeparator !== 'boolean') {
        throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    }
    var numericSeparator = opts.numericSeparator;

    if (typeof obj === 'undefined') {
        return 'undefined';
    }
    if (obj === null) {
        return 'null';
    }
    if (typeof obj === 'boolean') {
        return obj ? 'true' : 'false';
    }

    if (typeof obj === 'string') {
        return inspectString(obj, opts);
    }
    if (typeof obj === 'number') {
        if (obj === 0) {
            return Infinity / obj > 0 ? '0' : '-0';
        }
        var str = String(obj);
        return numericSeparator ? addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === 'bigint') {
        var bigIntStr = String(obj) + 'n';
        return numericSeparator ? addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }

    var maxDepth = typeof opts.depth === 'undefined' ? 5 : opts.depth;
    if (typeof depth === 'undefined') { depth = 0; }
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === 'object') {
        return isArray(obj) ? '[Array]' : '[Object]';
    }

    var indent = getIndent(opts, depth);

    if (typeof seen === 'undefined') {
        seen = [];
    } else if (indexOf(seen, obj) >= 0) {
        return '[Circular]';
    }

    function inspect(value, from, noIndent) {
        if (from) {
            seen = $arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if (has(opts, 'quoteStyle')) {
                newOpts.quoteStyle = opts.quoteStyle;
            }
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }

    if (typeof obj === 'function' && !isRegExp(obj)) { // in older engines, regexes are callable
        var name = nameOf(obj);
        var keys = arrObjKeys(obj, inspect);
        return '[Function' + (name ? ': ' + name : ' (anonymous)') + ']' + (keys.length > 0 ? ' { ' + $join.call(keys, ', ') + ' }' : '');
    }
    if (isSymbol(obj)) {
        var symString = hasShammedSymbols ? $replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, '$1') : symToString.call(obj);
        return typeof obj === 'object' && !hasShammedSymbols ? markBoxed(symString) : symString;
    }
    if (isElement(obj)) {
        var s = '<' + $toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for (var i = 0; i < attrs.length; i++) {
            s += ' ' + attrs[i].name + '=' + wrapQuotes(quote(attrs[i].value), 'double', opts);
        }
        s += '>';
        if (obj.childNodes && obj.childNodes.length) { s += '...'; }
        s += '</' + $toLowerCase.call(String(obj.nodeName)) + '>';
        return s;
    }
    if (isArray(obj)) {
        if (obj.length === 0) { return '[]'; }
        var xs = arrObjKeys(obj, inspect);
        if (indent && !singleLineValues(xs)) {
            return '[' + indentedJoin(xs, indent) + ']';
        }
        return '[ ' + $join.call(xs, ', ') + ' ]';
    }
    if (isError(obj)) {
        var parts = arrObjKeys(obj, inspect);
        if (!('cause' in Error.prototype) && 'cause' in obj && !isEnumerable.call(obj, 'cause')) {
            return '{ [' + String(obj) + '] ' + $join.call($concat.call('[cause]: ' + inspect(obj.cause), parts), ', ') + ' }';
        }
        if (parts.length === 0) { return '[' + String(obj) + ']'; }
        return '{ [' + String(obj) + '] ' + $join.call(parts, ', ') + ' }';
    }
    if (typeof obj === 'object' && customInspect) {
        if (inspectSymbol && typeof obj[inspectSymbol] === 'function' && utilInspect) {
            return utilInspect(obj, { depth: maxDepth - depth });
        } else if (customInspect !== 'symbol' && typeof obj.inspect === 'function') {
            return obj.inspect();
        }
    }
    if (isMap(obj)) {
        var mapParts = [];
        if (mapForEach) {
            mapForEach.call(obj, function (value, key) {
                mapParts.push(inspect(key, obj, true) + ' => ' + inspect(value, obj));
            });
        }
        return collectionOf('Map', mapSize.call(obj), mapParts, indent);
    }
    if (isSet(obj)) {
        var setParts = [];
        if (setForEach) {
            setForEach.call(obj, function (value) {
                setParts.push(inspect(value, obj));
            });
        }
        return collectionOf('Set', setSize.call(obj), setParts, indent);
    }
    if (isWeakMap(obj)) {
        return weakCollectionOf('WeakMap');
    }
    if (isWeakSet(obj)) {
        return weakCollectionOf('WeakSet');
    }
    if (isWeakRef(obj)) {
        return weakCollectionOf('WeakRef');
    }
    if (isNumber(obj)) {
        return markBoxed(inspect(Number(obj)));
    }
    if (isBigInt(obj)) {
        return markBoxed(inspect(bigIntValueOf.call(obj)));
    }
    if (isBoolean(obj)) {
        return markBoxed(booleanValueOf.call(obj));
    }
    if (isString(obj)) {
        return markBoxed(inspect(String(obj)));
    }
    // note: in IE 8, sometimes `global !== window` but both are the prototypes of each other
    /* eslint-env browser */
    if (typeof window !== 'undefined' && obj === window) {
        return '{ [object Window] }';
    }
    if (
        (typeof globalThis !== 'undefined' && obj === globalThis)
        || (typeof global !== 'undefined' && obj === global)
    ) {
        return '{ [object globalThis] }';
    }
    if (!isDate(obj) && !isRegExp(obj)) {
        var ys = arrObjKeys(obj, inspect);
        var isPlainObject = gPO ? gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? '' : 'null prototype';
        var stringTag = !isPlainObject && toStringTag && Object(obj) === obj && toStringTag in obj ? $slice.call(toStr(obj), 8, -1) : protoTag ? 'Object' : '';
        var constructorTag = isPlainObject || typeof obj.constructor !== 'function' ? '' : obj.constructor.name ? obj.constructor.name + ' ' : '';
        var tag = constructorTag + (stringTag || protoTag ? '[' + $join.call($concat.call([], stringTag || [], protoTag || []), ': ') + '] ' : '');
        if (ys.length === 0) { return tag + '{}'; }
        if (indent) {
            return tag + '{' + indentedJoin(ys, indent) + '}';
        }
        return tag + '{ ' + $join.call(ys, ', ') + ' }';
    }
    return String(obj);
};

function wrapQuotes(s, defaultStyle, opts) {
    var style = opts.quoteStyle || defaultStyle;
    var quoteChar = quotes[style];
    return quoteChar + s + quoteChar;
}

function quote(s) {
    return $replace.call(String(s), /"/g, '&quot;');
}

function canTrustToString(obj) {
    return !toStringTag || !(typeof obj === 'object' && (toStringTag in obj || typeof obj[toStringTag] !== 'undefined'));
}
function isArray(obj) { return toStr(obj) === '[object Array]' && canTrustToString(obj); }
function isDate(obj) { return toStr(obj) === '[object Date]' && canTrustToString(obj); }
function isRegExp(obj) { return toStr(obj) === '[object RegExp]' && canTrustToString(obj); }
function isError(obj) { return toStr(obj) === '[object Error]' && canTrustToString(obj); }
function isString(obj) { return toStr(obj) === '[object String]' && canTrustToString(obj); }
function isNumber(obj) { return toStr(obj) === '[object Number]' && canTrustToString(obj); }
function isBoolean(obj) { return toStr(obj) === '[object Boolean]' && canTrustToString(obj); }

// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function isSymbol(obj) {
    if (hasShammedSymbols) {
        return obj && typeof obj === 'object' && obj instanceof Symbol;
    }
    if (typeof obj === 'symbol') {
        return true;
    }
    if (!obj || typeof obj !== 'object' || !symToString) {
        return false;
    }
    try {
        symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}

function isBigInt(obj) {
    if (!obj || typeof obj !== 'object' || !bigIntValueOf) {
        return false;
    }
    try {
        bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}

var hasOwn = Object.prototype.hasOwnProperty || function (key) { return key in this; };
function has(obj, key) {
    return hasOwn.call(obj, key);
}

function toStr(obj) {
    return objectToString.call(obj);
}

function nameOf(f) {
    if (f.name) { return f.name; }
    var m = $match.call(functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) { return m[1]; }
    return null;
}

function indexOf(xs, x) {
    if (xs.indexOf) { return xs.indexOf(x); }
    for (var i = 0, l = xs.length; i < l; i++) {
        if (xs[i] === x) { return i; }
    }
    return -1;
}

function isMap(x) {
    if (!mapSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        mapSize.call(x);
        try {
            setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakMap(x) {
    if (!weakMapHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakMapHas.call(x, weakMapHas);
        try {
            weakSetHas.call(x, weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakRef(x) {
    if (!weakRefDeref || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}

function isSet(x) {
    if (!setSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        setSize.call(x);
        try {
            mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakSet(x) {
    if (!weakSetHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakSetHas.call(x, weakSetHas);
        try {
            weakMapHas.call(x, weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isElement(x) {
    if (!x || typeof x !== 'object') { return false; }
    if (typeof HTMLElement !== 'undefined' && x instanceof HTMLElement) {
        return true;
    }
    return typeof x.nodeName === 'string' && typeof x.getAttribute === 'function';
}

function inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = '... ' + remaining + ' more character' + (remaining > 1 ? 's' : '');
        return inspectString($slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    var quoteRE = quoteREs[opts.quoteStyle || 'single'];
    quoteRE.lastIndex = 0;
    // eslint-disable-next-line no-control-regex
    var s = $replace.call($replace.call(str, quoteRE, '\\$1'), /[\x00-\x1f]/g, lowbyte);
    return wrapQuotes(s, 'single', opts);
}

function lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: 'b',
        9: 't',
        10: 'n',
        12: 'f',
        13: 'r'
    }[n];
    if (x) { return '\\' + x; }
    return '\\x' + (n < 0x10 ? '0' : '') + $toUpperCase.call(n.toString(16));
}

function markBoxed(str) {
    return 'Object(' + str + ')';
}

function weakCollectionOf(type) {
    return type + ' { ? }';
}

function collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? indentedJoin(entries, indent) : $join.call(entries, ', ');
    return type + ' (' + size + ') {' + joinedEntries + '}';
}

function singleLineValues(xs) {
    for (var i = 0; i < xs.length; i++) {
        if (indexOf(xs[i], '\n') >= 0) {
            return false;
        }
    }
    return true;
}

function getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === '\t') {
        baseIndent = '\t';
    } else if (typeof opts.indent === 'number' && opts.indent > 0) {
        baseIndent = $join.call(Array(opts.indent + 1), ' ');
    } else {
        return null;
    }
    return {
        base: baseIndent,
        prev: $join.call(Array(depth + 1), baseIndent)
    };
}

function indentedJoin(xs, indent) {
    if (xs.length === 0) { return ''; }
    var lineJoiner = '\n' + indent.prev + indent.base;
    return lineJoiner + $join.call(xs, ',' + lineJoiner) + '\n' + indent.prev;
}

function arrObjKeys(obj, inspect) {
    var isArr = isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for (var i = 0; i < obj.length; i++) {
            xs[i] = has(obj, i) ? inspect(obj[i], obj) : '';
        }
    }
    var syms = typeof gOPS === 'function' ? gOPS(obj) : [];
    var symMap;
    if (hasShammedSymbols) {
        symMap = {};
        for (var k = 0; k < syms.length; k++) {
            symMap['$' + syms[k]] = syms[k];
        }
    }

    for (var key in obj) { // eslint-disable-line no-restricted-syntax
        if (!has(obj, key)) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (hasShammedSymbols && symMap['$' + key] instanceof Symbol) {
            // this is to prevent shammed Symbols, which are stored as strings, from being included in the string key section
            continue; // eslint-disable-line no-restricted-syntax, no-continue
        } else if ($test.call(/[^\w$]/, key)) {
            xs.push(inspect(key, obj) + ': ' + inspect(obj[key], obj));
        } else {
            xs.push(key + ': ' + inspect(obj[key], obj));
        }
    }
    if (typeof gOPS === 'function') {
        for (var j = 0; j < syms.length; j++) {
            if (isEnumerable.call(obj, syms[j])) {
                xs.push('[' + inspect(syms[j]) + ']: ' + inspect(obj[syms[j]], obj));
            }
        }
    }
    return xs;
}

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"./util.inspect":18}],137:[function(require,module,exports){
var wrappy = require('wrappy')
module.exports = wrappy(once)
module.exports.strict = wrappy(onceStrict)

once.proto = once(function () {
  Object.defineProperty(Function.prototype, 'once', {
    value: function () {
      return once(this)
    },
    configurable: true
  })

  Object.defineProperty(Function.prototype, 'onceStrict', {
    value: function () {
      return onceStrict(this)
    },
    configurable: true
  })
})

function once (fn) {
  var f = function () {
    if (f.called) return f.value
    f.called = true
    return f.value = fn.apply(this, arguments)
  }
  f.called = false
  return f
}

function onceStrict (fn) {
  var f = function () {
    if (f.called)
      throw new Error(f.onceError)
    f.called = true
    return f.value = fn.apply(this, arguments)
  }
  var name = fn.name || 'Function wrapped with `once`'
  f.onceError = name + " shouldn't be called more than once"
  f.called = false
  return f
}

},{"wrappy":190}],138:[function(require,module,exports){
(function (process){(function (){
// 'path' module extracted from Node.js v8.11.1 (only the posix part)
// transplited with Babel

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

'use strict';

function assertPath(path) {
  if (typeof path !== 'string') {
    throw new TypeError('Path must be a string. Received ' + JSON.stringify(path));
  }
}

// Resolves . and .. elements in a path with directory names
function normalizeStringPosix(path, allowAboveRoot) {
  var res = '';
  var lastSegmentLength = 0;
  var lastSlash = -1;
  var dots = 0;
  var code;
  for (var i = 0; i <= path.length; ++i) {
    if (i < path.length)
      code = path.charCodeAt(i);
    else if (code === 47 /*/*/)
      break;
    else
      code = 47 /*/*/;
    if (code === 47 /*/*/) {
      if (lastSlash === i - 1 || dots === 1) {
        // NOOP
      } else if (lastSlash !== i - 1 && dots === 2) {
        if (res.length < 2 || lastSegmentLength !== 2 || res.charCodeAt(res.length - 1) !== 46 /*.*/ || res.charCodeAt(res.length - 2) !== 46 /*.*/) {
          if (res.length > 2) {
            var lastSlashIndex = res.lastIndexOf('/');
            if (lastSlashIndex !== res.length - 1) {
              if (lastSlashIndex === -1) {
                res = '';
                lastSegmentLength = 0;
              } else {
                res = res.slice(0, lastSlashIndex);
                lastSegmentLength = res.length - 1 - res.lastIndexOf('/');
              }
              lastSlash = i;
              dots = 0;
              continue;
            }
          } else if (res.length === 2 || res.length === 1) {
            res = '';
            lastSegmentLength = 0;
            lastSlash = i;
            dots = 0;
            continue;
          }
        }
        if (allowAboveRoot) {
          if (res.length > 0)
            res += '/..';
          else
            res = '..';
          lastSegmentLength = 2;
        }
      } else {
        if (res.length > 0)
          res += '/' + path.slice(lastSlash + 1, i);
        else
          res = path.slice(lastSlash + 1, i);
        lastSegmentLength = i - lastSlash - 1;
      }
      lastSlash = i;
      dots = 0;
    } else if (code === 46 /*.*/ && dots !== -1) {
      ++dots;
    } else {
      dots = -1;
    }
  }
  return res;
}

function _format(sep, pathObject) {
  var dir = pathObject.dir || pathObject.root;
  var base = pathObject.base || (pathObject.name || '') + (pathObject.ext || '');
  if (!dir) {
    return base;
  }
  if (dir === pathObject.root) {
    return dir + base;
  }
  return dir + sep + base;
}

var posix = {
  // path.resolve([from ...], to)
  resolve: function resolve() {
    var resolvedPath = '';
    var resolvedAbsolute = false;
    var cwd;

    for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
      var path;
      if (i >= 0)
        path = arguments[i];
      else {
        if (cwd === undefined)
          cwd = process.cwd();
        path = cwd;
      }

      assertPath(path);

      // Skip empty entries
      if (path.length === 0) {
        continue;
      }

      resolvedPath = path + '/' + resolvedPath;
      resolvedAbsolute = path.charCodeAt(0) === 47 /*/*/;
    }

    // At this point the path should be resolved to a full absolute path, but
    // handle relative paths to be safe (might happen when process.cwd() fails)

    // Normalize the path
    resolvedPath = normalizeStringPosix(resolvedPath, !resolvedAbsolute);

    if (resolvedAbsolute) {
      if (resolvedPath.length > 0)
        return '/' + resolvedPath;
      else
        return '/';
    } else if (resolvedPath.length > 0) {
      return resolvedPath;
    } else {
      return '.';
    }
  },

  normalize: function normalize(path) {
    assertPath(path);

    if (path.length === 0) return '.';

    var isAbsolute = path.charCodeAt(0) === 47 /*/*/;
    var trailingSeparator = path.charCodeAt(path.length - 1) === 47 /*/*/;

    // Normalize the path
    path = normalizeStringPosix(path, !isAbsolute);

    if (path.length === 0 && !isAbsolute) path = '.';
    if (path.length > 0 && trailingSeparator) path += '/';

    if (isAbsolute) return '/' + path;
    return path;
  },

  isAbsolute: function isAbsolute(path) {
    assertPath(path);
    return path.length > 0 && path.charCodeAt(0) === 47 /*/*/;
  },

  join: function join() {
    if (arguments.length === 0)
      return '.';
    var joined;
    for (var i = 0; i < arguments.length; ++i) {
      var arg = arguments[i];
      assertPath(arg);
      if (arg.length > 0) {
        if (joined === undefined)
          joined = arg;
        else
          joined += '/' + arg;
      }
    }
    if (joined === undefined)
      return '.';
    return posix.normalize(joined);
  },

  relative: function relative(from, to) {
    assertPath(from);
    assertPath(to);

    if (from === to) return '';

    from = posix.resolve(from);
    to = posix.resolve(to);

    if (from === to) return '';

    // Trim any leading backslashes
    var fromStart = 1;
    for (; fromStart < from.length; ++fromStart) {
      if (from.charCodeAt(fromStart) !== 47 /*/*/)
        break;
    }
    var fromEnd = from.length;
    var fromLen = fromEnd - fromStart;

    // Trim any leading backslashes
    var toStart = 1;
    for (; toStart < to.length; ++toStart) {
      if (to.charCodeAt(toStart) !== 47 /*/*/)
        break;
    }
    var toEnd = to.length;
    var toLen = toEnd - toStart;

    // Compare paths to find the longest common path from root
    var length = fromLen < toLen ? fromLen : toLen;
    var lastCommonSep = -1;
    var i = 0;
    for (; i <= length; ++i) {
      if (i === length) {
        if (toLen > length) {
          if (to.charCodeAt(toStart + i) === 47 /*/*/) {
            // We get here if `from` is the exact base path for `to`.
            // For example: from='/foo/bar'; to='/foo/bar/baz'
            return to.slice(toStart + i + 1);
          } else if (i === 0) {
            // We get here if `from` is the root
            // For example: from='/'; to='/foo'
            return to.slice(toStart + i);
          }
        } else if (fromLen > length) {
          if (from.charCodeAt(fromStart + i) === 47 /*/*/) {
            // We get here if `to` is the exact base path for `from`.
            // For example: from='/foo/bar/baz'; to='/foo/bar'
            lastCommonSep = i;
          } else if (i === 0) {
            // We get here if `to` is the root.
            // For example: from='/foo'; to='/'
            lastCommonSep = 0;
          }
        }
        break;
      }
      var fromCode = from.charCodeAt(fromStart + i);
      var toCode = to.charCodeAt(toStart + i);
      if (fromCode !== toCode)
        break;
      else if (fromCode === 47 /*/*/)
        lastCommonSep = i;
    }

    var out = '';
    // Generate the relative path based on the path difference between `to`
    // and `from`
    for (i = fromStart + lastCommonSep + 1; i <= fromEnd; ++i) {
      if (i === fromEnd || from.charCodeAt(i) === 47 /*/*/) {
        if (out.length === 0)
          out += '..';
        else
          out += '/..';
      }
    }

    // Lastly, append the rest of the destination (`to`) path that comes after
    // the common path parts
    if (out.length > 0)
      return out + to.slice(toStart + lastCommonSep);
    else {
      toStart += lastCommonSep;
      if (to.charCodeAt(toStart) === 47 /*/*/)
        ++toStart;
      return to.slice(toStart);
    }
  },

  _makeLong: function _makeLong(path) {
    return path;
  },

  dirname: function dirname(path) {
    assertPath(path);
    if (path.length === 0) return '.';
    var code = path.charCodeAt(0);
    var hasRoot = code === 47 /*/*/;
    var end = -1;
    var matchedSlash = true;
    for (var i = path.length - 1; i >= 1; --i) {
      code = path.charCodeAt(i);
      if (code === 47 /*/*/) {
          if (!matchedSlash) {
            end = i;
            break;
          }
        } else {
        // We saw the first non-path separator
        matchedSlash = false;
      }
    }

    if (end === -1) return hasRoot ? '/' : '.';
    if (hasRoot && end === 1) return '//';
    return path.slice(0, end);
  },

  basename: function basename(path, ext) {
    if (ext !== undefined && typeof ext !== 'string') throw new TypeError('"ext" argument must be a string');
    assertPath(path);

    var start = 0;
    var end = -1;
    var matchedSlash = true;
    var i;

    if (ext !== undefined && ext.length > 0 && ext.length <= path.length) {
      if (ext.length === path.length && ext === path) return '';
      var extIdx = ext.length - 1;
      var firstNonSlashEnd = -1;
      for (i = path.length - 1; i >= 0; --i) {
        var code = path.charCodeAt(i);
        if (code === 47 /*/*/) {
            // If we reached a path separator that was not part of a set of path
            // separators at the end of the string, stop now
            if (!matchedSlash) {
              start = i + 1;
              break;
            }
          } else {
          if (firstNonSlashEnd === -1) {
            // We saw the first non-path separator, remember this index in case
            // we need it if the extension ends up not matching
            matchedSlash = false;
            firstNonSlashEnd = i + 1;
          }
          if (extIdx >= 0) {
            // Try to match the explicit extension
            if (code === ext.charCodeAt(extIdx)) {
              if (--extIdx === -1) {
                // We matched the extension, so mark this as the end of our path
                // component
                end = i;
              }
            } else {
              // Extension does not match, so our result is the entire path
              // component
              extIdx = -1;
              end = firstNonSlashEnd;
            }
          }
        }
      }

      if (start === end) end = firstNonSlashEnd;else if (end === -1) end = path.length;
      return path.slice(start, end);
    } else {
      for (i = path.length - 1; i >= 0; --i) {
        if (path.charCodeAt(i) === 47 /*/*/) {
            // If we reached a path separator that was not part of a set of path
            // separators at the end of the string, stop now
            if (!matchedSlash) {
              start = i + 1;
              break;
            }
          } else if (end === -1) {
          // We saw the first non-path separator, mark this as the end of our
          // path component
          matchedSlash = false;
          end = i + 1;
        }
      }

      if (end === -1) return '';
      return path.slice(start, end);
    }
  },

  extname: function extname(path) {
    assertPath(path);
    var startDot = -1;
    var startPart = 0;
    var end = -1;
    var matchedSlash = true;
    // Track the state of characters (if any) we see before our first dot and
    // after any path separator we find
    var preDotState = 0;
    for (var i = path.length - 1; i >= 0; --i) {
      var code = path.charCodeAt(i);
      if (code === 47 /*/*/) {
          // If we reached a path separator that was not part of a set of path
          // separators at the end of the string, stop now
          if (!matchedSlash) {
            startPart = i + 1;
            break;
          }
          continue;
        }
      if (end === -1) {
        // We saw the first non-path separator, mark this as the end of our
        // extension
        matchedSlash = false;
        end = i + 1;
      }
      if (code === 46 /*.*/) {
          // If this is our first dot, mark it as the start of our extension
          if (startDot === -1)
            startDot = i;
          else if (preDotState !== 1)
            preDotState = 1;
      } else if (startDot !== -1) {
        // We saw a non-dot and non-path separator before our dot, so we should
        // have a good chance at having a non-empty extension
        preDotState = -1;
      }
    }

    if (startDot === -1 || end === -1 ||
        // We saw a non-dot character immediately before the dot
        preDotState === 0 ||
        // The (right-most) trimmed path component is exactly '..'
        preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
      return '';
    }
    return path.slice(startDot, end);
  },

  format: function format(pathObject) {
    if (pathObject === null || typeof pathObject !== 'object') {
      throw new TypeError('The "pathObject" argument must be of type Object. Received type ' + typeof pathObject);
    }
    return _format('/', pathObject);
  },

  parse: function parse(path) {
    assertPath(path);

    var ret = { root: '', dir: '', base: '', ext: '', name: '' };
    if (path.length === 0) return ret;
    var code = path.charCodeAt(0);
    var isAbsolute = code === 47 /*/*/;
    var start;
    if (isAbsolute) {
      ret.root = '/';
      start = 1;
    } else {
      start = 0;
    }
    var startDot = -1;
    var startPart = 0;
    var end = -1;
    var matchedSlash = true;
    var i = path.length - 1;

    // Track the state of characters (if any) we see before our first dot and
    // after any path separator we find
    var preDotState = 0;

    // Get non-dir info
    for (; i >= start; --i) {
      code = path.charCodeAt(i);
      if (code === 47 /*/*/) {
          // If we reached a path separator that was not part of a set of path
          // separators at the end of the string, stop now
          if (!matchedSlash) {
            startPart = i + 1;
            break;
          }
          continue;
        }
      if (end === -1) {
        // We saw the first non-path separator, mark this as the end of our
        // extension
        matchedSlash = false;
        end = i + 1;
      }
      if (code === 46 /*.*/) {
          // If this is our first dot, mark it as the start of our extension
          if (startDot === -1) startDot = i;else if (preDotState !== 1) preDotState = 1;
        } else if (startDot !== -1) {
        // We saw a non-dot and non-path separator before our dot, so we should
        // have a good chance at having a non-empty extension
        preDotState = -1;
      }
    }

    if (startDot === -1 || end === -1 ||
    // We saw a non-dot character immediately before the dot
    preDotState === 0 ||
    // The (right-most) trimmed path component is exactly '..'
    preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
      if (end !== -1) {
        if (startPart === 0 && isAbsolute) ret.base = ret.name = path.slice(1, end);else ret.base = ret.name = path.slice(startPart, end);
      }
    } else {
      if (startPart === 0 && isAbsolute) {
        ret.name = path.slice(1, startDot);
        ret.base = path.slice(1, end);
      } else {
        ret.name = path.slice(startPart, startDot);
        ret.base = path.slice(startPart, end);
      }
      ret.ext = path.slice(startDot, end);
    }

    if (startPart > 0) ret.dir = path.slice(0, startPart - 1);else if (isAbsolute) ret.dir = '/';

    return ret;
  },

  sep: '/',
  delimiter: ':',
  win32: null,
  posix: null
};

posix.posix = posix;

module.exports = posix;

}).call(this)}).call(this,require('_process'))

},{"_process":150}],139:[function(require,module,exports){
module.exports={
  "_from": "pict-application@^1.0.34",
  "_id": "pict-application@1.0.34",
  "_inBundle": false,
  "_integrity": "sha512-z+qyYs/kMdAk3I2Z4XDUvGjNyK/gfFM3r5zhHQcQrIxOcVqMwXMZvoMDWzCXc6SzyTJjoWHKZkdfmtRnft2RNw==",
  "_location": "/pict-application",
  "_phantomChildren": {},
  "_requested": {
    "type": "range",
    "registry": true,
    "raw": "pict-application@^1.0.34",
    "name": "pict-application",
    "escapedName": "pict-application",
    "rawSpec": "^1.0.34",
    "saveSpec": null,
    "fetchSpec": "^1.0.34"
  },
  "_requiredBy": [
    "/",
    "/meadow-migrationmanager",
    "/pict",
    "/pict-docuserve",
    "/pict-terminalui",
    "/retold-harness",
    "/stricture",
    "/stricture/pict-terminalui"
  ],
  "_resolved": "https://registry.npmjs.org/pict-application/-/pict-application-1.0.34.tgz",
  "_shasum": "382dfc18e314ad1cdab3b8cd6687f441bf7521f8",
  "_spec": "pict-application@^1.0.34",
  "_where": "/Users/jacksonpollard/pict",
  "author": {
    "name": "steven velozo",
    "email": "steven@velozo.com"
  },
  "bugs": {
    "url": "https://github.com/stevenvelozo/pict-application/issues"
  },
  "bundleDependencies": false,
  "dependencies": {
    "fable-serviceproviderbase": "^3.0.19"
  },
  "deprecated": false,
  "description": "Application base class for a pict view-based application",
  "devDependencies": {
    "@eslint/js": "^9.28.0",
    "browser-env": "^3.3.0",
    "eslint": "^9.28.0",
    "pict": "^1.0.348",
    "pict-docuserve": "^0.1.5",
    "pict-provider": "^1.0.10",
    "pict-view": "^1.0.66",
    "quackage": "^1.1.0",
    "typescript": "^5.9.3"
  },
  "homepage": "https://github.com/stevenvelozo/pict-application#readme",
  "license": "MIT",
  "main": "source/Pict-Application.js",
  "mocha": {
    "diff": true,
    "extension": [
      "js"
    ],
    "package": "./package.json",
    "reporter": "spec",
    "slow": "75",
    "timeout": "5000",
    "ui": "tdd",
    "watch-files": [
      "source/**/*.js",
      "test/**/*.js"
    ],
    "watch-ignore": [
      "lib/vendor"
    ]
  },
  "name": "pict-application",
  "repository": {
    "type": "git",
    "url": "git+https://github.com/stevenvelozo/pict-application.git"
  },
  "scripts": {
    "build": "npx quack build",
    "coverage": "npx quack coverage",
    "docker-dev-build": "docker build ./ -f Dockerfile_LUXURYCode -t pict-application-image:local",
    "docker-dev-run": "docker run -it -d --name pict-application-dev -p 30001:8080 -p 38086:8086 -v \"$PWD/.config:/home/coder/.config\"  -v \"$PWD:/home/coder/pict-application\" -u \"$(id -u):$(id -g)\" -e \"DOCKER_USER=$USER\" pict-application-image:local",
    "docker-dev-shell": "docker exec -it pict-application-dev /bin/bash",
    "lint": "eslint source/**",
    "start": "node source/Pict-Application.js",
    "test": "npx quack test",
    "tests": "npx quack test -g",
    "types": "tsc -p ."
  },
  "types": "types/source/Pict-Application.d.ts",
  "version": "1.0.34"
}

},{}],140:[function(require,module,exports){
const libFableServiceBase = require('fable-serviceproviderbase')

const libPackage = require('../package.json');

const defaultPictSettings = (
	{
		Name: 'DefaultPictApplication',

		// The main "viewport" is the view that is used to host our application
		MainViewportViewIdentifier: 'Default-View',
		MainViewportRenderableHash: false,
		MainViewportDestinationAddress: false,
		MainViewportDefaultDataAddress: false,

		// Whether or not we should automatically render the main viewport and other autorender views after we initialize the pict application
		AutoSolveAfterInitialize: true,
		AutoRenderMainViewportViewAfterInitialize: true,
		AutoRenderViewsAfterInitialize: false,
		AutoLoginAfterInitialize: false,
		AutoLoadDataAfterLogin: false,

		ConfigurationOnlyViews: [],

		Manifests: {},
		// The prefix to prepend on all template destination hashes
		IdentifierAddressPrefix: 'PICT-'
	});

/**
 * Base class for pict applications.
 */
class PictApplication extends libFableServiceBase
{
	/**
	 * @param {import('fable')} pFable
	 * @param {Record<string, any>} [pOptions]
	 * @param {string} [pServiceHash]
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpCarryOverConfiguration = (typeof(pFable.settings.PictApplicationConfiguration) === 'object') ? pFable.settings.PictApplicationConfiguration : {};
		let tmpOptions = Object.assign({}, JSON.parse(JSON.stringify(defaultPictSettings)), tmpCarryOverConfiguration, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		/** @type {any} */
		this.options;
		/** @type {any} */
		this.log;
		/** @type {import('pict') & import('fable')} */
		this.fable;
		/** @type {string} */
		this.UUID;
		/** @type {string} */
		this.Hash;
		/**
		 * @type {{ [key: string]: any }}
		 */
		this.servicesMap;

		this.serviceType = 'PictApplication';
		/** @type {Record<string, any>} */
		this._Package = libPackage;

		// Convenience and consistency naming
		this.pict = this.fable;
		// Wire in the essential Pict state
		/** @type {Record<string, any>} */
		this.AppData = this.fable.AppData;
		/** @type {Record<string, any>} */
		this.Bundle = this.fable.Bundle;

		/** @type {number} */
		this.initializeTimestamp;
		/** @type {number} */
		this.lastSolvedTimestamp;
		/** @type {number} */
		this.lastLoginTimestamp;
		/** @type {number} */
		this.lastMarshalFromViewsTimestamp;
		/** @type {number} */
		this.lastMarshalToViewsTimestamp;
		/** @type {number} */
		this.lastAutoRenderTimestamp;
		/** @type {number} */
		this.lastLoadDataTimestamp;

		// Load all the manifests for the application
		let tmpManifestKeys = Object.keys(this.options.Manifests);
		if (tmpManifestKeys.length > 0)
		{
			for (let i = 0; i < tmpManifestKeys.length; i++)
			{
				// Load each manifest
				let tmpManifestKey = tmpManifestKeys[i];
				this.fable.instantiateServiceProvider('Manifest', this.options.Manifests[tmpManifestKey], tmpManifestKey);
			}
		}
	}

	/* -------------------------------------------------------------------------- */
	/*                     Code Section: Solve All Views                          */
	/* -------------------------------------------------------------------------- */
	/**
	 * @return {boolean}
	 */
	onPreSolve()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onPreSolve:`);
		}
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onPreSolveAsync(fCallback)
	{
		this.onPreSolve();
		return fCallback();
	}

	/**
	 * @return {boolean}
	 */
	onBeforeSolve()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onBeforeSolve:`);
		}
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onBeforeSolveAsync(fCallback)
	{
		this.onBeforeSolve();
		return fCallback();
	}

	/**
	 * @return {boolean}
	 */
	onSolve()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onSolve:`);
		}
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onSolveAsync(fCallback)
	{
		this.onSolve();
		return fCallback();
	}

	/**
	 * @return {boolean}
	 */
	solve()
	{
		if (this.pict.LogNoisiness > 2)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} executing solve() function...`)
		}

		// Walk through any loaded providers and solve them as well.
		let tmpLoadedProviders = Object.keys(this.pict.providers);
		let tmpProvidersToSolve = [];
		for (let i = 0; i < tmpLoadedProviders.length; i++)
		{
			let tmpProvider = this.pict.providers[tmpLoadedProviders[i]];
			if (tmpProvider.options.AutoSolveWithApp)
			{
				tmpProvidersToSolve.push(tmpProvider);
			}
		}
		// Sort the providers by their priority (if they are all priority 0, it will end up being add order due to JSON Object Property Key order stuff)
		tmpProvidersToSolve.sort((a, b) => { return a.options.AutoSolveOrdinal - b.options.AutoSolveOrdinal; });
		for (let i = 0; i < tmpProvidersToSolve.length; i++)
		{
			tmpProvidersToSolve[i].solve(tmpProvidersToSolve[i]);
		}

		this.onBeforeSolve();
		// Now walk through any loaded views and initialize them as well.
		let tmpLoadedViews = Object.keys(this.pict.views);
		let tmpViewsToSolve = [];
		for (let i = 0; i < tmpLoadedViews.length; i++)
		{
			let tmpView = this.pict.views[tmpLoadedViews[i]];
			if (tmpView.options.AutoInitialize)
			{
				tmpViewsToSolve.push(tmpView);
			}
		}
		// Sort the views by their priority (if they are all priority 0, it will end up being add order due to JSON Object Property Key order stuff)
		tmpViewsToSolve.sort((a, b) => { return a.options.AutoInitializeOrdinal - b.options.AutoInitializeOrdinal; });
		for (let i = 0; i < tmpViewsToSolve.length; i++)
		{
			tmpViewsToSolve[i].solve();
		}
		this.onSolve();
		this.onAfterSolve();
		this.lastSolvedTimestamp = this.fable.log.getTimeStamp();
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	solveAsync(fCallback)
	{
		let tmpAnticipate = this.fable.instantiateServiceProviderWithoutRegistration('Anticipate');

		tmpAnticipate.anticipate(this.onBeforeSolveAsync.bind(this));


		// Allow the callback to be passed in as the last parameter no matter what
		let tmpCallback = (typeof(fCallback) === 'function') ? fCallback : false;

		if (!tmpCallback)
		{
			this.log.warn(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} solveAsync was called without a valid callback.  A callback will be generated but this could lead to race conditions.`);
			tmpCallback = (pError) =>
				{
					if (pError)
					{
						this.log.error(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} solveAsync Auto Callback Error: ${pError}`, pError)
					}
				};
		}
		// Walk through any loaded providers and solve them as well.
		let tmpLoadedProviders = Object.keys(this.pict.providers);
		let tmpProvidersToSolve = [];
		for (let i = 0; i < tmpLoadedProviders.length; i++)
		{
			let tmpProvider = this.pict.providers[tmpLoadedProviders[i]];
			if (tmpProvider.options.AutoSolveWithApp)
			{
				tmpProvidersToSolve.push(tmpProvider);
			}
		}
		// Sort the providers by their priority (if they are all priority 0, it will end up being add order due to JSON Object Property Key order stuff)
		tmpProvidersToSolve.sort((a, b) => { return a.options.AutoSolveOrdinal - b.options.AutoSolveOrdinal; });
		for (let i = 0; i < tmpProvidersToSolve.length; i++)
		{
			tmpAnticipate.anticipate(tmpProvidersToSolve[i].solveAsync.bind(tmpProvidersToSolve[i]));
		}

		// Walk through any loaded views and solve them as well.
		let tmpLoadedViews = Object.keys(this.pict.views);
		let tmpViewsToSolve = [];
		for (let i = 0; i < tmpLoadedViews.length; i++)
		{
			let tmpView = this.pict.views[tmpLoadedViews[i]];
			if (tmpView.options.AutoSolveWithApp)
			{
				tmpViewsToSolve.push(tmpView);
			}
		}
		// Sort the views by their priority (if they are all priority 0, it will end up being add order due to JSON Object Property Key order stuff)
		tmpViewsToSolve.sort((a, b) => { return a.options.AutoSolveOrdinal - b.options.AutoSolveOrdinal; });
		for (let i = 0; i < tmpViewsToSolve.length; i++)
		{
			tmpAnticipate.anticipate(tmpViewsToSolve[i].solveAsync.bind(tmpViewsToSolve[i]));
		}

		tmpAnticipate.anticipate(this.onSolveAsync.bind(this));
		tmpAnticipate.anticipate(this.onAfterSolveAsync.bind(this));

		tmpAnticipate.wait(
			(pError) =>
			{
				if (this.pict.LogNoisiness > 2)
				{
					this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} solveAsync() complete.`);
				}
				this.lastSolvedTimestamp = this.fable.log.getTimeStamp();
				return tmpCallback(pError);
			});
	}

	/**
	 * @return {boolean}
	 */
	onAfterSolve()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onAfterSolve:`);
		}
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onAfterSolveAsync(fCallback)
	{
		this.onAfterSolve();
		return fCallback();
	}

	/* -------------------------------------------------------------------------- */
	/*                     Code Section: Application Login                        */
	/* -------------------------------------------------------------------------- */

	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onBeforeLoginAsync(fCallback)
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onBeforeLoginAsync:`);
		}
		return fCallback();
	}

	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onLoginAsync(fCallback)
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onLoginAsync:`);
		}
		return fCallback();
	}

	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	loginAsync(fCallback)
	{
		const tmpAnticipate = this.fable.instantiateServiceProviderWithoutRegistration('Anticipate');

		let tmpCallback = fCallback;

		if (typeof(tmpCallback) !== 'function')
		{
			this.log.warn(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} loginAsync was called without a valid callback.  A callback will be generated but this could lead to race conditions.`);
			tmpCallback = (pError) =>
				{
					if (pError)
					{
						this.log.error(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} loginAsync Auto Callback Error: ${pError}`, pError);
					}
				};
		}

		tmpAnticipate.anticipate(this.onBeforeLoginAsync.bind(this));
		tmpAnticipate.anticipate(this.onLoginAsync.bind(this));
		tmpAnticipate.anticipate(this.onAfterLoginAsync.bind(this));

		// check and see if we should automatically trigger a data load
		if (this.options.AutoLoadDataAfterLogin)
		{
			tmpAnticipate.anticipate((fNext) =>
			{
				if (!this.isLoggedIn())
				{
					return fNext();
				}
				if (this.pict.LogNoisiness > 1)
				{
					this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} auto loading data after login...`);
				}
				//TODO: should data load errors funnel here? this creates a weird coupling between login and data load callbacks
				this.loadDataAsync((pError) =>
				{
					fNext(pError);
				});
			});
		}

		tmpAnticipate.wait(
			(pError) =>
			{
				if (this.pict.LogNoisiness > 2)
				{
					this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} loginAsync() complete.`);
				}
				this.lastLoginTimestamp = this.fable.log.getTimeStamp();
				return tmpCallback(pError);
			});
	}

	/**
	 * Check if the application state is logged in. Defaults to true. Override this method in your application based on login requirements.
	 *
	 * @return {boolean}
	 */
	isLoggedIn()
	{
		return true;
	}

	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onAfterLoginAsync(fCallback)
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onAfterLoginAsync:`);
		}
		return fCallback();
	}

	/* -------------------------------------------------------------------------- */
	/*                     Code Section: Application LoadData                     */
	/* -------------------------------------------------------------------------- */

	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onBeforeLoadDataAsync(fCallback)
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onBeforeLoadDataAsync:`);
		}
		return fCallback();
	}

	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onLoadDataAsync(fCallback)
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onLoadDataAsync:`);
		}
		return fCallback();
	}

	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	loadDataAsync(fCallback)
	{
		const tmpAnticipate = this.fable.instantiateServiceProviderWithoutRegistration('Anticipate');

		let tmpCallback = fCallback;

		if (typeof(tmpCallback) !== 'function')
		{
			this.log.warn(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} loadDataAsync was called without a valid callback.  A callback will be generated but this could lead to race conditions.`);
			tmpCallback = (pError) =>
				{
					if (pError)
					{
						this.log.error(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} loadDataAsync Auto Callback Error: ${pError}`, pError);
					}
				};
		}

		tmpAnticipate.anticipate(this.onBeforeLoadDataAsync.bind(this));

		// Walk through any loaded providers and load their data as well.
		let tmpLoadedProviders = Object.keys(this.pict.providers);
		let tmpProvidersToLoadData = [];
		for (let i = 0; i < tmpLoadedProviders.length; i++)
		{
			let tmpProvider = this.pict.providers[tmpLoadedProviders[i]];
			if (tmpProvider.options.AutoLoadDataWithApp)
			{
				tmpProvidersToLoadData.push(tmpProvider);
			}
		}
		// Sort the providers by their priority (if they are all priority 0, it will end up being add order due to JSON Object Property Key order stuff)
		tmpProvidersToLoadData.sort((a, b) => { return a.options.AutoLoadDataOrdinal - b.options.AutoLoadDataOrdinal; });

		for (const tmpProvider of tmpProvidersToLoadData)
		{
			tmpAnticipate.anticipate(tmpProvider.onBeforeLoadDataAsync.bind(tmpProvider));
		}

		tmpAnticipate.anticipate(this.onLoadDataAsync.bind(this));

		//TODO: think about ways to parallelize these
		for (const tmpProvider of tmpProvidersToLoadData)
		{
			tmpAnticipate.anticipate(tmpProvider.onLoadDataAsync.bind(tmpProvider));
		}

		tmpAnticipate.anticipate(this.onAfterLoadDataAsync.bind(this));

		for (const tmpProvider of tmpProvidersToLoadData)
		{
			tmpAnticipate.anticipate(tmpProvider.onAfterLoadDataAsync.bind(tmpProvider));
		}

		tmpAnticipate.wait(
			/** @param {Error} [pError] */
			(pError) =>
			{
				if (this.pict.LogNoisiness > 2)
				{
					this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} loadDataAsync() complete.`);
				}
				this.lastLoadDataTimestamp = this.fable.log.getTimeStamp();
				return tmpCallback(pError);
			});
	}

	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onAfterLoadDataAsync(fCallback)
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onAfterLoadDataAsync:`);
		}
		return fCallback();
	}

	/* -------------------------------------------------------------------------- */
	/*                     Code Section: Application SaveData                     */
	/* -------------------------------------------------------------------------- */

	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onBeforeSaveDataAsync(fCallback)
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onBeforeSaveDataAsync:`);
		}
		return fCallback();
	}

	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onSaveDataAsync(fCallback)
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onSaveDataAsync:`);
		}
		return fCallback();
	}

	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	saveDataAsync(fCallback)
	{
		const tmpAnticipate = this.fable.instantiateServiceProviderWithoutRegistration('Anticipate');

		let tmpCallback = fCallback;

		if (typeof(tmpCallback) !== 'function')
		{
			this.log.warn(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} saveDataAsync was called without a valid callback.  A callback will be generated but this could lead to race conditions.`);
			tmpCallback = (pError) =>
				{
					if (pError)
					{
						this.log.error(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} saveDataAsync Auto Callback Error: ${pError}`, pError);
					}
				};
		}

		tmpAnticipate.anticipate(this.onBeforeSaveDataAsync.bind(this));

		// Walk through any loaded providers and load their data as well.
		let tmpLoadedProviders = Object.keys(this.pict.providers);
		let tmpProvidersToSaveData = [];
		for (let i = 0; i < tmpLoadedProviders.length; i++)
		{
			let tmpProvider = this.pict.providers[tmpLoadedProviders[i]];
			if (tmpProvider.options.AutoSaveDataWithApp)
			{
				tmpProvidersToSaveData.push(tmpProvider);
			}
		}
		// Sort the providers by their priority (if they are all priority 0, it will end up being add order due to JSON Object Property Key order stuff)
		tmpProvidersToSaveData.sort((a, b) => { return a.options.AutoSaveDataOrdinal - b.options.AutoSaveDataOrdinal; });

		for (const tmpProvider of tmpProvidersToSaveData)
		{
			tmpAnticipate.anticipate(tmpProvider.onBeforeSaveDataAsync.bind(tmpProvider));
		}

		tmpAnticipate.anticipate(this.onSaveDataAsync.bind(this));

		//TODO: think about ways to parallelize these
		for (const tmpProvider of tmpProvidersToSaveData)
		{
			tmpAnticipate.anticipate(tmpProvider.onSaveDataAsync.bind(tmpProvider));
		}

		tmpAnticipate.anticipate(this.onAfterSaveDataAsync.bind(this));

		for (const tmpProvider of tmpProvidersToSaveData)
		{
			tmpAnticipate.anticipate(tmpProvider.onAfterSaveDataAsync.bind(tmpProvider));
		}

		tmpAnticipate.wait(
			/** @param {Error} [pError] */
			(pError) =>
			{
				if (this.pict.LogNoisiness > 2)
				{
					this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} saveDataAsync() complete.`);
				}
				this.lastSaveDataTimestamp = this.fable.log.getTimeStamp();
				return tmpCallback(pError);
			});
	}

	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onAfterSaveDataAsync(fCallback)
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onAfterSaveDataAsync:`);
		}
		return fCallback();
	}

	/* -------------------------------------------------------------------------- */
	/*                     Code Section: Initialize Application                   */
	/* -------------------------------------------------------------------------- */
	/**
	 * @return {boolean}
	 */
	onBeforeInitialize()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onBeforeInitialize:`);
		}
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onBeforeInitializeAsync(fCallback)
	{
		this.onBeforeInitialize();
		return fCallback();
	}

	/**
	 * @return {boolean}
	 */
	onInitialize()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onInitialize:`);
		}
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onInitializeAsync(fCallback)
	{
		this.onInitialize();
		return fCallback();
	}

	/**
	 * @return {boolean}
	 */
	initialize()
	{
		if (this.pict.LogControlFlow)
		{
			this.log.trace(`PICT-ControlFlow APPLICATION [${this.UUID}]::[${this.Hash}] ${this.options.Name} initialize:`);
		}

		if (!this.initializeTimestamp)
		{
			this.onBeforeInitialize();

			if ('ConfigurationOnlyViews' in this.options)
			{
				// Load all the configuration only views
				for (let i = 0; i < this.options.ConfigurationOnlyViews.length; i++)
				{
					let tmpViewIdentifier = (typeof(this.options.ConfigurationOnlyViews[i].ViewIdentifier) === 'undefined') ? `AutoView-${this.fable.getUUID()}`
											: this.options.ConfigurationOnlyViews[i].ViewIdentifier;
					this.log.info(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} adding configuration only view: ${tmpViewIdentifier}`);
					this.pict.addView(tmpViewIdentifier, this.options.ConfigurationOnlyViews[i]);
				}
			}

			this.onInitialize();

			// Walk through any loaded providers and initialize them as well.
			let tmpLoadedProviders = Object.keys(this.pict.providers);
			let tmpProvidersToInitialize = [];
			for (let i = 0; i < tmpLoadedProviders.length; i++)
			{
				let tmpProvider = this.pict.providers[tmpLoadedProviders[i]];
				if (tmpProvider.options.AutoInitialize)
				{
					tmpProvidersToInitialize.push(tmpProvider);
				}
			}
			// Sort the providers by their priority (if they are all priority 0, it will end up being add order due to JSON Object Property Key order stuff)
			tmpProvidersToInitialize.sort((a, b) => { return a.options.AutoInitializeOrdinal - b.options.AutoInitializeOrdinal; });
			for (let i = 0; i < tmpProvidersToInitialize.length; i++)
			{
				tmpProvidersToInitialize[i].initialize();
			}

			// Now walk through any loaded views and initialize them as well.
			let tmpLoadedViews = Object.keys(this.pict.views);
			let tmpViewsToInitialize = [];
			for (let i = 0; i < tmpLoadedViews.length; i++)
			{
				let tmpView = this.pict.views[tmpLoadedViews[i]];
				if (tmpView.options.AutoInitialize)
				{
					tmpViewsToInitialize.push(tmpView);
				}
			}
			// Sort the views by their priority (if they are all priority 0, it will end up being add order due to JSON Object Property Key order stuff)
			tmpViewsToInitialize.sort((a, b) => { return a.options.AutoInitializeOrdinal - b.options.AutoInitializeOrdinal; });
			for (let i = 0; i < tmpViewsToInitialize.length; i++)
			{
				tmpViewsToInitialize[i].initialize();
			}

			this.onAfterInitialize();
			if (this.options.AutoSolveAfterInitialize)
			{
				if (this.pict.LogNoisiness > 1)
				{
					this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} auto solving after initialization...`);
				}
				// Solve the template synchronously
				this.solve();
			}
			// Now check and see if we should automatically render as well
			if (this.options.AutoRenderMainViewportViewAfterInitialize)
			{
				if (this.pict.LogNoisiness > 1)
				{
					this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} auto rendering after initialization...`);
				}
				// Render the template synchronously
				this.render();
			}
			this.initializeTimestamp = this.fable.log.getTimeStamp();
			this.onCompletionOfInitialize();
			return true;
		}
		else
		{
			this.log.warn(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} initialize called but initialization is already completed.  Aborting.`);
			return false;
		}
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	initializeAsync(fCallback)
	{
		if (this.pict.LogControlFlow)
		{
			this.log.trace(`PICT-ControlFlow APPLICATION [${this.UUID}]::[${this.Hash}] ${this.options.Name} initializeAsync:`);
		}

		// Allow the callback to be passed in as the last parameter no matter what
		let tmpCallback = (typeof(fCallback) === 'function') ? fCallback : false;

		if (!tmpCallback)
		{
			this.log.warn(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} initializeAsync was called without a valid callback.  A callback will be generated but this could lead to race conditions.`);
			tmpCallback = (pError) =>
				{
					if (pError)
					{
						this.log.error(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} initializeAsync Auto Callback Error: ${pError}`, pError)
					}
				};
		}

		if (!this.initializeTimestamp)
		{
			let tmpAnticipate = this.fable.instantiateServiceProviderWithoutRegistration('Anticipate');

			if (this.pict.LogNoisiness > 3)
			{
				this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} beginning initialization...`);
			}

			if ('ConfigurationOnlyViews' in this.options)
			{
				// Load all the configuration only views
				for (let i = 0; i < this.options.ConfigurationOnlyViews.length; i++)
				{
					let tmpViewIdentifier = (typeof(this.options.ConfigurationOnlyViews[i].ViewIdentifier) === 'undefined') ? `AutoView-${this.fable.getUUID()}`
											: this.options.ConfigurationOnlyViews[i].ViewIdentifier;
					this.log.info(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} adding configuration only view: ${tmpViewIdentifier}`);
					this.pict.addView(tmpViewIdentifier, this.options.ConfigurationOnlyViews[i]);
				}
			}

			tmpAnticipate.anticipate(this.onBeforeInitializeAsync.bind(this));
			tmpAnticipate.anticipate(this.onInitializeAsync.bind(this));

			// Walk through any loaded providers and solve them as well.
			let tmpLoadedProviders = Object.keys(this.pict.providers);
			let tmpProvidersToInitialize = [];
			for (let i = 0; i < tmpLoadedProviders.length; i++)
			{
				let tmpProvider = this.pict.providers[tmpLoadedProviders[i]];
				if (tmpProvider.options.AutoInitialize)
				{
					tmpProvidersToInitialize.push(tmpProvider);
				}
			}
			// Sort the providers by their priority (if they are all priority 0, it will end up being add order due to JSON Object Property Key order stuff)
			tmpProvidersToInitialize.sort((a, b) => { return a.options.AutoInitializeOrdinal - b.options.AutoInitializeOrdinal; });
			for (let i = 0; i < tmpProvidersToInitialize.length; i++)
			{
				tmpAnticipate.anticipate(tmpProvidersToInitialize[i].initializeAsync.bind(tmpProvidersToInitialize[i]));
			}

			// Now walk through any loaded views and initialize them as well.
			// TODO: Some optimization cleverness could be gained by grouping them into a parallelized async operation, by ordinal.
			let tmpLoadedViews = Object.keys(this.pict.views);
			let tmpViewsToInitialize = [];
			for (let i = 0; i < tmpLoadedViews.length; i++)
			{
				let tmpView = this.pict.views[tmpLoadedViews[i]];
				if (tmpView.options.AutoInitialize)
				{
					tmpViewsToInitialize.push(tmpView);
				}
			}
			// Sort the views by their priority
			// If they are all the default priority 0, it will end up being add order due to JSON Object Property Key order stuff
			tmpViewsToInitialize.sort((a, b) => { return a.options.AutoInitializeOrdinal - b.options.AutoInitializeOrdinal; });
			for (let i = 0; i < tmpViewsToInitialize.length; i++)
			{
				let tmpView = tmpViewsToInitialize[i];
				tmpAnticipate.anticipate(tmpView.initializeAsync.bind(tmpView));
			}

			tmpAnticipate.anticipate(this.onAfterInitializeAsync.bind(this));

			if (this.options.AutoLoginAfterInitialize)
			{
				if (this.pict.LogNoisiness > 1)
				{
					this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} auto login (asynchronously) after initialization...`);
				}
				tmpAnticipate.anticipate(this.loginAsync.bind(this));
			}

			if (this.options.AutoSolveAfterInitialize)
			{
				if (this.pict.LogNoisiness > 1)
				{
					this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} auto solving (asynchronously) after initialization...`);
				}
				tmpAnticipate.anticipate(this.solveAsync.bind(this));
			}

			if (this.options.AutoRenderMainViewportViewAfterInitialize)
			{
				if (this.pict.LogNoisiness > 1)
				{
					this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} auto rendering (asynchronously) after initialization...`);
				}
				tmpAnticipate.anticipate(this.renderMainViewportAsync.bind(this));
			}

			tmpAnticipate.wait(
				(pError) =>
				{
					if (pError)
					{
						this.log.error(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} initializeAsync Error: ${pError.message || pError}`, { stack: pError.stack });
					}
					this.initializeTimestamp = this.fable.log.getTimeStamp();
					if (this.pict.LogNoisiness > 2)
					{
						this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} initialization complete.`);
					}
					return tmpCallback();
				});
		}
		else
		{
			this.log.warn(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} async initialize called but initialization is already completed.  Aborting.`);
			// TODO: Should this be an error?
			return this.onCompletionOfInitializeAsync(tmpCallback);
		}
	}

	/**
	 * @return {boolean}
	 */
	onAfterInitialize()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onAfterInitialize:`);
		}
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onAfterInitializeAsync(fCallback)
	{
		this.onAfterInitialize();
		return fCallback();
	}


	/**
	 * @return {boolean}
	 */
	onCompletionOfInitialize()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onCompletionOfInitialize:`);
		}
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onCompletionOfInitializeAsync(fCallback)
	{
		this.onCompletionOfInitialize();
		return fCallback();
	}

	/* -------------------------------------------------------------------------- */
	/*                     Code Section: Marshal Data From All Views              */
	/* -------------------------------------------------------------------------- */
	/**
	 * @return {boolean}
	 */
	onBeforeMarshalFromViews()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onBeforeMarshalFromViews:`);
		}
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onBeforeMarshalFromViewsAsync(fCallback)
	{
		this.onBeforeMarshalFromViews();
		return fCallback();
	}

	/**
	 * @return {boolean}
	 */
	onMarshalFromViews()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onMarshalFromViews:`);
		}
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onMarshalFromViewsAsync(fCallback)
	{
		this.onMarshalFromViews();
		return fCallback();
	}

	/**
	 * @return {boolean}
	 */
	marshalFromViews()
	{
		if (this.pict.LogNoisiness > 2)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} executing marshalFromViews() function...`)
		}
		this.onBeforeMarshalFromViews();
		// Now walk through any loaded views and initialize them as well.
		let tmpLoadedViews = Object.keys(this.pict.views);
		let tmpViewsToMarshalFromViews = [];
		for (let i = 0; i < tmpLoadedViews.length; i++)
		{
			let tmpView = this.pict.views[tmpLoadedViews[i]];
			tmpViewsToMarshalFromViews.push(tmpView);
		}
		for (let i = 0; i < tmpViewsToMarshalFromViews.length; i++)
		{
			tmpViewsToMarshalFromViews[i].marshalFromView();
		}
		this.onMarshalFromViews();
		this.onAfterMarshalFromViews();
		this.lastMarshalFromViewsTimestamp = this.fable.log.getTimeStamp();
		return true;
	}

	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	marshalFromViewsAsync(fCallback)
	{
		let tmpAnticipate = this.fable.instantiateServiceProviderWithoutRegistration('Anticipate');

		// Allow the callback to be passed in as the last parameter no matter what
		let tmpCallback = (typeof(fCallback) === 'function') ? fCallback : false;

		if (!tmpCallback)
		{
			this.log.warn(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} marshalFromViewsAsync was called without a valid callback.  A callback will be generated but this could lead to race conditions.`);
			tmpCallback = (pError) =>
				{
					if (pError)
					{
						this.log.error(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} marshalFromViewsAsync Auto Callback Error: ${pError}`, pError)
					}
				};
		}

		tmpAnticipate.anticipate(this.onBeforeMarshalFromViewsAsync.bind(this));
		// Walk through any loaded views and marshalFromViews them as well.
		let tmpLoadedViews = Object.keys(this.pict.views);
		let tmpViewsToMarshalFromViews = [];
		for (let i = 0; i < tmpLoadedViews.length; i++)
		{
			let tmpView = this.pict.views[tmpLoadedViews[i]];
			tmpViewsToMarshalFromViews.push(tmpView);
		}
		for (let i = 0; i < tmpViewsToMarshalFromViews.length; i++)
		{
			tmpAnticipate.anticipate(tmpViewsToMarshalFromViews[i].marshalFromViewAsync.bind(tmpViewsToMarshalFromViews[i]));
		}
		tmpAnticipate.anticipate(this.onMarshalFromViewsAsync.bind(this));
		tmpAnticipate.anticipate(this.onAfterMarshalFromViewsAsync.bind(this));

		tmpAnticipate.wait(
			(pError) =>
			{
				if (this.pict.LogNoisiness > 2)
				{
					this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} marshalFromViewsAsync() complete.`);
				}
				this.lastMarshalFromViewsTimestamp = this.fable.log.getTimeStamp();
				return tmpCallback(pError);
			});
	}

	/**
	 * @return {boolean}
	 */
	onAfterMarshalFromViews()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onAfterMarshalFromViews:`);
		}
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onAfterMarshalFromViewsAsync(fCallback)
	{
		this.onAfterMarshalFromViews();
		return fCallback();
	}

	/* -------------------------------------------------------------------------- */
	/*                     Code Section: Marshal Data To All Views                */
	/* -------------------------------------------------------------------------- */
	/**
	 * @return {boolean}
	 */
	onBeforeMarshalToViews()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onBeforeMarshalToViews:`);
		}
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onBeforeMarshalToViewsAsync(fCallback)
	{
		this.onBeforeMarshalToViews();
		return fCallback();
	}

	/**
	 * @return {boolean}
	 */
	onMarshalToViews()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onMarshalToViews:`);
		}
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onMarshalToViewsAsync(fCallback)
	{
		this.onMarshalToViews();
		return fCallback();
	}

	/**
	 * @return {boolean}
	 */
	marshalToViews()
	{
		if (this.pict.LogNoisiness > 2)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} executing marshalToViews() function...`)
		}
		this.onBeforeMarshalToViews();
		// Now walk through any loaded views and initialize them as well.
		let tmpLoadedViews = Object.keys(this.pict.views);
		let tmpViewsToMarshalToViews = [];
		for (let i = 0; i < tmpLoadedViews.length; i++)
		{
			let tmpView = this.pict.views[tmpLoadedViews[i]];
			tmpViewsToMarshalToViews.push(tmpView);
		}
		for (let i = 0; i < tmpViewsToMarshalToViews.length; i++)
		{
			tmpViewsToMarshalToViews[i].marshalToView();
		}
		this.onMarshalToViews();
		this.onAfterMarshalToViews();
		this.lastMarshalToViewsTimestamp = this.fable.log.getTimeStamp();
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	marshalToViewsAsync(fCallback)
	{
		let tmpAnticipate = this.fable.instantiateServiceProviderWithoutRegistration('Anticipate');

		// Allow the callback to be passed in as the last parameter no matter what
		let tmpCallback = (typeof(fCallback) === 'function') ? fCallback : false;

		if (!tmpCallback)
		{
			this.log.warn(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} marshalToViewsAsync was called without a valid callback.  A callback will be generated but this could lead to race conditions.`);
			tmpCallback = (pError) =>
				{
					if (pError)
					{
						this.log.error(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} marshalToViewsAsync Auto Callback Error: ${pError}`, pError)
					}
				};
		}

		tmpAnticipate.anticipate(this.onBeforeMarshalToViewsAsync.bind(this));
		// Walk through any loaded views and marshalToViews them as well.
		let tmpLoadedViews = Object.keys(this.pict.views);
		let tmpViewsToMarshalToViews = [];
		for (let i = 0; i < tmpLoadedViews.length; i++)
		{
			let tmpView = this.pict.views[tmpLoadedViews[i]];
			tmpViewsToMarshalToViews.push(tmpView);
		}
		for (let i = 0; i < tmpViewsToMarshalToViews.length; i++)
		{
			tmpAnticipate.anticipate(tmpViewsToMarshalToViews[i].marshalToViewAsync.bind(tmpViewsToMarshalToViews[i]));
		}
		tmpAnticipate.anticipate(this.onMarshalToViewsAsync.bind(this));
		tmpAnticipate.anticipate(this.onAfterMarshalToViewsAsync.bind(this));

		tmpAnticipate.wait(
			(pError) =>
			{
				if (this.pict.LogNoisiness > 2)
				{
					this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} marshalToViewsAsync() complete.`);
				}
				this.lastMarshalToViewsTimestamp = this.fable.log.getTimeStamp();
				return tmpCallback(pError);
			});
	}

	/**
	 * @return {boolean}
	 */
	onAfterMarshalToViews()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onAfterMarshalToViews:`);
		}
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onAfterMarshalToViewsAsync(fCallback)
	{
		this.onAfterMarshalToViews();
		return fCallback();
	}

	/* -------------------------------------------------------------------------- */
	/*                     Code Section: Render View                              */
	/* -------------------------------------------------------------------------- */
	/**
	 * @return {boolean}
	 */
	onBeforeRender()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onBeforeRender:`);
		}
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onBeforeRenderAsync(fCallback)
	{
		this.onBeforeRender();
		return fCallback();
	}

	/**
	 * @param {string} [pViewIdentifier] - The hash of the view to render. By default, the main viewport view is rendered.
	 * @param {string} [pRenderableHash] - The hash of the renderable to render.
	 * @param {string} [pRenderDestinationAddress] - The address where the renderable will be rendered.
	 * @param {string} [pTemplateDataAddress] - The address where the data for the template is stored.
	 *
	 * TODO: Should we support objects for pTemplateDataAddress for parity with pict-view?
	 */
	render(pViewIdentifier, pRenderableHash, pRenderDestinationAddress, pTemplateDataAddress)
	{
		let tmpViewIdentifier = (typeof(pViewIdentifier) !== 'string') ? this.options.MainViewportViewIdentifier : pViewIdentifier;
		let tmpRenderableHash = (typeof(pRenderableHash) !== 'string') ? this.options.MainViewportRenderableHash : pRenderableHash;
		let tmpRenderDestinationAddress = (typeof(pRenderDestinationAddress) !== 'string') ? this.options.MainViewportDestinationAddress : pRenderDestinationAddress;
		let tmpTemplateDataAddress = (typeof(pTemplateDataAddress) !== 'string') ? this.options.MainViewportDefaultDataAddress : pTemplateDataAddress;

		if (this.pict.LogControlFlow)
		{
			this.log.trace(`PICT-ControlFlow APPLICATION [${this.UUID}]::[${this.Hash}] ${this.options.Name} VIEW Renderable[${tmpRenderableHash}] Destination[${tmpRenderDestinationAddress}] TemplateDataAddress[${tmpTemplateDataAddress}] render:`);
		}

		this.onBeforeRender();

		// Now get the view (by hash) from the loaded views
		let tmpView = (typeof (tmpViewIdentifier) === 'string') ? this.servicesMap.PictView[tmpViewIdentifier] : false;
		if (!tmpView)
		{
			this.log.error(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} could not render from View ${tmpViewIdentifier} because it is not a valid view.`);
			return false;
		}

		this.onRender();

		tmpView.render(tmpRenderableHash, tmpRenderDestinationAddress, tmpTemplateDataAddress);

		this.onAfterRender();

		return true;
	}
	/**
	 * @return {boolean}
	 */
	onRender()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onRender:`);
		}
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onRenderAsync(fCallback)
	{
		this.onRender();
		return fCallback();
	}

	/**
	 * @param {string|((error?: Error) => void)} pViewIdentifier - The hash of the view to render. By default, the main viewport view is rendered. (or the callback)
	 * @param {string|((error?: Error) => void)} [pRenderableHash] - The hash of the renderable to render. (or the callback)
	 * @param {string|((error?: Error) => void)} [pRenderDestinationAddress] - The address where the renderable will be rendered. (or the callback)
	 * @param {string|((error?: Error) => void)} [pTemplateDataAddress] - The address where the data for the template is stored. (or the callback)
	 * @param {(error?: Error) => void} [fCallback] - The callback, if all other parameters are provided.
	 *
	 * TODO: Should we support objects for pTemplateDataAddress for parity with pict-view?
	 */
	renderAsync(pViewIdentifier, pRenderableHash, pRenderDestinationAddress, pTemplateDataAddress, fCallback)
	{
		let tmpViewIdentifier = (typeof(pViewIdentifier) !== 'string') ? this.options.MainViewportViewIdentifier : pViewIdentifier;
		let tmpRenderableHash = (typeof(pRenderableHash) !== 'string') ? this.options.MainViewportRenderableHash : pRenderableHash;
		let tmpRenderDestinationAddress = (typeof(pRenderDestinationAddress) !== 'string') ? this.options.MainViewportDestinationAddress : pRenderDestinationAddress;
		let tmpTemplateDataAddress = (typeof(pTemplateDataAddress) !== 'string') ? this.options.MainViewportDefaultDataAddress : pTemplateDataAddress;

		// Allow the callback to be passed in as the last parameter no matter what
		let tmpCallback = (typeof(fCallback) === 'function') ? fCallback :
							(typeof(pTemplateDataAddress) === 'function') ? pTemplateDataAddress :
							(typeof(pRenderDestinationAddress) === 'function') ? pRenderDestinationAddress :
							(typeof(pRenderableHash) === 'function') ? pRenderableHash :
							(typeof(pViewIdentifier) === 'function') ? pViewIdentifier :
							false;

		if (!tmpCallback)
		{
			this.log.warn(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} renderAsync was called without a valid callback.  A callback will be generated but this could lead to race conditions.`);
			tmpCallback = (pError) =>
				{
					if (pError)
					{
						this.log.error(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} renderAsync Auto Callback Error: ${pError}`, pError)
					}
				};
		}

		if (this.pict.LogControlFlow)
		{
			this.log.trace(`PICT-ControlFlow APPLICATION [${this.UUID}]::[${this.Hash}] ${this.options.Name} VIEW Renderable[${tmpRenderableHash}] Destination[${tmpRenderDestinationAddress}] TemplateDataAddress[${tmpTemplateDataAddress}] renderAsync:`);
		}

		let tmpRenderAnticipate = this.fable.newAnticipate();

		tmpRenderAnticipate.anticipate(this.onBeforeRenderAsync.bind(this));

		let tmpView = (typeof (tmpViewIdentifier) === 'string') ? this.servicesMap.PictView[tmpViewIdentifier] : false;
		if (!tmpView)
		{
			let tmpErrorMessage = `PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} could not asynchronously render from View ${tmpViewIdentifier} because it is not a valid view.`;
			if (this.pict.LogNoisiness > 3)
			{
				this.log.error(tmpErrorMessage);
			}
			return tmpCallback(new Error(tmpErrorMessage));
		}

		tmpRenderAnticipate.anticipate(this.onRenderAsync.bind(this));

		tmpRenderAnticipate.anticipate(
			(fNext) =>
			{
				tmpView.renderAsync.call(tmpView, tmpRenderableHash, tmpRenderDestinationAddress, tmpTemplateDataAddress, fNext);
			});

		tmpRenderAnticipate.anticipate(this.onAfterRenderAsync.bind(this));

		return tmpRenderAnticipate.wait(tmpCallback);
	}

	/**
	 * @return {boolean}
	 */
	onAfterRender()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} onAfterRender:`);
		}
		return true;
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	onAfterRenderAsync(fCallback)
	{
		this.onAfterRender();
		return fCallback();
	}

	/**
	 * @return {boolean}
	 */
	renderMainViewport()
	{
		if (this.pict.LogControlFlow)
		{
			this.log.trace(`PICT-ControlFlow APPLICATION [${this.UUID}]::[${this.Hash}] ${this.options.Name} renderMainViewport:`);
		}

		return this.render();
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	renderMainViewportAsync(fCallback)
	{
		if (this.pict.LogControlFlow)
		{
			this.log.trace(`PICT-ControlFlow APPLICATION [${this.UUID}]::[${this.Hash}] ${this.options.Name} renderMainViewportAsync:`);
		}

		return this.renderAsync(fCallback);
	}
	/**
	 * @return {void}
	 */
	renderAutoViews()
	{
		if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} beginning renderAutoViews...`);
		}
		// Now walk through any loaded views and sort them by the AutoRender ordinal
		let tmpLoadedViews = Object.keys(this.pict.views);
		// Sort the views by their priority
		// If they are all the default priority 0, it will end up being add order due to JSON Object Property Key order stuff
		tmpLoadedViews.sort((a, b) =>
		{
			return this.pict.views[a].options.AutoRenderOrdinal - this.pict.views[b].options.AutoRenderOrdinal;
		});
		for (let i = 0; i < tmpLoadedViews.length; i++)
		{
			let tmpView = this.pict.views[tmpLoadedViews[i]];
			if (tmpView.options.AutoRender)
			{
				tmpView.render();
			}
		}
		if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} renderAutoViewsAsync complete.`);
		}
	}
	/**
	 * @param {(error?: Error) => void} fCallback
	 */
	renderAutoViewsAsync(fCallback)
	{
		let tmpAnticipate = this.fable.instantiateServiceProviderWithoutRegistration('Anticipate');

		// Allow the callback to be passed in as the last parameter no matter what
		let tmpCallback = (typeof(fCallback) === 'function') ? fCallback :
							false;

		if (!tmpCallback)
		{
			this.log.warn(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} renderAutoViewsAsync was called without a valid callback.  A callback will be generated but this could lead to race conditions.`);
			tmpCallback = (pError) =>
				{
					if (pError)
					{
						this.log.error(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} renderAutoViewsAsync Auto Callback Error: ${pError}`, pError)
					}
				};
		}

		if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} beginning renderAutoViewsAsync...`);
		}

		// Now walk through any loaded views and sort them by the AutoRender ordinal
		// TODO: Some optimization cleverness could be gained by grouping them into a parallelized async operation, by ordinal.
		let tmpLoadedViews = Object.keys(this.pict.views);
		// Sort the views by their priority
		// If they are all the default priority 0, it will end up being add order due to JSON Object Property Key order stuff
		tmpLoadedViews.sort((a, b) =>
		{
			return this.pict.views[a].options.AutoRenderOrdinal - this.pict.views[b].options.AutoRenderOrdinal;
		});
		for (let i = 0; i < tmpLoadedViews.length; i++)
		{
			let tmpView = this.pict.views[tmpLoadedViews[i]];
			if (tmpView.options.AutoRender)
			{
				tmpAnticipate.anticipate(tmpView.renderAsync.bind(tmpView));
			}
		}

		tmpAnticipate.wait(
			(pError) =>
			{
				this.lastAutoRenderTimestamp = this.fable.log.getTimeStamp();
				if (this.pict.LogNoisiness > 0)
				{
					this.log.trace(`PictApp [${this.UUID}]::[${this.Hash}] ${this.options.Name} renderAutoViewsAsync complete.`);
				}
				return tmpCallback(pError);
			});
	}

	/**
	 * @return {boolean}
	 */
	get isPictApplication()
	{
		return true;
	}
}

module.exports = PictApplication;

},{"../package.json":139,"fable-serviceproviderbase":59}],141:[function(require,module,exports){
module.exports={
  "_from": "pict-provider@^1.0.13",
  "_id": "pict-provider@1.0.13",
  "_inBundle": false,
  "_integrity": "sha512-MRNtnuFfQYyM6pDTfth9XQETUkN91m1sVPRfgurZkrlsh8Cd9uvCgBQWfjQWjqwAHxKCIrp+QJcij2nNB81NsA==",
  "_location": "/pict-provider",
  "_phantomChildren": {},
  "_requested": {
    "type": "range",
    "registry": true,
    "raw": "pict-provider@^1.0.13",
    "name": "pict-provider",
    "escapedName": "pict-provider",
    "rawSpec": "^1.0.13",
    "saveSpec": null,
    "fetchSpec": "^1.0.13"
  },
  "_requiredBy": [
    "/",
    "/bibliograph",
    "/meadow-migrationmanager/pict-section-flow",
    "/pict",
    "/pict-docuserve",
    "/pict-provider-theme",
    "/pict-section-content",
    "/pict-section-flow",
    "/pict-section-form",
    "/pict-section-theme",
    "/quackage/pict-provider-theme"
  ],
  "_resolved": "https://registry.npmjs.org/pict-provider/-/pict-provider-1.0.13.tgz",
  "_shasum": "af7bc4353d0381812d86a671d2a0da08c038c80c",
  "_spec": "pict-provider@^1.0.13",
  "_where": "/Users/jacksonpollard/pict",
  "author": {
    "name": "steven velozo",
    "email": "steven@velozo.com"
  },
  "bugs": {
    "url": "https://github.com/stevenvelozo/pict-provider/issues"
  },
  "bundleDependencies": false,
  "dependencies": {
    "fable-serviceproviderbase": "^3.0.19"
  },
  "deprecated": false,
  "description": "Pict Provider Base Class",
  "devDependencies": {
    "@eslint/js": "^9.39.1",
    "eslint": "^9.39.1",
    "pict": "^1.0.351",
    "pict-docuserve": "^0.1.5",
    "quackage": "^1.1.0",
    "typescript": "^5.9.3"
  },
  "homepage": "https://github.com/stevenvelozo/pict-provider#readme",
  "license": "MIT",
  "main": "source/Pict-Provider.js",
  "mocha": {
    "diff": true,
    "extension": [
      "js"
    ],
    "package": "./package.json",
    "reporter": "spec",
    "slow": "75",
    "timeout": "5000",
    "ui": "tdd",
    "watch-files": [
      "source/**/*.js",
      "test/**/*.js"
    ],
    "watch-ignore": [
      "lib/vendor"
    ]
  },
  "name": "pict-provider",
  "repository": {
    "type": "git",
    "url": "git+https://github.com/stevenvelozo/pict-provider.git"
  },
  "scripts": {
    "build": "npx quack build",
    "coverage": "npx quack coverage",
    "docker-dev-build": "docker build ./ -f Dockerfile_LUXURYCode -t pict-provider-image:local",
    "docker-dev-run": "docker run -it -d --name pict-provider-dev -p 24125:8080 -p 30027:8086 -v \"$PWD/.config:/home/coder/.config\"  -v \"$PWD:/home/coder/pict-provider\" -u \"$(id -u):$(id -g)\" -e \"DOCKER_USER=$USER\" pict-provider-image:local",
    "docker-dev-shell": "docker exec -it pict-provider-dev /bin/bash",
    "lint": "eslint source/**",
    "start": "node source/Pict-Provider.js",
    "test": "npx quack test",
    "tests": "npx quack test -g",
    "types": "tsc -p ."
  },
  "types": "types/source/Pict-Provider.d.ts",
  "version": "1.0.13"
}

},{}],142:[function(require,module,exports){
const libFableServiceBase = require('fable-serviceproviderbase');

const libPackage = require('../package.json');

const defaultPictProviderSettings = (
	{
		ProviderIdentifier: false,

		// If this is set to true, when the App initializes this will.
		// After the App initializes, initialize will be called as soon as it's added.
		AutoInitialize: true,
		AutoInitializeOrdinal: 0,

		AutoLoadDataWithApp: true,
		AutoLoadDataOrdinal: 0,

		AutoSolveWithApp: true,
		AutoSolveOrdinal: 0,

		Manifests: {},

		Templates: []
	});

class PictProvider extends libFableServiceBase
{
	/**
	 * @param {import('fable')} pFable - The Fable instance.
	 * @param {Record<string, any>} [pOptions] - The options for the provider.
	 * @param {string} [pServiceHash] - The service hash for the provider.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		// Intersect default options, parent constructor, service information
		let tmpOptions = Object.assign({}, JSON.parse(JSON.stringify(defaultPictProviderSettings)), pOptions);
		super(pFable, tmpOptions, pServiceHash);

		/** @type {import('fable') & import('pict') & { instantiateServiceProviderWithoutRegistration(pServiceType: string, pOptions?: Record<string, any>, pCustomServiceHash?: string): any }} */
		this.fable;
		/** @type {import('fable') & import('pict') & { instantiateServiceProviderWithoutRegistration(pServiceType: string, pOptions?: Record<string, any>, pCustomServiceHash?: string): any }} */
		this.pict;
		/** @type {any} */
		this.log;
		/** @type {Record<string, any>} */
		this.options;
		/** @type {string} */
		this.UUID;
		/** @type {string} */
		this.Hash;

		if (!this.options.ProviderIdentifier)
		{
			this.options.ProviderIdentifier = `AutoProviderID-${this.fable.getUUID()}`;
		}

		this.serviceType = 'PictProvider';
		/** @type {Record<string, any>} */
		this._Package = libPackage;

		// Convenience and consistency naming
		this.pict = this.fable;

		// Wire in the essential Pict application state
		/** @type {Record<string, any>} */
		this.AppData = this.pict.AppData;
		/** @type {Record<string, any>} */
		this.Bundle = this.pict.Bundle;

		this.initializeTimestamp = false;
		this.lastSolvedTimestamp = false;

		for (let i = 0; i < this.options.Templates.length; i++)
		{
			let tmpDefaultTemplate = this.options.Templates[i];

			if (!tmpDefaultTemplate.hasOwnProperty('Postfix') || !tmpDefaultTemplate.hasOwnProperty('Template'))
			{
				this.log.error(`PictProvider [${this.UUID}]::[${this.Hash}] ${this.options.ProviderIdentifier} could not load Default Template ${i} in the options array.`, tmpDefaultTemplate);
			}
			else
			{
				if (!tmpDefaultTemplate.Source)
				{
					tmpDefaultTemplate.Source = `PictProvider [${this.UUID}]::[${this.Hash}] ${this.options.ProviderIdentifier} options object.`;
				}
				this.pict.TemplateProvider.addDefaultTemplate(tmpDefaultTemplate.Prefix, tmpDefaultTemplate.Postfix, tmpDefaultTemplate.Template, tmpDefaultTemplate.Source);
			}
		}
	}

	/* -------------------------------------------------------------------------- */
	/*                        Code Section: Initialization                        */
	/* -------------------------------------------------------------------------- */
	onBeforeInitialize()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictProvider [${this.UUID}]::[${this.Hash}] ${this.options.ProviderIdentifier} onBeforeInitialize:`);
		}
		return true;
	}

	/**
	 * @param {(pError?: Error) => void} fCallback - The callback to call after pre-pinitialization.
	 *
	 * @return {void}
	 */
	onBeforeInitializeAsync(fCallback)
	{
		this.onBeforeInitialize();
		return fCallback();
	}

	onInitialize()
	{

		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictProvider [${this.UUID}]::[${this.Hash}] ${this.options.ProviderIdentifier} onInitialize:`);
		}
		return true;
	}

	/**
	 * @param {(pError?: Error) => void} fCallback - The callback to call after initialization.
	 *
	 * @return {void}
	 */
	onInitializeAsync(fCallback)
	{
		this.onInitialize();
		return fCallback();
	}

	initialize()
	{
		if (this.pict.LogControlFlow)
		{
			this.log.trace(`PICT-ControlFlow PROVIDER [${this.UUID}]::[${this.Hash}] ${this.options.ProviderIdentifier} initialize:`);
		}

		if (!this.initializeTimestamp)
		{
			this.onBeforeInitialize();
			this.onInitialize();
			this.onAfterInitialize();
			this.initializeTimestamp = this.pict.log.getTimeStamp();
			return true;
		}
		else
		{
			this.log.warn(`PictProvider [${this.UUID}]::[${this.Hash}] ${this.options.ProviderIdentifier} initialize called but initialization is already completed.  Aborting.`);
			return false;
		}
	}

	/**
	 * @param {(pError?: Error) => void} fCallback - The callback to call after initialization.
	 *
	 * @return {void}
	 */
	initializeAsync(fCallback)
	{
		if (this.pict.LogControlFlow)
		{
			this.log.trace(`PICT-ControlFlow PROVIDER [${this.UUID}]::[${this.Hash}] ${this.options.ProviderIdentifier} initializeAsync:`);
		}

		if (!this.initializeTimestamp)
		{
			let tmpAnticipate = this.pict.instantiateServiceProviderWithoutRegistration('Anticipate');

			if (this.pict.LogNoisiness > 0)
			{
				this.log.info(`PictProvider [${this.UUID}]::[${this.Hash}] ${this.options.ProviderIdentifier} beginning initialization...`);
			}

			tmpAnticipate.anticipate(this.onBeforeInitializeAsync.bind(this));
			tmpAnticipate.anticipate(this.onInitializeAsync.bind(this));
			tmpAnticipate.anticipate(this.onAfterInitializeAsync.bind(this));

			tmpAnticipate.wait(
				(pError) =>
				{
					this.initializeTimestamp = this.pict.log.getTimeStamp();
					if (pError)
					{
						this.log.error(`PictProvider [${this.UUID}]::[${this.Hash}] ${this.options.ProviderIdentifier} initialization failed: ${pError.message || pError}`, { Stack: pError.stack });
					}
					else if (this.pict.LogNoisiness > 0)
					{
						this.log.info(`PictProvider [${this.UUID}]::[${this.Hash}] ${this.options.ProviderIdentifier} initialization complete.`);
					}
					return fCallback();
				})
		}
		else
		{
			this.log.warn(`PictProvider [${this.UUID}]::[${this.Hash}] ${this.options.ProviderIdentifier} async initialize called but initialization is already completed.  Aborting.`);
			// TODO: Should this be an error?
			return fCallback();
		}
	}

	onAfterInitialize()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictProvider [${this.UUID}]::[${this.Hash}] ${this.options.ProviderIdentifier} onAfterInitialize:`);
		}
		return true;
	}

	/**
	 * @param {(pError?: Error) => void} fCallback - The callback to call after initialization.
	 *
	 * @return {void}
	 */
	onAfterInitializeAsync(fCallback)
	{
		this.onAfterInitialize();
		return fCallback();
	}

	onPreRender()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictProvider [${this.UUID}]::[${this.Hash}] ${this.options.ProviderIdentifier} onPreRender:`);
		}
		return true;
	}

	/**
	 * @param {(pError?: Error) => void} fCallback - The callback to call after pre-render.
	 *
	 * @return {void}
	 */
	onPreRenderAsync(fCallback)
	{
		this.onPreRender();
		return fCallback();
	}

	render()
	{
		return this.onPreRender();
	}

	/**
	 * @param {(pError?: Error) => void} fCallback - The callback to call after render.
	 *
	 * @return {void}
	 */
	renderAsync(fCallback)
	{
		this.onPreRender();
		return fCallback();
	}

	onPreSolve()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictProvider [${this.UUID}]::[${this.Hash}] ${this.options.ProviderIdentifier} onPreSolve:`);
		}
		return true;
	}

	/**
	 * @param {(pError?: Error) => void} fCallback - The callback to call after pre-solve.
	 *
	 * @return {void}
	 */
	onPreSolveAsync(fCallback)
	{
		this.onPreSolve();
		return fCallback();
	}

	solve()
	{
		return this.onPreSolve();
	}

	/**
	 * @param {(pError?: Error) => void} fCallback - The callback to call after solve.
	 *
	 * @return {void}
	 */
	solveAsync(fCallback)
	{
		this.onPreSolve();
		return fCallback();
	}

	/**
	 * @param {(pError?: Error) => void} fCallback - The callback to call after the data pre-load.
	 */
	onBeforeLoadDataAsync(fCallback)
	{
		return fCallback();
	}

	/**
	 * Hook to allow the provider to load data during application data load.
	 *
	 * @param {(pError?: Error) => void} fCallback - The callback to call after the data load.
	 */
	onLoadDataAsync(fCallback)
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictProvider [${this.UUID}]::[${this.Hash}] ${this.options.ProviderIdentifier} onLoadDataAsync:`);
		}
		return fCallback();
	}

	/**
	 * @param {(pError?: Error) => void} fCallback - The callback to call after the data post-load.
	 */
	onAfterLoadDataAsync(fCallback)
	{
		return fCallback();
	}

	/**
	 * @param {(pError?: Error) => void} fCallback - The callback to call after the data pre-load.
	 *
	 * @return {void}
	 */
	onBeforeSaveDataAsync(fCallback)
	{
		return fCallback();
	}

	/**
	 * Hook to allow the provider to load data during application data load.
	 *
	 * @param {(pError?: Error) => void} fCallback - The callback to call after the data load.
	 *
	 * @return {void}
	 */
	onSaveDataAsync(fCallback)
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictProvider [${this.UUID}]::[${this.Hash}] ${this.options.ProviderIdentifier} onSaveDataAsync:`);
		}
		return fCallback();
	}

	/**
	 * @param {(pError?: Error) => void} fCallback - The callback to call after the data post-load.
	 *
	 * @return {void}
	 */
	onAfterSaveDataAsync(fCallback)
	{
		return fCallback();
	}
}

module.exports = PictProvider;

},{"../package.json":141,"fable-serviceproviderbase":59}],143:[function(require,module,exports){
module.exports={
  "_from": "pict-template@^1.0.15",
  "_id": "pict-template@1.0.15",
  "_inBundle": false,
  "_integrity": "sha512-oS+1FFJN5+BiggktJOpYb/HHW4DH/Iz2t6p5RELFZk0OOpsEh4wryAK/8hGfXwzdOXaJMpwL7nxcgO3v6WS1ow==",
  "_location": "/pict-template",
  "_phantomChildren": {},
  "_requested": {
    "type": "range",
    "registry": true,
    "raw": "pict-template@^1.0.15",
    "name": "pict-template",
    "escapedName": "pict-template",
    "rawSpec": "^1.0.15",
    "saveSpec": null,
    "fetchSpec": "^1.0.15"
  },
  "_requiredBy": [
    "/",
    "/pict",
    "/pict-provider-theme",
    "/pict-section-form",
    "/quackage/pict-provider-theme"
  ],
  "_resolved": "https://registry.npmjs.org/pict-template/-/pict-template-1.0.15.tgz",
  "_shasum": "23b2ec321ff2d2f1c78557ec523af5b3063198f4",
  "_spec": "pict-template@^1.0.15",
  "_where": "/Users/jacksonpollard/pict",
  "author": {
    "name": "steven velozo",
    "email": "steven@velozo.com"
  },
  "bugs": {
    "url": "https://github.com/stevenvelozo/pict-view/issues"
  },
  "bundleDependencies": false,
  "dependencies": {
    "fable-serviceproviderbase": "^3.0.19"
  },
  "deprecated": false,
  "description": "Pict Template Base Class",
  "devDependencies": {
    "pict": "^1.0.348",
    "quackage": "^1.0.58",
    "typescript": "^5.9.3"
  },
  "homepage": "https://github.com/stevenvelozo/pict-view#readme",
  "license": "MIT",
  "main": "source/Pict-Template.js",
  "mocha": {
    "diff": true,
    "extension": [
      "js"
    ],
    "package": "./package.json",
    "reporter": "spec",
    "slow": "75",
    "timeout": "5000",
    "ui": "tdd",
    "watch-files": [
      "source/**/*.js",
      "test/**/*.js"
    ],
    "watch-ignore": [
      "lib/vendor"
    ]
  },
  "name": "pict-template",
  "repository": {
    "type": "git",
    "url": "git+https://github.com/stevenvelozo/pict-view.git"
  },
  "scripts": {
    "build": "npx quack build",
    "coverage": "npx quack coverage",
    "start": "node source/Pict-Template.js",
    "test": "npx quack test",
    "tests": "npx quack test -g",
    "types": "tsc -p ."
  },
  "types": "types/source/Pict-Template.d.ts",
  "version": "1.0.15"
}

},{}],144:[function(require,module,exports){
const libFableServiceBase = require('fable-serviceproviderbase');

const libPackage = require('../package.json');

/** @typedef {import('pict') & {
 *     [key: string]: any, // represent services for now as a workaround
 * }} Pict */
/**
 * @class PictTemplateExpression
 * @classdesc The PictTemplateExpression class is a service provider for the pict anti-framework that provides template rendering services.
 */
class PictTemplateExpression extends libFableServiceBase
{
	/**
	 * @param {Pict} pFable - The Fable Framework instance
	 * @param {Record<string, any>} [pOptions] - The options for the service
	 * @param {string} [pServiceHash] - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.fable;

		/** @type {Pict} */
		this.pict = this.fable;

		this.serviceType = 'PictTemplate';
		/** @type {Record<string, any>} */
		this._Package = libPackage;
	}

	/**
	 * Render a template expression, returning a string with the resulting content.
	 *
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {string} The rendered template
	 */
	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		return '';
	}

	/**
	 * Render a template expression, deliver a string with the resulting content to a callback function.
	 *
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {(error?: Error, content?: String) => void} fCallback - callback function invoked with the rendered template, or an error
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {void}
	 */
	renderAsync(pTemplateHash, pRecord, fCallback, pContextArray, pScope, pState)
	{
		return fCallback(null, this.render(pTemplateHash, pRecord, pContextArray, pScope, pState));
	}

	/**
	 * Provide a match criteria for a template expression.  Anything between these two values is returned as the template hash.
	 *
	 * @param {string} pMatchStart - The string pattern to start a match in the template trie
	 * @param {string} pMatchEnd  - The string pattern to stop a match in the trie acyclic graph
	 *
	 * @return {void}
	 */
	addPattern(pMatchStart, pMatchEnd)
	{
		return this.pict.MetaTemplate.addPatternBoth(pMatchStart, pMatchEnd, this.render, this.renderAsync, this);
	}

	/**
	 * Read a value from a nested object using a dot notation string.
	 *
	 * @param {string} pAddress - The address to resolve
	 * @param {Record<string, any>} pRecord - The record to resolve
	 * @param {Array<any>} [pContextArray] - The context array to resolve (optional)
	 * @param {Record<string, any>} [pRootDataObject] - The root data object to resolve (optional)
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {any} The value at the given address, or undefined
	 */
	resolveStateFromAddress(pAddress, pRecord, pContextArray, pRootDataObject, pScope, pState)
	{
		return this.pict.resolveStateFromAddress(pAddress, pRecord, pContextArray, pRootDataObject, pScope, pState);
	}
}

module.exports = PictTemplateExpression;
module.exports.template_hash = 'Default';

},{"../package.json":143,"fable-serviceproviderbase":59}],145:[function(require,module,exports){
module.exports={
  "_from": "pict-view@^1.0.68",
  "_id": "pict-view@1.0.68",
  "_inBundle": false,
  "_integrity": "sha512-hDrfBlcmCc+WyLJeapMhqCgI7yt5+6by+u5FQGnrlClezzcM3zzQv3rWJydQub1c3YBcSnSjqjpwa3Lx7Oik9w==",
  "_location": "/pict-view",
  "_phantomChildren": {},
  "_requested": {
    "type": "range",
    "registry": true,
    "raw": "pict-view@^1.0.68",
    "name": "pict-view",
    "escapedName": "pict-view",
    "rawSpec": "^1.0.68",
    "saveSpec": null,
    "fetchSpec": "^1.0.68"
  },
  "_requiredBy": [
    "/",
    "/meadow-integration",
    "/meadow-migrationmanager",
    "/meadow-migrationmanager/pict-section-flow",
    "/pict",
    "/pict-docuserve",
    "/pict-section-code",
    "/pict-section-connection-form",
    "/pict-section-content",
    "/pict-section-flow",
    "/pict-section-form",
    "/pict-section-histogram",
    "/pict-section-modal",
    "/pict-section-theme",
    "/pict-section-tuigrid",
    "/pict-terminalui",
    "/retold-harness",
    "/stricture",
    "/stricture/pict-terminalui"
  ],
  "_resolved": "https://registry.npmjs.org/pict-view/-/pict-view-1.0.68.tgz",
  "_shasum": "5df78b51e03625f624c988aad6c7f27b014e8f31",
  "_spec": "pict-view@^1.0.68",
  "_where": "/Users/jacksonpollard/pict",
  "author": {
    "name": "steven velozo",
    "email": "steven@velozo.com"
  },
  "bugs": {
    "url": "https://github.com/stevenvelozo/pict-view/issues"
  },
  "bundleDependencies": false,
  "dependencies": {
    "fable": "^3.1.67",
    "fable-serviceproviderbase": "^3.0.19"
  },
  "deprecated": false,
  "description": "Pict View Base Class",
  "devDependencies": {
    "@eslint/js": "^9.39.1",
    "browser-env": "^3.3.0",
    "eslint": "^9.39.1",
    "pict": "^1.0.363",
    "quackage": "^1.0.65",
    "typescript": "^5.9.3"
  },
  "homepage": "https://github.com/stevenvelozo/pict-view#readme",
  "license": "MIT",
  "main": "source/Pict-View.js",
  "mocha": {
    "diff": true,
    "extension": [
      "js"
    ],
    "package": "./package.json",
    "reporter": "spec",
    "slow": "75",
    "timeout": "5000",
    "ui": "tdd",
    "watch-files": [
      "source/**/*.js",
      "test/**/*.js"
    ],
    "watch-ignore": [
      "lib/vendor"
    ]
  },
  "name": "pict-view",
  "repository": {
    "type": "git",
    "url": "git+https://github.com/stevenvelozo/pict-view.git"
  },
  "scripts": {
    "build": "npx quack build",
    "coverage": "npx quack coverage",
    "docker-dev-build": "docker build ./ -f Dockerfile_LUXURYCode -t pict-view-image:local",
    "docker-dev-run": "docker run -it -d --name pict-view-dev -p 30001:8080 -p 38086:8086 -v \"$PWD/.config:/home/coder/.config\"  -v \"$PWD:/home/coder/pict-view\" -u \"$(id -u):$(id -g)\" -e \"DOCKER_USER=$USER\" pict-view-image:local",
    "docker-dev-shell": "docker exec -it pict-view-dev /bin/bash",
    "lint": "eslint source/**",
    "start": "node source/Pict-View.js",
    "test": "npx quack test",
    "tests": "npx quack test -g",
    "types": "tsc -p ."
  },
  "types": "types/source/Pict-View.d.ts",
  "version": "1.0.68"
}

},{}],146:[function(require,module,exports){

const libFableServiceBase = require('fable-serviceproviderbase');

const libPackage = require('../package.json');

const defaultPictViewSettings = (
	{
		DefaultRenderable: false,
		DefaultDestinationAddress: false,
		DefaultTemplateRecordAddress: false,

		ViewIdentifier: false,

		// If this is set to true, when the App initializes this will.
		// After the App initializes, initialize will be called as soon as it's added.
		AutoInitialize: true,
		AutoInitializeOrdinal: 0,

		// If this is set to true, when the App autorenders (on load) this will.
		// After the App initializes, render will be called as soon as it's added.
		AutoRender: true,
		AutoRenderOrdinal: 0,

		AutoSolveWithApp: true,
		AutoSolveOrdinal: 0,

		CSSHash: false,
		CSS: false,
		CSSProvider: false,
		CSSPriority: 500,

		Templates: [],

		DefaultTemplates: [],

		Renderables: [],

		Manifests: {}
	});

/** @typedef {(error?: Error) => void} ErrorCallback */
/** @typedef {number | boolean} PictTimestamp */

/**
 * @typedef {'replace' | 'append' | 'prepend' | 'append_once' | 'virtual-assignment'} RenderMethod
 */
/**
 * @typedef {Object} Renderable
 *
 * @property {string} RenderableHash - A unique hash for the renderable.
 * @property {string} TemplateHash - The hash of the template to use for rendering this renderable.
 * @property {string} [DefaultTemplateRecordAddress] - The default address for resolving the data record for this renderable.
 * @property {string} [ContentDestinationAddress] - The default address (DOM CSS selector) for rendering the content of this renderable.
 * @property {RenderMethod} [RenderMethod=replace] - The method to use when projecting the renderable to the DOM ('replace', 'append', 'prepend', 'append_once', 'virtual-assignment').
 * @property {string} [TestAddress] - The address to use for testing the renderable.
 * @property {string} [TransactionHash] - The transaction hash for the root renderable.
 * @property {string} [RootRenderableViewHash] - The hash of the root renderable.
 * @property {string} [Content] - The rendered content for this renderable, if applicable.
 */

/**
 * Represents a view in the Pict ecosystem.
 */
class PictView extends libFableServiceBase
{
	/**
	 * @param {any} pFable - The Fable object that this service is attached to.
	 * @param {any} [pOptions] - (optional) The options for this service.
	 * @param {string} [pServiceHash] - (optional) The hash of the service.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		// Intersect default options, parent constructor, service information
		let tmpOptions = Object.assign({}, JSON.parse(JSON.stringify(defaultPictViewSettings)), pOptions);
		super(pFable, tmpOptions, pServiceHash);
		//FIXME: add types to fable and ancillaries
		/** @type {any} */
		this.fable;
		/** @type {any} */
		this.options;
		/** @type {String} */
		this.UUID;
		/** @type {String} */
		this.Hash;
		/** @type {any} */
		this.log;

		const tmpHashIsUUID = this.Hash === this.UUID;
		//NOTE: since many places are using the view UUID as the HTML element ID, we prefix it to avoid starting with a number
		this.UUID = `V-${this.UUID}`;
		if (tmpHashIsUUID)
		{
			this.Hash = this.UUID;
		}

		if (!this.options.ViewIdentifier)
		{
			this.options.ViewIdentifier = `AutoViewID-${this.fable.getUUID()}`;
		}
		this.serviceType = 'PictView';
		/** @type {Record<string, any>} */
		this._Package = libPackage;
		// Convenience and consistency naming
		/** @type {import('pict') & { log: any, instantiateServiceProviderWithoutRegistration: (hash: String) => any, instantiateServiceProviderIfNotExists: (hash: string) => any, TransactionTracking: import('pict/types/source/services/Fable-Service-TransactionTracking') }} */
		this.pict = this.fable;
		// Wire in the essential Pict application state
		this.AppData = this.pict.AppData;
		this.Bundle = this.pict.Bundle;

		/** @type {PictTimestamp} */
		this.initializeTimestamp = false;
		/** @type {PictTimestamp} */
		this.lastSolvedTimestamp = false;
		/** @type {PictTimestamp} */
		this.lastRenderedTimestamp = false;
		/** @type {PictTimestamp} */
		this.lastMarshalFromViewTimestamp = false;
		/** @type {PictTimestamp} */
		this.lastMarshalToViewTimestamp = false;

		this.pict.instantiateServiceProviderIfNotExists('TransactionTracking');

		// Load all templates from the array in the options
		// Templates are in the form of {Hash:'Some-Template-Hash',Template:'Template content',Source:'TemplateSource'}
		for (let i = 0; i < this.options.Templates.length; i++)
		{
			let tmpTemplate = this.options.Templates[i];

			if (!('Hash' in tmpTemplate) || !('Template' in tmpTemplate))
			{
				this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} could not load Template ${i} in the options array.`, tmpTemplate);
			}
			else
			{
				if (!tmpTemplate.Source)
				{
					tmpTemplate.Source = `PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} options object.`;
				}
				this.pict.TemplateProvider.addTemplate(tmpTemplate.Hash, tmpTemplate.Template, tmpTemplate.Source);
			}
		}

		// Load all default templates from the array in the options
		// Templates are in the form of {Prefix:'',Postfix:'-List-Row',Template:'Template content',Source:'TemplateSourceString'}
		for (let i = 0; i < this.options.DefaultTemplates.length; i++)
		{
			let tmpDefaultTemplate = this.options.DefaultTemplates[i];

			if (!('Postfix' in tmpDefaultTemplate) || !('Template' in tmpDefaultTemplate))
			{
				this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} could not load Default Template ${i} in the options array.`, tmpDefaultTemplate);
			}
			else
			{
				if (!tmpDefaultTemplate.Source)
				{
					tmpDefaultTemplate.Source = `PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} options object.`;
				}
				this.pict.TemplateProvider.addDefaultTemplate(tmpDefaultTemplate.Prefix, tmpDefaultTemplate.Postfix, tmpDefaultTemplate.Template, tmpDefaultTemplate.Source);
			}
		}

		// Load the CSS if it's available
		if (this.options.CSS)
		{
			let tmpCSSHash = this.options.CSSHash ? this.options.CSSHash : `View-${this.options.ViewIdentifier}`;
			let tmpCSSProvider = this.options.CSSProvider ? this.options.CSSProvider : tmpCSSHash;
			this.pict.CSSMap.addCSS(tmpCSSHash, this.options.CSS, tmpCSSProvider, this.options.CSSPriority);
		}

		// Load all renderables
		// Renderables are launchable renderable instructions with templates
		// They look as such: {Identifier:'ContentEntry', TemplateHash:'Content-Entry-Section-Main', ContentDestinationAddress:'#ContentSection', RecordAddress:'AppData.Content.DefaultText', ManifestTransformation:'ManyfestHash', ManifestDestinationAddress:'AppData.Content.DataToTransformContent'}
		// The only parts that are necessary are Identifier and Template
		// A developer can then do render('ContentEntry') and it just kinda works.  Or they can override the ContentDestinationAddress
		/** @type {Record<String, Renderable>} */
		this.renderables = {};
		for (let i = 0; i < this.options.Renderables.length; i++)
		{
			/** @type {Renderable} */
			let tmpRenderable = this.options.Renderables[i];
			this.addRenderable(tmpRenderable);
		}
	}

	/**
	 * Adds a renderable to the view.
	 *
	 * @param {string | Renderable} pRenderableHash - The hash of the renderable, or a renderable object.
	 * @param {string} [pTemplateHash] - (optional) The hash of the template for the renderable.
	 * @param {string} [pDefaultTemplateRecordAddress] - (optional) The default data address for the template.
	 * @param {string} [pDefaultDestinationAddress] - (optional) The default destination address for the renderable.
	 * @param {RenderMethod} [pRenderMethod=replace] - (optional) The method to use when rendering the renderable (ex. 'replace').
	 */
	addRenderable(pRenderableHash, pTemplateHash, pDefaultTemplateRecordAddress, pDefaultDestinationAddress, pRenderMethod)
	{
		/** @type {Renderable} */
		let tmpRenderable;

		if (typeof(pRenderableHash) == 'object')
		{
			// The developer passed in the renderable as an object.
			// Use theirs instead!
			tmpRenderable = pRenderableHash;
		}
		else
		{
			/** @type {RenderMethod} */
			let tmpRenderMethod = (typeof(pRenderMethod) !== 'string') ? pRenderMethod : 'replace';
			tmpRenderable = (
				{
					RenderableHash: pRenderableHash,
					TemplateHash: pTemplateHash,
					DefaultTemplateRecordAddress: pDefaultTemplateRecordAddress,
					ContentDestinationAddress: pDefaultDestinationAddress,
					RenderMethod: tmpRenderMethod
				});
		}

		if ((typeof(tmpRenderable.RenderableHash) != 'string') || (typeof(tmpRenderable.TemplateHash) != 'string'))
		{
			this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} could not load Renderable; RenderableHash or TemplateHash are invalid.`, tmpRenderable);
		}
		else
		{
			if (this.pict.LogNoisiness > 0)
			{
				this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} adding renderable [${tmpRenderable.RenderableHash}] pointed to template ${tmpRenderable.TemplateHash}.`);
			}

			this.renderables[tmpRenderable.RenderableHash] = tmpRenderable;
		}
	}

	/* -------------------------------------------------------------------------- */
	/*                        Code Section: Initialization                        */
	/* -------------------------------------------------------------------------- */
	/**
	 * Lifecycle hook that triggers before the view is initialized.
	 */
	onBeforeInitialize()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onBeforeInitialize:`);
		}
		return true;
	}

	/**
	 * Lifecycle hook that triggers before the view is initialized (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 */
	onBeforeInitializeAsync(fCallback)
	{
		this.onBeforeInitialize();
		return fCallback();
	}

	/**
	 * Lifecycle hook that triggers when the view is initialized.
	 */
	onInitialize()
	{

		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onInitialize:`);
		}
		return true;
	}

	/**
	 * Lifecycle hook that triggers when the view is initialized (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 */
	onInitializeAsync(fCallback)
	{
		this.onInitialize();
		return fCallback();
	}

	/**
	 * Performs view initialization.
	 */
	initialize()
	{
		if (this.pict.LogControlFlow)
		{
			this.log.trace(`PICT-ControlFlow VIEW [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} initialize:`);
		}

		if (!this.initializeTimestamp)
		{
			this.onBeforeInitialize();
			this.onInitialize();
			this.onAfterInitialize();
			this.initializeTimestamp = this.pict.log.getTimeStamp();
			return true;
		}
		else
		{
			this.log.warn(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} initialize called but initialization is already completed.  Aborting.`);
			return false;
		}
	}

	/**
	 * Performs view initialization (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 */
	initializeAsync(fCallback)
	{
		if (this.pict.LogControlFlow)
		{
			this.log.trace(`PICT-ControlFlow VIEW [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} initializeAsync:`);
		}

		if (!this.initializeTimestamp)
		{
			let tmpAnticipate = this.pict.instantiateServiceProviderWithoutRegistration('Anticipate');

			if (this.pict.LogNoisiness > 0)
			{
				this.log.info(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} beginning initialization...`);
			}

			tmpAnticipate.anticipate(this.onBeforeInitializeAsync.bind(this));
			tmpAnticipate.anticipate(this.onInitializeAsync.bind(this));
			tmpAnticipate.anticipate(this.onAfterInitializeAsync.bind(this));

			tmpAnticipate.wait(
				/** @param {Error} pError */
				(pError) =>
				{
					if (pError)
					{
						this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} initialization failed: ${pError.message || pError}`, { stack: pError.stack });
					}
					this.initializeTimestamp = this.pict.log.getTimeStamp();
					if (this.pict.LogNoisiness > 0)
					{
						this.log.info(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} initialization complete.`);
					}
					return fCallback();
				});
		}
		else
		{
			this.log.warn(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} async initialize called but initialization is already completed.  Aborting.`);
			// TODO: Should this be an error?
			return fCallback();
		}
	}

	onAfterInitialize()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onAfterInitialize:`);
		}
		return true;
	}

	/**
	 * Lifecycle hook that triggers after the view is initialized (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 */
	onAfterInitializeAsync(fCallback)
	{
		this.onAfterInitialize();
		return fCallback();
	}

	/* -------------------------------------------------------------------------- */
	/*                            Code Section: Render                            */
	/* -------------------------------------------------------------------------- */
	/**
	 * Lifecycle hook that triggers before the view is rendered.
	 *
	 * @param {Renderable} pRenderable - The renderable that will be rendered.
	 */
	onBeforeRender(pRenderable)
	{
		// Overload this to mess with stuff before the content gets generated from the template
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onBeforeRender:`);
		}
		return true;
	}

	/**
	 * Lifecycle hook that triggers before the view is rendered (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 * @param {Renderable} pRenderable - The renderable that will be rendered.
	 */
	onBeforeRenderAsync(fCallback, pRenderable)
	{
		this.onBeforeRender(pRenderable);
		return fCallback();
	}

	/**
	 * Lifecycle hook that triggers before the view is projected into the DOM.
	 *
	 * @param {Renderable} pRenderable - The renderable that will be projected.
	 */
	onBeforeProject(pRenderable)
	{
		// Overload this to mess with stuff before the content gets generated from the template
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onBeforeProject:`);
		}
		return true;
	}

	/**
	 * Lifecycle hook that triggers before the view is projected into the DOM (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 * @param {Renderable} pRenderable - The renderable that will be projected.
	 */
	onBeforeProjectAsync(fCallback, pRenderable)
	{
		this.onBeforeProject(pRenderable);
		return fCallback();
	}

	/**
	 * Builds the render options for a renderable.
	 *
	 * For DRY purposes on the three flavors of render.
	 *
	 * @param {string|ErrorCallback} [pRenderableHash] - The hash of the renderable to render.
	 * @param {string|ErrorCallback} [pRenderDestinationAddress] - The address where the renderable will be rendered.
	 * @param {string|object|ErrorCallback} [pTemplateRecordAddress] - The address of (or actual obejct) where the data for the template is stored.
	 */
	buildRenderOptions(pRenderableHash, pRenderDestinationAddress, pTemplateRecordAddress)
	{
		let tmpRenderOptions = {Valid: true};
		tmpRenderOptions.RenderableHash = (typeof (pRenderableHash) === 'string') ? pRenderableHash :
								(typeof (this.options.DefaultRenderable) == 'string') ?
								this.options.DefaultRenderable : false;
		if (!tmpRenderOptions.RenderableHash)
		{
			this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} could not find a suitable RenderableHash ${tmpRenderOptions.RenderableHash} (param ${pRenderableHash}because it is not a valid renderable.`);
			tmpRenderOptions.Valid = false;
		}

		tmpRenderOptions.Renderable = this.renderables[tmpRenderOptions.RenderableHash];
		if (!tmpRenderOptions.Renderable)
		{
			this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} could not render ${tmpRenderOptions.RenderableHash} (param ${pRenderableHash}) because it does not exist.`);
			tmpRenderOptions.Valid = false;
		}

		tmpRenderOptions.DestinationAddress = (typeof (pRenderDestinationAddress) === 'string') ? pRenderDestinationAddress :
			(typeof (tmpRenderOptions.Renderable.ContentDestinationAddress) === 'string') ? tmpRenderOptions.Renderable.ContentDestinationAddress :
				(typeof (this.options.DefaultDestinationAddress) === 'string') ? this.options.DefaultDestinationAddress : false;
		if (!tmpRenderOptions.DestinationAddress)
		{
			this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} could not render ${tmpRenderOptions.RenderableHash} (param ${pRenderableHash}) because it does not have a valid destination address (param ${pRenderDestinationAddress}).`);
			tmpRenderOptions.Valid = false;
		}

		if (typeof(pTemplateRecordAddress) === 'object')
		{
			tmpRenderOptions.RecordAddress = 'Passed in as object';
			tmpRenderOptions.Record = pTemplateRecordAddress;
		}
		else
		{
			tmpRenderOptions.RecordAddress = (typeof (pTemplateRecordAddress) === 'string') ? pTemplateRecordAddress :
				(typeof (tmpRenderOptions.Renderable.DefaultTemplateRecordAddress) === 'string') ? tmpRenderOptions.Renderable.DefaultTemplateRecordAddress :
				(typeof (this.options.DefaultTemplateRecordAddress) === 'string') ? this.options.DefaultTemplateRecordAddress : false;
			tmpRenderOptions.Record = (typeof (tmpRenderOptions.RecordAddress) === 'string') ? this.pict.DataProvider.getDataByAddress(tmpRenderOptions.RecordAddress) : undefined;
		}

		return tmpRenderOptions;
	}

	/**
	 * Assigns the content to the destination address.
	 *
	 * For DRY purposes on the three flavors of render.
	 *
	 * @param {Renderable} pRenderable - The renderable to render.
	 * @param {string} pRenderDestinationAddress - The address where the renderable will be rendered.
	 * @param {string} pContent - The content to render.
	 * @returns {boolean} - Returns true if the content was assigned successfully.
	 * @memberof PictView
	 */
	assignRenderContent(pRenderable, pRenderDestinationAddress, pContent)
	{
		return this.pict.ContentAssignment.projectContent(pRenderable.RenderMethod, pRenderDestinationAddress, pContent, pRenderable.TestAddress);
	}

	/**
	 * Render a renderable from this view.
	 *
	 * @param {string} [pRenderableHash] - The hash of the renderable to render.
	 * @param {string} [pRenderDestinationAddress] - The address where the renderable will be rendered.
	 * @param {string|object} [pTemplateRecordAddress] - The address where the data for the template is stored.
	 * @param {Renderable} [pRootRenderable] - The root renderable for the render operation, if applicable.
	 * @return {boolean}
	 */
	render(pRenderableHash, pRenderDestinationAddress, pTemplateRecordAddress, pRootRenderable)
	{
		return this.renderWithScope(this, pRenderableHash, pRenderDestinationAddress, pTemplateRecordAddress, pRootRenderable);
	}

	/**
	 * Render a renderable from this view, providing a specifici scope for the template.
	 *
	 * @param {any} pScope - The scope to use for the template rendering.
	 * @param {string} [pRenderableHash] - The hash of the renderable to render.
	 * @param {string} [pRenderDestinationAddress] - The address where the renderable will be rendered.
	 * @param {string|object} [pTemplateRecordAddress] - The address where the data for the template is stored.
	 * @param {Renderable} [pRootRenderable] - The root renderable for the render operation, if applicable.
	 * @return {boolean}
	 */
	renderWithScope(pScope, pRenderableHash, pRenderDestinationAddress, pTemplateRecordAddress, pRootRenderable)
	{
		let tmpRenderableHash = (typeof (pRenderableHash) === 'string') ? pRenderableHash :
			(typeof (this.options.DefaultRenderable) == 'string') ? this.options.DefaultRenderable : false;
		if (!tmpRenderableHash)
		{
			this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} could not render ${tmpRenderableHash} (param ${pRenderableHash}) because it is not a valid renderable.`);
			return false;
		}

		/** @type {Renderable} */
		let tmpRenderable;
		if (tmpRenderableHash == '__Virtual')
		{
			tmpRenderable = {
				RenderableHash: '__Virtual',
				TemplateHash: this.renderables[this.options.DefaultRenderable].TemplateHash,
				ContentDestinationAddress: (typeof (pRenderDestinationAddress) === 'string') ? pRenderDestinationAddress :
					(typeof (tmpRenderable.ContentDestinationAddress) === 'string') ? tmpRenderable.ContentDestinationAddress :
					(typeof (this.options.DefaultDestinationAddress) === 'string') ? this.options.DefaultDestinationAddress : null,
				RenderMethod: 'virtual-assignment',
				TransactionHash: pRootRenderable && pRootRenderable.TransactionHash,
				RootRenderableViewHash: pRootRenderable && pRootRenderable.RootRenderableViewHash,
			};
		}
		else
		{
			tmpRenderable = Object.assign({}, this.renderables[tmpRenderableHash]);
			tmpRenderable.ContentDestinationAddress = (typeof (pRenderDestinationAddress) === 'string') ? pRenderDestinationAddress :
				(typeof (tmpRenderable.ContentDestinationAddress) === 'string') ? tmpRenderable.ContentDestinationAddress :
				(typeof (this.options.DefaultDestinationAddress) === 'string') ? this.options.DefaultDestinationAddress : null;
		}

		if (!tmpRenderable.TransactionHash)
		{
			tmpRenderable.TransactionHash = `ViewRender-V-${this.options.ViewIdentifier}-R-${tmpRenderableHash}-U-${this.pict.getUUID()}`;
			tmpRenderable.RootRenderableViewHash = this.Hash;
			this.pict.TransactionTracking.registerTransaction(tmpRenderable.TransactionHash);
		}

		if (!tmpRenderable)
		{
			this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} could not render ${tmpRenderableHash} (param ${pRenderableHash}) because it does not exist.`);
			return false;
		}

		if (!tmpRenderable.ContentDestinationAddress)
		{
			this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} could not render ${tmpRenderableHash} (param ${pRenderableHash}) because it does not have a valid destination address.`);
			return false;
		}

		let tmpRecordAddress;
		let tmpRecord;

		if (typeof(pTemplateRecordAddress) === 'object')
		{
			tmpRecord = pTemplateRecordAddress;
			tmpRecordAddress = 'Passed in as object';
		}
		else
		{
			tmpRecordAddress = (typeof (pTemplateRecordAddress) === 'string') ? pTemplateRecordAddress :
				(typeof (tmpRenderable.DefaultTemplateRecordAddress) === 'string') ? tmpRenderable.DefaultTemplateRecordAddress :
					(typeof (this.options.DefaultTemplateRecordAddress) === 'string') ? this.options.DefaultTemplateRecordAddress : false;

			tmpRecord = (typeof (tmpRecordAddress) === 'string') ? this.pict.DataProvider.getDataByAddress(tmpRecordAddress) : undefined;
		}

		// Execute the developer-overridable pre-render behavior
		this.onBeforeRender(tmpRenderable);

		if (this.pict.LogControlFlow)
		{
			this.log.trace(`PICT-ControlFlow VIEW [${this.UUID}]::[${this.Hash}] Renderable[${tmpRenderableHash}] Destination[${tmpRenderable.ContentDestinationAddress}] TemplateRecordAddress[${tmpRecordAddress}] render:`);
		}
		if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} Beginning Render of Renderable[${tmpRenderableHash}] to Destination [${tmpRenderable.ContentDestinationAddress}]...`);
		}
		// Generate the content output from the template and data
		tmpRenderable.Content = this.pict.parseTemplateByHash(tmpRenderable.TemplateHash, tmpRecord, null, [this], pScope, { RootRenderable: typeof pRootRenderable === 'object' ? pRootRenderable : tmpRenderable });

		if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} Assigning Renderable[${tmpRenderableHash}] content length ${tmpRenderable.Content.length} to Destination [${tmpRenderable.ContentDestinationAddress}] using render method [${tmpRenderable.RenderMethod}].`);
		}

		this.onBeforeProject(tmpRenderable);
		this.onProject(tmpRenderable);

		if (tmpRenderable.RenderMethod !== 'virtual-assignment')
		{
			this.onAfterProject(tmpRenderable);

			// Execute the developer-overridable post-render behavior
			this.onAfterRender(tmpRenderable);
		}

		return true;
	}

	/**
	 * Render a renderable from this view.
	 *
	 * @param {string|ErrorCallback} [pRenderableHash] - The hash of the renderable to render.
	 * @param {string|ErrorCallback} [pRenderDestinationAddress] - The address where the renderable will be rendered.
	 * @param {string|object|ErrorCallback} [pTemplateRecordAddress] - The address where the data for the template is stored.
	 * @param {Renderable|ErrorCallback} [pRootRenderable] - The root renderable for the render operation, if applicable.
	 * @param {ErrorCallback} [fCallback] - The callback to call when the async operation is complete.
	 *
	 * @return {void}
	 */
	renderAsync(pRenderableHash, pRenderDestinationAddress, pTemplateRecordAddress, pRootRenderable, fCallback)
	{
		return this.renderWithScopeAsync(this, pRenderableHash, pRenderDestinationAddress, pTemplateRecordAddress, pRootRenderable, fCallback);
	}

	/**
	 * Render a renderable from this view.
	 *
	 * @param {any} pScope - The scope to use for the template rendering.
	 * @param {string|ErrorCallback} [pRenderableHash] - The hash of the renderable to render.
	 * @param {string|ErrorCallback} [pRenderDestinationAddress] - The address where the renderable will be rendered.
	 * @param {string|object|ErrorCallback} [pTemplateRecordAddress] - The address where the data for the template is stored.
	 * @param {Renderable|ErrorCallback} [pRootRenderable] - The root renderable for the render operation, if applicable.
	 * @param {ErrorCallback} [fCallback] - The callback to call when the async operation is complete.
	 *
	 * @return {void}
	 */
	renderWithScopeAsync(pScope, pRenderableHash, pRenderDestinationAddress, pTemplateRecordAddress, pRootRenderable, fCallback)
	{
		let tmpRenderableHash = (typeof (pRenderableHash) === 'string') ? pRenderableHash :
			(typeof (this.options.DefaultRenderable) == 'string') ? this.options.DefaultRenderable : false;

		// Allow the callback to be passed in as the last parameter no matter what
		/** @type {ErrorCallback} */
		let tmpCallback = (typeof(fCallback) === 'function') ? fCallback :
							(typeof(pTemplateRecordAddress) === 'function') ? pTemplateRecordAddress :
							(typeof(pRenderDestinationAddress) === 'function') ? pRenderDestinationAddress :
							(typeof(pRenderableHash) === 'function') ? pRenderableHash :
							(typeof(pRootRenderable) === 'function') ? pRootRenderable :
							null;

		if (!tmpCallback)
		{
			this.log.warn(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.Name} renderAsync was called without a valid callback.  A callback will be generated but this could lead to race conditions.`);
			tmpCallback = (pError) =>
				{
					if (pError)
					{
						this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.Name} renderAsync Auto Callback Error: ${pError}`, pError);
					}
				};
		}

		if (!tmpRenderableHash)
		{
			this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} could not asynchronously render ${tmpRenderableHash} (param ${pRenderableHash}because it is not a valid renderable.`);
			return tmpCallback(new Error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} could not asynchronously render ${tmpRenderableHash} (param ${pRenderableHash}because it is not a valid renderable.`));
		}

		/** @type {Renderable} */
		let tmpRenderable;
		if (tmpRenderableHash == '__Virtual')
		{
			tmpRenderable = {
				RenderableHash: '__Virtual',
				TemplateHash: this.renderables[this.options.DefaultRenderable].TemplateHash,
				ContentDestinationAddress: (typeof (pRenderDestinationAddress) === 'string') ? pRenderDestinationAddress : (typeof (this.options.DefaultDestinationAddress) === 'string') ? this.options.DefaultDestinationAddress : null,
				RenderMethod: 'virtual-assignment',
				TransactionHash: pRootRenderable && typeof pRootRenderable !== 'function' && pRootRenderable.TransactionHash,
				RootRenderableViewHash: pRootRenderable && typeof pRootRenderable !== 'function' && pRootRenderable.RootRenderableViewHash,
			};
		}
		else
		{
			tmpRenderable = Object.assign({}, this.renderables[tmpRenderableHash]);
			tmpRenderable.ContentDestinationAddress = (typeof (pRenderDestinationAddress) === 'string') ? pRenderDestinationAddress :
				(typeof (tmpRenderable.ContentDestinationAddress) === 'string') ? tmpRenderable.ContentDestinationAddress :
				(typeof (this.options.DefaultDestinationAddress) === 'string') ? this.options.DefaultDestinationAddress : null;
		}

		if (!tmpRenderable.TransactionHash)
		{
			tmpRenderable.TransactionHash = `ViewRender-V-${this.options.ViewIdentifier}-R-${tmpRenderableHash}-U-${this.pict.getUUID()}`;
			tmpRenderable.RootRenderableViewHash = this.Hash;
			this.pict.TransactionTracking.registerTransaction(tmpRenderable.TransactionHash);
		}

		if (!tmpRenderable)
		{
			this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} could not render ${tmpRenderableHash} (param ${pRenderableHash}) because it does not exist.`);
			return tmpCallback(new Error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} could not render ${tmpRenderableHash} (param ${pRenderableHash}) because it does not exist.`));
		}

		if (!tmpRenderable.ContentDestinationAddress)
		{
			this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} could not render ${tmpRenderableHash} (param ${pRenderableHash}) because it does not have a valid destination address.`);
			return tmpCallback(new Error(`Could not render ${tmpRenderableHash}`));
		}

		let tmpRecordAddress;
		let tmpRecord;

		if (typeof(pTemplateRecordAddress) === 'object')
		{
			tmpRecord = pTemplateRecordAddress;
			tmpRecordAddress = 'Passed in as object';
		}
		else
		{
			tmpRecordAddress = (typeof (pTemplateRecordAddress) === 'string') ? pTemplateRecordAddress :
				(typeof (tmpRenderable.DefaultTemplateRecordAddress) === 'string') ? tmpRenderable.DefaultTemplateRecordAddress :
					(typeof (this.options.DefaultTemplateRecordAddress) === 'string') ? this.options.DefaultTemplateRecordAddress : false;

			tmpRecord = (typeof (tmpRecordAddress) === 'string') ? this.pict.DataProvider.getDataByAddress(tmpRecordAddress) : undefined;
		}

		if (this.pict.LogControlFlow)
		{
			this.log.trace(`PICT-ControlFlow VIEW [${this.UUID}]::[${this.Hash}] Renderable[${tmpRenderableHash}] Destination[${tmpRenderable.ContentDestinationAddress}] TemplateRecordAddress[${tmpRecordAddress}] renderAsync:`);
		}
		if (this.pict.LogNoisiness > 2)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} Beginning Asynchronous Render (callback-style)...`);
		}

		let tmpAnticipate = this.fable.newAnticipate();

		tmpAnticipate.anticipate(
			(fOnBeforeRenderCallback) =>
			{
				this.onBeforeRenderAsync(fOnBeforeRenderCallback, tmpRenderable);
			});

		tmpAnticipate.anticipate(
			(fAsyncTemplateCallback) =>
			{
				// Render the template (asynchronously)
				this.pict.parseTemplateByHash(tmpRenderable.TemplateHash, tmpRecord,
					(pError, pContent) =>
					{
						if (pError)
						{
							this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} could not render (asynchronously) ${tmpRenderableHash} (param ${pRenderableHash}) because it did not parse the template.`, pError);
							return fAsyncTemplateCallback(pError);
						}
						tmpRenderable.Content = pContent;

						return fAsyncTemplateCallback();
					}, [this], pScope, { RootRenderable: typeof pRootRenderable === 'object' ? pRootRenderable : tmpRenderable });
			});

		tmpAnticipate.anticipate((fNext) =>
		{
			this.onBeforeProjectAsync(fNext, tmpRenderable);
		});
		tmpAnticipate.anticipate((fNext) =>
		{
			this.onProjectAsync(fNext, tmpRenderable);
		});

		if (tmpRenderable.RenderMethod !== 'virtual-assignment')
		{
			tmpAnticipate.anticipate((fNext) =>
			{
				this.onAfterProjectAsync(fNext, tmpRenderable);
			});

			// Execute the developer-overridable post-render behavior
			tmpAnticipate.anticipate((fNext) =>
			{
				this.onAfterRenderAsync(fNext, tmpRenderable);
			});
		}

		tmpAnticipate.wait(tmpCallback);
	}

	/**
	 * Renders the default renderable.
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 */
	renderDefaultAsync(fCallback)
	{
		// Render the default renderable
		this.renderAsync(fCallback);
	}

	/**
	 * @param {string} [pRenderableHash] - The hash of the renderable to render.
	 * @param {string} [pRenderDestinationAddress] - The address where the renderable will be rendered.
	 * @param {string|object} [pTemplateRecordAddress] - The address of (or actual obejct) where the data for the template is stored.
	 */
	basicRender(pRenderableHash, pRenderDestinationAddress, pTemplateRecordAddress)
	{
		return this.basicRenderWithScope(this, pRenderableHash, pRenderDestinationAddress, pTemplateRecordAddress);
	}

	/**
	 * @param {any} pScope - The scope to use for the template rendering.
	 * @param {string} [pRenderableHash] - The hash of the renderable to render.
	 * @param {string} [pRenderDestinationAddress] - The address where the renderable will be rendered.
	 * @param {string|object} [pTemplateRecordAddress] - The address of (or actual obejct) where the data for the template is stored.
	 */
	basicRenderWithScope(pScope, pRenderableHash, pRenderDestinationAddress, pTemplateRecordAddress)
	{
		let tmpRenderOptions = this.buildRenderOptions(pRenderableHash, pRenderDestinationAddress, pTemplateRecordAddress);
		if (tmpRenderOptions.Valid)
		{
			this.assignRenderContent(tmpRenderOptions.Renderable, tmpRenderOptions.DestinationAddress, this.pict.parseTemplateByHash(tmpRenderOptions.Renderable.TemplateHash, tmpRenderOptions.Record, null, [this], pScope, { RootRenderable: tmpRenderOptions.Renderable }));
			return true;
		}
		else
		{
			this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} could not perform a basic render of ${tmpRenderOptions.RenderableHash} because it is not valid.`);
			return false;
		}
	}

	/**
	 * @param {string|ErrorCallback} [pRenderableHash] - The hash of the renderable to render.
	 * @param {string|ErrorCallback} [pRenderDestinationAddress] - The address where the renderable will be rendered.
	 * @param {string|Object|ErrorCallback} [pTemplateRecordAddress] - The address of (or actual obejct) where the data for the template is stored.
	 * @param {ErrorCallback} [fCallback] - The callback to call when the async operation is complete.
	 */
	basicRenderAsync(pRenderableHash, pRenderDestinationAddress, pTemplateRecordAddress, fCallback)
	{
		return this.basicRenderWithScopeAsync(this, pRenderableHash, pRenderDestinationAddress, pTemplateRecordAddress, fCallback);
	}

	/**
	 * @param {any} pScope - The scope to use for the template rendering.
	 * @param {string|ErrorCallback} [pRenderableHash] - The hash of the renderable to render.
	 * @param {string|ErrorCallback} [pRenderDestinationAddress] - The address where the renderable will be rendered.
	 * @param {string|Object|ErrorCallback} [pTemplateRecordAddress] - The address of (or actual obejct) where the data for the template is stored.
	 * @param {ErrorCallback} [fCallback] - The callback to call when the async operation is complete.
	 */
	basicRenderWithScopeAsync(pScope, pRenderableHash, pRenderDestinationAddress, pTemplateRecordAddress, fCallback)
	{
		// Allow the callback to be passed in as the last parameter no matter what
		/** @type {ErrorCallback} */
		let tmpCallback = (typeof(fCallback) === 'function') ? fCallback :
							(typeof(pTemplateRecordAddress) === 'function') ? pTemplateRecordAddress :
							(typeof(pRenderDestinationAddress) === 'function') ? pRenderDestinationAddress :
							(typeof(pRenderableHash) === 'function') ? pRenderableHash :
							null;
		if (!tmpCallback)
		{
			this.log.warn(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.Name} basicRenderAsync was called without a valid callback.  A callback will be generated but this could lead to race conditions.`);
			tmpCallback = (pError) =>
				{
					if (pError)
					{
						this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.Name} basicRenderAsync Auto Callback Error: ${pError}`, pError);
					}
				};
		}

		const tmpRenderOptions = this.buildRenderOptions(pRenderableHash, pRenderDestinationAddress, pTemplateRecordAddress);
		if (tmpRenderOptions.Valid)
		{
			this.pict.parseTemplateByHash(tmpRenderOptions.Renderable.TemplateHash, tmpRenderOptions.Record,
				/**
				 * @param {Error} [pError] - The error that occurred during template parsing.
				 * @param {string} [pContent] - The content that was rendered from the template.
				 */
				(pError, pContent) =>
				{
					if (pError)
					{
						this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} could not render (asynchronously) ${tmpRenderOptions.RenderableHash} because it did not parse the template.`, pError);
						return tmpCallback(pError);
					}

					this.assignRenderContent(tmpRenderOptions.Renderable, tmpRenderOptions.DestinationAddress, pContent);
					return tmpCallback();
				}, [this], pScope, { RootRenderable: tmpRenderOptions.Renderable });
		}
		else
		{
			let tmpErrorMessage = `PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} could not perform a basic render of ${tmpRenderOptions.RenderableHash} because it is not valid.`;
			this.log.error(tmpErrorMessage);
			return tmpCallback(new Error(tmpErrorMessage));
		}
	}

	/**
	 * @param {Renderable} pRenderable - The renderable that was rendered.
	 */
	onProject(pRenderable)
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onProject:`);
		}
		if (pRenderable.RenderMethod === 'virtual-assignment')
		{
			this.pict.TransactionTracking.pushToTransactionQueue(pRenderable.TransactionHash, { ViewHash: this.Hash, Renderable: pRenderable }, 'Deferred-Post-Content-Assignment');
		}

		if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} Assigning Renderable[${pRenderable.RenderableHash}] content length ${pRenderable.Content.length} to Destination [${pRenderable.ContentDestinationAddress}] using Async render method ${pRenderable.RenderMethod}.`);
		}

		// Assign the content to the destination address
		this.pict.ContentAssignment.projectContent(pRenderable.RenderMethod, pRenderable.ContentDestinationAddress, pRenderable.Content, pRenderable.TestAddress);

		this.lastRenderedTimestamp = this.pict.log.getTimeStamp();
	}

	/**
	 * Lifecycle hook that triggers after the view is projected into the DOM (async flow).
	 *
	 * @param {(error?: Error, content?: string) => void} fCallback - The callback to call when the async operation is complete.
	 * @param {Renderable} pRenderable - The renderable that is being projected.
	 */
	onProjectAsync(fCallback, pRenderable)
	{
		this.onProject(pRenderable);
		return fCallback();
	}

	/**
	 * Lifecycle hook that triggers after the view is rendered.
	 *
	 * @param {Renderable} pRenderable - The renderable that was rendered.
	 */
	onAfterRender(pRenderable)
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onAfterRender:`);
		}
		if (pRenderable && pRenderable.RootRenderableViewHash === this.Hash)
		{
			const tmpTransactionQueue = this.pict.TransactionTracking.clearTransactionQueue(pRenderable.TransactionHash) || [];
			for (const tmpEvent of tmpTransactionQueue)
			{
				const tmpView = this.pict.views[tmpEvent.Data.ViewHash];
				if (!tmpView)
				{
					this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onAfterRender: Could not find view for transaction hash ${pRenderable.TransactionHash} and ViewHash ${tmpEvent.Data.ViewHash}.`);
					continue;
				}
				tmpView.onAfterProject();

				// Execute the developer-overridable post-render behavior
				tmpView.onAfterRender(tmpEvent.Data.Renderable);
			}
			// Queue is drained and nested child renders have each cleaned up
			// their own transactions; remove this root render's entry from
			// the tracking map so it does not leak.
			this.pict.TransactionTracking.unregisterTransaction(pRenderable.TransactionHash);
		}
		return true;
	}

	/**
	 * Lifecycle hook that triggers after the view is rendered (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 * @param {Renderable} pRenderable - The renderable that was rendered.
	 */
	onAfterRenderAsync(fCallback, pRenderable)
	{
		// NOTE: this.onAfterRender(pRenderable) will itself clear the
		// transaction queue and unregister the transaction if this view is
		// the root renderable - see onAfterRender above. So by the time the
		// loop below runs, the queue is already empty and there is nothing
		// to drain. Keeping the async queue walk here defensively in case
		// future subclasses override onAfterRender in ways that skip the
		// drain, but the common path is now "sync drain, async no-op".
		this.onAfterRender(pRenderable);
		const tmpAnticipate = this.fable.newAnticipate();
		const tmpIsRootRenderable = pRenderable && pRenderable.RootRenderableViewHash === this.Hash;
		if (tmpIsRootRenderable)
		{
			const queue = this.pict.TransactionTracking.clearTransactionQueue(pRenderable.TransactionHash) || [];
			for (const event of queue)
			{
				/** @type {PictView} */
				const tmpView = this.pict.views[event.Data.ViewHash];
				if (!tmpView)
				{
					this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onAfterRenderAsync: Could not find view for transaction hash ${pRenderable.TransactionHash} and ViewHash ${event.Data.ViewHash}.`);
					continue;
				}
				tmpAnticipate.anticipate(tmpView.onAfterProjectAsync.bind(tmpView));
				tmpAnticipate.anticipate((fNext) =>
				{
					tmpView.onAfterRenderAsync(fNext, event.Data.Renderable);
				});

				// Execute the developer-overridable post-render behavior
			}
		}
		return tmpAnticipate.wait((pError) =>
		{
			// Nested virtual-assignment children have now settled their own
			// onAfterRenderAsync chains (and unregistered their own
			// transactions along the way). Ensure this root render's entry
			// is also gone - unregisterTransaction is a no-op if the sync
			// onAfterRender above already removed it, so this is safe to
			// call unconditionally on the root path.
			if (tmpIsRootRenderable && pRenderable && pRenderable.TransactionHash)
			{
				this.pict.TransactionTracking.unregisterTransaction(pRenderable.TransactionHash);
			}
			return fCallback(pError);
		});
	}

	/**
	 * Lifecycle hook that triggers after the view is projected into the DOM.
	 *
	 * @param {Renderable} pRenderable - The renderable that was projected.
	 */
	onAfterProject(pRenderable)
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onAfterProject:`);
		}
		return true;
	}

	/**
	 * Lifecycle hook that triggers after the view is projected into the DOM (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 * @param {Renderable} pRenderable - The renderable that was projected.
	 */
	onAfterProjectAsync(fCallback, pRenderable)
	{
		return fCallback();
	}

	/* -------------------------------------------------------------------------- */
	/*                            Code Section: Solver                            */
	/* -------------------------------------------------------------------------- */
	/**
	 * Lifecycle hook that triggers before the view is solved.
	 */
	onBeforeSolve()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onBeforeSolve:`);
		}
		return true;
	}

	/**
	 * Lifecycle hook that triggers before the view is solved (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 */
	onBeforeSolveAsync(fCallback)
	{
		this.onBeforeSolve();
		return fCallback();
	}

	/**
	 * Lifecycle hook that triggers when the view is solved.
	 */
	onSolve()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onSolve:`);
		}
		return true;
	}

	/**
	 * Lifecycle hook that triggers when the view is solved (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 */
	onSolveAsync(fCallback)
	{
		this.onSolve();
		return fCallback();
	}

	/**
	 * Performs view solving and triggers lifecycle hooks.
	 *
	 * @return {boolean} - True if the view was solved successfully, false otherwise.
	 */
	solve()
	{
		if (this.pict.LogNoisiness > 2)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} executing solve() function...`);
		}
		this.onBeforeSolve();
		this.onSolve();
		this.onAfterSolve();
		this.lastSolvedTimestamp = this.pict.log.getTimeStamp();
		return true;
	}

	/**
	 * Performs view solving and triggers lifecycle hooks (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 */
	solveAsync(fCallback)
	{
		let tmpAnticipate = this.pict.instantiateServiceProviderWithoutRegistration('Anticipate');

		/** @type {ErrorCallback} */
		let tmpCallback = (typeof(fCallback) === 'function') ? fCallback : null;
		if (!tmpCallback)
		{
			this.log.warn(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.Name} solveAsync was called without a valid callback.  A callback will be generated but this could lead to race conditions.`);
			tmpCallback = (pError) =>
				{
					if (pError)
					{
						this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.Name} solveAsync Auto Callback Error: ${pError}`, pError);
					}
				};
		}

		tmpAnticipate.anticipate(this.onBeforeSolveAsync.bind(this));
		tmpAnticipate.anticipate(this.onSolveAsync.bind(this));
		tmpAnticipate.anticipate(this.onAfterSolveAsync.bind(this));

		tmpAnticipate.wait(
			(pError) =>
			{
				if (this.pict.LogNoisiness > 2)
				{
					this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} solveAsync() complete.`);
				}
				this.lastSolvedTimestamp = this.pict.log.getTimeStamp();
				return tmpCallback(pError);
			});
	}

	/**
	 * Lifecycle hook that triggers after the view is solved.
	 */
	onAfterSolve()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onAfterSolve:`);
		}
		return true;
	}

	/**
	 * Lifecycle hook that triggers after the view is solved (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 */
	onAfterSolveAsync(fCallback)
	{
		this.onAfterSolve();
		return fCallback();
	}

	/* -------------------------------------------------------------------------- */
	/*                     Code Section: Marshal From View                        */
	/* -------------------------------------------------------------------------- */
	/**
	 * Lifecycle hook that triggers before data is marshaled from the view.
	 *
	 * @return {boolean} - True if the operation was successful, false otherwise.
	 */
	onBeforeMarshalFromView()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onBeforeMarshalFromView:`);
		}
		return true;
	}

	/**
	 * Lifecycle hook that triggers before data is marshaled from the view (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 */
	onBeforeMarshalFromViewAsync(fCallback)
	{
		this.onBeforeMarshalFromView();
		return fCallback();
	}

	/**
	 * Lifecycle hook that triggers when data is marshaled from the view.
	 */
	onMarshalFromView()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onMarshalFromView:`);
		}
		return true;
	}

	/**
	 * Lifecycle hook that triggers when data is marshaled from the view (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 */
	onMarshalFromViewAsync(fCallback)
	{

		this.onMarshalFromView();
		return fCallback();
	}

	/**
	 * Marshals data from the view.
	 *
	 * @return {boolean} - True if the operation was successful, false otherwise.
	 */
	marshalFromView()
	{
		if (this.pict.LogNoisiness > 2)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} executing solve() function...`);
		}
		this.onBeforeMarshalFromView();
		this.onMarshalFromView();
		this.onAfterMarshalFromView();
		this.lastMarshalFromViewTimestamp = this.pict.log.getTimeStamp();
		return true;
	}

	/**
	 * Marshals data from the view (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 */
	marshalFromViewAsync(fCallback)
	{
		let tmpAnticipate = this.pict.instantiateServiceProviderWithoutRegistration('Anticipate');

		/** @type {ErrorCallback} */
		let tmpCallback = (typeof(fCallback) === 'function') ? fCallback : null;
		if (!tmpCallback)
		{
			this.log.warn(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.Name} marshalFromViewAsync was called without a valid callback.  A callback will be generated but this could lead to race conditions.`);
			tmpCallback = (pError) =>
				{
					if (pError)
					{
						this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.Name} marshalFromViewAsync Auto Callback Error: ${pError}`, pError);
					}
				};
		}

		tmpAnticipate.anticipate(this.onBeforeMarshalFromViewAsync.bind(this));
		tmpAnticipate.anticipate(this.onMarshalFromViewAsync.bind(this));
		tmpAnticipate.anticipate(this.onAfterMarshalFromViewAsync.bind(this));

		tmpAnticipate.wait(
			(pError) =>
			{
				if (this.pict.LogNoisiness > 2)
				{
					this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} marshalFromViewAsync() complete.`);
				}
				this.lastMarshalFromViewTimestamp = this.pict.log.getTimeStamp();
				return tmpCallback(pError);
			});
	}

	/**
	 * Lifecycle hook that triggers after data is marshaled from the view.
	 */
	onAfterMarshalFromView()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onAfterMarshalFromView:`);
		}
		return true;
	}

	/**
	 * Lifecycle hook that triggers after data is marshaled from the view (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 */
	onAfterMarshalFromViewAsync(fCallback)
	{
		this.onAfterMarshalFromView();
		return fCallback();
	}

	/* -------------------------------------------------------------------------- */
	/*                     Code Section: Marshal To View                          */
	/* -------------------------------------------------------------------------- */
	/**
	 * Lifecycle hook that triggers before data is marshaled into the view.
	 */
	onBeforeMarshalToView()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onBeforeMarshalToView:`);
		}
		return true;
	}

	/**
	 * Lifecycle hook that triggers before data is marshaled into the view (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 */
	onBeforeMarshalToViewAsync(fCallback)
	{
		this.onBeforeMarshalToView();
		return fCallback();
	}

	/**
	 * Lifecycle hook that triggers when data is marshaled into the view.
	 */
	onMarshalToView()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onMarshalToView:`);
		}
		return true;
	}

	/**
	 * Lifecycle hook that triggers when data is marshaled into the view (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 */
	onMarshalToViewAsync(fCallback)
	{
		this.onMarshalToView();
		return fCallback();
	}

	/**
	 * Marshals data into the view.
	 *
	 * @return {boolean} - True if the operation was successful, false otherwise.
	 */
	marshalToView()
	{
		if (this.pict.LogNoisiness > 2)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} executing solve() function...`);
		}
		this.onBeforeMarshalToView();
		this.onMarshalToView();
		this.onAfterMarshalToView();
		this.lastMarshalToViewTimestamp = this.pict.log.getTimeStamp();
		return true;
	}

	/**
	 * Marshals data into the view (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 */
	marshalToViewAsync(fCallback)
	{
		let tmpAnticipate = this.pict.instantiateServiceProviderWithoutRegistration('Anticipate');


		/** @type {ErrorCallback} */
		let tmpCallback = (typeof(fCallback) === 'function') ? fCallback : null;
		if (!tmpCallback)
		{
			this.log.warn(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.Name} marshalToViewAsync was called without a valid callback.  A callback will be generated but this could lead to race conditions.`);
			tmpCallback = (pError) =>
				{
					if (pError)
					{
						this.log.error(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.Name} marshalToViewAsync Auto Callback Error: ${pError}`, pError);
					}
				};
		}
		tmpAnticipate.anticipate(this.onBeforeMarshalToViewAsync.bind(this));
		tmpAnticipate.anticipate(this.onMarshalToViewAsync.bind(this));
		tmpAnticipate.anticipate(this.onAfterMarshalToViewAsync.bind(this));

		tmpAnticipate.wait(
			(pError) =>
			{
				if (this.pict.LogNoisiness > 2)
				{
					this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} marshalToViewAsync() complete.`);
				}
				this.lastMarshalToViewTimestamp = this.pict.log.getTimeStamp();
				return tmpCallback(pError);
			});
	}

	/**
	 * Lifecycle hook that triggers after data is marshaled into the view.
	 */
	onAfterMarshalToView()
	{
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PictView [${this.UUID}]::[${this.Hash}] ${this.options.ViewIdentifier} onAfterMarshalToView:`);
		}
		return true;
	}

	/**
	 * Lifecycle hook that triggers after data is marshaled into the view (async flow).
	 *
	 * @param {ErrorCallback} fCallback - The callback to call when the async operation is complete.
	 */
	onAfterMarshalToViewAsync(fCallback)
	{
		this.onAfterMarshalToView();
		return fCallback();
	}

	/** @return {boolean} - True if the object is a PictView. */
	get isPictView()
	{
		return true;
	}
}

module.exports = PictView;

},{"../package.json":145,"fable-serviceproviderbase":59}],147:[function(require,module,exports){
/**
* Precedent Meta-Templating
*
* @license     MIT
*
* @author      Steven Velozo <steven@velozo.com>
*
* @description Process text streams, parsing out meta-template expressions.
*/
var libWordTree = require(`./WordTree.js`);
var libStringParser = require(`./StringParser.js`);

class Precedent
{
	/**
	 * Precedent Constructor
	 */
	constructor()
	{
		this.WordTree = new libWordTree();

		this.StringParser = new libStringParser();

		this.ParseTree = this.WordTree.ParseTree;
	}

	/**
	 * Add a Pattern to the Parse Tree
	 * @method addPattern
	 * @param {Object} pTree - A node on the parse tree to push the characters into
	 * @param {string} pPattern - The string to add to the tree
	 * @param {number} pIndex - callback function
	 * @return {bool} True if adding the pattern was successful
	 */
	addPattern(pPatternStart, pPatternEnd, pParser)
	{
		return this.WordTree.addPattern(pPatternStart, pPatternEnd, pParser);
	}

	/**
	 * Parse a string with the existing parse tree
	 * @method parseString
	 * @param {string} pString - The string to parse
	 * @param {object} pData - Data to pass in as the second argument
	 * @return {string} The result from the parser
	 */
	parseString(pString, pData)
	{
		return this.StringParser.parseString(pString, this.ParseTree, pData);
	}
}

module.exports = Precedent;

},{"./StringParser.js":148,"./WordTree.js":149}],148:[function(require,module,exports){
/**
* String Parser
* @author      Steven Velozo <steven@velozo.com>
* @description Parse a string, properly processing each matched token in the word tree.
*/

class StringParser
{
	/**
	 * StringParser Constructor
	 */
	constructor()
	{
	}

	/**
	 * Create a fresh parsing state object to work with.
	 * @method newParserState
	 * @param {Object} pParseTree - A node on the parse tree to begin parsing from (usually root)
	 * @return {Object} A new parser state object for running a character parser on
	 * @private
	 */
	newParserState (pParseTree)
	{
		return (
		{
			ParseTree: pParseTree,

			Asynchronous: false,

			Output: '',
			OutputBuffer: '',

			Pattern: {},

			PatternMatch: false,
			PatternMatchEnd: false
		});
	}

	/**
	 * Append a character to the output buffer in the parser state.
	 * This output buffer is used when a potential match is being explored, or a match is being explored.
	 * @method appendOutputBuffer
	 * @param {string} pCharacter - The character to append
	 * @param {Object} pParserState - The state object for the current parsing task
	 * @private
	 */
	appendOutputBuffer (pCharacter, pParserState)
	{
		pParserState.OutputBuffer += pCharacter;
	}

	/**
	 * Flush the output buffer to the output and clear it.
	 * @method flushOutputBuffer
	 * @param {Object} pParserState - The state object for the current parsing task
	 * @private
	 */
	flushOutputBuffer (pParserState)
	{
		pParserState.Output += pParserState.OutputBuffer;
		pParserState.OutputBuffer = '';
	}

	resetOutputBuffer (pParserState)
	{
		// Flush the output buffer.
		this.flushOutputBuffer(pParserState);
		// End pattern mode
		pParserState.Pattern = false;
		pParserState.PatternStartNode = false;
		pParserState.StartPatternMatchComplete = false;
		pParserState.EndPatternMatchBegan = false;
		pParserState.PatternMatch = false;

		return true;
	}

	/**
	 * Parse a character in the buffer.
	 * @method parseCharacter
	 * @param {string} pCharacter - The character to append
	 * @param {Object} pParserState - The state object for the current parsing task
	 * @private
	 */
	parseCharacter (pCharacter, pParserState, pData)
	{
		// If we are already in a pattern match traversal
		if (pParserState.PatternMatch)
		{
			// If the pattern is still matching the start and we haven't passed the buffer
			if (!pParserState.StartPatternMatchComplete && pParserState.Pattern.hasOwnProperty(pCharacter))
			{
				pParserState.Pattern = pParserState.Pattern[pCharacter];
				this.appendOutputBuffer(pCharacter, pParserState);
			}
			else if (pParserState.EndPatternMatchBegan)
			{
				if (pParserState.Pattern.PatternEnd.hasOwnProperty(pCharacter))
				{
					// This leaf has a PatternEnd tree, so we will wait until that end is met.
					pParserState.Pattern = pParserState.Pattern.PatternEnd[pCharacter];
					// Flush the output buffer.
					this.appendOutputBuffer(pCharacter, pParserState);
					// If this last character is the end of the pattern, parse it.
					if (pParserState.Pattern.hasOwnProperty('Parse'))
					{
						// Run the function
						pParserState.OutputBuffer = pParserState.Pattern.Parse(pParserState.OutputBuffer.substr(pParserState.Pattern.PatternStartString.length, pParserState.OutputBuffer.length - (pParserState.Pattern.PatternStartString.length+pParserState.Pattern.PatternEndString.length)), pData);
						return this.resetOutputBuffer(pParserState);
					}
				}
				else if (pParserState.PatternStartNode.PatternEnd.hasOwnProperty(pCharacter))
				{
					// We broke out of the end -- see if this is a new start of the end.
					pParserState.Pattern = pParserState.PatternStartNode.PatternEnd[pCharacter];
					this.appendOutputBuffer(pCharacter, pParserState);
				}
				else
				{
					pParserState.EndPatternMatchBegan = false;
					this.appendOutputBuffer(pCharacter, pParserState);
				}
			}
			else if (pParserState.Pattern.hasOwnProperty('PatternEnd'))
			{
				if (!pParserState.StartPatternMatchComplete)
				{
					pParserState.StartPatternMatchComplete = true;
					pParserState.PatternStartNode = pParserState.Pattern;
				}

				this.appendOutputBuffer(pCharacter, pParserState);

				if (pParserState.Pattern.PatternEnd.hasOwnProperty(pCharacter))
				{
					// This is the first character of the end pattern.
					pParserState.EndPatternMatchBegan = true;
					// This leaf has a PatternEnd tree, so we will wait until that end is met.
					pParserState.Pattern = pParserState.Pattern.PatternEnd[pCharacter];
					// If this last character is the end of the pattern, parse it.
					if (pParserState.Pattern.hasOwnProperty('Parse'))
					{
						// Run the t*mplate function
						pParserState.OutputBuffer = pParserState.Pattern.Parse(pParserState.OutputBuffer.substr(pParserState.Pattern.PatternStartString.length, pParserState.OutputBuffer.length - (pParserState.Pattern.PatternStartString.length+pParserState.Pattern.PatternEndString.length)), pData);
						return this.resetOutputBuffer(pParserState);
					}
				}
			}
			else
			{
				// We are in a pattern start but didn't match one; reset and start trying again from this character.
				this.resetOutputBuffer(pParserState);
			}
		}
		// If we aren't in a pattern match or pattern, and this isn't the start of a new pattern (RAW mode)....
		if (!pParserState.PatternMatch)
		{
			// This may be the start of a new pattern....
			if (pParserState.ParseTree.hasOwnProperty(pCharacter))
			{
				// ... assign the root node as the matched node.
				this.resetOutputBuffer(pParserState);
				this.appendOutputBuffer(pCharacter, pParserState);
				pParserState.Pattern = pParserState.ParseTree[pCharacter];
				pParserState.PatternMatch = true;
				return true;
			}
			else
			{
				this.appendOutputBuffer(pCharacter, pParserState);
			}
		}
		return false;
	}

	/**
	 * Parse a string for matches, and process any template segments that occur.
	 * @method parseString
	 * @param {string} pString - The string to parse.
	 * @param {Object} pParseTree - The parse tree to begin parsing from (usually root)
	 * @param {Object} pData - The data to pass to the function as a second parameter
	 */
	parseString (pString, pParseTree, pData)
	{
		let tmpParserState = this.newParserState(pParseTree);

		for (var i = 0; i < pString.length; i++)
		{
			this.parseCharacter(pString[i], tmpParserState, pData);
		}

		this.flushOutputBuffer(tmpParserState);

		return tmpParserState.Output;
	}
}

module.exports = StringParser;

},{}],149:[function(require,module,exports){
/**
* Word Tree
* @author      Steven Velozo <steven@velozo.com>
* @description Create a tree (directed graph) of Javascript objects, one character per object.
*/

class WordTree
{
	/**
	 * WordTree Constructor
	 */
	constructor()
	{
		this.ParseTree = {};
	}

	/**
	 * Add a child character to a Parse Tree node
	 * @method addChild
	 * @param {Object} pTree - A parse tree to push the characters into
	 * @param {string} pPattern - The string to add to the tree
	 * @returns {Object} The resulting leaf node that was added (or found)
	 * @private
	 */
	addChild (pTree, pPattern)
	{
		if (!pTree.hasOwnProperty(pPattern))
		{
			pTree[pPattern] = {};
		}

		return pTree[pPattern];
	}

	/**
	 * Add a child character to a Parse Tree PatternEnd subtree
	 * @method addChild
	 * @param {Object} pTree - A parse tree to push the characters into
	 * @param {string} pPattern - The string to add to the tree
	 * @returns {Object} The resulting leaf node that was added (or found)
	 * @private
	 */
	addEndChild (pTree, pPattern)
	{
		if (!pTree.hasOwnProperty('PatternEnd'))
		{
			pTree.PatternEnd = {};
		}

		pTree.PatternEnd[pPattern] = {};

		return pTree.PatternEnd[pPattern];
	}

	/** Add a Pattern to the Parse Tree
	 * @method addPattern
	 * @param {Object} pPatternStart - The starting string for the pattern (e.g. "${")
	 * @param {string} pPatternEnd - The ending string for the pattern (e.g. "}")
	 * @param {function} fParser - The function to parse if this is the matched pattern, once the Pattern End is met.  If this is a string, a simple replacement occurs.
	 * @return {bool} True if adding the pattern was successful
	 */
	addPattern (pPatternStart, pPatternEnd, fParser)
	{
		if (pPatternStart.length < 1)
		{
			return false;
		}

		if ((typeof(pPatternEnd) === 'string') && (pPatternEnd.length < 1))
		{
			return false;
		}

		let tmpLeaf = this.ParseTree;

		// Add the tree of leaves iteratively
		for (var i = 0; i < pPatternStart.length; i++)
		{
			tmpLeaf = this.addChild(tmpLeaf, pPatternStart[i], i);
		}

		if (!tmpLeaf.hasOwnProperty('PatternEnd'))
		{
			tmpLeaf.PatternEnd = {};
		}

		let tmpPatternEnd = (typeof(pPatternEnd) === 'string') ? pPatternEnd : pPatternStart;
		for (let i = 0; i < tmpPatternEnd.length; i++)
		{
			tmpLeaf = this.addEndChild(tmpLeaf, tmpPatternEnd[i], i);
		}

		tmpLeaf.PatternStartString = pPatternStart;
		tmpLeaf.PatternEndString = tmpPatternEnd;
		tmpLeaf.Parse = (typeof(fParser) === 'function') ? fParser :
						(typeof(fParser) === 'string') ? () => { return fParser; } :
						(pData) => { return pData; };

		return true;
	}
}

module.exports = WordTree;

},{}],150:[function(require,module,exports){
// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };

},{}],151:[function(require,module,exports){
'use strict';

var replace = String.prototype.replace;
var percentTwenties = /%20/g;

var Format = {
    RFC1738: 'RFC1738',
    RFC3986: 'RFC3986'
};

module.exports = {
    'default': Format.RFC3986,
    formatters: {
        RFC1738: function (value) {
            return replace.call(value, percentTwenties, '+');
        },
        RFC3986: function (value) {
            return String(value);
        }
    },
    RFC1738: Format.RFC1738,
    RFC3986: Format.RFC3986
};

},{}],152:[function(require,module,exports){
'use strict';

var stringify = require('./stringify');
var parse = require('./parse');
var formats = require('./formats');

module.exports = {
    formats: formats,
    parse: parse,
    stringify: stringify
};

},{"./formats":151,"./parse":153,"./stringify":154}],153:[function(require,module,exports){
'use strict';

var utils = require('./utils');

var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;

var defaults = {
    allowDots: false,
    allowEmptyArrays: false,
    allowPrototypes: false,
    allowSparse: false,
    arrayLimit: 20,
    charset: 'utf-8',
    charsetSentinel: false,
    comma: false,
    decodeDotInKeys: false,
    decoder: utils.decode,
    delimiter: '&',
    depth: 5,
    duplicates: 'combine',
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictDepth: false,
    strictMerge: true,
    strictNullHandling: false,
    throwOnLimitExceeded: false
};

var interpretNumericEntities = function (str) {
    return str.replace(/&#(\d+);/g, function ($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};

var parseArrayValue = function (val, options, currentArrayLength) {
    if (val && typeof val === 'string' && options.comma && val.indexOf(',') > -1) {
        return val.split(',');
    }

    if (options.throwOnLimitExceeded && currentArrayLength >= options.arrayLimit) {
        throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
    }

    return val;
};

// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')

// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')

var parseValues = function parseQueryStringValues(str, options) {
    var obj = { __proto__: null };

    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
    cleanStr = cleanStr.replace(/%5B/gi, '[').replace(/%5D/gi, ']');

    var limit = options.parameterLimit === Infinity ? void undefined : options.parameterLimit;
    var parts = cleanStr.split(
        options.delimiter,
        options.throwOnLimitExceeded && typeof limit !== 'undefined' ? limit + 1 : limit
    );

    if (options.throwOnLimitExceeded && typeof limit !== 'undefined' && parts.length > limit) {
        throw new RangeError('Parameter limit exceeded. Only ' + limit + ' parameter' + (limit === 1 ? '' : 's') + ' allowed.');
    }

    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;

    var charset = options.charset;
    if (options.charsetSentinel) {
        for (i = 0; i < parts.length; ++i) {
            if (parts[i].indexOf('utf8=') === 0) {
                if (parts[i] === charsetSentinel) {
                    charset = 'utf-8';
                } else if (parts[i] === isoSentinel) {
                    charset = 'iso-8859-1';
                }
                skipIndex = i;
                i = parts.length; // The eslint settings do not allow break;
            }
        }
    }

    for (i = 0; i < parts.length; ++i) {
        if (i === skipIndex) {
            continue;
        }
        var part = parts[i];

        var bracketEqualsPos = part.indexOf(']=');
        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;

        var key;
        var val;
        if (pos === -1) {
            key = options.decoder(part, defaults.decoder, charset, 'key');
            val = options.strictNullHandling ? null : '';
        } else {
            key = options.decoder(part.slice(0, pos), defaults.decoder, charset, 'key');

            if (key !== null) {
                val = utils.maybeMap(
                    parseArrayValue(
                        part.slice(pos + 1),
                        options,
                        isArray(obj[key]) ? obj[key].length : 0
                    ),
                    function (encodedVal) {
                        return options.decoder(encodedVal, defaults.decoder, charset, 'value');
                    }
                );
            }
        }

        if (val && options.interpretNumericEntities && charset === 'iso-8859-1') {
            val = interpretNumericEntities(String(val));
        }

        if (part.indexOf('[]=') > -1) {
            val = isArray(val) ? [val] : val;
        }

        if (options.comma && isArray(val) && val.length > options.arrayLimit) {
            if (options.throwOnLimitExceeded) {
                throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
            }
            val = utils.combine([], val, options.arrayLimit, options.plainObjects);
        }

        if (key !== null) {
            var existing = has.call(obj, key);
            if (existing && (options.duplicates === 'combine' || part.indexOf('[]=') > -1)) {
                obj[key] = utils.combine(
                    obj[key],
                    val,
                    options.arrayLimit,
                    options.plainObjects
                );
            } else if (!existing || options.duplicates === 'last') {
                obj[key] = val;
            }
        }
    }

    return obj;
};

var parseObject = function (chain, val, options, valuesParsed) {
    var currentArrayLength = 0;
    if (chain.length > 0 && chain[chain.length - 1] === '[]') {
        var parentKey = chain.slice(0, -1).join('');
        currentArrayLength = Array.isArray(val) && val[parentKey] ? val[parentKey].length : 0;
    }

    var leaf = valuesParsed ? val : parseArrayValue(val, options, currentArrayLength);

    for (var i = chain.length - 1; i >= 0; --i) {
        var obj;
        var root = chain[i];

        if (root === '[]' && options.parseArrays) {
            if (utils.isOverflow(leaf)) {
                // leaf is already an overflow object, preserve it
                obj = leaf;
            } else {
                obj = options.allowEmptyArrays && (leaf === '' || (options.strictNullHandling && leaf === null))
                    ? []
                    : utils.combine(
                        [],
                        leaf,
                        options.arrayLimit,
                        options.plainObjects
                    );
            }
        } else {
            obj = options.plainObjects ? { __proto__: null } : {};
            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
            var decodedRoot = options.decodeDotInKeys ? cleanRoot.replace(/%2E/g, '.') : cleanRoot;
            var index = parseInt(decodedRoot, 10);
            var isValidArrayIndex = !isNaN(index)
                && root !== decodedRoot
                && String(index) === decodedRoot
                && index >= 0
                && options.parseArrays;
            if (!options.parseArrays && decodedRoot === '') {
                obj = { 0: leaf };
            } else if (isValidArrayIndex && index < options.arrayLimit) {
                obj = [];
                obj[index] = leaf;
            } else if (isValidArrayIndex && options.throwOnLimitExceeded) {
                throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
            } else if (isValidArrayIndex) {
                obj[index] = leaf;
                utils.markOverflow(obj, index);
            } else if (decodedRoot !== '__proto__') {
                obj[decodedRoot] = leaf;
            }
        }

        leaf = obj;
    }

    return leaf;
};

// Split a key like "a[b][c[]]" into ['a', '[b]', '[c[]]'] while preserving
// qs parse semantics for depth/prototype guards.
var splitKeyIntoSegments = function splitKeyIntoSegments(originalKey, options) {
    var key = options.allowDots ? originalKey.replace(/\.([^.[]+)/g, '[$1]') : originalKey;

    // depth <= 0 keeps the whole key as one segment
    if (options.depth <= 0) {
        if (!options.plainObjects && has.call(Object.prototype, key)) {
            if (!options.allowPrototypes) {
                return;
            }
        }

        return [key];
    }

    var segments = [];

    // parent before the first '[' (may be empty if key starts with '[')
    var first = key.indexOf('[');
    var parent = first >= 0 ? key.slice(0, first) : key;
    if (parent) {
        if (!options.plainObjects && has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) {
                return;
            }
        }

        segments[segments.length] = parent;
    }

    var n = key.length;
    var open = first;
    var collected = 0;

    while (open >= 0 && collected < options.depth) {
        var level = 1;
        var i = open + 1;
        var close = -1;

        // balance nested '[' and ']' inside this bracket group using a nesting level counter
        while (i < n && close < 0) {
            var cu = key.charCodeAt(i);
            if (cu === 0x5B) { // '['
                level += 1;
            } else if (cu === 0x5D) { // ']'
                level -= 1;
                if (level === 0) {
                    close = i; // found matching close; loop will exit by condition
                }
            }
            i += 1;
        }

        if (close < 0) {
            // Unterminated group: wrap the raw remainder in one bracket pair so it stays
            // a single literal segment (e.g. "[[]b" -> "[[]b]"); we do not infer missing ']'.
            segments[segments.length] = '[' + key.slice(open) + ']';
            return segments;
        }

        var seg = key.slice(open, close + 1);
        // prototype guard for the content of this group
        var content = seg.slice(1, -1);
        if (!options.plainObjects && has.call(Object.prototype, content) && !options.allowPrototypes) {
            return;
        }

        segments[segments.length] = seg;
        collected += 1;

        // find the next '[' after this balanced group
        open = key.indexOf('[', close + 1);
    }

    if (open >= 0) {
        if (options.strictDepth === true) {
            throw new RangeError('Input depth exceeded depth option of ' + options.depth + ' and strictDepth is true');
        }

        segments[segments.length] = '[' + key.slice(open) + ']';
    }

    return segments;
};

var parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) {
        return;
    }

    var keys = splitKeyIntoSegments(givenKey, options);

    if (!keys) {
        return;
    }

    return parseObject(keys, val, options, valuesParsed);
};

var normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) {
        return defaults;
    }

    if (typeof opts.allowEmptyArrays !== 'undefined' && typeof opts.allowEmptyArrays !== 'boolean') {
        throw new TypeError('`allowEmptyArrays` option can only be `true` or `false`, when provided');
    }

    if (typeof opts.decodeDotInKeys !== 'undefined' && typeof opts.decodeDotInKeys !== 'boolean') {
        throw new TypeError('`decodeDotInKeys` option can only be `true` or `false`, when provided');
    }

    if (opts.decoder !== null && typeof opts.decoder !== 'undefined' && typeof opts.decoder !== 'function') {
        throw new TypeError('Decoder has to be a function.');
    }

    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    }

    if (typeof opts.throwOnLimitExceeded !== 'undefined' && typeof opts.throwOnLimitExceeded !== 'boolean') {
        throw new TypeError('`throwOnLimitExceeded` option must be a boolean');
    }

    var charset = typeof opts.charset === 'undefined' ? defaults.charset : opts.charset;

    var duplicates = typeof opts.duplicates === 'undefined' ? defaults.duplicates : opts.duplicates;

    if (duplicates !== 'combine' && duplicates !== 'first' && duplicates !== 'last') {
        throw new TypeError('The duplicates option must be either combine, first, or last');
    }

    var allowDots = typeof opts.allowDots === 'undefined' ? opts.decodeDotInKeys === true ? true : defaults.allowDots : !!opts.allowDots;

    return {
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === 'boolean' ? !!opts.allowEmptyArrays : defaults.allowEmptyArrays,
        allowPrototypes: typeof opts.allowPrototypes === 'boolean' ? opts.allowPrototypes : defaults.allowPrototypes,
        allowSparse: typeof opts.allowSparse === 'boolean' ? opts.allowSparse : defaults.allowSparse,
        arrayLimit: typeof opts.arrayLimit === 'number' ? opts.arrayLimit : defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
        comma: typeof opts.comma === 'boolean' ? opts.comma : defaults.comma,
        decodeDotInKeys: typeof opts.decodeDotInKeys === 'boolean' ? opts.decodeDotInKeys : defaults.decodeDotInKeys,
        decoder: typeof opts.decoder === 'function' ? opts.decoder : defaults.decoder,
        delimiter: typeof opts.delimiter === 'string' || utils.isRegExp(opts.delimiter) ? opts.delimiter : defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: (typeof opts.depth === 'number' || opts.depth === false) ? +opts.depth : defaults.depth,
        duplicates: duplicates,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === 'boolean' ? opts.interpretNumericEntities : defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === 'number' ? opts.parameterLimit : defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === 'boolean' ? opts.plainObjects : defaults.plainObjects,
        strictDepth: typeof opts.strictDepth === 'boolean' ? !!opts.strictDepth : defaults.strictDepth,
        strictMerge: typeof opts.strictMerge === 'boolean' ? !!opts.strictMerge : defaults.strictMerge,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling,
        throwOnLimitExceeded: typeof opts.throwOnLimitExceeded === 'boolean' ? opts.throwOnLimitExceeded : false
    };
};

module.exports = function (str, opts) {
    var options = normalizeParseOptions(opts);

    if (str === '' || str === null || typeof str === 'undefined') {
        return options.plainObjects ? { __proto__: null } : {};
    }

    var tempObj = typeof str === 'string' ? parseValues(str, options) : str;
    var obj = options.plainObjects ? { __proto__: null } : {};

    // Iterate over the keys and setup the new object

    var keys = Object.keys(tempObj);
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        var newObj = parseKeys(key, tempObj[key], options, typeof str === 'string');
        obj = utils.merge(obj, newObj, options);
    }

    if (options.allowSparse === true) {
        return obj;
    }

    return utils.compact(obj);
};

},{"./utils":155}],154:[function(require,module,exports){
'use strict';

var getSideChannel = require('side-channel');
var utils = require('./utils');
var formats = require('./formats');
var has = Object.prototype.hasOwnProperty;

var arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + '[]';
    },
    comma: 'comma',
    indices: function indices(prefix, key) {
        return prefix + '[' + key + ']';
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};

var isArray = Array.isArray;
var push = Array.prototype.push;
var pushToArray = function (arr, valueOrArray) {
    push.apply(arr, isArray(valueOrArray) ? valueOrArray : [valueOrArray]);
};

var toISO = Date.prototype.toISOString;

var defaultFormat = formats['default'];
var defaults = {
    addQueryPrefix: false,
    allowDots: false,
    allowEmptyArrays: false,
    arrayFormat: 'indices',
    charset: 'utf-8',
    charsetSentinel: false,
    commaRoundTrip: false,
    delimiter: '&',
    encode: true,
    encodeDotInKeys: false,
    encoder: utils.encode,
    encodeValuesOnly: false,
    filter: void undefined,
    format: defaultFormat,
    formatter: formats.formatters[defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};

var isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === 'string'
        || typeof v === 'number'
        || typeof v === 'boolean'
        || typeof v === 'symbol'
        || typeof v === 'bigint';
};

var sentinel = {};

var stringify = function stringify(
    object,
    prefix,
    generateArrayPrefix,
    commaRoundTrip,
    allowEmptyArrays,
    strictNullHandling,
    skipNulls,
    encodeDotInKeys,
    encoder,
    filter,
    sort,
    allowDots,
    serializeDate,
    format,
    formatter,
    encodeValuesOnly,
    charset,
    sideChannel
) {
    var obj = object;

    var tmpSc = sideChannel;
    var step = 0;
    var findFlag = false;
    while ((tmpSc = tmpSc.get(sentinel)) !== void undefined && !findFlag) {
        // Where object last appeared in the ref tree
        var pos = tmpSc.get(object);
        step += 1;
        if (typeof pos !== 'undefined') {
            if (pos === step) {
                throw new RangeError('Cyclic object value');
            } else {
                findFlag = true; // Break while
            }
        }
        if (typeof tmpSc.get(sentinel) === 'undefined') {
            step = 0;
        }
    }

    if (typeof filter === 'function') {
        obj = filter(prefix, obj);
    } else if (obj instanceof Date) {
        obj = serializeDate(obj);
    } else if (generateArrayPrefix === 'comma' && isArray(obj)) {
        obj = utils.maybeMap(obj, function (value) {
            if (value instanceof Date) {
                return serializeDate(value);
            }
            return value;
        });
    }

    if (obj === null) {
        if (strictNullHandling) {
            return formatter(encoder && !encodeValuesOnly ? encoder(prefix, defaults.encoder, charset, 'key', format) : prefix);
        }

        obj = '';
    }

    if (isNonNullishPrimitive(obj) || utils.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults.encoder, charset, 'key', format);
            return [formatter(keyValue) + '=' + formatter(encoder(obj, defaults.encoder, charset, 'value', format))];
        }
        return [formatter(prefix) + '=' + formatter(String(obj))];
    }

    var values = [];

    if (typeof obj === 'undefined') {
        return values;
    }

    var objKeys;
    if (generateArrayPrefix === 'comma' && isArray(obj)) {
        // we need to join elements in
        if (encodeValuesOnly && encoder) {
            obj = utils.maybeMap(obj, function (v) {
                return v == null ? v : encoder(v);
            });
        }
        objKeys = [{ value: obj.length > 0 ? obj.join(',') || null : void undefined }];
    } else if (isArray(filter)) {
        objKeys = filter;
    } else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }

    var encodedPrefix = encodeDotInKeys ? String(prefix).replace(/\./g, '%2E') : String(prefix);

    var adjustedPrefix = commaRoundTrip && isArray(obj) && obj.length === 1 ? encodedPrefix + '[]' : encodedPrefix;

    if (allowEmptyArrays && isArray(obj) && obj.length === 0) {
        return adjustedPrefix + '[]';
    }

    for (var j = 0; j < objKeys.length; ++j) {
        var key = objKeys[j];
        var value = typeof key === 'object' && key && typeof key.value !== 'undefined'
            ? key.value
            : obj[key];

        if (skipNulls && value === null) {
            continue;
        }

        var encodedKey = allowDots && encodeDotInKeys ? String(key).replace(/\./g, '%2E') : String(key);
        var keyPrefix = isArray(obj)
            ? typeof generateArrayPrefix === 'function' ? generateArrayPrefix(adjustedPrefix, encodedKey) : adjustedPrefix
            : adjustedPrefix + (allowDots ? '.' + encodedKey : '[' + encodedKey + ']');

        sideChannel.set(object, step);
        var valueSideChannel = getSideChannel();
        valueSideChannel.set(sentinel, sideChannel);
        pushToArray(values, stringify(
            value,
            keyPrefix,
            generateArrayPrefix,
            commaRoundTrip,
            allowEmptyArrays,
            strictNullHandling,
            skipNulls,
            encodeDotInKeys,
            generateArrayPrefix === 'comma' && encodeValuesOnly && isArray(obj) ? null : encoder,
            filter,
            sort,
            allowDots,
            serializeDate,
            format,
            formatter,
            encodeValuesOnly,
            charset,
            valueSideChannel
        ));
    }

    return values;
};

var normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) {
        return defaults;
    }

    if (typeof opts.allowEmptyArrays !== 'undefined' && typeof opts.allowEmptyArrays !== 'boolean') {
        throw new TypeError('`allowEmptyArrays` option can only be `true` or `false`, when provided');
    }

    if (typeof opts.encodeDotInKeys !== 'undefined' && typeof opts.encodeDotInKeys !== 'boolean') {
        throw new TypeError('`encodeDotInKeys` option can only be `true` or `false`, when provided');
    }

    if (opts.encoder !== null && typeof opts.encoder !== 'undefined' && typeof opts.encoder !== 'function') {
        throw new TypeError('Encoder has to be a function.');
    }

    var charset = opts.charset || defaults.charset;
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    }

    var format = formats['default'];
    if (typeof opts.format !== 'undefined') {
        if (!has.call(formats.formatters, opts.format)) {
            throw new TypeError('Unknown format option provided.');
        }
        format = opts.format;
    }
    var formatter = formats.formatters[format];

    var filter = defaults.filter;
    if (typeof opts.filter === 'function' || isArray(opts.filter)) {
        filter = opts.filter;
    }

    var arrayFormat;
    if (opts.arrayFormat in arrayPrefixGenerators) {
        arrayFormat = opts.arrayFormat;
    } else if ('indices' in opts) {
        arrayFormat = opts.indices ? 'indices' : 'repeat';
    } else {
        arrayFormat = defaults.arrayFormat;
    }

    if ('commaRoundTrip' in opts && typeof opts.commaRoundTrip !== 'boolean') {
        throw new TypeError('`commaRoundTrip` must be a boolean, or absent');
    }

    var allowDots = typeof opts.allowDots === 'undefined' ? opts.encodeDotInKeys === true ? true : defaults.allowDots : !!opts.allowDots;

    return {
        addQueryPrefix: typeof opts.addQueryPrefix === 'boolean' ? opts.addQueryPrefix : defaults.addQueryPrefix,
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === 'boolean' ? !!opts.allowEmptyArrays : defaults.allowEmptyArrays,
        arrayFormat: arrayFormat,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
        commaRoundTrip: !!opts.commaRoundTrip,
        delimiter: typeof opts.delimiter === 'undefined' ? defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === 'boolean' ? opts.encode : defaults.encode,
        encodeDotInKeys: typeof opts.encodeDotInKeys === 'boolean' ? opts.encodeDotInKeys : defaults.encodeDotInKeys,
        encoder: typeof opts.encoder === 'function' ? opts.encoder : defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === 'boolean' ? opts.encodeValuesOnly : defaults.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === 'function' ? opts.serializeDate : defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === 'boolean' ? opts.skipNulls : defaults.skipNulls,
        sort: typeof opts.sort === 'function' ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
    };
};

module.exports = function (object, opts) {
    var obj = object;
    var options = normalizeStringifyOptions(opts);

    var objKeys;
    var filter;

    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    } else if (isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }

    var keys = [];

    if (typeof obj !== 'object' || obj === null) {
        return '';
    }

    var generateArrayPrefix = arrayPrefixGenerators[options.arrayFormat];
    var commaRoundTrip = generateArrayPrefix === 'comma' && options.commaRoundTrip;

    if (!objKeys) {
        objKeys = Object.keys(obj);
    }

    if (options.sort) {
        objKeys.sort(options.sort);
    }

    var sideChannel = getSideChannel();
    for (var i = 0; i < objKeys.length; ++i) {
        var key = objKeys[i];

        if (typeof key === 'undefined' || key === null) {
            continue;
        }

        var value = obj[key];

        if (options.skipNulls && value === null) {
            continue;
        }
        pushToArray(keys, stringify(
            value,
            key,
            generateArrayPrefix,
            commaRoundTrip,
            options.allowEmptyArrays,
            options.strictNullHandling,
            options.skipNulls,
            options.encodeDotInKeys,
            options.encode ? options.encoder : null,
            options.filter,
            options.sort,
            options.allowDots,
            options.serializeDate,
            options.format,
            options.formatter,
            options.encodeValuesOnly,
            options.charset,
            sideChannel
        ));
    }

    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? '?' : '';

    if (options.charsetSentinel) {
        if (options.charset === 'iso-8859-1') {
            // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
            prefix += 'utf8=%26%2310003%3B' + options.delimiter;
        } else {
            // encodeURIComponent('✓')
            prefix += 'utf8=%E2%9C%93' + options.delimiter;
        }
    }

    return joined.length > 0 ? prefix + joined : '';
};

},{"./formats":151,"./utils":155,"side-channel":163}],155:[function(require,module,exports){
'use strict';

var formats = require('./formats');
var getSideChannel = require('side-channel');

var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;

// Track objects created from arrayLimit overflow using side-channel
// Stores the current max numeric index for O(1) lookup
var overflowChannel = getSideChannel();

var markOverflow = function markOverflow(obj, maxIndex) {
    overflowChannel.set(obj, maxIndex);
    return obj;
};

var isOverflow = function isOverflow(obj) {
    return overflowChannel.has(obj);
};

var getMaxIndex = function getMaxIndex(obj) {
    return overflowChannel.get(obj);
};

var setMaxIndex = function setMaxIndex(obj, maxIndex) {
    overflowChannel.set(obj, maxIndex);
};

var hexTable = (function () {
    var array = [];
    for (var i = 0; i < 256; ++i) {
        array[array.length] = '%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase();
    }

    return array;
}());

var compactQueue = function compactQueue(queue) {
    while (queue.length > 1) {
        var item = queue.pop();
        var obj = item.obj[item.prop];

        if (isArray(obj)) {
            var compacted = [];

            for (var j = 0; j < obj.length; ++j) {
                if (typeof obj[j] !== 'undefined') {
                    compacted[compacted.length] = obj[j];
                }
            }

            item.obj[item.prop] = compacted;
        }
    }
};

var arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? { __proto__: null } : {};
    for (var i = 0; i < source.length; ++i) {
        if (typeof source[i] !== 'undefined') {
            obj[i] = source[i];
        }
    }

    return obj;
};

var merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */
    if (!source) {
        return target;
    }

    if (typeof source !== 'object' && typeof source !== 'function') {
        if (isArray(target)) {
            var nextIndex = target.length;
            if (options && typeof options.arrayLimit === 'number' && nextIndex > options.arrayLimit) {
                return markOverflow(arrayToObject(target.concat(source), options), nextIndex);
            }
            target[nextIndex] = source;
        } else if (target && typeof target === 'object') {
            if (isOverflow(target)) {
                // Add at next numeric index for overflow objects
                var newIndex = getMaxIndex(target) + 1;
                target[newIndex] = source;
                setMaxIndex(target, newIndex);
            } else if (options && options.strictMerge) {
                return [target, source];
            } else if (
                (options && (options.plainObjects || options.allowPrototypes))
                || !has.call(Object.prototype, source)
            ) {
                target[source] = true;
            }
        } else {
            return [target, source];
        }

        return target;
    }

    if (!target || typeof target !== 'object') {
        if (isOverflow(source)) {
            // Create new object with target at 0, source values shifted by 1
            var sourceKeys = Object.keys(source);
            var result = options && options.plainObjects
                ? { __proto__: null, 0: target }
                : { 0: target };
            for (var m = 0; m < sourceKeys.length; m++) {
                var oldKey = parseInt(sourceKeys[m], 10);
                result[oldKey + 1] = source[sourceKeys[m]];
            }
            return markOverflow(result, getMaxIndex(source) + 1);
        }
        var combined = [target].concat(source);
        if (options && typeof options.arrayLimit === 'number' && combined.length > options.arrayLimit) {
            return markOverflow(arrayToObject(combined, options), combined.length - 1);
        }
        return combined;
    }

    var mergeTarget = target;
    if (isArray(target) && !isArray(source)) {
        mergeTarget = arrayToObject(target, options);
    }

    if (isArray(target) && isArray(source)) {
        source.forEach(function (item, i) {
            if (has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === 'object' && item && typeof item === 'object') {
                    target[i] = merge(targetItem, item, options);
                } else {
                    target[target.length] = item;
                }
            } else {
                target[i] = item;
            }
        });
        return target;
    }

    return Object.keys(source).reduce(function (acc, key) {
        var value = source[key];

        if (has.call(acc, key)) {
            acc[key] = merge(acc[key], value, options);
        } else {
            acc[key] = value;
        }

        if (isOverflow(source) && !isOverflow(acc)) {
            markOverflow(acc, getMaxIndex(source));
        }
        if (isOverflow(acc)) {
            var keyNum = parseInt(key, 10);
            if (String(keyNum) === key && keyNum >= 0 && keyNum > getMaxIndex(acc)) {
                setMaxIndex(acc, keyNum);
            }
        }

        return acc;
    }, mergeTarget);
};

var assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function (acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};

var decode = function (str, defaultDecoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, ' ');
    if (charset === 'iso-8859-1') {
        // unescape never throws, no try...catch needed:
        return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    }
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};

var limit = 1024;

/* eslint operator-linebreak: [2, "before"] */

var encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) {
        return str;
    }

    var string = str;
    if (typeof str === 'symbol') {
        string = Symbol.prototype.toString.call(str);
    } else if (typeof str !== 'string') {
        string = String(str);
    }

    if (charset === 'iso-8859-1') {
        return escape(string).replace(/%u[0-9a-f]{4}/gi, function ($0) {
            return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
        });
    }

    var out = '';
    for (var j = 0; j < string.length; j += limit) {
        var segment = string.length >= limit ? string.slice(j, j + limit) : string;
        var arr = [];

        for (var i = 0; i < segment.length; ++i) {
            var c = segment.charCodeAt(i);
            if (
                c === 0x2D // -
                || c === 0x2E // .
                || c === 0x5F // _
                || c === 0x7E // ~
                || (c >= 0x30 && c <= 0x39) // 0-9
                || (c >= 0x41 && c <= 0x5A) // a-z
                || (c >= 0x61 && c <= 0x7A) // A-Z
                || (format === formats.RFC1738 && (c === 0x28 || c === 0x29)) // ( )
            ) {
                arr[arr.length] = segment.charAt(i);
                continue;
            }

            if (c < 0x80) {
                arr[arr.length] = hexTable[c];
                continue;
            }

            if (c < 0x800) {
                arr[arr.length] = hexTable[0xC0 | (c >> 6)]
                    + hexTable[0x80 | (c & 0x3F)];
                continue;
            }

            if (c < 0xD800 || c >= 0xE000) {
                arr[arr.length] = hexTable[0xE0 | (c >> 12)]
                    + hexTable[0x80 | ((c >> 6) & 0x3F)]
                    + hexTable[0x80 | (c & 0x3F)];
                continue;
            }

            i += 1;
            c = 0x10000 + (((c & 0x3FF) << 10) | (segment.charCodeAt(i) & 0x3FF));

            arr[arr.length] = hexTable[0xF0 | (c >> 18)]
                + hexTable[0x80 | ((c >> 12) & 0x3F)]
                + hexTable[0x80 | ((c >> 6) & 0x3F)]
                + hexTable[0x80 | (c & 0x3F)];
        }

        out += arr.join('');
    }

    return out;
};

var compact = function compact(value) {
    var queue = [{ obj: { o: value }, prop: 'o' }];
    var refs = [];

    for (var i = 0; i < queue.length; ++i) {
        var item = queue[i];
        var obj = item.obj[item.prop];

        var keys = Object.keys(obj);
        for (var j = 0; j < keys.length; ++j) {
            var key = keys[j];
            var val = obj[key];
            if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
                queue[queue.length] = { obj: obj, prop: key };
                refs[refs.length] = val;
            }
        }
    }

    compactQueue(queue);

    return value;
};

var isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
};

var isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== 'object') {
        return false;
    }

    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};

var combine = function combine(a, b, arrayLimit, plainObjects) {
    // If 'a' is already an overflow object, add to it
    if (isOverflow(a)) {
        var newIndex = getMaxIndex(a) + 1;
        a[newIndex] = b;
        setMaxIndex(a, newIndex);
        return a;
    }

    var result = [].concat(a, b);
    if (result.length > arrayLimit) {
        return markOverflow(arrayToObject(result, { plainObjects: plainObjects }), result.length - 1);
    }
    return result;
};

var maybeMap = function maybeMap(val, fn) {
    if (isArray(val)) {
        var mapped = [];
        for (var i = 0; i < val.length; i += 1) {
            mapped[mapped.length] = fn(val[i]);
        }
        return mapped;
    }
    return fn(val);
};

module.exports = {
    arrayToObject: arrayToObject,
    assign: assign,
    combine: combine,
    compact: compact,
    decode: decode,
    encode: encode,
    isBuffer: isBuffer,
    isOverflow: isOverflow,
    isRegExp: isRegExp,
    markOverflow: markOverflow,
    maybeMap: maybeMap,
    merge: merge
};

},{"./formats":151,"side-channel":163}],156:[function(require,module,exports){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

'use strict';

// If obj.hasOwnProperty has been overridden, then calling
// obj.hasOwnProperty(prop) will break.
// See: https://github.com/joyent/node/issues/1707
function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

module.exports = function(qs, sep, eq, options) {
  sep = sep || '&';
  eq = eq || '=';
  var obj = {};

  if (typeof qs !== 'string' || qs.length === 0) {
    return obj;
  }

  var regexp = /\+/g;
  qs = qs.split(sep);

  var maxKeys = 1000;
  if (options && typeof options.maxKeys === 'number') {
    maxKeys = options.maxKeys;
  }

  var len = qs.length;
  // maxKeys <= 0 means that we should not limit keys count
  if (maxKeys > 0 && len > maxKeys) {
    len = maxKeys;
  }

  for (var i = 0; i < len; ++i) {
    var x = qs[i].replace(regexp, '%20'),
        idx = x.indexOf(eq),
        kstr, vstr, k, v;

    if (idx >= 0) {
      kstr = x.substr(0, idx);
      vstr = x.substr(idx + 1);
    } else {
      kstr = x;
      vstr = '';
    }

    k = decodeURIComponent(kstr);
    v = decodeURIComponent(vstr);

    if (!hasOwnProperty(obj, k)) {
      obj[k] = v;
    } else if (isArray(obj[k])) {
      obj[k].push(v);
    } else {
      obj[k] = [obj[k], v];
    }
  }

  return obj;
};

var isArray = Array.isArray || function (xs) {
  return Object.prototype.toString.call(xs) === '[object Array]';
};

},{}],157:[function(require,module,exports){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

'use strict';

var stringifyPrimitive = function(v) {
  switch (typeof v) {
    case 'string':
      return v;

    case 'boolean':
      return v ? 'true' : 'false';

    case 'number':
      return isFinite(v) ? v : '';

    default:
      return '';
  }
};

module.exports = function(obj, sep, eq, name) {
  sep = sep || '&';
  eq = eq || '=';
  if (obj === null) {
    obj = undefined;
  }

  if (typeof obj === 'object') {
    return map(objectKeys(obj), function(k) {
      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
      if (isArray(obj[k])) {
        return map(obj[k], function(v) {
          return ks + encodeURIComponent(stringifyPrimitive(v));
        }).join(sep);
      } else {
        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
      }
    }).join(sep);

  }

  if (!name) return '';
  return encodeURIComponent(stringifyPrimitive(name)) + eq +
         encodeURIComponent(stringifyPrimitive(obj));
};

var isArray = Array.isArray || function (xs) {
  return Object.prototype.toString.call(xs) === '[object Array]';
};

function map (xs, f) {
  if (xs.map) return xs.map(f);
  var res = [];
  for (var i = 0; i < xs.length; i++) {
    res.push(f(xs[i], i));
  }
  return res;
}

var objectKeys = Object.keys || function (obj) {
  var res = [];
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) res.push(key);
  }
  return res;
};

},{}],158:[function(require,module,exports){
'use strict';

exports.decode = exports.parse = require('./decode');
exports.encode = exports.stringify = require('./encode');

},{"./decode":156,"./encode":157}],159:[function(require,module,exports){
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */
/* eslint-disable node/no-deprecated-api */
var buffer = require('buffer')
var Buffer = buffer.Buffer

// alternative to using Object.keys for old browsers
function copyProps (src, dst) {
  for (var key in src) {
    dst[key] = src[key]
  }
}
if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
  module.exports = buffer
} else {
  // Copy properties from require('buffer')
  copyProps(buffer, exports)
  exports.Buffer = SafeBuffer
}

function SafeBuffer (arg, encodingOrOffset, length) {
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.prototype = Object.create(Buffer.prototype)

// Copy static methods from Buffer
copyProps(Buffer, SafeBuffer)

SafeBuffer.from = function (arg, encodingOrOffset, length) {
  if (typeof arg === 'number') {
    throw new TypeError('Argument must not be a number')
  }
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.alloc = function (size, fill, encoding) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  var buf = Buffer(size)
  if (fill !== undefined) {
    if (typeof encoding === 'string') {
      buf.fill(fill, encoding)
    } else {
      buf.fill(fill)
    }
  } else {
    buf.fill(0)
  }
  return buf
}

SafeBuffer.allocUnsafe = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return Buffer(size)
}

SafeBuffer.allocUnsafeSlow = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return buffer.SlowBuffer(size)
}

},{"buffer":20}],160:[function(require,module,exports){
'use strict';

var inspect = require('object-inspect');

var $TypeError = require('es-errors/type');

/*
* This function traverses the list returning the node corresponding to the given key.
*
* That node is also moved to the head of the list, so that if it's accessed again we don't need to traverse the whole list.
* By doing so, all the recently used nodes can be accessed relatively quickly.
*/
/** @type {import('./list.d.ts').listGetNode} */
// eslint-disable-next-line consistent-return
var listGetNode = function (list, key, isDelete) {
	/** @type {typeof list | NonNullable<(typeof list)['next']>} */
	var prev = list;
	/** @type {(typeof list)['next']} */
	var curr;
	// eslint-disable-next-line eqeqeq
	for (; (curr = prev.next) != null; prev = curr) {
		if (curr.key === key) {
			prev.next = curr.next;
			if (!isDelete) {
				// eslint-disable-next-line no-extra-parens
				curr.next = /** @type {NonNullable<typeof list.next>} */ (list.next);
				list.next = curr; // eslint-disable-line no-param-reassign
			}
			return curr;
		}
	}
};

/** @type {import('./list.d.ts').listGet} */
var listGet = function (objects, key) {
	if (!objects) {
		return void undefined;
	}
	var node = listGetNode(objects, key);
	return node && node.value;
};
/** @type {import('./list.d.ts').listSet} */
var listSet = function (objects, key, value) {
	var node = listGetNode(objects, key);
	if (node) {
		node.value = value;
	} else {
		// Prepend the new node to the beginning of the list
		objects.next = /** @type {import('./list.d.ts').ListNode<typeof value, typeof key>} */ ({ // eslint-disable-line no-param-reassign, no-extra-parens
			key: key,
			next: objects.next,
			value: value
		});
	}
};
/** @type {import('./list.d.ts').listHas} */
var listHas = function (objects, key) {
	if (!objects) {
		return false;
	}
	return !!listGetNode(objects, key);
};
/** @type {import('./list.d.ts').listDelete} */
// eslint-disable-next-line consistent-return
var listDelete = function (objects, key) {
	if (objects) {
		return listGetNode(objects, key, true);
	}
};

/** @type {import('.')} */
module.exports = function getSideChannelList() {
	/** @typedef {ReturnType<typeof getSideChannelList>} Channel */
	/** @typedef {Parameters<Channel['get']>[0]} K */
	/** @typedef {Parameters<Channel['set']>[1]} V */

	/** @type {import('./list.d.ts').RootNode<V, K> | undefined} */ var $o;

	/** @type {Channel} */
	var channel = {
		assert: function (key) {
			if (!channel.has(key)) {
				throw new $TypeError('Side channel does not contain ' + inspect(key));
			}
		},
		'delete': function (key) {
			var deletedNode = listDelete($o, key);
			if (deletedNode && $o && !$o.next) {
				$o = void undefined;
			}
			return !!deletedNode;
		},
		get: function (key) {
			return listGet($o, key);
		},
		has: function (key) {
			return listHas($o, key);
		},
		set: function (key, value) {
			if (!$o) {
				// Initialize the linked list as an empty node, so that we don't have to special-case handling of the first node: we can always refer to it as (previous node).next, instead of something like (list).head
				$o = {
					next: void undefined
				};
			}
			// eslint-disable-next-line no-extra-parens
			listSet(/** @type {NonNullable<typeof $o>} */ ($o), key, value);
		}
	};
	return channel;
};

},{"es-errors/type":47,"object-inspect":136}],161:[function(require,module,exports){
'use strict';

var GetIntrinsic = require('get-intrinsic');
var callBound = require('call-bound');
var inspect = require('object-inspect');

var $TypeError = require('es-errors/type');
var $Map = GetIntrinsic('%Map%', true);

/** @type {<K, V>(thisArg: Map<K, V>, key: K) => V} */
var $mapGet = callBound('Map.prototype.get', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K, value: V) => void} */
var $mapSet = callBound('Map.prototype.set', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => boolean} */
var $mapHas = callBound('Map.prototype.has', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => boolean} */
var $mapDelete = callBound('Map.prototype.delete', true);
/** @type {<K, V>(thisArg: Map<K, V>) => number} */
var $mapSize = callBound('Map.prototype.size', true);

/** @type {import('.')} */
module.exports = !!$Map && /** @type {Exclude<import('.'), false>} */ function getSideChannelMap() {
	/** @typedef {ReturnType<typeof getSideChannelMap>} Channel */
	/** @typedef {Parameters<Channel['get']>[0]} K */
	/** @typedef {Parameters<Channel['set']>[1]} V */

	/** @type {Map<K, V> | undefined} */ var $m;

	/** @type {Channel} */
	var channel = {
		assert: function (key) {
			if (!channel.has(key)) {
				throw new $TypeError('Side channel does not contain ' + inspect(key));
			}
		},
		'delete': function (key) {
			if ($m) {
				var result = $mapDelete($m, key);
				if ($mapSize($m) === 0) {
					$m = void undefined;
				}
				return result;
			}
			return false;
		},
		get: function (key) { // eslint-disable-line consistent-return
			if ($m) {
				return $mapGet($m, key);
			}
		},
		has: function (key) {
			if ($m) {
				return $mapHas($m, key);
			}
			return false;
		},
		set: function (key, value) {
			if (!$m) {
				// @ts-expect-error TS can't handle narrowing a variable inside a closure
				$m = new $Map();
			}
			$mapSet($m, key, value);
		}
	};

	// @ts-expect-error TODO: figure out why TS is erroring here
	return channel;
};

},{"call-bound":30,"es-errors/type":47,"get-intrinsic":104,"object-inspect":136}],162:[function(require,module,exports){
'use strict';

var GetIntrinsic = require('get-intrinsic');
var callBound = require('call-bound');
var inspect = require('object-inspect');
var getSideChannelMap = require('side-channel-map');

var $TypeError = require('es-errors/type');
var $WeakMap = GetIntrinsic('%WeakMap%', true);

/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => V} */
var $weakMapGet = callBound('WeakMap.prototype.get', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K, value: V) => void} */
var $weakMapSet = callBound('WeakMap.prototype.set', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => boolean} */
var $weakMapHas = callBound('WeakMap.prototype.has', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => boolean} */
var $weakMapDelete = callBound('WeakMap.prototype.delete', true);

/** @type {import('.')} */
module.exports = $WeakMap
	? /** @type {Exclude<import('.'), false>} */ function getSideChannelWeakMap() {
		/** @typedef {ReturnType<typeof getSideChannelWeakMap>} Channel */
		/** @typedef {Parameters<Channel['get']>[0]} K */
		/** @typedef {Parameters<Channel['set']>[1]} V */

		/** @type {WeakMap<K & object, V> | undefined} */ var $wm;
		/** @type {Channel | undefined} */ var $m;

		/** @type {Channel} */
		var channel = {
			assert: function (key) {
				if (!channel.has(key)) {
					throw new $TypeError('Side channel does not contain ' + inspect(key));
				}
			},
			'delete': function (key) {
				if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
					if ($wm) {
						return $weakMapDelete($wm, key);
					}
				} else if (getSideChannelMap) {
					if ($m) {
						return $m['delete'](key);
					}
				}
				return false;
			},
			get: function (key) {
				if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
					if ($wm) {
						return $weakMapGet($wm, key);
					}
				}
				return $m && $m.get(key);
			},
			has: function (key) {
				if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
					if ($wm) {
						return $weakMapHas($wm, key);
					}
				}
				return !!$m && $m.has(key);
			},
			set: function (key, value) {
				if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
					if (!$wm) {
						$wm = new $WeakMap();
					}
					$weakMapSet($wm, key, value);
				} else if (getSideChannelMap) {
					if (!$m) {
						$m = getSideChannelMap();
					}
					// eslint-disable-next-line no-extra-parens
					/** @type {NonNullable<typeof $m>} */ ($m).set(key, value);
				}
			}
		};

		// @ts-expect-error TODO: figure out why this is erroring
		return channel;
	}
	: getSideChannelMap;

},{"call-bound":30,"es-errors/type":47,"get-intrinsic":104,"object-inspect":136,"side-channel-map":161}],163:[function(require,module,exports){
'use strict';

var $TypeError = require('es-errors/type');
var inspect = require('object-inspect');
var getSideChannelList = require('side-channel-list');
var getSideChannelMap = require('side-channel-map');
var getSideChannelWeakMap = require('side-channel-weakmap');

var makeChannel = getSideChannelWeakMap || getSideChannelMap || getSideChannelList;

/** @type {import('.')} */
module.exports = function getSideChannel() {
	/** @typedef {ReturnType<typeof getSideChannel>} Channel */

	/** @type {Channel | undefined} */ var $channelData;

	/** @type {Channel} */
	var channel = {
		assert: function (key) {
			if (!channel.has(key)) {
				throw new $TypeError('Side channel does not contain ' + inspect(key));
			}
		},
		'delete': function (key) {
			return !!$channelData && $channelData['delete'](key);
		},
		get: function (key) {
			return $channelData && $channelData.get(key);
		},
		has: function (key) {
			return !!$channelData && $channelData.has(key);
		},
		set: function (key, value) {
			if (!$channelData) {
				$channelData = makeChannel();
			}

			$channelData.set(key, value);
		}
	};
	// @ts-expect-error TODO: figure out why this is erroring
	return channel;
};

},{"es-errors/type":47,"object-inspect":136,"side-channel-list":160,"side-channel-map":161,"side-channel-weakmap":162}],164:[function(require,module,exports){
(function (Buffer){(function (){
/*! simple-concat. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */
module.exports = function (stream, cb) {
  var chunks = []
  stream.on('data', function (chunk) {
    chunks.push(chunk)
  })
  stream.once('end', function () {
    if (cb) cb(null, Buffer.concat(chunks))
    cb = null
  })
  stream.once('error', function (err) {
    if (cb) cb(err)
    cb = null
  })
}

}).call(this)}).call(this,require("buffer").Buffer)

},{"buffer":20}],165:[function(require,module,exports){
(function (Buffer){(function (){
/*! simple-get. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */
module.exports = simpleGet

const concat = require('simple-concat')
const decompressResponse = require('decompress-response') // excluded from browser build
const http = require('http')
const https = require('https')
const once = require('once')
const querystring = require('querystring')
const url = require('url')

const isStream = o => o !== null && typeof o === 'object' && typeof o.pipe === 'function'

function simpleGet (opts, cb) {
  opts = Object.assign({ maxRedirects: 10 }, typeof opts === 'string' ? { url: opts } : opts)
  cb = once(cb)

  if (opts.url) {
    const { hostname, port, protocol, auth, path } = url.parse(opts.url) // eslint-disable-line node/no-deprecated-api
    delete opts.url
    if (!hostname && !port && !protocol && !auth) opts.path = path // Relative redirect
    else Object.assign(opts, { hostname, port, protocol, auth, path }) // Absolute redirect
  }

  const headers = { 'accept-encoding': 'gzip, deflate' }
  if (opts.headers) Object.keys(opts.headers).forEach(k => (headers[k.toLowerCase()] = opts.headers[k]))
  opts.headers = headers

  let body
  if (opts.body) {
    body = opts.json && !isStream(opts.body) ? JSON.stringify(opts.body) : opts.body
  } else if (opts.form) {
    body = typeof opts.form === 'string' ? opts.form : querystring.stringify(opts.form)
    opts.headers['content-type'] = 'application/x-www-form-urlencoded'
  }

  if (body) {
    if (!opts.method) opts.method = 'POST'
    if (!isStream(body)) opts.headers['content-length'] = Buffer.byteLength(body)
    if (opts.json && !opts.form) opts.headers['content-type'] = 'application/json'
  }
  delete opts.body; delete opts.form

  if (opts.json) opts.headers.accept = 'application/json'
  if (opts.method) opts.method = opts.method.toUpperCase()

  const originalHost = opts.hostname // hostname before potential redirect
  const protocol = opts.protocol === 'https:' ? https : http // Support http/https urls
  const req = protocol.request(opts, res => {
    if (opts.followRedirects !== false && res.statusCode >= 300 && res.statusCode < 400 && res.headers.location) {
      opts.url = res.headers.location // Follow 3xx redirects
      delete opts.headers.host // Discard `host` header on redirect (see #32)
      res.resume() // Discard response

      const redirectHost = url.parse(opts.url).hostname // eslint-disable-line node/no-deprecated-api
      // If redirected host is different than original host, drop headers to prevent cookie leak (#73)
      if (redirectHost !== null && redirectHost !== originalHost) {
        delete opts.headers.cookie
        delete opts.headers.authorization
      }

      if (opts.method === 'POST' && [301, 302].includes(res.statusCode)) {
        opts.method = 'GET' // On 301/302 redirect, change POST to GET (see #35)
        delete opts.headers['content-length']; delete opts.headers['content-type']
      }

      if (opts.maxRedirects-- === 0) return cb(new Error('too many redirects'))
      else return simpleGet(opts, cb)
    }

    const tryUnzip = typeof decompressResponse === 'function' && opts.method !== 'HEAD'
    cb(null, tryUnzip ? decompressResponse(res) : res)
  })
  req.on('timeout', () => {
    req.abort()
    cb(new Error('Request timed out'))
  })
  req.on('error', cb)

  if (isStream(body)) body.on('error', cb).pipe(req)
  else req.end(body)

  return req
}

simpleGet.concat = (opts, cb) => {
  return simpleGet(opts, (err, res) => {
    if (err) return cb(err)
    concat(res, (err, data) => {
      if (err) return cb(err)
      if (opts.json) {
        try {
          data = JSON.parse(data.toString())
        } catch (err) {
          return cb(err, res, data)
        }
      }
      cb(null, res, data)
    })
  })
}

;['get', 'post', 'put', 'patch', 'head', 'delete'].forEach(method => {
  simpleGet[method] = (opts, cb) => {
    if (typeof opts === 'string') opts = { url: opts }
    return simpleGet(Object.assign({ method: method.toUpperCase() }, opts), cb)
  }
})

}).call(this)}).call(this,require("buffer").Buffer)

},{"buffer":20,"decompress-response":18,"http":166,"https":113,"once":137,"querystring":158,"simple-concat":164,"url":188}],166:[function(require,module,exports){
(function (global){(function (){
var ClientRequest = require('./lib/request')
var response = require('./lib/response')
var extend = require('xtend')
var statusCodes = require('builtin-status-codes')
var url = require('url')

var http = exports

http.request = function (opts, cb) {
	if (typeof opts === 'string')
		opts = url.parse(opts)
	else
		opts = extend(opts)

	// Normally, the page is loaded from http or https, so not specifying a protocol
	// will result in a (valid) protocol-relative url. However, this won't work if
	// the protocol is something else, like 'file:'
	var defaultProtocol = global.location.protocol.search(/^https?:$/) === -1 ? 'http:' : ''

	var protocol = opts.protocol || defaultProtocol
	var host = opts.hostname || opts.host
	var port = opts.port
	var path = opts.path || '/'

	// Necessary for IPv6 addresses
	if (host && host.indexOf(':') !== -1)
		host = '[' + host + ']'

	// This may be a relative url. The browser should always be able to interpret it correctly.
	opts.url = (host ? (protocol + '//' + host) : '') + (port ? ':' + port : '') + path
	opts.method = (opts.method || 'GET').toUpperCase()
	opts.headers = opts.headers || {}

	// Also valid opts.auth, opts.mode

	var req = new ClientRequest(opts)
	if (cb)
		req.on('response', cb)
	return req
}

http.get = function get (opts, cb) {
	var req = http.request(opts, cb)
	req.end()
	return req
}

http.ClientRequest = ClientRequest
http.IncomingMessage = response.IncomingMessage

http.Agent = function () {}
http.Agent.defaultMaxSockets = 4

http.globalAgent = new http.Agent()

http.STATUS_CODES = statusCodes

http.METHODS = [
	'CHECKOUT',
	'CONNECT',
	'COPY',
	'DELETE',
	'GET',
	'HEAD',
	'LOCK',
	'M-SEARCH',
	'MERGE',
	'MKACTIVITY',
	'MKCOL',
	'MOVE',
	'NOTIFY',
	'OPTIONS',
	'PATCH',
	'POST',
	'PROPFIND',
	'PROPPATCH',
	'PURGE',
	'PUT',
	'REPORT',
	'SEARCH',
	'SUBSCRIBE',
	'TRACE',
	'UNLOCK',
	'UNSUBSCRIBE'
]
}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"./lib/request":168,"./lib/response":169,"builtin-status-codes":21,"url":188,"xtend":191}],167:[function(require,module,exports){
(function (global){(function (){
exports.fetch = isFunction(global.fetch) && isFunction(global.ReadableStream)

exports.writableStream = isFunction(global.WritableStream)

exports.abortController = isFunction(global.AbortController)

// The xhr request to example.com may violate some restrictive CSP configurations,
// so if we're running in a browser that supports `fetch`, avoid calling getXHR()
// and assume support for certain features below.
var xhr
function getXHR () {
	// Cache the xhr value
	if (xhr !== undefined) return xhr

	if (global.XMLHttpRequest) {
		xhr = new global.XMLHttpRequest()
		// If XDomainRequest is available (ie only, where xhr might not work
		// cross domain), use the page location. Otherwise use example.com
		// Note: this doesn't actually make an http request.
		try {
			xhr.open('GET', global.XDomainRequest ? '/' : 'https://example.com')
		} catch(e) {
			xhr = null
		}
	} else {
		// Service workers don't have XHR
		xhr = null
	}
	return xhr
}

function checkTypeSupport (type) {
	var xhr = getXHR()
	if (!xhr) return false
	try {
		xhr.responseType = type
		return xhr.responseType === type
	} catch (e) {}
	return false
}

// If fetch is supported, then arraybuffer will be supported too. Skip calling
// checkTypeSupport(), since that calls getXHR().
exports.arraybuffer = exports.fetch || checkTypeSupport('arraybuffer')

// These next two tests unavoidably show warnings in Chrome. Since fetch will always
// be used if it's available, just return false for these to avoid the warnings.
exports.msstream = !exports.fetch && checkTypeSupport('ms-stream')
exports.mozchunkedarraybuffer = !exports.fetch && checkTypeSupport('moz-chunked-arraybuffer')

// If fetch is supported, then overrideMimeType will be supported too. Skip calling
// getXHR().
exports.overrideMimeType = exports.fetch || (getXHR() ? isFunction(getXHR().overrideMimeType) : false)

function isFunction (value) {
	return typeof value === 'function'
}

xhr = null // Help gc

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{}],168:[function(require,module,exports){
(function (process,global,Buffer){(function (){
var capability = require('./capability')
var inherits = require('inherits')
var response = require('./response')
var stream = require('readable-stream')

var IncomingMessage = response.IncomingMessage
var rStates = response.readyStates

function decideMode (preferBinary, useFetch) {
	if (capability.fetch && useFetch) {
		return 'fetch'
	} else if (capability.mozchunkedarraybuffer) {
		return 'moz-chunked-arraybuffer'
	} else if (capability.msstream) {
		return 'ms-stream'
	} else if (capability.arraybuffer && preferBinary) {
		return 'arraybuffer'
	} else {
		return 'text'
	}
}

var ClientRequest = module.exports = function (opts) {
	var self = this
	stream.Writable.call(self)

	self._opts = opts
	self._body = []
	self._headers = {}
	if (opts.auth)
		self.setHeader('Authorization', 'Basic ' + Buffer.from(opts.auth).toString('base64'))
	Object.keys(opts.headers).forEach(function (name) {
		self.setHeader(name, opts.headers[name])
	})

	var preferBinary
	var useFetch = true
	if (opts.mode === 'disable-fetch' || ('requestTimeout' in opts && !capability.abortController)) {
		// If the use of XHR should be preferred. Not typically needed.
		useFetch = false
		preferBinary = true
	} else if (opts.mode === 'prefer-streaming') {
		// If streaming is a high priority but binary compatibility and
		// the accuracy of the 'content-type' header aren't
		preferBinary = false
	} else if (opts.mode === 'allow-wrong-content-type') {
		// If streaming is more important than preserving the 'content-type' header
		preferBinary = !capability.overrideMimeType
	} else if (!opts.mode || opts.mode === 'default' || opts.mode === 'prefer-fast') {
		// Use binary if text streaming may corrupt data or the content-type header, or for speed
		preferBinary = true
	} else {
		throw new Error('Invalid value for opts.mode')
	}
	self._mode = decideMode(preferBinary, useFetch)
	self._fetchTimer = null
	self._socketTimeout = null
	self._socketTimer = null

	self.on('finish', function () {
		self._onFinish()
	})
}

inherits(ClientRequest, stream.Writable)

ClientRequest.prototype.setHeader = function (name, value) {
	var self = this
	var lowerName = name.toLowerCase()
	// This check is not necessary, but it prevents warnings from browsers about setting unsafe
	// headers. To be honest I'm not entirely sure hiding these warnings is a good thing, but
	// http-browserify did it, so I will too.
	if (unsafeHeaders.indexOf(lowerName) !== -1)
		return

	self._headers[lowerName] = {
		name: name,
		value: value
	}
}

ClientRequest.prototype.getHeader = function (name) {
	var header = this._headers[name.toLowerCase()]
	if (header)
		return header.value
	return null
}

ClientRequest.prototype.removeHeader = function (name) {
	var self = this
	delete self._headers[name.toLowerCase()]
}

ClientRequest.prototype._onFinish = function () {
	var self = this

	if (self._destroyed)
		return
	var opts = self._opts

	if ('timeout' in opts && opts.timeout !== 0) {
		self.setTimeout(opts.timeout)
	}

	var headersObj = self._headers
	var body = null
	if (opts.method !== 'GET' && opts.method !== 'HEAD') {
        body = new Blob(self._body, {
            type: (headersObj['content-type'] || {}).value || ''
        });
    }

	// create flattened list of headers
	var headersList = []
	Object.keys(headersObj).forEach(function (keyName) {
		var name = headersObj[keyName].name
		var value = headersObj[keyName].value
		if (Array.isArray(value)) {
			value.forEach(function (v) {
				headersList.push([name, v])
			})
		} else {
			headersList.push([name, value])
		}
	})

	if (self._mode === 'fetch') {
		var signal = null
		if (capability.abortController) {
			var controller = new AbortController()
			signal = controller.signal
			self._fetchAbortController = controller

			if ('requestTimeout' in opts && opts.requestTimeout !== 0) {
				self._fetchTimer = global.setTimeout(function () {
					self.emit('requestTimeout')
					if (self._fetchAbortController)
						self._fetchAbortController.abort()
				}, opts.requestTimeout)
			}
		}

		global.fetch(self._opts.url, {
			method: self._opts.method,
			headers: headersList,
			body: body || undefined,
			mode: 'cors',
			credentials: opts.withCredentials ? 'include' : 'same-origin',
			signal: signal
		}).then(function (response) {
			self._fetchResponse = response
			self._resetTimers(false)
			self._connect()
		}, function (reason) {
			self._resetTimers(true)
			if (!self._destroyed)
				self.emit('error', reason)
		})
	} else {
		var xhr = self._xhr = new global.XMLHttpRequest()
		try {
			xhr.open(self._opts.method, self._opts.url, true)
		} catch (err) {
			process.nextTick(function () {
				self.emit('error', err)
			})
			return
		}

		// Can't set responseType on really old browsers
		if ('responseType' in xhr)
			xhr.responseType = self._mode

		if ('withCredentials' in xhr)
			xhr.withCredentials = !!opts.withCredentials

		if (self._mode === 'text' && 'overrideMimeType' in xhr)
			xhr.overrideMimeType('text/plain; charset=x-user-defined')

		if ('requestTimeout' in opts) {
			xhr.timeout = opts.requestTimeout
			xhr.ontimeout = function () {
				self.emit('requestTimeout')
			}
		}

		headersList.forEach(function (header) {
			xhr.setRequestHeader(header[0], header[1])
		})

		self._response = null
		xhr.onreadystatechange = function () {
			switch (xhr.readyState) {
				case rStates.LOADING:
				case rStates.DONE:
					self._onXHRProgress()
					break
			}
		}
		// Necessary for streaming in Firefox, since xhr.response is ONLY defined
		// in onprogress, not in onreadystatechange with xhr.readyState = 3
		if (self._mode === 'moz-chunked-arraybuffer') {
			xhr.onprogress = function () {
				self._onXHRProgress()
			}
		}

		xhr.onerror = function () {
			if (self._destroyed)
				return
			self._resetTimers(true)
			self.emit('error', new Error('XHR error'))
		}

		try {
			xhr.send(body)
		} catch (err) {
			process.nextTick(function () {
				self.emit('error', err)
			})
			return
		}
	}
}

/**
 * Checks if xhr.status is readable and non-zero, indicating no error.
 * Even though the spec says it should be available in readyState 3,
 * accessing it throws an exception in IE8
 */
function statusValid (xhr) {
	try {
		var status = xhr.status
		return (status !== null && status !== 0)
	} catch (e) {
		return false
	}
}

ClientRequest.prototype._onXHRProgress = function () {
	var self = this

	self._resetTimers(false)

	if (!statusValid(self._xhr) || self._destroyed)
		return

	if (!self._response)
		self._connect()

	self._response._onXHRProgress(self._resetTimers.bind(self))
}

ClientRequest.prototype._connect = function () {
	var self = this

	if (self._destroyed)
		return

	self._response = new IncomingMessage(self._xhr, self._fetchResponse, self._mode, self._resetTimers.bind(self))
	self._response.on('error', function(err) {
		self.emit('error', err)
	})

	self.emit('response', self._response)
}

ClientRequest.prototype._write = function (chunk, encoding, cb) {
	var self = this

	self._body.push(chunk)
	cb()
}

ClientRequest.prototype._resetTimers = function (done) {
	var self = this

	global.clearTimeout(self._socketTimer)
	self._socketTimer = null

	if (done) {
		global.clearTimeout(self._fetchTimer)
		self._fetchTimer = null
	} else if (self._socketTimeout) {
		self._socketTimer = global.setTimeout(function () {
			self.emit('timeout')
		}, self._socketTimeout)
	}
}

ClientRequest.prototype.abort = ClientRequest.prototype.destroy = function (err) {
	var self = this
	self._destroyed = true
	self._resetTimers(true)
	if (self._response)
		self._response._destroyed = true
	if (self._xhr)
		self._xhr.abort()
	else if (self._fetchAbortController)
		self._fetchAbortController.abort()

	if (err)
		self.emit('error', err)
}

ClientRequest.prototype.end = function (data, encoding, cb) {
	var self = this
	if (typeof data === 'function') {
		cb = data
		data = undefined
	}

	stream.Writable.prototype.end.call(self, data, encoding, cb)
}

ClientRequest.prototype.setTimeout = function (timeout, cb) {
	var self = this

	if (cb)
		self.once('timeout', cb)

	self._socketTimeout = timeout
	self._resetTimers(false)
}

ClientRequest.prototype.flushHeaders = function () {}
ClientRequest.prototype.setNoDelay = function () {}
ClientRequest.prototype.setSocketKeepAlive = function () {}

// Taken from http://www.w3.org/TR/XMLHttpRequest/#the-setrequestheader%28%29-method
var unsafeHeaders = [
	'accept-charset',
	'accept-encoding',
	'access-control-request-headers',
	'access-control-request-method',
	'connection',
	'content-length',
	'cookie',
	'cookie2',
	'date',
	'dnt',
	'expect',
	'host',
	'keep-alive',
	'origin',
	'referer',
	'te',
	'trailer',
	'transfer-encoding',
	'upgrade',
	'via'
]

}).call(this)}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer)

},{"./capability":167,"./response":169,"_process":150,"buffer":20,"inherits":115,"readable-stream":184}],169:[function(require,module,exports){
(function (process,global,Buffer){(function (){
var capability = require('./capability')
var inherits = require('inherits')
var stream = require('readable-stream')

var rStates = exports.readyStates = {
	UNSENT: 0,
	OPENED: 1,
	HEADERS_RECEIVED: 2,
	LOADING: 3,
	DONE: 4
}

var IncomingMessage = exports.IncomingMessage = function (xhr, response, mode, resetTimers) {
	var self = this
	stream.Readable.call(self)

	self._mode = mode
	self.headers = {}
	self.rawHeaders = []
	self.trailers = {}
	self.rawTrailers = []

	// Fake the 'close' event, but only once 'end' fires
	self.on('end', function () {
		// The nextTick is necessary to prevent the 'request' module from causing an infinite loop
		process.nextTick(function () {
			self.emit('close')
		})
	})

	if (mode === 'fetch') {
		self._fetchResponse = response

		self.url = response.url
		self.statusCode = response.status
		self.statusMessage = response.statusText
		
		response.headers.forEach(function (header, key){
			self.headers[key.toLowerCase()] = header
			self.rawHeaders.push(key, header)
		})

		if (capability.writableStream) {
			var writable = new WritableStream({
				write: function (chunk) {
					resetTimers(false)
					return new Promise(function (resolve, reject) {
						if (self._destroyed) {
							reject()
						} else if(self.push(Buffer.from(chunk))) {
							resolve()
						} else {
							self._resumeFetch = resolve
						}
					})
				},
				close: function () {
					resetTimers(true)
					if (!self._destroyed)
						self.push(null)
				},
				abort: function (err) {
					resetTimers(true)
					if (!self._destroyed)
						self.emit('error', err)
				}
			})

			try {
				response.body.pipeTo(writable).catch(function (err) {
					resetTimers(true)
					if (!self._destroyed)
						self.emit('error', err)
				})
				return
			} catch (e) {} // pipeTo method isn't defined. Can't find a better way to feature test this
		}
		// fallback for when writableStream or pipeTo aren't available
		var reader = response.body.getReader()
		function read () {
			reader.read().then(function (result) {
				if (self._destroyed)
					return
				resetTimers(result.done)
				if (result.done) {
					self.push(null)
					return
				}
				self.push(Buffer.from(result.value))
				read()
			}).catch(function (err) {
				resetTimers(true)
				if (!self._destroyed)
					self.emit('error', err)
			})
		}
		read()
	} else {
		self._xhr = xhr
		self._pos = 0

		self.url = xhr.responseURL
		self.statusCode = xhr.status
		self.statusMessage = xhr.statusText
		var headers = xhr.getAllResponseHeaders().split(/\r?\n/)
		headers.forEach(function (header) {
			var matches = header.match(/^([^:]+):\s*(.*)/)
			if (matches) {
				var key = matches[1].toLowerCase()
				if (key === 'set-cookie') {
					if (self.headers[key] === undefined) {
						self.headers[key] = []
					}
					self.headers[key].push(matches[2])
				} else if (self.headers[key] !== undefined) {
					self.headers[key] += ', ' + matches[2]
				} else {
					self.headers[key] = matches[2]
				}
				self.rawHeaders.push(matches[1], matches[2])
			}
		})

		self._charset = 'x-user-defined'
		if (!capability.overrideMimeType) {
			var mimeType = self.rawHeaders['mime-type']
			if (mimeType) {
				var charsetMatch = mimeType.match(/;\s*charset=([^;])(;|$)/)
				if (charsetMatch) {
					self._charset = charsetMatch[1].toLowerCase()
				}
			}
			if (!self._charset)
				self._charset = 'utf-8' // best guess
		}
	}
}

inherits(IncomingMessage, stream.Readable)

IncomingMessage.prototype._read = function () {
	var self = this

	var resolve = self._resumeFetch
	if (resolve) {
		self._resumeFetch = null
		resolve()
	}
}

IncomingMessage.prototype._onXHRProgress = function (resetTimers) {
	var self = this

	var xhr = self._xhr

	var response = null
	switch (self._mode) {
		case 'text':
			response = xhr.responseText
			if (response.length > self._pos) {
				var newData = response.substr(self._pos)
				if (self._charset === 'x-user-defined') {
					var buffer = Buffer.alloc(newData.length)
					for (var i = 0; i < newData.length; i++)
						buffer[i] = newData.charCodeAt(i) & 0xff

					self.push(buffer)
				} else {
					self.push(newData, self._charset)
				}
				self._pos = response.length
			}
			break
		case 'arraybuffer':
			if (xhr.readyState !== rStates.DONE || !xhr.response)
				break
			response = xhr.response
			self.push(Buffer.from(new Uint8Array(response)))
			break
		case 'moz-chunked-arraybuffer': // take whole
			response = xhr.response
			if (xhr.readyState !== rStates.LOADING || !response)
				break
			self.push(Buffer.from(new Uint8Array(response)))
			break
		case 'ms-stream':
			response = xhr.response
			if (xhr.readyState !== rStates.LOADING)
				break
			var reader = new global.MSStreamReader()
			reader.onprogress = function () {
				if (reader.result.byteLength > self._pos) {
					self.push(Buffer.from(new Uint8Array(reader.result.slice(self._pos))))
					self._pos = reader.result.byteLength
				}
			}
			reader.onload = function () {
				resetTimers(true)
				self.push(null)
			}
			// reader.onerror = ??? // TODO: this
			reader.readAsArrayBuffer(response)
			break
	}

	// The ms-stream case handles end separately in reader.onload()
	if (self._xhr.readyState === rStates.DONE && self._mode !== 'ms-stream') {
		resetTimers(true)
		self.push(null)
	}
}

}).call(this)}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer)

},{"./capability":167,"_process":150,"buffer":20,"inherits":115,"readable-stream":184}],170:[function(require,module,exports){
'use strict';

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var codes = {};

function createErrorType(code, message, Base) {
  if (!Base) {
    Base = Error;
  }

  function getMessage(arg1, arg2, arg3) {
    if (typeof message === 'string') {
      return message;
    } else {
      return message(arg1, arg2, arg3);
    }
  }

  var NodeError =
  /*#__PURE__*/
  function (_Base) {
    _inheritsLoose(NodeError, _Base);

    function NodeError(arg1, arg2, arg3) {
      return _Base.call(this, getMessage(arg1, arg2, arg3)) || this;
    }

    return NodeError;
  }(Base);

  NodeError.prototype.name = Base.name;
  NodeError.prototype.code = code;
  codes[code] = NodeError;
} // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js


function oneOf(expected, thing) {
  if (Array.isArray(expected)) {
    var len = expected.length;
    expected = expected.map(function (i) {
      return String(i);
    });

    if (len > 2) {
      return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(', '), ", or ") + expected[len - 1];
    } else if (len === 2) {
      return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
    } else {
      return "of ".concat(thing, " ").concat(expected[0]);
    }
  } else {
    return "of ".concat(thing, " ").concat(String(expected));
  }
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith


function startsWith(str, search, pos) {
  return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith


function endsWith(str, search, this_len) {
  if (this_len === undefined || this_len > str.length) {
    this_len = str.length;
  }

  return str.substring(this_len - search.length, this_len) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes


function includes(str, search, start) {
  if (typeof start !== 'number') {
    start = 0;
  }

  if (start + search.length > str.length) {
    return false;
  } else {
    return str.indexOf(search, start) !== -1;
  }
}

createErrorType('ERR_INVALID_OPT_VALUE', function (name, value) {
  return 'The value "' + value + '" is invalid for option "' + name + '"';
}, TypeError);
createErrorType('ERR_INVALID_ARG_TYPE', function (name, expected, actual) {
  // determiner: 'must be' or 'must not be'
  var determiner;

  if (typeof expected === 'string' && startsWith(expected, 'not ')) {
    determiner = 'must not be';
    expected = expected.replace(/^not /, '');
  } else {
    determiner = 'must be';
  }

  var msg;

  if (endsWith(name, ' argument')) {
    // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat(oneOf(expected, 'type'));
  } else {
    var type = includes(name, '.') ? 'property' : 'argument';
    msg = "The \"".concat(name, "\" ").concat(type, " ").concat(determiner, " ").concat(oneOf(expected, 'type'));
  }

  msg += ". Received type ".concat(typeof actual);
  return msg;
}, TypeError);
createErrorType('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF');
createErrorType('ERR_METHOD_NOT_IMPLEMENTED', function (name) {
  return 'The ' + name + ' method is not implemented';
});
createErrorType('ERR_STREAM_PREMATURE_CLOSE', 'Premature close');
createErrorType('ERR_STREAM_DESTROYED', function (name) {
  return 'Cannot call ' + name + ' after a stream was destroyed';
});
createErrorType('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times');
createErrorType('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable');
createErrorType('ERR_STREAM_WRITE_AFTER_END', 'write after end');
createErrorType('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
createErrorType('ERR_UNKNOWN_ENCODING', function (arg) {
  return 'Unknown encoding: ' + arg;
}, TypeError);
createErrorType('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event');
module.exports.codes = codes;

},{}],171:[function(require,module,exports){
(function (process){(function (){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.

'use strict';

/*<replacement>*/
var objectKeys = Object.keys || function (obj) {
  var keys = [];
  for (var key in obj) keys.push(key);
  return keys;
};
/*</replacement>*/

module.exports = Duplex;
var Readable = require('./_stream_readable');
var Writable = require('./_stream_writable');
require('inherits')(Duplex, Readable);
{
  // Allow the keys array to be GC'ed.
  var keys = objectKeys(Writable.prototype);
  for (var v = 0; v < keys.length; v++) {
    var method = keys[v];
    if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
  }
}
function Duplex(options) {
  if (!(this instanceof Duplex)) return new Duplex(options);
  Readable.call(this, options);
  Writable.call(this, options);
  this.allowHalfOpen = true;
  if (options) {
    if (options.readable === false) this.readable = false;
    if (options.writable === false) this.writable = false;
    if (options.allowHalfOpen === false) {
      this.allowHalfOpen = false;
      this.once('end', onend);
    }
  }
}
Object.defineProperty(Duplex.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState.highWaterMark;
  }
});
Object.defineProperty(Duplex.prototype, 'writableBuffer', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState && this._writableState.getBuffer();
  }
});
Object.defineProperty(Duplex.prototype, 'writableLength', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState.length;
  }
});

// the no-half-open enforcer
function onend() {
  // If the writable side ended, then we're ok.
  if (this._writableState.ended) return;

  // no more data can be written.
  // But allow more writes to happen in this tick.
  process.nextTick(onEndNT, this);
}
function onEndNT(self) {
  self.end();
}
Object.defineProperty(Duplex.prototype, 'destroyed', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    if (this._readableState === undefined || this._writableState === undefined) {
      return false;
    }
    return this._readableState.destroyed && this._writableState.destroyed;
  },
  set: function set(value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (this._readableState === undefined || this._writableState === undefined) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
    this._writableState.destroyed = value;
  }
});
}).call(this)}).call(this,require('_process'))

},{"./_stream_readable":173,"./_stream_writable":175,"_process":150,"inherits":115}],172:[function(require,module,exports){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.

'use strict';

module.exports = PassThrough;
var Transform = require('./_stream_transform');
require('inherits')(PassThrough, Transform);
function PassThrough(options) {
  if (!(this instanceof PassThrough)) return new PassThrough(options);
  Transform.call(this, options);
}
PassThrough.prototype._transform = function (chunk, encoding, cb) {
  cb(null, chunk);
};
},{"./_stream_transform":174,"inherits":115}],173:[function(require,module,exports){
(function (process,global){(function (){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

'use strict';

module.exports = Readable;

/*<replacement>*/
var Duplex;
/*</replacement>*/

Readable.ReadableState = ReadableState;

/*<replacement>*/
var EE = require('events').EventEmitter;
var EElistenerCount = function EElistenerCount(emitter, type) {
  return emitter.listeners(type).length;
};
/*</replacement>*/

/*<replacement>*/
var Stream = require('./internal/streams/stream');
/*</replacement>*/

var Buffer = require('buffer').Buffer;
var OurUint8Array = (typeof global !== 'undefined' ? global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}

/*<replacement>*/
var debugUtil = require('util');
var debug;
if (debugUtil && debugUtil.debuglog) {
  debug = debugUtil.debuglog('stream');
} else {
  debug = function debug() {};
}
/*</replacement>*/

var BufferList = require('./internal/streams/buffer_list');
var destroyImpl = require('./internal/streams/destroy');
var _require = require('./internal/streams/state'),
  getHighWaterMark = _require.getHighWaterMark;
var _require$codes = require('../errors').codes,
  ERR_INVALID_ARG_TYPE = _require$codes.ERR_INVALID_ARG_TYPE,
  ERR_STREAM_PUSH_AFTER_EOF = _require$codes.ERR_STREAM_PUSH_AFTER_EOF,
  ERR_METHOD_NOT_IMPLEMENTED = _require$codes.ERR_METHOD_NOT_IMPLEMENTED,
  ERR_STREAM_UNSHIFT_AFTER_END_EVENT = _require$codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;

// Lazy loaded to improve the startup performance.
var StringDecoder;
var createReadableStreamAsyncIterator;
var from;
require('inherits')(Readable, Stream);
var errorOrDestroy = destroyImpl.errorOrDestroy;
var kProxyEvents = ['error', 'close', 'destroy', 'pause', 'resume'];
function prependListener(emitter, event, fn) {
  // Sadly this is not cacheable as some libraries bundle their own
  // event emitter implementation with them.
  if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);

  // This is a hack to make sure that our error handler is attached before any
  // userland ones.  NEVER DO THIS. This is here only because this code needs
  // to continue to work with older versions of Node.js that do not include
  // the prependListener() method. The goal is to eventually remove this hack.
  if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn);else emitter._events[event] = [fn, emitter._events[event]];
}
function ReadableState(options, stream, isDuplex) {
  Duplex = Duplex || require('./_stream_duplex');
  options = options || {};

  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream.
  // These options can be provided separately as readableXXX and writableXXX.
  if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof Duplex;

  // object stream flag. Used to make read(n) ignore n and to
  // make all the buffer merging and length checks go away
  this.objectMode = !!options.objectMode;
  if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;

  // the point at which it stops calling _read() to fill the buffer
  // Note: 0 is a valid value, means "don't call _read preemptively ever"
  this.highWaterMark = getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex);

  // A linked list is used to store data chunks instead of an array because the
  // linked list can remove elements from the beginning faster than
  // array.shift()
  this.buffer = new BufferList();
  this.length = 0;
  this.pipes = null;
  this.pipesCount = 0;
  this.flowing = null;
  this.ended = false;
  this.endEmitted = false;
  this.reading = false;

  // a flag to be able to tell if the event 'readable'/'data' is emitted
  // immediately, or on a later tick.  We set this to true at first, because
  // any actions that shouldn't happen until "later" should generally also
  // not happen before the first read call.
  this.sync = true;

  // whenever we return null, then we set a flag to say
  // that we're awaiting a 'readable' event emission.
  this.needReadable = false;
  this.emittedReadable = false;
  this.readableListening = false;
  this.resumeScheduled = false;
  this.paused = true;

  // Should close be emitted on destroy. Defaults to true.
  this.emitClose = options.emitClose !== false;

  // Should .destroy() be called after 'end' (and potentially 'finish')
  this.autoDestroy = !!options.autoDestroy;

  // has it been destroyed
  this.destroyed = false;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // the number of writers that are awaiting a drain event in .pipe()s
  this.awaitDrain = 0;

  // if true, a maybeReadMore has been scheduled
  this.readingMore = false;
  this.decoder = null;
  this.encoding = null;
  if (options.encoding) {
    if (!StringDecoder) StringDecoder = require('string_decoder/').StringDecoder;
    this.decoder = new StringDecoder(options.encoding);
    this.encoding = options.encoding;
  }
}
function Readable(options) {
  Duplex = Duplex || require('./_stream_duplex');
  if (!(this instanceof Readable)) return new Readable(options);

  // Checking for a Stream.Duplex instance is faster here instead of inside
  // the ReadableState constructor, at least with V8 6.5
  var isDuplex = this instanceof Duplex;
  this._readableState = new ReadableState(options, this, isDuplex);

  // legacy
  this.readable = true;
  if (options) {
    if (typeof options.read === 'function') this._read = options.read;
    if (typeof options.destroy === 'function') this._destroy = options.destroy;
  }
  Stream.call(this);
}
Object.defineProperty(Readable.prototype, 'destroyed', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    if (this._readableState === undefined) {
      return false;
    }
    return this._readableState.destroyed;
  },
  set: function set(value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._readableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
  }
});
Readable.prototype.destroy = destroyImpl.destroy;
Readable.prototype._undestroy = destroyImpl.undestroy;
Readable.prototype._destroy = function (err, cb) {
  cb(err);
};

// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
Readable.prototype.push = function (chunk, encoding) {
  var state = this._readableState;
  var skipChunkCheck;
  if (!state.objectMode) {
    if (typeof chunk === 'string') {
      encoding = encoding || state.defaultEncoding;
      if (encoding !== state.encoding) {
        chunk = Buffer.from(chunk, encoding);
        encoding = '';
      }
      skipChunkCheck = true;
    }
  } else {
    skipChunkCheck = true;
  }
  return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};

// Unshift should *always* be something directly out of read()
Readable.prototype.unshift = function (chunk) {
  return readableAddChunk(this, chunk, null, true, false);
};
function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
  debug('readableAddChunk', chunk);
  var state = stream._readableState;
  if (chunk === null) {
    state.reading = false;
    onEofChunk(stream, state);
  } else {
    var er;
    if (!skipChunkCheck) er = chunkInvalid(state, chunk);
    if (er) {
      errorOrDestroy(stream, er);
    } else if (state.objectMode || chunk && chunk.length > 0) {
      if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer.prototype) {
        chunk = _uint8ArrayToBuffer(chunk);
      }
      if (addToFront) {
        if (state.endEmitted) errorOrDestroy(stream, new ERR_STREAM_UNSHIFT_AFTER_END_EVENT());else addChunk(stream, state, chunk, true);
      } else if (state.ended) {
        errorOrDestroy(stream, new ERR_STREAM_PUSH_AFTER_EOF());
      } else if (state.destroyed) {
        return false;
      } else {
        state.reading = false;
        if (state.decoder && !encoding) {
          chunk = state.decoder.write(chunk);
          if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);else maybeReadMore(stream, state);
        } else {
          addChunk(stream, state, chunk, false);
        }
      }
    } else if (!addToFront) {
      state.reading = false;
      maybeReadMore(stream, state);
    }
  }

  // We can push more data if we are below the highWaterMark.
  // Also, if we have no data yet, we can stand some more bytes.
  // This is to work around cases where hwm=0, such as the repl.
  return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function addChunk(stream, state, chunk, addToFront) {
  if (state.flowing && state.length === 0 && !state.sync) {
    state.awaitDrain = 0;
    stream.emit('data', chunk);
  } else {
    // update the buffer info.
    state.length += state.objectMode ? 1 : chunk.length;
    if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);
    if (state.needReadable) emitReadable(stream);
  }
  maybeReadMore(stream, state);
}
function chunkInvalid(state, chunk) {
  var er;
  if (!_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
    er = new ERR_INVALID_ARG_TYPE('chunk', ['string', 'Buffer', 'Uint8Array'], chunk);
  }
  return er;
}
Readable.prototype.isPaused = function () {
  return this._readableState.flowing === false;
};

// backwards compatibility.
Readable.prototype.setEncoding = function (enc) {
  if (!StringDecoder) StringDecoder = require('string_decoder/').StringDecoder;
  var decoder = new StringDecoder(enc);
  this._readableState.decoder = decoder;
  // If setEncoding(null), decoder.encoding equals utf8
  this._readableState.encoding = this._readableState.decoder.encoding;

  // Iterate over current buffer to convert already stored Buffers:
  var p = this._readableState.buffer.head;
  var content = '';
  while (p !== null) {
    content += decoder.write(p.data);
    p = p.next;
  }
  this._readableState.buffer.clear();
  if (content !== '') this._readableState.buffer.push(content);
  this._readableState.length = content.length;
  return this;
};

// Don't raise the hwm > 1GB
var MAX_HWM = 0x40000000;
function computeNewHighWaterMark(n) {
  if (n >= MAX_HWM) {
    // TODO(ronag): Throw ERR_VALUE_OUT_OF_RANGE.
    n = MAX_HWM;
  } else {
    // Get the next highest power of 2 to prevent increasing hwm excessively in
    // tiny amounts
    n--;
    n |= n >>> 1;
    n |= n >>> 2;
    n |= n >>> 4;
    n |= n >>> 8;
    n |= n >>> 16;
    n++;
  }
  return n;
}

// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function howMuchToRead(n, state) {
  if (n <= 0 || state.length === 0 && state.ended) return 0;
  if (state.objectMode) return 1;
  if (n !== n) {
    // Only flow one buffer at a time
    if (state.flowing && state.length) return state.buffer.head.data.length;else return state.length;
  }
  // If we're asking for more than the current hwm, then raise the hwm.
  if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
  if (n <= state.length) return n;
  // Don't have enough
  if (!state.ended) {
    state.needReadable = true;
    return 0;
  }
  return state.length;
}

// you can override either this method, or the async _read(n) below.
Readable.prototype.read = function (n) {
  debug('read', n);
  n = parseInt(n, 10);
  var state = this._readableState;
  var nOrig = n;
  if (n !== 0) state.emittedReadable = false;

  // if we're doing read(0) to trigger a readable event, but we
  // already have a bunch of data in the buffer, then just trigger
  // the 'readable' event and move on.
  if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
    debug('read: emitReadable', state.length, state.ended);
    if (state.length === 0 && state.ended) endReadable(this);else emitReadable(this);
    return null;
  }
  n = howMuchToRead(n, state);

  // if we've ended, and we're now clear, then finish it up.
  if (n === 0 && state.ended) {
    if (state.length === 0) endReadable(this);
    return null;
  }

  // All the actual chunk generation logic needs to be
  // *below* the call to _read.  The reason is that in certain
  // synthetic stream cases, such as passthrough streams, _read
  // may be a completely synchronous operation which may change
  // the state of the read buffer, providing enough data when
  // before there was *not* enough.
  //
  // So, the steps are:
  // 1. Figure out what the state of things will be after we do
  // a read from the buffer.
  //
  // 2. If that resulting state will trigger a _read, then call _read.
  // Note that this may be asynchronous, or synchronous.  Yes, it is
  // deeply ugly to write APIs this way, but that still doesn't mean
  // that the Readable class should behave improperly, as streams are
  // designed to be sync/async agnostic.
  // Take note if the _read call is sync or async (ie, if the read call
  // has returned yet), so that we know whether or not it's safe to emit
  // 'readable' etc.
  //
  // 3. Actually pull the requested chunks out of the buffer and return.

  // if we need a readable event, then we need to do some reading.
  var doRead = state.needReadable;
  debug('need readable', doRead);

  // if we currently have less than the highWaterMark, then also read some
  if (state.length === 0 || state.length - n < state.highWaterMark) {
    doRead = true;
    debug('length less than watermark', doRead);
  }

  // however, if we've ended, then there's no point, and if we're already
  // reading, then it's unnecessary.
  if (state.ended || state.reading) {
    doRead = false;
    debug('reading or ended', doRead);
  } else if (doRead) {
    debug('do read');
    state.reading = true;
    state.sync = true;
    // if the length is currently zero, then we *need* a readable event.
    if (state.length === 0) state.needReadable = true;
    // call internal read method
    this._read(state.highWaterMark);
    state.sync = false;
    // If _read pushed data synchronously, then `reading` will be false,
    // and we need to re-evaluate how much data we can return to the user.
    if (!state.reading) n = howMuchToRead(nOrig, state);
  }
  var ret;
  if (n > 0) ret = fromList(n, state);else ret = null;
  if (ret === null) {
    state.needReadable = state.length <= state.highWaterMark;
    n = 0;
  } else {
    state.length -= n;
    state.awaitDrain = 0;
  }
  if (state.length === 0) {
    // If we have nothing in the buffer, then we want to know
    // as soon as we *do* get something into the buffer.
    if (!state.ended) state.needReadable = true;

    // If we tried to read() past the EOF, then emit end on the next tick.
    if (nOrig !== n && state.ended) endReadable(this);
  }
  if (ret !== null) this.emit('data', ret);
  return ret;
};
function onEofChunk(stream, state) {
  debug('onEofChunk');
  if (state.ended) return;
  if (state.decoder) {
    var chunk = state.decoder.end();
    if (chunk && chunk.length) {
      state.buffer.push(chunk);
      state.length += state.objectMode ? 1 : chunk.length;
    }
  }
  state.ended = true;
  if (state.sync) {
    // if we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call
    emitReadable(stream);
  } else {
    // emit 'readable' now to make sure it gets picked up.
    state.needReadable = false;
    if (!state.emittedReadable) {
      state.emittedReadable = true;
      emitReadable_(stream);
    }
  }
}

// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function emitReadable(stream) {
  var state = stream._readableState;
  debug('emitReadable', state.needReadable, state.emittedReadable);
  state.needReadable = false;
  if (!state.emittedReadable) {
    debug('emitReadable', state.flowing);
    state.emittedReadable = true;
    process.nextTick(emitReadable_, stream);
  }
}
function emitReadable_(stream) {
  var state = stream._readableState;
  debug('emitReadable_', state.destroyed, state.length, state.ended);
  if (!state.destroyed && (state.length || state.ended)) {
    stream.emit('readable');
    state.emittedReadable = false;
  }

  // The stream needs another readable event if
  // 1. It is not flowing, as the flow mechanism will take
  //    care of it.
  // 2. It is not ended.
  // 3. It is below the highWaterMark, so we can schedule
  //    another readable later.
  state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
  flow(stream);
}

// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function maybeReadMore(stream, state) {
  if (!state.readingMore) {
    state.readingMore = true;
    process.nextTick(maybeReadMore_, stream, state);
  }
}
function maybeReadMore_(stream, state) {
  // Attempt to read more data if we should.
  //
  // The conditions for reading more data are (one of):
  // - Not enough data buffered (state.length < state.highWaterMark). The loop
  //   is responsible for filling the buffer with enough data if such data
  //   is available. If highWaterMark is 0 and we are not in the flowing mode
  //   we should _not_ attempt to buffer any extra data. We'll get more data
  //   when the stream consumer calls read() instead.
  // - No data in the buffer, and the stream is in flowing mode. In this mode
  //   the loop below is responsible for ensuring read() is called. Failing to
  //   call read here would abort the flow and there's no other mechanism for
  //   continuing the flow if the stream consumer has just subscribed to the
  //   'data' event.
  //
  // In addition to the above conditions to keep reading data, the following
  // conditions prevent the data from being read:
  // - The stream has ended (state.ended).
  // - There is already a pending 'read' operation (state.reading). This is a
  //   case where the the stream has called the implementation defined _read()
  //   method, but they are processing the call asynchronously and have _not_
  //   called push() with new data. In this case we skip performing more
  //   read()s. The execution ends in this method again after the _read() ends
  //   up calling push() with more data.
  while (!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)) {
    var len = state.length;
    debug('maybeReadMore read 0');
    stream.read(0);
    if (len === state.length)
      // didn't get any data, stop spinning.
      break;
  }
  state.readingMore = false;
}

// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
Readable.prototype._read = function (n) {
  errorOrDestroy(this, new ERR_METHOD_NOT_IMPLEMENTED('_read()'));
};
Readable.prototype.pipe = function (dest, pipeOpts) {
  var src = this;
  var state = this._readableState;
  switch (state.pipesCount) {
    case 0:
      state.pipes = dest;
      break;
    case 1:
      state.pipes = [state.pipes, dest];
      break;
    default:
      state.pipes.push(dest);
      break;
  }
  state.pipesCount += 1;
  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
  var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;
  var endFn = doEnd ? onend : unpipe;
  if (state.endEmitted) process.nextTick(endFn);else src.once('end', endFn);
  dest.on('unpipe', onunpipe);
  function onunpipe(readable, unpipeInfo) {
    debug('onunpipe');
    if (readable === src) {
      if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
        unpipeInfo.hasUnpiped = true;
        cleanup();
      }
    }
  }
  function onend() {
    debug('onend');
    dest.end();
  }

  // when the dest drains, it reduces the awaitDrain counter
  // on the source.  This would be more elegant with a .once()
  // handler in flow(), but adding and removing repeatedly is
  // too slow.
  var ondrain = pipeOnDrain(src);
  dest.on('drain', ondrain);
  var cleanedUp = false;
  function cleanup() {
    debug('cleanup');
    // cleanup event handlers once the pipe is broken
    dest.removeListener('close', onclose);
    dest.removeListener('finish', onfinish);
    dest.removeListener('drain', ondrain);
    dest.removeListener('error', onerror);
    dest.removeListener('unpipe', onunpipe);
    src.removeListener('end', onend);
    src.removeListener('end', unpipe);
    src.removeListener('data', ondata);
    cleanedUp = true;

    // if the reader is waiting for a drain event from this
    // specific writer, then it would cause it to never start
    // flowing again.
    // So, if this is awaiting a drain, then we just call it now.
    // If we don't know, then assume that we are waiting for one.
    if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
  }
  src.on('data', ondata);
  function ondata(chunk) {
    debug('ondata');
    var ret = dest.write(chunk);
    debug('dest.write', ret);
    if (ret === false) {
      // If the user unpiped during `dest.write()`, it is possible
      // to get stuck in a permanently paused state if that write
      // also returned false.
      // => Check whether `dest` is still a piping destination.
      if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
        debug('false write response, pause', state.awaitDrain);
        state.awaitDrain++;
      }
      src.pause();
    }
  }

  // if the dest has an error, then stop piping into it.
  // however, don't suppress the throwing behavior for this.
  function onerror(er) {
    debug('onerror', er);
    unpipe();
    dest.removeListener('error', onerror);
    if (EElistenerCount(dest, 'error') === 0) errorOrDestroy(dest, er);
  }

  // Make sure our error handler is attached before userland ones.
  prependListener(dest, 'error', onerror);

  // Both close and finish should trigger unpipe, but only once.
  function onclose() {
    dest.removeListener('finish', onfinish);
    unpipe();
  }
  dest.once('close', onclose);
  function onfinish() {
    debug('onfinish');
    dest.removeListener('close', onclose);
    unpipe();
  }
  dest.once('finish', onfinish);
  function unpipe() {
    debug('unpipe');
    src.unpipe(dest);
  }

  // tell the dest that it's being piped to
  dest.emit('pipe', src);

  // start the flow if it hasn't been started already.
  if (!state.flowing) {
    debug('pipe resume');
    src.resume();
  }
  return dest;
};
function pipeOnDrain(src) {
  return function pipeOnDrainFunctionResult() {
    var state = src._readableState;
    debug('pipeOnDrain', state.awaitDrain);
    if (state.awaitDrain) state.awaitDrain--;
    if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
      state.flowing = true;
      flow(src);
    }
  };
}
Readable.prototype.unpipe = function (dest) {
  var state = this._readableState;
  var unpipeInfo = {
    hasUnpiped: false
  };

  // if we're not piping anywhere, then do nothing.
  if (state.pipesCount === 0) return this;

  // just one destination.  most common case.
  if (state.pipesCount === 1) {
    // passed in one, but it's not the right one.
    if (dest && dest !== state.pipes) return this;
    if (!dest) dest = state.pipes;

    // got a match.
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;
    if (dest) dest.emit('unpipe', this, unpipeInfo);
    return this;
  }

  // slow case. multiple pipe destinations.

  if (!dest) {
    // remove all.
    var dests = state.pipes;
    var len = state.pipesCount;
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;
    for (var i = 0; i < len; i++) dests[i].emit('unpipe', this, {
      hasUnpiped: false
    });
    return this;
  }

  // try to find the right one.
  var index = indexOf(state.pipes, dest);
  if (index === -1) return this;
  state.pipes.splice(index, 1);
  state.pipesCount -= 1;
  if (state.pipesCount === 1) state.pipes = state.pipes[0];
  dest.emit('unpipe', this, unpipeInfo);
  return this;
};

// set up data events if they are asked for
// Ensure readable listeners eventually get something
Readable.prototype.on = function (ev, fn) {
  var res = Stream.prototype.on.call(this, ev, fn);
  var state = this._readableState;
  if (ev === 'data') {
    // update readableListening so that resume() may be a no-op
    // a few lines down. This is needed to support once('readable').
    state.readableListening = this.listenerCount('readable') > 0;

    // Try start flowing on next tick if stream isn't explicitly paused
    if (state.flowing !== false) this.resume();
  } else if (ev === 'readable') {
    if (!state.endEmitted && !state.readableListening) {
      state.readableListening = state.needReadable = true;
      state.flowing = false;
      state.emittedReadable = false;
      debug('on readable', state.length, state.reading);
      if (state.length) {
        emitReadable(this);
      } else if (!state.reading) {
        process.nextTick(nReadingNextTick, this);
      }
    }
  }
  return res;
};
Readable.prototype.addListener = Readable.prototype.on;
Readable.prototype.removeListener = function (ev, fn) {
  var res = Stream.prototype.removeListener.call(this, ev, fn);
  if (ev === 'readable') {
    // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    process.nextTick(updateReadableListening, this);
  }
  return res;
};
Readable.prototype.removeAllListeners = function (ev) {
  var res = Stream.prototype.removeAllListeners.apply(this, arguments);
  if (ev === 'readable' || ev === undefined) {
    // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    process.nextTick(updateReadableListening, this);
  }
  return res;
};
function updateReadableListening(self) {
  var state = self._readableState;
  state.readableListening = self.listenerCount('readable') > 0;
  if (state.resumeScheduled && !state.paused) {
    // flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;

    // crude way to check if we should resume
  } else if (self.listenerCount('data') > 0) {
    self.resume();
  }
}
function nReadingNextTick(self) {
  debug('readable nexttick read 0');
  self.read(0);
}

// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
Readable.prototype.resume = function () {
  var state = this._readableState;
  if (!state.flowing) {
    debug('resume');
    // we flow only if there is no one listening
    // for readable, but we still have to call
    // resume()
    state.flowing = !state.readableListening;
    resume(this, state);
  }
  state.paused = false;
  return this;
};
function resume(stream, state) {
  if (!state.resumeScheduled) {
    state.resumeScheduled = true;
    process.nextTick(resume_, stream, state);
  }
}
function resume_(stream, state) {
  debug('resume', state.reading);
  if (!state.reading) {
    stream.read(0);
  }
  state.resumeScheduled = false;
  stream.emit('resume');
  flow(stream);
  if (state.flowing && !state.reading) stream.read(0);
}
Readable.prototype.pause = function () {
  debug('call pause flowing=%j', this._readableState.flowing);
  if (this._readableState.flowing !== false) {
    debug('pause');
    this._readableState.flowing = false;
    this.emit('pause');
  }
  this._readableState.paused = true;
  return this;
};
function flow(stream) {
  var state = stream._readableState;
  debug('flow', state.flowing);
  while (state.flowing && stream.read() !== null);
}

// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
Readable.prototype.wrap = function (stream) {
  var _this = this;
  var state = this._readableState;
  var paused = false;
  stream.on('end', function () {
    debug('wrapped end');
    if (state.decoder && !state.ended) {
      var chunk = state.decoder.end();
      if (chunk && chunk.length) _this.push(chunk);
    }
    _this.push(null);
  });
  stream.on('data', function (chunk) {
    debug('wrapped data');
    if (state.decoder) chunk = state.decoder.write(chunk);

    // don't skip over falsy values in objectMode
    if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;
    var ret = _this.push(chunk);
    if (!ret) {
      paused = true;
      stream.pause();
    }
  });

  // proxy all the other methods.
  // important when wrapping filters and duplexes.
  for (var i in stream) {
    if (this[i] === undefined && typeof stream[i] === 'function') {
      this[i] = function methodWrap(method) {
        return function methodWrapReturnFunction() {
          return stream[method].apply(stream, arguments);
        };
      }(i);
    }
  }

  // proxy certain important events.
  for (var n = 0; n < kProxyEvents.length; n++) {
    stream.on(kProxyEvents[n], this.emit.bind(this, kProxyEvents[n]));
  }

  // when we try to consume some more bytes, simply unpause the
  // underlying stream.
  this._read = function (n) {
    debug('wrapped _read', n);
    if (paused) {
      paused = false;
      stream.resume();
    }
  };
  return this;
};
if (typeof Symbol === 'function') {
  Readable.prototype[Symbol.asyncIterator] = function () {
    if (createReadableStreamAsyncIterator === undefined) {
      createReadableStreamAsyncIterator = require('./internal/streams/async_iterator');
    }
    return createReadableStreamAsyncIterator(this);
  };
}
Object.defineProperty(Readable.prototype, 'readableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._readableState.highWaterMark;
  }
});
Object.defineProperty(Readable.prototype, 'readableBuffer', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._readableState && this._readableState.buffer;
  }
});
Object.defineProperty(Readable.prototype, 'readableFlowing', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._readableState.flowing;
  },
  set: function set(state) {
    if (this._readableState) {
      this._readableState.flowing = state;
    }
  }
});

// exposed for testing purposes only.
Readable._fromList = fromList;
Object.defineProperty(Readable.prototype, 'readableLength', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._readableState.length;
  }
});

// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromList(n, state) {
  // nothing buffered
  if (state.length === 0) return null;
  var ret;
  if (state.objectMode) ret = state.buffer.shift();else if (!n || n >= state.length) {
    // read it all, truncate the list
    if (state.decoder) ret = state.buffer.join('');else if (state.buffer.length === 1) ret = state.buffer.first();else ret = state.buffer.concat(state.length);
    state.buffer.clear();
  } else {
    // read part of list
    ret = state.buffer.consume(n, state.decoder);
  }
  return ret;
}
function endReadable(stream) {
  var state = stream._readableState;
  debug('endReadable', state.endEmitted);
  if (!state.endEmitted) {
    state.ended = true;
    process.nextTick(endReadableNT, state, stream);
  }
}
function endReadableNT(state, stream) {
  debug('endReadableNT', state.endEmitted, state.length);

  // Check that we didn't get one last unshift.
  if (!state.endEmitted && state.length === 0) {
    state.endEmitted = true;
    stream.readable = false;
    stream.emit('end');
    if (state.autoDestroy) {
      // In case of duplex streams we need a way to detect
      // if the writable side is ready for autoDestroy as well
      var wState = stream._writableState;
      if (!wState || wState.autoDestroy && wState.finished) {
        stream.destroy();
      }
    }
  }
}
if (typeof Symbol === 'function') {
  Readable.from = function (iterable, opts) {
    if (from === undefined) {
      from = require('./internal/streams/from');
    }
    return from(Readable, iterable, opts);
  };
}
function indexOf(xs, x) {
  for (var i = 0, l = xs.length; i < l; i++) {
    if (xs[i] === x) return i;
  }
  return -1;
}
}).call(this)}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"../errors":170,"./_stream_duplex":171,"./internal/streams/async_iterator":176,"./internal/streams/buffer_list":177,"./internal/streams/destroy":178,"./internal/streams/from":180,"./internal/streams/state":182,"./internal/streams/stream":183,"_process":150,"buffer":20,"events":50,"inherits":115,"string_decoder/":185,"util":18}],174:[function(require,module,exports){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.

'use strict';

module.exports = Transform;
var _require$codes = require('../errors').codes,
  ERR_METHOD_NOT_IMPLEMENTED = _require$codes.ERR_METHOD_NOT_IMPLEMENTED,
  ERR_MULTIPLE_CALLBACK = _require$codes.ERR_MULTIPLE_CALLBACK,
  ERR_TRANSFORM_ALREADY_TRANSFORMING = _require$codes.ERR_TRANSFORM_ALREADY_TRANSFORMING,
  ERR_TRANSFORM_WITH_LENGTH_0 = _require$codes.ERR_TRANSFORM_WITH_LENGTH_0;
var Duplex = require('./_stream_duplex');
require('inherits')(Transform, Duplex);
function afterTransform(er, data) {
  var ts = this._transformState;
  ts.transforming = false;
  var cb = ts.writecb;
  if (cb === null) {
    return this.emit('error', new ERR_MULTIPLE_CALLBACK());
  }
  ts.writechunk = null;
  ts.writecb = null;
  if (data != null)
    // single equals check for both `null` and `undefined`
    this.push(data);
  cb(er);
  var rs = this._readableState;
  rs.reading = false;
  if (rs.needReadable || rs.length < rs.highWaterMark) {
    this._read(rs.highWaterMark);
  }
}
function Transform(options) {
  if (!(this instanceof Transform)) return new Transform(options);
  Duplex.call(this, options);
  this._transformState = {
    afterTransform: afterTransform.bind(this),
    needTransform: false,
    transforming: false,
    writecb: null,
    writechunk: null,
    writeencoding: null
  };

  // start out asking for a readable event once data is transformed.
  this._readableState.needReadable = true;

  // we have implemented the _read method, and done the other things
  // that Readable wants before the first _read call, so unset the
  // sync guard flag.
  this._readableState.sync = false;
  if (options) {
    if (typeof options.transform === 'function') this._transform = options.transform;
    if (typeof options.flush === 'function') this._flush = options.flush;
  }

  // When the writable side finishes, then flush out anything remaining.
  this.on('prefinish', prefinish);
}
function prefinish() {
  var _this = this;
  if (typeof this._flush === 'function' && !this._readableState.destroyed) {
    this._flush(function (er, data) {
      done(_this, er, data);
    });
  } else {
    done(this, null, null);
  }
}
Transform.prototype.push = function (chunk, encoding) {
  this._transformState.needTransform = false;
  return Duplex.prototype.push.call(this, chunk, encoding);
};

// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
Transform.prototype._transform = function (chunk, encoding, cb) {
  cb(new ERR_METHOD_NOT_IMPLEMENTED('_transform()'));
};
Transform.prototype._write = function (chunk, encoding, cb) {
  var ts = this._transformState;
  ts.writecb = cb;
  ts.writechunk = chunk;
  ts.writeencoding = encoding;
  if (!ts.transforming) {
    var rs = this._readableState;
    if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
  }
};

// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
Transform.prototype._read = function (n) {
  var ts = this._transformState;
  if (ts.writechunk !== null && !ts.transforming) {
    ts.transforming = true;
    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
  } else {
    // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
  }
};
Transform.prototype._destroy = function (err, cb) {
  Duplex.prototype._destroy.call(this, err, function (err2) {
    cb(err2);
  });
};
function done(stream, er, data) {
  if (er) return stream.emit('error', er);
  if (data != null)
    // single equals check for both `null` and `undefined`
    stream.push(data);

  // TODO(BridgeAR): Write a test for these two error cases
  // if there's nothing in the write buffer, then that means
  // that nothing more will ever be provided
  if (stream._writableState.length) throw new ERR_TRANSFORM_WITH_LENGTH_0();
  if (stream._transformState.transforming) throw new ERR_TRANSFORM_ALREADY_TRANSFORMING();
  return stream.push(null);
}
},{"../errors":170,"./_stream_duplex":171,"inherits":115}],175:[function(require,module,exports){
(function (process,global){(function (){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.

'use strict';

module.exports = Writable;

/* <replacement> */
function WriteReq(chunk, encoding, cb) {
  this.chunk = chunk;
  this.encoding = encoding;
  this.callback = cb;
  this.next = null;
}

// It seems a linked list but it is not
// there will be only 2 of these for each stream
function CorkedRequest(state) {
  var _this = this;
  this.next = null;
  this.entry = null;
  this.finish = function () {
    onCorkedFinish(_this, state);
  };
}
/* </replacement> */

/*<replacement>*/
var Duplex;
/*</replacement>*/

Writable.WritableState = WritableState;

/*<replacement>*/
var internalUtil = {
  deprecate: require('util-deprecate')
};
/*</replacement>*/

/*<replacement>*/
var Stream = require('./internal/streams/stream');
/*</replacement>*/

var Buffer = require('buffer').Buffer;
var OurUint8Array = (typeof global !== 'undefined' ? global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}
var destroyImpl = require('./internal/streams/destroy');
var _require = require('./internal/streams/state'),
  getHighWaterMark = _require.getHighWaterMark;
var _require$codes = require('../errors').codes,
  ERR_INVALID_ARG_TYPE = _require$codes.ERR_INVALID_ARG_TYPE,
  ERR_METHOD_NOT_IMPLEMENTED = _require$codes.ERR_METHOD_NOT_IMPLEMENTED,
  ERR_MULTIPLE_CALLBACK = _require$codes.ERR_MULTIPLE_CALLBACK,
  ERR_STREAM_CANNOT_PIPE = _require$codes.ERR_STREAM_CANNOT_PIPE,
  ERR_STREAM_DESTROYED = _require$codes.ERR_STREAM_DESTROYED,
  ERR_STREAM_NULL_VALUES = _require$codes.ERR_STREAM_NULL_VALUES,
  ERR_STREAM_WRITE_AFTER_END = _require$codes.ERR_STREAM_WRITE_AFTER_END,
  ERR_UNKNOWN_ENCODING = _require$codes.ERR_UNKNOWN_ENCODING;
var errorOrDestroy = destroyImpl.errorOrDestroy;
require('inherits')(Writable, Stream);
function nop() {}
function WritableState(options, stream, isDuplex) {
  Duplex = Duplex || require('./_stream_duplex');
  options = options || {};

  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream,
  // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
  if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof Duplex;

  // object stream flag to indicate whether or not this stream
  // contains buffers or objects.
  this.objectMode = !!options.objectMode;
  if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;

  // the point at which write() starts returning false
  // Note: 0 is a valid value, means that we always return false if
  // the entire buffer is not flushed immediately on write()
  this.highWaterMark = getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex);

  // if _final has been called
  this.finalCalled = false;

  // drain event flag.
  this.needDrain = false;
  // at the start of calling end()
  this.ending = false;
  // when end() has been called, and returned
  this.ended = false;
  // when 'finish' is emitted
  this.finished = false;

  // has it been destroyed
  this.destroyed = false;

  // should we decode strings into buffers before passing to _write?
  // this is here so that some node-core streams can optimize string
  // handling at a lower level.
  var noDecode = options.decodeStrings === false;
  this.decodeStrings = !noDecode;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // not an actual buffer we keep track of, but a measurement
  // of how much we're waiting to get pushed to some underlying
  // socket or file.
  this.length = 0;

  // a flag to see when we're in the middle of a write.
  this.writing = false;

  // when true all writes will be buffered until .uncork() call
  this.corked = 0;

  // a flag to be able to tell if the onwrite cb is called immediately,
  // or on a later tick.  We set this to true at first, because any
  // actions that shouldn't happen until "later" should generally also
  // not happen before the first write call.
  this.sync = true;

  // a flag to know if we're processing previously buffered items, which
  // may call the _write() callback in the same tick, so that we don't
  // end up in an overlapped onwrite situation.
  this.bufferProcessing = false;

  // the callback that's passed to _write(chunk,cb)
  this.onwrite = function (er) {
    onwrite(stream, er);
  };

  // the callback that the user supplies to write(chunk,encoding,cb)
  this.writecb = null;

  // the amount that is being written when _write is called.
  this.writelen = 0;
  this.bufferedRequest = null;
  this.lastBufferedRequest = null;

  // number of pending user-supplied write callbacks
  // this must be 0 before 'finish' can be emitted
  this.pendingcb = 0;

  // emit prefinish if the only thing we're waiting for is _write cbs
  // This is relevant for synchronous Transform streams
  this.prefinished = false;

  // True if the error was already emitted and should not be thrown again
  this.errorEmitted = false;

  // Should close be emitted on destroy. Defaults to true.
  this.emitClose = options.emitClose !== false;

  // Should .destroy() be called after 'finish' (and potentially 'end')
  this.autoDestroy = !!options.autoDestroy;

  // count buffered requests
  this.bufferedRequestCount = 0;

  // allocate the first CorkedRequest, there is always
  // one allocated and free to use, and we maintain at most two
  this.corkedRequestsFree = new CorkedRequest(this);
}
WritableState.prototype.getBuffer = function getBuffer() {
  var current = this.bufferedRequest;
  var out = [];
  while (current) {
    out.push(current);
    current = current.next;
  }
  return out;
};
(function () {
  try {
    Object.defineProperty(WritableState.prototype, 'buffer', {
      get: internalUtil.deprecate(function writableStateBufferGetter() {
        return this.getBuffer();
      }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.', 'DEP0003')
    });
  } catch (_) {}
})();

// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
  realHasInstance = Function.prototype[Symbol.hasInstance];
  Object.defineProperty(Writable, Symbol.hasInstance, {
    value: function value(object) {
      if (realHasInstance.call(this, object)) return true;
      if (this !== Writable) return false;
      return object && object._writableState instanceof WritableState;
    }
  });
} else {
  realHasInstance = function realHasInstance(object) {
    return object instanceof this;
  };
}
function Writable(options) {
  Duplex = Duplex || require('./_stream_duplex');

  // Writable ctor is applied to Duplexes, too.
  // `realHasInstance` is necessary because using plain `instanceof`
  // would return false, as no `_writableState` property is attached.

  // Trying to use the custom `instanceof` for Writable here will also break the
  // Node.js LazyTransform implementation, which has a non-trivial getter for
  // `_writableState` that would lead to infinite recursion.

  // Checking for a Stream.Duplex instance is faster here instead of inside
  // the WritableState constructor, at least with V8 6.5
  var isDuplex = this instanceof Duplex;
  if (!isDuplex && !realHasInstance.call(Writable, this)) return new Writable(options);
  this._writableState = new WritableState(options, this, isDuplex);

  // legacy.
  this.writable = true;
  if (options) {
    if (typeof options.write === 'function') this._write = options.write;
    if (typeof options.writev === 'function') this._writev = options.writev;
    if (typeof options.destroy === 'function') this._destroy = options.destroy;
    if (typeof options.final === 'function') this._final = options.final;
  }
  Stream.call(this);
}

// Otherwise people can pipe Writable streams, which is just wrong.
Writable.prototype.pipe = function () {
  errorOrDestroy(this, new ERR_STREAM_CANNOT_PIPE());
};
function writeAfterEnd(stream, cb) {
  var er = new ERR_STREAM_WRITE_AFTER_END();
  // TODO: defer error events consistently everywhere, not just the cb
  errorOrDestroy(stream, er);
  process.nextTick(cb, er);
}

// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function validChunk(stream, state, chunk, cb) {
  var er;
  if (chunk === null) {
    er = new ERR_STREAM_NULL_VALUES();
  } else if (typeof chunk !== 'string' && !state.objectMode) {
    er = new ERR_INVALID_ARG_TYPE('chunk', ['string', 'Buffer'], chunk);
  }
  if (er) {
    errorOrDestroy(stream, er);
    process.nextTick(cb, er);
    return false;
  }
  return true;
}
Writable.prototype.write = function (chunk, encoding, cb) {
  var state = this._writableState;
  var ret = false;
  var isBuf = !state.objectMode && _isUint8Array(chunk);
  if (isBuf && !Buffer.isBuffer(chunk)) {
    chunk = _uint8ArrayToBuffer(chunk);
  }
  if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }
  if (isBuf) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;
  if (typeof cb !== 'function') cb = nop;
  if (state.ending) writeAfterEnd(this, cb);else if (isBuf || validChunk(this, state, chunk, cb)) {
    state.pendingcb++;
    ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
  }
  return ret;
};
Writable.prototype.cork = function () {
  this._writableState.corked++;
};
Writable.prototype.uncork = function () {
  var state = this._writableState;
  if (state.corked) {
    state.corked--;
    if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
  }
};
Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
  // node::ParseEncoding() requires lower case.
  if (typeof encoding === 'string') encoding = encoding.toLowerCase();
  if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new ERR_UNKNOWN_ENCODING(encoding);
  this._writableState.defaultEncoding = encoding;
  return this;
};
Object.defineProperty(Writable.prototype, 'writableBuffer', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState && this._writableState.getBuffer();
  }
});
function decodeChunk(state, chunk, encoding) {
  if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
    chunk = Buffer.from(chunk, encoding);
  }
  return chunk;
}
Object.defineProperty(Writable.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState.highWaterMark;
  }
});

// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
  if (!isBuf) {
    var newChunk = decodeChunk(state, chunk, encoding);
    if (chunk !== newChunk) {
      isBuf = true;
      encoding = 'buffer';
      chunk = newChunk;
    }
  }
  var len = state.objectMode ? 1 : chunk.length;
  state.length += len;
  var ret = state.length < state.highWaterMark;
  // we must ensure that previous needDrain will not be reset to false.
  if (!ret) state.needDrain = true;
  if (state.writing || state.corked) {
    var last = state.lastBufferedRequest;
    state.lastBufferedRequest = {
      chunk: chunk,
      encoding: encoding,
      isBuf: isBuf,
      callback: cb,
      next: null
    };
    if (last) {
      last.next = state.lastBufferedRequest;
    } else {
      state.bufferedRequest = state.lastBufferedRequest;
    }
    state.bufferedRequestCount += 1;
  } else {
    doWrite(stream, state, false, len, chunk, encoding, cb);
  }
  return ret;
}
function doWrite(stream, state, writev, len, chunk, encoding, cb) {
  state.writelen = len;
  state.writecb = cb;
  state.writing = true;
  state.sync = true;
  if (state.destroyed) state.onwrite(new ERR_STREAM_DESTROYED('write'));else if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
  state.sync = false;
}
function onwriteError(stream, state, sync, er, cb) {
  --state.pendingcb;
  if (sync) {
    // defer the callback if we are being called synchronously
    // to avoid piling up things on the stack
    process.nextTick(cb, er);
    // this can emit finish, and it will always happen
    // after error
    process.nextTick(finishMaybe, stream, state);
    stream._writableState.errorEmitted = true;
    errorOrDestroy(stream, er);
  } else {
    // the caller expect this to happen before if
    // it is async
    cb(er);
    stream._writableState.errorEmitted = true;
    errorOrDestroy(stream, er);
    // this can emit finish, but finish must
    // always follow error
    finishMaybe(stream, state);
  }
}
function onwriteStateUpdate(state) {
  state.writing = false;
  state.writecb = null;
  state.length -= state.writelen;
  state.writelen = 0;
}
function onwrite(stream, er) {
  var state = stream._writableState;
  var sync = state.sync;
  var cb = state.writecb;
  if (typeof cb !== 'function') throw new ERR_MULTIPLE_CALLBACK();
  onwriteStateUpdate(state);
  if (er) onwriteError(stream, state, sync, er, cb);else {
    // Check if we're actually ready to finish, but don't emit yet
    var finished = needFinish(state) || stream.destroyed;
    if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
      clearBuffer(stream, state);
    }
    if (sync) {
      process.nextTick(afterWrite, stream, state, finished, cb);
    } else {
      afterWrite(stream, state, finished, cb);
    }
  }
}
function afterWrite(stream, state, finished, cb) {
  if (!finished) onwriteDrain(stream, state);
  state.pendingcb--;
  cb();
  finishMaybe(stream, state);
}

// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function onwriteDrain(stream, state) {
  if (state.length === 0 && state.needDrain) {
    state.needDrain = false;
    stream.emit('drain');
  }
}

// if there's something in the buffer waiting, then process it
function clearBuffer(stream, state) {
  state.bufferProcessing = true;
  var entry = state.bufferedRequest;
  if (stream._writev && entry && entry.next) {
    // Fast case, write everything using _writev()
    var l = state.bufferedRequestCount;
    var buffer = new Array(l);
    var holder = state.corkedRequestsFree;
    holder.entry = entry;
    var count = 0;
    var allBuffers = true;
    while (entry) {
      buffer[count] = entry;
      if (!entry.isBuf) allBuffers = false;
      entry = entry.next;
      count += 1;
    }
    buffer.allBuffers = allBuffers;
    doWrite(stream, state, true, state.length, buffer, '', holder.finish);

    // doWrite is almost always async, defer these to save a bit of time
    // as the hot path ends with doWrite
    state.pendingcb++;
    state.lastBufferedRequest = null;
    if (holder.next) {
      state.corkedRequestsFree = holder.next;
      holder.next = null;
    } else {
      state.corkedRequestsFree = new CorkedRequest(state);
    }
    state.bufferedRequestCount = 0;
  } else {
    // Slow case, write chunks one-by-one
    while (entry) {
      var chunk = entry.chunk;
      var encoding = entry.encoding;
      var cb = entry.callback;
      var len = state.objectMode ? 1 : chunk.length;
      doWrite(stream, state, false, len, chunk, encoding, cb);
      entry = entry.next;
      state.bufferedRequestCount--;
      // if we didn't call the onwrite immediately, then
      // it means that we need to wait until it does.
      // also, that means that the chunk and cb are currently
      // being processed, so move the buffer counter past them.
      if (state.writing) {
        break;
      }
    }
    if (entry === null) state.lastBufferedRequest = null;
  }
  state.bufferedRequest = entry;
  state.bufferProcessing = false;
}
Writable.prototype._write = function (chunk, encoding, cb) {
  cb(new ERR_METHOD_NOT_IMPLEMENTED('_write()'));
};
Writable.prototype._writev = null;
Writable.prototype.end = function (chunk, encoding, cb) {
  var state = this._writableState;
  if (typeof chunk === 'function') {
    cb = chunk;
    chunk = null;
    encoding = null;
  } else if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }
  if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);

  // .end() fully uncorks
  if (state.corked) {
    state.corked = 1;
    this.uncork();
  }

  // ignore unnecessary end() calls.
  if (!state.ending) endWritable(this, state, cb);
  return this;
};
Object.defineProperty(Writable.prototype, 'writableLength', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState.length;
  }
});
function needFinish(state) {
  return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function callFinal(stream, state) {
  stream._final(function (err) {
    state.pendingcb--;
    if (err) {
      errorOrDestroy(stream, err);
    }
    state.prefinished = true;
    stream.emit('prefinish');
    finishMaybe(stream, state);
  });
}
function prefinish(stream, state) {
  if (!state.prefinished && !state.finalCalled) {
    if (typeof stream._final === 'function' && !state.destroyed) {
      state.pendingcb++;
      state.finalCalled = true;
      process.nextTick(callFinal, stream, state);
    } else {
      state.prefinished = true;
      stream.emit('prefinish');
    }
  }
}
function finishMaybe(stream, state) {
  var need = needFinish(state);
  if (need) {
    prefinish(stream, state);
    if (state.pendingcb === 0) {
      state.finished = true;
      stream.emit('finish');
      if (state.autoDestroy) {
        // In case of duplex streams we need a way to detect
        // if the readable side is ready for autoDestroy as well
        var rState = stream._readableState;
        if (!rState || rState.autoDestroy && rState.endEmitted) {
          stream.destroy();
        }
      }
    }
  }
  return need;
}
function endWritable(stream, state, cb) {
  state.ending = true;
  finishMaybe(stream, state);
  if (cb) {
    if (state.finished) process.nextTick(cb);else stream.once('finish', cb);
  }
  state.ended = true;
  stream.writable = false;
}
function onCorkedFinish(corkReq, state, err) {
  var entry = corkReq.entry;
  corkReq.entry = null;
  while (entry) {
    var cb = entry.callback;
    state.pendingcb--;
    cb(err);
    entry = entry.next;
  }

  // reuse the free corkReq.
  state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty(Writable.prototype, 'destroyed', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    if (this._writableState === undefined) {
      return false;
    }
    return this._writableState.destroyed;
  },
  set: function set(value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._writableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._writableState.destroyed = value;
  }
});
Writable.prototype.destroy = destroyImpl.destroy;
Writable.prototype._undestroy = destroyImpl.undestroy;
Writable.prototype._destroy = function (err, cb) {
  cb(err);
};
}).call(this)}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"../errors":170,"./_stream_duplex":171,"./internal/streams/destroy":178,"./internal/streams/state":182,"./internal/streams/stream":183,"_process":150,"buffer":20,"inherits":115,"util-deprecate":189}],176:[function(require,module,exports){
(function (process){(function (){
'use strict';

var _Object$setPrototypeO;
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var finished = require('./end-of-stream');
var kLastResolve = Symbol('lastResolve');
var kLastReject = Symbol('lastReject');
var kError = Symbol('error');
var kEnded = Symbol('ended');
var kLastPromise = Symbol('lastPromise');
var kHandlePromise = Symbol('handlePromise');
var kStream = Symbol('stream');
function createIterResult(value, done) {
  return {
    value: value,
    done: done
  };
}
function readAndResolve(iter) {
  var resolve = iter[kLastResolve];
  if (resolve !== null) {
    var data = iter[kStream].read();
    // we defer if data is null
    // we can be expecting either 'end' or
    // 'error'
    if (data !== null) {
      iter[kLastPromise] = null;
      iter[kLastResolve] = null;
      iter[kLastReject] = null;
      resolve(createIterResult(data, false));
    }
  }
}
function onReadable(iter) {
  // we wait for the next tick, because it might
  // emit an error with process.nextTick
  process.nextTick(readAndResolve, iter);
}
function wrapForNext(lastPromise, iter) {
  return function (resolve, reject) {
    lastPromise.then(function () {
      if (iter[kEnded]) {
        resolve(createIterResult(undefined, true));
        return;
      }
      iter[kHandlePromise](resolve, reject);
    }, reject);
  };
}
var AsyncIteratorPrototype = Object.getPrototypeOf(function () {});
var ReadableStreamAsyncIteratorPrototype = Object.setPrototypeOf((_Object$setPrototypeO = {
  get stream() {
    return this[kStream];
  },
  next: function next() {
    var _this = this;
    // if we have detected an error in the meanwhile
    // reject straight away
    var error = this[kError];
    if (error !== null) {
      return Promise.reject(error);
    }
    if (this[kEnded]) {
      return Promise.resolve(createIterResult(undefined, true));
    }
    if (this[kStream].destroyed) {
      // We need to defer via nextTick because if .destroy(err) is
      // called, the error will be emitted via nextTick, and
      // we cannot guarantee that there is no error lingering around
      // waiting to be emitted.
      return new Promise(function (resolve, reject) {
        process.nextTick(function () {
          if (_this[kError]) {
            reject(_this[kError]);
          } else {
            resolve(createIterResult(undefined, true));
          }
        });
      });
    }

    // if we have multiple next() calls
    // we will wait for the previous Promise to finish
    // this logic is optimized to support for await loops,
    // where next() is only called once at a time
    var lastPromise = this[kLastPromise];
    var promise;
    if (lastPromise) {
      promise = new Promise(wrapForNext(lastPromise, this));
    } else {
      // fast path needed to support multiple this.push()
      // without triggering the next() queue
      var data = this[kStream].read();
      if (data !== null) {
        return Promise.resolve(createIterResult(data, false));
      }
      promise = new Promise(this[kHandlePromise]);
    }
    this[kLastPromise] = promise;
    return promise;
  }
}, _defineProperty(_Object$setPrototypeO, Symbol.asyncIterator, function () {
  return this;
}), _defineProperty(_Object$setPrototypeO, "return", function _return() {
  var _this2 = this;
  // destroy(err, cb) is a private API
  // we can guarantee we have that here, because we control the
  // Readable class this is attached to
  return new Promise(function (resolve, reject) {
    _this2[kStream].destroy(null, function (err) {
      if (err) {
        reject(err);
        return;
      }
      resolve(createIterResult(undefined, true));
    });
  });
}), _Object$setPrototypeO), AsyncIteratorPrototype);
var createReadableStreamAsyncIterator = function createReadableStreamAsyncIterator(stream) {
  var _Object$create;
  var iterator = Object.create(ReadableStreamAsyncIteratorPrototype, (_Object$create = {}, _defineProperty(_Object$create, kStream, {
    value: stream,
    writable: true
  }), _defineProperty(_Object$create, kLastResolve, {
    value: null,
    writable: true
  }), _defineProperty(_Object$create, kLastReject, {
    value: null,
    writable: true
  }), _defineProperty(_Object$create, kError, {
    value: null,
    writable: true
  }), _defineProperty(_Object$create, kEnded, {
    value: stream._readableState.endEmitted,
    writable: true
  }), _defineProperty(_Object$create, kHandlePromise, {
    value: function value(resolve, reject) {
      var data = iterator[kStream].read();
      if (data) {
        iterator[kLastPromise] = null;
        iterator[kLastResolve] = null;
        iterator[kLastReject] = null;
        resolve(createIterResult(data, false));
      } else {
        iterator[kLastResolve] = resolve;
        iterator[kLastReject] = reject;
      }
    },
    writable: true
  }), _Object$create));
  iterator[kLastPromise] = null;
  finished(stream, function (err) {
    if (err && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') {
      var reject = iterator[kLastReject];
      // reject if we are waiting for data in the Promise
      // returned by next() and store the error
      if (reject !== null) {
        iterator[kLastPromise] = null;
        iterator[kLastResolve] = null;
        iterator[kLastReject] = null;
        reject(err);
      }
      iterator[kError] = err;
      return;
    }
    var resolve = iterator[kLastResolve];
    if (resolve !== null) {
      iterator[kLastPromise] = null;
      iterator[kLastResolve] = null;
      iterator[kLastReject] = null;
      resolve(createIterResult(undefined, true));
    }
    iterator[kEnded] = true;
  });
  stream.on('readable', onReadable.bind(null, iterator));
  return iterator;
};
module.exports = createReadableStreamAsyncIterator;
}).call(this)}).call(this,require('_process'))

},{"./end-of-stream":179,"_process":150}],177:[function(require,module,exports){
'use strict';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var _require = require('buffer'),
  Buffer = _require.Buffer;
var _require2 = require('util'),
  inspect = _require2.inspect;
var custom = inspect && inspect.custom || 'inspect';
function copyBuffer(src, target, offset) {
  Buffer.prototype.copy.call(src, target, offset);
}
module.exports = /*#__PURE__*/function () {
  function BufferList() {
    _classCallCheck(this, BufferList);
    this.head = null;
    this.tail = null;
    this.length = 0;
  }
  _createClass(BufferList, [{
    key: "push",
    value: function push(v) {
      var entry = {
        data: v,
        next: null
      };
      if (this.length > 0) this.tail.next = entry;else this.head = entry;
      this.tail = entry;
      ++this.length;
    }
  }, {
    key: "unshift",
    value: function unshift(v) {
      var entry = {
        data: v,
        next: this.head
      };
      if (this.length === 0) this.tail = entry;
      this.head = entry;
      ++this.length;
    }
  }, {
    key: "shift",
    value: function shift() {
      if (this.length === 0) return;
      var ret = this.head.data;
      if (this.length === 1) this.head = this.tail = null;else this.head = this.head.next;
      --this.length;
      return ret;
    }
  }, {
    key: "clear",
    value: function clear() {
      this.head = this.tail = null;
      this.length = 0;
    }
  }, {
    key: "join",
    value: function join(s) {
      if (this.length === 0) return '';
      var p = this.head;
      var ret = '' + p.data;
      while (p = p.next) ret += s + p.data;
      return ret;
    }
  }, {
    key: "concat",
    value: function concat(n) {
      if (this.length === 0) return Buffer.alloc(0);
      var ret = Buffer.allocUnsafe(n >>> 0);
      var p = this.head;
      var i = 0;
      while (p) {
        copyBuffer(p.data, ret, i);
        i += p.data.length;
        p = p.next;
      }
      return ret;
    }

    // Consumes a specified amount of bytes or characters from the buffered data.
  }, {
    key: "consume",
    value: function consume(n, hasStrings) {
      var ret;
      if (n < this.head.data.length) {
        // `slice` is the same for buffers and strings.
        ret = this.head.data.slice(0, n);
        this.head.data = this.head.data.slice(n);
      } else if (n === this.head.data.length) {
        // First chunk is a perfect match.
        ret = this.shift();
      } else {
        // Result spans more than one buffer.
        ret = hasStrings ? this._getString(n) : this._getBuffer(n);
      }
      return ret;
    }
  }, {
    key: "first",
    value: function first() {
      return this.head.data;
    }

    // Consumes a specified amount of characters from the buffered data.
  }, {
    key: "_getString",
    value: function _getString(n) {
      var p = this.head;
      var c = 1;
      var ret = p.data;
      n -= ret.length;
      while (p = p.next) {
        var str = p.data;
        var nb = n > str.length ? str.length : n;
        if (nb === str.length) ret += str;else ret += str.slice(0, n);
        n -= nb;
        if (n === 0) {
          if (nb === str.length) {
            ++c;
            if (p.next) this.head = p.next;else this.head = this.tail = null;
          } else {
            this.head = p;
            p.data = str.slice(nb);
          }
          break;
        }
        ++c;
      }
      this.length -= c;
      return ret;
    }

    // Consumes a specified amount of bytes from the buffered data.
  }, {
    key: "_getBuffer",
    value: function _getBuffer(n) {
      var ret = Buffer.allocUnsafe(n);
      var p = this.head;
      var c = 1;
      p.data.copy(ret);
      n -= p.data.length;
      while (p = p.next) {
        var buf = p.data;
        var nb = n > buf.length ? buf.length : n;
        buf.copy(ret, ret.length - n, 0, nb);
        n -= nb;
        if (n === 0) {
          if (nb === buf.length) {
            ++c;
            if (p.next) this.head = p.next;else this.head = this.tail = null;
          } else {
            this.head = p;
            p.data = buf.slice(nb);
          }
          break;
        }
        ++c;
      }
      this.length -= c;
      return ret;
    }

    // Make sure the linked list only shows the minimal necessary information.
  }, {
    key: custom,
    value: function value(_, options) {
      return inspect(this, _objectSpread(_objectSpread({}, options), {}, {
        // Only inspect one level.
        depth: 0,
        // It should not recurse.
        customInspect: false
      }));
    }
  }]);
  return BufferList;
}();
},{"buffer":20,"util":18}],178:[function(require,module,exports){
(function (process){(function (){
'use strict';

// undocumented cb() API, needed for core, not for public API
function destroy(err, cb) {
  var _this = this;
  var readableDestroyed = this._readableState && this._readableState.destroyed;
  var writableDestroyed = this._writableState && this._writableState.destroyed;
  if (readableDestroyed || writableDestroyed) {
    if (cb) {
      cb(err);
    } else if (err) {
      if (!this._writableState) {
        process.nextTick(emitErrorNT, this, err);
      } else if (!this._writableState.errorEmitted) {
        this._writableState.errorEmitted = true;
        process.nextTick(emitErrorNT, this, err);
      }
    }
    return this;
  }

  // we set destroyed to true before firing error callbacks in order
  // to make it re-entrance safe in case destroy() is called within callbacks

  if (this._readableState) {
    this._readableState.destroyed = true;
  }

  // if this is a duplex stream mark the writable part as destroyed as well
  if (this._writableState) {
    this._writableState.destroyed = true;
  }
  this._destroy(err || null, function (err) {
    if (!cb && err) {
      if (!_this._writableState) {
        process.nextTick(emitErrorAndCloseNT, _this, err);
      } else if (!_this._writableState.errorEmitted) {
        _this._writableState.errorEmitted = true;
        process.nextTick(emitErrorAndCloseNT, _this, err);
      } else {
        process.nextTick(emitCloseNT, _this);
      }
    } else if (cb) {
      process.nextTick(emitCloseNT, _this);
      cb(err);
    } else {
      process.nextTick(emitCloseNT, _this);
    }
  });
  return this;
}
function emitErrorAndCloseNT(self, err) {
  emitErrorNT(self, err);
  emitCloseNT(self);
}
function emitCloseNT(self) {
  if (self._writableState && !self._writableState.emitClose) return;
  if (self._readableState && !self._readableState.emitClose) return;
  self.emit('close');
}
function undestroy() {
  if (this._readableState) {
    this._readableState.destroyed = false;
    this._readableState.reading = false;
    this._readableState.ended = false;
    this._readableState.endEmitted = false;
  }
  if (this._writableState) {
    this._writableState.destroyed = false;
    this._writableState.ended = false;
    this._writableState.ending = false;
    this._writableState.finalCalled = false;
    this._writableState.prefinished = false;
    this._writableState.finished = false;
    this._writableState.errorEmitted = false;
  }
}
function emitErrorNT(self, err) {
  self.emit('error', err);
}
function errorOrDestroy(stream, err) {
  // We have tests that rely on errors being emitted
  // in the same tick, so changing this is semver major.
  // For now when you opt-in to autoDestroy we allow
  // the error to be emitted nextTick. In a future
  // semver major update we should change the default to this.

  var rState = stream._readableState;
  var wState = stream._writableState;
  if (rState && rState.autoDestroy || wState && wState.autoDestroy) stream.destroy(err);else stream.emit('error', err);
}
module.exports = {
  destroy: destroy,
  undestroy: undestroy,
  errorOrDestroy: errorOrDestroy
};
}).call(this)}).call(this,require('_process'))

},{"_process":150}],179:[function(require,module,exports){
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).

'use strict';

var ERR_STREAM_PREMATURE_CLOSE = require('../../../errors').codes.ERR_STREAM_PREMATURE_CLOSE;
function once(callback) {
  var called = false;
  return function () {
    if (called) return;
    called = true;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    callback.apply(this, args);
  };
}
function noop() {}
function isRequest(stream) {
  return stream.setHeader && typeof stream.abort === 'function';
}
function eos(stream, opts, callback) {
  if (typeof opts === 'function') return eos(stream, null, opts);
  if (!opts) opts = {};
  callback = once(callback || noop);
  var readable = opts.readable || opts.readable !== false && stream.readable;
  var writable = opts.writable || opts.writable !== false && stream.writable;
  var onlegacyfinish = function onlegacyfinish() {
    if (!stream.writable) onfinish();
  };
  var writableEnded = stream._writableState && stream._writableState.finished;
  var onfinish = function onfinish() {
    writable = false;
    writableEnded = true;
    if (!readable) callback.call(stream);
  };
  var readableEnded = stream._readableState && stream._readableState.endEmitted;
  var onend = function onend() {
    readable = false;
    readableEnded = true;
    if (!writable) callback.call(stream);
  };
  var onerror = function onerror(err) {
    callback.call(stream, err);
  };
  var onclose = function onclose() {
    var err;
    if (readable && !readableEnded) {
      if (!stream._readableState || !stream._readableState.ended) err = new ERR_STREAM_PREMATURE_CLOSE();
      return callback.call(stream, err);
    }
    if (writable && !writableEnded) {
      if (!stream._writableState || !stream._writableState.ended) err = new ERR_STREAM_PREMATURE_CLOSE();
      return callback.call(stream, err);
    }
  };
  var onrequest = function onrequest() {
    stream.req.on('finish', onfinish);
  };
  if (isRequest(stream)) {
    stream.on('complete', onfinish);
    stream.on('abort', onclose);
    if (stream.req) onrequest();else stream.on('request', onrequest);
  } else if (writable && !stream._writableState) {
    // legacy streams
    stream.on('end', onlegacyfinish);
    stream.on('close', onlegacyfinish);
  }
  stream.on('end', onend);
  stream.on('finish', onfinish);
  if (opts.error !== false) stream.on('error', onerror);
  stream.on('close', onclose);
  return function () {
    stream.removeListener('complete', onfinish);
    stream.removeListener('abort', onclose);
    stream.removeListener('request', onrequest);
    if (stream.req) stream.req.removeListener('finish', onfinish);
    stream.removeListener('end', onlegacyfinish);
    stream.removeListener('close', onlegacyfinish);
    stream.removeListener('finish', onfinish);
    stream.removeListener('end', onend);
    stream.removeListener('error', onerror);
    stream.removeListener('close', onclose);
  };
}
module.exports = eos;
},{"../../../errors":170}],180:[function(require,module,exports){
module.exports = function () {
  throw new Error('Readable.from is not available in the browser')
};

},{}],181:[function(require,module,exports){
// Ported from https://github.com/mafintosh/pump with
// permission from the author, Mathias Buus (@mafintosh).

'use strict';

var eos;
function once(callback) {
  var called = false;
  return function () {
    if (called) return;
    called = true;
    callback.apply(void 0, arguments);
  };
}
var _require$codes = require('../../../errors').codes,
  ERR_MISSING_ARGS = _require$codes.ERR_MISSING_ARGS,
  ERR_STREAM_DESTROYED = _require$codes.ERR_STREAM_DESTROYED;
function noop(err) {
  // Rethrow the error if it exists to avoid swallowing it
  if (err) throw err;
}
function isRequest(stream) {
  return stream.setHeader && typeof stream.abort === 'function';
}
function destroyer(stream, reading, writing, callback) {
  callback = once(callback);
  var closed = false;
  stream.on('close', function () {
    closed = true;
  });
  if (eos === undefined) eos = require('./end-of-stream');
  eos(stream, {
    readable: reading,
    writable: writing
  }, function (err) {
    if (err) return callback(err);
    closed = true;
    callback();
  });
  var destroyed = false;
  return function (err) {
    if (closed) return;
    if (destroyed) return;
    destroyed = true;

    // request.destroy just do .end - .abort is what we want
    if (isRequest(stream)) return stream.abort();
    if (typeof stream.destroy === 'function') return stream.destroy();
    callback(err || new ERR_STREAM_DESTROYED('pipe'));
  };
}
function call(fn) {
  fn();
}
function pipe(from, to) {
  return from.pipe(to);
}
function popCallback(streams) {
  if (!streams.length) return noop;
  if (typeof streams[streams.length - 1] !== 'function') return noop;
  return streams.pop();
}
function pipeline() {
  for (var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++) {
    streams[_key] = arguments[_key];
  }
  var callback = popCallback(streams);
  if (Array.isArray(streams[0])) streams = streams[0];
  if (streams.length < 2) {
    throw new ERR_MISSING_ARGS('streams');
  }
  var error;
  var destroys = streams.map(function (stream, i) {
    var reading = i < streams.length - 1;
    var writing = i > 0;
    return destroyer(stream, reading, writing, function (err) {
      if (!error) error = err;
      if (err) destroys.forEach(call);
      if (reading) return;
      destroys.forEach(call);
      callback(error);
    });
  });
  return streams.reduce(pipe);
}
module.exports = pipeline;
},{"../../../errors":170,"./end-of-stream":179}],182:[function(require,module,exports){
'use strict';

var ERR_INVALID_OPT_VALUE = require('../../../errors').codes.ERR_INVALID_OPT_VALUE;
function highWaterMarkFrom(options, isDuplex, duplexKey) {
  return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function getHighWaterMark(state, options, duplexKey, isDuplex) {
  var hwm = highWaterMarkFrom(options, isDuplex, duplexKey);
  if (hwm != null) {
    if (!(isFinite(hwm) && Math.floor(hwm) === hwm) || hwm < 0) {
      var name = isDuplex ? duplexKey : 'highWaterMark';
      throw new ERR_INVALID_OPT_VALUE(name, hwm);
    }
    return Math.floor(hwm);
  }

  // Default value
  return state.objectMode ? 16 : 16 * 1024;
}
module.exports = {
  getHighWaterMark: getHighWaterMark
};
},{"../../../errors":170}],183:[function(require,module,exports){
module.exports = require('events').EventEmitter;

},{"events":50}],184:[function(require,module,exports){
exports = module.exports = require('./lib/_stream_readable.js');
exports.Stream = exports;
exports.Readable = exports;
exports.Writable = require('./lib/_stream_writable.js');
exports.Duplex = require('./lib/_stream_duplex.js');
exports.Transform = require('./lib/_stream_transform.js');
exports.PassThrough = require('./lib/_stream_passthrough.js');
exports.finished = require('./lib/internal/streams/end-of-stream.js');
exports.pipeline = require('./lib/internal/streams/pipeline.js');

},{"./lib/_stream_duplex.js":171,"./lib/_stream_passthrough.js":172,"./lib/_stream_readable.js":173,"./lib/_stream_transform.js":174,"./lib/_stream_writable.js":175,"./lib/internal/streams/end-of-stream.js":179,"./lib/internal/streams/pipeline.js":181}],185:[function(require,module,exports){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

'use strict';

/*<replacement>*/

var Buffer = require('safe-buffer').Buffer;
/*</replacement>*/

var isEncoding = Buffer.isEncoding || function (encoding) {
  encoding = '' + encoding;
  switch (encoding && encoding.toLowerCase()) {
    case 'hex':case 'utf8':case 'utf-8':case 'ascii':case 'binary':case 'base64':case 'ucs2':case 'ucs-2':case 'utf16le':case 'utf-16le':case 'raw':
      return true;
    default:
      return false;
  }
};

function _normalizeEncoding(enc) {
  if (!enc) return 'utf8';
  var retried;
  while (true) {
    switch (enc) {
      case 'utf8':
      case 'utf-8':
        return 'utf8';
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return 'utf16le';
      case 'latin1':
      case 'binary':
        return 'latin1';
      case 'base64':
      case 'ascii':
      case 'hex':
        return enc;
      default:
        if (retried) return; // undefined
        enc = ('' + enc).toLowerCase();
        retried = true;
    }
  }
};

// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function normalizeEncoding(enc) {
  var nenc = _normalizeEncoding(enc);
  if (typeof nenc !== 'string' && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
  return nenc || enc;
}

// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
exports.StringDecoder = StringDecoder;
function StringDecoder(encoding) {
  this.encoding = normalizeEncoding(encoding);
  var nb;
  switch (this.encoding) {
    case 'utf16le':
      this.text = utf16Text;
      this.end = utf16End;
      nb = 4;
      break;
    case 'utf8':
      this.fillLast = utf8FillLast;
      nb = 4;
      break;
    case 'base64':
      this.text = base64Text;
      this.end = base64End;
      nb = 3;
      break;
    default:
      this.write = simpleWrite;
      this.end = simpleEnd;
      return;
  }
  this.lastNeed = 0;
  this.lastTotal = 0;
  this.lastChar = Buffer.allocUnsafe(nb);
}

StringDecoder.prototype.write = function (buf) {
  if (buf.length === 0) return '';
  var r;
  var i;
  if (this.lastNeed) {
    r = this.fillLast(buf);
    if (r === undefined) return '';
    i = this.lastNeed;
    this.lastNeed = 0;
  } else {
    i = 0;
  }
  if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
  return r || '';
};

StringDecoder.prototype.end = utf8End;

// Returns only complete characters in a Buffer
StringDecoder.prototype.text = utf8Text;

// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
StringDecoder.prototype.fillLast = function (buf) {
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
  this.lastNeed -= buf.length;
};

// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function utf8CheckByte(byte) {
  if (byte <= 0x7F) return 0;else if (byte >> 5 === 0x06) return 2;else if (byte >> 4 === 0x0E) return 3;else if (byte >> 3 === 0x1E) return 4;
  return byte >> 6 === 0x02 ? -1 : -2;
}

// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function utf8CheckIncomplete(self, buf, i) {
  var j = buf.length - 1;
  if (j < i) return 0;
  var nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 1;
    return nb;
  }
  if (--j < i || nb === -2) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 2;
    return nb;
  }
  if (--j < i || nb === -2) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) {
      if (nb === 2) nb = 0;else self.lastNeed = nb - 3;
    }
    return nb;
  }
  return 0;
}

// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function utf8CheckExtraBytes(self, buf, p) {
  if ((buf[0] & 0xC0) !== 0x80) {
    self.lastNeed = 0;
    return '\ufffd';
  }
  if (self.lastNeed > 1 && buf.length > 1) {
    if ((buf[1] & 0xC0) !== 0x80) {
      self.lastNeed = 1;
      return '\ufffd';
    }
    if (self.lastNeed > 2 && buf.length > 2) {
      if ((buf[2] & 0xC0) !== 0x80) {
        self.lastNeed = 2;
        return '\ufffd';
      }
    }
  }
}

// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function utf8FillLast(buf) {
  var p = this.lastTotal - this.lastNeed;
  var r = utf8CheckExtraBytes(this, buf, p);
  if (r !== undefined) return r;
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, p, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, p, 0, buf.length);
  this.lastNeed -= buf.length;
}

// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function utf8Text(buf, i) {
  var total = utf8CheckIncomplete(this, buf, i);
  if (!this.lastNeed) return buf.toString('utf8', i);
  this.lastTotal = total;
  var end = buf.length - (total - this.lastNeed);
  buf.copy(this.lastChar, 0, end);
  return buf.toString('utf8', i, end);
}

// For UTF-8, a replacement character is added when ending on a partial
// character.
function utf8End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + '\ufffd';
  return r;
}

// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function utf16Text(buf, i) {
  if ((buf.length - i) % 2 === 0) {
    var r = buf.toString('utf16le', i);
    if (r) {
      var c = r.charCodeAt(r.length - 1);
      if (c >= 0xD800 && c <= 0xDBFF) {
        this.lastNeed = 2;
        this.lastTotal = 4;
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
        return r.slice(0, -1);
      }
    }
    return r;
  }
  this.lastNeed = 1;
  this.lastTotal = 2;
  this.lastChar[0] = buf[buf.length - 1];
  return buf.toString('utf16le', i, buf.length - 1);
}

// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function utf16End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) {
    var end = this.lastTotal - this.lastNeed;
    return r + this.lastChar.toString('utf16le', 0, end);
  }
  return r;
}

function base64Text(buf, i) {
  var n = (buf.length - i) % 3;
  if (n === 0) return buf.toString('base64', i);
  this.lastNeed = 3 - n;
  this.lastTotal = 3;
  if (n === 1) {
    this.lastChar[0] = buf[buf.length - 1];
  } else {
    this.lastChar[0] = buf[buf.length - 2];
    this.lastChar[1] = buf[buf.length - 1];
  }
  return buf.toString('base64', i, buf.length - n);
}

function base64End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
  return r;
}

// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function simpleWrite(buf) {
  return buf.toString(this.encoding);
}

function simpleEnd(buf) {
  return buf && buf.length ? this.write(buf) : '';
}
},{"safe-buffer":159}],186:[function(require,module,exports){
(function (setImmediate,clearImmediate){(function (){
var nextTick = require('process/browser.js').nextTick;
var apply = Function.prototype.apply;
var slice = Array.prototype.slice;
var immediateIds = {};
var nextImmediateId = 0;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) { timeout.close(); };

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(window, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// That's not how node.js implements it but the exposed api is the same.
exports.setImmediate = typeof setImmediate === "function" ? setImmediate : function(fn) {
  var id = nextImmediateId++;
  var args = arguments.length < 2 ? false : slice.call(arguments, 1);

  immediateIds[id] = true;

  nextTick(function onNextTick() {
    if (immediateIds[id]) {
      // fn.call() is faster so we optimize for the common use-case
      // @see http://jsperf.com/call-apply-segu
      if (args) {
        fn.apply(null, args);
      } else {
        fn.call(null);
      }
      // Prevent ids from leaking
      exports.clearImmediate(id);
    }
  });

  return id;
};

exports.clearImmediate = typeof clearImmediate === "function" ? clearImmediate : function(id) {
  delete immediateIds[id];
};
}).call(this)}).call(this,require("timers").setImmediate,require("timers").clearImmediate)

},{"process/browser.js":150,"timers":186}],187:[function(require,module,exports){
(function (global){(function (){
/*! https://mths.be/punycode v1.4.1 by @mathias */
;(function(root) {

	/** Detect free variables */
	var freeExports = typeof exports == 'object' && exports &&
		!exports.nodeType && exports;
	var freeModule = typeof module == 'object' && module &&
		!module.nodeType && module;
	var freeGlobal = typeof global == 'object' && global;
	if (
		freeGlobal.global === freeGlobal ||
		freeGlobal.window === freeGlobal ||
		freeGlobal.self === freeGlobal
	) {
		root = freeGlobal;
	}

	/**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */
	var punycode,

	/** Highest positive signed 32-bit float value */
	maxInt = 2147483647, // aka. 0x7FFFFFFF or 2^31-1

	/** Bootstring parameters */
	base = 36,
	tMin = 1,
	tMax = 26,
	skew = 38,
	damp = 700,
	initialBias = 72,
	initialN = 128, // 0x80
	delimiter = '-', // '\x2D'

	/** Regular expressions */
	regexPunycode = /^xn--/,
	regexNonASCII = /[^\x20-\x7E]/, // unprintable ASCII chars + non-ASCII chars
	regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, // RFC 3490 separators

	/** Error messages */
	errors = {
		'overflow': 'Overflow: input needs wider integers to process',
		'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
		'invalid-input': 'Invalid input'
	},

	/** Convenience shortcuts */
	baseMinusTMin = base - tMin,
	floor = Math.floor,
	stringFromCharCode = String.fromCharCode,

	/** Temporary variable */
	key;

	/*--------------------------------------------------------------------------*/

	/**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */
	function error(type) {
		throw new RangeError(errors[type]);
	}

	/**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */
	function map(array, fn) {
		var length = array.length;
		var result = [];
		while (length--) {
			result[length] = fn(array[length]);
		}
		return result;
	}

	/**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */
	function mapDomain(string, fn) {
		var parts = string.split('@');
		var result = '';
		if (parts.length > 1) {
			// In email addresses, only the domain name should be punycoded. Leave
			// the local part (i.e. everything up to `@`) intact.
			result = parts[0] + '@';
			string = parts[1];
		}
		// Avoid `split(regex)` for IE8 compatibility. See #17.
		string = string.replace(regexSeparators, '\x2E');
		var labels = string.split('.');
		var encoded = map(labels, fn).join('.');
		return result + encoded;
	}

	/**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */
	function ucs2decode(string) {
		var output = [],
		    counter = 0,
		    length = string.length,
		    value,
		    extra;
		while (counter < length) {
			value = string.charCodeAt(counter++);
			if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
				// high surrogate, and there is a next character
				extra = string.charCodeAt(counter++);
				if ((extra & 0xFC00) == 0xDC00) { // low surrogate
					output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
				} else {
					// unmatched surrogate; only append this code unit, in case the next
					// code unit is the high surrogate of a surrogate pair
					output.push(value);
					counter--;
				}
			} else {
				output.push(value);
			}
		}
		return output;
	}

	/**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */
	function ucs2encode(array) {
		return map(array, function(value) {
			var output = '';
			if (value > 0xFFFF) {
				value -= 0x10000;
				output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
				value = 0xDC00 | value & 0x3FF;
			}
			output += stringFromCharCode(value);
			return output;
		}).join('');
	}

	/**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */
	function basicToDigit(codePoint) {
		if (codePoint - 48 < 10) {
			return codePoint - 22;
		}
		if (codePoint - 65 < 26) {
			return codePoint - 65;
		}
		if (codePoint - 97 < 26) {
			return codePoint - 97;
		}
		return base;
	}

	/**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */
	function digitToBasic(digit, flag) {
		//  0..25 map to ASCII a..z or A..Z
		// 26..35 map to ASCII 0..9
		return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
	}

	/**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * https://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */
	function adapt(delta, numPoints, firstTime) {
		var k = 0;
		delta = firstTime ? floor(delta / damp) : delta >> 1;
		delta += floor(delta / numPoints);
		for (/* no initialization */; delta > baseMinusTMin * tMax >> 1; k += base) {
			delta = floor(delta / baseMinusTMin);
		}
		return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
	}

	/**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */
	function decode(input) {
		// Don't use UCS-2
		var output = [],
		    inputLength = input.length,
		    out,
		    i = 0,
		    n = initialN,
		    bias = initialBias,
		    basic,
		    j,
		    index,
		    oldi,
		    w,
		    k,
		    digit,
		    t,
		    /** Cached calculation results */
		    baseMinusT;

		// Handle the basic code points: let `basic` be the number of input code
		// points before the last delimiter, or `0` if there is none, then copy
		// the first basic code points to the output.

		basic = input.lastIndexOf(delimiter);
		if (basic < 0) {
			basic = 0;
		}

		for (j = 0; j < basic; ++j) {
			// if it's not a basic code point
			if (input.charCodeAt(j) >= 0x80) {
				error('not-basic');
			}
			output.push(input.charCodeAt(j));
		}

		// Main decoding loop: start just after the last delimiter if any basic code
		// points were copied; start at the beginning otherwise.

		for (index = basic > 0 ? basic + 1 : 0; index < inputLength; /* no final expression */) {

			// `index` is the index of the next character to be consumed.
			// Decode a generalized variable-length integer into `delta`,
			// which gets added to `i`. The overflow checking is easier
			// if we increase `i` as we go, then subtract off its starting
			// value at the end to obtain `delta`.
			for (oldi = i, w = 1, k = base; /* no condition */; k += base) {

				if (index >= inputLength) {
					error('invalid-input');
				}

				digit = basicToDigit(input.charCodeAt(index++));

				if (digit >= base || digit > floor((maxInt - i) / w)) {
					error('overflow');
				}

				i += digit * w;
				t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);

				if (digit < t) {
					break;
				}

				baseMinusT = base - t;
				if (w > floor(maxInt / baseMinusT)) {
					error('overflow');
				}

				w *= baseMinusT;

			}

			out = output.length + 1;
			bias = adapt(i - oldi, out, oldi == 0);

			// `i` was supposed to wrap around from `out` to `0`,
			// incrementing `n` each time, so we'll fix that now:
			if (floor(i / out) > maxInt - n) {
				error('overflow');
			}

			n += floor(i / out);
			i %= out;

			// Insert `n` at position `i` of the output
			output.splice(i++, 0, n);

		}

		return ucs2encode(output);
	}

	/**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */
	function encode(input) {
		var n,
		    delta,
		    handledCPCount,
		    basicLength,
		    bias,
		    j,
		    m,
		    q,
		    k,
		    t,
		    currentValue,
		    output = [],
		    /** `inputLength` will hold the number of code points in `input`. */
		    inputLength,
		    /** Cached calculation results */
		    handledCPCountPlusOne,
		    baseMinusT,
		    qMinusT;

		// Convert the input in UCS-2 to Unicode
		input = ucs2decode(input);

		// Cache the length
		inputLength = input.length;

		// Initialize the state
		n = initialN;
		delta = 0;
		bias = initialBias;

		// Handle the basic code points
		for (j = 0; j < inputLength; ++j) {
			currentValue = input[j];
			if (currentValue < 0x80) {
				output.push(stringFromCharCode(currentValue));
			}
		}

		handledCPCount = basicLength = output.length;

		// `handledCPCount` is the number of code points that have been handled;
		// `basicLength` is the number of basic code points.

		// Finish the basic string - if it is not empty - with a delimiter
		if (basicLength) {
			output.push(delimiter);
		}

		// Main encoding loop:
		while (handledCPCount < inputLength) {

			// All non-basic code points < n have been handled already. Find the next
			// larger one:
			for (m = maxInt, j = 0; j < inputLength; ++j) {
				currentValue = input[j];
				if (currentValue >= n && currentValue < m) {
					m = currentValue;
				}
			}

			// Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
			// but guard against overflow
			handledCPCountPlusOne = handledCPCount + 1;
			if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
				error('overflow');
			}

			delta += (m - n) * handledCPCountPlusOne;
			n = m;

			for (j = 0; j < inputLength; ++j) {
				currentValue = input[j];

				if (currentValue < n && ++delta > maxInt) {
					error('overflow');
				}

				if (currentValue == n) {
					// Represent delta as a generalized variable-length integer
					for (q = delta, k = base; /* no condition */; k += base) {
						t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
						if (q < t) {
							break;
						}
						qMinusT = q - t;
						baseMinusT = base - t;
						output.push(
							stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0))
						);
						q = floor(qMinusT / baseMinusT);
					}

					output.push(stringFromCharCode(digitToBasic(q, 0)));
					bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
					delta = 0;
					++handledCPCount;
				}
			}

			++delta;
			++n;

		}
		return output.join('');
	}

	/**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */
	function toUnicode(input) {
		return mapDomain(input, function(string) {
			return regexPunycode.test(string)
				? decode(string.slice(4).toLowerCase())
				: string;
		});
	}

	/**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */
	function toASCII(input) {
		return mapDomain(input, function(string) {
			return regexNonASCII.test(string)
				? 'xn--' + encode(string)
				: string;
		});
	}

	/*--------------------------------------------------------------------------*/

	/** Define the public API */
	punycode = {
		/**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */
		'version': '1.4.1',
		/**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */
		'ucs2': {
			'decode': ucs2decode,
			'encode': ucs2encode
		},
		'decode': decode,
		'encode': encode,
		'toASCII': toASCII,
		'toUnicode': toUnicode
	};

	/** Expose `punycode` */
	// Some AMD build optimizers, like r.js, check for specific condition patterns
	// like the following:
	if (
		typeof define == 'function' &&
		typeof define.amd == 'object' &&
		define.amd
	) {
		define('punycode', function() {
			return punycode;
		});
	} else if (freeExports && freeModule) {
		if (module.exports == freeExports) {
			// in Node.js, io.js, or RingoJS v0.8.0+
			freeModule.exports = punycode;
		} else {
			// in Narwhal or RingoJS v0.7.0-
			for (key in punycode) {
				punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
			}
		}
	} else {
		// in Rhino or a web browser
		root.punycode = punycode;
	}

}(this));

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{}],188:[function(require,module,exports){
/*
 * Copyright Joyent, Inc. and other Node contributors.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a
 * copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to permit
 * persons to whom the Software is furnished to do so, subject to the
 * following conditions:
 *
 * The above copyright notice and this permission notice shall be included
 * in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
 * OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
 * NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
 * DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
 * OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
 * USE OR OTHER DEALINGS IN THE SOFTWARE.
 */

'use strict';

var punycode = require('punycode/');

function Url() {
  this.protocol = null;
  this.slashes = null;
  this.auth = null;
  this.host = null;
  this.port = null;
  this.hostname = null;
  this.hash = null;
  this.search = null;
  this.query = null;
  this.pathname = null;
  this.path = null;
  this.href = null;
}

// Reference: RFC 3986, RFC 1808, RFC 2396

/*
 * define these here so at least they only have to be
 * compiled once on the first module load.
 */
var protocolPattern = /^([a-z0-9.+-]+:)/i,
  portPattern = /:[0-9]*$/,

  // Special case for a simple path URL
  simplePathPattern = /^(\/\/?(?!\/)[^?\s]*)(\?[^\s]*)?$/,

  /*
   * RFC 2396: characters reserved for delimiting URLs.
   * We actually just auto-escape these.
   */
  delims = [
    '<', '>', '"', '`', ' ', '\r', '\n', '\t'
  ],

  // RFC 2396: characters not allowed for various reasons.
  unwise = [
    '{', '}', '|', '\\', '^', '`'
  ].concat(delims),

  // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
  autoEscape = ['\''].concat(unwise),
  /*
   * Characters that are never ever allowed in a hostname.
   * Note that any invalid chars are also handled, but these
   * are the ones that are *expected* to be seen, so we fast-path
   * them.
   */
  nonHostChars = [
    '%', '/', '?', ';', '#'
  ].concat(autoEscape),
  hostEndingChars = [
    '/', '?', '#'
  ],
  hostnameMaxLen = 255,
  hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/,
  hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/,
  // protocols that can allow "unsafe" and "unwise" chars.
  unsafeProtocol = {
    javascript: true,
    'javascript:': true
  },
  // protocols that never have a hostname.
  hostlessProtocol = {
    javascript: true,
    'javascript:': true
  },
  // protocols that always contain a // bit.
  slashedProtocol = {
    http: true,
    https: true,
    ftp: true,
    gopher: true,
    file: true,
    'http:': true,
    'https:': true,
    'ftp:': true,
    'gopher:': true,
    'file:': true
  },
  querystring = require('qs');

function urlParse(url, parseQueryString, slashesDenoteHost) {
  if (url && typeof url === 'object' && url instanceof Url) { return url; }

  var u = new Url();
  u.parse(url, parseQueryString, slashesDenoteHost);
  return u;
}

Url.prototype.parse = function (url, parseQueryString, slashesDenoteHost) {
  if (typeof url !== 'string') {
    throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
  }

  /*
   * Copy chrome, IE, opera backslash-handling behavior.
   * Back slashes before the query string get converted to forward slashes
   * See: https://code.google.com/p/chromium/issues/detail?id=25916
   */
  var queryIndex = url.indexOf('?'),
    splitter = queryIndex !== -1 && queryIndex < url.indexOf('#') ? '?' : '#',
    uSplit = url.split(splitter),
    slashRegex = /\\/g;
  uSplit[0] = uSplit[0].replace(slashRegex, '/');
  url = uSplit.join(splitter);

  var rest = url;

  /*
   * trim before proceeding.
   * This is to support parse stuff like "  http://foo.com  \n"
   */
  rest = rest.trim();

  if (!slashesDenoteHost && url.split('#').length === 1) {
    // Try fast path regexp
    var simplePath = simplePathPattern.exec(rest);
    if (simplePath) {
      this.path = rest;
      this.href = rest;
      this.pathname = simplePath[1];
      if (simplePath[2]) {
        this.search = simplePath[2];
        if (parseQueryString) {
          this.query = querystring.parse(this.search.substr(1));
        } else {
          this.query = this.search.substr(1);
        }
      } else if (parseQueryString) {
        this.search = '';
        this.query = {};
      }
      return this;
    }
  }

  var proto = protocolPattern.exec(rest);
  if (proto) {
    proto = proto[0];
    var lowerProto = proto.toLowerCase();
    this.protocol = lowerProto;
    rest = rest.substr(proto.length);
  }

  /*
   * figure out if it's got a host
   * user@server is *always* interpreted as a hostname, and url
   * resolution will treat //foo/bar as host=foo,path=bar because that's
   * how the browser resolves relative URLs.
   */
  if (slashesDenoteHost || proto || rest.match(/^\/\/[^@/]+@[^@/]+/)) {
    var slashes = rest.substr(0, 2) === '//';
    if (slashes && !(proto && hostlessProtocol[proto])) {
      rest = rest.substr(2);
      this.slashes = true;
    }
  }

  if (!hostlessProtocol[proto] && (slashes || (proto && !slashedProtocol[proto]))) {

    /*
     * there's a hostname.
     * the first instance of /, ?, ;, or # ends the host.
     *
     * If there is an @ in the hostname, then non-host chars *are* allowed
     * to the left of the last @ sign, unless some host-ending character
     * comes *before* the @-sign.
     * URLs are obnoxious.
     *
     * ex:
     * http://a@b@c/ => user:a@b host:c
     * http://a@b?@c => user:a host:c path:/?@c
     */

    /*
     * v0.12 TODO(isaacs): This is not quite how Chrome does things.
     * Review our test case against browsers more comprehensively.
     */

    // find the first instance of any hostEndingChars
    var hostEnd = -1;
    for (var i = 0; i < hostEndingChars.length; i++) {
      var hec = rest.indexOf(hostEndingChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) { hostEnd = hec; }
    }

    /*
     * at this point, either we have an explicit point where the
     * auth portion cannot go past, or the last @ char is the decider.
     */
    var auth, atSign;
    if (hostEnd === -1) {
      // atSign can be anywhere.
      atSign = rest.lastIndexOf('@');
    } else {
      /*
       * atSign must be in auth portion.
       * http://a@b/c@d => host:b auth:a path:/c@d
       */
      atSign = rest.lastIndexOf('@', hostEnd);
    }

    /*
     * Now we have a portion which is definitely the auth.
     * Pull that off.
     */
    if (atSign !== -1) {
      auth = rest.slice(0, atSign);
      rest = rest.slice(atSign + 1);
      this.auth = decodeURIComponent(auth);
    }

    // the host is the remaining to the left of the first non-host char
    hostEnd = -1;
    for (var i = 0; i < nonHostChars.length; i++) {
      var hec = rest.indexOf(nonHostChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) { hostEnd = hec; }
    }
    // if we still have not hit it, then the entire thing is a host.
    if (hostEnd === -1) { hostEnd = rest.length; }

    this.host = rest.slice(0, hostEnd);
    rest = rest.slice(hostEnd);

    // pull out port.
    this.parseHost();

    /*
     * we've indicated that there is a hostname,
     * so even if it's empty, it has to be present.
     */
    this.hostname = this.hostname || '';

    /*
     * if hostname begins with [ and ends with ]
     * assume that it's an IPv6 address.
     */
    var ipv6Hostname = this.hostname[0] === '[' && this.hostname[this.hostname.length - 1] === ']';

    // validate a little.
    if (!ipv6Hostname) {
      var hostparts = this.hostname.split(/\./);
      for (var i = 0, l = hostparts.length; i < l; i++) {
        var part = hostparts[i];
        if (!part) { continue; }
        if (!part.match(hostnamePartPattern)) {
          var newpart = '';
          for (var j = 0, k = part.length; j < k; j++) {
            if (part.charCodeAt(j) > 127) {
              /*
               * we replace non-ASCII char with a temporary placeholder
               * we need this to make sure size of hostname is not
               * broken by replacing non-ASCII by nothing
               */
              newpart += 'x';
            } else {
              newpart += part[j];
            }
          }
          // we test again with ASCII char only
          if (!newpart.match(hostnamePartPattern)) {
            var validParts = hostparts.slice(0, i);
            var notHost = hostparts.slice(i + 1);
            var bit = part.match(hostnamePartStart);
            if (bit) {
              validParts.push(bit[1]);
              notHost.unshift(bit[2]);
            }
            if (notHost.length) {
              rest = '/' + notHost.join('.') + rest;
            }
            this.hostname = validParts.join('.');
            break;
          }
        }
      }
    }

    if (this.hostname.length > hostnameMaxLen) {
      this.hostname = '';
    } else {
      // hostnames are always lower case.
      this.hostname = this.hostname.toLowerCase();
    }

    if (!ipv6Hostname) {
      /*
       * IDNA Support: Returns a punycoded representation of "domain".
       * It only converts parts of the domain name that
       * have non-ASCII characters, i.e. it doesn't matter if
       * you call it with a domain that already is ASCII-only.
       */
      this.hostname = punycode.toASCII(this.hostname);
    }

    var p = this.port ? ':' + this.port : '';
    var h = this.hostname || '';
    this.host = h + p;
    this.href += this.host;

    /*
     * strip [ and ] from the hostname
     * the host field still retains them, though
     */
    if (ipv6Hostname) {
      this.hostname = this.hostname.substr(1, this.hostname.length - 2);
      if (rest[0] !== '/') {
        rest = '/' + rest;
      }
    }
  }

  /*
   * now rest is set to the post-host stuff.
   * chop off any delim chars.
   */
  if (!unsafeProtocol[lowerProto]) {

    /*
     * First, make 100% sure that any "autoEscape" chars get
     * escaped, even if encodeURIComponent doesn't think they
     * need to be.
     */
    for (var i = 0, l = autoEscape.length; i < l; i++) {
      var ae = autoEscape[i];
      if (rest.indexOf(ae) === -1) { continue; }
      var esc = encodeURIComponent(ae);
      if (esc === ae) {
        esc = escape(ae);
      }
      rest = rest.split(ae).join(esc);
    }
  }

  // chop off from the tail first.
  var hash = rest.indexOf('#');
  if (hash !== -1) {
    // got a fragment string.
    this.hash = rest.substr(hash);
    rest = rest.slice(0, hash);
  }
  var qm = rest.indexOf('?');
  if (qm !== -1) {
    this.search = rest.substr(qm);
    this.query = rest.substr(qm + 1);
    if (parseQueryString) {
      this.query = querystring.parse(this.query);
    }
    rest = rest.slice(0, qm);
  } else if (parseQueryString) {
    // no query string, but parseQueryString still requested
    this.search = '';
    this.query = {};
  }
  if (rest) { this.pathname = rest; }
  if (slashedProtocol[lowerProto] && this.hostname && !this.pathname) {
    this.pathname = '/';
  }

  // to support http.request
  if (this.pathname || this.search) {
    var p = this.pathname || '';
    var s = this.search || '';
    this.path = p + s;
  }

  // finally, reconstruct the href based on what has been validated.
  this.href = this.format();
  return this;
};

// format a parsed object into a url string
function urlFormat(obj) {
  /*
   * ensure it's an object, and not a string url.
   * If it's an obj, this is a no-op.
   * this way, you can call url_format() on strings
   * to clean up potentially wonky urls.
   */
  if (typeof obj === 'string') { obj = urlParse(obj); }
  if (!(obj instanceof Url)) { return Url.prototype.format.call(obj); }
  return obj.format();
}

Url.prototype.format = function () {
  var auth = this.auth || '';
  if (auth) {
    auth = encodeURIComponent(auth);
    auth = auth.replace(/%3A/i, ':');
    auth += '@';
  }

  var protocol = this.protocol || '',
    pathname = this.pathname || '',
    hash = this.hash || '',
    host = false,
    query = '';

  if (this.host) {
    host = auth + this.host;
  } else if (this.hostname) {
    host = auth + (this.hostname.indexOf(':') === -1 ? this.hostname : '[' + this.hostname + ']');
    if (this.port) {
      host += ':' + this.port;
    }
  }

  if (this.query && typeof this.query === 'object' && Object.keys(this.query).length) {
    query = querystring.stringify(this.query, {
      arrayFormat: 'repeat',
      addQueryPrefix: false
    });
  }

  var search = this.search || (query && ('?' + query)) || '';

  if (protocol && protocol.substr(-1) !== ':') { protocol += ':'; }

  /*
   * only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
   * unless they had them to begin with.
   */
  if (this.slashes || (!protocol || slashedProtocol[protocol]) && host !== false) {
    host = '//' + (host || '');
    if (pathname && pathname.charAt(0) !== '/') { pathname = '/' + pathname; }
  } else if (!host) {
    host = '';
  }

  if (hash && hash.charAt(0) !== '#') { hash = '#' + hash; }
  if (search && search.charAt(0) !== '?') { search = '?' + search; }

  pathname = pathname.replace(/[?#]/g, function (match) {
    return encodeURIComponent(match);
  });
  search = search.replace('#', '%23');

  return protocol + host + pathname + search + hash;
};

function urlResolve(source, relative) {
  return urlParse(source, false, true).resolve(relative);
}

Url.prototype.resolve = function (relative) {
  return this.resolveObject(urlParse(relative, false, true)).format();
};

function urlResolveObject(source, relative) {
  if (!source) { return relative; }
  return urlParse(source, false, true).resolveObject(relative);
}

Url.prototype.resolveObject = function (relative) {
  if (typeof relative === 'string') {
    var rel = new Url();
    rel.parse(relative, false, true);
    relative = rel;
  }

  var result = new Url();
  var tkeys = Object.keys(this);
  for (var tk = 0; tk < tkeys.length; tk++) {
    var tkey = tkeys[tk];
    result[tkey] = this[tkey];
  }

  /*
   * hash is always overridden, no matter what.
   * even href="" will remove it.
   */
  result.hash = relative.hash;

  // if the relative url is empty, then there's nothing left to do here.
  if (relative.href === '') {
    result.href = result.format();
    return result;
  }

  // hrefs like //foo/bar always cut to the protocol.
  if (relative.slashes && !relative.protocol) {
    // take everything except the protocol from relative
    var rkeys = Object.keys(relative);
    for (var rk = 0; rk < rkeys.length; rk++) {
      var rkey = rkeys[rk];
      if (rkey !== 'protocol') { result[rkey] = relative[rkey]; }
    }

    // urlParse appends trailing / to urls like http://www.example.com
    if (slashedProtocol[result.protocol] && result.hostname && !result.pathname) {
      result.pathname = '/';
      result.path = result.pathname;
    }

    result.href = result.format();
    return result;
  }

  if (relative.protocol && relative.protocol !== result.protocol) {
    /*
     * if it's a known url protocol, then changing
     * the protocol does weird things
     * first, if it's not file:, then we MUST have a host,
     * and if there was a path
     * to begin with, then we MUST have a path.
     * if it is file:, then the host is dropped,
     * because that's known to be hostless.
     * anything else is assumed to be absolute.
     */
    if (!slashedProtocol[relative.protocol]) {
      var keys = Object.keys(relative);
      for (var v = 0; v < keys.length; v++) {
        var k = keys[v];
        result[k] = relative[k];
      }
      result.href = result.format();
      return result;
    }

    result.protocol = relative.protocol;
    if (!relative.host && !hostlessProtocol[relative.protocol]) {
      var relPath = (relative.pathname || '').split('/');
      while (relPath.length && !(relative.host = relPath.shift())) { }
      if (!relative.host) { relative.host = ''; }
      if (!relative.hostname) { relative.hostname = ''; }
      if (relPath[0] !== '') { relPath.unshift(''); }
      if (relPath.length < 2) { relPath.unshift(''); }
      result.pathname = relPath.join('/');
    } else {
      result.pathname = relative.pathname;
    }
    result.search = relative.search;
    result.query = relative.query;
    result.host = relative.host || '';
    result.auth = relative.auth;
    result.hostname = relative.hostname || relative.host;
    result.port = relative.port;
    // to support http.request
    if (result.pathname || result.search) {
      var p = result.pathname || '';
      var s = result.search || '';
      result.path = p + s;
    }
    result.slashes = result.slashes || relative.slashes;
    result.href = result.format();
    return result;
  }

  var isSourceAbs = result.pathname && result.pathname.charAt(0) === '/',
    isRelAbs = relative.host || relative.pathname && relative.pathname.charAt(0) === '/',
    mustEndAbs = isRelAbs || isSourceAbs || (result.host && relative.pathname),
    removeAllDots = mustEndAbs,
    srcPath = result.pathname && result.pathname.split('/') || [],
    relPath = relative.pathname && relative.pathname.split('/') || [],
    psychotic = result.protocol && !slashedProtocol[result.protocol];

  /*
   * if the url is a non-slashed url, then relative
   * links like ../.. should be able
   * to crawl up to the hostname, as well.  This is strange.
   * result.protocol has already been set by now.
   * Later on, put the first path part into the host field.
   */
  if (psychotic) {
    result.hostname = '';
    result.port = null;
    if (result.host) {
      if (srcPath[0] === '') { srcPath[0] = result.host; } else { srcPath.unshift(result.host); }
    }
    result.host = '';
    if (relative.protocol) {
      relative.hostname = null;
      relative.port = null;
      if (relative.host) {
        if (relPath[0] === '') { relPath[0] = relative.host; } else { relPath.unshift(relative.host); }
      }
      relative.host = null;
    }
    mustEndAbs = mustEndAbs && (relPath[0] === '' || srcPath[0] === '');
  }

  if (isRelAbs) {
    // it's absolute.
    result.host = relative.host || relative.host === '' ? relative.host : result.host;
    result.hostname = relative.hostname || relative.hostname === '' ? relative.hostname : result.hostname;
    result.search = relative.search;
    result.query = relative.query;
    srcPath = relPath;
    // fall through to the dot-handling below.
  } else if (relPath.length) {
    /*
     * it's relative
     * throw away the existing file, and take the new path instead.
     */
    if (!srcPath) { srcPath = []; }
    srcPath.pop();
    srcPath = srcPath.concat(relPath);
    result.search = relative.search;
    result.query = relative.query;
  } else if (relative.search != null) {
    /*
     * just pull out the search.
     * like href='?foo'.
     * Put this after the other two cases because it simplifies the booleans
     */
    if (psychotic) {
      result.host = srcPath.shift();
      result.hostname = result.host;
      /*
       * occationaly the auth can get stuck only in host
       * this especially happens in cases like
       * url.resolveObject('mailto:local1@domain1', 'local2@domain2')
       */
      var authInHost = result.host && result.host.indexOf('@') > 0 ? result.host.split('@') : false;
      if (authInHost) {
        result.auth = authInHost.shift();
        result.hostname = authInHost.shift();
        result.host = result.hostname;
      }
    }
    result.search = relative.search;
    result.query = relative.query;
    // to support http.request
    if (result.pathname !== null || result.search !== null) {
      result.path = (result.pathname ? result.pathname : '') + (result.search ? result.search : '');
    }
    result.href = result.format();
    return result;
  }

  if (!srcPath.length) {
    /*
     * no path at all.  easy.
     * we've already handled the other stuff above.
     */
    result.pathname = null;
    // to support http.request
    if (result.search) {
      result.path = '/' + result.search;
    } else {
      result.path = null;
    }
    result.href = result.format();
    return result;
  }

  /*
   * if a url ENDs in . or .., then it must get a trailing slash.
   * however, if it ends in anything else non-slashy,
   * then it must NOT get a trailing slash.
   */
  var last = srcPath.slice(-1)[0];
  var hasTrailingSlash = (result.host || relative.host || srcPath.length > 1) && (last === '.' || last === '..') || last === '';

  /*
   * strip single dots, resolve double dots to parent dir
   * if the path tries to go above the root, `up` ends up > 0
   */
  var up = 0;
  for (var i = srcPath.length; i >= 0; i--) {
    last = srcPath[i];
    if (last === '.') {
      srcPath.splice(i, 1);
    } else if (last === '..') {
      srcPath.splice(i, 1);
      up++;
    } else if (up) {
      srcPath.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (!mustEndAbs && !removeAllDots) {
    for (; up--; up) {
      srcPath.unshift('..');
    }
  }

  if (mustEndAbs && srcPath[0] !== '' && (!srcPath[0] || srcPath[0].charAt(0) !== '/')) {
    srcPath.unshift('');
  }

  if (hasTrailingSlash && (srcPath.join('/').substr(-1) !== '/')) {
    srcPath.push('');
  }

  var isAbsolute = srcPath[0] === '' || (srcPath[0] && srcPath[0].charAt(0) === '/');

  // put the host back
  if (psychotic) {
    result.hostname = isAbsolute ? '' : srcPath.length ? srcPath.shift() : '';
    result.host = result.hostname;
    /*
     * occationaly the auth can get stuck only in host
     * this especially happens in cases like
     * url.resolveObject('mailto:local1@domain1', 'local2@domain2')
     */
    var authInHost = result.host && result.host.indexOf('@') > 0 ? result.host.split('@') : false;
    if (authInHost) {
      result.auth = authInHost.shift();
      result.hostname = authInHost.shift();
      result.host = result.hostname;
    }
  }

  mustEndAbs = mustEndAbs || (result.host && srcPath.length);

  if (mustEndAbs && !isAbsolute) {
    srcPath.unshift('');
  }

  if (srcPath.length > 0) {
    result.pathname = srcPath.join('/');
  } else {
    result.pathname = null;
    result.path = null;
  }

  // to support request.http
  if (result.pathname !== null || result.search !== null) {
    result.path = (result.pathname ? result.pathname : '') + (result.search ? result.search : '');
  }
  result.auth = relative.auth || result.auth;
  result.slashes = result.slashes || relative.slashes;
  result.href = result.format();
  return result;
};

Url.prototype.parseHost = function () {
  var host = this.host;
  var port = portPattern.exec(host);
  if (port) {
    port = port[0];
    if (port !== ':') {
      this.port = port.substr(1);
    }
    host = host.substr(0, host.length - port.length);
  }
  if (host) { this.hostname = host; }
};

exports.parse = urlParse;
exports.resolve = urlResolve;
exports.resolveObject = urlResolveObject;
exports.format = urlFormat;

exports.Url = Url;

},{"punycode/":187,"qs":152}],189:[function(require,module,exports){
(function (global){(function (){

/**
 * Module exports.
 */

module.exports = deprecate;

/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */

function deprecate (fn, msg) {
  if (config('noDeprecation')) {
    return fn;
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (config('throwDeprecation')) {
        throw new Error(msg);
      } else if (config('traceDeprecation')) {
        console.trace(msg);
      } else {
        console.warn(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
}

/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */

function config (name) {
  // accessing global.localStorage can trigger a DOMException in sandboxed iframes
  try {
    if (!global.localStorage) return false;
  } catch (_) {
    return false;
  }
  var val = global.localStorage[name];
  if (null == val) return false;
  return String(val).toLowerCase() === 'true';
}

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{}],190:[function(require,module,exports){
// Returns a wrapper function that returns a wrapped callback
// The wrapper function should do some stuff, and return a
// presumably different callback function.
// This makes sure that own properties are retained, so that
// decorations and such are not lost along the way.
module.exports = wrappy
function wrappy (fn, cb) {
  if (fn && cb) return wrappy(fn)(cb)

  if (typeof fn !== 'function')
    throw new TypeError('need wrapper function')

  Object.keys(fn).forEach(function (k) {
    wrapper[k] = fn[k]
  })

  return wrapper

  function wrapper() {
    var args = new Array(arguments.length)
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i]
    }
    var ret = fn.apply(this, args)
    var cb = args[args.length-1]
    if (typeof ret === 'function' && ret !== cb) {
      Object.keys(cb).forEach(function (k) {
        ret[k] = cb[k]
      })
    }
    return ret
  }
}

},{}],191:[function(require,module,exports){
module.exports = extend

var hasOwnProperty = Object.prototype.hasOwnProperty;

function extend() {
    var target = {}

    for (var i = 0; i < arguments.length; i++) {
        var source = arguments[i]

        for (var key in source) {
            if (hasOwnProperty.call(source, key)) {
                target[key] = source[key]
            }
        }
    }

    return target
}

},{}],192:[function(require,module,exports){
module.exports={
  "name": "pict",
  "version": "1.0.372",
  "description": "Pict browser library.",
  "main": "source/Pict.js",
  "scripts": {
    "start": "node source/Pict.js",
    "test": "npx quack test",
    "tests": "npx quack test -g",
    "coverage": "npx quack coverage",
    "build": "npx quack build",
    "prepublishOnly": "npx quack build",
    "docker-dev-build": "docker build ./ -f Dockerfile_LUXURYCode -t pict-image:local",
    "docker-dev-run": "docker run -it -d --name pict-dev -p 37447:8080 -p 19506:8086 -v \"$PWD/.config:/home/coder/.config\"  -v \"$PWD:/home/coder/pict\" -u \"$(id -u):$(id -g)\" -e \"DOCKER_USER=$USER\" pict-image:local",
    "docker-dev-shell": "docker exec -it pict-dev /bin/bash",
    "lint": "eslint source/**/*.js test/**/*.js",
    "types": "tsc -p ."
  },
  "files": [
    "source/",
    "dist/",
    "types/"
  ],
  "types": "types/source/Pict.d.ts",
  "mocha": {
    "diff": true,
    "extension": [
      "js"
    ],
    "package": "./package.json",
    "reporter": "spec",
    "slow": "75",
    "timeout": "5000",
    "ui": "tdd",
    "watch-files": [
      "source/**/*.js",
      "test/**/*.js"
    ],
    "watch-ignore": [
      "lib/vendor"
    ]
  },
  "repository": {
    "type": "git",
    "url": "git+https://stevenvelozo@github.com/stevenvelozo/pict.git"
  },
  "author": "steven velozo <steven@velozo.com>",
  "license": "MIT",
  "bugs": {
    "url": "https://github.com/stevenvelozo/pict/issues"
  },
  "homepage": "https://github.com/stevenvelozo/pict#readme",
  "devDependencies": {
    "@eslint/js": "^9.39.1",
    "@types/jquery": "^3.5.33",
    "@types/sinon": "^17.0.4",
    "eslint": "^9.39.1",
    "globals": "^16.5.0",
    "pict-docuserve": "^1.3.2",
    "quackage": "^1.2.3",
    "sinon": "^20.0.0",
    "typescript": "^5.9.3"
  },
  "dependencies": {
    "cachetrax": "^1.0.6",
    "fable": "^3.1.74",
    "pict-application": "^1.0.34",
    "pict-provider": "^1.0.13",
    "pict-template": "^1.0.15",
    "pict-view": "^1.0.68"
  }
}

},{}],193:[function(require,module,exports){
// This assumes Pict has been required in the browser. Delcare these as globals so linter can do its job.
/* global Pict, _Pict: writeable */

/**
 * Simple function to load a pict Application
 *
 * @param {import('pict-application')} [pPictApplication] - The pict application to load.
 * @param {number} [pLogNoisiness] - The log noisiness level.
 */
module.exports = function (pPictApplication, pLogNoisiness)
{
	let tmpLogNoisiness = (typeof(pLogNoisiness) == 'undefined') ? 0 : pLogNoisiness;

	// Set up a basal pict on the window object
	if (pPictApplication && typeof pPictApplication['default_configuration'] === 'object' && ('pict_configuration' in pPictApplication['default_configuration']))
	{
		window._Pict = new Pict(pPictApplication['default_configuration'].pict_configuration);
	}
	else
	{
		window._Pict = new Pict();
	}

	window._Pict.LogNoisiness = tmpLogNoisiness;

	let tmpApplicationHash = 'DefaultApplication';
	let tmpDefaultConfiguration = {};

	if ('default_configuration' in pPictApplication)
	{
		tmpDefaultConfiguration = pPictApplication.default_configuration;

		if ('Hash' in tmpDefaultConfiguration && typeof tmpDefaultConfiguration.Hash === 'string')
		{
			tmpApplicationHash = tmpDefaultConfiguration.Hash;
		}
	}
	_Pict.log.info(`Loading the pict application [${tmpApplicationHash}] and associated views.`);

	_Pict.addApplication(tmpApplicationHash, tmpDefaultConfiguration, pPictApplication);

	_Pict.PictApplication.initializeAsync(
		function (pError)
		{
			if (pError)
			{
				console.log('Error initializing the pict application: '+pError)
			}
			_Pict.log.info('Loading the Application and associated views.');
		});
}

},{}],194:[function(require,module,exports){

/**
 * Provide a safe on document ready function (without needing a framework like jquery)
 *
 * @param {function} fCallback - The function to call when the document is ready
 */
module.exports = function (fCallback)
{
	if (!document)
	{
		console.log('No document object found; no initialization happening.');
		return;
	}
	// In case the document is already rendered
	if (document.readyState!='loading') fCallback();
	// Modern browsers have event listener capabilities
	else if (document.addEventListener) document.addEventListener('DOMContentLoaded', function() { fCallback(); });
	//@ts-ignore IE <= 8 and ... other abominations
	else document.attachEvent('onreadystatechange', function() { if (document.readyState=='complete') fCallback(); });
}

},{}],195:[function(require,module,exports){

const libFableServiceBase = require('fable').ServiceProviderBase;

const defaultConfiguration = (
	{
		// This is the address for the <script /> tag that contains the CSS.
		CSSElementAddress: '#PICT-CSS'
	}
)

class PictCSS extends libFableServiceBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.options;
		/** @type {{ ContentAssignment: import('./Pict-Content-Assignment') }} */
		this.services;
		/** @type {import('fable')} */
		this.fable;

		// No merging of options necessary
		if (typeof(this.options.CSSElementAddress) === 'undefined')
		{
			this.options.CSSElementAddress = defaultConfiguration.CSSElementAddress;
		}

		this.inlineCSSMap = {};

		this.fable.addSolverFunction(this.fable.expressionParser, 'createcsscolorrgbfromnumeric', this.createCssColorRGBFromNumeric.bind(this), 'Create a CSS color from RGB components');
	}

	// Add a CSS fragment to the CSS map (each view can have its own CSS fragment)
	// Hash is shared across all views, so if 10 views all load the "My-Table-View" fragment, it will only be loaded once.
	addCSS(pHash, pContent, pPriority, pProvider)
	{
		let tmpPriority = (typeof(pPriority) !== 'undefined') ? pPriority : 1000;
		let tmpProvidor = (typeof(pProvider) === 'string') ? pProvider : 'Unknown';
		this.inlineCSSMap[pHash] = { Hash: pHash, Content: pContent, Provider: tmpProvidor, Priority:tmpPriority };
	}

	removeCSS(pHash)
	{
		delete this.inlineCSSMap[pHash];
	}

	createCssColorRGBFromNumeric(pRed, pGreen, pBlue)
	{
		// 1. cast red, green and blue to floating point numbers
		// 2. If the numbers are all three less than or equal to 1.0, multiply each by 255 and round to the nearest integer.
		// 2a. If any of the numbers are greater than 1.0, round each to the nearest integer and make sure it's less than or equal to 255.
		// 3. Return a #RRGGBB string.
		let tmpRed = parseFloat(pRed);
		let tmpGreen = parseFloat(pGreen);
		let tmpBlue = parseFloat(pBlue);
		if (isNaN(tmpRed) || isNaN(tmpGreen) || isNaN(tmpBlue))
		{
			return '#000000';
		}
		if (tmpRed <= 1.0 && tmpGreen <= 1.0 && tmpBlue <= 1.0)
		{
			tmpRed = Math.round(tmpRed * 255);
			tmpGreen = Math.round(tmpGreen * 255);
			tmpBlue = Math.round(tmpBlue * 255);
		}
		// If they are less than or equal to 255, cast them to integers and round them.
		else if (tmpRed <= 255 && tmpGreen <= 255 && tmpBlue <= 255)
		{
			tmpRed = Math.round(tmpRed);
			tmpGreen = Math.round(tmpGreen);
			tmpBlue = Math.round(tmpBlue);
		}
		// Otherwise get the maximum of the three and quantize them to 255
		else
		{
			let tmpMax = Math.max(Math.max(tmpRed, tmpGreen), tmpBlue);
			tmpRed = Math.round((tmpRed / tmpMax) * 255);
			tmpGreen = Math.round((tmpGreen / tmpMax) * 255);
			tmpBlue = Math.round((tmpBlue / tmpMax) * 255);
		}
		tmpRed = Math.abs(tmpRed);
		tmpGreen = Math.abs(tmpGreen);
		tmpBlue = Math.abs(tmpBlue);
		let tmpRedHex = tmpRed.toString(16).padStart(2, '0');
		let tmpGreenHex = tmpGreen.toString(16).padStart(2, '0');
		let tmpBlueHex = tmpBlue.toString(16).padStart(2, '0');
		return `#${tmpRedHex}${tmpGreenHex}${tmpBlueHex}`;
	}

	generateCSS()
	{
		let tmpCSS = '';
		let tmpCSSHashes = Object.keys(this.inlineCSSMap);
		// Sort the hashes by Priority
		tmpCSSHashes.sort((a, b) => { return this.inlineCSSMap[a].Priority - this.inlineCSSMap[b].Priority; });
		for (let i = 0; i < tmpCSSHashes.length; i++)
		{
			let tmpCSSFragment = this.inlineCSSMap[tmpCSSHashes[i]];
			let tmpCSSComment = tmpCSSFragment.Hash;
			if (tmpCSSFragment.Hash != tmpCSSFragment.Provider)
			{
				tmpCSSComment = `${tmpCSSComment} from ${tmpCSSFragment.Provider}`;
			}
			tmpCSS += `/* ${tmpCSSComment} */\n${tmpCSSFragment.Content}\n`;
		}
		return tmpCSS;
	}

	// Inject the CSS into the magic DOM element for it
	injectCSS()
	{
		this.services.ContentAssignment.assignContent(this.options.CSSElementAddress, this.generateCSS());
	}
}

module.exports = PictCSS;

},{"fable":68}],196:[function(require,module,exports){
const libFableServiceBase = require('fable').ServiceProviderBase;

/**
 * Class for moving content around in the DOM.
 */
class PictContentAssignment extends libFableServiceBase
{
	/**
	 * @param {import('fable')} pFable - The Fable library instance.
	 * @param {any} [pOptions] - The options for the service.
	 * @param {string} [pServiceHash] - The hash of services.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.log;
		/** @type {any} */
		this.fable;

		this.serviceType = 'PictContentAssignment';

		this.manifest = pFable.newManyfest();

		// Check to see if we are running in a browser
		this.inBrowser = false;
		this.hasDocument = false;
		if (typeof (window) == 'object')
		{
			this.inBrowser = true;
			// Now check that the browser has a document object
			if ((typeof (window.document) != 'undefined') && (typeof (window.document.querySelectorAll) == 'function'))
			{
				this.hasDocument = true;
			}
		}

		// If we're in a browser, check to see if jQuery is available.
		this.hasJquery = false;
		this.jQuery = false;
		if (this.inBrowser && typeof (window.jQuery) !== 'undefined')
		{
			this.hasJquery = true;
		}

		/**
		 * Set this to override the default mechanism for setting the content of a DOM element.
		 *
		 * @type {Function}
		 * @param {string|HTMLElement} pAddress - The address of the element (a CSS selector), or the element itself.
		 * @param {string} pContent - The content to set.
		 */
		this.customAssignFunction = null;
		/**
		 * Set this to override the default mechanism for prepend content to a DOM element.
		 *
		 * @type {Function}
		 * @param {string|HTMLElement} pAddress - The address of the element (a CSS selector), or the element itself.
		 * @param {string} pContent - The content to prepend.
		 */
		this.customPrependFunction = null;
		/**
		 * Set this to override the default mechanism for appending content to a DOM element.
		 *
		 * @type {Function}
		 * @param {string|HTMLElement} pAddress - The address of the element (a CSS selector), or the element itself.
		 * @param {string} pContent - The content to append.
		 */
		this.customAppendFunction = null;
		/**
		 * Set this to override the default mechanism for appending content to a DOM element.
		 *
		 * @type {(pBeforeAddress: string|HTMLElement, pContent: string) => void}
		 * @param {string|HTMLElement} pBeforeAddress - The address of the element (a CSS selector), or the element itself.
		 * @param {string} pContent - The content to append.
		 */
		this.customInsertBeforeFunction = null;
		/**
		 * Set this to override the default mechanism for appending content to a DOM element.
		 *
		 * @type {(pAfterAddress: string|HTMLElement, pContent: string) => void}
		 * @param {string|HTMLElement} pAfterAddress - The address of the element (a CSS selector), or the element itself.
		 * @param {string} pContent - The content to append.
		 */
		this.customInsertAfterFunction = null;

		/**
		 * Set this to override the default mechanism for reading content from the DOM.
		 *
		 * @type {Function}
		 * @param {string|HTMLElement} pAddress - The address of the element (a CSS selector), or the element itself.
		 * @return {string} - The content of the element.
		 */
		this.customReadFunction = null;
		/**
		 * Set this to override the default mechanism for getting elements.
		 *
		 * @type {Function}
		 * @param {string|HTMLElement} pAddress - The address of the element (a CSS selector), or the element itself.
		 * @return {Array<any>} - The matched elements.
		 */
		this.customGetElementFunction = null;

		// API Consumers can also craft their own attribute read function
		this.customReadAttributeFunction = null;
		// API Consumers can also craft their own attribute set function
		this.customSetAttributeFunction = null;
		// API Consumers can also craft their own attribute remove function
		this.customRemoveAttributeFunction = null;

		// API Consumers can also craft their own class read function
		this.customReadClassFunction = null;
		// API Consumers can also craft their own class set function
		this.customSetClassFunction = null;
		// API Consumers can also craft their own class remove function
		this.customRemoveClassFunction = null;
	}

	/**
	 * Get an element from the DOM.
	 *
	 * @param {string} pAddress - The address of the element.
	 * @return {Array<any>} - The matched elements.
	 */
	getElement(pAddress)
	{
		if (this.customGetElementFunction)
		{
			return this.customGetElementFunction(pAddress);
		}
		else if (this.hasJquery)
		{
			let tmpElements = window.jQuery(pAddress);
			if (tmpElements.length == 0)
			{
				return [];
			}
			// TODO: This isn't the most efficient method, but it is the most compatible.
			let tmpElementSet = [];
			for (let i = 0; i < tmpElements.length; i++)
			{
				tmpElementSet.push(tmpElements[i]);
			}
			return tmpElementSet;
		}
		else if (this.inBrowser && this.hasDocument)
		{
			// convert from NodeList to Array for consistent return type
			const tmpElements = window.document.querySelectorAll(pAddress);
			let tmpElementSet = [];
			for (let i = 0; i < tmpElements.length; i++)
			{
				tmpElementSet.push(tmpElements[i]);
			}
			return tmpElementSet;
		}
		else
		{
			// Just log it out for now
			this.log.trace(`PICT Content GET ELEMENT for [${pAddress}] will return empty because none of the browser methods are available`);
			return [];
		}
	}

	/**
	 * @param {string|HTMLElement} pAddress - The address of the element (a CSS selector), or the element itself.
	 * @param {string|boolean} pContent - The content to assign.
	 * @return {void}
	 */
	assignContent(pAddress, pContent)
	{
		if (this.customAssignFunction)
		{
			return this.customAssignFunction(pAddress, pContent);
		}
		else if (this.hasJquery)
		{
			// Get the element(s)
			//FIXME: this is silly, but it makes the type system happy - it picks a different overload for each case
			const tmpTargetElementSet = typeof pAddress === 'string' ? window.jQuery(pAddress) : window.jQuery(pAddress);

			for (let i = 0; i < tmpTargetElementSet.length; i++)
			{
				const tmpElement = tmpTargetElementSet[i];
				switch (tmpElement.tagName)
				{
					case 'INPUT':
						if (tmpElement instanceof HTMLInputElement && tmpElement.type == 'checkbox')
						{
							tmpElement.checked = Boolean(pContent);
						}
						/* falls through */
					case 'SELECT':
					case 'TEXTAREA':
						if (tmpElement instanceof HTMLInputElement || tmpElement instanceof HTMLSelectElement || tmpElement instanceof HTMLTextAreaElement)
						{
							tmpElement.value = String(pContent);
						}
						break;
					case 'SCRIPT':
						if (tmpElement instanceof HTMLScriptElement)
						{
							tmpElement.text = String(pContent);
						}
						break;
					default:
						tmpElement.innerHTML = String(pContent);
				}
			}
		}
		else if (this.inBrowser && this.hasDocument)
		{
			// Get the element(s)
			const tmpTargetElementSet = typeof pAddress === 'string' ? window.document.querySelectorAll(pAddress) : [ pAddress ];

			for (let i = 0; i < tmpTargetElementSet.length; i++)
			{
				const tmpElement = tmpTargetElementSet[i];
				switch (tmpTargetElementSet[i].tagName)
				{
					case 'INPUT':
						if (tmpElement instanceof HTMLInputElement && tmpElement.type == 'checkbox')
						{
							tmpElement.checked = Boolean(pContent);
						}
						/* falls through */
					case 'SELECT':
					case 'TEXTAREA':
						if (tmpElement instanceof HTMLInputElement || tmpElement instanceof HTMLSelectElement || tmpElement instanceof HTMLTextAreaElement)
						{
							tmpElement.value = String(pContent);
						}
						break;
					case 'SCRIPT':
						if (tmpElement instanceof HTMLScriptElement)
						{
							tmpElement.text = String(pContent);
						}
						break;
					default:
						tmpElement.innerHTML = String(pContent);
				}
			}
		}
		else
		{
			// Just log it out for now
			this.log.trace(`PICT Content ASSIGN to [${pAddress}]:`, pContent);
		}
	}

	/**
	 * Append content to an element.
	 *
	 * @param {string|HTMLElement} pAddress - The address of the element (a CSS selector), or the element itself.
	 * @param {string} pContent - The content to append.
	 */
	appendContent(pAddress, pContent)
	{
		if (this.customAppendFunction)
		{
			return this.customAppendFunction(pAddress, pContent);
		}
		else if (this.hasJquery)
		{
			//FIXME: this is silly, but it makes the type system happy - it picks a different overload for each case
			const tmpTargetElement = typeof pAddress === 'string' ? window.jQuery(pAddress) : window.jQuery(pAddress);
			tmpTargetElement.append(pContent);
		}
		else if (this.inBrowser && this.hasDocument)
		{
			const tmpTargetElementSet = typeof pAddress === 'string' ? window.document.querySelectorAll(pAddress) : [ pAddress ];
			for (let i = 0; i < tmpTargetElementSet.length; i++)
			{
				tmpTargetElementSet[i].insertAdjacentHTML("beforeend", pContent);
			}
		}
		else
		{
			// Just log it out for now -- nothing browser in our mix.
			this.log.trace(`PICT Content APPEND to [${pAddress}]:`, pContent);
		}
	}

	/**
	 * Insert content before an element. The new content will be a sibling of the target element.
	 *
	 * @param {string|HTMLElement} pBeforeAddress - The address of the element (a CSS selector), or the element itself.
	 * @param {string} pContent - The content to insert.
	 */
	insertContentBefore(pBeforeAddress, pContent)
	{
		if (this.customInsertBeforeFunction)
		{
			return this.customInsertBeforeFunction(pBeforeAddress, pContent);
		}
		else if (this.hasJquery)
		{
			window.jQuery(pContent).insertBefore(pBeforeAddress);
		}
		else if (this.inBrowser && this.hasDocument)
		{
			const tmpTargetElementSet = typeof pBeforeAddress === 'string' ? window.document.querySelectorAll(pBeforeAddress) : [ pBeforeAddress ];
			for (let i = 0; i < tmpTargetElementSet.length; i++)
			{
				tmpTargetElementSet[i].insertAdjacentHTML("beforebegin", pContent);
			}
		}
		else
		{
			// Just log it out for now -- nothing browser in our mix.
			this.log.trace(`PICT Content INSERT BEFORE [${pBeforeAddress}]:`, pContent);
		}
	}

	/**
	 * Insert content after an element. The new content will be a sibling of the target element.
	 *
	 * @param {string|HTMLElement} pAfterAddress - The address of the element (a CSS selector), or the element itself.
	 * @param {string} pContent - The content to insert.
	 */
	insertContentAfter(pAfterAddress, pContent)
	{
		if (this.customInsertAfterFunction)
		{
			return this.customInsertAfterFunction(pAfterAddress, pContent);
		}
		else if (this.hasJquery)
		{
			window.jQuery(pContent).insertAfter(pAfterAddress);
		}
		else if (this.inBrowser && this.hasDocument)
		{
			const tmpTargetElementSet = typeof pAfterAddress === 'string' ? window.document.querySelectorAll(pAfterAddress) : [ pAfterAddress ];
			for (let i = 0; i < tmpTargetElementSet.length; i++)
			{
				tmpTargetElementSet[i].insertAdjacentHTML("afterend", pContent);
			}
		}
		else
		{
			// Just log it out for now -- nothing browser in our mix.
			this.log.trace(`PICT Content INSERT AFTER [${pAfterAddress}]:`, pContent);
		}
	}

	/**
	 * Prepend content to an element.
	 *
	 * @param {string|HTMLElement} pAddress - The address of the element (a CSS selector), or the element itself.
	 * @param {string} pContent - The content to prepend.
	 */
	prependContent(pAddress, pContent)
	{
		if (this.customAppendFunction)
		{
			return this.customPrependFunction(pAddress, pContent);
		}
		else if (this.hasJquery)
		{
			//FIXME: this is silly, but it makes the type system happy - it picks a different overload for each case
			const tmpTargetElement = typeof pAddress === 'string' ? window.jQuery(pAddress) : window.jQuery(pAddress);
			tmpTargetElement.prepend(pContent);
		}
		else if (this.inBrowser && this.hasDocument)
		{
			const tmpTargetElementSet = typeof pAddress === 'string' ? window.document.querySelectorAll(pAddress) : [ pAddress ];
			for (let i = 0; i < tmpTargetElementSet.length; i++)
			{
				tmpTargetElementSet[i].insertAdjacentHTML("afterbegin", pContent);
			}
		}
		else
		{
			// Just log it out for now -- nothing browser in our mix.
			this.log.trace(`PICT Content PREPEND in [${pAddress}]:`, pContent);
		}
	}

	/**
	 * Project content into a destination address based on a render method -- as the views do.
	 * Valid render methods are:
	 * - append: Append the content to the destination address.
	 * - prepend: Prepend the content to the destination address.
	 * - append_once: Append the content to the destination address only if it doesn't already exist in the test address.
	 * - replace: Replace the content of the destination address with the new content.
	 * @param {string} pRenderMethod
	 * @param {string} pDestinationAddress
	 * @param {string} pContent
	 * @param {string} pTestAddress
	 * @returns Result of the content assignment.
	 */
	projectContent(pRenderMethod, pDestinationAddress, pContent, pTestAddress)
	{
		// Assign the content to the destination address
		switch(pRenderMethod)
		{
			case 'virtual-assignment':
				return this.manifest.setValueByHash(this.fable, pDestinationAddress, pContent);
			case 'append':
				return this.appendContent(pDestinationAddress, pContent);
			case 'prepend':
				return this.prependContent(pDestinationAddress, pContent);
			case 'append_once':
			{
				if (typeof(pTestAddress) == 'string' && pTestAddress.length > 0)
				{
					let tmpExistingContent = this.getElement(pTestAddress);
					if (tmpExistingContent.length < 1)
					{
						return this.appendContent(pDestinationAddress, pContent);
					}
					break;
				}
				// Without a test address, preserve the "once" guarantee by
				// treating a non-empty destination as "already populated."
				// (The previous fallback ran getElement on the destination
				// container itself, which virtually always exists, so
				// append_once silently became a no-op whenever TestAddress
				// was omitted.)
				let tmpDestinationContent = this.readContent(pDestinationAddress);
				if (tmpDestinationContent == null || String(tmpDestinationContent).trim() === '')
				{
					return this.appendContent(pDestinationAddress, pContent);
				}
				break;
			}
			case 'replace':
				// TODO: Should this be the default?
				/* falls through */
			default:
				return this.assignContent(pDestinationAddress, pContent);
		}
	}

	/**
	 * Read content from an element.
	 *
	 * @param {string|HTMLElement} pAddress - The address of the element (a CSS selector), or the element itself.
	 *
	 * TODO: return {boolean|string|number|string[]} - The content of the element.
	 * @return {string|boolean} - The content of the element.
	 */
	readContent(pAddress)
	{
		if (this.customReadFunction)
		{
			return this.customReadFunction(pAddress);
		}
		else if (this.hasJquery)
		{
			//FIXME: this is silly, but it makes the type system happy - it picks a different overload for each case
			const tmpTargetElement = typeof pAddress === 'string' ? window.jQuery(pAddress) : window.jQuery(pAddress);
			switch (tmpTargetElement.prop('tagName'))
				{
					case 'INPUT':
						if (tmpTargetElement.attr('type') == 'checkbox')
						{
							return tmpTargetElement.prop('checked');
						}
						/* falls through */
					case 'SELECT':
					case 'TEXTAREA':
					{
						//FIXME: masking types to simplify the expressed return value, for now
						/** @type {any} */
						const value = tmpTargetElement.val();
						return value;
					}
					case 'SCRIPT':
						return tmpTargetElement.text();
					default:
						return tmpTargetElement.html();
				}
		}
		else if (this.inBrowser && this.hasDocument)
		{
			let tmpTargetElementSet = typeof pAddress === 'string' ? window.document.querySelectorAll(pAddress) : [ pAddress ];
			if (tmpTargetElementSet.length < 1)
			{
				return null;
			}
			else if (tmpTargetElementSet.length == 1)
			{
				const tmpElement = tmpTargetElementSet[0];
				switch (tmpElement.tagName)
				{
					case 'INPUT':
						if (tmpElement instanceof HTMLInputElement && tmpElement.type == 'checkbox')
						{
							return tmpElement.checked;
						}
						/* falls through */
					case 'SELECT':
					case 'TEXTAREA':
						if (tmpElement instanceof HTMLInputElement || tmpElement instanceof HTMLSelectElement || tmpElement instanceof HTMLTextAreaElement)
						{
							return tmpElement.value;
						}
						/* falls through */
					case 'SCRIPT':
						if (tmpElement instanceof HTMLScriptElement)
						{
							return tmpElement.text;
						}
						/* falls through */
					default:
						return tmpElement.innerHTML;
				}
			}
		}
		else
		{
			// Just log it out for now -- nothing browser in our mix.
			this.log.trace(`PICT Content READ from [${pAddress}]...`);
			return '';
		}
	}

	/**
	 * Add a class to an element.
	 *
	 * @param {string|HTMLElement} pAddress - The address of the element (a CSS selector), or the element itself.
	 * @param {string|string[]} pClass - The class to add.
	 */
	addClass(pAddress, pClass)
	{
		if (this.customSetClassFunction)
		{
			return this.customSetClassFunction(pAddress, pClass);
		}
		else if (this.hasJquery)
		{
			// Get the element
			//FIXME: this is silly, but it makes the type system happy - it picks a different overload for each case
			const tmpTargetElement = typeof pAddress === 'string' ? window.jQuery(pAddress) : window.jQuery(pAddress);
			tmpTargetElement.addClass(pClass);
		}
		else if (this.inBrowser && this.hasDocument)
		{
			const tmpTargetElementSet = typeof pAddress === 'string' ? window.document.querySelectorAll(pAddress) : [ pAddress ];

			for (let i = 0; i < tmpTargetElementSet.length; i++)
			{
				if (Array.isArray(pClass))
				{
					for (const tmpClass of pClass)
					{
						tmpTargetElementSet[i].classList.add(tmpClass);
					}
				}
				else
				{
					tmpTargetElementSet[i].classList.add(pClass);
				}
			}
		}
		else
		{
			this.log.trace(`PICT Content ADDCLASS to [${pAddress}]:`, pClass);
		}
	}

	/**
	 * Remove a class from an element.
	 *
	 * @param {string|HTMLElement} pAddress - The address of the element (a CSS selector), or the element itself.
	 * @param {string|string[]} pClass - The class to remove.
	 */
	removeClass(pAddress, pClass)
	{
		if (this.customRemoveClassFunction)
		{
			return this.customRemoveClassFunction(pAddress, pClass);
		}
		else if (this.hasJquery)
		{
			// Get the element
			//FIXME: this is silly, but it makes the type system happy - it picks a different overload for each case
			const tmpTargetElement = typeof pAddress === 'string' ? window.jQuery(pAddress) : window.jQuery(pAddress);
			tmpTargetElement.removeClass(pClass);
		}
		else if (this.inBrowser && this.hasDocument)
		{
			const tmpTargetElementSet = typeof pAddress === 'string' ? window.document.querySelectorAll(pAddress) : [ pAddress ];

			for (let i = 0; i < tmpTargetElementSet.length; i++)
			{
				if (Array.isArray(pClass))
				{
					for (const tmpClass of pClass)
					{
						tmpTargetElementSet[i].classList.remove(tmpClass);
					}
				}
				else
				{
					tmpTargetElementSet[i].classList.remove(pClass);
				}
			}
		}
		else
		{
			this.log.trace(`PICT Content REMOVECLASS from [${pAddress}]:`, pClass);
		}
	}

	/**
	 * Read an attribute from an element.
	 *
	 * @param {string|HTMLElement} pAddress - The address of the element (a CSS selector), or the element itself.
	 * @param {string} pAttribute - The attribute name to read.
	 */
	readAttribute(pAddress, pAttribute)
	{
		if (this.customReadAttributeFunction)
		{
			return this.customReadAttributeFunction(pAddress, pAttribute);
		}
		else if (this.hasJquery)
		{
			//FIXME: this is silly, but it makes the type system happy - it picks a different overload for each case
			const tmpTargetElement = typeof pAddress === 'string' ? window.jQuery(pAddress) : window.jQuery(pAddress);
			return tmpTargetElement.attr(pAttribute);
		}
		else if (this.inBrowser && this.hasDocument)
		{
			const tmpTargetElementSet = typeof pAddress === 'string' ? window.document.querySelectorAll(pAddress) : [ pAddress ];

			for (let i = 0; i < tmpTargetElementSet.length; i++)
			{
				tmpTargetElementSet[i].getAttribute(pAttribute);
			}
			return tmpTargetElementSet;
		}
		else
		{
			this.log.trace(`PICT Content READATTRIBUTE from [${pAddress}]:`, pAttribute);
		}
	}

	/**
	 * Set an attribute on an element.
	 *
	 * @param {string|HTMLElement} pAddress - The address of the element (a CSS selector), or the element itself.
	 * @param {string} pAttribute - The attribute name to set.
	 * @param {string} pValue - The value to set.
	 */
	setAttribute(pAddress, pAttribute, pValue)
	{
		if (this.customSetAttributeFunction)
		{
			return this.customSetAttributeFunction(pAddress, pAttribute, pValue);
		}
		else if (this.hasJquery)
		{
			//FIXME: this is silly, but it makes the type system happy - it picks a different overload for each case
			const tmpTargetElement = typeof pAddress === 'string' ? window.jQuery(pAddress) : window.jQuery(pAddress);
			tmpTargetElement.attr(pAttribute, pValue);
		}
		else if (this.inBrowser && this.hasDocument)
		{
			const tmpTargetElementSet = typeof pAddress === 'string' ? window.document.querySelectorAll(pAddress) : [ pAddress ];

			for (let i = 0; i < tmpTargetElementSet.length; i++)
			{
				tmpTargetElementSet[i].setAttribute(pAttribute, pValue);
			}
		}
		else
		{
			this.log.trace(`PICT Content SETATTRIBUTE for [${pAddress}] ATTRIBUTE [${pAttribute}]:`, pValue);
		}
	}

	/**
	 * Remove an attribute from an element.
	 *
	 * @param {string|HTMLElement} pAddress - The address of the element (a CSS selector), or the element itself.
	 * @param {string} pAttribute - The attribute name to remove.
	 */
	removeAttribute(pAddress, pAttribute)
	{
		if (this.customRemoveAttributeFunction)
		{
			return this.customRemoveAttributeFunction(pAddress, pAttribute);
		}
		else if (this.hasJquery)
		{
			//FIXME: this is silly, but it makes the type system happy - it picks a different overload for each case
			const tmpTargetElement = typeof pAddress === 'string' ? window.jQuery(pAddress) : window.jQuery(pAddress);
			tmpTargetElement.removeAttr(pAttribute);
		}
		else if (this.inBrowser && this.hasDocument)
		{
			const tmpTargetElementSet = typeof pAddress === 'string' ? window.document.querySelectorAll(pAddress) : [ pAddress ];

			for (let i = 0; i < tmpTargetElementSet.length; i++)
			{
				tmpTargetElementSet[i].removeAttribute(pAttribute);
			}
		}
		else
		{
			this.log.trace(`PICT Content REMOVEATTRIBUTE for [${pAddress}] ATTRIBUTE [${pAttribute}]`);
		}
	}

	/**
	 * Check if an element has a class.
	 *
	 * @param {string|HTMLElement} pAddress - The address of the element (a CSS selector), or the element itself.
	 * @param {string} pClass - The class to toggle.
	 *
	 * @return {boolean} - Whether the element has the class. If multiple elements are matched, returns true if any have the class.
	 */
	hasClass(pAddress, pClass)
	{
		if (this.customReadClassFunction)
		{
			return this.customReadClassFunction(pAddress, pClass);
		}
		if (this.hasJquery)
		{
			//FIXME: this is silly, but it makes the type system happy - it picks a different overload for each case
			const tmpTargetElement = typeof pAddress === 'string' ? window.jQuery(pAddress) : window.jQuery(pAddress);
			return tmpTargetElement.hasClass(pClass);
		}
		else if (this.inBrowser && this.hasDocument)
		{
			const tmpTargetElementSet = typeof pAddress === 'string' ? window.document.querySelectorAll(pAddress) : [ pAddress ];

			for (let i = 0; i < tmpTargetElementSet.length; i++)
			{
				if (tmpTargetElementSet[i].classList.contains(pClass))
				{
					return true;
				}
			}
			return false;
		}
		else
		{
			this.log.trace(`PICT Content HASCLASS for [${pAddress}] CLASS [${pClass}]:`);
			return false;
		}
	}

	/**
	 * Toggle a class on or off an element
	 *
	 * @param {string|HTMLElement} pAddress - The address of the element (a CSS selector), or the element itself.
	 * @param {string} pClass - The class to check for.
	 */
	toggleClass(pAddress, pClass)
	{
		if (this.hasClass(pAddress, pClass))
		{
			this.removeClass(pAddress, pClass);
		}
		else
		{
			this.addClass(pAddress, pClass);
		}
	}
}

module.exports = PictContentAssignment;

},{"fable":68}],197:[function(require,module,exports){
const libFableServiceBase = require('fable').ServiceProviderBase;

class PictDataProvider extends libFableServiceBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('fable') & import('./Pict')} */
		this.fable;

		this.serviceType = 'PictDataProvider';
	}

	/**
	 * @param {string} pAddress - The address of the data to retrieve
	 * @param {object} [pData] - (optional) The record to provide to the address resolver
	 */
	getDataByAddress(pAddress, pData)
	{
		let tmpData = (typeof(pData) === 'undefined') ? {} : pData;

		const tmpAddressSpace =
		{
			Fable: this.fable,
			Pict: this.fable,
			AppData: this.fable.AppData,
			Bundle: this.fable.Bundle,
			Record: tmpData,
		};
		return this.fable.manifest.getValueByHash(tmpAddressSpace, pAddress);
	}
}

module.exports = PictDataProvider;

},{"fable":68}],198:[function(require,module,exports){
const libFableServiceBase = require('fable').ServiceProviderBase;

class PictMeadowEntityProvider extends libFableServiceBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.options;
		/** @type {import('./Pict') & { settings: any } & { newAnticipate: any }} */
		this.fable;
		/** @type {any} */
		this.log;

		this.serviceType = 'PictMeadowProvider';

		if (this.fable.settings.PictDefaultURLPrefix)
		{
			this.options.urlPrefix = this.fable.settings.PictDefaultURLPrefix;
		}
		else if (!this.options.urlPrefix)
		{
			this.options.urlPrefix = '/1.0/';
		}

		if (!this.options.downloadBatchSize)
		{
			if (typeof this.fable.settings.PictDefaultDownloadBatchSize === 'number')
			{
				this.options.downloadBatchSize = this.fable.settings.PictDefaultDownloadBatchSize;
			}
			else
			{
				this.options.downloadBatchSize = 100;
			}
		}

		if (typeof this.options.downloadPageConcurrency !== 'number')
		{
			this.options.downloadPageConcurrency = (typeof this.fable.settings.PictDefaultDownloadPageConcurrency === 'number')
				? this.fable.settings.PictDefaultDownloadPageConcurrency
				: 4;
		}

		if (typeof this.options.maxBundleConcurrency !== 'number')
		{
			this.options.maxBundleConcurrency = (typeof this.fable.settings.PictDefaultMaxBundleConcurrency === 'number')
				? this.fable.settings.PictDefaultMaxBundleConcurrency
				: 8;
		}

		//@ts-ignore - FIXME - remove once we have fable types
		this.restClient = this.fable.RestClient ?? this.fable.instantiateServiceProviderWithoutRegistration('RestClient');

		/** @type {Record<string, import('cachetrax')>} */
		this.recordCache = {};
		/** @type {Record<string, import('cachetrax')>} */
		this.recordSetCache = {};

		this.entityColumnTranslations = (
			{
				CreatingIDUser: 'User',
				UpdatingIDUser: 'User',
				DeletingIDUser: 'User'
			});

		/** @type {(pOptions: Record<string, any>) => Record<string, any>} */
		this.prepareRequestOptions = (pOptions) => { return pOptions; };

		/**
		 * After buildBundleWaves() is called by gatherDataFromServer(), this
		 * property holds the computed wave schedule for inspection/debugging.
		 * @type {Array<Array<{Index: number, Step: Record<string, any>}>>|null}
		 */
		this.lastBundleWaves = null;
	}

	/**
	 * @param {string} pEntity - The name of the entity to initialize the cache for
	 */
	initializeCache(pEntity)
	{
		// This should not be happening as often as it's happening.
		if (!(pEntity in this.recordCache))
		{
			//@ts-ignore - FIXME - remove once we have fable types
			this.recordCache[pEntity] = this.fable.instantiateServiceProviderWithoutRegistration('ObjectCache');
			// TODO: Make this a configuration?
			// For now cache for 30 seconds.
			this.recordCache[pEntity].maxAge = 30000;
			this.recordCache[pEntity].maxLength = 10000;

			this.fable.Bundle[pEntity] = this.recordCache[pEntity].RecordMap;
		}
		// This should not be happening as often as it's happening.
		if (!(pEntity in this.recordSetCache))
		{
			//@ts-ignore - FIXME - remove once we have fable types
			this.recordSetCache[pEntity] = this.fable.instantiateServiceProviderWithoutRegistration('ObjectCache');
			// TODO: Make this a configuration?
			// For now cache for 10 seconds.
			this.recordSetCache[pEntity].maxAge = 10000;
			this.recordSetCache[pEntity].maxLength = 100;
		}
	}

	/**
	 * @param {object} pEntityInformation - The entity information object.
	 * @param {object} pContext - The context object to use when parsing the filter template and assigning the results to the destination.
	 * @param {() => void} fCallback - The callback function to call when the operation is complete, which should take an optional error as its first parameter.
	 */
	gatherEntitySetCount(pEntityInformation, pContext, fCallback)
	{
		pEntityInformation.CountOnly = true;
		return this.gatherEntitySet(pEntityInformation, pContext, fCallback);
	}

	/**
	 * @param {Record<string, any>} pEntityInformation - The entity information object.
	 * @param {Record<string, any>} pContext - The context object to use when parsing the filter template and assigning the results to the destination.
	 * @param {(pError?: Error) => void} fCallback - The callback function to call when the operation is complete, which should take an optional error as its first parameter and the record set or count as its second parameter.
	 */
	gatherEntitySet(pEntityInformation, pContext, fCallback)
	{
		// First sanity check the pEntityInformation
		if (!('Entity' in pEntityInformation) || (typeof(pEntityInformation.Entity) != 'string'))
		{
			this.log.warn(`EntityBundleRequest failed to parse entity request because the entity stanza did not contain an Entity string.`);
			return fCallback();
		}
		if (!('Destination' in pEntityInformation) || (typeof(pEntityInformation.Destination) != 'string'))
		{
			this.log.warn(`EntityBundleRequest failed to parse entity request because the entity stanza did not contain a Destination string.`);
			return fCallback();
		}
		if (!('Filter' in pEntityInformation) || (typeof(pEntityInformation.Filter) != 'string'))
		{
			pEntityInformation.Filter = '';
		}
		if (!('FilterData' in pEntityInformation) || (typeof(pEntityInformation.FilterData) != 'object'))
		{
			pEntityInformation.FilterData = {};
		}
		pContext.StepData = pEntityInformation.FilterData;
		if (!('RecordStartCursor' in pEntityInformation) || (typeof(pEntityInformation.RecordStartCursor) != 'number'))
		{
			pEntityInformation.RecordStartCursor = 0;
		}
		//TODO: consider ChunkSize for cases when AllRecords is set and we want to control the to-server page size
		if (!('PageSize' in pEntityInformation) || (typeof(pEntityInformation.PageSize) != 'number'))
		{
			//TODO: this is a safety measure to try and not break things when we release this pict version; should be a lower value
			pEntityInformation.PageSize = 10000;
		}
		if (!('AllRecords' in pEntityInformation) || (typeof(pEntityInformation.AllRecords) != 'boolean'))
		{
			pEntityInformation.AllRecords = false;
		}

		let tmpRecordStartCursor = null;
		let tmpPageSize = null;
		if (pEntityInformation.PageSize)
		{
			tmpRecordStartCursor = pEntityInformation.RecordStartCursor;
			tmpPageSize = pEntityInformation.PageSize;
		}
		// Parse the filter template
		const tmpFilterString = this.fable.parseTemplate(pEntityInformation.Filter, pContext);

		// Create a callback function to handle receiving the record set
		const fRecordFetchComplete = (pError, pRecordSet) =>
		{
			if (pError)
			{
				this.log.error(`EntityBundleRequest request Error getting entity set for [${pEntityInformation.Entity}] with filter [${tmpFilterString}]: ${pError}`, pError);
				return fCallback(pError);
			}

			if (pEntityInformation.CountOnly)
			{
				this.log.trace(`EntityBundleRequest counted ${pRecordSet} records for ${pEntityInformation.Entity} filtered to [${tmpFilterString}]${!pEntityInformation.CountOnly && !pEntityInformation.AllRecords ? ` [${tmpRecordStartCursor}/${tmpPageSize}]` : ''}`);

				this.fable.manifest.setValueByHash(pContext, pEntityInformation.Destination, pRecordSet);
			}
			// Now assign it back to the destination; because this is not view specific it doesn't use the manifests from them (to deal with scope overlap with subgrids).
			else if (pEntityInformation.SingleRecord)
			{
				this.log.trace(`EntityBundleRequest found ${pRecordSet.length} records for ${pEntityInformation.Entity} filtered to [${tmpFilterString}]${!pEntityInformation.CountOnly && !pEntityInformation.AllRecords ? ` [${tmpRecordStartCursor}/${tmpPageSize}]` : ''}`);

				if (pRecordSet.length > 1)
				{
					this.log.warn(`EntityBundleRequest found more than one record for ${pEntityInformation.Entity} filtered to [${tmpFilterString}] but SingleRecord is true; setting the first record.`);
				}
				if (pRecordSet.length < 1)
				{
					this.fable.manifest.setValueByHash(pContext, pEntityInformation.Destination, false);
				}
				this.fable.manifest.setValueByHash(pContext, pEntityInformation.Destination, pRecordSet[0]);
			}
			else
			{
				this.log.trace(`EntityBundleRequest found ${pRecordSet.length} records for ${pEntityInformation.Entity} filtered to [${tmpFilterString}]${!pEntityInformation.CountOnly && !pEntityInformation.AllRecords ? ` [${tmpRecordStartCursor}/${tmpPageSize}]` : ''}`);

				this.fable.manifest.setValueByHash(pContext, pEntityInformation.Destination, pRecordSet);
			}

			return fCallback();
		};
		if (pEntityInformation.CountOnly)
		{
			this.getEntitySetRecordCount(pEntityInformation.Entity, tmpFilterString, fRecordFetchComplete, pEntityInformation.Postfix);
		}
		else if (tmpPageSize && !pEntityInformation.AllRecords)
		{
			this.getEntitySetPage(pEntityInformation.Entity, tmpFilterString, tmpRecordStartCursor, tmpPageSize, fRecordFetchComplete, pEntityInformation.Postfix);
		}
		else
		{
			this.getEntitySet(pEntityInformation.Entity, tmpFilterString, fRecordFetchComplete, pEntityInformation.Postfix, pEntityInformation);
		}
	}

	/**
	 * @param {Record<string, any>} pDestinationEntity - The destination entity to map the join results to.
	 * @param {Record<string, any>} pCustomRequestInformation - The custom request information object.
	 * @param {Record<string, any>} pContext - The context object to use when parsing templates and resolving addresses.
	 */
	mapJoinSingleDestination(pDestinationEntity, pCustomRequestInformation, pContext)
	{
		const tmpSourceEntities = this.fable.manifest.getValueByHash(pContext, pCustomRequestInformation.JoinRecordSetAddress);
		if (!Array.isArray(tmpSourceEntities))
		{
			throw new Error(`EntityBundleRequest failed to map join because the source [${pCustomRequestInformation.JoinRecordSetAddress}] did not return an array.`);
		}

		const tmpSourceLookup = {};
		for (const tmpSourceEntity of tmpSourceEntities)
		{
			const tmpSourceJoinValue = tmpSourceEntity[pCustomRequestInformation.JoinValue];
			tmpSourceLookup[tmpSourceJoinValue] = tmpSourceEntity;
		}

		for (const tmpSourceEntity of tmpSourceEntities)
		{
			if (!tmpSourceEntity)
			{
				this.log.error(`EntityBundleRequest failed to map join because the source entity was not found in the source lookup.`);
				continue;
			}
			if (pCustomRequestInformation.BucketBy || pCustomRequestInformation.BucketByTemplate)
			{
				const tmpBucketValues = [];
				if (pCustomRequestInformation.BucketBy)
				{
					const tmpBucketByKeys = Array.isArray(pCustomRequestInformation.BucketBy) ? pCustomRequestInformation.BucketBy : [pCustomRequestInformation.BucketBy];
					for (const tmpBucketByKey of tmpBucketByKeys)
					{
						const tmpBucketValue = this.fable.manifest.getValueByHash(tmpSourceEntity, tmpBucketByKey);
						tmpBucketValues.push(tmpBucketValue);
					}
				}
				else
				{
					const tmpBucketByTemplates = Array.isArray(pCustomRequestInformation.BucketByTemplate) ? pCustomRequestInformation.BucketByTemplate : [pCustomRequestInformation.BucketByTemplate];
					for (const tmpBucketByTemplate of tmpBucketByTemplates)
					{
						const tmpBucketValue = this.fable.parseTemplate(tmpBucketByTemplate, tmpSourceEntity);
						if (tmpBucketValue)
						{
							tmpBucketValues.push(tmpBucketValue);
						}
					}
				}
				if (tmpBucketValues.length < 1)
				{
					if (this.fable.LogNoisiness > 0)
					{
						this.log.warn(`EntityBundleRequest failed to map join because no bucket values were found.`, { pCustomRequestInformation, tmpSourceEntity });
					}
				}
				else
				{
					const tmpBucketAddress = `${pCustomRequestInformation.RecordDestinationAddress}.${tmpBucketValues.join('.')}`;
					if (pCustomRequestInformation.SingleRecord)
					{
						//TODO: warn if there is a collision?
						this.fable.manifest.setValueByHash(pDestinationEntity, tmpBucketAddress, tmpSourceEntity);
					}
					else
					{
						let tmpBucketArray = this.fable.manifest.getValueByHash(pDestinationEntity, tmpBucketAddress, tmpSourceEntity);
						if (!tmpBucketArray)
						{
							tmpBucketArray = [];
							this.fable.manifest.setValueByHash(pDestinationEntity, tmpBucketAddress, tmpBucketArray);
						}
						tmpBucketArray.push(tmpSourceEntity);
					}
				}
			}
			else if (pCustomRequestInformation.SingleRecord)
			{
				if (pDestinationEntity[pCustomRequestInformation.RecordDestinationAddress] && this.fable.LogNoisiness > 1)
				{
					this.fable.log.warn(`EntityBundleRequest found more than one record for [${pCustomRequestInformation.RecordDestinationAddress}] in mapJoin mapped as SingleRecord.`);
				}
				pDestinationEntity[pCustomRequestInformation.RecordDestinationAddress] = tmpSourceEntity;
			}
			else
			{
				pDestinationEntity[pCustomRequestInformation.RecordDestinationAddress] = pDestinationEntity[pCustomRequestInformation.RecordDestinationAddress] || [];
				pDestinationEntity[pCustomRequestInformation.RecordDestinationAddress].push(tmpSourceEntity);
			}
		}
		return [pDestinationEntity];
	}

	/**
	 * @param {Record<string, any>} pCustomRequestInformation - The custom request information object.
	 * @param {Record<string, any>} pContext - The context object to use when parsing templates and resolving addresses.
	 */
	mapJoin(pCustomRequestInformation, pContext)
	{
		const tmpSingleDestinationEntity = pCustomRequestInformation.DestinationRecordAddress ? this.fable.manifest.getValueByHash(pContext, pCustomRequestInformation.DestinationRecordAddress) : null;
		const tmpDestinationEntities = pCustomRequestInformation.DestinationRecordSetAddress ? this.fable.manifest.getValueByHash(pContext, pCustomRequestInformation.DestinationRecordSetAddress) : null;
		if (!Array.isArray(tmpDestinationEntities) && !tmpSingleDestinationEntity)
		{
			throw new Error(`EntityBundleRequest failed to map join because the destination [${pCustomRequestInformation.DestinationRecordSetAddress}] did not return an array.`);
		}
		if (tmpSingleDestinationEntity)
		{
			return this.mapJoinSingleDestination(tmpSingleDestinationEntity, pCustomRequestInformation, pContext);
		}

		const tmpJoinEntities = this.fable.manifest.getValueByHash(pContext, pCustomRequestInformation.Joins);
		if (!Array.isArray(tmpJoinEntities))
		{
			throw new Error(`EntityBundleRequest failed to map join because the join [${pCustomRequestInformation.Joins}] did not return an array.`);
		}
		const tmpSourceEntities = this.fable.manifest.getValueByHash(pContext, pCustomRequestInformation.JoinRecordSetAddress);
		if (!Array.isArray(tmpSourceEntities))
		{
			throw new Error(`EntityBundleRequest failed to map join because the source [${pCustomRequestInformation.JoinRecordSetAddress}] did not return an array.`);
		}

		const tmpLHSJoinKey = pCustomRequestInformation.JoinJoinValueLHS || pCustomRequestInformation.DestinationJoinValue;
		const tmpRHSJoinKey = pCustomRequestInformation.JoinJoinValueRHS || pCustomRequestInformation.JoinValue;
		const tmpDestinationLookup = {};
		const tmpSourceLookup = {};
		const tmpJoinMap = {};
		for (const tmpDestinationEntity of tmpDestinationEntities || [])
		{
			const tmpDestinationJoinValue = tmpDestinationEntity[pCustomRequestInformation.DestinationJoinValue];
			tmpDestinationLookup[tmpDestinationJoinValue] = tmpDestinationEntity;
		}
		for (const tmpSourceEntity of tmpSourceEntities)
		{
			const tmpSourceJoinValue = tmpSourceEntity[pCustomRequestInformation.JoinValue];
			tmpSourceLookup[tmpSourceJoinValue] = tmpSourceEntity;
		}

		for (const tmpJoinEntity of tmpJoinEntities)
		{
			const tmpLHSJoinValue = tmpJoinEntity[tmpLHSJoinKey];
			const tmpRHSJoinValue = tmpJoinEntity[tmpRHSJoinKey];
			tmpJoinMap[tmpLHSJoinValue] = tmpJoinMap[tmpLHSJoinValue] || new Set();
			tmpJoinMap[tmpLHSJoinValue].add(tmpRHSJoinValue);
		}

		for (const tmpLHSJoinValue of Object.keys(tmpJoinMap))
		{
			const tmpRHSJoinValues = Array.from(tmpJoinMap[tmpLHSJoinValue]);
			const tmpDestinationEntity = tmpDestinationLookup[tmpLHSJoinValue];
			if (!tmpDestinationEntity)
			{
				this.log.error(`EntityBundleRequest failed to map join because the LHS join value [${tmpLHSJoinValue}] was not found in the destination lookup.`);
				continue;
			}
			for (const tmpRHSJoinValue of tmpRHSJoinValues)
			{
				const tmpSourceEntity = tmpSourceLookup[tmpRHSJoinValue];
				if (!tmpSourceEntity)
				{
					this.log.error(`EntityBundleRequest failed to map join because the RHS join value [${tmpRHSJoinValue}] was not found in the source lookup.`);
					continue;
				}
				if (pCustomRequestInformation.BucketBy || pCustomRequestInformation.BucketByTemplate)
				{
					const tmpBucketValues = [];
					if (pCustomRequestInformation.BucketBy)
					{
						const tmpBucketByKeys = Array.isArray(pCustomRequestInformation.BucketBy) ? pCustomRequestInformation.BucketBy : [pCustomRequestInformation.BucketBy];
						for (const tmpBucketByKey of tmpBucketByKeys)
						{
							const tmpBucketValue = this.fable.manifest.getValueByHash(tmpSourceEntity, tmpBucketByKey);
							tmpBucketValues.push(tmpBucketValue);
						}
					}
					else
					{
						const tmpBucketByTemplates = Array.isArray(pCustomRequestInformation.BucketByTemplate) ? pCustomRequestInformation.BucketByTemplate : [pCustomRequestInformation.BucketByTemplate];
						for (const tmpBucketByTemplate of tmpBucketByTemplates)
						{
							const tmpBucketValue = this.fable.parseTemplate(tmpBucketByTemplate, tmpSourceEntity);
							tmpBucketValues.push(tmpBucketValue);
						}
					}
					if (!tmpDestinationEntity[pCustomRequestInformation.RecordDestinationAddress])
					{
						tmpDestinationEntity[pCustomRequestInformation.RecordDestinationAddress] = {};
					}
					const tmpBucketAddress = `${pCustomRequestInformation.RecordDestinationAddress}.${tmpBucketValues.join('.')}`;
					if (pCustomRequestInformation.SingleRecord)
					{
						//TODO: warn if there is a collision?
						this.fable.manifest.setValueByHash(tmpDestinationEntity, tmpBucketAddress, tmpSourceEntity);
					}
					else
					{
						let tmpBucketArray = this.fable.manifest.getValueByHash(tmpDestinationEntity, tmpBucketAddress, tmpSourceEntity);
						if (!tmpBucketArray)
						{
							tmpBucketArray = [];
							this.fable.manifest.setValueByHash(tmpDestinationEntity, tmpBucketAddress, tmpBucketArray);
						}
						tmpBucketArray.push(tmpSourceEntity);
					}
				}
				else if (pCustomRequestInformation.SingleRecord)
				{
					if (tmpDestinationEntity[pCustomRequestInformation.RecordDestinationAddress] && this.fable.LogNoisiness > 1)
					{
						this.fable.log.warn(`EntityBundleRequest found more than one record for [${pCustomRequestInformation.RecordDestinationAddress}] in mapJoin mapped as SingleRecord.`);
					}
					tmpDestinationEntity[pCustomRequestInformation.RecordDestinationAddress] = tmpSourceEntity;
				}
				else
				{
					tmpDestinationEntity[pCustomRequestInformation.RecordDestinationAddress] = tmpDestinationEntity[pCustomRequestInformation.RecordDestinationAddress] || [];
					tmpDestinationEntity[pCustomRequestInformation.RecordDestinationAddress].push(tmpSourceEntity);
				}
			}
		}
		return tmpDestinationEntities;
	}

	/**
	 * ExampleConfig:
	 * {
	 *      "InputRecordsetAddress": "AppData.DocumentData.ReportData.Observations[]<<~?ObservationType,==,WalbecNDTRollerTests?~>>",
	 *      "OutputRecordsetAddress": "AppData.DocumentData.ReportData.FormData.ADDTests",
	 * 		"OutputRecordsetAddressMapping":
	 *      {
	 * 			"InputRecord.Tags[],AnyContains,HR": "AppData.DocumentData.ReportData.FormData.HRTests",
	 * 			"InputRecord.Tags[],AnyContains,CR": "AppData.DocumentData.ReportData.FormData.CRTests",
	 * 			"InputRecord.Tags[],AnyContains,IR": "AppData.DocumentData.ReportData.FormData.IRTests"
	 *      },
	 * 		"RecordPrototypeAddress": "OutputRecordSet[]<<~?IDObservation,==,{~D:InputRecord.IDObservation~}?~>>",
	 * 		"RecordFieldMapping":
	 *      {
	 * 			"AppData.DocumentData.ReportData.FormData.HRTests":
	 *          {
	 *               "InputRecord.Details.WalbecNDTRollerTests[0].Datum.MaterialTemperature": "OutputRecord.Temp",
	 *               "InputRecord.Details.WalbecNDTRollerTests[0].Datum.PercentDensity": "OutputRecord.Density",
	 *               "InputRecord.Details.WalbecNDTRollerTests[0].Datum.Offset": "OutputRecord.Offset",
	 *               "InputRecord.IDObservation": "OutputRecord.IDObservation"
	 *          },
	 * 			"AppData.DocumentData.ReportData.FormData.CRTests":
	 *          {
	 *               "InputRecord.Details.WalbecNDTRollerTests[0].Datum.MaterialTemperature": "OutputRecord.CRTemp",
	 *               "InputRecord.Details.WalbecNDTRollerTests[0].Datum.PercentDensity": "OutputRecord.CRDensity",
	 *               "InputRecord.Details.WalbecNDTRollerTests[0].Datum.Offset": "OutputRecord.CROffset",
	 *               "InputRecord.IDObservation": "OutputRecord.IDObservation"
	 *          },
	 * 			"AppData.DocumentData.ReportData.FormData.IRTests":
	 *          {
	 *               "InputRecord.Details.WalbecNDTRollerTests[0].Datum.MaterialTemperature": "OutputRecord.IRTemp",
	 *               "InputRecord.Details.WalbecNDTRollerTests[0].Datum.PercentDensity": "OutputRecord.IRDensity",
	 *               "InputRecord.Details.WalbecNDTRollerTests[0].Datum.Offset": "OutputRecord.IROffset",
	 *               "InputRecord.IDObservation": "OutputRecord.IDObservation"
	 *          },
	 *          "Default":
	 *          {
	 *               "InputRecord.Details.WalbecNDTRollerTests[0].Datum.MaterialTemperature": "OutputRecord.ADDTemp",
	 *               "InputRecord.Details.WalbecNDTRollerTests[0].Datum.PercentDensity": "OutputRecord.ADDDensity",
	 *               "InputRecord.Details.WalbecNDTRollerTests[0].Datum.Offset": "OutputRecord.ADDOffset",
	 *               "InputRecord.IDObservation": "OutputRecord.IDObservation"
	 *          }
	 *      }
	 * }
	 *
	 * @param {Record<string, any>} pConfiguration - The configuration object for the dataset projection.
	 * @param {Record<string, any>} pContext - The context object to use when parsing the record prototype template and resolving the output recordset address mapping.
	 */
	projectDataset(pConfiguration, pContext)
	{
		let tmpInputRecordset = this.fable.manifest.getValueByHash(pContext, pConfiguration.InputRecordsetAddress);
		if (typeof tmpInputRecordset == null || typeof tmpInputRecordset !== 'object')
		{
			throw new Error(`EntityBundleRequest failed to project dataset because the input recordset [${pConfiguration.InputRecordsetAddress}] did not return an valid object.`);
		}
		if (!Array.isArray(tmpInputRecordset))
		{
			tmpInputRecordset = [ tmpInputRecordset ];
		}
		let tmpDefaultOutputRecordset = this.fable.manifest.getValueByHash(pContext, pConfiguration.OutputRecordsetAddress);
		if (!tmpDefaultOutputRecordset)
		{
			tmpDefaultOutputRecordset = [];
			this.fable.manifest.setValueByHash(pContext, pConfiguration.OutputRecordsetAddress, tmpDefaultOutputRecordset);
		}
		for (const tmpInputRecord of tmpInputRecordset)
		{
			let tmpOutputRecordset = tmpDefaultOutputRecordset;
			let tmpOutputRecordsetAddressOverride;
			if (typeof pConfiguration.OutputRecordsetAddressMapping === 'object')
			{
				tmpOutputRecordsetAddressOverride = this._resolveOutputRecordsetAddressMapping(pConfiguration, pContext, tmpInputRecord);
				if (tmpOutputRecordsetAddressOverride)
				{
					tmpOutputRecordset = this.fable.manifest.getValueByHash(pContext, tmpOutputRecordsetAddressOverride);
					if (!tmpOutputRecordset)
					{
						tmpOutputRecordset = [];
						this.fable.manifest.setValueByHash(pContext, tmpOutputRecordsetAddressOverride, tmpOutputRecordset);
					}
				}
				if (!tmpOutputRecordset || !Array.isArray(tmpOutputRecordset))
				{
					tmpOutputRecordset = tmpDefaultOutputRecordset;
				}
			}
			const tmpPrototypeAddress = this.fable.parseTemplate(pConfiguration.RecordPrototypeAddress, Object.assign({ InputRecord: tmpInputRecord }, pContext));
			const tmpRecordPrototype = this.fable.manifest.getValueByHash(Object.assign({ InputRecord: tmpInputRecord, OutputRecordset: tmpOutputRecordset }, pContext), tmpPrototypeAddress);
			let tmpOutputRecord = { };
			if (Array.isArray(tmpRecordPrototype) && tmpRecordPrototype.length > 0)
			{
				tmpOutputRecord = tmpRecordPrototype[0];
			}
			else
			{
				tmpOutputRecordset.push(tmpOutputRecord);
			}
			let tmpRecordFieldMapping = pConfiguration.RecordFieldMapping[tmpOutputRecordsetAddressOverride] || pConfiguration.RecordFieldMapping.Default;
			if (!tmpRecordFieldMapping)
			{
				tmpRecordFieldMapping = pConfiguration.RecordFieldMapping[Object.keys(pConfiguration.RecordFieldMapping)[0]];
			}
			if (!tmpRecordFieldMapping)
			{
				throw new Error(`EntityBundleRequest failed to project dataset because the record field mapping for [${tmpOutputRecordsetAddressOverride}] did not return a mapping.`);
			}
			for (const tmpInputFieldAddress of Object.keys(tmpRecordFieldMapping))
			{
				const tmpOutputFieldAddress = tmpRecordFieldMapping[tmpInputFieldAddress];
				const tmpInputFieldValue = this.fable.manifest.getValueByHash(Object.assign({ InputRecord: tmpInputRecord }, pContext), tmpInputFieldAddress);
				this.fable.manifest.setValueByHash(Object.assign({ OutputRecord: tmpOutputRecord }, pContext), tmpOutputFieldAddress, tmpInputFieldValue);
			}
		}
	}

	/**
	 * @param {Record<string, any>} pConfiguration - The configuration object for the dataset projection.
	 * @param {Record<string, any>} pContext - The context object to use when resolving the output recordset address mapping.
	 * @param {Record<string, any>} pInputRecord - The input record to use when resolving the output recordset address mapping.
	 *
	 * @return {string|null} - The resolved output recordset address, or null if no mapping was found.
	 */
	_resolveOutputRecordsetAddressMapping(pConfiguration, pContext, pInputRecord)
	{
		const tmpAddressSpace = Object.assign({ InputRecord: pInputRecord }, pContext);
		for (const tmpRule of Object.keys(pConfiguration.OutputRecordsetAddressMapping))
		{
			const [ tmpLHSAddress, tmpOperator, tmpMatchValue ] = tmpRule.split(',');
			const tmpLHS = this.fable.manifest.getValueByHash(tmpAddressSpace, tmpLHSAddress);
			if (!tmpLHS)
			{
				if (this.fable.LogNoisiness > 0)
				{
					this.log.warn(`EntityBundleRequest failed to project dataset because the LHS address [${tmpLHSAddress}] did not return a value.`);
				}
				continue;
			}
			switch (tmpOperator)
			{
				case 'AnyContains':
					if (!Array.isArray(tmpLHS))
					{
						//TODO: consider making this use objects as well?
						this.log.error(`EntityBundleRequest failed to project dataset because the LHS address [${tmpLHSAddress}] did not return an array.`);
						continue;
					}
					for (const tmpLHSValue of tmpLHS)
					{
						if (String(tmpLHSValue).includes(tmpMatchValue))
						{
							return pConfiguration.OutputRecordsetAddressMapping[tmpRule];
						}
					}
			}
		}
		return null;
	}

	/**
	 * @param {Record<string, any>} pCustomRequestInformation - The custom request information object.
	 * @param {Record<string, any>} pContext - The context object to use when parsing templates and resolving addresses.
	 * @param {(pError?: Error) => void} fCallback - The callback function to call when the operation is complete, which should take an optional error as its first parameter and the data set as its second parameter.
	 */
	gatherCustomDataSet(pCustomRequestInformation, pContext, fCallback)
	{
		// First sanity check the pCustomRequestInformation
		if (!('URL' in pCustomRequestInformation) || (typeof(pCustomRequestInformation.URL) != 'string'))
		{
			this.log.warn(`EntityBundleRequest failed to parse custom data request because the stanza did not contain a URL string.`);
			return fCallback();
		}
		if (!('URLData' in pCustomRequestInformation) || (typeof(pCustomRequestInformation.URLData) != 'object'))
		{
			pCustomRequestInformation.URLData = {};
		}
		pContext.StepData = pCustomRequestInformation.URLData;
		// Parse the filter template
		const tmpURLTemplateString = this.fable.parseTemplate(pCustomRequestInformation.URL, pContext);
		if (tmpURLTemplateString == '')
		{
			// We may want to continue, but for now let's say nah and nope out.
			this.log.warn(`EntityBundleRequest failed to parse custom data request because the entity Filter did not return a string for FilterBy`)
		}

		let tmpURLPrefix = '';
		// This will only be true if the "Host" is set.
		const tmpCustomURIHost = pCustomRequestInformation.Host ? pCustomRequestInformation.Host : false;
		// If "Host" is set, protocol and port are optional.
		const tmpCustomURIProtocol = pCustomRequestInformation.Protocol ? pCustomRequestInformation.Protocol : 'https';
		const tmpCustomURIPort = pCustomRequestInformation.Port ? pCustomRequestInformation.Port : false;

		if (tmpCustomURIHost)
		{
			tmpURLPrefix = `${tmpCustomURIProtocol}://${tmpCustomURIHost}`;
			if (tmpCustomURIPort)
			{
				tmpURLPrefix += `:${tmpCustomURIPort}`;
			}
		}
		else
		{
			tmpURLPrefix = this.fable.EntityProvider.options.urlPrefix;
		}

		// Now get the records
		/** @type {(pError: Error | null, pResponse: any, pData: any) => void} */
		const callback = (pError, pResponse, pData) =>
		{
			if (pError)
			{
				this.log.error(`EntityBundleRequest request Error getting data set for [${pCustomRequestInformation.Entity}] with filter [${tmpURLTemplateString}]: ${pError}`, pError);
				return fCallback(pError);
			}

			this.log.trace(`EntityBundleRequest completed request for ${pCustomRequestInformation.Entity} filtered to [${tmpURLTemplateString}]`);

			// Since this is a templated endpoint it can be used for logging etc.
			if (pCustomRequestInformation.Destination)
			{
				this.fable.manifest.setValueByHash(pContext, pCustomRequestInformation.Destination, pData);
			}

			return fCallback();
		};

		/** @type {Record<string, any>} */
		let tmpOptions = (
			{
				url: `${tmpURLPrefix}${tmpURLTemplateString}`
			});
		tmpOptions = this.fable.EntityProvider.prepareRequestOptions(tmpOptions);
		return this.fable.EntityProvider.restClient.getJSON(tmpOptions, callback);
	}

	/**
	 * Local version of gatherDataFromServer that only support synchronous operations.
	 *
	 * @param {Array<Record<string, any>>} pEntitiesBundleDescription - The entity bundle description object.
	 */
	processBundle(pEntitiesBundleDescription)
	{
		if (!Array.isArray(pEntitiesBundleDescription))
		{
			this.log.error(`EntityBundleRequest failed to parse entity bundle request because the input was not an array.`);
			throw new Error('EntityBundleRequest failed to parse entity bundle request because the input was not an array.');
		}

		const tmpStateStack = [];
		let tmpState = {};

		for (const tmpEntityBundleEntry of pEntitiesBundleDescription)
		{
			try
			{
				switch (tmpEntityBundleEntry.Type)
				{
					case 'SetStateAddress':
						tmpStateStack.push(tmpState);
						tmpState = this.fable.manifest.getValueByHash(this.fable, tmpEntityBundleEntry.StateAddress);
						if (typeof tmpState === 'undefined')
						{
							tmpState = {};
							this.fable.manifest.setValueByHash(this.fable, tmpEntityBundleEntry.StateAddress, tmpState);
						}
						break;
					case 'PopState':
						if (tmpStateStack.length > 0)
						{
							tmpState = tmpStateStack.pop();
						}
						else
						{
							this.log.warn(`EntityBundleRequest encountered a PopState without a matching SetStateAddress.`);
						}
						break;
					case 'MapJoin':
						this.mapJoin(tmpEntityBundleEntry, this.prepareState(tmpState, tmpEntityBundleEntry));
						break;
					case 'ProjectDataset':
						this.projectDataset(tmpEntityBundleEntry, this.prepareState(tmpState, tmpEntityBundleEntry));
						break;
					default:
						this.log.error(`EntityBundleRequest encountered an unsupported type [${tmpEntityBundleEntry.Type}] in the entity bundle description.`);
				}
			}
			catch (pError)
			{
				this.log.error(`EntityBundleRequest error gathering entity set: ${pError}`, { Stack: pError.stack });
			}
		}
	}

	/**
	 * Gather data from the server returning a promise when it is complete.
	 *
	 * @param {Array<Record<string, any>>} pEntitiesBundleDescription - The entity bundle description object.
	 * @param {(error?: Error) => void} fCallback - The callback function to call when the data gathering is complete.
	 */
	/**
	 * Extract the set of destination addresses that a bundle step depends on.
	 *
	 * Scans the step's Filter, URL, and data-address properties for template
	 * references of the form:
	 *   - {~PJU:..^Field^SomeAddress~}  (primary-key join/unique)
	 *   - {~D:SomeAddress.Field~}        (data-address lookup)
	 *
	 * Also inspects MapJoin/ProjectDataset address properties for references
	 * to destinations produced by earlier steps.
	 *
	 * @param {Record<string, any>} pStep - A single entity bundle step.
	 * @return {Set<string>} - The set of destination address prefixes this step references.
	 */
	extractStepDependencies(pStep)
	{
		const tmpDependencies = new Set();

		// Collect all string fields that may contain template expressions
		const tmpTemplateFields = [];
		if (typeof pStep.Filter === 'string')
		{
			tmpTemplateFields.push(pStep.Filter);
		}
		if (typeof pStep.URL === 'string')
		{
			tmpTemplateFields.push(pStep.URL);
		}
		if (typeof pStep.BucketByTemplate === 'string')
		{
			tmpTemplateFields.push(pStep.BucketByTemplate);
		}

		/**
		 * Add a dependency address, stripping the Record. prefix if present.
		 * The Record. prefix is used in PJU/D templates because the template
		 * parser receives a context object with Record as a root property,
		 * but the actual data address is everything after Record.
		 *
		 * @param {string} pValue - The raw address from the template or step config.
		 */
		const addDependency = (pValue) =>
		{
			if (typeof pValue === 'string' && pValue.startsWith('Record.'))
			{
				tmpDependencies.add(pValue.substring('Record.'.length));
			}
			else
			{
				tmpDependencies.add(pValue);
			}
		};

		// Parse template references from Filter/URL strings
		for (const tmpField of tmpTemplateFields)
		{
			// Match {~PJU:..^Field^Address.Path~} — the address is after the last ^
			// Address characters include alphanumerics, dots, brackets, hyphens (e.g. State[Step-1])
			const tmpPJUMatches = tmpField.matchAll(/\^([^~}^]+)~\}/g);
			for (const tmpMatch of tmpPJUMatches)
			{
				addDependency(tmpMatch[1]);
			}
			// Match {~D:Address.Path.Field~}
			const tmpDMatches = tmpField.matchAll(/\{~D:([^~}]+)~\}/g);
			for (const tmpMatch of tmpDMatches)
			{
				addDependency(tmpMatch[1]);
			}
		}

		// MapJoin steps reference data from prior steps via address properties
		if (pStep.Type === 'MapJoin')
		{
			if (typeof pStep.DestinationRecordSetAddress === 'string')
			{
				addDependency(pStep.DestinationRecordSetAddress);
			}
			if (typeof pStep.DestinationRecordAddress === 'string')
			{
				addDependency(pStep.DestinationRecordAddress);
			}
			if (typeof pStep.Joins === 'string')
			{
				addDependency(pStep.Joins);
			}
			if (typeof pStep.JoinRecordSetAddress === 'string')
			{
				addDependency(pStep.JoinRecordSetAddress);
			}
		}

		// ProjectDataset steps reference input recordset addresses
		if (pStep.Type === 'ProjectDataset')
		{
			if (typeof pStep.InputRecordsetAddress === 'string')
			{
				// Strip any manyfest filter expression from the address
				const tmpCleanAddress = pStep.InputRecordsetAddress.split('[]')[0];
				addDependency(tmpCleanAddress);
			}
		}
		return tmpDependencies;
	}

	/**
	 * Build execution waves from a bundle description by analyzing inter-step
	 * dependencies. Steps within the same wave have no data dependencies on
	 * each other and can execute concurrently. Waves execute sequentially.
	 *
	 * SetStateAddress and PopState steps act as wave barriers — they always
	 * start a new wave and execute alone.
	 *
	 * @param {Array<Record<string, any>>} pEntitiesBundleDescription - The entity bundle description.
	 * @return {Array<Array<{Index: number, Step: Record<string, any>}>>} - An array of waves, each wave an array of {Index, Step} objects.
	 */
	buildBundleWaves(pEntitiesBundleDescription)
	{
		// First, annotate each step with its dependencies and destination
		const tmpAnnotatedSteps = [];
		for (let i = 0; i < pEntitiesBundleDescription.length; i++)
		{
			const tmpStep = pEntitiesBundleDescription[i];
			// MapJoin and ProjectDataset are synchronous steps that mutate records
			// in-place, creating implicit data dependencies that can't be reliably
			// detected from the step config alone. Force them to run sequentially.
			const tmpIsSyncMutation = (tmpStep.Type === 'MapJoin' || tmpStep.Type === 'ProjectDataset');
			tmpAnnotatedSteps.push({
				Index: i,
				Step: tmpStep,
				Destination: typeof tmpStep.Destination === 'string' ? tmpStep.Destination : null,
				Dependencies: this.extractStepDependencies(tmpStep),
				IsBarrier: (tmpStep.Type === 'SetStateAddress' || tmpStep.Type === 'PopState'),
				// Allow individual steps to opt out of parallel execution.
				// Sync mutation steps are always sequential unless explicitly overridden.
				ForceSequential: tmpIsSyncMutation ? (tmpStep.Parallel !== true) : (tmpStep.Parallel === false)
			});
		}

		const tmpWaves = [];
		const tmpResolved = new Set();
		const tmpRemaining = new Set(tmpAnnotatedSteps.map((pEntry) => { return pEntry.Index; }));

		while (tmpRemaining.size > 0)
		{
			const tmpWave = [];

			// Process steps in original order to find candidates for this wave
			for (const tmpIdx of tmpRemaining)
			{
				const tmpEntry = tmpAnnotatedSteps[tmpIdx];

				// Barrier steps always run alone in their own wave
				if (tmpEntry.IsBarrier)
				{
					if (tmpWave.length === 0)
					{
						tmpWave.push(tmpEntry);
					}
					// If we already have steps in this wave, the barrier starts the next wave
					break;
				}

				// If this wave already contains a barrier, stop adding
				if (tmpWave.length > 0 && tmpWave[0].IsBarrier)
				{
					break;
				}

				// Check if all dependencies are resolved
				let tmpDepsResolved = true;
				for (const tmpDep of tmpEntry.Dependencies)
				{
					// Check if any resolved destination is a prefix of (or equal to) this dependency
					let tmpFoundResolved = false;
					for (const tmpResolvedDest of tmpResolved)
					{
						if (tmpDep === tmpResolvedDest || tmpDep.startsWith(tmpResolvedDest + '.'))
						{
							tmpFoundResolved = true;
							break;
						}
					}
					if (tmpFoundResolved)
					{
						continue;
					}

					// Check if any unresolved step (remaining or current wave) produces this dependency.
					// If so, we cannot run this step yet.
					let tmpProducedByUnresolved = false;
					for (const tmpOtherIdx of tmpRemaining)
					{
						if (tmpOtherIdx === tmpEntry.Index)
						{
							continue;
						}
						const tmpOther = tmpAnnotatedSteps[tmpOtherIdx];
						if (tmpOther.Destination && (tmpDep === tmpOther.Destination || tmpDep.startsWith(tmpOther.Destination + '.')))
						{
							tmpProducedByUnresolved = true;
							break;
						}
					}
					// Also check steps already added to this wave
					if (!tmpProducedByUnresolved)
					{
						for (const tmpWaveEntry of tmpWave)
						{
							if (tmpWaveEntry.Destination && (tmpDep === tmpWaveEntry.Destination || tmpDep.startsWith(tmpWaveEntry.Destination + '.')))
							{
								tmpProducedByUnresolved = true;
								break;
							}
						}
					}
					if (tmpProducedByUnresolved)
					{
						tmpDepsResolved = false;
						break;
					}
					// Dependency refers to data not produced by any step (e.g. pre-seeded AppData);
					// treat as already available
				}

				if (!tmpDepsResolved)
				{
					continue;
				}

				// If this step forces sequential, it must be alone in its wave
				if (tmpEntry.ForceSequential)
				{
					if (tmpWave.length === 0)
					{
						tmpWave.push(tmpEntry);
						break;
					}
					// Otherwise skip it for now — it will be alone in a future wave
					continue;
				}

				tmpWave.push(tmpEntry);
			}

			// Safety valve: if we made no progress, force the next remaining step
			// to avoid an infinite loop (e.g. circular or unresolvable dependency)
			if (tmpWave.length === 0)
			{
				const tmpNextIdx = tmpRemaining.values().next().value;
				tmpWave.push(tmpAnnotatedSteps[tmpNextIdx]);
			}

			tmpWaves.push(tmpWave.map((pEntry) => { return { Index: pEntry.Index, Step: pEntry.Step }; }));

			for (const tmpEntry of tmpWave)
			{
				tmpRemaining.delete(tmpEntry.Index);
				if (tmpEntry.Destination)
				{
					tmpResolved.add(tmpEntry.Destination);
				}
			}
		}

		return tmpWaves;
	}

	gatherDataFromServer(pEntitiesBundleDescription, fCallback)
	{
		if (!Array.isArray(pEntitiesBundleDescription))
		{
			this.log.error(`EntityBundleRequest failed to parse entity bundle request because the input was not an array.`);
			return fCallback(new Error('EntityBundleRequest failed to parse entity bundle request because the input was not an array.'));
		}

		const tmpStateStack = [];
		let tmpState = {};

		// Build execution waves from the bundle description
		const tmpWaves = this.buildBundleWaves(pEntitiesBundleDescription);
		this.lastBundleWaves = tmpWaves;

		// The maximum number of concurrent requests per wave
		const tmpMaxConcurrency = (typeof this.options.maxBundleConcurrency === 'number') ? this.options.maxBundleConcurrency : 8;

		// Execute waves sequentially; steps within each wave run concurrently
		let tmpWaveIndex = 0;

		const fExecuteNextWave = () =>
		{
			if (tmpWaveIndex >= tmpWaves.length)
			{
				return fCallback();
			}

			const tmpWave = tmpWaves[tmpWaveIndex];
			tmpWaveIndex++;

			let tmpWaveAnticipate = this.fable.newAnticipate();
			tmpWaveAnticipate.maxOperations = Math.min(tmpWave.length, tmpMaxConcurrency);

			for (let w = 0; w < tmpWave.length; w++)
			{
				const tmpEntityBundleEntry = tmpWave[w].Step;
				tmpWaveAnticipate.anticipate(
					(fNext) =>
					{
						try
						{
							switch (tmpEntityBundleEntry.Type)
							{
								case 'SetStateAddress':
									tmpStateStack.push(tmpState);
									tmpState = this.fable.manifest.getValueByHash(this.fable, tmpEntityBundleEntry.StateAddress);
									if (typeof tmpState === 'undefined')
									{
										tmpState = {};
										this.fable.manifest.setValueByHash(this.fable, tmpEntityBundleEntry.StateAddress, tmpState);
									}
									return fNext();
								case 'PopState':
									if (tmpStateStack.length > 0)
									{
										tmpState = tmpStateStack.pop();
									}
									else
									{
										this.log.warn(`EntityBundleRequest encountered a PopState without a matching SetStateAddress.`);
									}
									return fNext();
								case 'Custom':
									return this.gatherCustomDataSet(tmpEntityBundleEntry, this.prepareState(tmpState, tmpEntityBundleEntry), fNext);
								case 'MapJoin':
									this.mapJoin(tmpEntityBundleEntry, this.prepareState(tmpState, tmpEntityBundleEntry));
									return fNext();
								case 'ProjectDataset':
									this.projectDataset(tmpEntityBundleEntry, this.prepareState(tmpState, tmpEntityBundleEntry));
									return fNext();
								// This is the default case, for a meadow entity set or single entity
								case 'MeadowEntityCount':
									return this.gatherEntitySetCount(tmpEntityBundleEntry, this.prepareState(tmpState, tmpEntityBundleEntry), fNext);
								case 'MeadowEntity':
								default:
									return this.gatherEntitySet(tmpEntityBundleEntry, this.prepareState(tmpState, tmpEntityBundleEntry), fNext);
							}
						}
						catch (pError)
						{
							this.log.error(`EntityBundleRequest error gathering entity set: ${pError}`, { Stack: pError.stack });
							return fNext();
						}
					});
			}

			tmpWaveAnticipate.wait(
				(pError) =>
				{
					if (pError)
					{
						this.log.error(`EntityBundleRequest error gathering entity set: ${pError}`, { Stack: pError.stack });
						return fCallback(pError);
					}
					return fExecuteNextWave();
				});
		};

		fExecuteNextWave();
	}

	/**
	 * Creates a wrapper state object to allow referencing common global state in addition to flow-state.
	 *
	 * @param {Record<string, any>} pState - The state object to prepare.
	 * @param {any} [pStepConfiguration] - (optional) The step configuration object provided in the config, if any.
	 * @return {Record<string, any>} - The prepared state object.
	 */
	prepareState(pState, pStepConfiguration)
	{
		return {
			State: pState,
			AppData: this.fable.AppData,
			Bundle: this.fable.Bundle,
			Pict: this.fable,
			Fable: this.fable,
			StepConfiguration: pStepConfiguration,
		};
	}

	/**
	 * @param {string} pEntity - The name of the entity to get.
	 * @param {string|number} pIDRecord - The ID of the record to get.
	 * @param {(pError?: Error, pRecord?: any) => void} fCallback - The callback function to call when the operation is complete.
	 */
	getEntity(pEntity, pIDRecord, fCallback)
	{
		this.initializeCache(pEntity);
		// Discard anything from the cache that has expired or is over size.
		this.recordCache[pEntity].prune(
			function ()
			{
				let tmpPossibleRecord = this.recordCache[pEntity].read(pIDRecord);

				if (tmpPossibleRecord)
				{
					return fCallback(null, tmpPossibleRecord);
				}

				let tmpOptions = (
					{
						url: `${this.options.urlPrefix}${pEntity}/${pIDRecord}`
					});
				tmpOptions = this.prepareRequestOptions(tmpOptions);

				return this.restClient.getJSON(tmpOptions,
					(pError, pResponse, pBody) =>
					{
						/*
						 * FIXME: This breaks entity reads for nonexistent records. Putting this back for now until we can audit and fix all the places that may rely on this.
						if (pResponse && pResponse.statusCode && pResponse.statusCode >= 400)
						{
							this.log.error(`Error getting entity [${pEntity}] with ID [${pIDRecord}] from url [${tmpOptions.url}]: ${pResponse.statusCode} ${pResponse.statusMessage}`);
							return fCallback(new Error(`Error getting entity [${pEntity}] with ID [${pIDRecord}] from url [${tmpOptions.url}]: ${pResponse.statusCode} ${JSON.stringify(pBody || {})}`));
						}
						*/
						if (pBody)
						{
							this.recordCache[pEntity].put(pBody, pIDRecord);
						}
						return fCallback(pError, pBody);
					});
			}.bind(this));
	}

	/**
	 * For a given list of objects, cache connected entity records (use lazy loading of pages and not count requests).
	 *
	 * @param {Array} pRecordSet - An array of objects to check cache on joined records for, and, get/cache the records as needed.
	 * @param {Array} pIDListToCache - An array of property strings that are the ID fields to cache connected records for.
	 * @param {Array} pEntityListToCache - An array of entity names, which can override the speculative entity name derived from the ID field name.
	 * @param {boolean} pLiteRecords - If true, only cache lite records (ID and Name fields).
	 *
	 * @return {void}
	 */
	cacheConnectedEntityRecordsWithoutCount(pRecordSet, pIDListToCache, pEntityListToCache, pLiteRecords, fCallback)
	{
		//FIXME: pLiteRecords is ignored?
		if (!Array.isArray(pRecordSet) || pRecordSet.length < 1)
		{
			return fCallback();
		}

		if (!Array.isArray(pIDListToCache) || pIDListToCache.length < 1)
		{
			return fCallback();
		};

		const tmpAnticipate = this.fable.newAnticipate();

		const tmpEntityListToCache = pEntityListToCache || [];
		tmpAnticipate.maxOperations = 10;
		for (let i = 0; i < pIDListToCache.length; i++)
		{
			const tmpEntityIDSourceField = pIDListToCache[i];
			// If an entity name override is provided, use it, otherwise speculate the joined entity name ID field from the source ID field name.
			const tmpEntityName = tmpEntityListToCache[i] || tmpEntityIDSourceField.replace(/^ID/, '');
			const tmpIDField = `ID${tmpEntityName}`;

			// Make a set of IDs to fetch for this entity.
			const tmpEntityIDsToFetch = new Set();

			// Initialize the cache
			this.initializeCache(tmpEntityName);

			// First pass: gather IDs to fetch
			for (const tmpRecord of pRecordSet)
			{
				const tmpIDValue = tmpRecord[tmpEntityIDSourceField];
				if (tmpIDValue)
				{
					const tmpCachedRecord = this.recordCache[tmpEntityName].read(tmpIDValue);
					if (!tmpCachedRecord)
					{
						tmpEntityIDsToFetch.add(tmpIDValue);
					}
				}
			}

			// Now if there are records to fetch, do the request.
			if (tmpEntityIDsToFetch.size > 0)
			{
				tmpAnticipate.anticipate(
					function (fRequestComplete)
					{
						const tmpIDRecordsArray = Array.from(tmpEntityIDsToFetch);
						const tmpMeadowFilterExpression = `FBL~ID${tmpEntityName}~INN~${tmpIDRecordsArray.join(',')}`;

						this.getEntitySet(tmpEntityName, tmpMeadowFilterExpression,
							(pError, pEntitySet) =>
							{
								if (pError)
								{
									this.log.error(`cacheConnectedEntityRecords error getting connected entity records for [${tmpEntityName}] with IDs [${tmpIDRecordsArray.join(',')}]: ${pError}`, { Stack: pError.stack });
									return fRequestComplete(pError);
								}
								// The method automagically cached them for us!  Just move on to the next...
								return fRequestComplete();
							}, null, { NoCount: true });
					}.bind(this));
			}
		}

		tmpAnticipate.wait(
			(pError) =>
			{
				if (pError)
				{
					this.log.error(`cacheConnectedEntityRecords error gathering connected entity records: ${pError}`, { Stack: pError.stack });
					return fCallback(pError);
				}
				return fCallback();
			});
	}

	/**
	 * For a given list of objects, cache connected entity records.
	 *
	 * @param {Array} pRecordSet - An array of objects to check cache on joined records for, and, get/cache the records as needed.
	 * @param {Array} pIDListToCache - An array of property strings that are the ID fields to cache connected records for.
	 * @param {Array} pEntityListToCache - An array of entity names, which can override the speculative entity name derived from the ID field name.
	 * @param {boolean} pLiteRecords - If true, only cache lite records (ID and Name fields).
	 *
	 * @return {void}
	 */
	cacheConnectedEntityRecords(pRecordSet, pIDListToCache, pEntityListToCache, pLiteRecords, fCallback)
	{
		//FIXME: pLiteRecords is ignored?
		if (!Array.isArray(pRecordSet) || pRecordSet.length < 1)
		{
			return fCallback();
		}

		if (!Array.isArray(pIDListToCache) || pIDListToCache.length < 1)
		{
			return fCallback();
		};

		const tmpAnticipate = this.fable.newAnticipate();

		const tmpEntityListToCache = pEntityListToCache || [];

		for (let i = 0; i < pIDListToCache.length; i++)
		{
			const tmpEntityIDSourceField = pIDListToCache[i];
			// If an entity name override is provided, use it, otherwise speculate the joined entity name ID field from the source ID field name.
			const tmpEntityName = tmpEntityListToCache[i] || tmpEntityIDSourceField.replace(/^ID/, '');
			const tmpIDField = `ID${tmpEntityName}`;

			// Make a set of IDs to fetch for this entity.
			const tmpEntityIDsToFetch = new Set();

			// Initialize the cache
			this.initializeCache(tmpEntityName);

			// First pass: gather IDs to fetch
			for (const tmpRecord of pRecordSet)
			{
				const tmpIDValue = tmpRecord[tmpEntityIDSourceField];
				if (tmpIDValue)
				{
					const tmpCachedRecord = this.recordCache[tmpEntityName].read(tmpIDValue);
					if (!tmpCachedRecord)
					{
						tmpEntityIDsToFetch.add(tmpIDValue);
					}
				}
			}

			// Now if there are records to fetch, do the request.
			if (tmpEntityIDsToFetch.size > 0)
			{
				tmpAnticipate.anticipate(
					function (fRequestComplete)
					{
						const tmpIDRecordsArray = Array.from(tmpEntityIDsToFetch);
						const tmpMeadowFilterExpression = `FBL~ID${tmpEntityName}~INN~${tmpIDRecordsArray.join(',')}`;

						this.getEntitySet(tmpEntityName, tmpMeadowFilterExpression,
							(pError, pEntitySet) =>
							{
								if (pError)
								{
									this.log.error(`cacheConnectedEntityRecords error getting connected entity records for [${tmpEntityName}] with IDs [${tmpIDRecordsArray.join(',')}]: ${pError}`, { Stack: pError.stack });
									return fRequestComplete(pError);
								}
								// The method automagically cached them for us!  Just move on to the next...
								return fRequestComplete();
							});
					}.bind(this));
			}
		}

		tmpAnticipate.wait(
			(pError) =>
			{
				if (pError)
				{
					this.log.error(`cacheConnectedEntityRecords error gathering connected entity records: ${pError}`, { Stack: pError.stack });
					return fCallback(pError);
				}
				return fCallback();
			});
	}

	/**
	 * Cache an array of records, likely from a meadow endpoint
	 *
	 * @param {string} pEntity - The entity type to cache individual records for
	 * @param {Array<Record<string, any>>} pRecordSet - An array of records to cache
	 */
	cacheIndividualEntityRecords(pEntity, pRecordSet)
	{
		this.initializeCache(pEntity);

		const tmpEntitySet = pRecordSet;

		if (Array.isArray(tmpEntitySet) && tmpEntitySet.length > 0)
		{
			// Cache each record individually.
			// This code is here because the downstream getEntitySet function uses this to load records, so both are covered here.
			const tmpSpeculativeRecordIDColumn = `ID${pEntity}`;
			if (tmpEntitySet[0] && typeof tmpEntitySet[0] === 'object' && tmpSpeculativeRecordIDColumn in tmpEntitySet[0])
			{
				for (let i = 0; i < tmpEntitySet.length; i++)
				{
					const tmpRecord = tmpEntitySet[i];
					const tmpIDRecord = tmpRecord[tmpSpeculativeRecordIDColumn];
					if (tmpIDRecord)
					{
						this.recordCache[pEntity].put(tmpRecord, tmpIDRecord);
					}
				}
			}
		}
	}

	/**
	 * @param {string} pEntity - The name of the entity to get.
	 * @param {string} pMeadowFilterExpression - The meadow filter expression to filter the entity set by.
	 * @param {number} pRecordStartCursor - The starting cursor for record pagination.
	 * @param {number} pRecordCount - The number of records to return for pagination.
	 * @param {(pError?: Error, pEntitySet?: Array<Record<string, any>>) => void} fCallback - The callback function to call when the operation is complete.
	 * @param {string} [postfix] - Optional, adds a postfix string to the url.
	 */
	getEntitySetPage(pEntity, pMeadowFilterExpression, pRecordStartCursor, pRecordCount, fCallback, postfix = '')
	{
		const tmpFilterStanza = pMeadowFilterExpression ? `/FilteredTo/${pMeadowFilterExpression}` : '';
		const tmpURL = `${this.options.urlPrefix}${pEntity}s${tmpFilterStanza}/${pRecordStartCursor}/${pRecordCount}`;

		return this.restClient.getJSON(tmpURL + (postfix || ''),
			function (pDownloadError, pDownloadResponse, pDownloadBody)
			{
				if (pDownloadResponse && pDownloadResponse.statusCode && pDownloadResponse.statusCode >= 400)
				{
					this.log.error(`Error getting entity set of [${pEntity}] filtered to [${pMeadowFilterExpression}] [${pRecordStartCursor}/${pRecordCount}] from url [${tmpURL}]: ${pDownloadResponse.statusCode} ${pDownloadResponse.statusMessage}`);
					return fCallback(new Error(`Error getting entity set of [${pEntity}] filtered to [${pMeadowFilterExpression}] [${pRecordStartCursor}/${pRecordCount}] from url [${tmpURL}]: ${pDownloadResponse.statusCode} ${JSON.stringify(pDownloadBody || {})}`));
				}

				this.cacheIndividualEntityRecords(pEntity, pDownloadBody);

				return fCallback(pDownloadError, pDownloadBody);
			}.bind(this));
	}

	/**
	 * @param {string} pEntity - The name of the entity to get the count of.
	 * @param {string} pMeadowFilterExpression - The meadow filter expression to filter the entity set by.
	 * @param {(pError?: Error, pRecordCount?: number) => void} fCallback - The callback function to call when the operation is complete.
	 * @param {string} [postfix] - Optional, adds a postfix string to the count url
	 */
	getEntitySetRecordCount(pEntity, pMeadowFilterExpression, fCallback, postfix = '')
	{
		const tmpFilterStanza = pMeadowFilterExpression ? `/FilteredTo/${pMeadowFilterExpression}` : '';
		const tmpURL = `${this.options.urlPrefix}${pEntity}s/Count${tmpFilterStanza}`;

		return this.restClient.getJSON(tmpURL + (postfix || ''),
			function (pError, pResponse, pBody)
			{
				if (pResponse && pResponse.statusCode && pResponse.statusCode >= 400)
				{
					this.log.error(`Error getting entity count of [${pEntity}] filtered to [${pMeadowFilterExpression}] from url [${tmpURL}]: ${pResponse.statusCode} ${pResponse.statusMessage}`);
					return fCallback(new Error(`Error getting entity count of [${pEntity}] filtered to [${pMeadowFilterExpression}] from url [${tmpURL}]: ${pResponse.statusCode} ${JSON.stringify(pBody || {})}`));
				}
				if (pError)
				{
					this.log.error(`Error getting entity count of [${pEntity}] filtered to [${pMeadowFilterExpression}] from url [${tmpURL}]: ${pError}`);
					return fCallback(pError);
				}
				let tmpRecordCount = 0;
				if (pBody.Count)
				{
					tmpRecordCount = pBody.Count;
				}
				return fCallback(pError, tmpRecordCount);
			}.bind(this));
	}

	/**
	 * @param {string} pEntity - The name of the entity to get.
	 * @param {string} pMeadowFilterExpression - The meadow filter expression to filter the entity set by.
	 * @param {(pError?: Error, pEntitySet?: Array<Record<string, any>>) => void} fCallback - The callback function to call when the operation is complete.
	 */
	getEntitySetWithAutoCaching(pEntity, pMeadowFilterExpression, fCallback)
	{
		let tmpAnticipate = this.fable.newAnticipate();

		let tmpRequestState = {Entity: pEntity, MeadowFilterExpression: pMeadowFilterExpression, EntitySet: null};

		tmpAnticipate.anticipate(
			function(fNext)
			{
				this.getEntitySet(pEntity, pMeadowFilterExpression,
					(pError, pEntitySet) =>
					{
						if (pError)
						{
							this.log.error(`getEntitySetWithAutoCaching error getting entity set for [${pEntity}] filtered to [${pMeadowFilterExpression}]: ${pError}`, { Stack: pError.stack });
							return fNext(pError);
						}
						tmpRequestState.EntitySet = pEntitySet;
						return fNext();
					});
			}.bind(this));

		tmpAnticipate.anticipate(
			function(fNext)
			{
				// Now see if we can infer some entities from this set to cache individual records for.
				if ((typeof(tmpRequestState.EntitySet) == 'object') && Array.isArray(tmpRequestState.EntitySet) && (tmpRequestState.EntitySet.length > 0))
				{
					// Look at each column and if it starts with `ID` and is longer than `ID` then speculate it is an entity join.
					const tmpFirstRecord = tmpRequestState.EntitySet[0];
					const tmpIDColumnsToCache = [];
					const tmpEntityNamesToCache = [];
					for (const tmpColumnName of Object.keys(tmpFirstRecord))
					{
						if ((tmpColumnName.startsWith('ID')) && (tmpColumnName.length > 2))
						{
							// Speculate this is an entity join.
							tmpIDColumnsToCache.push(tmpColumnName);
							const tmpSpeculatedEntityName = tmpColumnName.substring(2);
							tmpEntityNamesToCache.push(tmpSpeculatedEntityName);
						}
						// Mutate any `CreatingIDUser`, `UpdatingIDUser`, `DeletingIDUser` to the proper entiity
						else if (tmpColumnName in this.entityColumnTranslations)
						{
							tmpIDColumnsToCache.push(tmpColumnName);
							tmpEntityNamesToCache.push(this.entityColumnTranslations[tmpColumnName]);
						}
					}

					if (tmpIDColumnsToCache.length > 0)
					{
						return this.cacheConnectedEntityRecords(
							tmpRequestState.EntitySet,
							tmpIDColumnsToCache,
							tmpEntityNamesToCache,
							false,
							(pError) =>
							{
								if (pError)
								{
									this.log.error(`getEntitySetWithAutoCaching error caching connected entity records for [${pEntity}] filtered to [${pMeadowFilterExpression}]: ${pError}`, { Stack: pError.stack });
									return fNext(pError);
								}
								return fNext();
							});
					}
					else
					{
						return fNext();
					}
				}
				else
				{
					return fNext();
				}
			}.bind(this));

		tmpAnticipate.wait(
			function (pError)
			{
				if (pError)
				{
					this.log.error(`getEntitySetWithAutoCaching error gathering entity set for [${pEntity}] filtered to [${pMeadowFilterExpression}]: ${pError}`, { Stack: pError.stack });
					return fCallback(pError);
				}
				return fCallback(null, tmpRequestState.EntitySet);
			}.bind(this));
	}

	/**
	 * @param {string} pEntity - The entity to get a set of.
	 * @param {string} pMeadowFilterExpression - The meadow filter expression to filter the entity set by.
	 * @param {(pError?: Error, pEntitySet?: Array) => void} fCallback - The callback to call when the request is complete.
	 * @param {string} [postfix] - Optional, adds a postfix string to all calls made.
	 * @param {Record<string, any>} [pOptions] - Optional, per-call options (e.g. { DownloadPageConcurrency: 1 }).
	 *
	 * @return {void}
	 */
	getEntitySet(pEntity, pMeadowFilterExpression, fCallback, postfix = '', pOptions = {})
	{
		// TODO: Should we test for too many record IDs here by string length in pMeadowFilterExpression?
		//       FBL~ID${pDestinationEntity}~INN~${tmpIDRecordsCommaSeparated}
		//       If the list is mega-long we can parse it and break it into chunks.
		this.initializeCache(pEntity);
		// Discard anything from the cache that has expired or is over size.
		this.recordSetCache[pEntity].prune(
			function ()
			{
				let tmpPossibleRecords = this.recordSetCache[pEntity].read(pMeadowFilterExpression);

				if (tmpPossibleRecords)
				{
					return fCallback(null, tmpPossibleRecords);
				}
				if (pOptions.NoCount)
				{
					// Lazily load until we hit a not full page rather than using couns.
					// Does not respect parallelization.
					const pageSize = 250;
					let page = 0;
					let returnSet = [];
					const tmpFilterStanza = pMeadowFilterExpression ? `/FilteredTo/${pMeadowFilterExpression}` : '';
					const recursiveCallback = (pDownloadError, pDownloadResponse, pDownloadBody) => 
					{
						if ((pDownloadResponse && pDownloadResponse.statusCode && pDownloadResponse.statusCode >= 400) || !Array.isArray(pDownloadBody))
						{
							this.log.error(`Error getting entity set of [${pEntity}] filtered to [${pMeadowFilterExpression}]: ${pDownloadResponse.statusCode} ${pDownloadResponse.statusMessage}`);
							return fCallback(new Error(`Error getting entity set of [${pEntity}] filtered to [${pMeadowFilterExpression}]: ${pDownloadResponse.statusCode} ${JSON.stringify(pDownloadBody || {})}`), []);
						}

						returnSet = returnSet.concat(pDownloadBody);

						if (pDownloadBody?.length < pageSize)
						{
							this.recordSetCache[pEntity].put(returnSet, pMeadowFilterExpression);

							this.cacheIndividualEntityRecords(pEntity, returnSet);
							fCallback(null, returnSet);
						}
						else
						{
							page += 1;
							this.restClient.getJSON(`${this.options.urlPrefix}${pEntity}s${tmpFilterStanza}/${page * pageSize}/${pageSize}` + (postfix || ''), recursiveCallback);
						}
					};
					return this.restClient.getJSON(`${this.options.urlPrefix}${pEntity}s${tmpFilterStanza}/${page * pageSize}/${pageSize}` + (postfix || ''), recursiveCallback);
				}
				return this.getEntitySetRecordCount(pEntity, pMeadowFilterExpression,
					(pRecordCountError, pRecordCount) =>
					{
						if (pRecordCountError)
						{
							return fCallback(pRecordCountError);
						}
						let tmpRecordCount = pRecordCount;

						if (isNaN(pRecordCount))
						{
							this.log.error(`Entity count did not return a number for [${pEntity}] filtered to [${pMeadowFilterExpression}]... something is fatally wrong from the server accessed in getEntitySet call.`);
							return fCallback(new Error('Entity count did not return a number in getEntitySet.'));
						}

						let tmpDownloadBatchSize = this.options.downloadBatchSize;
						const tmpFilterStanza = pMeadowFilterExpression ? `/FilteredTo/${pMeadowFilterExpression}` : '';
						const tmpPageCount = Math.ceil(tmpRecordCount / tmpDownloadBatchSize);

						// Build an indexed array of page descriptors to preserve ordering
						const tmpPages = [];
						for (let i = 0; i < tmpPageCount; i++)
						{
							tmpPages.push({
								Index: i,
								URL: `${this.options.urlPrefix}${pEntity}s${tmpFilterStanza}/${i * tmpDownloadBatchSize}/${tmpDownloadBatchSize}`,
								Records: null
							});
						}

						// Fetch pages concurrently and reassemble in order.
						// Per-call DownloadPageConcurrency overrides the provider-level default.
						const tmpPageConcurrency = (typeof pOptions.DownloadPageConcurrency === 'number')
							? pOptions.DownloadPageConcurrency
							: ((typeof this.options.downloadPageConcurrency === 'number') ? this.options.downloadPageConcurrency : 4);
						this.fable.Utility.eachLimit(tmpPages, tmpPageConcurrency,
							(pPage, fDownloadCallback) =>
							{
								this.restClient.getJSON(pPage.URL + (postfix || ''),
									(pDownloadError, pDownloadResponse, pDownloadBody) =>
									{
										if (pDownloadResponse && pDownloadResponse.statusCode && pDownloadResponse.statusCode >= 400)
										{
											this.log.error(`Error getting entity set of [${pEntity}] filtered to [${pMeadowFilterExpression}] from url [${pPage.URL}]: ${pDownloadResponse.statusCode} ${pDownloadResponse.statusMessage}`);
											return fDownloadCallback(new Error(`Error getting entity set of [${pEntity}] filtered to [${pMeadowFilterExpression}] from url [${pPage.URL}]: ${pDownloadResponse.statusCode} ${JSON.stringify(pDownloadBody || {})}`));
										}
										if (Array.isArray(pDownloadBody))
										{
											pPage.Records = pDownloadBody;
										}
										return fDownloadCallback(pDownloadError);
									});
							},
							(pFullDownloadError) =>
							{
								// Reassemble pages in index order to maintain consistent ordering
								let tmpEntitySet = [];
								for (let i = 0; i < tmpPages.length; i++)
								{
									if (Array.isArray(tmpPages[i].Records))
									{
										tmpEntitySet = tmpEntitySet.concat(tmpPages[i].Records);
									}
								}

								if (tmpEntitySet)
								{
									this.recordSetCache[pEntity].put(tmpEntitySet, pMeadowFilterExpression);
								}

								this.cacheIndividualEntityRecords(pEntity, tmpEntitySet);

								return fCallback(pFullDownloadError, tmpEntitySet);
							})
					}, postfix);
			}.bind(this));
	}

	////////////////////////////////////////////////////////////////////////////////
	// Entity Creation and Update Methods
	/**
	 * @param {string} pEntityType - The type of the entity to format the URL for.
	 *
	 * @return {string} - The formatted URL for the given entity type.
	 */
	formatUrl(pEntityType)
	{
		return `${this.options.urlPrefix}${pEntityType}`;
	}


	/**
	 * Create a new entity record.
	 *
	 * @param {string} pEntityType - The entity type to create.
	 * @param {Record<string, any>} pRecord - The record to create.
	 * @param {(pError?: Error, pResult?: Record<string, any>) => void} fCallback - The callback to call when the request is complete.
	 *
	 * @return {void}
	 */
	createEntity(pEntityType, pRecord, fCallback)
	{
		let tmpRequestOptions = (
			{
				url: this.formatUrl(pEntityType),
				body: pRecord
			});

		this.restClient.postJSON(tmpRequestOptions,
			(pError, pResponse, pBody) =>
			{
				if (pError)
				{
					this.log.error(`Error creating ${pEntityType} record: ${pError.message}`);
				}
				else
				{
					this.log.info(`Created ${pEntityType} record ID ${pBody[`ID${pEntityType}`]}`);
				}
				return fCallback(pError, pBody);
			});
	}

	/**
	 * Update an entity record.
	 *
	 * @param {string} pEntityType - The entity type to create.
	 * @param {Record<string, any>} pRecord - The record to create.
	 * @param {(pError?: Error, pResult?: Record<string, any>) => void} fCallback - The callback to call when the request is complete.
	 *
	 * @return {void}
	 */
	updateEntity(pEntityType, pRecord, fCallback)
	{
		let tmpRequestOptions = (
			{
				url: this.formatUrl(pEntityType),
				body: pRecord
			});

		this.restClient.putJSON(tmpRequestOptions,
			(pError, pResponse, pBody) =>
			{
				if (pError)
				{
					this.log.error(`Error updating ${pEntityType} record: ${pError.message}`);
				}
				else
				{
					this.log.info(`Updated ${pEntityType} record ID ${pBody[`ID${pEntityType}`]}`);
				}
				return fCallback(pError, pBody);
			});
	}

	/**
	 * Upsert an entity record.
	 *
	 * @param {String} pEntityType - The entity type to be upserted.
	 * @param {Object<String, any>} pRecord - The record to upsert.
	 * @param {(pError?: Error, pResult?: any) => void} fCallback - The callback to call when the request is complete.
	 *
	 * @return {void}
	 */
	upsertEntity(pEntityType, pRecord, fCallback)
	{
		let tmpRequestOptions = (
			{
				url: this.formatUrl(`${pEntityType}/Upsert`),
				body: pRecord
			});

		this.restClient.putJSON(tmpRequestOptions,
			(pError, pResponse, pBody) =>
			{
				if (pError)
				{
					this.log.error(`Error upserting ${pEntityType} record: ${pError.message}`);
				}
				else
				{
					this.log.info(`Upserted ${pEntityType} record ID ${pBody[`ID${pEntityType}`]}`);
				}
				return fCallback(pError, pBody);
			});
	}

	/**
	 * Upsert a array of entity records.
	 *
	 * @param {string} pEntityType - The entity type to be upserted.
	 * @param {Array<Record<string, any>>} pRecords - The records to upsert.
	 * @param {(pError?: Error, pResults?: Array<any>) => void} fCallback - The callback to call when the request is complete.
	 *
	 * @return {void}
	 */
	upsertEntities(pEntityType, pRecords, fCallback)
	{
		let tmpRequestOptions = (
			{
				url: this.formatUrl(`${pEntityType}/Upserts`),
				body: pRecords
			});

		this.restClient.putJSON(tmpRequestOptions,
			(pError, pResponse, pBody) =>
			{
				if (pError)
				{
					this.log.error(`Error upserting ${pEntityType} records: ${pError.message}`);
				}
				else
				{
					this.log.info(`Upserted multiple ${pEntityType} records (count: ${pBody.length})`);
				}
				return fCallback(pError, pBody);
			});
	}

	/**
	 * Delete an entity record.
	 *
	 * @param {string} pEntityType - The entity type to create.
	 * @param {string | Number} pIDRecord - The ID of the record to delete.
	 * @param {(pError?: Error, pResult?: Record<string, any>) => void} fCallback - The callback to call when the request is complete.
	 *
	 * @return {void}
	 */
	deleteEntity(pEntityType, pIDRecord, fCallback)
	{
		let tmpRequestOptions = (
			{
				url: this.formatUrl(`${pEntityType}/${pIDRecord}`),
			});

		this.restClient.delJSON(tmpRequestOptions,
			(pError, pResponse, pBody) =>
			{
				if (pError)
				{
					this.log.error(`Error deleting ${pEntityType} record ID ${pIDRecord}: ${pError.message}`);
				}
				else
				{
					this.log.info(`Deleted ${pEntityType} record ID ${pIDRecord}`);
				}
				return fCallback(pError, pBody);
			});
	}
}

module.exports = PictMeadowEntityProvider;

},{"fable":68}],199:[function(require,module,exports){
const libFableServiceBase = require('fable').ServiceProviderBase;

class PictTemplateAudit extends libFableServiceBase
{
	/**
	 * @param {import('pict')} pFable - The Fable Framework instance
	 * @param {Record<string, any>} [pOptions] - The options for the service
	 * @param {string} [pServiceHash] - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.log;
		/** @type {string} */
		this.UUID;
		/** @type {string} */
		this.Hash;

		this.serviceType = 'PictTemplateAudit';

		/** @type {import('pict') & { TemplateDebug?: boolean, TemplateDebugStack?: boolean }} */
		this.fable;

		// Array of root-level audit trees
		this.auditLog = [];
	}

	prepareAuditing()
	{
		// Install method wrappers on the Pict instance
		this._installWrappers();
	}

	/**
	 * Install audit wrappers around the 6 parseTemplate* methods on the Pict instance.
	 * Each wrapper checks this.fable.TemplateDebug and delegates to the original when disabled.
	 *
	 * @private
	 */
	_installWrappers()
	{
		let tmpPict = this.fable;
		let tmpAudit = this;

		// Save references to original methods
		this._originalParseTemplate = tmpPict.parseTemplate.bind(tmpPict);
		this._originalParseTemplateByHash = tmpPict.parseTemplateByHash.bind(tmpPict);
		this._originalParseTemplateSet = tmpPict.parseTemplateSet.bind(tmpPict);
		this._originalParseTemplateSetByHash = tmpPict.parseTemplateSetByHash.bind(tmpPict);
		this._originalParseTemplateSetWithPayload = tmpPict.parseTemplateSetWithPayload.bind(tmpPict);
		this._originalParseTemplateSetWithPayloadByHash = tmpPict.parseTemplateSetWithPayloadByHash.bind(tmpPict);

		// -- parseTemplate wrapper --
		tmpPict.parseTemplate = function _auditParseTemplate(pTemplateString, pData, fCallback, pContextArray, pScope, pState)
		{
			if (!tmpPict.TemplateDebug)
			{
				return tmpAudit._originalParseTemplate(pTemplateString, pData, fCallback, pContextArray, pScope, pState);
			}

			let tmpAuditPrep = tmpAudit.prepareState(pState, pTemplateString.substring(0, 80));
			let tmpState = tmpAuditPrep.state;
			let tmpAuditContext = tmpAudit.beginAudit(tmpState, tmpAuditPrep.identifier, 'parseTemplate', pData);

			if (typeof fCallback === 'function')
			{
				let tmpWrappedCallback = function _auditCallback(pError, pResult)
				{
					tmpAudit.endAudit(tmpState, tmpAuditContext);
					return fCallback(pError, pResult);
				};
				return tmpAudit._originalParseTemplate(pTemplateString, pData, tmpWrappedCallback, pContextArray, pScope, tmpState);
			}
			else
			{
				let tmpResult = tmpAudit._originalParseTemplate(pTemplateString, pData, null, pContextArray, pScope, tmpState);
				tmpAudit.endAudit(tmpState, tmpAuditContext);
				return tmpResult;
			}
		};

		// -- parseTemplateByHash wrapper --
		tmpPict.parseTemplateByHash = function _auditParseTemplateByHash(pTemplateHash, pData, fCallback, pContextArray, pScope, pState)
		{
			if (!tmpPict.TemplateDebug)
			{
				return tmpAudit._originalParseTemplateByHash(pTemplateHash, pData, fCallback, pContextArray, pScope, pState);
			}

			let tmpState = tmpAudit.setHashHint(pState, pTemplateHash);
			return tmpAudit._originalParseTemplateByHash(pTemplateHash, pData, fCallback, pContextArray, pScope, tmpState);
		};

		// -- parseTemplateSet wrapper --
		tmpPict.parseTemplateSet = function _auditParseTemplateSet(pTemplateString, pDataSet, fCallback, pContextArray, pScope, pState)
		{
			if (!tmpPict.TemplateDebug)
			{
				return tmpAudit._originalParseTemplateSet(pTemplateString, pDataSet, fCallback, pContextArray, pScope, pState);
			}

			let tmpAuditPrep = tmpAudit.prepareState(pState, pTemplateString.substring(0, 80));
			let tmpState = tmpAuditPrep.state;
			let tmpAuditContext = tmpAudit.beginAudit(tmpState, tmpAuditPrep.identifier, 'parseTemplateSet', pDataSet);

			if (typeof fCallback === 'function')
			{
				let tmpWrappedCallback = function _auditSetCallback(pError, pResult)
				{
					tmpAudit.endAudit(tmpState, tmpAuditContext);
					return fCallback(pError, pResult);
				};
				return tmpAudit._originalParseTemplateSet(pTemplateString, pDataSet, tmpWrappedCallback, pContextArray, pScope, tmpState);
			}
			else
			{
				let tmpResult = tmpAudit._originalParseTemplateSet(pTemplateString, pDataSet, null, pContextArray, pScope, tmpState);
				tmpAudit.endAudit(tmpState, tmpAuditContext);
				return tmpResult;
			}
		};

		// -- parseTemplateSetByHash wrapper --
		tmpPict.parseTemplateSetByHash = function _auditParseTemplateSetByHash(pTemplateHash, pDataSet, fCallback, pContextArray, pScope, pState)
		{
			if (!tmpPict.TemplateDebug)
			{
				return tmpAudit._originalParseTemplateSetByHash(pTemplateHash, pDataSet, fCallback, pContextArray, pScope, pState);
			}

			let tmpState = tmpAudit.setHashHint(pState, pTemplateHash);
			return tmpAudit._originalParseTemplateSetByHash(pTemplateHash, pDataSet, fCallback, pContextArray, pScope, tmpState);
		};

		// -- parseTemplateSetWithPayload wrapper --
		tmpPict.parseTemplateSetWithPayload = function _auditParseTemplateSetWithPayload(pTemplateString, pDataSet, pPayload, fCallback, pContextArray, pScope, pState)
		{
			if (!tmpPict.TemplateDebug)
			{
				return tmpAudit._originalParseTemplateSetWithPayload(pTemplateString, pDataSet, pPayload, fCallback, pContextArray, pScope, pState);
			}

			let tmpAuditPrep = tmpAudit.prepareState(pState, pTemplateString.substring(0, 80));
			let tmpState = tmpAuditPrep.state;
			let tmpAuditContext = tmpAudit.beginAudit(tmpState, tmpAuditPrep.identifier, 'parseTemplateSetWithPayload', pDataSet);

			if (typeof fCallback === 'function')
			{
				let tmpWrappedCallback = function _auditSetPayloadCallback(pError, pResult)
				{
					tmpAudit.endAudit(tmpState, tmpAuditContext);
					return fCallback(pError, pResult);
				};
				return tmpAudit._originalParseTemplateSetWithPayload(pTemplateString, pDataSet, pPayload, tmpWrappedCallback, pContextArray, pScope, tmpState);
			}
			else
			{
				let tmpResult = tmpAudit._originalParseTemplateSetWithPayload(pTemplateString, pDataSet, pPayload, null, pContextArray, pScope, tmpState);
				tmpAudit.endAudit(tmpState, tmpAuditContext);
				return tmpResult;
			}
		};

		// -- parseTemplateSetWithPayloadByHash wrapper --
		tmpPict.parseTemplateSetWithPayloadByHash = function _auditParseTemplateSetWithPayloadByHash(pTemplateHash, pDataSet, pPayload, fCallback, pContextArray, pScope, pState)
		{
			if (!tmpPict.TemplateDebug)
			{
				return tmpAudit._originalParseTemplateSetWithPayloadByHash(pTemplateHash, pDataSet, pPayload, fCallback, pContextArray, pScope, pState);
			}

			let tmpState = tmpAudit.setHashHint(pState, pTemplateHash);
			return tmpAudit._originalParseTemplateSetWithPayloadByHash(pTemplateHash, pDataSet, pPayload, fCallback, pContextArray, pScope, tmpState);
		};
	}

	unwrapTemplateFunctions()
	{
		let tmpPict = this.fable;

		if (this._originalParseTemplate && typeof(this._originalParseTemplate) === 'function')
		{
			tmpPict.parseTemplate = this._originalParseTemplate;
			this._originalParseTemplate = null;
		}

		if (this._originalParseTemplateByHash && typeof(this._originalParseTemplateByHash) === 'function')
		{
			tmpPict.parseTemplateByHash = this._originalParseTemplateByHash;
			this._originalParseTemplateByHash = null;
		}

		if (this._originalParseTemplateSet && typeof(this._originalParseTemplateSet) === 'function')
		{
			tmpPict.parseTemplateSet = this._originalParseTemplateSet;
			this._originalParseTemplateSet = null;
		}

		if (this._originalParseTemplateSetByHash && typeof(this._originalParseTemplateSetByHash) === 'function')
		{
			tmpPict.parseTemplateSetByHash = this._originalParseTemplateSetByHash;
			this._originalParseTemplateSetByHash = null;
		}

		if (this._originalParseTemplateSetWithPayload && typeof(this._originalParseTemplateSetWithPayload) === 'function')
		{
			tmpPict.parseTemplateSetWithPayload = this._originalParseTemplateSetWithPayload;
			this._originalParseTemplateSetWithPayload = null;
		}
	}

	/**
	 * Begin an audit node for template processing.
	 *
	 * @param {any} pState - The state object threading through template processing
	 * @param {string} pTemplateIdentifier - Hash or preview of the template
	 * @param {string} pEntrypoint - Name of the entry function
	 * @param {any} pData - The data passed to the template
	 *
	 * @return {object|null} The audit context, or null if auditing is disabled
	 */
	beginAudit(pState, pTemplateIdentifier, pEntrypoint, pData)
	{
		if (!this.fable.TemplateDebug)
		{
			return null;
		}

		let tmpAuditNode =
		{
			TemplateHash: pTemplateIdentifier,
			Entrypoint: pEntrypoint,
			StartTime: Date.now(),
			FinishTime: null,
			Duration: null,
			DataSize: (typeof pData === 'object' && pData !== null) ? JSON.stringify(pData).length : 0,
			StackTrace: null,
			ChildTemplates: []
		};

		if (this.fable.TemplateDebugStack)
		{
			tmpAuditNode.StackTrace = new Error().stack;
		}

		if (pState && pState._TemplateAuditParent)
		{
			// Child template -- append to parent
			pState._TemplateAuditParent.ChildTemplates.push(tmpAuditNode);
		}
		else
		{
			// Root-level template call
			this.auditLog.push(tmpAuditNode);
		}

		let tmpPreviousParent = (pState && pState._TemplateAuditParent) ? pState._TemplateAuditParent : null;
		if (pState)
		{
			pState._TemplateAuditParent = tmpAuditNode;
		}

		return { AuditNode: tmpAuditNode, PreviousParent: tmpPreviousParent };
	}

	/**
	 * End an audit node for template processing.
	 *
	 * @param {any} pState - The state object threading through template processing
	 * @param {object} pAuditContext - The object returned by beginAudit
	 */
	endAudit(pState, pAuditContext)
	{
		if (!pAuditContext)
		{
			return;
		}
		pAuditContext.AuditNode.FinishTime = Date.now();
		pAuditContext.AuditNode.Duration = pAuditContext.AuditNode.FinishTime - pAuditContext.AuditNode.StartTime;

		if (pState)
		{
			pState._TemplateAuditParent = pAuditContext.PreviousParent;
		}
	}

	/**
	 * Prepare pState for auditing, auto-creating if needed.
	 * Also consumes any _TemplateAuditHashHint to resolve the identifier.
	 *
	 * @param {any} pState - The current state object (may be null/undefined)
	 * @param {string} pFallbackIdentifier - Fallback identifier if no hash hint is set
	 *
	 * @return {{ state: any, identifier: string }} The prepared state and resolved identifier
	 */
	prepareState(pState, pFallbackIdentifier)
	{
		let tmpState = pState;
		if (this.fable.TemplateDebug && !tmpState)
		{
			tmpState = {};
		}

		let tmpIdentifier = pFallbackIdentifier;
		if (tmpState && tmpState._TemplateAuditHashHint)
		{
			tmpIdentifier = tmpState._TemplateAuditHashHint;
			delete tmpState._TemplateAuditHashHint;
		}

		return { state: tmpState, identifier: tmpIdentifier };
	}

	/**
	 * Set a hash hint on pState so the next audit node uses the hash name.
	 *
	 * @param {any} pState - The current state object (may be null/undefined)
	 * @param {string} pHash - The template hash to use as the identifier
	 *
	 * @return {any} The state object (auto-created if needed)
	 */
	setHashHint(pState, pHash)
	{
		let tmpState = pState;
		if (this.fable.TemplateDebug)
		{
			if (!tmpState) { tmpState = {}; }
			tmpState._TemplateAuditHashHint = pHash;
		}
		return tmpState;
	}

	/**
	 * Clear the audit log.
	 */
	clear()
	{
		this.auditLog = [];
	}

	/**
	 * Get a summary of the audit log.
	 *
	 * @return {object} Summary statistics
	 */
	getSummary()
	{
		let tmpTotalCalls = 0;
		let tmpTotalDuration = 0;
		let tmpMaxDepth = 0;

		let fWalkNode = (pNode, pDepth) =>
		{
			tmpTotalCalls++;
			tmpTotalDuration += (pNode.Duration || 0);
			if (pDepth > tmpMaxDepth)
			{
				tmpMaxDepth = pDepth;
			}
			for (let i = 0; i < pNode.ChildTemplates.length; i++)
			{
				fWalkNode(pNode.ChildTemplates[i], pDepth + 1);
			}
		};

		for (let i = 0; i < this.auditLog.length; i++)
		{
			fWalkNode(this.auditLog[i], 0);
		}

		return {
			RootCalls: this.auditLog.length,
			TotalCalls: tmpTotalCalls,
			TotalDuration: tmpTotalDuration,
			MaxDepth: tmpMaxDepth
		};
	}
}

module.exports = PictTemplateAudit;

/** @type {Record<string, any>} */
PictTemplateAudit.default_configuration = {};

},{"fable":68}],200:[function(require,module,exports){
const libFableServiceBase = require('fable').ServiceProviderBase;

class PictTemplateProvider extends libFableServiceBase
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.log;
		/** @type {string} */
		this.UUID;
		/** @type {string} */
		this.Hash;

		this.serviceType = 'PictTemplateProvider';

		this.templates = {};
		this.templateSources = {};

		// Default templates are stored by prefix.
		// The longest prefix match is used.
		// Case sensitive.
		this.defaultTemplates = [];

		/**
		 * @type {(hash?: string) => { template: string, source: string }?} loadTemplateFunction - The function to load a template
		 */
		this.loadTemplateFunction = () => { return null; };
	}

	/**
	 * Add a template to the provider.
	 *
	 * @param {String} pTemplateHash - The hash of the template
	 * @param {String} pTemplate - The template
	 * @param {String} [pTemplateSource] - (optional) The source of the template
	 */
	addTemplate(pTemplateHash, pTemplate, pTemplateSource)
	{
		this.templates[pTemplateHash] = pTemplate;

		if (typeof(pTemplateSource) == 'string')
		{
			this.templateSources[pTemplateHash] = pTemplateSource;
		}
		else
		{
			this.templateSources[pTemplateHash] = `Direct addTemplate('${pTemplateHash}') function load into PictTemplateProvider [${this.UUID}]::[${this.Hash}]`;
		}
	}

	/**
	 * Add a default template to the provider.
	 *
	 * @param {String} pPrefix - The prefix of the template identifier.
	 * @param {String} pPostfix - The postfix of the template identifier.
	 * @param {String} pTemplate - The template
	 * @param {String} [pSource] - (optional) The source of the template
	 */
	addDefaultTemplate(pPrefix, pPostfix, pTemplate, pSource)
	{
		let tmpSource = (typeof(pSource) == 'string') ? pSource : `Direct addDefaultTemplate('${pPrefix}','${pPostfix}',..) function load into PictTemplateProvider [${this.UUID}]::[${this.Hash}]`
		let tmpDefaultTemplate = {
			prefix: pPrefix,
			postfix: pPostfix,
			template: pTemplate,
			source: tmpSource
		};
		if (typeof(pTemplate) != 'string')
		{
			this.log.error('PictTemplateProvider.addDefaultTemplate: pTemplate is not a string.');
		}
		this.defaultTemplates.push(tmpDefaultTemplate);
	}

	/**
	 * Attempt to populate a template to a default template if it matches a given hash.
	 *
	 * Default templates are managed by postfix and prefix.  The use case is things like titles, headers, list
	 * wrappers, rows, etc.
	 *
	 * So we might have a default template for a list wrapper and it should expect "-ListWrap" as the postfix.
	 * And we might have a default template for a list row and it should expect "-ListRow" as the postfix.
	 * The list might have a "-ListTitle", or we might have shared titles and it would just be "-Title".
	 *
	 * The idea is to allow fallbacks on defaults.
	 *
	 * @param {String} pTemplateHash - The hash of the template
	 * @return {string} - The template, or false if not found
	 */
	checkDefaultTemplateHash(pTemplateHash)
	{
		for (let i = 0; i < this.defaultTemplates.length; i++)
		{
			if ((pTemplateHash.indexOf(this.defaultTemplates[i].postfix) == pTemplateHash.length - this.defaultTemplates[i].postfix.length)
				&& (pTemplateHash.indexOf(this.defaultTemplates[i].prefix) == 0))
			{
				this.templates[pTemplateHash] = this.defaultTemplates[i].template;
				this.templateSources[pTemplateHash] = `Auto created in checkDefaultTemplateHash('${pTemplateHash}') function by PictTemplateProvider [${this.UUID}]::[${this.Hash}] from [${this.defaultTemplates[i].prefix}]...[${this.defaultTemplates[i].postfix}]`;
				return this.templates[pTemplateHash];
			}
		}
		return null;
	}

	/**
	 * Get a template by hash.
	 *
	 * @param {String} pTemplateHash - The hash of the template
	 * @return {String} - The template, or false if not found
	 */
	getTemplate(pTemplateHash)
	{
		// TODO: Optimize this.
		// If the template doesn't exist, try to load it with the loading function
		if (!(pTemplateHash in this.templates))
		{
			this.loadTemplate(pTemplateHash);
		}
		// If the loading function fails, try to load it from the default templates
		if (!(pTemplateHash in this.templates))
		{
			this.checkDefaultTemplateHash(pTemplateHash);
		}
		if ((pTemplateHash in this.templates))
		{
			return this.templates[pTemplateHash];
		}
		return null;
	}

	/**
	 * Load a template by hash.
	 *
	 * @param {String} pTemplateHash - The hash of the template
	 */
	loadTemplate(pTemplateHash)
	{
		let tmpTemplate = this.loadTemplateFunction(pTemplateHash);

		if (tmpTemplate)
		{
			this.templates[pTemplateHash] = tmpTemplate.template;
			this.templateSources[pTemplateHash] = `Loaded in loadTemplate('${pTemplateHash}') function by PictTemplateProvider [${this.UUID}]::[${this.Hash}] from [${tmpTemplate.source}]`;

		}

		return tmpTemplate;
	}
}

module.exports = PictTemplateProvider;

},{"fable":68}],201:[function(require,module,exports){
/**
 * @author <steven@velozo.com>
 */
const libFableServiceTransactionTracking = require(`./services/Fable-Service-TransactionTracking.js`);

/**
 * @typedef {{
 *    UUID: string,
 *    settings: any,
 *    fable: Fable,
 *    servicesMap: any,
 *    addAndInstantiateServiceType: (hash: string, prototype: any) => any,
 *    addServiceTypeIfNotExists: (hash: string, prototype: any) => any,
 *    addServiceType: (hash: string, prototype: any) => any,
 *    instantiateServiceProvider: (hash: string, options?: any, prototype?: any) => any,
 *    instantiateServiceProviderWithoutRegistration: (hash: string) => any,
 *    instantiateServiceProviderFromPrototype: (pServiceType: string, pOptions?: any, pCustomServiceHash?: string, pServicePrototype?: any) => any,
 *    getUUID: () => string,
 *    Utility:
 *    {
 *				extend: (pObject: any, ...pExtension: any[]) => any,
 *				eachLimit: (pArray: any[], pLimit: number, pIterator: (pRecord: any, fRecordCallback: () => void) => void, fCallback: (pError: any) => void) => void,
 *    },
 *    MetaTemplate: any,
 * }} Fable
 */
/** @type {{ new(...args: any[]): Fable }} */
const libFable = require('fable');

const libPackage = require('../package.json');
const libProviderFilterManager = require('./providers/Provider-Filter-Manager.js');
const libProviderDataBroker = require('./providers/Provider-DataBroker.js');
const libProviderIcon = require('./providers/Provider-Icon.js');

const PictTemplateProvider = require('./Pict-Template-Provider.js');
const PictTemplateAudit = require('./Pict-Template-Audit.js');
const PictContentAssignment = require('./Pict-Content-Assignment.js');
const PictDataProvider = require('./Pict-DataProvider.js');
const PictCSS = require('./Pict-CSS.js');
const PictMeadowEntityProvider = require('./Pict-Meadow-EntityProvider.js');

/**
 * Pict management object.
 */
class Pict extends libFable {
	/**
	 * @param {Object<String, any>} pSettings - The settings for the Pict instance.
	 */
	constructor(pSettings) {
		super(pSettings);

		/** @type {any} */
		this.settings;
		/** @type {Record<string, any>} */
		this.services;
		/** @type {Record<string, any>} */
		this.servicesMap;

		this.isBrowser = new Function(
			"try {return (this===window);} catch(pError) {return false;}",
		);

		/** @type {Object} */
		this._PackageFable = this._Package;
		/** @type {Record<string, any>} */
		this._Package = libPackage;

		this.browserAddress = "window._Pict";
		if ("BrowserAddress" in this.settings) {
			this.browserAddress = this.settings.BrowserAddress;
		}
		this.children = [];

		/** @type {import('pict-application')} */
		this.PictApplication = null;
		// shim types from fable until we export types properly
		/** @type {any} */
		this.log;
		//NOTE: This needs to come before any other providers which may instantiate a rest client so we don't proliferate them
		this.instantiateServiceProvider("RestClient");
		/**
		 * The templateProvider provides a basic key->template mapping with default fallback capabilities
		 *
		 * @type {PictTemplateProvider}
		 */
		this.TemplateProvider = null;
		this.addAndInstantiateServiceType("TemplateProvider", PictTemplateProvider);
		/**
		 * The template audit provider.
		 *
		 * @type {PictTemplateAudit}
		 */
		this.TemplateAudit = null;
		this.addAndInstantiateServiceType("TemplateAudit", PictTemplateAudit);
		/**
		 * The meadow entity provider.
		 *
		 * @type {PictMeadowEntityProvider}
		 */
		this.EntityProvider = null;
		this.addAndInstantiateServiceType(
			"EntityProvider",
			PictMeadowEntityProvider,
		);
		/**
		 * The data provider.
		 *
		 * @type {PictDataProvider}
		 */
		this.DataProvider = null;
		this.addAndInstantiateServiceType("DataProvider", PictDataProvider);

		this.addServiceTypeIfNotExists('TransactionTracking', libFableServiceTransactionTracking);
		/**
		 * The content assignment module.
		 *
		 * @type {PictContentAssignment}
		 */
		this.ContentAssignment = null;
		this.expressionParser = this.instantiateServiceProvider("ExpressionParser");
		this.addAndInstantiateServiceType(
			"ContentAssignment",
			PictContentAssignment,
		);
		/**
		 * The CSS module.
		 *
		 * @type {PictCSS}
		 * @public
		 */
		this.CSSMap = null;
		this.addAndInstantiateServiceType("CSSMap", PictCSS);

		this.addServiceType("PictTemplate", require("pict-template"));
		this.instantiateServiceProvider("MetaTemplate");
		this.instantiateServiceProvider("DataGeneration");

		this.manifest = this.instantiateServiceProvider("Manifest");

		/** @type {Record<string, any>} */
		this.AppData = {};
		if ("DefaultAppData" in this.fable.settings)
		{
			this.AppData = this.fable.settings.DefaultAppData;
		}

		/** @type {Record<string, any>} */
		// Added for transitory data like chart data caches
		this.TempData = {};

		/** @type {Record<string, any>} */
		this.Bundle = {};
		if ("DefaultBundle" in this.fable.settings)
		{
			this.Bundle = this.fable.settings.DefaultBundle;
		}

		// Log noisness goes from 0 - 5, where 5 is show me everything.
		this.LogNoisiness = 0;
		// Although we have log noisiness, sometimes we need control flow without all the other noise for hard to diagnose interpreters.
		this.LogControlFlow = false;
		// And an easy way to be introspective about data at various locations
		this.LogControlFlowWatchAddressList = [];

		// Template auditing -- when enabled, builds a tree of template processing info
		this.TemplateDebug = false;
		// Secondary flag to capture real Error().stack traces (expensive, off by default)
		this.TemplateDebugStack = false;

		// Load manifest sets
		if (this.settings.Manifests) {
			this.loadManifestSet(this.settings.Manifests);
		}

		this._DefaultPictTemplatesInitialized = false;
		this.initializePictTemplateEngine();

		this.addServiceType("PictView", require("pict-view"));
		this.addServiceType("PictProvider", require("pict-provider"));
		this.addServiceType("PictApplication", require("pict-application"));

		// Expose the named views directly, through a convenience accessor
		/** @type {{ FilterManager: libProviderFilterManager, [key: string]: any }} */
		this.providers = this.servicesMap.PictProvider;
		this.views = this.servicesMap.PictView;

		this.addProvider('FilterManager', {}, libProviderFilterManager);
		this.addProvider('DataBroker', {}, libProviderDataBroker);
		this.addProvider('Icon', {}, libProviderIcon);
	}

	/**
	 * Convenience accessor for the built-in icon registry — equivalent to
	 * `pict.providers.Icon.get(name, opts)`.  Always returns a string
	 * (never throws, never undefined); a missing icon emits a visible
	 * question-mark glyph so the gap is obvious in the UI.
	 *
	 * @param {string} pName     PascalCase icon name, or an alias.
	 * @param {object} [pOpts]   { variant, size, class, ariaLabel }
	 * @returns {string}
	 */
	icon(pName, pOpts)
	{
		if (!this.providers || !this.providers.Icon)
		{
			return '';
		}
		return this.providers.Icon.get(pName, pOpts);
	}

	/**
	 * Load manifests in as Hashed services
	 *
	 * @param {Object<String, String>} pManifestSet - The manifest set to load.
	 */
	loadManifestSet(pManifestSet) {
		if (typeof pManifestSet != "object") {
			this.log.warn(
				`PICT [${this.UUID}] could not load Manifest Set; pManifestSet was not an object.`,
			);
			return;
		}
		let tmpManifestKeys = Object.keys(pManifestSet);
		if (tmpManifestKeys.length > 0) {
			for (let i = 0; i < tmpManifestKeys.length; i++) {
				// Load each manifest
				let tmpManifestKey = tmpManifestKeys[i];
				this.instantiateServiceProvider(
					"Manifest",
					pManifestSet[tmpManifestKey],
					tmpManifestKey,
				);
			}
		}
	}

	/**
	 * Add a template expression to the template engine from the PictTemplate service.
	 *
	 * @template {new (...args: any[]) => any} T
	 * @param {T} pTemplatePrototype - The prototype class for the template expression
	 *
	 * @return {InstanceType<T>} the service instance, or null if the prototype was invalid
	 */
	addTemplate(pTemplatePrototype) {
		if (typeof pTemplatePrototype != "function") {
			this.log.warn(
				`PICT [${this.UUID}] could not add Template; pTemplatePrototype was not a class it was ${typeof pTemplatePrototype}.`,
			);
			return null;
		}

		let tmpTemplateHash = pTemplatePrototype["template_hash"];

		if (this.LogNoisiness > 1) {
			this.log.info(`PICT-ControlFlow addTemplate [${tmpTemplateHash}]`);
		}

		return this.instantiateServiceProviderFromPrototype(
			"PictTemplate",
			{},
			tmpTemplateHash,
			pTemplatePrototype,
		);
	}

	/**
	 * Just passing an options will construct one for us.
	 * Passing a hash will set the hash.
	 * Passing a prototype will use that!
	 *
	 * @template {new (...args: any[]) => any} [T=typeof import('pict-view')]
	 * @param {String} pViewHash - The hash of the view.
	 * @param {Object<String, any>} [pOptions] - The options for the view.
	 * @param {T} [pViewPrototype] - The prototype for the view.
	 *
	 * @return {InstanceType<T>} The view instance.
	 */
	addView(pViewHash, pOptions, pViewPrototype) {
		let tmpOptions = typeof pOptions == "object" ? pOptions : {};
		let tmpViewHash =
			typeof pViewHash == "string" ? pViewHash : this.fable.getUUID();
		// This is here to change how the value is managed by webpack
		let tmpViewPrototype = pViewPrototype;

		if (this.LogControlFlow) {
			if (this.LogNoisiness > 1) {
				this.log.info(`PICT-ControlFlow addView [${tmpViewHash}]:`, {
					Options: tmpOptions,
				});
			} else {
				this.log.info(`PICT-ControlFlow addView [${tmpViewHash}]`);
			}
		}

		if (tmpViewPrototype) {
			// If the prototype has a default_configuration, it will be merged with options.
			const tmpDefaultViewConfiguration =
				tmpViewPrototype["default_configuration"];
			if (tmpDefaultViewConfiguration) {
				tmpOptions = this.fable.Utility.extend(
					{},
					JSON.parse(JSON.stringify(tmpDefaultViewConfiguration)),
					tmpOptions,
				);
			}
			return this.instantiateServiceProviderFromPrototype(
				"PictView",
				tmpOptions,
				tmpViewHash,
				tmpViewPrototype,
			);
		} else {
			return this.instantiateServiceProvider(
				"PictView",
				tmpOptions,
				tmpViewHash,
			);
		}
	}

	/**
	 * Add a view unless one already exists, then return that one.
	 * Just passing an options will construct one for us.
	 * Passing a hash will set the hash.
	 * Passing a prototype will use that!
	 *
	 * @param {String} pViewHash - The hash of the view.
	 * @param {Object<String, any>} [pOptions] - The options for the view.
	 * @param {any} [pViewPrototype] - The prototype for the view.
	 * @return {any} The view instance.
	 */
	addViewSingleton(pViewHash, pOptions, pViewPrototype)
	{
		if (pViewHash in this.views)
		{
			return this.views[pViewHash];
		}
		return this.addView(pViewHash, pOptions, pViewPrototype);
	}

	/**
	 * Add a provider unless one already exists, then return that one.
	 *
	 * Just passing an options will construct one for us.
	 * Passing a hash will set the hash.
	 * Passing a prototype will use that!
	 *
	 * @param {String} pProviderHash - The hash of the provider.
	 * @param {Object<String, any>} [pOptions] - The options for the provider.
	 * @param {any} [pProviderPrototype] - The prototype for the provider.
	 *
	 * FIXME: refer to PictProvider here once it has a type definition
	 *
	 * @return {any} The provider instance.
	 */
	addProviderSingleton(pProviderHash, pOptions, pProviderPrototype) {
		if (pProviderHash in this.providers) {
			return this.providers[pProviderHash];
		}
		return this.addProvider(pProviderHash, pOptions, pProviderPrototype);
	}

	/**
	 * @return {libFableServiceTransactionTracking}
	 */
	newTransactionTracker()
	{
		return this.instantiateServiceProviderWithoutRegistration('TransactionTracking');
	}

	/**
	 * Add an Expression Parser function to the solver.
	 *
	 * @param {Object} pExpressionParser - The expresssion parser to add the function to
	 * @param {string} pFunctionName - The name of the function
	 * @param {string} pFunctionAddress - The address of the function
	 * @param {string} pFunctionComment - A comment about the function
	 */
	addSolverFunction(pExpressionParser, pFunctionName, pFunctionAddress, pFunctionComment)
	{
		let tmpFunctionName = (pFunctionName || '').trim().toLowerCase();
		let tmpExpressionParser = pExpressionParser;
		if (!tmpExpressionParser || typeof(tmpExpressionParser) !== 'object' || !tmpExpressionParser.functionMap)
		{
			tmpExpressionParser = this.expressionParser;
		}
		if (tmpExpressionParser.functionMap.hasOwnProperty(tmpFunctionName))
		{
			this.log.warn(`Pict: Function ${tmpFunctionName} already exists in the solver, overwriting with address [${pFunctionAddress}].`);
			//return false;
		}
		tmpExpressionParser.functionMap[tmpFunctionName] = (
		{
			Name: pFunctionComment || `Autogenerated PICT function ${tmpFunctionName}`,
			Address: pFunctionAddress,
		});

		return tmpExpressionParser.functionMap[tmpFunctionName];
	}

	/**
	 * Just passing an options will construct one for us.
	 * Passing a hash will set the hash.
	 * Passing a prototype will use that!
	 *
	 * @param {String} pProviderHash - The hash of the provider.
	 * @param {Object<String, any>} [pOptions] - The options for the provider.
	 * @param {any} [pProviderPrototype] - The prototype for the provider.
	 *
	 * FIXME: refer to PictProvider here once it has a type definition
	 *
	 * @return {any} The provider instance.
	 */
	addProvider(pProviderHash, pOptions, pProviderPrototype) {
		let tmpOptions = typeof pOptions == "object" ? pOptions : {};
		let tmpProviderHash =
			typeof pProviderHash == "string" ? pProviderHash : this.fable.getUUID();

		if (this.LogControlFlow) {
			if (this.LogNoisiness > 1) {
				this.log.info(`PICT-ControlFlow addProvider [${tmpProviderHash}]:`, {
					Options: tmpOptions,
				});
			} else {
				this.log.info(`PICT-ControlFlow addProvider [${tmpProviderHash}]`);
			}
		}

		if (typeof pProviderPrototype != "undefined") {
			// If the prototype has a default_configuration, it will be merged with options.
			if ("default_configuration" in pProviderPrototype) {
				tmpOptions = this.fable.Utility.extend(
					{},
					pProviderPrototype.default_configuration,
					tmpOptions,
				);
			}
			return this.instantiateServiceProviderFromPrototype(
				"PictProvider",
				tmpOptions,
				tmpProviderHash,
				pProviderPrototype,
			);
		} else {
			return this.instantiateServiceProvider(
				"PictProvider",
				tmpOptions,
				tmpProviderHash,
			);
		}
	}

	/**
	 * Just passing an options will construct one for us.
	 * Passing a hash will set the hash.
	 * Passing a prototype will use that!
	 *
	 * @param {String} pApplicationHash - The hash of the application.
	 * @param {Object} [pOptions] - The options for the application.
	 * @param {any} [pApplicationPrototype] - The prototype for the application.
	 *
	 * FIXME: refer to PictApplication here once it has a type definition
	 *
	 * @return {any} The application instance.
	 */
	addApplication(pApplicationHash, pOptions, pApplicationPrototype) {
		let tmpOptions = typeof pOptions == "object" ? pOptions : {};
		let tmpApplicationHash =
			typeof pApplicationHash == "string"
				? pApplicationHash
				: this.fable.getUUID();

		if (this.LogControlFlow) {
			if (this.LogNoisiness > 1) {
				this.log.info(
					`PICT-ControlFlow addApplication [${tmpApplicationHash}]:`,
					{ Options: tmpOptions },
				);
			} else {
				this.log.info(
					`PICT-ControlFlow addApplication [${tmpApplicationHash}]`,
				);
			}
		}

		if (typeof pApplicationPrototype != "undefined") {
			// If the prototype has a default_configuration, it will be merged with options.
			if ("default_configuration" in pApplicationPrototype) {
				tmpOptions = this.fable.Utility.extend(
					{},
					pApplicationPrototype.default_configuration,
					tmpOptions,
				);
			}

			return this.instantiateServiceProviderFromPrototype(
				"PictApplication",
				tmpOptions,
				tmpApplicationHash,
				pApplicationPrototype,
			);
		} else {
			return this.instantiateServiceProvider(
				"PictApplication",
				tmpOptions,
				tmpApplicationHash,
			);
		}
	}

	/**
	 * Attach the default template engine renderers.
	 *
	 * TODO: Move this to a one-time service
	 *
	 * @private
	 */
	initializePictTemplateEngine() {
		if (!this._DefaultPictTemplatesInitialized) {
			// Just looking up data in the application state template expression
			//{~Data:AppData.Some.Value.to.Render~}
			//{~D:AppData.Some.Value.to.Render~}
			this.addTemplate(require(`./templates/Pict-Template-Data.js`));

			this.addTemplate(require(`./templates/Pict-Template-DataWithTemplateFallback.js`));

			this.addTemplate(require(`./templates/Pict-Template-DataWithAbsoluteFallback.js`));

			this.addTemplate(require(`./templates/Pict-Template-TemplateByReference.js`));

			this.addTemplate(require(`./templates/Pict-Template-TemplateFromAddress.js`));

			this.addTemplate(require(`./templates/Pict-Template-TemplateByTypes.js`));

			this.addTemplate(require(`./templates/Pict-Template-DataValueByKey.js`));

			this.addTemplate(require(`./templates/Pict-Template-View.js`));

			this.addTemplate(require(`./templates/data/Pict-Template-DataEncodeJavascriptString.js`));

			// HTML Comment Start and End based on truthiness ... if the value is false, the comment shows up.
			// {~HtmlCommentStart:Some.Address~} gives you "<!--"
			// {~HCS:Some.Address~} gives you "<!--"
			this.addTemplate(
				require(`./templates/data/Pict-Template-HtmlCommentStart.js`),
			);
			// {~HtmlCommentEnd:Some.Address~} gives you "-->"
			// {~HCE:Some.Address~} gives you "-->"
			this.addTemplate(
				require(`./templates/data/Pict-Template-HtmlCommentEnd.js`),
			);

			// Know the in-browser reference for Pict when appropriate
			this.addTemplate(require(`./templates/Pict-Template-Self.js`));

			// Built-in icon glyph by PascalCase name.
			//   {~Icon:Home~}              default variant
			//   {~Icon:Folder:Filled~}     explicit variant
			//   {~I:Spreadsheet~}          short alias
			//   {~I:File:Filled~}          short + variant
			// Backed by pict.providers.Icon — host modules register
			// additional glyphs via pict.providers.Icon.registerSet().
			this.addTemplate(require(`./templates/Pict-Template-Icon.js`));

			// Look up an entity template expression
			// {~Entity:Book^AppData.Some.Address.IDBook^Render-Book-Template~}
			// {~E:Book^AppData.Some.Address.IDBook^Render-Book-Template~}
			// ...meaning GET BOOK with IDBook FROM AppData.Some.Address.IDBook and render it to Render-Book-Template
			this.addTemplate(require(`./templates/Pict-Template-Entity.js`));

			// Child Template Expressions
			// {~T:Template:AddressOfData~}
			this.addTemplate(require(`./templates/Pict-Template-Template.js`));
			this.addTemplate(require(`./templates/Pict-Template-TemplateByDataAddress.js`));
			// Inline Template Expression -- parse the contents as a template at runtime
			// {<TEMPLATED CONTENT HERE, {~D:AppData.SomeValue~}.>}
			this.addTemplate(require(`./templates/Pict-Template-InlineTemplate.js`));
			// Function Expression -- call a function by address with addressed arguments
			// {~Function:Pict.providers.X.makeThing:Record.X:Record.Y~}  /  {~F:...~}
			this.addTemplate(require(`./templates/Pict-Template-Function.js`));
			// Addressed Template Expression -- resolve an address to a template string and render it
			// {[AppData.MyTemplate]}
			this.addTemplate(require(`./templates/Pict-Template-AddressedTemplate.js`));
			// {~SBR:AppData.Equation:AppData.HomeworkRectangleSize:AppData.HomeworkManifest~}
			this.addTemplate(require(`./templates/Pict-Template-SolveByReference.js`));
			this.addTemplate(require(`./templates/Pict-Template-Solve.js`));
			// {~TS:Template:AddressOfDataSet~}
			this.addTemplate(require(`./templates/Pict-Template-TemplateSet.js`));
			// {~TVS:Template:AddressOfDataSet~}
			this.addTemplate(
				require(`./templates/Pict-Template-TemplateValueSet.js`),
			);
			this.addTemplate(
				require(`./templates/Pict-Template-TemplateSetWithPayload.js`),
			);
			this.addTemplate(require(`./templates/Pict-Template-TemplateFromMap.js`));
			this.addTemplate(
				require(`./templates/Pict-Template-TemplateSetFromMap.js`),
			);

			// Logical Branching Template Expressions
			// {~TemplateIf:Template:AddressOfData:AppData.Some.Address.IDBook^OPERATOR^AppData.Some.Address2.IDBook~}
			// {~TIf:Template:AddressOfData:AppData.Some.Address.IDBook^OPERATOR^AppData.Some.Address2.IDBook~}
			this.addTemplate(
				require(`./templates/logic/Pict-Template-TemplateIf.js`),
			);
			// {~TemplateIfAbsolute:Template:AddressOfData:AppData.Some.Address.IDBook^OPERATOR^Absolute_Value~}
			// {~TIfAbs:Template:AddressOfData:AppData.Some.Address.IDBook^OPERATOR^Absolute_Value~}
			this.addTemplate(
				require(`./templates/logic/Pict-Template-TemplateIfAbsolute.js`),
			);
			// {~NotEmpty:AppData.Some.Address^Absolute Value~}
			this.addTemplate(require(`./templates/logic/Pict-Template-NotEmpty.js`));

			// Data Manipulation Templates
			this.addTemplate(require(`./templates/data/Pict-Template-DataJson.js`));
			this.addTemplate(
				require(`./templates/data/Pict-Template-PascalCaseIdentifier.js`),
			);
			this.addTemplate(
				require(`./templates/data/Pict-Template-DateOnlyFormat.js`),
			);
			this.addTemplate(
				require(`./templates/data/Pict-Template-DateOnlyYMD.js`),
			);
			this.addTemplate(
				require(`./templates/data/Pict-Template-DateTimeFormat.js`),
			);
			this.addTemplate(
				require(`./templates/data/Pict-Template-DateTimeYMD.js`),
			);
			this.addTemplate(require(`./templates/data/Pict-Template-Digits.js`));
			this.addTemplate(require(`./templates/data/Pict-Template-Dollars.js`));

			this.addTemplate(require(`./templates/data/Pict-Template-Join.js`));
			this.addTemplate(require(`./templates/data/Pict-Template-JoinUnique.js`));
			this.addTemplate(
				require(`./templates/data/Pict-Template-PluckJoinUnique.js`),
			);

			// Data Generation Templates
			this.addTemplate(
				require(`./templates/data-generation/Pict-Template-RandomNumber.js`),
			);
			this.addTemplate(
				require(
					`./templates/data-generation/Pict-Template-RandomNumberString.js`,
				),
			);

			// Debugging Templates
			this.addTemplate(
				require(`./templates/debugging/Pict-Template-Breakpoint.js`),
			);
			this.addTemplate(
				require(`./templates/debugging/Pict-Template-LogStatement.js`),
			);
			this.addTemplate(
				require(`./templates/debugging/Pict-Template-LogValue.js`),
			);
			this.addTemplate(
				require(`./templates/debugging/Pict-Template-LogValueTree.js`),
			);
			this.addTemplate(
				require(`./templates/debugging/Pict-Template-DataValueTree.js`),
			);

			this._DefaultPictTemplatesInitialized = true;
		}
	}

	/**
	 * Read a value from a nested object using a dot notation string.
	 *
	 * TODO: re-home this in the data broker
	 *
	 * @param {string} pAddress - The address to resolve
	 * @param {Record<string, any>} [pRecord] - The record to resolve
	 * @param {Array<any>} [pContextArray] - The context array to resolve (optional)
	 * @param {Record<string, any>} [pRootDataObject] - The root data object to resolve (optional)
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {any} The value at the given address, or undefined
	 */
	resolveStateFromAddress(pAddress, pRecord, pContextArray, pRootDataObject, pScope, pState)
	{
		let tmpContextArray = (Array.isArray(pContextArray)) ? pContextArray : [ this ];
		let tmpScope = pScope || this;
		let tmpRootDataObject = typeof(pRootDataObject) === 'object' && pRootDataObject != null ? pRootDataObject : {};

		tmpRootDataObject.Fable = this;
		tmpRootDataObject.Pict = this;
		tmpRootDataObject.AppData = this.AppData;
		tmpRootDataObject.TempData = this.TempData;
		tmpRootDataObject.Bundle = this.Bundle;
		tmpRootDataObject.Context = tmpContextArray;
		tmpRootDataObject.Record = pRecord;
		tmpRootDataObject.Scope = tmpScope;
		tmpRootDataObject.__State = pState;

		return this.manifest.getValueByHash(tmpRootDataObject, pAddress);
	}

	/**
	 * Set a value from a nested object using a dot notation string.
	 *
	 * TODO: re-home this in the data broker
	 *
	 * @param {string} pAddress - The address to resolve
	 * @param {any} pRecord - The record to resolve
	 * @param {any} pValue - The value to set at the given address
	 * @param {Array<any>} [pContextArray] - The context array to resolve
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 *
	 * @return {any} The value at the given address, or undefined
	 */
	setStateValueAtAddress(pAddress, pRecord, pValue, pContextArray, pScope)
	{
		let tmpContextArray = (Array.isArray(pContextArray)) ? pContextArray : [ this ];
		let tmpScope = pScope || this;
		const tmpAddressSpace =
		{
			Fable: this.fable,
			Pict: this,
			AppData: this.AppData,
			TempData: this.TempData,
			Bundle: this.Bundle,
			Context: tmpContextArray,
			Record: pRecord,
			Scope: tmpScope,
		};
		return this.manifest.setValueByHash(tmpAddressSpace, pAddress, pValue);
	}

	/**
	 * Parse a template.
	 *
	 * @param {String} pTemplateString - The template string to parse
	 * @param {Object} pData - The data to use in the template
	 * @param {Function} [fCallback] - The callback to call when the template is parsed
	 * @param {Array<any>} [pContextArray] - The context array to use in the template
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {String?} The parsed template string, or undefined if a callback was provided
	 */
	parseTemplate(pTemplateString, pData, fCallback, pContextArray, pScope, pState)
	{
		let tmpData = typeof pData === "object" ? pData : {};
		let tmpContextArray = Array.isArray(pContextArray) ? pContextArray : [ this ];
		let tmpScope = pScope || this;
		let tmpParseUUID;
		if (this.LogControlFlow) {
			tmpParseUUID = this.fable.getUUID();
			this.log.info(
				`PICT-ControlFlow parseTemplate ${tmpParseUUID} [${pTemplateString.substring(0, 50).replace("\n", "\\n")}...${pTemplateString.length}] (fCallback: ${typeof fCallback}) with data size [${JSON.stringify(tmpData).length}]`,
			);
			if (this.LogNoisiness > 1) {
				this.log.info(
					`PICT-ControlFlow parseTemplate ${tmpParseUUID} template:\n${pTemplateString}`,
				);
			}
			if (this.LogControlFlowWatchAddressList.length > 0) {
				for (let i = 0; i < this.LogControlFlowWatchAddressList.length; i++) {
					this.log.info(
						`PICT-ControlFlow parseTemplate ${tmpParseUUID} Watch Value: [${this.LogControlFlowWatchAddressList[i]}]=>[${this.resolveStateFromAddress(this.LogControlFlowWatchAddressList[i], tmpData)}]`,
					);
				}
			}
		}

		if (typeof fCallback === "function") {
			this.MetaTemplate.parseString(
				pTemplateString,
				tmpData,
				(pError, pParsedTemplate) => {
					if (this.LogControlFlow && this.LogNoisiness > 1) {
						this.log.info(
							`PICT-ControlFlow parseTemplate ${tmpParseUUID} Template Async Return Value:\n${pParsedTemplate}`,
						);
					}
					return fCallback(pError, pParsedTemplate);
				},
				tmpContextArray,
				tmpScope,
				pState,
			);
		} else {
			let tmpResult = this.MetaTemplate.parseString(
				pTemplateString,
				tmpData,
				null,
				tmpContextArray,
				tmpScope,
				pState,
			);
			if (this.LogControlFlow && this.LogNoisiness > 1) {
				this.log.info(
					`PICT-ControlFlow parseTemplate ${tmpParseUUID} Template Return Value:\n${tmpResult}`,
				);
			}
			return tmpResult;
		}
	}

	/**
	 * Parse a template by hash.
	 *
	 * @param {String} pTemplateHash - The hash of the template to parse
	 * @param {Object} pData - The data to use in the template
	 * @param {Function} [fCallback] - The callback to call when the template is parsed
	 * @param {Array<any>} [pContextArray] - The context array to use in the template
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {String?} The parsed template string, or undefined if a callback was provided
	 */
	parseTemplateByHash(pTemplateHash, pData, fCallback, pContextArray, pScope, pState)
	{
		let tmpTemplateString = this.TemplateProvider.getTemplate(pTemplateHash);

		// TODO: Unsure if returning empty is always the right behavior -- if it isn't we will use config to set the behavior
		if (!tmpTemplateString) {
			tmpTemplateString = "";
		}

		return this.parseTemplate(
			tmpTemplateString,
			pData,
			fCallback,
			pContextArray,
			pScope,
			pState,
		);
	}

	/**
	 * Parse a template set.
	 *
	 * @param {String} pTemplateString - The template string to parse
	 * @param {Array<any>|Object} pDataSet - The data set to use in the template
	 * @param {Function} [fCallback] - The callback to call when the template set is parsed
	 * @param {Array<any>} [pContextArray] - The context array to use in the template
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {String?} The parsed template string, or undefined if a callback was provided
	 */
	parseTemplateSet(pTemplateString, pDataSet, fCallback, pContextArray, pScope, pState)
	{
		// TODO: This will need streaming -- for now janky old string append does the trick
		let tmpValue = "";
		if (typeof fCallback == "function") {
			if (Array.isArray(pDataSet) || typeof pDataSet == "object") {
				this.Utility.eachLimit(
					pDataSet,
					1,
					(pRecord, fRecordTemplateCallback) => {
						return this.parseTemplate(
							pTemplateString,
							pRecord,
							(pError, pTemplateResult) => {
								tmpValue += pTemplateResult;
								return fRecordTemplateCallback();
							},
							pContextArray,
							pScope,
							pState,
						);
					},
					(pError) => {
						return fCallback(pError, tmpValue);
					},
				);
			} else {
				return fCallback(
					Error("Pict: Template Set: pDataSet is not an array or object."),
					"",
				);
			}
		} else {
			if (Array.isArray(pDataSet) || typeof pDataSet == "object") {
				if (Array.isArray(pDataSet)) {
					for (let i = 0; i < pDataSet.length; i++) {
						tmpValue += this.parseTemplate(
							pTemplateString,
							pDataSet[i],
							null,
							pContextArray,
							pScope,
							pState,
						);
					}
				} else {
					let tmpKeys = Object.keys(pDataSet);
					for (let i = 0; i < tmpKeys.length; i++) {
						tmpValue += this.parseTemplate(
							pTemplateString,
							pDataSet[tmpKeys[i]],
							null,
							pContextArray,
							pScope,
							pState,
						);
					}
				}

				return tmpValue;
			} else {
				return "";
			}
		}
	}

	/**
	 * Parse a template set by hash.
	 *
	 * @param {String} pTemplateHash - The hash of the template to parse
	 * @param {Array<any>|Object} pDataSet - The data set to use in the template
	 * @param {Function} [fCallback] - The callback to call when the template is parsed
	 * @param {Array<any>} [pContextArray] - The context array to use in the template
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {String?} The parsed template string, or undefined if a callback was provided
	 */
	parseTemplateSetByHash(pTemplateHash, pDataSet, fCallback, pContextArray, pScope, pState)
	{
		let tmpTemplateString = this.TemplateProvider.getTemplate(pTemplateHash);

		// TODO: Unsure if returning empty is always the right behavior -- if it isn't we will use config to set the behavior
		if (!tmpTemplateString) {
			tmpTemplateString = "";
		}

		return this.parseTemplateSet(
			tmpTemplateString,
			pDataSet,
			fCallback,
			pContextArray,
			pScope,
			pState,
		);
	}


	/**
	 * Parse a template set.
	 *
	 * @param {String} pTemplateString - The template string to parse
	 * @param {Array<any>|Object} pDataSet - The data set to use in the template
	 * @param {Function} [fCallback] - The callback to call when the template set is parsed
	 * @param {Array<any>} [pContextArray] - The context array to use in the template
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {String?} The parsed template string, or undefined if a callback was provided
	 */
	parseTemplateSetWithPayload(pTemplateString, pDataSet, pPayload, fCallback, pContextArray, pScope, pState)
	{
		// TODO: This will need streaming -- for now janky old string append does the trick
		let tmpValue = "";
		if (typeof fCallback == "function") {
			if (Array.isArray(pDataSet) || typeof pDataSet == "object") {
				this.Utility.eachLimit(
					pDataSet,
					1,
					(pRecord, fRecordTemplateCallback) => {
						return this.parseTemplate(
							pTemplateString,
							{ Data: pRecord, Payload: pPayload },
							(pError, pTemplateResult) => {
								tmpValue += pTemplateResult;
								return fRecordTemplateCallback();
							},
							pContextArray,
							pScope,
							pState,
						);
					},
					(pError) => {
						return fCallback(pError, tmpValue);
					},
				);
			} else {
				return fCallback(
					Error("Pict: Template Set: pDataSet is not an array or object."),
					"",
				);
			}
		} else {
			if (Array.isArray(pDataSet) || typeof pDataSet == "object") {
				if (Array.isArray(pDataSet)) {
					for (let i = 0; i < pDataSet.length; i++) {
						tmpValue += this.parseTemplate(
							pTemplateString,
							{ Data: pDataSet[i], Payload: pPayload },
							null,
							pContextArray,
							pScope,
							pState,
						);
					}
				} else {
					let tmpKeys = Object.keys(pDataSet);
					for (let i = 0; i < tmpKeys.length; i++) {
						tmpValue += this.parseTemplate(
							pTemplateString,
							{ Data: pDataSet[tmpKeys[i]], Payload: pPayload },
							null,
							pContextArray,
							pScope,
							pState,
						);
					}
				}

				return tmpValue;
			} else {
				return "";
			}
		}
	}

	/**
	 * Parse a template set by hash.
	 *
	 * @param {String} pTemplateHash - The hash of the template to parse
	 * @param {Array<any>|Object} pDataSet - The data set to use in the template
	 * @param {Object} pPayload - The payload to use in the template
	 * @param {Function} [fCallback] - The callback to call when the template is parsed
	 * @param {Array<any>} [pContextArray] - The context array to use in the template
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {String?} The parsed template string, or undefined if a callback was provided
	 */
	parseTemplateSetWithPayloadByHash(pTemplateHash, pDataSet, pPayload, fCallback, pContextArray, pScope, pState)
	{
		let tmpTemplateString = this.TemplateProvider.getTemplate(pTemplateHash);

		// TODO: Unsure if returning empty is always the right behavior -- if it isn't we will use config to set the behavior
		if (!tmpTemplateString) {
			tmpTemplateString = "";
		}

		return this.parseTemplateSetWithPayload(
			tmpTemplateString,
			pDataSet,
			pPayload,
			fCallback,
			pContextArray,
			pScope,
			pState,
		);
	}
}

module.exports = Pict;
module.exports.ServiceProviderBase = require('fable-serviceproviderbase');

module.exports.PictApplicationClass = require("pict-application");

module.exports.PictViewClass = require("pict-view");
module.exports.PictProviderClass = require("pict-provider");
module.exports.PictTemplateClass = require("pict-template");

module.exports.EnvironmentLog = require("./environments/Pict-Environment-Log.js");
module.exports.EnvironmentObject = require("./environments/Pict-Environment-Object.js");
module.exports.FilterClauseBase = require('./filters/FilterClauseBase.js');
module.exports.FilterClauseLocal = require('./filters/FilterClauseLocal.js');
module.exports.FilterClauseInternalJoin = require('./filters/FilterClauseInternalJoin.js');
module.exports.FilterClauseExternalJoin = require('./filters/FilterClauseExternalJoin.js');

// This is to help understand the type of enivironement we're executing in
module.exports.isBrowser = new Function(
	"try {return (this===window);} catch(pError) {return false;}",
);

module.exports.safeOnDocumentReady = require(
	`./Pict-Browser-SafeOnDocumentReady.js`,
);
module.exports.safeLoadPictApplication = require(`./Pict-Browser-SafeLoad.js`);

},{"../package.json":192,"./Pict-Browser-SafeLoad.js":193,"./Pict-Browser-SafeOnDocumentReady.js":194,"./Pict-CSS.js":195,"./Pict-Content-Assignment.js":196,"./Pict-DataProvider.js":197,"./Pict-Meadow-EntityProvider.js":198,"./Pict-Template-Audit.js":199,"./Pict-Template-Provider.js":200,"./environments/Pict-Environment-Log.js":202,"./environments/Pict-Environment-Object.js":203,"./filters/FilterClauseBase.js":205,"./filters/FilterClauseExternalJoin.js":206,"./filters/FilterClauseInternalJoin.js":207,"./filters/FilterClauseLocal.js":208,"./providers/Provider-DataBroker.js":210,"./providers/Provider-Filter-Manager.js":211,"./providers/Provider-Icon.js":212,"./services/Fable-Service-TransactionTracking.js":213,"./templates/Pict-Template-AddressedTemplate.js":214,"./templates/Pict-Template-Data.js":215,"./templates/Pict-Template-DataValueByKey.js":216,"./templates/Pict-Template-DataWithAbsoluteFallback.js":217,"./templates/Pict-Template-DataWithTemplateFallback.js":218,"./templates/Pict-Template-Entity.js":219,"./templates/Pict-Template-Function.js":220,"./templates/Pict-Template-Icon.js":221,"./templates/Pict-Template-InlineTemplate.js":222,"./templates/Pict-Template-Self.js":223,"./templates/Pict-Template-Solve.js":224,"./templates/Pict-Template-SolveByReference.js":225,"./templates/Pict-Template-Template.js":226,"./templates/Pict-Template-TemplateByDataAddress.js":227,"./templates/Pict-Template-TemplateByReference.js":228,"./templates/Pict-Template-TemplateByTypes.js":229,"./templates/Pict-Template-TemplateFromAddress.js":230,"./templates/Pict-Template-TemplateFromMap.js":231,"./templates/Pict-Template-TemplateSet.js":232,"./templates/Pict-Template-TemplateSetFromMap.js":233,"./templates/Pict-Template-TemplateSetWithPayload.js":234,"./templates/Pict-Template-TemplateValueSet.js":235,"./templates/Pict-Template-View.js":236,"./templates/data-generation/Pict-Template-RandomNumber.js":237,"./templates/data-generation/Pict-Template-RandomNumberString.js":238,"./templates/data/Pict-Template-DataEncodeJavascriptString.js":239,"./templates/data/Pict-Template-DataJson.js":240,"./templates/data/Pict-Template-DateOnlyFormat.js":241,"./templates/data/Pict-Template-DateOnlyYMD.js":242,"./templates/data/Pict-Template-DateTimeFormat.js":243,"./templates/data/Pict-Template-DateTimeYMD.js":244,"./templates/data/Pict-Template-Digits.js":245,"./templates/data/Pict-Template-Dollars.js":246,"./templates/data/Pict-Template-HtmlCommentEnd.js":247,"./templates/data/Pict-Template-HtmlCommentStart.js":248,"./templates/data/Pict-Template-Join.js":249,"./templates/data/Pict-Template-JoinUnique.js":250,"./templates/data/Pict-Template-PascalCaseIdentifier.js":251,"./templates/data/Pict-Template-PluckJoinUnique.js":252,"./templates/debugging/Pict-Template-Breakpoint.js":253,"./templates/debugging/Pict-Template-DataValueTree.js":254,"./templates/debugging/Pict-Template-LogStatement.js":255,"./templates/debugging/Pict-Template-LogValue.js":256,"./templates/debugging/Pict-Template-LogValueTree.js":257,"./templates/logic/Pict-Template-NotEmpty.js":258,"./templates/logic/Pict-Template-TemplateIf.js":260,"./templates/logic/Pict-Template-TemplateIfAbsolute.js":261,"fable":68,"fable-serviceproviderbase":59,"pict-application":140,"pict-provider":142,"pict-template":144,"pict-view":146}],202:[function(require,module,exports){
/**
* Pict browser shim loader
* @author <steven@velozo.com>
*
* This was born after writing about 10 views and copying basically the same
* mock environment read/write functions into the test harnesses.  It allows
* mocks or other types of communications back-and-forth to be configured
* as an environment for views and applications.
*
* To use this:
*
* 1. Construct a pict object in your favorite fashion:
*        let _Pict = new libPict({...Environment})
* 2. Require this; it's exported as a static subobject of the pict library,
*    so you can do:
*        const libPictEnvironmentLog = require('pict').EnvironmentLog;
* 3. Create an object that is your custom read data.  Any key that is requested
*    but missing will return empty.
*        const tmpContentMap = { '#SomeElement': 'SomeValue' };
* 4. Pass your pict through this to get the custom functions mapped into the ContentAssignment service:
*        let tmpMockEnvironment = new libPictEnvironmentLog(_Pict, tmpContentMap);
* 5. Now you can use your pict as normal, and it will log all of the read/write events out and keep a log of when they occurred.
*/
class PictEnvironmentLog
{
	/**
	 * @typedef {import('../Pict')} Pict
	 */
	/**
	 * @param {Pict} pPict - The pict object to attach the custom read/write functions to.
	 * @param {Object<String, any>} pContentMap - The content map to use for custom reads.
	 */
	constructor(pPict, pContentMap)
	{
		this.contentMap = (typeof(pContentMap) == 'object') ? pContentMap : {};

		this.pict = pPict;

		// If this is set to false, we won't keep an array-based log of every read, assignment, append or get.
		this.truncateContentLength = 256;
		this.storeEventLog = true;
		// Where to store each event type
		this.eventLog = {};
		this.eventLog.GetElement = [];
		this.eventLog.Read = [];
		this.eventLog.Prepend = [];
		this.eventLog.Append = [];
		this.eventLog.Assign = [];

		this.pict.ContentAssignment.customGetElementFunction = this.customGetElementFunction.bind(this);
		this.pict.ContentAssignment.customReadFunction = this.customReadFunction.bind(this);
		this.pict.ContentAssignment.customAppendFunction = this.customAppendFunction.bind(this);
		this.pict.ContentAssignment.customPrependFunction = this.customPrependFunction.bind(this)
		this.pict.ContentAssignment.customAssignFunction = this.customAssignFunction.bind(this);

		this.pict.ContentAssignment.customReadAttributeFunction = this.customReadAttributeFunction.bind(this);
		this.pict.ContentAssignment.customSetAttributeFunction = this.customSetAttributeFunction.bind(this);
	}

	/**
	 * Create an event log entry.
	 *
	 * @param {string} pAddress - The address of the event.
	 * @param {string} [pContent] - The content of the event.
	 */
	createEventLogEntry(pAddress, pContent)
	{
		let tmpContent = (typeof(pContent) == 'undefined') ? '' : pContent;
		return (
			{
				TimeStamp:this.pict.log.getTimeStamp(),
				Hash: pAddress,
				Content: tmpContent
			});
	}

	/**
	 * Custom GetElement function.
	 *
	 * @param {string} pAddress - The address of the element.
	 */
	customGetElementFunction(pAddress)
	{
		if (this.storeEventLog) this.eventLog.GetElement.push(this.createEventLogEntry(pAddress));
		this.pict.log.info(`Mocking an GET of Address -> [${pAddress}]`);
		return '';
	}

	/**
	 * Custom Read function.
	 *
	 * @param {string} pAddress - The address of the element.
	 */
	customReadFunction(pAddress)
	{
		if (this.storeEventLog) this.eventLog.Read.push(this.createEventLogEntry(pAddress));
		this.pict.log.info(`Mocking an READ from Address -> [${pAddress}]`);
		if (pAddress in this.contentMap)
		{
			// The data is in the content map!
			return this.contentMap[pAddress];
		}
		this.pict.log.warn(`Mock read from Address ${pAddress} did not find a value in the content map.`);
		return '';
	}

	/**
	 * Custom Append function.
	 *
	 * @param {string} pAddress - The address of the element.
	 * @param {string} pContent - The content to append.
	 */
	customAppendFunction(pAddress, pContent)
	{
		if (this.storeEventLog) this.eventLog.Append.push(this.createEventLogEntry(pAddress, pContent));
		if (pContent.length > this.truncateContentLength)
		{
			this.pict.log.info(`Mocking an APPEND to Address -> [${pAddress}] (log truncated to first ${this.truncateContentLength} characters)`, {Content: pContent.substring(0, this.truncateContentLength)});
		}
		else
		{
			this.pict.log.info(`Mocking an APPEND to Address -> [${pAddress}]`, {Content: pContent});
		}
		return '';
	}

	/**
	 * Custom Prepend function.
	 *
	 * @param {string} pAddress - The address of the element.
	 * @param {string} pContent - The content to prepend.
	 */
	customPrependFunction(pAddress, pContent)
	{
		if (this.storeEventLog) this.eventLog.Prepend.push(this.createEventLogEntry(pAddress, pContent));
		if (pContent.length > this.truncateContentLength)
		{
			this.pict.log.info(`Mocking an PREPEND to Address -> [${pAddress}] (log truncated to first ${this.truncateContentLength} characters)`, {Content: pContent.substring(0, this.truncateContentLength)});
		}
		else
		{
			this.pict.log.info(`Mocking an PREPEND to Address -> [${pAddress}]`, {Content: pContent});
		}
		return '';
	}

	/**
	 * Custom Assign function.
	 *
	 * @param {string} pAddress - The address of the element.
	 * @param {string} pContent - The content to assign.
	 */
	customAssignFunction(pAddress, pContent)
	{
		if (this.storeEventLog) this.eventLog.Assign.push(this.createEventLogEntry(pAddress, pContent));
		if (pContent.length > this.truncateContentLength)
		{
			this.pict.log.info(`Mocking an ASSIGN to Address -> [${pAddress}] (log truncated to first ${this.truncateContentLength} characters)`, {Content: pContent.substring(0, this.truncateContentLength)});
		}
		else
		{
			this.pict.log.info(`Mocking an ASSIGN to Address -> [${pAddress}]`, {Content: pContent});
		}
		return '';
	}

	/**
	 * Custom Read Attribute function.
	 *
	 * @param {string} pAddress - The address of the element.
	 * @param {string} pAttribute - The attribute to read.
	 */
	customReadAttributeFunction(pAddress, pAttribute)
	{
		this.pict.log.info(`Mocking an READ ATTRIBUTE from Address -> [${pAddress}]`, {Attribute: pAttribute});
		return '';
	}

	/**
	 * Custom Set Attribute function.
	 *
	 * @param {string} pAddress - The address of the element.
	 * @param {string} pAttribute - The attribute to set.
	 */
	customSetAttributeFunction(pAddress, pAttribute, pContent)
	{
		if (pContent.length > this.truncateContentLength)
		{
			this.pict.log.info(`Mocking an SET ATTRIBUTE to Address -> [${pAddress}] (log truncated to first ${this.truncateContentLength} characters)`, {Attribute: pAttribute, Content: pContent.substring(0, this.truncateContentLength)});
		}
		else
		{
			this.pict.log.info(`Mocking an SET ATTRIBUTE to Address -> [${pAddress}]`, {Attribute: pAttribute, Content: pContent});
		}
		return '';
	}
}

module.exports = PictEnvironmentLog;

},{}],203:[function(require,module,exports){
/**
* Pict browser shim loader with Object statefulness for the environement
* @author <steven@velozo.com>
*
* This was born after writing about 10 views and copying basically the same
* mock environment read/write functions into the test harnesses.  It allows
* mocks or other types of communications back-and-forth to be configured
* as an environment for views and applications.
*
* To use this:
*
* 1. Construct a pict object in your favorite fashion:
*        let _Pict = new libPict({...Environment})
* 2. Require this; it's exported as a static subobject of the pict library,
*    so you can do:
*        const libPictEnvironmentLog = require('pict').EnvironmentLog;
* 3. Create an object that is your custom read data.  Any key that is requested
*    but missing will return empty.
*        const tmpContentMap = { '#SomeElement': 'SomeValue' };
* 4. Pass your pict through this to get the custom functions mapped into the ContentAssignment service:
*        let tmpMockEnvironment = new libPictEnvironmentLog(_Pict, tmpContentMap);
* 5. Now you can use your pict as normal, and it will log all of the read/write events out and keep a log of when they occurred.
*/
class PictEnvironmentObject
{
	/**
	 * @typedef {import('../Pict')} Pict
	 */
	/**
	 * @param {Pict} pPict - The pict object to attach the custom read/write functions to.q
	 * @param {Object<String, any>} pContentMap - The content map to use for custom reads.
	 */
	constructor(pPict, pContentMap)
	{
		this.contentMap = (typeof(pContentMap) == 'object') ? pContentMap : {};

		this.contentMap._ATTRIBUTE_MAP = {};
		this.contentMap._CLASS_MAP = {};

		this.pict = pPict;

		// If this is set to false, we won't keep an array-based log of every read, assignment, append or get.
		this.truncateContentLength = 256;
		this.storeEventLog = true;
		// Where to store each event type
		this.eventLog = {};
		this.eventLog.GetElement = [];
		this.eventLog.Read = [];
		this.eventLog.Prepend = [];
		this.eventLog.Append = [];
		this.eventLog.Assign = [];
		this.eventLog.ReadAttribute = [];
		this.eventLog.SetAttribute = [];
		this.eventLog.RemoveAttribute = [];
		this.eventLog.ReadClass = [];
		this.eventLog.SetClass = [];
		this.eventLog.RemoveClass = [];

		this.pict.ContentAssignment.customGetElementFunction = this.customGetElementFunction.bind(this);
		this.pict.ContentAssignment.customReadFunction = this.customReadFunction.bind(this);
		this.pict.ContentAssignment.customAppendFunction = this.customAppendFunction.bind(this);
		this.pict.ContentAssignment.customPrependFunction = this.customPrependFunction.bind(this)
		this.pict.ContentAssignment.customAssignFunction = this.customAssignFunction.bind(this);
		this.pict.ContentAssignment.customReadAttributeFunction = this.customReadAttributeFunction.bind(this);
		this.pict.ContentAssignment.customSetAttributeFunction = this.customSetAttributeFunction.bind(this);
		this.pict.ContentAssignment.customRemoveAttributeFunction = this.customRemoveAttributeFunction.bind(this);
		this.pict.ContentAssignment.customReadClassFunction = this.customReadClassFunction.bind(this);
		this.pict.ContentAssignment.customSetClassFunction = this.customSetClassFunction.bind(this);
		this.pict.ContentAssignment.customRemoveClassFunction = this.customRemoveClassFunction.bind(this);
	}

	createEventLogEntry(pAddress, pContent)
	{
		let tmpContent = (typeof(pContent) == 'undefined') ? '' : pContent;
		return (
			{
				TimeStamp:this.pict.log.getTimeStamp(),
				Hash: pAddress,
				Content: tmpContent
			});
	}

	customGetElementFunction (pAddress)
	{
		if (this.storeEventLog)
		{
			this.eventLog.GetElement.push(this.createEventLogEntry(pAddress));
		}

		this.pict.log.info(`Mocking an GET of Address -> [${pAddress}]`);
		return '';
	}

	customReadFunction (pAddress)
	{
		if (this.storeEventLog)
		{
			this.eventLog.Read.push(this.createEventLogEntry(pAddress));
		}

		this.pict.log.info(`Mocking an READ from Address -> [${pAddress}]`);
		if (pAddress in this.contentMap)
		{
			// The data is in the content map!
			return this.contentMap[pAddress];
		}
		this.pict.log.warn(`Mock read from Address ${pAddress} did not find a value in the content map.`);
		return '';
	}

	customAppendFunction (pAddress, pContent)
	{
		this.contentMap[pAddress] = (typeof(this.contentMap[pAddress]) == 'undefined') ? pContent : this.contentMap[pAddress] + pContent;

		if (this.storeEventLog)
		{
			this.eventLog.Append.push(this.createEventLogEntry(pAddress, pContent));
		}

		if (pContent.length > this.truncateContentLength)
		{
			this.pict.log.info(`Mocking an APPEND to Address -> [${pAddress}] (log truncated to first ${this.truncateContentLength} characters)`, {Content: pContent.substring(0, this.truncateContentLength)});
		}
		else
		{
			this.pict.log.info(`Mocking an APPEND to Address -> [${pAddress}]`, {Content: pContent});
		}
		return '';
	}
	customPrependFunction (pAddress, pContent)
	{
		this.contentMap[pAddress] = (typeof(this.contentMap[pAddress]) == 'undefined') ? pContent : pContent + this.contentMap[pAddress];

		if (this.storeEventLog)
		{
			this.eventLog.Prepend.push(this.createEventLogEntry(pAddress, pContent));
		}

		if (pContent.length > this.truncateContentLength)
		{
			this.pict.log.info(`Mocking an PREPEND to Address -> [${pAddress}] (log truncated to first ${this.truncateContentLength} characters)`, {Content: pContent.substring(0, this.truncateContentLength)});
		}
		else
		{
			this.pict.log.info(`Mocking an PREPEND to Address -> [${pAddress}]`, {Content: pContent});
		}
		return '';
	}

	customAssignFunction (pAddress, pContent)
	{
		this.contentMap[pAddress] = pContent;

		if (this.storeEventLog)
		{
			this.eventLog.Prepend.push(this.createEventLogEntry(pAddress, pContent));
		}

		if (pContent.length > this.truncateContentLength)
		{
			this.pict.log.info(`Mocking an ASSIGN to Address -> [${pAddress}] (log truncated to first ${this.truncateContentLength} characters)`, {Content: pContent.substring(0, this.truncateContentLength)});
		}
		else
		{
			this.pict.log.info(`Mocking an ASSIGN to Address -> [${pAddress}]`, {Content: pContent});
		}
		return '';
	}

	initializeAttributeMapLocation(pAddress, pAttribute)
	{
		if (!(pAddress in this.contentMap._ATTRIBUTE_MAP))
		{
			this.contentMap._ATTRIBUTE_MAP[pAddress] = {};
		}
		if (!(pAttribute in this.contentMap._ATTRIBUTE_MAP[pAddress]))
		{
			this.contentMap._ATTRIBUTE_MAP[pAddress][pAttribute] = false;
		}
	}

	initializeClassMapLocation(pAddress)
	{
		if (!(pAddress in this.contentMap._CLASS_MAP))
		{
			this.contentMap._CLASS_MAP[pAddress] = [];
		}
	}

	customReadAttributeFunction (pAddress, pAttribute)
	{
		this.initializeAttributeMapLocation(pAddress, pAttribute);

		let tmpContent = this.contentMap._ATTRIBUTE_MAP[pAddress][pAttribute];

		if (this.storeEventLog)
		{
			this.eventLog.Assign.push(this.createEventLogEntry(pAddress, pAttribute));
		}

		if (tmpContent.length > this.truncateContentLength)
		{
			this.pict.log.info(`Mocking an ATTRIBUTE READ for Address -> [${pAddress}] (log truncated to first ${this.truncateContentLength} characters)`, {Content: tmpContent.substring(0, this.truncateContentLength)});
		}
		else
		{
			this.pict.log.info(`Mocking an ATTRIBUTE READ for Address -> [${pAddress}]::[${pAttribute}]`, {Content: tmpContent});
		}
		return tmpContent;
	}

	customSetAttributeFunction (pAddress, pAttribute, pValue)
	{
		this.initializeAttributeMapLocation(pAddress, pAttribute);

		this.contentMap._ATTRIBUTE_MAP[pAddress][pAttribute] = pValue;

		if (this.storeEventLog)
		{
			this.eventLog.Assign.push(this.createEventLogEntry(pAddress, pAttribute));
		}

		if (pValue.length > this.truncateContentLength)
		{
			this.pict.log.info(`Mocking an ATTRIBUTE SET for Address -> [${pAddress}] (log truncated to first ${this.truncateContentLength} characters)`, {Content: pValue.substring(0, this.truncateContentLength)});
		}
		else
		{
			this.pict.log.info(`Mocking an ATTRIBUTE SET for Address -> [${pAddress}]::[${pAttribute}]`, {Content: pValue});
		}
		return pValue;
	}

	customRemoveAttributeFunction (pAddress, pAttribute)
	{
		this.initializeAttributeMapLocation(pAddress, pAttribute);

		let tmpContent = this.contentMap._ATTRIBUTE_MAP[pAddress][pAttribute];

		if (this.storeEventLog)
		{
			this.eventLog.Assign.push(this.createEventLogEntry(pAddress, pAttribute));
		}

		if (tmpContent.length > this.truncateContentLength)
		{
			this.pict.log.info(`Mocking an ATTRIBUTE REMOVE for Address -> [${pAddress}] (log truncated to first ${this.truncateContentLength} characters)`, {Content: tmpContent.substring(0, this.truncateContentLength)});
		}
		else
		{
			this.pict.log.info(`Mocking an ATTRIBUTE REMOVE for Address -> [${pAddress}]::[${pAttribute}]`, {Content: tmpContent});
		}

		delete this.contentMap._ATTRIBUTE_MAP[pAddress][pAttribute];

		return true;
	}

	customReadClassFunction (pAddress, pClass)
	{
		this.initializeClassMapLocation(pAddress);

		const tmpContent = this.contentMap._CLASS_MAP[pAddress].indexOf(pClass) > -1;

		if (this.storeEventLog)
		{
			this.eventLog.Assign.push(this.createEventLogEntry(pAddress, pClass));
		}
		this.pict.log.info(`Mocking an CLASS READ for Address -> [${pAddress}]::[${pClass}]`, {Content: tmpContent});

		return tmpContent;
	}

	customSetClassFunction (pAddress, pClass)
	{
		this.initializeClassMapLocation(pAddress);

		let tmpContent = this.contentMap._CLASS_MAP[pAddress];

		if (this.contentMap._CLASS_MAP[pAddress].indexOf(pClass) == -1)
		{
			this.contentMap._CLASS_MAP[pAddress].push(pClass);
		}

		if (this.storeEventLog)
		{
			this.eventLog.Assign.push(this.createEventLogEntry(pAddress, pClass));
		}
		this.pict.log.info(`Mocking an CLASS SET for Address -> [${pAddress}]::[${pClass}]`, {Content: tmpContent.join(' ')});

		return tmpContent;
	}

	customRemoveClassFunction (pAddress, pClass)
	{
		this.initializeClassMapLocation(pAddress);

		let tmpContent = this.contentMap._CLASS_MAP[pAddress];

		this.contentMap._CLASS_MAP[pAddress].splice(pClass);

		if (this.storeEventLog)
		{
			this.eventLog.Assign.push(this.createEventLogEntry(pAddress, pClass));
		}
		this.pict.log.info(`Mocking an CLASS REMOVE for Address -> [${pAddress}]::[${pClass}]`, {Content: tmpContent.join(' ')});

		return tmpContent;
	}
}

module.exports = PictEnvironmentObject;

},{}],204:[function(require,module,exports){

/**
 * @typedef {{
 *   ValueTemplate?: string,
 *   Value?: string,
 *   CoreEntity: string,
 *   Instruction: string,
 *   Operator: string,
 *   Fields: string[],
 * }} FilterConnection
 *
 * @typedef {{
 *   GUID: string,
 *   Filters: Array<Record<string, any>>,
 *   JoinConfig?: FilterConnection,
 * 	 Ordinal?: number,
 * 	 Junction?: string,
 * 	 GroupOpen?: boolean,
 *   GroupJunction?: string,
 *   GroupClose?: boolean
 * }} PreparedFilter
 * 
 * * @typedef {{
 *   PreparedFilters?: Array<PreparedFilter>,
 *   Junction?: string,
 *   Ordinal?: number,
 *   GUIDGroup: string
 * }} FilterGroup
 *
 * @typedef {{
 *   Entity: string,
 * 	 Groups: Array<FilterGroup>,
 *   Filter: string,
 *   ResultDestinationAddress: string,
 *   Mode?: 'Count' | 'Records',
 *   RecordOffset?: number,
 *   PageSize?: number,
 *   FilterConfiguration: Array<Record<string, any>>,
 *   PreparedFilters: Array<PreparedFilter>,
 *   BundleConfig?: Array<Record<string, any>>,
 *   UserFilters?: Array<string>,
 * 	 Postfix?: string
 * }} FilterState
 *
 * @typedef { 'None' |
 * 'Match' | 'StringMatch' | 'DateMatch' | 'NumericMatch' |
 * 'Range' | 'StringRange' | 'DateRange' | 'NumericRange' |
 * 'InternalJoinMatch' | 'InternalJoinStringMatch' | 'InternalJoinNumericMatch' | 'InternalJoinDateMatch' |
 * 'InternalJoinRange' | 'InternalJoinStringRange' | 'InternalJoinNumericRange' | 'InternalJoinDateRange'  | 'InternalJoinSelectedValue' | 'InternalJoinSelectedValueList' |
 * 'ExternalJoinMatch' | 'ExternalJoinStringMatch' | 'ExternalJoinNumericMatch' | 'ExternalJoinDateMatch' |
 * 'ExternalJoinRange' | 'ExternalJoinStringRange' | 'ExternalJoinNumericRange' | 'ExternalJoinDateRange' | 'ExternalJoinSelectedValue' | 'ExternalJoinSelectedValueList' } FilterType
 */

class FilterMeadowStanzaTokenGenerator
{
	/**
	 * @param {import('../Pict.js')} pFable
	 */
	constructor(pFable)
	{
		this.fable = pFable;
		this.pict = pFable;
		this.log = pFable.log;
	}

	/**
	 * @param {FilterState} pFilterState
	 */
	generateMeadowFilterStanzas(pFilterState)
	{
		let tmpResult = [];
		pFilterState.UserFilters = [];
		const groupedFilterStates = {};
		if (Array.isArray(pFilterState.Groups))
		{
			for (let g of pFilterState.Groups)
			{
				groupedFilterStates[g.GUIDGroup] =
				Object.assign({
					PreparedFilters: [],
					Junction: 'AND',
					Ordinal: 0
				}, g);
			}
		}
		for (const tmpFilterConfig of pFilterState.FilterConfiguration || [])
		{
			if (tmpFilterConfig.Enabled === false)
			{
				if (this.pict.LogNoisiness > 1)
				{
					this.log.info(`Skipping disabled filter configuration: ${tmpFilterConfig.Type}`, { FilterConfig: tmpFilterConfig });
				}
				continue;
			}
			/** @type {PreparedFilter} */
			const tmpFilterResult = { GUID: this.pict.getUUID(), Filters: [], Ordinal: tmpFilterConfig.Ordinal || 0, Junction: tmpFilterConfig.Junction || 'AND' };
			const tmpValuesArray = Array.isArray(tmpFilterConfig.Values) ? tmpFilterConfig.Values : tmpFilterConfig.Value != null && tmpFilterConfig.Value != '' && (tmpFilterConfig.Type != 'ExternalJoinDateMatch' || tmpFilterConfig.Value != 0) ? [ tmpFilterConfig.Value ] : [];
			let tmpFilterByColumns;
			switch (tmpFilterConfig.Type)
			{
				case 'ExternalJoinSelectedValue':
				case 'ExternalJoinSelectedValueList':
					tmpFilterByColumns = [ tmpFilterConfig.ExternalFilterTableLookupColumn || `ID${tmpFilterConfig.ExternalFilterByTable}` ];
					// fall through
				case 'ExternalJoinMatch':
				case 'ExternalJoinStringMatch':
				case 'ExternalJoinDateMatch':
				case 'ExternalJoinNumericMatch':
					/*
					  "Values": [ "John", "Jane" ],
					  "ExternalFilterByColumns": [ "Name" ],
					  "ExactMatch": false,

					  "CoreConnectionColumn": "IDBook",

					  "JoinTable": "BookAuthorJoin",
					  "JoinTableExternalConnectionColumn": "IDAuthor",
					  "JoinTableCoreConnectionColumn": "IDBook",

					  "ExternalFilterByTable": "Author",
					  "ExternalFilterByTableConnectionColumn": "IDAuthor",
					 */
					if (!tmpFilterByColumns)
					{
						tmpFilterByColumns = tmpFilterConfig.ExternalFilterByColumns || (tmpFilterConfig.ExternalFilterByColumn ? [ tmpFilterConfig.ExternalFilterByColumn ] : [ 'Name' ]);
					}
					for (const tmpField of tmpFilterByColumns)
					{
						for (const tmpValue of tmpValuesArray)
						{
							const tmpFilter =
							{
								Index: -1,
								Entity: tmpFilterConfig.ExternalFilterByTable,
								Instruction: 'FBVOR',
								Field: tmpField,
							};
							if (tmpFilterConfig.ExactMatch || (typeof tmpFilterConfig.ExactMatch === 'undefined' &&
									(tmpFilterConfig.Type == 'ExternalJoinNumericMatch' || tmpFilterConfig.Type == 'ExternalJoinDateMatch' || tmpFilterConfig.Type == 'ExternalJoinSelectedValue' || tmpFilterConfig.Type == 'ExternalJoinSelectedValueList')))
							{
								//TODO: optimize this to use in-list, but requires restructuring of this code
								tmpFilter.Operator = 'EQ';
								tmpFilter.Value = tmpValue;
							}
							else
							{
								tmpFilter.Operator = 'LK';
								tmpFilter.Value = `%25${tmpValue}%25`; //FIXME: point of URI encoding needs to be addressed
							}
							tmpFilterResult.Filters.push(tmpFilter);
						}
					}
					if (!tmpFilterConfig.JoinTable)
					{
						this.log.error(`${tmpFilterConfig.Type} filter missing JoinTable, cannot filter join table.`, { FilterConfig: tmpFilterConfig });
						break;
					}
					if (!tmpFilterConfig.JoinTableExternalConnectionColumn)
					{
						this.log.error(`${tmpFilterConfig.Type} filter missing JoinTableExternalConnectionColumn, cannot filter join table [${tmpFilterConfig.JoinTable}].`);
						break;
					}
					if (tmpFilterResult.Filters.length > 0)
					{
						tmpFilterResult.Filters.push(
						{
							Index: 0,
							Fulcrum: true,
							Entity: tmpFilterConfig.JoinTable,
							Instruction: 'FBL',
							Field: tmpFilterConfig.JoinTableExternalConnectionColumn,
							Operator: 'INN',
							ValueTemplate: `{~PJU:,^${tmpFilterConfig.ExternalFilterByTableConnectionColumn || tmpFilterConfig.JoinTableExternalConnectionColumn}^Record.State[Step-1]~}`,
						});
						if (tmpFilterConfig.PolyJoinRemoteType)
						{
							tmpFilterResult.Filters.push(
							{
								Index: 0,
								Fulcrum: true,
								Entity: tmpFilterConfig.JoinTable,
								Instruction: 'FBV',
								Field: tmpFilterConfig.PolyJoinRemoteColumn || 'RemoteType',
								Operator: 'EQ',
								ValueTemplate: tmpFilterConfig.PolyJoinRemoteType,
							});
						}
						if (!tmpFilterConfig.CoreConnectionColumn)
						{
							this.log.error(`${tmpFilterConfig.Type} filter missing CoreConnectionColumn, cannot filter core table [${pFilterState.Entity}].`);
							break;
						}
						tmpFilterResult.JoinConfig =
						{
							CoreEntity: pFilterState.Entity,
							Instruction: 'FBLOR',
							Fields: [ tmpFilterConfig.CoreConnectionColumn ],
							Operator: 'INN',
							ValueTemplate: `{~PJU:,^${tmpFilterConfig.JoinTableCoreConnectionColumn}^Record.State[Step0]~}`,
						};
					}
					break;
				case 'ExternalJoinStringRange':
				case 'ExternalJoinNumericRange':
				case 'ExternalJoinDateRange':
				case 'ExternalJoinRange':
					if (!tmpFilterConfig.Values || (tmpFilterConfig.Values.Start == null && tmpFilterConfig.Values.End == null))
					{
						break;
					}

					// do not honor '0' for dates
					if (tmpFilterConfig.Type == 'ExternalJoinDateRange')
					{
						if ((!tmpFilterConfig.Values.Start || tmpFilterConfig.Values.Start == '0') &&
								(!tmpFilterConfig.Values.End || tmpFilterConfig.Values.End == '0'))
						{
							break;
						}
					}

					for (const tmpField of tmpFilterConfig.ExternalFilterByColumns || (tmpFilterConfig.ExternalFilterByColumn ? [ tmpFilterConfig.ExternalFilterByColumn ] : [ 'Name' ]))
					{
						const hasStartValue = tmpFilterConfig.Values && tmpFilterConfig.Values.Start && (tmpFilterConfig.Type != 'ExternalJoinDateRange' || tmpFilterConfig.Values.Start != '0');
						const hasEndValue = tmpFilterConfig.Values && tmpFilterConfig.Values.End && (tmpFilterConfig.Type != 'ExternalJoinDateRange' || tmpFilterConfig.Values.End != '0');
						if (hasStartValue)
						{
							tmpFilterResult.Filters.push(
							{
								Index: -1,
								Entity: tmpFilterConfig.ExternalFilterByTable,
								Instruction: 'FBVOR',
								OpenParen: true,
								OpenParenOr: true,
								CloseParen: !hasEndValue,
								Field: tmpField,
								Operator: tmpFilterConfig.StartExclusive ? 'GT' : 'GE',
								Value: tmpFilterConfig.Values.Start,
							});
						}
						if (hasEndValue)
						{
							tmpFilterResult.Filters.push(
							{
								Index: -1,
								Entity: tmpFilterConfig.ExternalFilterByTable,
								Instruction: 'FBV',
								OpenParen: !hasStartValue,
								OpenParenOr: !hasStartValue,
								CloseParen: true,
								Field: tmpField,
								Operator: tmpFilterConfig.EndExclusive ? 'LT' : 'LE',
								Value: tmpFilterConfig.Values.End,
							});
						}
					}
					if (!tmpFilterConfig.JoinTable)
					{
						this.log.error(`${tmpFilterConfig.Type} filter missing JoinTable, cannot filter join table.`, { FilterConfig: tmpFilterConfig });
						break;
					}
					if (!tmpFilterConfig.JoinTableExternalConnectionColumn)
					{
						this.log.error(`${tmpFilterConfig.Type} filter missing JoinTableExternalConnectionColumn, cannot filter join table [${tmpFilterConfig.JoinTable}].`);
						break;
					}
					if (tmpFilterResult.Filters.length > 0)
					{
						tmpFilterResult.Filters.push(
						{
							Index: 0,
							Fulcrum: true,
							Entity: tmpFilterConfig.JoinTable,
							Instruction: 'FBL',
							Field: tmpFilterConfig.JoinTableExternalConnectionColumn,
							Operator: 'INN',
							ValueTemplate: `{~PJU:,^${tmpFilterConfig.ExternalFilterByTableConnectionColumn || tmpFilterConfig.JoinTableExternalConnectionColumn}^Record.State[Step-1]~}`,
						});
						if (tmpFilterConfig.PolyJoinRemoteType)
						{
							tmpFilterResult.Filters.push(
							{
								Index: 0,
								Fulcrum: true,
								Entity: tmpFilterConfig.JoinTable,
								Instruction: 'FBV',
								Field: tmpFilterConfig.PolyJoinRemoteColumn || 'RemoteType',
								Operator: 'EQ',
								ValueTemplate: tmpFilterConfig.PolyJoinRemoteType,
							});
						}
						if (!tmpFilterConfig.CoreConnectionColumn)
						{
							this.log.error(`${tmpFilterConfig.Type} filter missing CoreConnectionColumn, cannot filter core table [${pFilterState.Entity}].`);
							break;
						}
						if (!tmpFilterConfig.JoinTableCoreConnectionColumn)
						{
							this.log.error(`${tmpFilterConfig.Type} filter missing JoinTableCoreConnectionColumn, cannot filter core table [${pFilterState.Entity}].`);
							break;
						}
						tmpFilterResult.JoinConfig =
						{
							CoreEntity: pFilterState.Entity,
							Instruction: 'FBLOR',
							Fields: [ tmpFilterConfig.CoreConnectionColumn ],
							Operator: 'INN',
							ValueTemplate: `{~PJU:,^${tmpFilterConfig.JoinTableCoreConnectionColumn}^Record.State[Step0]~}`,
						};
					}
					break;
				case 'StringRange':
				case 'DateRange':
				case 'NumericRange':
				case 'Range':
					if (!tmpFilterConfig.Values || (tmpFilterConfig.Values.Start == null && tmpFilterConfig.Values.End == null))
					{
						break;
					}

					// do not honor '0' for dates
					if (tmpFilterConfig.Type == 'DateRange')
					{
						if ((!tmpFilterConfig.Values.Start || tmpFilterConfig.Values.Start == '0') &&
								(!tmpFilterConfig.Values.End || tmpFilterConfig.Values.End == '0'))
						{
							break;
						}
					}
					/*
					  "Values":
					  {
						  "Start": "2023-01-01T00:00:00Z",
						  "End": "2024-01-01T00:00:00Z"
					  },
					  "FilterByColumn": "CreateDate",
					 */
					for (const tmpField of tmpFilterConfig.FilterByColumns || (tmpFilterConfig.FilterByColumn ? [ tmpFilterConfig.FilterByColumn ] : [ 'Name' ]))
					{
						const hasStartValue = tmpFilterConfig.Values && tmpFilterConfig.Values.Start && (tmpFilterConfig.Type != 'DateRange' || tmpFilterConfig.Values.Start != '0');
						const hasEndValue = tmpFilterConfig.Values && tmpFilterConfig.Values.End && (tmpFilterConfig.Type != 'DateRange' || tmpFilterConfig.Values.End != '0');
						if (hasStartValue)
						{
							tmpFilterResult.Filters.push(
							{
								Index: 0,
								CoreEntity: true,
								Entity: pFilterState.Entity,
								Instruction: 'FBVOR',
								Field: tmpField,
								OpenParen: true,
								OpenParenOr: true,
								CloseParen: !hasEndValue,
								Operator: tmpFilterConfig.StartExclusive ? 'GT' : 'GE',
								Value: tmpFilterConfig.Values.Start,
							});
						}
						if (hasEndValue)
						{
							tmpFilterResult.Filters.push(
							{
								Index: 0,
								CoreEntity: true,
								Entity: pFilterState.Entity,
								Instruction: 'FBV',
								OpenParen: !hasStartValue,
								OpenParenOr: !hasStartValue,
								CloseParen: true,
								Field: tmpField,
								Operator: tmpFilterConfig.EndExclusive ? 'LT' : 'LE',
								Value: tmpFilterConfig.Values.End,
							});
						}
					}
					break;
				case 'StringMatch':
				case 'DateMatch':
				case 'NumericMatch':
				case 'Match':
					/*
					  "Values": [ "John", "Jane" ],
					  "FilterByColumn": "Name",
					  "ExactMatch": false,
					 */
					for (const tmpField of tmpFilterConfig.FilterByColumns || (tmpFilterConfig.FilterByColumn ? [ tmpFilterConfig.FilterByColumn ] : [ 'Name' ]))
					{
						for (const tmpValue of tmpValuesArray)
						{
							const tmpFilter =
							{
								Index: 0,
								CoreEntity: true,
								Entity: pFilterState.Entity,
								Instruction: 'FBVOR',
								Field: tmpField,
							};
							// don't use like for numbers
							if (tmpFilterConfig.ExactMatch || (typeof tmpFilterConfig.ExactMatch === 'undefined' &&
									(tmpFilterConfig.Type == 'NumericMatch' || tmpFilterConfig.Type == 'DateMatch')))
							{
								tmpFilter.Operator = 'EQ';
								tmpFilter.Value = tmpValue;
							}
							else
							{
								tmpFilter.Operator = 'LK';
								tmpFilter.Value = `%25${tmpValue}%25`; //FIXME: figure out a cleaner way to do URL encoding for these - probably, should be downstream, but isn't currently
							}
							tmpFilterResult.Filters.push(tmpFilter);
						}
					}
					break;
				case 'InternalJoinStringRange':
				case 'InternalJoinNumericRange':
				case 'InternalJoinDateRange':
				case 'InternalJoinRange':
					if (!tmpFilterConfig.Values || (tmpFilterConfig.Values.Start == null && tmpFilterConfig.Values.End == null))
					{
						break;
					}

					// do not honor '0' for dates
					if (tmpFilterConfig.Type == 'InternalJoinDateRange')
					{
						if ((!tmpFilterConfig.Values.Start || tmpFilterConfig.Values.Start == '0') &&
								(!tmpFilterConfig.Values.End || tmpFilterConfig.Values.End == '0'))
						{
							break;
						}
					}

					for (const tmpField of tmpFilterConfig.ExternalFilterByColumns || (tmpFilterConfig.ExternalFilterByColumn ? [ tmpFilterConfig.ExternalFilterByColumn ] : [ 'Name' ]))
					{
						const hasStartValue = tmpFilterConfig.Values && tmpFilterConfig.Values.Start && (tmpFilterConfig.Type != 'InternalJoinDateRange' || tmpFilterConfig.Values.Start != '0');
						const hasEndValue = tmpFilterConfig.Values && tmpFilterConfig.Values.End && (tmpFilterConfig.Type != 'InternalJoinDateRange' || tmpFilterConfig.Values.End != '0');
						if (hasStartValue)
						{
							tmpFilterResult.Filters.push(
							{
								Index: 0,
								Entity: tmpFilterConfig.RemoteTable,
								Instruction: 'FBVOR',
								Field: tmpField,
								OpenParen: true,
								OpenParenOr: true,
								CloseParen: !hasEndValue,
								Operator: tmpFilterConfig.StartExclusive ? 'GT' : 'GE',
								Value: tmpFilterConfig.Values.Start,
							});
						}
						if (hasEndValue)
						{
							tmpFilterResult.Filters.push(
							{
								Index: 0,
								Entity: tmpFilterConfig.RemoteTable,
								Instruction: 'FBV',
								OpenParen: !hasStartValue,
								OpenParenOr: !hasStartValue,
								CloseParen: true,
								Field: tmpField,
								Operator: tmpFilterConfig.EndExclusive ? 'LT' : 'LE',
								Value: tmpFilterConfig.Values.End,
							});
						}
					}
					if (tmpFilterResult.Filters.length > 0)
					{
						if (!tmpFilterConfig.JoinInternalConnectionColumn)
						{
							this.log.error(`${tmpFilterConfig.Type} filter missing JoinInternalConnectionColumn, cannot filter core table [${pFilterState.Entity}].`);
							break;
						}
						tmpFilterResult.JoinConfig =
						{
							Instruction: 'FBLOR',
							CoreEntity: pFilterState.Entity,
							Fields: [ tmpFilterConfig.JoinInternalConnectionColumn ],
							Operator: 'INN',
							ValueTemplate: `{~PJU:,^${tmpFilterConfig.JoinExternalConnectionColumn}^Record.State[Step0]~}`,
						};
					}
					break;
				case 'InternalJoinSelectedValue':
				case 'InternalJoinSelectedValueList':
					tmpFilterByColumns = [ tmpFilterConfig.ExternalFilterTableLookupColumn || `ID${tmpFilterConfig.RemoteTable}` ];
					// fall through
				case 'InternalJoinMatch':
				case 'InternalJoinStringMatch':
				case 'InternalJoinDateMatch':
				case 'InternalJoinNumericMatch':
					/*
					  "Values": [ "Bob" ],
                      "RemoteTable": "User",
                      "ExternalFilterByColumns": [ "NameFirst", "NameLast" ],
                      "JoinExternalConnectionColumn": "IDUser",
                      "JoinInternalConnectionColumn": "CreatingIDUser",
					 */
					if (!tmpFilterByColumns)
					{
						tmpFilterByColumns = tmpFilterConfig.ExternalFilterByColumns || (tmpFilterConfig.ExternalFilterByColumn ? [ tmpFilterConfig.ExternalFilterByColumn ] : [ 'Name' ]);
					}
					for (const tmpField of tmpFilterByColumns)
					{
						for (const tmpValue of tmpValuesArray)
						{
							const tmpFilter =
							{
								Index: 0,
								Entity: tmpFilterConfig.RemoteTable,
								Instruction: 'FBVOR',
								Field: tmpField,
							};
							if (tmpFilterConfig.ExactMatch || (typeof tmpFilterConfig.ExactMatch === 'undefined' &&
									(tmpFilterConfig.Type == 'InternalJoinNumericMatch' || tmpFilterConfig.Type == 'InternalJoinDateMatch' || tmpFilterConfig.Type == 'InternalJoinSelectedValue' || tmpFilterConfig.Type == 'InternalJoinSelectedValueList')))
							{
								//TODO: optimize this to use in-list, but requires restructuring of this code
								tmpFilter.Operator = 'EQ';
								tmpFilter.Value = tmpValue;
							}
							else
							{
								tmpFilter.Operator = 'LK';
								tmpFilter.Value = `%25${tmpValue}%25`;
							}
							tmpFilterResult.Filters.push(tmpFilter);
						}
					}
					if (tmpFilterResult.Filters.length > 0)
					{
						if (!tmpFilterConfig.JoinInternalConnectionColumn)
						{
							this.log.error(`${tmpFilterConfig.Type} filter missing JoinInternalConnectionColumn, cannot filter core table [${pFilterState.Entity}].`);
							break;
						}
						tmpFilterResult.JoinConfig =
						{
							Instruction: 'FBLOR',
							CoreEntity: pFilterState.Entity,
							Fields: [ tmpFilterConfig.JoinInternalConnectionColumn ],
							Operator: 'INN',
							ValueTemplate: `{~PJU:,^${tmpFilterConfig.JoinExternalConnectionColumn}^Record.State[Step0]~}`,
						};
					}
					break;
				case 'RawFilter':
					if (!tmpFilterConfig.Value)
					{
						this.log.warn(`RawFilter configuration missing Value, not adding filter.`, { FilterConfig: tmpFilterConfig });
						break;
					}
					pFilterState.UserFilters.push(tmpFilterConfig.Value);
					break;
				default:
					this.log.warn(`Unknown filter type ${tmpFilterConfig.Type} in filter configuration.`, { FilterConfig: tmpFilterConfig });
			}
			if (tmpFilterResult.Filters.length > 0)
			{
				if (tmpFilterConfig.GUIDGroup)
				{
					if (groupedFilterStates[tmpFilterConfig.GUIDGroup])
					{
						groupedFilterStates[tmpFilterConfig.GUIDGroup].PreparedFilters.push(tmpFilterResult);
					}
					else
					{
						groupedFilterStates[tmpFilterConfig.GUIDGroup] = 
						{
							PreparedFilters: [tmpFilterResult],
							Junction: 'AND',
							Ordinal: 0
						};
					}
				}
				else
				{
					tmpResult.push(tmpFilterResult);
				}
			}
		}
		const sortSet = (arr) =>
		{
			for (let x = 0; x < arr.length; x++)
			{
				arr[x].Ordinal = arr[x].Ordinal || 0;
			}
			return arr.sort((a, b) => 
			{
				if (a.Ordinal > b.Ordinal)
				{
					return 1;
				}
				else if (b.Ordinal > a.Ordinal)
				{
					return -1;
				}
				return 0;
			});
		};
		const spreadGroupings = (arr) =>
		{
			const outputSet = [];
			for (const group of arr)
			{
				if (group.PreparedFilters)
				{
					group.PreparedFilters[0].GroupOpen = true;
					group.PreparedFilters[0].GroupJunction = group.Junction;
					group.PreparedFilters[group.PreparedFilters.length - 1].GroupClose = true;
					for (let x = 0; x < group.PreparedFilters.length; x++)
					{
						outputSet.push(group.PreparedFilters[x]);
					}
				}
				else
				{
					outputSet.push(group);
				}
			}
			return outputSet;
		};
		for (let g of Object.keys(groupedFilterStates))
		{
			if (groupedFilterStates[g].PreparedFilters?.length)
			{
				groupedFilterStates[g].PreparedFilters = sortSet(groupedFilterStates[g].PreparedFilters);
			}
			tmpResult.push(groupedFilterStates[g]);
		}
		tmpResult = spreadGroupings(sortSet(tmpResult));
		pFilterState.PreparedFilters = tmpResult;
	}

	/**
	 * @param {FilterState} pFilterState
	 */
	linkPreparedFilters(pFilterState)
	{
		const tmpGroupedStanzas = [];
		for (const tmpPreparedFilter of pFilterState.PreparedFilters || [])
		{
			if (tmpPreparedFilter.JoinConfig)
			{
				const tmpSubGroup = tmpPreparedFilter.Filters;
				const tmpJoinConfig = tmpPreparedFilter.JoinConfig;
				for (const tmpField of tmpJoinConfig.Fields || [])
				{
					const tmpStanza =
					{
						Index: 1,
						CoreEntity: true,
						Entity: tmpPreparedFilter.JoinConfig.CoreEntity,
						Instruction: tmpPreparedFilter.JoinConfig.Instruction || 'FBVOR',
						Field: tmpField,
						Operator: tmpJoinConfig.Operator,
						Value: tmpJoinConfig.Value,
						ValueTemplate: tmpJoinConfig.ValueTemplate,
					};
					tmpSubGroup.push(tmpStanza);
				}
				tmpGroupedStanzas.push(tmpSubGroup);
			}
			else
			{
				tmpGroupedStanzas.push(tmpPreparedFilter.Filters);
			}
		}
		return tmpGroupedStanzas;
	}

	/**
	 * Generate a computed index for each filter in the meadow filter stanzas such that the overall address space is non-overlapping and stable.
	 *
	 * @param {FilterState} pFilterState
	 */
	normalizeMeadowFilterStanzas(pFilterState)
	{
		let tmpTotalIndexCount = 0;
		for (const tmpFilterGroup of pFilterState.PreparedFilters)
		{
			const tmpLocalIndices = new Set();
			tmpFilterGroup.Filters.sort((a, b) => a.Index - b.Index);
			for (const tmpFilter of tmpFilterGroup.Filters)
			{
				if (!tmpFilter.CoreEntity)
				{
					tmpLocalIndices.add(tmpFilter.Index);
				}
			}
			tmpTotalIndexCount += tmpLocalIndices.size;
		}

		let tmpComputedIndex = -tmpTotalIndexCount - 1;

		for (const tmpFilterGroup of pFilterState.PreparedFilters)
		{
			let tmpCurrentIndex = null;
			for (const tmpFilter of tmpFilterGroup.Filters)
			{
				if (tmpFilter.Index !== tmpCurrentIndex)
				{
					++tmpComputedIndex;
					tmpCurrentIndex = tmpFilter.Index;
				}
				tmpFilter.ComputedIndex = tmpComputedIndex;
			}
			for (const tmpFilter of tmpFilterGroup.Filters)
			{
				if (tmpFilter.ValueTemplate)
				{
					tmpFilter.ValueTemplate = tmpFilter.ValueTemplate.replace(/\[([^\]]+)\]/g, (match) =>
					{
						const tmpLocalIndex = match.substring(5, match.length - 1);
						const tmpGlobalIndex = tmpFilterGroup.Filters.find((f) => f.Index == tmpLocalIndex)?.ComputedIndex;
						if (tmpGlobalIndex == null)
						{
							throw new Error(`Filter index ${tmpLocalIndex} not found in group filters.`);
						}
						return match.replace(tmpLocalIndex, tmpGlobalIndex);
					});
				}
			}
		}
	}

	/**
	 * @param {FilterState} pFilterState
	 */
	compileMeadowFilterStanzas(pFilterState)
	{
		const tmpBundleConfig = [];
		//TODO: mathematically solve the number line
		// planned synthesized syntax for running on the server
		// FBV-3_Author~Name~LK~%25Ann%25~FBL-2_BookAuthorJoin~IDAuthor~INN~{~PJU:,^State[Step-3]^IDAuthor~}~FBV-1~User~NameFirst~LK~%25Bob%25~FBVOR-1~User~NameLast~LK~%25Bob%25~FBV~CreateDate~GT~2023-01-01T00:00:00Z~FBV~CreateDate~LT~2024-01-01T00:00:00Z~FBL~IDBook~INN~{~PJU:,^State[Step-2]^IDBook~}
		if (!pFilterState.Filter)
		{
			pFilterState.Filter = `${pFilterState.Entity || 'Unknown'}-${this.pict.getUUID()}`;
		}
		tmpBundleConfig.push(
		{
			Type: 'SetStateAddress',
			StateAddress: `Bundle[${pFilterState.Filter}]`,
		});
		const tmpGroupedFilters = {};
		const tmpGroupedFilterKeys = [];
		const tmpGroupedCoreFilters = [];
		const tmpGroupedCoreFilterKeys = [];
		let tmpCoreEntity;
		const tmpCoreFilterStrings = [];
		for (const tmpFilterGroup of pFilterState.PreparedFilters)
		{
			for (const tmpFilter of tmpFilterGroup.Filters)
			{
				if (tmpFilter.CoreEntity)
				{
					tmpCoreEntity = tmpFilter.Entity;
					const tmpFilterGUID = `${tmpFilterGroup.GUID}-${tmpFilter.ComputedIndex}`;
					if (!tmpGroupedCoreFilterKeys.find((v) => v == tmpFilterGUID))
					{
						tmpGroupedCoreFilterKeys.push(tmpFilterGUID);
					}
					if (!tmpGroupedCoreFilters[tmpFilterGUID])
					{
						tmpGroupedCoreFilters[tmpFilterGUID] = { Stanzas: [], ComputedIndex: tmpFilter.ComputedIndex, Entity: tmpFilter.Entity, Junction: tmpFilterGroup.Junction || 'AND', GroupOpen: tmpFilterGroup.GroupOpen || false, GroupJunction: tmpFilterGroup.GroupJunction || 'AND', GroupClose: tmpFilterGroup.GroupClose || false };
					}
					tmpGroupedCoreFilters[tmpFilterGUID].Stanzas.push(this._compileSimpleFilterToString(tmpFilter));
				}
				else
				{
					const tmpFilterGroupGUID = `${tmpFilterGroup.GUID}-${tmpFilter.ComputedIndex}`;
					if (!tmpGroupedFilterKeys.find((v) => v == tmpFilterGroupGUID))
					{
						tmpGroupedFilterKeys.push(tmpFilterGroupGUID);
					}
					if (!tmpGroupedFilters[tmpFilterGroupGUID])
					{
						tmpGroupedFilters[tmpFilterGroupGUID] = { Stanzas: [], ComputedIndex: tmpFilter.ComputedIndex, Entity: tmpFilter.Entity };
					}
					tmpGroupedFilters[tmpFilterGroupGUID].Stanzas.push(this._compileSimpleFilterToString(tmpFilter));
				}
			}
			for (const tmpFilterGroupKey of tmpGroupedFilterKeys)
			{
				tmpGroupedFilters[tmpFilterGroupKey].Stanzas = tmpGroupedFilters[tmpFilterGroupKey].Stanzas.filter((f) => f.length > 0);
				if (tmpGroupedFilters[tmpFilterGroupKey].Stanzas.length > 0)
				{
					tmpBundleConfig.push(
						{
							Type: 'MeadowEntity',
							AllRecords: true,
							Entity: tmpGroupedFilters[tmpFilterGroupKey].Entity,
							Filter: tmpGroupedFilters[tmpFilterGroupKey].Stanzas.join('~'),
							Destination: `State[Step${tmpGroupedFilters[tmpFilterGroupKey].ComputedIndex}]`,
						});
				}
			}
		}
		for (const tmpCoreFilterKey of tmpGroupedCoreFilterKeys)
		{
			tmpGroupedCoreFilters[tmpCoreFilterKey].Stanzas = tmpGroupedCoreFilters[tmpCoreFilterKey].Stanzas.filter((f) => f.length > 0);
			if (tmpGroupedCoreFilters[tmpCoreFilterKey].Stanzas.length > 0)
			{
				let stringConstruct = '';
				if (tmpGroupedCoreFilters[tmpCoreFilterKey].GroupOpen)
				{
					stringConstruct += tmpGroupedCoreFilters[tmpCoreFilterKey].GroupJunction == 'OR' ? 'FOPOR~0~(~0~' : 'FOP~0~(~0~';
				}
				stringConstruct += [ tmpGroupedCoreFilters[tmpCoreFilterKey].Junction == 'OR' ? 'FOPOR~0~(~0' : 'FOP~0~(~0', ...tmpGroupedCoreFilters[tmpCoreFilterKey].Stanzas, 'FCP~0~)~0'].join('~');
				if (tmpGroupedCoreFilters[tmpCoreFilterKey].GroupClose)
				{
					stringConstruct += '~FCP~0~)~0'
				}
				tmpCoreFilterStrings.push(stringConstruct);
			}
		}
		if (!tmpCoreEntity)
		{
			tmpCoreEntity = pFilterState.Entity;
		}
		const tmpCoreLoadStep =
		{
			Type: pFilterState.Mode === 'Count' ? 'MeadowEntityCount' : 'MeadowEntity',
			Entity: tmpCoreEntity,
			Filter: tmpCoreFilterStrings.join('~'),
			AllRecords: typeof pFilterState.PageSize === 'undefined',
			RecordStartCursor: pFilterState.RecordOffset,
			Postfix: pFilterState.Postfix || '',
			PageSize: pFilterState.PageSize,
			Destination: pFilterState.ResultDestinationAddress,
		};
		if (pFilterState.UserFilters.length > 0)
		{
			let tmpAllSorts = '';
			let tmpFilter = '';
			for (const tmpUserFilter of pFilterState.UserFilters)
			{
				let tmpSorts;
				let tmpSanitizedUserFilter = tmpUserFilter;
				if (pFilterState.Mode === 'Count')
				{
					tmpSanitizedUserFilter = this._sanitizeFilterForCount(tmpUserFilter);
				}
				else
				{
					[ tmpSanitizedUserFilter, tmpSorts ] = this._extractSortsFromFilter(tmpUserFilter);
					if (tmpSorts)
					{
						if (tmpAllSorts.length > 0)
						{
							tmpAllSorts += '~';
						}
						tmpAllSorts += tmpSorts;
					}
					if (!tmpSanitizedUserFilter)
					{
						continue;
					}
				}
				if (!tmpSanitizedUserFilter)
				{
					continue;
				}
				if (tmpFilter.length > 0)
				{
					tmpFilter += '~';
				}
				tmpFilter += 'FOP~0~(~0~';
				tmpFilter += tmpSanitizedUserFilter;
				tmpFilter += '~FCP~0~)~0';
			}
			if (tmpCoreLoadStep.Filter)
			{
				if (tmpFilter.length > 0)
				{
					tmpFilter += '~';
				}
				tmpFilter += 'FOP~0~(~0~';
				tmpFilter += tmpCoreLoadStep.Filter;
				tmpFilter += '~FCP~0~)~0';
			}
			if (tmpAllSorts)
			{
				if (tmpFilter.length > 0)
				{
					tmpFilter += '~';
				}
				tmpFilter += tmpAllSorts;
			}
			tmpCoreLoadStep.Filter = tmpFilter;
		}
		tmpBundleConfig.push(tmpCoreLoadStep);
		pFilterState.BundleConfig = tmpBundleConfig;
	}

	/**
	 * @param {string} pFilter
	 *
	 * @return {string}
	 */
	_sanitizeFilterForCount(pFilter)
	{
		if (!pFilter || typeof pFilter !== 'string')
		{
			return pFilter;
		}

		let tmpMicroStanzas = pFilter.split('~');
		for (let i = 0; i < tmpMicroStanzas.length; i += 4)
		{
			if (tmpMicroStanzas[i] === 'FSF')
			{
				tmpMicroStanzas = tmpMicroStanzas.slice(0, i).concat(tmpMicroStanzas.slice(i + 4));
				i -= 4; // adjust for removed elements
			}
		}
		return tmpMicroStanzas.join('~');
	}

	/**
	 * @param {string} pFilter
	 *
	 * @return {Array<string>}
	 */
	_extractSortsFromFilter(pFilter)
	{
		if (!pFilter || typeof pFilter !== 'string')
		{
			return [ pFilter, '' ];
		}

		let tmpSortStanzas = [];
		let tmpMicroStanzas = pFilter.split('~');
		for (let i = 0; i < tmpMicroStanzas.length; i += 4)
		{
			if (tmpMicroStanzas[i] === 'FSF')
			{
				tmpSortStanzas.push(tmpMicroStanzas.slice(i, i + 4).join('~'));
				tmpMicroStanzas = tmpMicroStanzas.slice(0, i).concat(tmpMicroStanzas.slice(i + 4));
				i -= 4; // adjust for removed elements
			}
		}
		return [ tmpMicroStanzas.join('~'), tmpSortStanzas.join('~') ];
	}

	_compileSimpleFilterToString(pFilter)
	{
		let tmpFilterString = `${pFilter.Instruction}`;
		tmpFilterString += `~${pFilter.Field}`;
		tmpFilterString += `~${pFilter.Operator}`;
		if (pFilter.ValueTemplate)
		{
			tmpFilterString += `~${pFilter.ValueTemplate}`;
		}
		else
		{
			tmpFilterString += `~${pFilter.Value || ''}`;
		}
		if (pFilter.OpenParen)
		{
			tmpFilterString = `${ pFilter.OpenParenOr ? 'FOPOR' : 'FOP' }~0~(~0~${tmpFilterString}`;
		}
		if (pFilter.CloseParen)
		{
			tmpFilterString = `${tmpFilterString}~FCP~0~)~0`;
		}
		return tmpFilterString;
	}
}

module.exports = FilterMeadowStanzaTokenGenerator;

},{}],205:[function(require,module,exports){

/**
 * @typedef {{
 *    Type: 'None'
 * } | {
 *    Type: 'Match' | 'StringMatch' | 'DateMatch' | 'NumericMatch',
 *    Values: string[] | number[],
 *    ExactMatch?: boolean,
 *    FilterByColumn: string,
 * } | {
 *    Type: 'Range' | 'StringRange' | 'DateRange' | 'NumericRange',
 *    Values: { Start?: string | number, End?: string | number },
 *    StartExclusive?: boolean,
 *    EndExclusive?: boolean,
 *    FilterByColumn: string,
 * } | {
 *    Type: 'InternalJoinMatch' | 'InternalJoinStringMatch' | 'InternalJoinNumericMatch' | 'InternalJoinDateMatch',
 *    Values: string[] | number[],
 *    ExactMatch?: boolean,
 *    RemoteTable: string,
 *    ExternalFilterByColumn?: string,
 *    ExternalFilterByColumns?: string[],
 *    JoinExternalConnectionColumn: string,
 *    JoinInternalConnectionColumn: string,
 * } | {
 *    Type: 'InternalJoinSelectedValue' | 'InternalJoinSelectedValueList',
 *    Values: string[] | number[],
 *    ExactMatch?: boolean,
 *    RemoteTable: string,
 *    ExternalFilterByColumn?: string,
 *    ExternalFilterByColumns?: string[],
 *    ExternalFilterTableLookupColumn?: string,
 *    JoinExternalConnectionColumn: string,
 *    JoinInternalConnectionColumn: string,
 * } | {
 *    Type: 'InternalJoinRange' | 'InternalJoinStringRange' | 'InternalJoinNumericRange' | 'InternalJoinDateRange',
 *    Values: { Start?: string | number, End?: string | number },
 *    StartExclusive?: boolean,
 *    EndExclusive?: boolean,
 *    RemoteTable: string,
 *    ExternalFilterByColumn?: string,
 *    ExternalFilterByColumns?: string[],
 *    JoinExternalConnectionColumn: string,
 *    JoinInternalConnectionColumn: string,
 * } | {
 *    Type: 'ExternalJoinMatch' | 'ExternalJoinStringMatch' | 'ExternalJoinNumericMatch' | 'ExternalJoinDateMatch',
 *    Values: string[] | number[],
 *    ExactMatch?: boolean,
 *    ExternalFilterByColumn?: string,
 *    ExternalFilterByColumns?: string[],
 *    CoreConnectionColumn: string,
 *    JoinTable: string,
 *    JoinTableExternalConnectionColumn: string,
 *    JoinTableCoreConnectionColumn: string,
 *    ExternalFilterByTable: string,
 *    ExternalFilterByTableConnectionColumn: string,
 * 	  PolyJoinRemoteType: string,
 *    PolyJoinRemoteColumn: string
 * } | {
 *    Type: 'ExternalJoinRange' | 'ExternalJoinStringRange' | 'ExternalJoinNumericRange' | 'ExternalJoinDateRange',
 *    Values: { Start?: string | number, End?: string | number },
 *    StartExclusive?: boolean,
 *    EndExclusive?: boolean,
 *    ExternalFilterByColumn?: string,
 *    ExternalFilterByColumns?: string[],
 *    CoreConnectionColumn: string,
 *    JoinTable: string,
 *    JoinTableExternalConnectionColumn: string,
 *    JoinTableCoreConnectionColumn: string,
 *    ExternalFilterByTable: string,
 *    ExternalFilterByTableConnectionColumn: string,
 * 	  PolyJoinRemoteType: string,
 *    PolyJoinRemoteColumn: string
 * } | {
 *    Type: 'ExternalJoinSelectedValue' | 'ExternalJoinSelectedValueList',
 *    Values: { Start?: string | number, End?: string | number },
 *    StartExclusive?: boolean,
 *    EndExclusive?: boolean,
 *    ExternalFilterByColumn?: string,
 *    ExternalFilterByColumns?: string[],
 *    CoreConnectionColumn: string,
 *    JoinTable: string,
 *    JoinTableExternalConnectionColumn: string,
 *    JoinTableCoreConnectionColumn: string,
 *    ExternalFilterByTable: string,
 *    ExternalFilterTableLookupColumn?: string,
 *    ExternalFilterByTableConnectionColumn: string,
 * 	  PolyJoinRemoteType: string,
 *    PolyJoinRemoteColumn: string
 * }} FilterClauseConfig
 */

class FilterClauseBase
{
	/**
	 * @param {import('../Pict.js')} pFable
	 */
	constructor(pFable)
	{
		this.fable = pFable;
		this.pict = pFable;
		this.log = pFable.log;

		/** @type {import('./Filter.js').FilterType} */
		this._type = 'None';
		/** @type {string[] | number[] | { Start?: string | number, End?: string | number }} */
		this.values = [];
	}


	/**
	 * @param {import('./Filter.js').FilterType} pType
	 */
	set type(pType)
	{
		this._type = pType;
		if (pType.includes('Range'))
		{
			if (typeof this.values !== 'object' || this.values === null || Array.isArray(this.values))
			{
				this.values = { Start: undefined, End: undefined };
			}
		}
		else
		{
			if (!Array.isArray(this.values))
			{
				this.values = [];
			}
		}
	}

	/**
	 * @return {import('./Filter.js').FilterType}
	 */
    get type()
    {
        return this._type;
    }

	/**
	 * @return {FilterClauseConfig}
	 */
	generateFilterClauseConfig()
	{
		return { Type: 'None' };
	}
}

module.exports = FilterClauseBase;

},{}],206:[function(require,module,exports){

const libFilterClauseBase = require('./FilterClauseBase.js');

/**
 * Manage filter state for a filter that works on a one level of indirect direct join.
 */
class FilterClauseExternalJoin extends libFilterClauseBase
{
	/**
	 * @param {import('../Pict.js')} pFable
	 */
	constructor(pFable)
	{
		super(pFable);

		/** @type {import('./Filter.js').FilterType} */
		this.type = 'ExternalJoinMatch';
		/** @type {string[] | number[] | { Start?: string | number, End?: string | number }} */
		this.values = [];
		/** @type {boolean?} */
		this.exactMatch;
		/** @type {boolean?} */
		this.startExclusive;
		/** @type {boolean?} */
		this.endExclusive;
		/** @type {string?} */
		this.externalFilterByColumn;
		/** @type {string[]?} */
		this.externalFilterByColumns;
		/** @type {string} */
		this.coreConnectionColumn = '';
		/** @type {string} */
		this.joinTable = '';
		/** @type {string} */
		this.joinTableExternalConnectionColumn = '';
		/** @type {string} */
		this.joinTableCoreConnectionColumn = '';
		/** @type {string} */
		this.externalFilterByTable = '';
		/** @type {string} */
		this.externalFilterTableLookupColumn = '';
		/** @type {string} */
		this.externalFilterByTableConnectionColumn = '';
		/** @type {string} */
		this.polyJoinRemoteType = '';
		/** @type {string} */
		this.polyJoinRemoteColumn = '';
	}

	/**
	 * @return {import('./FilterClauseBase.js').FilterClauseConfig}
	 */
	generateFilterClauseConfig()
	{
		switch (this.type)
		{
			case 'ExternalJoinMatch':
			case 'ExternalJoinStringMatch':
			case 'ExternalJoinDateMatch':
			case 'ExternalJoinNumericMatch':
				return {
					Type: this.type,
					Values: Array.isArray(this.values) ? this.values : [],
					ExactMatch: this.exactMatch,
					ExternalFilterByColumn: this.externalFilterByColumn,
					ExternalFilterByColumns: this.externalFilterByColumns,
					CoreConnectionColumn: this.coreConnectionColumn,
					JoinTable: this.joinTable,
					JoinTableExternalConnectionColumn: this.joinTableExternalConnectionColumn,
					JoinTableCoreConnectionColumn: this.joinTableCoreConnectionColumn,
					ExternalFilterByTable: this.externalFilterByTable,
					ExternalFilterByTableConnectionColumn: this.externalFilterByTableConnectionColumn,
					PolyJoinRemoteType: this.polyJoinRemoteType,
					PolyJoinRemoteColumn: this.polyJoinRemoteColumn
				};
			case 'ExternalJoinRange':
			case 'ExternalJoinStringRange':
			case 'ExternalJoinDateRange':
			case 'ExternalJoinNumericRange':
				return {
					Type: this.type,
					Values: Array.isArray(this.values) ? { Start: undefined, End: undefined } : Object.assign({}, this.values),
					StartExclusive: this.startExclusive,
					EndExclusive: this.endExclusive,
					ExternalFilterByColumn: this.externalFilterByColumn,
					ExternalFilterByColumns: this.externalFilterByColumns,
					CoreConnectionColumn: this.coreConnectionColumn,
					JoinTable: this.joinTable,
					JoinTableExternalConnectionColumn: this.joinTableExternalConnectionColumn,
					JoinTableCoreConnectionColumn: this.joinTableCoreConnectionColumn,
					ExternalFilterByTable: this.externalFilterByTable,
					ExternalFilterByTableConnectionColumn: this.externalFilterByTableConnectionColumn,
					PolyJoinRemoteType: this.polyJoinRemoteType,
					PolyJoinRemoteColumn: this.polyJoinRemoteColumn
				};
			case 'ExternalJoinSelectedValue':
			case 'ExternalJoinSelectedValueList':
				return {
					Type: this.type,
					Values: Array.isArray(this.values) ? { Start: undefined, End: undefined } : Object.assign({}, this.values),
					StartExclusive: this.startExclusive,
					EndExclusive: this.endExclusive,
					ExternalFilterByColumn: this.externalFilterByColumn,
					ExternalFilterByColumns: this.externalFilterByColumns,
					CoreConnectionColumn: this.coreConnectionColumn,
					JoinTable: this.joinTable,
					JoinTableExternalConnectionColumn: this.joinTableExternalConnectionColumn,
					JoinTableCoreConnectionColumn: this.joinTableCoreConnectionColumn,
					ExternalFilterByTable: this.externalFilterByTable,
					ExternalFilterTableLookupColumn: this.externalFilterTableLookupColumn,
					ExternalFilterByTableConnectionColumn: this.externalFilterByTableConnectionColumn,
					PolyJoinRemoteType: this.polyJoinRemoteType,
					PolyJoinRemoteColumn: this.polyJoinRemoteColumn
				};
			default:
				throw new Error(`Unsupported filter type: ${this.type}`);
		}
	}
}

module.exports = FilterClauseExternalJoin;

},{"./FilterClauseBase.js":205}],207:[function(require,module,exports){

const libFilterClauseBase = require('./FilterClauseBase.js');

/**
 * Manage filter state for a filter that works on a one level of indirect direct join.
 */
class FilterClauseInternalJoin extends libFilterClauseBase
{
	/**
	 * @param {import('../Pict.js')} pFable
	 */
	constructor(pFable)
	{
		super(pFable);

		/** @type {import('./Filter.js').FilterType} */
		this.type = 'None';
		/** @type {string[] | number[] | { Start?: string | number, End?: string | number }} */
		this.values = [];
		/** @type {boolean?} */
		this.exactMatch;
		/** @type {boolean?} */
		this.startExclusive;
		/** @type {boolean?} */
		this.endExclusive;
		/** @type {string} */
		this.remoteTable = '';
		/** @type {string?} */
		this.externalFilterByColumn;
		/** @type {string[]?} */
		this.externalFilterByColumns;
		/** @type {string?} */
		this.externalFilterTableLookupColumn;
		/** @type {string} */
		this.joinExternalConnectionColumn = '';
		/** @type {string} */
		this.joinInternalConnectionColumn = '';
	}

	/**
	 * @return {import('./FilterClauseBase.js').FilterClauseConfig}
	 */
	generateFilterClauseConfig()
	{
		switch (this._type)
		{
			case 'InternalJoinMatch':
			case 'InternalJoinStringMatch':
			case 'InternalJoinDateMatch':
			case 'InternalJoinNumericMatch':
				return {
					Type: this._type,
					Values: Array.isArray(this.values) ? this.values : [],
					ExactMatch: this.exactMatch,
					RemoteTable: this.remoteTable,
					ExternalFilterByColumn: this.externalFilterByColumn,
					ExternalFilterByColumns: this.externalFilterByColumns,
					JoinExternalConnectionColumn: this.joinExternalConnectionColumn,
					JoinInternalConnectionColumn: this.joinInternalConnectionColumn,
				};
			case 'InternalJoinSelectedValue':
			case 'InternalJoinSelectedValueList':
				return {
					Type: this._type,
					Values: Array.isArray(this.values) ? this.values : [],
					ExactMatch: this.exactMatch,
					RemoteTable: this.remoteTable,
					ExternalFilterByColumn: this.externalFilterByColumn,
					ExternalFilterByColumns: this.externalFilterByColumns,
					ExternalFilterTableLookupColumn: this.externalFilterTableLookupColumn,
					JoinExternalConnectionColumn: this.joinExternalConnectionColumn,
					JoinInternalConnectionColumn: this.joinInternalConnectionColumn,
				};
			case 'InternalJoinRange':
			case 'InternalJoinStringRange':
			case 'InternalJoinDateRange':
			case 'InternalJoinNumericRange':
				return {
					Type: this._type,
					Values: Array.isArray(this.values) ? { Start: undefined, End: undefined } : Object.assign({}, this.values),
					StartExclusive: this.startExclusive,
					EndExclusive: this.endExclusive,
					RemoteTable: this.remoteTable,
					ExternalFilterByColumn: this.externalFilterByColumn,
					ExternalFilterByColumns: this.externalFilterByColumns,
					JoinExternalConnectionColumn: this.joinExternalConnectionColumn,
					JoinInternalConnectionColumn: this.joinInternalConnectionColumn,
				};
			default:
				throw new Error(`Unsupported filter type: ${this.type}`);
		}
	}
}

module.exports = FilterClauseInternalJoin;

},{"./FilterClauseBase.js":205}],208:[function(require,module,exports){

const libFilterClauseBase = require('./FilterClauseBase.js');

/**
 * Manage filter state for a filter that only works on fields local to the table.
 */
class FilterClauseLocal extends libFilterClauseBase
{
	/**
	 * @param {import('../Pict.js')} pFable
	 */
	constructor(pFable)
	{
		super(pFable);

		/** @type {import('./Filter.js').FilterType} */
		this._type = 'Match';
		/** @type {string} */
		this.filterByColumn;
		/** @type {boolean?} */
		this.exactMatch;
		/** @type {boolean?} */
		this.startExclusive;
		/** @type {boolean?} */
		this.endExclusive;
	}

	/**
	 * @return {import('./FilterClauseBase.js').FilterClauseConfig}
	 */
	generateFilterClauseConfig()
	{
		switch (this._type)
		{
			case 'Match':
			case 'StringMatch':
			case 'DateMatch':
			case 'NumericMatch':
				return {
					Type: this._type,
					Values: Array.isArray(this.values) ? this.values : [],
					ExactMatch: this.exactMatch,
					FilterByColumn: this.filterByColumn,
				};
			case 'Range':
			case 'StringRange':
			case 'DateRange':
			case 'NumericRange':
				return {
					Type: this._type,
					Values: Array.isArray(this.values) ? { Start: undefined, End: undefined } : Object.assign({}, this.values),
					StartExclusive: this.startExclusive,
					EndExclusive: this.endExclusive,
					FilterByColumn: this.filterByColumn,
				};
			default:
				throw new Error(`Unsupported filter type: ${this.type}`);
		}
	}
}

module.exports = FilterClauseLocal;

},{"./FilterClauseBase.js":205}],209:[function(require,module,exports){
/**
 * Built-in icon set for Pict-Provider-Icon.
 *
 * Every glyph is a full <svg> string with `viewBox="0 0 24 24"` and uses
 * `currentColor` for paint so it picks up surrounding text color (and
 * therefore the active theme).  Width/height are intentionally NOT set
 * on the <svg> — the provider's CSS sizes them via `font-size` so
 * consumers can scale with the natural font cascade or via an `em`-aware
 * `style="font-size:20px"` from a one-off `pict.icon('X', { size: 20 })`.
 *
 * Variants:
 *   - Outline  (default)  — single-stroke, hollow.  Lucide-style.
 *   - Filled              — solid currentColor fill, no stroke.  Used when
 *                            the filled visual is meaningfully distinct
 *                            (closed-shape icons mostly — see _DEFAULTS).
 *
 * Adding more variants (TwoTone, Duotone, custom illustrative sets) is
 * just another key on the exported map plus a corresponding `registerSet`
 * call from a host or section-module.  No core change required.
 *
 * Naming convention: PascalCase canonical names.  Aliases live in
 * Provider-Icon.js (Gear -> Settings, House -> Home, X -> Close, etc.)
 * so consumers don't fight over naming.
 */

const _OutlineDefaults =
{
	// File system
	'Folder': '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M3 7.5V18a1.5 1.5 0 0 0 1.5 1.5h15A1.5 1.5 0 0 0 21 18V9a1.5 1.5 0 0 0-1.5-1.5h-7L10.5 6H4.5A1.5 1.5 0 0 0 3 7.5z"/></svg>',
	'FolderOpen': '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M3 7.5V18a1.5 1.5 0 0 0 1.5 1.5h15A1.5 1.5 0 0 0 21 18v-7H3"/><path d="M3 7.5h7L11.5 9h8A1.5 1.5 0 0 1 21 10.5"/></svg>',
	'File': '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>',
	'FileText': '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="8" y1="13" x2="16" y2="13"/><line x1="8" y1="17" x2="14" y2="17"/></svg>',
	'Spreadsheet': '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="16" rx="1.5"/><line x1="3" y1="9" x2="21" y2="9"/><line x1="3" y1="14" x2="21" y2="14"/><line x1="9" y1="4" x2="9" y2="20"/></svg>',
	'Image': '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="16" rx="2"/><circle cx="9" cy="10" r="1.5"/><path d="m21 16-5-5L7 20"/></svg>',
	'Code': '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><polyline points="16 18 22 12 16 6"/><polyline points="8 6 2 12 8 18"/></svg>',

	// Chevrons (open shapes — Outline only makes sense)
	'ChevronUp':    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 15 12 9 18 15"/></svg>',
	'ChevronDown':  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"/></svg>',
	'ChevronLeft':  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 6 9 12 15 18"/></svg>',
	'ChevronRight': '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 6 15 12 9 18"/></svg>',

	// Arrows (open shapes)
	'ArrowUp':    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="19" x2="12" y2="5"/><polyline points="5 12 12 5 19 12"/></svg>',
	'ArrowDown':  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="5" x2="12" y2="19"/><polyline points="19 12 12 19 5 12"/></svg>',
	'ArrowLeft':  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><line x1="19" y1="12" x2="5" y2="12"/><polyline points="12 19 5 12 12 5"/></svg>',
	'ArrowRight': '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>',

	// Actions
	'Save': '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"/><polyline points="17 21 17 13 7 13 7 21"/><polyline points="7 3 7 8 15 8"/></svg>',
	'Close':  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>',
	'Check':  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>',
	'Plus':   '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>',
	'Minus':  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"/></svg>',
	'Edit':   '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>',
	'Trash':  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/><line x1="10" y1="11" x2="10" y2="17"/><line x1="14" y1="11" x2="14" y2="17"/></svg>',
	'Copy':   '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg>',
	'Share':  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><circle cx="18" cy="5"  r="3"/><circle cx="6"  cy="12" r="3"/><circle cx="18" cy="19" r="3"/><line x1="8.59"  y1="13.51" x2="15.42" y2="17.49"/><line x1="15.41" y1="6.51"  x2="8.59"  y2="10.49"/></svg>',
	'Search': '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>',
	'Refresh':'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><polyline points="23 4 23 10 17 10"/><polyline points="1 20 1 14 7 14"/><path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"/></svg>',
	'Download':'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>',
	'Upload': '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/></svg>',
	'Link':   '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/></svg>',
	'ExternalLink':'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/><polyline points="15 3 21 3 21 9"/><line x1="10" y1="14" x2="21" y2="3"/></svg>',

	// Status
	'Info':    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/></svg>',
	'Warning': '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>',
	'Error':   '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="15" y1="9"  x2="9"  y2="15"/><line x1="9"  y1="9"  x2="15" y2="15"/></svg>',
	'Success': '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>',

	// UI chrome
	'Home':     '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M3 10.5 12 3l9 7.5V20a1 1 0 0 1-1 1h-5v-7h-6v7H4a1 1 0 0 1-1-1v-9.5z"/></svg>',
	'Settings': '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 1 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.6 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 1 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 1 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 1 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/></svg>',
	'Menu':     '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><line x1="3" y1="6"  x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/></svg>',
	'More':     '<svg viewBox="0 0 24 24" fill="currentColor" stroke="none"><circle cx="5"  cy="12" r="1.6"/><circle cx="12" cy="12" r="1.6"/><circle cx="19" cy="12" r="1.6"/></svg>',
	'Eye':      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>',
	'EyeOff':   '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/><line x1="1" y1="1" x2="23" y2="23"/></svg>',
	'Lock':     '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>',
	'User':     '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>',
	'Help':     '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>'
};

// Filled variants — only where the filled visual is meaningfully distinct
// from the outline.  Open-shape icons (Chevrons, Arrows, Close, Plus) have
// no Filled variant; lookup falls back to Outline.
const _FilledVariants =
{
	'Folder':     '<svg viewBox="0 0 24 24" fill="currentColor" stroke="none"><path d="M3 7.5V18a1.5 1.5 0 0 0 1.5 1.5h15A1.5 1.5 0 0 0 21 18V9a1.5 1.5 0 0 0-1.5-1.5h-7L10.5 6H4.5A1.5 1.5 0 0 0 3 7.5z"/></svg>',
	'FolderOpen': '<svg viewBox="0 0 24 24" fill="currentColor" stroke="none"><path d="M3 8a1 1 0 0 1 1-1h6.5l2 2H20a1 1 0 0 1 1 1v8.5A1.5 1.5 0 0 1 19.5 20h-15A1.5 1.5 0 0 1 3 18.5V8z" fill-opacity="0.92"/></svg>',
	'File':       '<svg viewBox="0 0 24 24" fill="currentColor" stroke="none"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6zm-.5 7V3.5L19.5 9.5H14a.5.5 0 0 1-.5-.5z"/></svg>',
	'FileText':   '<svg viewBox="0 0 24 24" fill="currentColor" stroke="none"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6zm-.5 7V3.5L19.5 9.5H14a.5.5 0 0 1-.5-.5zM8 12.4a.6.6 0 0 1 .6-.6h6.8a.6.6 0 0 1 0 1.2H8.6a.6.6 0 0 1-.6-.6zm0 4a.6.6 0 0 1 .6-.6h4.8a.6.6 0 0 1 0 1.2H8.6a.6.6 0 0 1-.6-.6z"/></svg>',
	'Spreadsheet':'<svg viewBox="0 0 24 24" fill="currentColor" stroke="none"><path d="M4 4h16a1.5 1.5 0 0 1 1.5 1.5v13A1.5 1.5 0 0 1 20 20H4a1.5 1.5 0 0 1-1.5-1.5v-13A1.5 1.5 0 0 1 4 4zm5 1.2H4.2v3.6H9V5.2zm10.8 0H10.2v3.6h9.6V5.2zM9 9.7H4.2v3.6H9V9.7zm10.8 0H10.2v3.6h9.6V9.7zM9 14.2H4.2v4.6H9v-4.6zm10.8 0H10.2v4.6h9.6v-4.6z"/></svg>',
	'Home':       '<svg viewBox="0 0 24 24" fill="currentColor" stroke="none"><path d="M11.3 2.2a1 1 0 0 1 1.4 0l9 7.5a1 1 0 0 1 .3.7V20a1 1 0 0 1-1 1h-5a.5.5 0 0 1-.5-.5V14a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0-.5.5v6.5a.5.5 0 0 1-.5.5H4a1 1 0 0 1-1-1v-9.5a1 1 0 0 1 .3-.7l8-7.6z"/></svg>',
	'Settings':   '<svg viewBox="0 0 24 24" fill="currentColor" stroke="none"><path d="M19.43 12.98c.04-.32.07-.65.07-.98s-.03-.66-.07-.98l2.11-1.65a.5.5 0 0 0 .12-.64l-2-3.46a.5.5 0 0 0-.61-.22l-2.49 1a7.3 7.3 0 0 0-1.69-.98l-.38-2.65A.49.49 0 0 0 14 2h-4a.49.49 0 0 0-.49.42l-.38 2.65a7.6 7.6 0 0 0-1.69.98l-2.49-1a.51.51 0 0 0-.61.22l-2 3.46a.493.493 0 0 0 .12.64l2.11 1.65c-.04.32-.07.65-.07.98s.03.66.07.98l-2.11 1.65a.5.5 0 0 0-.12.64l2 3.46a.5.5 0 0 0 .61.22l2.49-1c.52.4 1.08.73 1.69.98l.38 2.65A.49.49 0 0 0 10 22h4a.49.49 0 0 0 .49-.42l.38-2.65c.61-.25 1.17-.59 1.69-.98l2.49 1c.23.09.49 0 .61-.22l2-3.46a.5.5 0 0 0-.12-.64l-2.11-1.65zM12 15.5A3.5 3.5 0 1 1 12 8.5a3.5 3.5 0 0 1 0 7z"/></svg>',
	'Trash':      '<svg viewBox="0 0 24 24" fill="currentColor" stroke="none"><path d="M9 3a1 1 0 0 0-1 1v1H4.5a.5.5 0 0 0 0 1H5v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V6h.5a.5.5 0 0 0 0-1H16V4a1 1 0 0 0-1-1H9zm1 5a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-1 0v-9a.5.5 0 0 1 .5-.5zm4 0a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-1 0v-9a.5.5 0 0 1 .5-.5z"/></svg>',
	'User':       '<svg viewBox="0 0 24 24" fill="currentColor" stroke="none"><circle cx="12" cy="7" r="4"/><path d="M4 21v-1a6 6 0 0 1 6-6h4a6 6 0 0 1 6 6v1H4z"/></svg>',
	'Lock':       '<svg viewBox="0 0 24 24" fill="currentColor" stroke="none"><path d="M12 2a5 5 0 0 0-5 5v3H6a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-9a2 2 0 0 0-2-2h-1V7a5 5 0 0 0-5-5zm-3 5a3 3 0 0 1 6 0v3H9V7z"/></svg>',
	'Info':       '<svg viewBox="0 0 24 24" fill="currentColor" stroke="none"><path d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20zm-.99 5.99a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM10.5 11h2a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-1 0V12h-1.5a.5.5 0 0 1 0-1z"/></svg>',
	'Warning':    '<svg viewBox="0 0 24 24" fill="currentColor" stroke="none"><path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0zM11.5 9a.5.5 0 0 1 1 0v4a.5.5 0 0 1-1 0V9zM12 17.5a.9.9 0 1 1 0-1.8.9.9 0 0 1 0 1.8z"/></svg>'
};

module.exports =
{
	Outline: _OutlineDefaults,
	Filled:  _FilledVariants
};

},{}],210:[function(require,module,exports){
const libPictProvider = require('pict-provider');

/** @type {Record<string, any>} */
const _DEFAULT_PROVIDER_CONFIGURATION =
{
	ProviderIdentifier: 'Pict-Provider-DataBroker',

	AutoInitialize: true,
	AutoInitializeOrdinal: 0
}

class PictDataBrokerProvider extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DEFAULT_PROVIDER_CONFIGURATION, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		/** @type {Record<string, any>} */
		this.options;
		/** @type {import('../Pict.js')} */
		this.pict;

		this.marshalDestination = 'AppData';
	}

	/**
	 * @param {string} pHash - The hash of the value to retrieve.
	 */
	getValue(pHash)
	{
		return this.getValueByHash(pHash);
	}

	/**
	 * @param {string} pHash - The hash of the value to retrieve.
	 */
	getValueByHash(pHash)
	{
		return this.pict.manifest.getValueByHash(this.getMarshalDestinationObject(), pHash);
	}

	/**
	 * @param {string} pHash - The hash of the value to retrieve.
	 * @param {any} pValue - The value to set.
	 */
	setValue(pHash, pValue)
	{
		return this.setValueByHash(pHash, pValue);
	}

	/**
	 * @param {string} pHash - The hash of the value to retrieve.
	 * @param {any} pValue - The value to set.
	 */
	setValueByHash(pHash, pValue)
	{
		return this.pict.manifest.setValueByHash(this.getMarshalDestinationObject(), pHash, pValue);
	}

	/**
	 * @return {string} - The address of the marshal destination.
	 */
	get marshalDestination()
	{
		return this._marshalDestination;
	}

	/**
	 * @param {string} pMarshalDestinationAddress - The address of the marshal destination.
	 */
	set marshalDestination(pMarshalDestinationAddress)
	{
		this._marshalDestination = pMarshalDestinationAddress;
	}

	/**
	 * @return {Record<string, any>} - The marshal destination object.
	 */
	get marshalDestinationObject()
	{
		const tmpMarshalDestinationAddress = this.marshalDestination;
		if (!tmpMarshalDestinationAddress)
		{
			throw new Error(`Attempt to access marshal destination object with no marshal destination set.`);
		}
		//TODO: figure out a clean way to cache this object that sanely invalidates if the destination changes
		let tmpMarshalDestinationObject = this.pict.resolveStateFromAddress(tmpMarshalDestinationAddress);
		if (!tmpMarshalDestinationObject)
		{
			this.log.error(`Data Broker bootstrapping missing object at marshal destination address: ${tmpMarshalDestinationAddress}`);
			this.pict.setStateValueAtAddress(tmpMarshalDestinationAddress, null, {});
			tmpMarshalDestinationObject = this.pict.resolveStateFromAddress(tmpMarshalDestinationAddress);
			if (!tmpMarshalDestinationObject)
			{
				throw new Error(`Attempt to access marshal destination object with no marshal destination set.`);
			}
		}
		return tmpMarshalDestinationObject;
	}

	getMarshalDestinationObject()
	{
		return this.marshalDestinationObject;
	}

	/**
	 * @param {string} [pOverrideMarshalDestination] - Optional override for the marshal destination address.
	 */
	resolveMarshalDestinationObject(pOverrideMarshalDestination)
	{
		const tmpMarshalDestinationAddress = pOverrideMarshalDestination || this.marshalDestination;
		if (!tmpMarshalDestinationAddress)
		{
			throw new Error(`Attempt to resolve marshal destination object with no marshal destination set.`);
		}
		let tmpMarshalDestinationObject;
		if (pOverrideMarshalDestination)
		{
			tmpMarshalDestinationObject = this.pict.resolveStateFromAddress(pOverrideMarshalDestination);
			if (!tmpMarshalDestinationObject)
			{
				this.log.error(`Data Broker bootstrapping missing object at marshal destination address: ${tmpMarshalDestinationAddress}`);
				this.pict.setStateValueAtAddress(tmpMarshalDestinationAddress, null, {});
			}
		}
		else
		{
			tmpMarshalDestinationObject = this.getMarshalDestinationObject();
		}
		return tmpMarshalDestinationObject;
	}
}

module.exports = PictDataBrokerProvider;
module.exports.default_configuration = _DEFAULT_PROVIDER_CONFIGURATION;

},{"pict-provider":142}],211:[function(require,module,exports){
const libPictProvider = require('pict-provider');
const libFilter = require('../filters/Filter.js');

/** @type {Record<string, any>} */
const _DEFAULT_PROVIDER_CONFIGURATION =
{
	ProviderIdentifier: 'Pict-RecordSet-FilterManager',

	AutoInitialize: true,
	AutoInitializeOrdinal: 0
}

class PictRecordSetFilterManager extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DEFAULT_PROVIDER_CONFIGURATION, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		/** @type {Record<string, any>} */
		this.options;
		/** @type {import('../Pict.js')} */
		this.pict;

		this.filters = {};
		this.filterCriteria = {};
	}

	/**
	 * @param {string} pFilterHash
	 * @param {Record<string, any>} pFilterConfig
	 *
	 * @return {void}
	 */
	addFilter(pFilterHash, pFilterConfig)
	{
		if (!pFilterHash || typeof pFilterHash !== 'string')
		{
			this.log.error('Invalid filter hash provided. It must be a non-empty string.');
			return;
		}
		if (!pFilterConfig || typeof pFilterConfig !== 'object' || !pFilterConfig.Type)
		{
			this.log.error('Invalid filter configuration provided. It must be an object with a Type property.');
			return;
		}
		const tmpFilterConfig = JSON.parse(JSON.stringify(pFilterConfig));
		if (tmpFilterConfig.Hash && tmpFilterConfig.Hash !== pFilterHash)
		{
			this.log.warn(`Filter configuration hash mismatch: provided ${tmpFilterConfig.Hash}, expected ${pFilterHash}. Overriding with provided hash.`);
		}
		tmpFilterConfig.Hash = pFilterHash;
		this.filters[tmpFilterConfig.Hash] = tmpFilterConfig;
	}

	/**
	 * @param {string} pFilterCriteriaHash
	 * @param {Record<string, any>} pFilterCriteriaConfig
	 *
	 * @return {void}
	 */
	addFilterCriteria(pFilterCriteriaHash, pFilterCriteriaConfig)
	{
		if (!pFilterCriteriaHash || typeof pFilterCriteriaHash !== 'string')
		{
			this.log.error('Invalid filter criteria hash provided. It must be a non-empty string.');
			return;
		}
		if (!pFilterCriteriaConfig || !Array.isArray(pFilterCriteriaConfig))
		{
			this.log.error('Invalid filter criteria configuration provided. It must be an array of filter clauses.');
			return;
		}
		const tmpFilterCriteriaConfig = JSON.parse(JSON.stringify(pFilterCriteriaConfig));
		this.filterCriteria[pFilterCriteriaHash] = tmpFilterCriteriaConfig;
	}

	/**
	 * @param {string} pFilterHash
	 * @return {Record<string, any> | undefined}
	 */
	getFilter(pFilterHash)
	{
		return this.filters[pFilterHash];
	}

	/**
	 * @param {string} pFilterCriteriaHash
	 * @return {Record<string, any> | undefined}
	 */
	getFilterCriteria(pFilterCriteriaHash)
	{
		return this.filterCriteria[pFilterCriteriaHash];
	}

	/**
	 * Run a filter configuration against a filter experience and return ALL matched records.
	 *
	 * @param {Array<Record<string, any>>} pFilterConfiguration
	 * @param {Record<string, any>} pFilterExperience
	 * @param {(pError?: Error) => void} fCallback
	 */
	loadRecordsByFilter(pFilterConfiguration, pFilterExperience, fCallback)
	{
		return this.loadRecordsByFilterUsingProvider(this.pict.EntityProvider, pFilterConfiguration, pFilterExperience, fCallback);
	}

	/**
	 * Run a filter configuration against a filter experience and return ALL matched records.
	 *
	 * @param {import('../Pict-Meadow-EntityProvider.js')} pEntityProvider
	 * @param {Array<Record<string, any>>} pFilterConfiguration
	 * @param {Record<string, any>} pFilterExperience
	 * @param {(pError?: Error) => void} fCallback
	 */
	loadRecordsByFilterUsingProvider(pEntityProvider, pFilterConfiguration, pFilterExperience, fCallback)
	{
		if (!pEntityProvider || typeof pEntityProvider.gatherDataFromServer !== 'function')
		{
			return fCallback(new Error('loadRecordsByFilter: Missing or invalid EntityProvider.'));
		}
		/** @type {import('../filters/Filter.js').FilterState} */
		const tmpState = JSON.parse(JSON.stringify(pFilterExperience));
		tmpState.Mode = 'Records';
		tmpState.FilterConfiguration = pFilterConfiguration;
		const tmpFilter = new libFilter(this.pict);
		tmpFilter.generateMeadowFilterStanzas(tmpState);
		tmpFilter.linkPreparedFilters(tmpState);
		tmpFilter.normalizeMeadowFilterStanzas(tmpState);
		tmpFilter.compileMeadowFilterStanzas(tmpState);
		pEntityProvider.gatherDataFromServer(tmpState.BundleConfig, fCallback);
	}

	/**
	 * Run a filter configuration against a filter experience and return a page of records.
	 *
	 * @param {Array<Record<string, any>>} pFilterConfiguration
	 * @param {Record<string, any>} pFilterExperience
	 * @param {number | string | ((pError?: Error) => void)} pRecordOffset
	 * @param {number | string | ((pError?: Error) => void)} pPageSize
	 * @param {(pError?: Error) => void} fCallback
	 */
	loadRecordPageByFilter(pFilterConfiguration, pFilterExperience, pRecordOffset, pPageSize, fCallback)
	{
		return this.loadRecordPageByFilterUsingProvider(this.pict.EntityProvider, pFilterConfiguration, pFilterExperience, pRecordOffset, pPageSize, fCallback);
	}

	/**
	 * Run a filter configuration against a filter experience and return a page of records.
	 *
	 * @param {import('../Pict-Meadow-EntityProvider.js')} pEntityProvider
	 * @param {Array<Record<string, any>>} pFilterConfiguration
	 * @param {Record<string, any>} pFilterExperience
	 * @param {number | string | ((pError?: Error) => void)} pRecordOffset
	 * @param {number | string | ((pError?: Error) => void)} pPageSize
	 * @param {(pError?: Error) => void} fCallback
	 */
	loadRecordPageByFilterUsingProvider(pEntityProvider, pFilterConfiguration, pFilterExperience, pRecordOffset, pPageSize, fCallback)
	{
		if (!pEntityProvider || typeof pEntityProvider.gatherDataFromServer !== 'function')
		{
			return fCallback(new Error('loadRecordPageByFilter: Missing or invalid EntityProvider.'));
		}
		const tmpCallback = typeof pRecordOffset === 'function' ? pRecordOffset : typeof pPageSize === 'function' ? pPageSize : fCallback;
		let tmpRecordOffset = typeof pRecordOffset === 'function' ? 0 : parseInt(String(pRecordOffset));
		if (isNaN(tmpRecordOffset) || tmpRecordOffset < 0)
		{
			tmpRecordOffset = 0;
		}
		let tmpPageSize = typeof pPageSize === 'function' ? 0 : parseInt(String(pPageSize));
		if (isNaN(tmpPageSize) || tmpPageSize < 0)
		{
			//TODO: this is a safety measure to try and not break things when we release this pict version; should be a lower value
			tmpPageSize = 10000;
		}
		/** @type {import('../filters/Filter.js').FilterState} */
		const tmpState = JSON.parse(JSON.stringify(pFilterExperience));
		tmpState.Mode = 'Records';
		tmpState.RecordOffset = tmpRecordOffset;
		tmpState.PageSize = tmpPageSize;
		tmpState.FilterConfiguration = pFilterConfiguration;
		const tmpFilter = new libFilter(this.pict);
		tmpFilter.generateMeadowFilterStanzas(tmpState);
		tmpFilter.linkPreparedFilters(tmpState);
		tmpFilter.normalizeMeadowFilterStanzas(tmpState);
		tmpFilter.compileMeadowFilterStanzas(tmpState);
		pEntityProvider.gatherDataFromServer(tmpState.BundleConfig, tmpCallback);
	}

	/**
	 * Run a filter configuration against a filter experience and return the count of records.
	 *
	 * @param {Array<Record<string, any>>} pFilterConfiguration
	 * @param {Record<string, any>} pFilterExperience
	 * @param {(pError?: Error) => void} fCallback
	 */
	countRecordsByFilter(pFilterConfiguration, pFilterExperience, fCallback)
	{
		return this.countRecordsByFilterUsingProivider(this.pict.EntityProvider, pFilterConfiguration, pFilterExperience, fCallback);
	}

	/**
	 * Run a filter configuration against a filter experience and return the count of records.
	 *
	 * @param {import('../Pict-Meadow-EntityProvider.js')} pEntityProvider
	 * @param {Array<Record<string, any>>} pFilterConfiguration
	 * @param {Record<string, any>} pFilterExperience
	 * @param {(pError?: Error) => void} fCallback
	 */
	countRecordsByFilterUsingProivider(pEntityProvider, pFilterConfiguration, pFilterExperience, fCallback)
	{
		/** @type {import('../filters/Filter.js').FilterState} */
		const tmpState = JSON.parse(JSON.stringify(pFilterExperience));
		tmpState.Mode = 'Count';
		tmpState.FilterConfiguration = pFilterConfiguration;
		const tmpFilter = new libFilter(this.pict);
		tmpFilter.generateMeadowFilterStanzas(tmpState);
		tmpFilter.linkPreparedFilters(tmpState);
		tmpFilter.normalizeMeadowFilterStanzas(tmpState);
		tmpFilter.compileMeadowFilterStanzas(tmpState);
		pEntityProvider.gatherDataFromServer(tmpState.BundleConfig, fCallback);
	}

	/**
	 * @param {string} pFilterConfigurationAddress
	 * @param {string} pFilterExperienceAddress
	 * @param {(pError?: Error) => void} fCallback
	 *
	 * @return {void}
	 */
	executeFilter(pFilterConfigurationAddress, pFilterExperienceAddress, fCallback)
	{
		return this.executeFilterUsingProvider(this.pict.EntityProvider, pFilterConfigurationAddress, pFilterExperienceAddress, fCallback);
	}

	/**
	 * @param {import('../Pict-Meadow-EntityProvider.js')} pEntityProvider
	 * @param {string} pFilterConfigurationAddress
	 * @param {string} pFilterExperienceAddress
	 * @param {(pError?: Error) => void} fCallback
	 *
	 * @return {void}
	 */
	executeFilterUsingProvider(pEntityProvider, pFilterConfigurationAddress, pFilterExperienceAddress, fCallback)
	{
		if (!pEntityProvider || typeof pEntityProvider.gatherDataFromServer !== 'function')
		{
			return fCallback(new Error('executeFilter: Missing or invalid EntityProvider.'));
		}
		const tmpFilterConfiguration = this.pict.resolveStateFromAddress(pFilterConfigurationAddress);
		if (!Array.isArray(tmpFilterConfiguration))
		{
			return fCallback(new Error(`Filter configuration at address ${pFilterConfigurationAddress} is not an array.`));
		}
		const tmpFilterExperience = this.pict.resolveStateFromAddress(pFilterExperienceAddress);
		if (!tmpFilterExperience || typeof tmpFilterExperience !== 'object')
		{
			return fCallback(new Error(`Filter experience at address ${pFilterExperienceAddress} is not an object.`));
		}
		return this.loadRecordsByFilterUsingProvider(pEntityProvider, tmpFilterConfiguration, tmpFilterExperience, fCallback);
	}

	/**
	 * Run a filter configuration against a filter experience and return a page of records.
	 *
	 * @param {string} pFilterConfigurationAddress
	 * @param {string} pFilterExperienceAddress
	 * @param {number | ((pError?: Error) => void)} pRecordOffset
	 * @param {number | ((pError?: Error) => void)} pPageSize
	 * @param {(pError?: Error) => void} fCallback
	 */
	executeFilterPage(pFilterConfigurationAddress, pFilterExperienceAddress, pRecordOffset, pPageSize, fCallback)
	{
		return this.executeFilterPageUsingProvider(this.pict.EntityProvider, pFilterConfigurationAddress, pFilterExperienceAddress, pRecordOffset, pPageSize, fCallback);
	}

	/**
	 * Run a filter configuration against a filter experience and return a page of records.
	 *
	 * @param {import('../Pict-Meadow-EntityProvider.js')} pEntityProvider
	 * @param {string} pFilterConfigurationAddress
	 * @param {string} pFilterExperienceAddress
	 * @param {number | ((pError?: Error) => void)} pRecordOffset
	 * @param {number | ((pError?: Error) => void)} pPageSize
	 * @param {(pError?: Error) => void} fCallback
	 */
	executeFilterPageUsingProvider(pEntityProvider, pFilterConfigurationAddress, pFilterExperienceAddress, pRecordOffset, pPageSize, fCallback)
	{
		const tmpCallback = typeof pRecordOffset === 'function' ? pRecordOffset : typeof pPageSize === 'function' ? pPageSize : fCallback;
		const tmpFilterConfiguration = this.pict.resolveStateFromAddress(pFilterConfigurationAddress);
		if (!Array.isArray(tmpFilterConfiguration))
		{
			return tmpCallback(new Error(`Filter configuration at address ${pFilterConfigurationAddress} is not an array.`));
		}
		const tmpFilterExperience = this.pict.resolveStateFromAddress(pFilterExperienceAddress);
		if (!tmpFilterExperience || typeof tmpFilterExperience !== 'object')
		{
			return tmpCallback(new Error(`Filter experience at address ${pFilterExperienceAddress} is not an object.`));
		}
		return this.loadRecordPageByFilterUsingProvider(pEntityProvider, tmpFilterConfiguration, tmpFilterExperience, pRecordOffset, pPageSize, fCallback);
	}

	/**
	 * @param {string} pFilterConfigurationAddress
	 * @param {string} pFilterExperienceAddress
	 * @param {(pError?: Error) => void} fCallback
	 *
	 * @return {void}
	 */
	executeFilterCount(pFilterConfigurationAddress, pFilterExperienceAddress, fCallback)
	{
		return this.executeFilterCountUsingProvider(this.pict.EntityProvider, pFilterConfigurationAddress, pFilterExperienceAddress, fCallback);
	}

	/**
	 * @param {import('../Pict-Meadow-EntityProvider.js')} pEntityProvider
	 * @param {string} pFilterConfigurationAddress
	 * @param {string} pFilterExperienceAddress
	 * @param {(pError?: Error) => void} fCallback
	 *
	 * @return {void}
	 */
	executeFilterCountUsingProvider(pEntityProvider, pFilterConfigurationAddress, pFilterExperienceAddress, fCallback)
	{
		const tmpFilterConfiguration = this.pict.resolveStateFromAddress(pFilterConfigurationAddress);
		if (!Array.isArray(tmpFilterConfiguration))
		{
			return fCallback(new Error(`Filter configuration at address ${pFilterConfigurationAddress} is not an array.`));
		}
		const tmpFilterExperience = this.pict.resolveStateFromAddress(pFilterExperienceAddress);
		if (!tmpFilterExperience || typeof tmpFilterExperience !== 'object')
		{
			return fCallback(new Error(`Filter experience at address ${pFilterExperienceAddress} is not an object.`));
		}
		return this.countRecordsByFilterUsingProivider(pEntityProvider, tmpFilterConfiguration, tmpFilterExperience, fCallback);
	}
}

module.exports = PictRecordSetFilterManager;
module.exports.default_configuration = _DEFAULT_PROVIDER_CONFIGURATION;

},{"../filters/Filter.js":204,"pict-provider":142}],212:[function(require,module,exports){
const libPictProvider = require('pict-provider');
const _BuiltInIcons   = require('./Pict-Icons-Base.js');

/**
 * Pict-Provider-Icon — the central icon registry.
 *
 * Every glyph is an SVG string with `currentColor`-driven paint, so icons
 * inherit text color from the surrounding context and re-skin automatically
 * when the active theme changes.  The provider also injects a small base
 * stylesheet so `font-size` on a parent scales icons natively — no SVG
 * width/height juggling.
 *
 * Public surface:
 *   pict.icon(name [, opts])                    convenience shortcut
 *   pict.providers.Icon.get(name [, opts])      same, via the provider
 *   pict.providers.Icon.has(name [, variant])
 *   pict.providers.Icon.register(name, svg [, opts])
 *   pict.providers.Icon.registerSet(byVariant)
 *
 * Template tag (registered by Pict-Template-Icon.js):
 *   {~Icon:Home~}              default variant
 *   {~Icon:Folder:Filled~}     explicit variant
 *   {~I:Spreadsheet~}          short alias
 *   {~I:File:Filled~}          short + variant
 *
 * Extension pattern — pict-section-* modules call `registerSet()` at boot
 * to plug in section-specific icons (file-type glyphs, language marks,
 * etc.) without forking core.
 *
 * Lookup order on miss:
 *   1. exact (name, variant)
 *   2. (name, defaultVariant) for that name
 *   3. (name, Outline) — the global default variant
 *   4. inline question-mark glyph + log warning; never throws
 */

const _DefaultProviderConfiguration =
{
	ProviderIdentifier: 'Pict-Provider-Icon',

	AutoInitialize: true,
	AutoInitializeOrdinal: 0,

	// Variant used when {~Icon:Name~} is asked for with no explicit
	// variant *and* no per-name default exists.
	DefaultVariant: 'Outline',

	// Default extra class applied to every emitted icon wrapper.  Apps
	// override per-call via opts.class.  Always also gets 'pict-icon'.
	DefaultIconClass: 'pict-icon',

	// Default font-size when caller passes { size: N }.  Icons sized via
	// `em` (1em x 1em on the inner <svg>) so font-size drives dimensions.
	DefaultSize: null,

	// Auto-register the bundled base icon set during construction.  Apps
	// that want a completely custom set can set this false and seed via
	// registerSet() after construction.
	RegisterBaseIcons: true
};

// PascalCase aliases — let consumers reach for the name they remember
// first.  Resolved at lookup time, so registering 'Settings' makes 'Gear'
// resolve to it automatically.  Kept short on purpose; expansive aliasing
// is the host's job, not core's.
const _Aliases =
{
	Gear:       'Settings',
	Cog:        'Settings',
	House:      'Home',
	X:          'Close',
	Cross:      'Close',
	Hamburger:  'Menu',
	Pencil:     'Edit',
	Bin:        'Trash',
	Magnifier:  'Search',
	Reload:     'Refresh',
	Person:     'User',
	Padlock:    'Lock'
};

// Minimal CSS — sizes the icon via the parent's font cascade, no SVG
// width/height baked in.  Themes recolor through currentColor; consumers
// can layer additional class rules on top.
const _ProviderCSS = (
	'.pict-icon { display: inline-flex; align-items: center; justify-content: center; vertical-align: -0.125em; flex-shrink: 0; line-height: 0; color: inherit; }' +
	'.pict-icon > svg { width: 1em; height: 1em; display: block; }'
);

// Inline fallback emitted when a requested icon is missing entirely.
// Visible (not invisible) so the misconfiguration is obvious in the UI
// the first time it surfaces.
const _MissingGlyph = (
	'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" ' +
	'stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">' +
	'<circle cx="12" cy="12" r="10"/>' +
	'<path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/>' +
	'<line x1="12" y1="17" x2="12.01" y2="17"/></svg>'
);

class PictProviderIcon extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DefaultProviderConfiguration, pOptions);
		super(pFable, tmpOptions, pServiceHash);

		/** @type {Record<string, any>} */
		this.options;
		/** @type {import('../Pict.js')} */
		this.pict;

		// Registry shape:  { [variant]: { [name]: svgString } }
		this._registry = {};

		// Per-name default variant.  Set by the first register() call for
		// that name unless a later call passes { default: true }.
		this._defaultsByName = {};

		// Register base icons (Outline + Filled) before anyone can ask
		// for them.
		if (this.options.RegisterBaseIcons)
		{
			this.registerSet(_BuiltInIcons);
		}

		// Inject the base stylesheet.  CSSMap dedupes by hash so this is
		// safe even if multiple Pict instances register their own Icon
		// providers (single-tenant in browsers, but worth honoring).
		if (this.pict && this.pict.CSSMap && typeof (this.pict.CSSMap.addCSS) === 'function')
		{
			this.pict.CSSMap.addCSS('Pict-Provider-Icon-CSS', _ProviderCSS, 100);
		}
	}

	/**
	 * Register a single glyph.  First call for a (name) sets the default
	 * variant for that name unless an explicit variant is passed; subsequent
	 * calls add more variants without changing the default.
	 *
	 * @param {string} pName    PascalCase icon name (e.g. 'FileFolder')
	 * @param {string} pSvg     Full <svg>...</svg> string (no width/height)
	 * @param {object} [pOpts]  { variant: 'Outline'|'Filled'|... , default: bool, force: bool }
	 * @returns {boolean}       true on success, false if a (name, variant)
	 *                           already exists and { force: true } wasn't set.
	 */
	register(pName, pSvg, pOpts)
	{
		if (typeof (pName) !== 'string' || pName.length < 1)
		{
			this.log.warn('Pict-Provider-Icon.register requires a non-empty name.');
			return false;
		}
		if (typeof (pSvg) !== 'string' || pSvg.indexOf('<svg') < 0)
		{
			this.log.warn('Pict-Provider-Icon.register requires an SVG string for [' + pName + '].');
			return false;
		}

		let tmpOpts = pOpts || {};
		let tmpVariant = tmpOpts.variant || this.options.DefaultVariant;
		let tmpForce   = !!tmpOpts.force;
		let tmpDefault = !!tmpOpts.default;

		if (!this._registry[tmpVariant])
		{
			this._registry[tmpVariant] = {};
		}
		if (this._registry[tmpVariant][pName] && !tmpForce)
		{
			this.log.warn('Pict-Provider-Icon: refusing to overwrite [' + pName + ':' + tmpVariant
				+ '] (pass { force: true } to replace).');
			return false;
		}
		this._registry[tmpVariant][pName] = pSvg;

		// First registration for this name → it becomes the default,
		// regardless of which variant it was registered under.  This is
		// what "default is first registered" means in practice.
		if (!this._defaultsByName[pName] || tmpDefault)
		{
			this._defaultsByName[pName] = tmpVariant;
		}
		return true;
	}

	/**
	 * Bulk register a whole icon set, keyed by variant.
	 *
	 *   registerSet({ Outline: { Home: '<svg/>', Folder: '<svg/>' },
	 *                 Filled:  { Home: '<svg/>' } });
	 *
	 * Per-name defaults follow registration order — the first variant
	 * containing a given name becomes that name's default.
	 *
	 * @param {Record<string, Record<string, string>>} pByVariant
	 * @param {object} [pOpts] { force: bool }
	 */
	registerSet(pByVariant, pOpts)
	{
		if (!pByVariant || typeof (pByVariant) !== 'object')
		{
			return;
		}
		let tmpForce = !!(pOpts && pOpts.force);
		let tmpVariants = Object.keys(pByVariant);
		for (let v = 0; v < tmpVariants.length; v++)
		{
			let tmpVariant = tmpVariants[v];
			let tmpIcons = pByVariant[tmpVariant];
			if (!tmpIcons) continue;
			let tmpNames = Object.keys(tmpIcons);
			for (let n = 0; n < tmpNames.length; n++)
			{
				let tmpName = tmpNames[n];
				this.register(tmpName, tmpIcons[tmpName], { variant: tmpVariant, force: tmpForce });
			}
		}
	}

	/**
	 * @param {string} pName
	 * @param {string} [pVariant]
	 * @returns {boolean}
	 */
	has(pName, pVariant)
	{
		let tmpResolved = _Aliases[pName] || pName;
		if (pVariant)
		{
			return !!(this._registry[pVariant] && this._registry[pVariant][tmpResolved]);
		}
		return !!this._defaultsByName[tmpResolved];
	}

	/**
	 * Return the wrapped icon HTML for `pName`.  Always returns a string
	 * — never throws and never returns undefined, so it's safe to embed
	 * in template output unchecked.
	 *
	 * @param {string} pName     PascalCase icon name, or an alias
	 * @param {object} [pOpts]   { variant, size, class, ariaLabel }
	 * @returns {string}
	 */
	get(pName, pOpts)
	{
		let tmpName = (typeof (pName) === 'string') ? pName.trim() : '';
		if (tmpName.length < 1)
		{
			this.log.warn('Pict-Provider-Icon.get called with empty name.');
			return this._wrap(_MissingGlyph, pOpts);
		}
		// Alias resolution — Gear → Settings, etc.
		let tmpResolved = _Aliases[tmpName] || tmpName;
		let tmpOpts = pOpts || {};
		let tmpRequestedVariant = tmpOpts.variant;

		// 1. exact match for explicitly-requested variant
		if (tmpRequestedVariant && this._registry[tmpRequestedVariant] && this._registry[tmpRequestedVariant][tmpResolved])
		{
			return this._wrap(this._registry[tmpRequestedVariant][tmpResolved], tmpOpts);
		}
		// 2. per-name default variant
		let tmpNameDefault = this._defaultsByName[tmpResolved];
		if (tmpNameDefault && this._registry[tmpNameDefault] && this._registry[tmpNameDefault][tmpResolved])
		{
			if (tmpRequestedVariant)
			{
				// Fell back from a requested-but-missing variant — log so
				// the gap is visible in dev, but still emit a glyph.
				this.log.trace('Pict-Provider-Icon: variant [' + tmpRequestedVariant + '] missing for ['
					+ tmpResolved + '], using [' + tmpNameDefault + '].');
			}
			return this._wrap(this._registry[tmpNameDefault][tmpResolved], tmpOpts);
		}
		// 3. global default variant
		let tmpGlobal = this.options.DefaultVariant;
		if (this._registry[tmpGlobal] && this._registry[tmpGlobal][tmpResolved])
		{
			return this._wrap(this._registry[tmpGlobal][tmpResolved], tmpOpts);
		}
		// 4. missing — show a question-mark glyph so the gap surfaces
		this.log.warn('Pict-Provider-Icon: unknown icon [' + tmpName + ']'
			+ (tmpRequestedVariant ? ' (variant ' + tmpRequestedVariant + ')' : '') + '.');
		return this._wrap(_MissingGlyph, tmpOpts);
	}

	/**
	 * @private
	 * @param {string} pSvg
	 * @param {object} [pOpts] { size, class, ariaLabel }
	 * @returns {string}
	 */
	_wrap(pSvg, pOpts)
	{
		let tmpOpts = pOpts || {};
		let tmpClass = this.options.DefaultIconClass;
		if (typeof (tmpOpts.class) === 'string' && tmpOpts.class.length > 0)
		{
			tmpClass += ' ' + tmpOpts.class;
		}
		let tmpStyle = '';
		if (typeof (tmpOpts.size) === 'number' && tmpOpts.size > 0)
		{
			tmpStyle = ' style="font-size:' + tmpOpts.size + 'px"';
		}
		else if (typeof (tmpOpts.size) === 'string' && tmpOpts.size.length > 0)
		{
			tmpStyle = ' style="font-size:' + tmpOpts.size + '"';
		}
		// aria-hidden default true — most icons are decorative.  Caller
		// passes ariaLabel to attach a label and flip aria-hidden off.
		let tmpAria = ' aria-hidden="true"';
		if (typeof (tmpOpts.ariaLabel) === 'string' && tmpOpts.ariaLabel.length > 0)
		{
			tmpAria = ' role="img" aria-label="' + tmpOpts.ariaLabel.replace(/"/g, '&quot;') + '"';
		}
		return '<span class="' + tmpClass + '"' + tmpStyle + tmpAria + '>' + pSvg + '</span>';
	}
}

module.exports = PictProviderIcon;
module.exports.default_configuration = _DefaultProviderConfiguration;

},{"./Pict-Icons-Base.js":209,"pict-provider":142}],213:[function(require,module,exports){
const libFableServiceProviderBase = require('fable-serviceproviderbase');

/** @typedef {{ TimeStamp: Date, Category: string, Message: string }} TransactionLogEntry */
/** @typedef {{ Timestamp: number, Data: any, Type: string }} TransactionQueueItem */
/** @typedef {{ TransactionKey: string, Events: Record<string, Record<string, boolean>>, Log: Array<TransactionLogEntry>, TransactionQueue: Array<TransactionQueueItem> }} TransactionInfo */

/*
 * Provides transaction tracking with keys and events, allowing us to block repeat attempts.
 * Once the shape is solidified, will move it back to the fable codebase
 */
class TransactionTracking extends libFableServiceProviderBase
{
	constructor(pFable, pOptions, pServiceHash)
	{
		// Intersect default options, parent constructor, service information
		super(pFable, pOptions, pServiceHash);

		/** @type {import('../Pict') & { addAndInstantiateSingletonService: (hash: string, options: any, prototype: any) => any }} */
		this.fable;
		/** @type {any} */
		this.log;
		/** @type {string} */
		this.UUID;

		/**
		 * @type {Record<string, TransactionInfo>}
		 */
		this.transactionMap = {};
	}

	/**
	 * @return {Record<string, TransactionInfo>}
	 */
	get transactions()
	{
		return this.transactionMap;
	}

	/**
	 * @param {string} pKey
	 * @param {string} pMessage
	 * @param {string} [pCategory='General']
	 */
	logToTransaction(pKey, pMessage, pCategory)
	{
		let tmpTransaction = this.transactionMap[pKey];
		if (tmpTransaction == null)
		{
			this.log.warn(`TransactionTracking logToTransaction key [${pKey}] does not exist; auto creating...`);
			tmpTransaction = this.registerTransaction(pKey);
		}

		let tmpCategory = typeof(pCategory) === 'string' ? pCategory : 'General';

		this.transactionMap[pKey].Log.push({TimeStamp: new Date(), Category:tmpCategory, Message:pMessage});

		//this.log.trace(`TransactionTracking logToTransaction [${pKey}]: (${tmpCategory}) ${pMessage}`);

		return true;
	}

	/**
	 * @param {string} pKey
	 *
	 * @return {TransactionInfo}
	 */
	registerTransaction(pKey)
	{
		if (this.transactionMap[pKey] != null)
		{
			//this.log.warn(`TransactionTracking registerTransaction key [${pKey}] already exists... returning existing transaction.`);
			return this.transactionMap[pKey];
		}

		this.transactionMap[pKey] = (
			{
				TransactionKey: pKey,
				Events: {},
				Log: [],
				TransactionQueue: [],
			});
		return this.transactionMap[pKey];
	}

	/**
	 * Remove a transaction from the tracking map. Safe to call on a key that
	 * no longer exists (returns false without side effects).
	 *
	 * Guarded: logs a warning and refuses to delete if the transaction still
	 * has a non-empty queue - that would indicate the caller is unregistering
	 * prematurely with work still pending. Callers who have explicitly
	 * drained or discarded the queue can pass pForce=true to bypass the
	 * guard.
	 *
	 * Note that the existing `finalizeTransaction` /
	 * `eventTransactionAsyncOperationComplete` pathways in pict-section-form
	 * manage their own map cleanup directly on the `transactions` getter;
	 * this method is the canonical API for any other caller that needs to
	 * remove a transaction entry.
	 *
	 * @param {string} pKey - The transaction key to unregister.
	 * @param {boolean} [pForce] - If true, unregister even if the queue is
	 *     not empty. Use only when the caller has explicitly drained or
	 *     discarded the queue state.
	 *
	 * @return {boolean} true if an entry was removed, false otherwise.
	 */
	unregisterTransaction(pKey, pForce)
	{
		const tmpTransaction = this.transactionMap[pKey];
		if (tmpTransaction == null)
		{
			return false;
		}
		if (!pForce && tmpTransaction.TransactionQueue && tmpTransaction.TransactionQueue.length > 0)
		{
			this.log.warn(`TransactionTracking unregisterTransaction [${pKey}] refused: queue has ${tmpTransaction.TransactionQueue.length} item(s) still pending. Pass pForce=true if you explicitly want to discard them.`);
			return false;
		}
		delete this.transactionMap[pKey];
		return true;
	}

	/**
	 * @param {string} pKey
	 * @param {any} pData
	 * @param {string} [pType='Entry']
	 *
	 * @return {number} the current queue size
	 */
	pushToTransactionQueue(pKey, pData, pType = 'Entry')
	{
		let tmpTransaction = this.transactionMap[pKey];
		if (tmpTransaction == null)
		{
			this.log.warn(`TransactionTracking pushToTransactionQueue key [${pKey}] does not exist; auto creating...`);
			tmpTransaction = this.registerTransaction(pKey);
		}

		tmpTransaction.TransactionQueue.push({ Timestamp: Date.now(), Data: pData, Type: pType });
		this.logToTransaction(pKey, `Pushed data to transaction queue`, 'Queue');

		return tmpTransaction.TransactionQueue.length;
	}

	/**
	 * Returns the transaction queue with wrapping metadata.
	 *
	 * @param {string} pKey
	 *
	 * @return {Array<TransactionQueueItem>}
	 */
	checkTransactionQueue(pKey)
	{
		let tmpTransaction = this.transactionMap[pKey];
		if (tmpTransaction == null)
		{
			this.log.warn(`TransactionTracking checkTransactionQueue key [${pKey}] does not exist; auto creating...`);
			tmpTransaction = this.registerTransaction(pKey);
		}

		if (tmpTransaction.TransactionQueue == null)
		{
			tmpTransaction.TransactionQueue = [];
		}

		this.logToTransaction(pKey, `Checked transaction queue`, 'Queue');

		return tmpTransaction.TransactionQueue;
	}

	/**
	 * Returns an array of object registered in the transaction queue for a given transaction ID.
	 *
	 * @param {string} pKey
	 *
	 * @return {Array<any>}
	 */
	getTransactionQueue(pKey)
	{
		const tmpQueue = this.checkTransactionQueue(pKey);
		return tmpQueue.map((item) => item.Data);
	}

	/**
	 * @param {string} pKey
	 *
	 * @return {Array<TransactionQueueItem>}
	 */
	clearTransactionQueue(pKey)
	{
		let tmpTransaction = this.transactionMap[pKey];
		if (tmpTransaction == null)
		{
			this.log.warn(`TransactionTracking clearTransactionQueue key [${pKey}] does not exist; skipping...`);
			return;
		}

		const tmpQueue = tmpTransaction.TransactionQueue;
		tmpTransaction.TransactionQueue = [];
		this.logToTransaction(pKey, `Cleared transaction queue`, 'Queue');

		return tmpQueue;
	}

	/**
	 * @param {string} pKey
	 * @param {string} pEvent
	 * @param {string} [pHash='']
	 *
	 * @return {boolean} true if the event is new, false if it has already been registered
	 */
	checkEvent(pKey, pEvent, pHash)
	{
		let tmpHash = (typeof(pHash) === 'string') ? pHash : '';
		let tmpTransaction = this.transactionMap[pKey];
		if (tmpTransaction == null)
		{
			this.log.warn(`TransactionTracking checkTransactionEvent event [${pEvent}]->[${tmpHash}] key [${pKey}] does not exist; auto creating...`);
			tmpTransaction = this.registerTransaction(pKey);
		}

		if (tmpTransaction.Events[pEvent] == null)
		{
			tmpTransaction.Events[pEvent] = {};
		}
		if (tmpHash in tmpTransaction.Events[pEvent])
		{
			//this.log.warn(`TransactionTracking checkTransactionEvent event [${pEvent}]->[${tmpHash}] key [${pKey}] firing a second time...`);
			this.logToTransaction(pKey, `Event [${pEvent}]->[${tmpHash}] already exists in transaction [${pKey}]`, 'Event');
			return false;
		}
		else
		{
			//this.log.warn(`TransactionTracking checkTransactionEvent event [${pEvent}]->[${tmpHash}] key [${pKey}] firing a first time...`);
			this.logToTransaction(pKey, `Event [${pEvent}]->[${tmpHash}] registered in transaction [${pKey}]`, 'Event');
			tmpTransaction.Events[pEvent][tmpHash] = true;
			return true;
		}
	}
}

module.exports = TransactionTracking;

/** @type {Record<string, any>} */
TransactionTracking.default_configuration = { };

},{"fable-serviceproviderbase":59}],214:[function(require,module,exports){
const libPictTemplate = require('pict-template');

/**
 * Addressed Template expression.
 *
 *   {[AppData.MyTemplate]}
 *
 * Looks up the value at the given address (resolved through the same
 * scope as {~D:~} -- Record, AppData, Pict, Bundle, Context, Scope,
 * TempData, __State) and renders it as a template against the current
 * Record/Context/Scope/State.  Pairs with the inline template `{<...>}`:
 *
 *   {<inline body, parsed at runtime>}
 *   {[AppData.PathToTemplateString]}     <- body is *stored* at the address
 *
 * If the address does not resolve, or resolves to a non-string, a warning
 * is logged that names the address and the full expression, and the
 * expression renders as ''.
 */
class PictTemplateProviderAddressedTemplate extends libPictTemplate
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.log;

		this.addPattern('{[', ']}');
	}

	/**
	 * Render the addressed template: resolve the address to a template
	 * string and parse it against the current scope.
	 *
	 * @param {string} pTemplateHash - The address (what's between `{[` and `]}`)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {string} The rendered template, or '' when the address can't be resolved to a string.
	 */
	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		let tmpAddress = pTemplateHash.trim();
		let tmpRecord = (typeof (pRecord) === 'object') ? pRecord : {};

		if (this.pict.LogNoisiness > 4)
		{
			this.log.trace(`PICT Template [fAddressedTemplateRender]::[${tmpAddress}] with tmpData:`, tmpRecord);
		}
		else if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PICT Template [fAddressedTemplateRender]::[${tmpAddress}]`);
		}

		if (tmpAddress.length < 1)
		{
			this.log.warn(`Pict: Addressed Template Render: No address provided in expression [{[${pTemplateHash}]}]`);
			return '';
		}

		let tmpTemplate = this.resolveStateFromAddress(tmpAddress, tmpRecord, pContextArray, null, pScope, pState);

		if (tmpTemplate == null)
		{
			this.log.warn(`Pict: Addressed Template Render: Address [${tmpAddress}] did not resolve for expression [{[${pTemplateHash}]}]`);
			return '';
		}

		if (typeof (tmpTemplate) !== 'string')
		{
			this.log.warn(`Pict: Addressed Template Render: Address [${tmpAddress}] resolved to a non-string (${typeof tmpTemplate}) for expression [{[${pTemplateHash}]}]`);
			return '';
		}

		if (tmpTemplate.length < 1)
		{
			return '';
		}

		return this.pict.parseTemplate(tmpTemplate, pRecord, null, pContextArray, pScope, pState);
	}

	/**
	 * Render the addressed template asynchronously.
	 *
	 * @param {string} pTemplateHash - The address (what's between `{[` and `]}`)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {(error?: Error, content?: String) => void} fCallback - callback function invoked with the rendered template, or an error
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {void}
	 */
	renderAsync(pTemplateHash, pRecord, fCallback, pContextArray, pScope, pState)
	{
		let tmpAddress = pTemplateHash.trim();
		let tmpRecord = (typeof (pRecord) === 'object') ? pRecord : {};
		let tmpCallback = (typeof (fCallback) === 'function') ? fCallback : () => { return ''; };

		if (this.pict.LogNoisiness > 4)
		{
			this.log.trace(`PICT Template [fAddressedTemplateRenderAsync]::[${tmpAddress}] with tmpData:`, tmpRecord);
		}
		else if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PICT Template [fAddressedTemplateRenderAsync]::[${tmpAddress}]`);
		}

		if (tmpAddress.length < 1)
		{
			this.log.warn(`Pict: Addressed Template Render: No address provided in expression [{[${pTemplateHash}]}]`);
			return tmpCallback(null, '');
		}

		let tmpTemplate = this.resolveStateFromAddress(tmpAddress, tmpRecord, pContextArray, null, pScope, pState);

		if (tmpTemplate == null)
		{
			this.log.warn(`Pict: Addressed Template Render: Address [${tmpAddress}] did not resolve for expression [{[${pTemplateHash}]}]`);
			return tmpCallback(null, '');
		}

		if (typeof (tmpTemplate) !== 'string')
		{
			this.log.warn(`Pict: Addressed Template Render: Address [${tmpAddress}] resolved to a non-string (${typeof tmpTemplate}) for expression [{[${pTemplateHash}]}]`);
			return tmpCallback(null, '');
		}

		if (tmpTemplate.length < 1)
		{
			return tmpCallback(null, '');
		}

		this.pict.parseTemplate(tmpTemplate, pRecord,
			(pError, pValue) =>
			{
				if (pError)
				{
					return tmpCallback(pError, '');
				}
				return tmpCallback(null, pValue);
			}, pContextArray, pScope, pState);
	}
}

module.exports = PictTemplateProviderAddressedTemplate;
module.exports.template_hash = 'AddressedTemplate';

},{"pict-template":144}],215:[function(require,module,exports){
const libPictTemplate = require('pict-template');

class PictTemplateProviderData extends libPictTemplate
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.log;

		this.addPattern('{~Data:', '~}');
		this.addPattern('{~D:', '~}');
	}

	/**
	 * Render a template expression, returning a string with the resulting content or an optional default value.
	 *
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {string} The rendered template
	 */
	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();
		let tmpRecord = (typeof(pRecord) === 'object') ? pRecord : {};

		if (this.pict.LogNoisiness > 4)
		{
			this.log.trace(`PICT Template [fDataRender]::[${tmpHash}] with tmpData:`, tmpRecord);
		}
		else if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PICT Template [fDataRender]::[${tmpHash}]`);
		}

		let tmpDefaultValue = '';
		if (tmpHash.indexOf(':') > -1)
		{
			tmpDefaultValue = tmpHash.split(':')[1];
			tmpHash = tmpHash.split(':')[0];
		}

		let tmpValue = '';
		if (tmpHash != null)
		{
			tmpValue = this.resolveStateFromAddress(tmpHash, tmpRecord, pContextArray, null, pScope, pState);
		}
		if ((tmpValue == null) || (tmpValue == 'undefined') || (typeof(tmpValue) == 'undefined') || (tmpValue === ''))
		{
			return tmpDefaultValue;
		}
		return tmpValue;
	}
}

module.exports = PictTemplateProviderData;

},{"pict-template":144}],216:[function(require,module,exports){
const libPictTemplate = require('pict-template');

class PictTemplateProviderDataValueByKey extends libPictTemplate
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.log;

		this.addPattern('{~DataValueByKey:', '~}');
		this.addPattern('{~DVBK:', '~}');
	}

	/**
	 * Render a template expression, returning a string with the resulting content.
	 *
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {string} The rendered template
	 */
	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();
		let tmpRecord = (typeof(pRecord) === 'object') ? pRecord : {};

		if (this.pict.LogNoisiness > 4)
		{
			this.log.trace(`PICT Template [fDataRender]::[${tmpHash}] with tmpData:`, tmpRecord);
		}
		else if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PICT Template [fDataRender]::[${tmpHash}]`);
		}

		let tmpHashArray = tmpHash.split(':');

		if (tmpHashArray.length < 2)
		{
			this.log.trace(`PICT Template [fDataRender]::[${tmpHash}] failed because there were not two stanzas in the expression [${pTemplateHash}]`);
			return '';
		}

		let tmpDefaultValue = '';
		if (tmpHashArray.length > 2)
		{
			tmpDefaultValue = tmpHashArray[2];
		}

		let tmpValueObject = this.resolveStateFromAddress(tmpHashArray[0], tmpRecord, pContextArray, null, pScope, pState);
		let tmpValueAddress = this.resolveStateFromAddress(tmpHashArray[1], tmpRecord, pContextArray, null, pScope, pState);
		let tmpValue = this.pict.manifest.getValueByHash(tmpValueObject, tmpValueAddress);
		if ((tmpValue == null) || (tmpValue == 'undefined') || (typeof(tmpValue) == 'undefined'))
		{
			return tmpDefaultValue;
		}
		return tmpValue;
	}
}

module.exports = PictTemplateProviderDataValueByKey;

},{"pict-template":144}],217:[function(require,module,exports){
const libPictTemplate = require('pict-template');

class PictTemplateProviderData extends libPictTemplate
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.log;

		this.addPattern('{~DataWithAbsoluteFallback:', '~}');
		this.addPattern('{~DWAF:', '~}');
	}

	/**
	 * Render a template expression, returning a string with the resulting content or an optional default template string from an address.
	 *
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {string} The rendered template
	 */
	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();
		let tmpRecord = (typeof(pRecord) === 'object') ? pRecord : {};

		if (this.pict.LogNoisiness > 4)
		{
			this.log.trace(`PICT DataWithAbsoluteFallback [fDataRender]::[${tmpHash}] with tmpRecord:`, tmpRecord);
		}
		else if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PICT DataWithAbsoluteFallback [fDataRender]::[${tmpHash}]`);
		}

		let tmpAbsoluteFallbackValue = '';
		if (tmpHash.indexOf(':') > -1)
		{
			tmpAbsoluteFallbackValue = tmpHash.split(':')[1];
			tmpHash = tmpHash.split(':')[0];
		}

		let tmpValue = '';
		if (tmpHash != null)
		{
			tmpValue = this.resolveStateFromAddress(tmpHash, tmpRecord, pContextArray, null, pScope, pState);

			if (tmpValue && tmpValue !== 'undefined')
			{
				if (this.pict.LogNoisiness > 3)
				{
					this.log.trace(`PICT DataWithAbsoluteFallback [fDataRender]::[${tmpHash}] - Found value: ${tmpValue}`);
				}
				// If a value is found, return it
				return tmpValue;
			}
		}
		// If the value is not found or is undefined, use the fallback value.
		return tmpAbsoluteFallbackValue;
	}

	/**
	 * Render a template expression asynchronously, returning a string with the resulting content or an optional fallback template string from an address.
	 *
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {(pError?: Error, pResult?: string) => void} fCallback - The callback function to be called with the result
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {void} The result is passed to the callback function
	 */
	renderAsync(pTemplateHash, pRecord, fCallback, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();
		let tmpRecord = (typeof (pRecord) === 'object') ? pRecord : {};
		let tmpCallback = (typeof (fCallback) === 'function') ? fCallback : () => { return ''; };

		if (this.pict.LogNoisiness > 4)
		{
			this.log.trace(`PICT DataWithAbsoluteFallback [fDataRender]::[${tmpHash}] with tmpRecord:`, tmpRecord);
		}
		else if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PICT DataWithAbsoluteFallback [fDataRender]::[${tmpHash}]`);
		}

		let tmpAbsoluteFallbackValue = '';
		if (tmpHash.indexOf(':') > -1)
		{
			tmpAbsoluteFallbackValue = tmpHash.split(':')[1];
			tmpHash = tmpHash.split(':')[0];
		}

		let tmpValue = '';
		if (tmpHash != null)
		{
			tmpValue = this.resolveStateFromAddress(tmpHash, tmpRecord, pContextArray, null, pScope, pState);

			if (tmpValue && tmpValue !== 'undefined')
			{
				if (this.pict.LogNoisiness > 3)
				{
					this.log.trace(`PICT DataWithAbsoluteFallback [fDataRender]::[${tmpHash}] - Found value: ${tmpValue}`);
				}
				return tmpCallback(null, tmpValue);
			}
		}
		// If the value is not found or is undefined, use the fallback value
		return tmpCallback(null, tmpAbsoluteFallbackValue);
	}

}

module.exports = PictTemplateProviderData;

},{"pict-template":144}],218:[function(require,module,exports){
const libPictTemplate = require('pict-template');

class PictTemplateProviderData extends libPictTemplate
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.log;

		this.addPattern('{~DataWithTemplateFallback:', '~}');
		this.addPattern('{~DWTF:', '~}');
	}

	/**
	 * Render a template expression, returning a string with the resulting content or an optional default template string from an address.
	 *
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {string} The rendered template
	 */
	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();
		let tmpRecord = (typeof(pRecord) === 'object') ? pRecord : {};

		if (this.pict.LogNoisiness > 4)
		{
			this.log.trace(`PICT DataWithTemplateFallback [fDataRender]::[${tmpHash}] with tmpRecord:`, tmpRecord);
		}
		else if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PICT DataWithTemplateFallback [fDataRender]::[${tmpHash}]`);
		}

		let tmpTemplateFallbackAddress = '';
		if (tmpHash.indexOf(':') > -1)
		{
			tmpTemplateFallbackAddress = tmpHash.split(':')[1];
			tmpHash = tmpHash.split(':')[0];
		}

		let tmpValue = '';
		if (tmpHash != null)
		{
			tmpValue = this.resolveStateFromAddress(tmpHash, tmpRecord, pContextArray, null, pScope, pState);

			if (tmpValue && tmpValue !== 'undefined')
			{
				if (this.pict.LogNoisiness > 3)
				{
					this.log.trace(`PICT DataWithTemplateFallback [fDataRender]::[${tmpHash}] - Found value: ${tmpValue}`);
				}
				// If a value is found, return it
				return tmpValue;
			}
		}
		// If the value is not found or is undefined, try to use the fallback template
		const tmpFallbackTemplate = this.pict.parseTemplateByHash(tmpTemplateFallbackAddress, tmpRecord, null, pContextArray, pScope, pState);
		if (tmpFallbackTemplate == null || tmpFallbackTemplate === '')
		{
			this.log.warn(`PICT DataWithTemplateFallback [fDataRender]::[${tmpHash}] - No fallback template found at address: ${tmpTemplateFallbackAddress}`);
			// If no fallback template is found, return an empty string
			return '';
		}
		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PICT DataWithTemplateFallback [fDataRender]::[${tmpHash}] - Using fallback template from address: ${tmpTemplateFallbackAddress}`);
		}
		return tmpFallbackTemplate;
	}

	/**
	 * Render a template expression asynchronously, returning a string with the resulting content or an optional fallback template string from an address.
	 *
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {(pError?: Error, pResult?: string) => void} fCallback - The callback function to be called with the result
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {void} The result is passed to the callback function
	 */
	renderAsync(pTemplateHash, pRecord, fCallback, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();
		let tmpRecord = (typeof (pRecord) === 'object') ? pRecord : {};
		let tmpCallback = (typeof (fCallback) === 'function') ? fCallback : () => { return ''; };

		if (this.pict.LogNoisiness > 4)
		{
			this.log.trace(`PICT DataWithTemplateFallback [fDataRender]::[${tmpHash}] with tmpRecord:`, tmpRecord);
		}
		else if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PICT DataWithTemplateFallback [fDataRender]::[${tmpHash}]`);
		}

		let tmpTemplateFallbackAddress = '';
		if (tmpHash.indexOf(':') > -1)
		{
			tmpTemplateFallbackAddress = tmpHash.split(':')[1];
			tmpHash = tmpHash.split(':')[0];
		}

		let tmpValue = '';
		if (tmpHash != null)
		{
			tmpValue = this.resolveStateFromAddress(tmpHash, tmpRecord, pContextArray, null, pScope, pState);

			if (tmpValue && tmpValue !== 'undefined')
			{
				if (this.pict.LogNoisiness > 3)
				{
					this.log.trace(`PICT DataWithTemplateFallback [fDataRender]::[${tmpHash}] - Found value: ${tmpValue}`);
				}
				return tmpCallback(null, tmpValue);
			}
		}
		// If the value is not found or is undefined, try to use the fallback template
		this.pict.parseTemplateByHash(tmpTemplateFallbackAddress, tmpRecord, (pError, pValue) =>
			{
				if (pError)
				{
					return tmpCallback(pError, '');
				}
				if (pValue == null || pValue === '')
				{
					this.log.warn(`PICT DataWithTemplateFallback [fDataRender]::[${tmpHash}] - No fallback template found at address: ${tmpTemplateFallbackAddress}`);
					// If no fallback template is found, return an empty string
					return tmpCallback(null, '');
				}
				if (this.pict.LogNoisiness > 3)
				{
					this.log.trace(`PICT DataWithTemplateFallback [fDataRender]::[${tmpHash}] - Using fallback template from address: ${tmpTemplateFallbackAddress}`);
				}
				return tmpCallback(null, pValue);
			}, pContextArray, pScope, pState);
	}

}

module.exports = PictTemplateProviderData;

},{"pict-template":144}],219:[function(require,module,exports){
const libPictTemplate = require('pict-template');

class PictTemplateProviderEntity extends libPictTemplate
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.log;

		this.addPattern('{~E:', '~}');
		this.addPattern('{~Entity:', '~}');
	}

	/**
	 * Render a template expression, returning a string with the resulting content.
	 *
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {string} The rendered template
	 */
	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		// TODO: Better messaging
		this.log.error(`Pict: Entity Render [${pTemplateHash}]: Render called in a non-asynchronous fashion.  This should not happen.`);
		return '';
	}

	/**
	 * Render a template expression, deliver a string with the resulting content to a callback function.
	 *
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {(error?: Error, content?: String) => void} fCallback - callback function invoked with the rendered template, or an error
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {void}
	 */
	renderAsync(pTemplateHash, pRecord, fCallback, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();
		let tmpData = (typeof (pRecord) === 'object') ? pRecord : {};
		let tmpCallback = (typeof (fCallback) === 'function') ? fCallback : () => { return ''; };

		if (this.pict.LogNoisiness > 4)
		{
			this.log.trace(`PICT Template [fEntityRender]::[${tmpHash}] with tmpData:`, tmpData);
		}
		else if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PICT Template [fEntityRender]::[${tmpHash}]`);
		}

		let tmpEntity;
		/** @type {string|number} */
		let tmpEntityID = '';
		let tmpEntityTemplate;

		// This expression requires 2 parts -- a third is optional, and, if present, is the template to render to.
		let tmpAddressParts = tmpHash.split('^');

		if (tmpAddressParts.length < 2)
		{
			this.log.warn(`Pict: Entity Render: Entity or entity ID not resolved for [${tmpHash}]`);
			return tmpCallback(null, '');
		}

		tmpEntity = tmpAddressParts[0].trim();
		tmpEntityID = tmpAddressParts[1].trim();
		tmpEntityTemplate = tmpAddressParts[2].trim();

		if (!isNaN(Number(tmpEntityID)))
		{
			try
			{
				tmpEntityID = parseInt(String(tmpEntityID));
			}
			catch
			{
				this.log.warn(`Pict: Entity Render: Could not parse entity ID.`);
				tmpEntityID = 0;
			}
		}
		else
		{
			// This is an address, so we need to get the value at the address
			tmpEntityID = this.resolveStateFromAddress(String(tmpEntityID), tmpData, pContextArray, null, pScope, pState);
		}

		// No Entity or EntityID
		if (!tmpEntity || !tmpEntityID)
		{
			this.log.warn(`Pict: Entity Render: Entity or entity ID not resolved for [${tmpHash}]  Entity: ${tmpEntity} ID: ${tmpEntityID}`);
			return tmpCallback(null, '');
		}

		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`Pict: Entity Render: Entity [${tmpEntity}] with ID [${tmpEntityID}] as template [${tmpEntityTemplate}] from [${tmpHash}]`);
		}

		// Now try to get the entity
		this.pict.EntityProvider.getEntity(tmpEntity, tmpEntityID,
			function (pError, pRecord)
			{
				if (pError)
				{
					this.log.error(`Pict: Entity Render: Error getting entity [${tmpEntity}] with ID [${tmpEntityID}] for [${tmpHash}]: ${pError}`, pError);
					return tmpCallback(pError, '');
				}

				// Now render the template
				if (tmpEntityTemplate)
				{
					this.pict.parseTemplateByHash(tmpEntityTemplate, pRecord, tmpCallback, pContextArray, pScope, pState);
				}
				else
				{
					tmpCallback(null, '');
				}
			}.bind(this));
	}
}

module.exports = PictTemplateProviderEntity;

},{"pict-template":144}],220:[function(require,module,exports){
const libPictTemplate = require('pict-template');

/**
 * Function template expression.
 *
 *   {~Function:Pict.providers.SomeProvider.makeThing:Record.X:Record.Y~}
 *   {~F:Pict.providers.SomeProvider.makeThing:Record.X:Record.Y~}
 *
 * First parameter is the address of a function to call (resolved with
 * `pict.resolveStateFromAddress` against the usual root: Record, AppData,
 * Pict, Bundle, Context, Scope, TempData, __State).  Each subsequent
 * `:`-separated parameter is itself an address whose resolved value is
 * passed as an argument to the function.  Arity is dynamic.
 *
 * Returns whatever the function returns (coerced to '' when null /
 * undefined).  If the address does not resolve to a function, a warning is
 * logged that names the address and the full template expression, and the
 * expression renders as ''.  If the function throws, the error is logged
 * and the expression renders as ''.
 *
 * `this` is bound to the address's parent object so instance methods work
 * naturally:  `Pict.providers.X.go(...)` invokes with `this === Pict.providers.X`.
 */
class PictTemplateProviderFunction extends libPictTemplate
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.log;

		this.addPattern('{~Function:', '~}');
		this.addPattern('{~F:', '~}');
	}

	/**
	 * Render the Function expression: call the resolved function with the
	 * resolved arguments and return its result.
	 *
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {string} The function's return value, stringified by the template engine; '' if the function is missing or throws.
	 */
	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();
		let tmpRecord = (typeof (pRecord) === 'object') ? pRecord : {};

		if (this.pict.LogNoisiness > 4)
		{
			this.log.trace(`PICT Template [fFunctionRender]::[${tmpHash}] with tmpData:`, tmpRecord);
		}
		else if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PICT Template [fFunctionRender]::[${tmpHash}]`);
		}

		let tmpParts = tmpHash.split(':');
		let tmpFunctionAddress = (tmpParts.length > 0) ? tmpParts[0].trim() : '';

		if (tmpFunctionAddress.length < 1)
		{
			this.log.warn(`Pict: Function Render: No function address provided in template [{~Function:${tmpHash}~}]`);
			return '';
		}

		let tmpFunction = this.resolveStateFromAddress(tmpFunctionAddress, tmpRecord, pContextArray, null, pScope, pState);

		if (typeof (tmpFunction) !== 'function')
		{
			this.log.warn(`Pict: Function Render: Function not found at address [${tmpFunctionAddress}] for template [{~Function:${tmpHash}~}]`);
			return '';
		}

		// Resolve `this` to the function's parent so instance methods bind naturally.
		let tmpThis = null;
		let tmpLastDot = tmpFunctionAddress.lastIndexOf('.');
		if (tmpLastDot > 0)
		{
			let tmpParentAddress = tmpFunctionAddress.substring(0, tmpLastDot);
			tmpThis = this.resolveStateFromAddress(tmpParentAddress, tmpRecord, pContextArray, null, pScope, pState);
		}

		let tmpArguments = [];
		for (let i = 1; i < tmpParts.length; i++)
		{
			tmpArguments.push(this.resolveStateFromAddress(tmpParts[i], tmpRecord, pContextArray, null, pScope, pState));
		}

		try
		{
			let tmpResult = tmpFunction.apply(tmpThis, tmpArguments);
			if (tmpResult == null)
			{
				return '';
			}
			return tmpResult;
		}
		catch (pError)
		{
			this.log.warn(`Pict: Function Render: Error invoking function at [${tmpFunctionAddress}] for template [{~Function:${tmpHash}~}]: ${pError.message}`);
			return '';
		}
	}
}

module.exports = PictTemplateProviderFunction;
module.exports.template_hash = 'Function';

},{"pict-template":144}],221:[function(require,module,exports){
const libPictTemplate = require('pict-template');

/**
 * Icon template tag — emits a themable SVG icon by PascalCase name.
 *
 *   {~Icon:Home~}              → default variant for 'Home'
 *   {~Icon:Folder:Filled~}     → explicit variant
 *   {~I:Spreadsheet~}          → short alias of {~Icon:~}
 *   {~I:File:Filled~}          → short + variant
 *
 * The plugin is a thin shim over the `Icon` provider — all the registry
 * + lookup + variant-fallback logic lives there.  See Provider-Icon.js
 * for registration, alias resolution, and per-name defaults.
 *
 * Sizing happens at the CSS layer: icons are wrapped in `<span class="pict-icon">`
 * whose inner svg is `1em × 1em`.  To resize, set `font-size` on the
 * parent (e.g. a button) — no template-side sizing needed for the common
 * case.  One-off sizing still works through the JS API:
 * `pict.icon('Save', { size: 20 })`.
 */
class PictTemplateProviderIcon extends libPictTemplate
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.addPattern('{~Icon:', '~}');
		this.addPattern('{~I:',    '~}');
	}

	/**
	 * @param {string} pTemplateHash - Body of the tag (the bit between the
	 *                                  opening pattern and the closing `~}`).
	 *                                  Either "Name" or "Name:Variant".
	 * @returns {string}
	 */
	render(pTemplateHash)
	{
		let tmpBody = (pTemplateHash || '').trim();
		if (tmpBody.length < 1)
		{
			return '';
		}
		let tmpName = tmpBody;
		let tmpVariant = null;
		let tmpColon = tmpBody.indexOf(':');
		if (tmpColon > -1)
		{
			tmpName    = tmpBody.slice(0, tmpColon).trim();
			tmpVariant = tmpBody.slice(tmpColon + 1).trim();
		}

		let tmpProvider = this.pict && this.pict.providers && this.pict.providers.Icon;
		if (!tmpProvider || typeof (tmpProvider.get) !== 'function')
		{
			// Provider missing — should never happen in a normally-booted
			// Pict app, but degrade silently rather than emit something
			// that looks like a template tag.
			return '';
		}

		let tmpOpts = tmpVariant ? { variant: tmpVariant } : undefined;
		return tmpProvider.get(tmpName, tmpOpts);
	}
}

module.exports = PictTemplateProviderIcon;

},{"pict-template":144}],222:[function(require,module,exports){
const libPictTemplate = require('pict-template');

/**
 * Inline Template expression.
 *
 * Captures its raw contents (verbatim, including any other pict template
 * tags) and processes them as a template at runtime.  At render time the
 * captured string is fed back through `pict.parseTemplate(...)` with the
 * same Record/Context/Scope/State that was active at the outer scope.
 *
 *   {<TEMPLATED CONTENT HERE, {~D:AppData.SomeValue~}.>}
 *
 * Direct nesting of `{<...>}` inside another `{<...>}` is not supported;
 * the first `>}` closes the outer block.  Wrap the inner literal in a
 * registered template hash and reference it with `{~T:Hash~}` for that.
 */
class PictTemplateProviderInlineTemplate extends libPictTemplate
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.log;

		this.addPattern('{<', '>}');
	}

	/**
	 * Render an inline template expression, returning a string with the
	 * processed template content.
	 *
	 * @param {string} pTemplateBody - The raw inline template body (what was between `{<` and `>}`)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {string} The rendered template
	 */
	render(pTemplateBody, pRecord, pContextArray, pScope, pState)
	{
		let tmpBody = (typeof (pTemplateBody) === 'string') ? pTemplateBody : '';

		if (this.pict.LogNoisiness > 4)
		{
			this.log.trace(`PICT Template [fInlineTemplateRender]::[${tmpBody}] with tmpData:`, pRecord);
		}
		else if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PICT Template [fInlineTemplateRender]::[${tmpBody}]`);
		}

		if (tmpBody.length < 1)
		{
			return '';
		}

		return this.pict.parseTemplate(tmpBody, pRecord, null, pContextArray, pScope, pState);
	}

	/**
	 * Render an inline template expression, delivering the result to a callback.
	 *
	 * @param {string} pTemplateBody - The raw inline template body (what was between `{<` and `>}`)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {(error?: Error, content?: String) => void} fCallback - callback function invoked with the rendered template, or an error
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {void}
	 */
	renderAsync(pTemplateBody, pRecord, fCallback, pContextArray, pScope, pState)
	{
		let tmpBody = (typeof (pTemplateBody) === 'string') ? pTemplateBody : '';
		let tmpCallback = (typeof (fCallback) === 'function') ? fCallback : () => { return ''; };

		if (this.pict.LogNoisiness > 4)
		{
			this.log.trace(`PICT Template [fInlineTemplateRenderAsync]::[${tmpBody}] with tmpData:`, pRecord);
		}
		else if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PICT Template [fInlineTemplateRenderAsync]::[${tmpBody}]`);
		}

		if (tmpBody.length < 1)
		{
			return tmpCallback(null, '');
		}

		this.pict.parseTemplate(tmpBody, pRecord,
			(pError, pValue) =>
			{
				if (pError)
				{
					return tmpCallback(pError, '');
				}
				return tmpCallback(null, pValue);
			}, pContextArray, pScope, pState);
	}
}

module.exports = PictTemplateProviderInlineTemplate;
module.exports.template_hash = 'InlineTemplate';

},{"pict-template":144}],223:[function(require,module,exports){
const libPictTemplate = require('pict-template');

class PictTemplateProviderSelf extends libPictTemplate
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		this.addPattern('{~Pict', '~}');
		this.addPattern('{~P', '~}');
		this.addPattern('{~p', '~}');
	}

	/**
	 * Render a template expression, returning a string with the resulting content.
	 *
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {string} The rendered template
	 */
	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		return this.pict.browserAddress;
	}
}

module.exports = PictTemplateProviderSelf;

},{"pict-template":144}],224:[function(require,module,exports){
const libPictTemplate = require('pict-template');

class PictTemplateProviderSolve extends libPictTemplate
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.log;

		this.addPattern('{~Solve:', '~}');
		this.addPattern('{~S:', '~}');
	}

	/**
	 * Render a template expression, returning a string with the resulting content.
	 *
	 * @param {string} pSolveParams - The solver parameters.
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {string} The rendered template
	 */
	render(pSolveParams, pRecord, pContextArray, pScope, pState)
	{
		// {~S:ROUND(250*0.4129+Width,3):AppData.HomeworkRectangleSize:AppData.HomeworkManifest~}
		const [ tmpEquation, tmpRecordAddress, tmpManifestAddress ] = pSolveParams.trim().split(':', 3);
		const tmpContextualRecord = (typeof (pRecord) === 'object') ? pRecord : {};

		if (this.pict.LogNoisiness > 4)
		{
			this.log.trace(`PICT Solve [fTemplateRender]::[${pSolveParams}] with tmpData:`, tmpContextualRecord);
		}
		else if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PICT Solve [fTemplateRender]::[${pSolveParams}]`);
		}

		if (!tmpEquation)
		{
			if (this.pict.LogNoisiness > 2)
			{
				this.log.warn(`Pict: Solve: Equation not found for [${tmpEquation}]`);
			}
			return '';
		}
		const tmpRecord = (tmpRecordAddress && this.pict.resolveStateFromAddress(tmpRecordAddress, tmpContextualRecord, pContextArray, null, pScope, pState)) || tmpContextualRecord;
		const tmpManifest = (tmpManifestAddress && this.pict.resolveStateFromAddress(tmpManifestAddress, tmpContextualRecord, pContextArray, null, pScope, pState)) || this.pict.manifest;
		const expressionParser = this.fable.instantiateServiceProviderIfNotExists('ExpressionParser');
		const tmpResultObject = { };
		return expressionParser.solve(tmpEquation, tmpRecord, tmpResultObject, tmpManifest, tmpRecord);
	}
}

module.exports = PictTemplateProviderSolve;

},{"pict-template":144}],225:[function(require,module,exports){
const libPictTemplate = require('pict-template');

class PictTemplateProviderSolveByReference extends libPictTemplate
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.log;

		this.addPattern('{~SolveByReference:', '~}');
		this.addPattern('{~SBR:', '~}');
	}

	/**
	 * Render a template expression, returning a string with the resulting content.
	 *
	 * @param {string} pSolveParams - The solver parameters.
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {string} The rendered template
	 */
	render(pSolveParams, pRecord, pContextArray, pScope, pState)
	{
		// {~SBR:AppData.Equation:AppData.HomeworkRectangleSize:AppData.HomeworkManifest~}
		const [ tmpEquationAddress, tmpRecordAddress, tmpManifestAddress ] = pSolveParams.trim().split(':', 3);
		const tmpContextualRecord = (typeof (pRecord) === 'object') ? pRecord : {};

		if (this.pict.LogNoisiness > 4)
		{
			this.log.trace(`PICT SolveByReference [fTemplateRender]::[${pSolveParams}] with tmpData:`, tmpContextualRecord);
		}
		else if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PICT SolveByReference [fTemplateRender]::[${pSolveParams}]`);
		}

		const tmpEquation = this.pict.resolveStateFromAddress(tmpEquationAddress, tmpContextualRecord, pContextArray, null, pScope, pState);
		if (!tmpEquation)
		{
			if (this.pict.LogNoisiness > 2)
			{
				this.log.warn(`Pict: SolveByReference: Equation not found for [${tmpEquationAddress}]`);
			}
			return '';
		}
		const tmpRecord = (tmpRecordAddress && this.pict.resolveStateFromAddress(tmpRecordAddress, tmpContextualRecord, pContextArray, null, pScope, pState)) || tmpContextualRecord;
		const tmpManifest = (tmpManifestAddress && this.pict.resolveStateFromAddress(tmpManifestAddress, tmpContextualRecord, pContextArray, null, pScope, pState)) || this.pict.manifest;
		const expressionParser = this.fable.instantiateServiceProviderIfNotExists('ExpressionParser');
		const tmpResultObject = { };
		return expressionParser.solve(tmpEquation, tmpRecord, tmpResultObject, tmpManifest, tmpRecord);
	}
}

module.exports = PictTemplateProviderSolveByReference;

},{"pict-template":144}],226:[function(require,module,exports){
const libPictTemplate = require('pict-template');

class PictTemplateProviderTemplate extends libPictTemplate
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.log;

		this.addPattern('{~Template:', '~}');
		this.addPattern('{~T:', '~}');
	}

	/**
	 * Render a template expression, returning a string with the resulting content.
	 *
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {string} The rendered template
	 */
	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();
		let tmpData = (typeof (pRecord) === 'object') ? pRecord : {};

		if (this.pict.LogNoisiness > 4)
		{
			this.log.trace(`PICT Template [fTemplateRender]::[${tmpHash}] with tmpData:`, tmpData);
		}
		else if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PICT Template [fTemplateRender]::[${tmpHash}]`);
		}

		let tmpTemplateHash;
		let tmpAddressOfData;

		// This is just a simple 2 part hash (the entity and the ID)
		let tmpHashTemplateSeparator = tmpHash.indexOf(':');
		tmpTemplateHash = tmpHash.substring(0, tmpHashTemplateSeparator);
		if (tmpHashTemplateSeparator > -1)
		{
			tmpAddressOfData = tmpHash.substring(tmpHashTemplateSeparator + 1);
		}
		else
		{
			tmpTemplateHash = tmpHash;
		}

		// No template hash
		if (!tmpTemplateHash)
		{
			this.log.warn(`Pict: Template Render: TemplateHash not resolved for [${tmpHash}]`);
			return '';
		}

		if (!tmpAddressOfData)
		{
			// No address was provided, just render the template with what this template has.
			return this.pict.parseTemplateByHash(tmpTemplateHash, pRecord, null, pContextArray, pScope, pState);
		}
		else
		{
			return this.pict.parseTemplateByHash(tmpTemplateHash, this.resolveStateFromAddress(tmpAddressOfData, tmpData, pContextArray, null, pScope, pState), null, pContextArray, pScope, pState);
		}
	}

	/**
	 * Render a template expression, deliver a string with the resulting content to a callback function.
	 *
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {(error?: Error, content?: String) => void} fCallback - callback function invoked with the rendered template, or an error
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {void}
	 */
	renderAsync(pTemplateHash, pRecord, fCallback, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();
		let tmpData = (typeof (pRecord) === 'object') ? pRecord : {};
		let tmpCallback = (typeof (fCallback) === 'function') ? fCallback : () => { return ''; };

		if (this.pict.LogNoisiness > 4)
		{
			this.log.trace(`PICT Template [fTemplateRenderAsync]::[${tmpHash}] with tmpData:`, tmpData);
		}
		else if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PICT Template [fTemplateRenderAsync]::[${tmpHash}]`);
		}

		let tmpTemplateHash;
		let tmpAddressOfData;

		// This is just a simple 2 part hash (the entity and the ID)
		let tmpHashTemplateSeparator = tmpHash.indexOf(':');
		tmpTemplateHash = tmpHash.substring(0, tmpHashTemplateSeparator);
		if (tmpHashTemplateSeparator > -1)
		{
			tmpAddressOfData = tmpHash.substring(tmpHashTemplateSeparator + 1);
		}
		else
		{
			tmpTemplateHash = tmpHash;
		}

		// No template hash
		if (!tmpTemplateHash)
		{
			this.log.warn(`Pict: Template Render Async: TemplateHash not resolved for [${tmpHash}]`);
			return fCallback(null, '');
		}

		if (!tmpAddressOfData)
		{
			// No address was provided, just render the template with what this template has.
			// The async portion of this is a mind bender because of how entry can happen dynamically from templates
			this.pict.parseTemplateByHash(tmpTemplateHash, pRecord,
				(pError, pValue) =>
				{
					if (pError)
					{
						return tmpCallback(pError, '');
					}
					return tmpCallback(null, pValue);
				}, pContextArray, pScope, pState);
		}
		else
		{
			this.pict.parseTemplateByHash(tmpTemplateHash, this.resolveStateFromAddress(tmpAddressOfData, tmpData, pContextArray, null, pScope, pState),
				(pError, pValue) =>
				{
					if (pError)
					{
						return tmpCallback(pError, '');
					}
					return tmpCallback(null, pValue);
				}, pContextArray, pScope, pState);
		}
	}
}

module.exports = PictTemplateProviderTemplate;

},{"pict-template":144}],227:[function(require,module,exports){
const libPictTemplate = require('pict-template');

class PictTemplateProviderTemplateByDataAddress extends libPictTemplate
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.log;

		this.addPattern('{~TemplateByDataAddress:', '~}');
		this.addPattern('{~TBDA:', '~}');
	}

	/**
	 * Render a template expression, returning a string with the resulting content.
	 *
	 * @param {string} pTemplateDataAddress - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {string} The rendered template
	 */
	render(pTemplateDataAddress, pRecord, pContextArray, pScope, pState)
	{
		let tmpDataAddress = pTemplateDataAddress.trim();
		let tmpData = (typeof (pRecord) === 'object') ? pRecord : {};

		if (this.pict.LogNoisiness > 4)
		{
			this.log.trace(`PICT TemplateByDataAddress [fTemplateRender]::[${tmpDataAddress}] with tmpData:`, tmpData);
		}
		else if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PICT TemplateByDataAddress [fTemplateRender]::[${tmpDataAddress}]`);
		}

		let tmpTemplateDataAddress;
		let tmpAddressOfData;

		// This is just a simple 2 part hash (the entity and the ID)
		let tmpHashTemplateSeparator = tmpDataAddress.indexOf(':');
		tmpTemplateDataAddress = tmpDataAddress.substring(0, tmpHashTemplateSeparator);
		if (tmpHashTemplateSeparator > -1)
		{
			tmpAddressOfData = tmpDataAddress.substring(tmpHashTemplateSeparator + 1);
		}
		else
		{
			tmpTemplateDataAddress = tmpDataAddress;
		}

		// No template hash
		if (!tmpTemplateDataAddress)
		{
			this.log.warn(`Pict: Template Render: TemplateHash not resolved for [${tmpDataAddress}]`);
			return '';
		}

		let tmpTemplate = this.pict.resolveStateFromAddress(tmpTemplateDataAddress, pRecord, pContextArray, null, pScope, pState);
		if (!tmpTemplate)
		{
			if (this.pict.LogNoisiness > 2)
			{
				this.log.warn(`Pict: Template Render: Template not found for [${tmpTemplateDataAddress}]`);
			}
			tmpTemplate = '';
		}
		if (!tmpAddressOfData)
		{
			// No address was provided, just render the template with what this template has.
			return this.pict.parseTemplate(tmpTemplate, pRecord, null, pContextArray, pScope, pState);
		}
		else
		{
			return this.pict.parseTemplate(tmpTemplate, this.resolveStateFromAddress(tmpAddressOfData, tmpData, pContextArray, null, pScope, pState), null, pContextArray, pScope, pState);
		}
	}

	/**
	 * Render a template expression, deliver a string with the resulting content to a callback function.
	 *
	 * @param {string} pTemplateDataAddress - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {(error?: Error, content?: String) => void} fCallback - callback function invoked with the rendered template, or an error
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {void}
	 */
	renderAsync(pTemplateDataAddress, pRecord, fCallback, pContextArray, pScope, pState)
	{
		let tmpDataAddress = pTemplateDataAddress.trim();
		let tmpData = (typeof (pRecord) === 'object') ? pRecord : {};
		let tmpCallback = (typeof (fCallback) === 'function') ? fCallback : () => { return ''; };

		if (this.pict.LogNoisiness > 4)
		{
			this.log.trace(`PICT TemplateByDataAddress [fTemplateRenderAsync]::[${tmpDataAddress}] with tmpData:`, tmpData);
		}
		else if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PICT TemplateByDataAddress [fTemplateRenderAsync]::[${tmpDataAddress}]`);
		}

		let tmpTemplateDataAddress;
		let tmpAddressOfData;

		// This is just a simple 2 part hash (the entity and the ID)
		let tmpHashTemplateSeparator = tmpDataAddress.indexOf(':');
		tmpTemplateDataAddress = tmpDataAddress.substring(0, tmpHashTemplateSeparator);
		if (tmpHashTemplateSeparator > -1)
		{
			tmpAddressOfData = tmpDataAddress.substring(tmpHashTemplateSeparator + 1);
		}
		else
		{
			tmpTemplateDataAddress = tmpDataAddress;
		}

		// No template hash
		if (!tmpTemplateDataAddress)
		{
			this.log.warn(`Pict: Template Render Async: TemplateHash not resolved for [${tmpDataAddress}]`);
			return tmpCallback(null, '');
		}

		let tmpTemplate = this.pict.resolveStateFromAddress(tmpTemplateDataAddress, pRecord, pContextArray, null, pScope, pState) || '';
		if (!tmpTemplate)
		{
			if (this.pict.LogNoisiness > 2)
			{
				this.log.warn(`Pict: Template Render: Template not found for [${tmpTemplateDataAddress}]`);
			}
			tmpTemplate = '';
		}
		if (!tmpAddressOfData)
		{
			// No address was provided, just render the template with what this template has.
			// The async portion of this is a mind bender because of how entry can happen dynamically from templates
			this.pict.parseTemplate(tmpTemplate, pRecord,
				(pError, pValue) =>
				{
					if (pError)
					{
						return tmpCallback(pError, '');
					}
					return tmpCallback(null, pValue);
				}, pContextArray, pScope, pState);
		}
		else
		{
			this.pict.parseTemplate(tmpTemplate, this.resolveStateFromAddress(tmpAddressOfData, tmpData, pContextArray, null, pScope, pState),
				(pError, pValue) =>
				{
					if (pError)
					{
						return tmpCallback(pError, '');
					}
					return tmpCallback(null, pValue);
				}, pContextArray, pScope, pState);
		}
	}
}

module.exports = PictTemplateProviderTemplateByDataAddress;

},{"pict-template":144}],228:[function(require,module,exports){
const libPictTemplate = require('pict-template');

class PictTemplateProviderTemplate extends libPictTemplate
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.log;

		this.addPattern('{~TemplateByReference:', '~}');
		this.addPattern('{~TBR:', '~}');
	}

	/**
	 * Render a template expression, returning a string with the resulting content.
	 *
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {string} The rendered template
	 */
	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();
		let tmpData = (typeof (pRecord) === 'object') ? pRecord : {};

		if (this.pict.LogNoisiness > 4)
		{
			this.log.trace(`PICT Template [fTemplateRender]::[${tmpHash}] with tmpData:`, tmpData);
		}
		else if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PICT Template [fTemplateRender]::[${tmpHash}]`);
		}

		let tmpTemplateHashReferenceLocation;
		let tmpAddressOfData;

		// This is just a simple 2 part hash (the entity and the ID)
		let tmpHashTemplateSeparator = tmpHash.indexOf(':');
		tmpTemplateHashReferenceLocation = tmpHash.substring(0, tmpHashTemplateSeparator);
		if (tmpHashTemplateSeparator > -1)
		{
			tmpAddressOfData = tmpHash.substring(tmpHashTemplateSeparator + 1);
		}
		else
		{
			tmpTemplateHashReferenceLocation = tmpHash;
		}

		// No template hash
		if (!tmpTemplateHashReferenceLocation)
		{
			this.log.warn(`Pict: Template Render: TemplateHashReferenceLocation not resolved for [${tmpHash}]`);
			return '';
		}

		// Now look up the template by the reference
		let tmpTemplateHash = this.resolveStateFromAddress(tmpTemplateHashReferenceLocation, pRecord, pContextArray, null, pScope, pState);

		// No template hash
		if (!tmpTemplateHash)
		{
			this.log.warn(`Pict: Template Render: TemplateHash not resolved for [${tmpHash}]`);
			return '';
		}

		if (!tmpAddressOfData)
		{
			// No address was provided, just render the template with what this template has.
			return this.pict.parseTemplateByHash(tmpTemplateHash, pRecord, null, pContextArray, pScope, pState);
		}
		else
		{
			return this.pict.parseTemplateByHash(tmpTemplateHash, this.resolveStateFromAddress(tmpAddressOfData, tmpData, pContextArray, null, pScope, pState), null, pContextArray, pScope, pState);
		}
	}

	/**
	 * Render a template expression, deliver a string with the resulting content to a callback function.
	 *
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {(error?: Error, content?: String) => void} fCallback - callback function invoked with the rendered template, or an error
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {void}
	 */
	renderAsync(pTemplateHash, pRecord, fCallback, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();
		let tmpData = (typeof (pRecord) === 'object') ? pRecord : {};
		let tmpCallback = (typeof (fCallback) === 'function') ? fCallback : () => { return ''; };

		if (this.pict.LogNoisiness > 4)
		{
			this.log.trace(`PICT Template [fTemplateRenderAsync]::[${tmpHash}] with tmpData:`, tmpData);
		}
		else if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PICT Template [fTemplateRenderAsync]::[${tmpHash}]`);
		}

		let tmpTemplateHashReferenceLocation;
		let tmpAddressOfData;

		// This is just a simple 2 part hash (the entity and the ID)
		let tmpHashTemplateSeparator = tmpHash.indexOf(':');
		tmpTemplateHashReferenceLocation = tmpHash.substring(0, tmpHashTemplateSeparator);
		if (tmpHashTemplateSeparator > -1)
		{
			tmpAddressOfData = tmpHash.substring(tmpHashTemplateSeparator + 1);
		}
		else
		{
			tmpTemplateHashReferenceLocation = tmpHash;
		}

		// No template hash
		if (!tmpTemplateHashReferenceLocation)
		{
			this.log.warn(`Pict: Template Render Async: TemplateHashReferenceLocation not resolved for [${tmpHash}]`);
			return fCallback(null, '');
		}

		// Now look up the template by the reference
		let tmpTemplateHash = this.resolveStateFromAddress(tmpTemplateHashReferenceLocation, pRecord, pContextArray, null, pScope, pState);

		// No template hash
		if (!tmpTemplateHash)
		{
			this.log.warn(`Pict: Template Render Async: TemplateHash not resolved for [${tmpHash}]`);
			return fCallback(null, '');
		}

		if (!tmpAddressOfData)
		{
			// No address was provided, just render the template with what this template has.
			// The async portion of this is a mind bender because of how entry can happen dynamically from templates
			this.pict.parseTemplateByHash(tmpTemplateHash, pRecord,
				(pError, pValue) =>
				{
					if (pError)
					{
						return tmpCallback(pError, '');
					}
					return tmpCallback(null, pValue);
				}, pContextArray, pScope, pState);
		}
		else
		{
			this.pict.parseTemplateByHash(tmpTemplateHash, this.resolveStateFromAddress(tmpAddressOfData, tmpData, pContextArray, null, pScope, pState),
				(pError, pValue) =>
				{
					if (pError)
					{
						return tmpCallback(pError, '');
					}
					return tmpCallback(null, pValue);
				}, pContextArray, pScope, pState);
		}
	}
}

module.exports = PictTemplateProviderTemplate;

},{"pict-template":144}],229:[function(require,module,exports){
const libPictTemplate = require('pict-template');

class PictTemplateProviderTemplateByTypes extends libPictTemplate
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.log;

		this.addPattern('{~TemplateByType:', '~}');
		this.addPattern('{~TBT:', '~}');
	}

	/**
	 * Render a template expression if it's in the passed-in types, otherwise falling back to a fallback template, returning a string with the resulting content.
	 *
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {string} The rendered template
	 */
	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();
		let tmpData = (typeof (pRecord) === 'object') ? pRecord : {};

		if (this.pict.LogNoisiness > 4)
		{
			this.log.trace(`PICT Template [fTemplateRender]::[${tmpHash}] with tmpData:`, tmpData);
		}
		else if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PICT Template [fTemplateRender]::[${tmpHash}]`);
		}

		let tmpAddressToTest;
		let tmpDataTypesToTest;
		let tmpTemplateHash;
		let tmpAddressOfData;
		let tmpFallbackTemplate;

		// This is {~TBT:AppData.Some.Address.To.Test:string,number:SomeTemplate:FallbackTemplate~}
		let tmpTemplateHashes = tmpHash.trim().split(':');

		if (tmpTemplateHashes.length < 3)
		{
			return '';
		}

		tmpAddressToTest = tmpTemplateHashes[0];
		tmpDataTypesToTest = tmpTemplateHashes[1].split(',');
		tmpTemplateHash = tmpTemplateHashes[2];

		if (tmpTemplateHashes.length > 3)
		{
			tmpAddressOfData = tmpTemplateHashes[3];
		}

		if (tmpTemplateHashes.length > 4)
		{
			tmpFallbackTemplate = tmpTemplateHashes[4];
		}

		// No template hash
		if (!tmpTemplateHash)
		{
			return '';
		}

		let tmpRecord = pRecord;
		if (tmpAddressOfData)
		{
			tmpRecord = this.resolveStateFromAddress(tmpAddressOfData, tmpData, pContextArray, null, pScope, pState);
		}

		const tmpValueAtAddress = this.resolveStateFromAddress(tmpAddressToTest, tmpData, pContextArray, null, pScope, pState);
		/** @type {string} */
		let tmpTypeOfDataAtAddress = typeof tmpValueAtAddress;
		if (tmpTypeOfDataAtAddress == 'object' && Array.isArray(tmpValueAtAddress))
		{
			tmpTypeOfDataAtAddress = 'array';
		}
		if (tmpDataTypesToTest.indexOf(tmpTypeOfDataAtAddress) === -1)
		{
			// Type not found, use the fallback template if we have one.
			if (tmpFallbackTemplate)
			{
				tmpTemplateHash = tmpFallbackTemplate;
			}
			else
			{
				return '';
			}
		}

		// No address was provided, just render the template with what this template has.
		return this.pict.parseTemplateByHash(tmpTemplateHash, tmpRecord, null, pContextArray, pScope, pState);
	}

	/**
	 * Render a template expression, deliver a string with the resulting content to a callback function.
	 *
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {(error?: Error, content?: String) => void} fCallback - callback function invoked with the rendered template, or an error
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {void}
	 */
	renderAsync(pTemplateHash, pRecord, fCallback, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();
		let tmpData = (typeof (pRecord) === 'object') ? pRecord : {};
		let tmpCallback = (typeof (fCallback) === 'function') ? fCallback : () => { return ''; };

		if (this.pict.LogNoisiness > 4)
		{
			this.log.trace(`PICT Template [fTemplateRenderAsync]::[${tmpHash}] with tmpData:`, tmpData);
		}
		else if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PICT Template [fTemplateRenderAsync]::[${tmpHash}]`);
		}

		let tmpAddressToTest;
		let tmpDataTypesToTest;
		let tmpTemplateHash;
		let tmpAddressOfData;
		let tmpFallbackTemplate;

		// This is {~TBT:AppData.Some.Address.To.Test:string,number:SomeTemplate:FallbackTemplate~}
		let tmpTemplateHashes = tmpHash.trim().split(':');

		if (tmpTemplateHashes.length < 3)
		{
			return fCallback(null, '');
		}

		tmpAddressToTest = tmpTemplateHashes[0];
		tmpDataTypesToTest = tmpTemplateHashes[1].split(',');
		tmpTemplateHash = tmpTemplateHashes[2];

		if (tmpTemplateHashes.length > 3)
		{
			tmpAddressOfData = tmpTemplateHashes[3];
		}

		if (tmpTemplateHashes.length > 4)
		{
			tmpFallbackTemplate = tmpTemplateHashes[4];
		}

		// No template hash
		if (!tmpTemplateHash)
		{
			return fCallback(null, '');
		}

		let tmpRecord = pRecord;
		if (tmpAddressOfData)
		{
			tmpRecord = this.resolveStateFromAddress(tmpAddressOfData, tmpData, pContextArray, null, pScope, pState);
		}

		const tmpValueAtAddress = this.resolveStateFromAddress(tmpAddressToTest, tmpData, pContextArray, null, pScope, pState);
		/** @type {string} */
		let tmpTypeOfDataAtAddress = typeof tmpValueAtAddress;
		if (tmpTypeOfDataAtAddress == 'object' && Array.isArray(tmpValueAtAddress))
		{
			tmpTypeOfDataAtAddress = 'array';
		}
		if (tmpDataTypesToTest.indexOf(tmpTypeOfDataAtAddress) === -1)
		{
			// Type not found, use the fallback template if we have one.
			if (tmpFallbackTemplate)
			{
				tmpTemplateHash = tmpFallbackTemplate;
			}
			else
			{
				return fCallback(null, '');
			}
		}

		// No address was provided, just render the template with what this template has.
		this.pict.parseTemplateByHash(tmpTemplateHash, tmpRecord,
			(pError, pValue) =>
			{
				if (pError)
				{
					return tmpCallback(pError, '');
				}
				return tmpCallback(null, pValue);
			}, pContextArray, pScope, pState);
	}
}

module.exports = PictTemplateProviderTemplateByTypes;

},{"pict-template":144}],230:[function(require,module,exports){
const libPictTemplate = require('pict-template');

class PictTemplateProviderTemplateFromAddress extends libPictTemplate
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.log;

		this.addPattern('{~TemplateFromAddress:', '~}');
		this.addPattern('{~TFA:', '~}');
	}

	/**
	 * Render a template expression, returning a string with the resulting content.
	 *
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {string} The rendered template
	 */
	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();
		let tmpData = (typeof (pRecord) === 'object') ? pRecord : {};

		if (this.pict.LogNoisiness > 4)
		{
			this.log.trace(`PICT Template [fTemplateRender]::[${tmpHash}] with tmpData:`, tmpData);
		}
		else if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PICT Template [fTemplateRender]::[${tmpHash}]`);
		}

		let tmpTemplateContentAddress;
		let tmpAddressOfData;

		// This is just a simple 2 part hash (the entity and the ID)
		let tmpHashTemplateSeparator = tmpHash.indexOf(':');
		tmpTemplateContentAddress = tmpHash.substring(0, tmpHashTemplateSeparator);
		if (tmpHashTemplateSeparator > -1)
		{
			tmpAddressOfData = tmpHash.substring(tmpHashTemplateSeparator + 1);
		}
		else
		{
			tmpTemplateContentAddress = tmpHash;
		}

		// No template hash
		if (!tmpTemplateContentAddress)
		{
			this.log.warn(`Pict: Template Render: TemplateHashReferenceLocation not resolved for [${tmpHash}]`);
			return '';
		}

		// Now look up the template by the reference
		let tmpTemplateContent = this.resolveStateFromAddress(tmpTemplateContentAddress, pRecord, pContextArray, null, pScope, pState);

		// No template hash
		if (!tmpTemplateContent)
		{
			this.log.warn(`Pict: Template Render: Template not resolved for [${tmpHash}]`);
			return '';
		}

		if (!tmpAddressOfData)
		{
			// No address was provided, just render the template with what this template has.
			return this.pict.parseTemplate(tmpTemplateContent, pRecord, null, pContextArray, pScope, pState);
		}
		else
		{
			return this.pict.parseTemplate(tmpTemplateContent, this.resolveStateFromAddress(tmpAddressOfData, tmpData, pContextArray, null, pScope, pState), null, pContextArray, pScope, pState);
		}
	}

	/**
	 * Render a template expression, deliver a string with the resulting content to a callback function.
	 *
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {(error?: Error, content?: String) => void} fCallback - callback function invoked with the rendered template, or an error
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {void}
	 */
	renderAsync(pTemplateHash, pRecord, fCallback, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();
		let tmpData = (typeof (pRecord) === 'object') ? pRecord : {};
		let tmpCallback = (typeof (fCallback) === 'function') ? fCallback : () => { return ''; };

		if (this.pict.LogNoisiness > 4)
		{
			this.log.trace(`PICT Template [fTemplateRenderAsync]::[${tmpHash}] with tmpData:`, tmpData);
		}
		else if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PICT Template [fTemplateRenderAsync]::[${tmpHash}]`);
		}

		let tmpTemplateContentAddress;
		let tmpAddressOfData;

		// This is just a simple 2 part hash (the entity and the ID)
		let tmpHashTemplateSeparator = tmpHash.indexOf(':');
		tmpTemplateContentAddress = tmpHash.substring(0, tmpHashTemplateSeparator);
		if (tmpHashTemplateSeparator > -1)
		{
			tmpAddressOfData = tmpHash.substring(tmpHashTemplateSeparator + 1);
		}
		else
		{
			tmpTemplateContentAddress = tmpHash;
		}

		// No template hash
		if (!tmpTemplateContentAddress)
		{
			this.log.warn(`Pict: Template Render Async: TemplateHashReferenceLocation not resolved for [${tmpHash}]`);
			return fCallback(null, '');
		}

		// Now look up the template by the reference
		let tmpTemplateContent = this.resolveStateFromAddress(tmpTemplateContentAddress, pRecord, pContextArray, null, pScope, pState);

		// No template hash
		if (!tmpTemplateContent)
		{
			this.log.warn(`Pict: Template Render Async: TemplateHash not resolved for [${tmpHash}]`);
			return fCallback(null, '');
		}

		if (!tmpAddressOfData)
		{
			// No address was provided, just render the template with what this template has.
			// The async portion of this is a mind bender because of how entry can happen dynamically from templates
			this.pict.parseTemplate(tmpTemplateContent, pRecord,
				(pError, pValue) =>
				{
					if (pError)
					{
						return tmpCallback(pError, '');
					}
					return tmpCallback(null, pValue);
				}, pContextArray, pScope, pState);
		}
		else
		{
			this.pict.parseTemplate(tmpTemplateContent, this.resolveStateFromAddress(tmpAddressOfData, tmpData, pContextArray, null, pScope, pState),
				(pError, pValue) =>
				{
					if (pError)
					{
						return tmpCallback(pError, '');
					}
					return tmpCallback(null, pValue);
				}, pContextArray, pScope, pState);
		}
	}
}

module.exports = PictTemplateProviderTemplateFromAddress;

},{"pict-template":144}],231:[function(require,module,exports){
const libPictTemplate = require('pict-template');

class PictTemplateProviderTemplateFromMap extends libPictTemplate
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.log;

		this.addPattern('{~TFM:', '~}');
		this.addPattern('{~TemplateFromMap:', '~}');
	}

	/**
	 * Render a template expression, returning a string with the resulting content.
	 *
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {string} The rendered template
	 */
	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();
		let tmpData = (typeof (pRecord) === 'object') ? pRecord : {};

		if (this.pict.LogNoisiness > 4)
		{
			this.log.trace(`PICT TemplateFromMap [fTemplateFromMapRender]::[${tmpHash}] with tmpData:`, tmpData);
		}
		else if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PICT TemplateFromMap [fTemplateFromMapRender]::[${tmpHash}]`);
		}

		let tmpTemplateFromMapHash;
		let tmpAddressOfMap;
		let tmpAddressOfKey;

		// This is a 3 part hash with the map address and the key address both
		let tmpTemplateHashPart = tmpHash.split(':');

		if (tmpTemplateHashPart.length < 3)
		{
			this.log.trace(`PICT TemplateFromMap [fTemplateFromMapRenderAsync]::[${tmpHash}] failed because there were not three stanzas in the expression [${pTemplateHash}]`);
			return ''
		}

		tmpTemplateFromMapHash = tmpTemplateHashPart[0];
		tmpAddressOfMap = tmpTemplateHashPart[1];
		tmpAddressOfKey = tmpTemplateHashPart[2];

		// No TemplateFromMap hash
		if (!tmpTemplateFromMapHash)
		{
			this.log.warn(`Pict: TemplateFromMap Render: TemplateFromMapHash not resolved for [${tmpHash}]`);
			return '';
		}

		// Now resolve the data
		let tmpMap = this.resolveStateFromAddress(tmpAddressOfMap, tmpData, pContextArray, null, pScope, pState);
		let tmpKey = this.resolveStateFromAddress(tmpAddressOfKey, tmpData, pContextArray, null, pScope, pState);

		if (!tmpMap)
		{
			this.log.warn(`Pict: TemplateFromMap Render: Map not resolved for [${tmpHash}]`);
			return '';
		}

		tmpData = tmpMap[tmpKey];

		if (!tmpData)
		{
			// No address was provided, just render the TemplateFromMap with what this TemplateFromMap has.
			return this.pict.parseTemplateByHash(tmpTemplateFromMapHash, pRecord, null, pContextArray, pScope, pState);
		}
		else
		{
			return this.pict.parseTemplateByHash(tmpTemplateFromMapHash, tmpData, null, pContextArray, pScope, pState);
		}
	}

	/**
	 * Render a template expression, deliver a string with the resulting content to a callback function.
	 *
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {(error?: Error, content?: String) => void} fCallback - callback function invoked with the rendered template, or an error
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {void}
	 */
	renderAsync(pTemplateHash, pRecord, fCallback, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();
		let tmpData = (typeof (pRecord) === 'object') ? pRecord : {};
		let tmpCallback = (typeof (fCallback) === 'function') ? fCallback : () => { return ''; };

		if (this.pict.LogNoisiness > 4)
		{
			this.log.trace(`PICT TemplateFromMap [fTemplateFromMapRenderAsync]::[${tmpHash}] with tmpData:`, tmpData);
		}
		else if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PICT TemplateFromMap [fTemplateFromMapRenderAsync]::[${tmpHash}]`);
		}

		let tmpTemplateFromMapHash;
		let tmpAddressOfMap;
		let tmpAddressOfKey;

		// This is a 3 part hash with the map address and the key address both
		let tmpTemplateHashPart = tmpHash.split(':');

		if (tmpTemplateHashPart.length < 3)
		{
			this.log.trace(`PICT TemplateFromMap [fTemplateFromMapRenderAsync]::[${tmpHash}] failed because there were not three stanzas in the expression [${pTemplateHash}]`);
			return fCallback(null, '');
		}

		tmpTemplateFromMapHash = tmpTemplateHashPart[0];
		tmpAddressOfMap = tmpTemplateHashPart[1];
		tmpAddressOfKey = tmpTemplateHashPart[2];

		// No TemplateFromMap hash
		if (!tmpTemplateFromMapHash)
		{
			this.log.warn(`Pict: TemplateFromMap Render Async: TemplateFromMapHash not resolved for [${tmpHash}]`);
			return fCallback(null, '');
		}

		// Now resolve the data
		let tmpMap = this.resolveStateFromAddress(tmpAddressOfMap, tmpData, pContextArray, null, pScope, pState);
		let tmpKey = this.resolveStateFromAddress(tmpAddressOfKey, tmpData, pContextArray, null, pScope, pState);

		if (!tmpMap)
		{
			this.log.warn(`Pict: TemplateFromMap Render: Map not resolved for [${tmpHash}]`);
			return fCallback(null, '');
		}

		tmpData = tmpMap[tmpKey];

		if (!tmpData)
		{
			// No address was provided, just render the TemplateFromMap with what this TemplateFromMap has.
			// The async portion of this is a mind bender because of how entry can happen dynamically from TemplateFromMaps
			this.pict.parseTemplateByHash(tmpTemplateFromMapHash, pRecord,
				(pError, pValue) =>
				{
					if (pError)
					{
						return tmpCallback(pError, '');
					}
					return tmpCallback(null, pValue);
				}, pContextArray, pScope, pState);
		}
		else
		{
			this.pict.parseTemplateByHash(tmpTemplateFromMapHash, tmpData,
				(pError, pValue) =>
				{
					if (pError)
					{
						return tmpCallback(pError, '');
					}
					return tmpCallback(null, pValue);
				}, pContextArray, pScope, pState);
		}
	}
}

module.exports = PictTemplateProviderTemplateFromMap;

},{"pict-template":144}],232:[function(require,module,exports){
const libPictTemplate = require('pict-template');

class PictTemplateProviderTemplateSet extends libPictTemplate
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.log;

		this.addPattern('{~TemplateSet:', '~}');
		this.addPattern('{~TS:', '~}');
	}

	/**
	 * Render a template expression, returning a string with the resulting content.
	 *
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {string} The rendered template
	 */
	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();
		let tmpData = (typeof (pRecord) === 'object') ? pRecord : {};

		if (this.pict.LogNoisiness > 4)
		{
			this.log.trace(`PICT Template [fTemplateSetRender]::[${tmpHash}] with tmpData:`, tmpData);
		}
		else if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PICT Template [fTemplateSetRender]::[${tmpHash}]`);
		}

		let tmpTemplateHash;
		let tmpAddressOfData;

		// This is just a simple 2 part hash (the entity and the ID)
		let tmpHashTemplateSeparator = tmpHash.indexOf(':');
		tmpTemplateHash = tmpHash.substring(0, tmpHashTemplateSeparator);
		if (tmpHashTemplateSeparator > -1)
		{
			tmpAddressOfData = tmpHash.substring(tmpHashTemplateSeparator + 1);
		}
		else
		{
			tmpTemplateHash = tmpHash;
		}

		// No template hash
		if (!tmpTemplateHash)
		{
			this.log.warn(`Pict: Template Render: TemplateHash not resolved for [${tmpHash}]`);
			return '';
		}

		if (!tmpAddressOfData)
		{
			// No address was provided, just render the template with what this template has.
			return this.pict.parseTemplateSetByHash(tmpTemplateHash, pRecord, null, pContextArray, pScope, pState);
		}
		else
		{
			return this.pict.parseTemplateSetByHash(tmpTemplateHash, this.resolveStateFromAddress(tmpAddressOfData, tmpData, pContextArray, null, pScope, pState), null, pContextArray, pScope, pState);
		}
	}

	/**
	 * Render a template expression, deliver a string with the resulting content to a callback function.
	 *
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {(error?: Error, content?: String) => void} fCallback - callback function invoked with the rendered template, or an error
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {void}
	 */
	renderAsync(pTemplateHash, pRecord, fCallback, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();
		let tmpData = (typeof (pRecord) === 'object') ? pRecord : {};
		let tmpCallback = (typeof (fCallback) === 'function') ? fCallback : () => { return ''; };

		if (this.pict.LogNoisiness > 4)
		{
			this.log.trace(`PICT Template [fTemplateSetRenderAsync]::[${tmpHash}] with tmpData:`, tmpData);
		}
		else if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PICT Template [fTemplateSetRenderAsync]::[${tmpHash}]`);
		}

		let tmpTemplateFromMapHash;
		let tmpAddressOfData;

		// This is a 3 part hash with the map address and the key address both
		let tmpTemplateHashPart = tmpHash.split(':');

		if (tmpTemplateHashPart.length < 2)
		{
			this.log.trace(`PICT TemplateFromMap [fTemplateRenderAsync]::[${tmpHash}] failed because there were not three stanzas in the expression [${pTemplateHash}]`);
			return fCallback(null, '');
		}

		tmpTemplateFromMapHash = tmpTemplateHashPart[0]
		tmpAddressOfData = tmpTemplateHashPart[1];

		// No TemplateFromMap hash
		if (!tmpTemplateFromMapHash)
		{
			this.log.warn(`Pict: TemplateFromMap Render Async: TemplateFromMapHash not resolved for [${tmpHash}]`);
			return fCallback(null, '');
		}

		// Now resolve the data
		tmpData = this.resolveStateFromAddress(tmpAddressOfData, tmpData, pContextArray, null, pScope, pState);

		if (!tmpData)
		{
			// No address was provided, just render the template with what this template has.
			// The async portion of this is a mind bender because of how entry can happen dynamically from templates
			this.pict.parseTemplateSetByHash(tmpTemplateFromMapHash, pRecord,
				(pError, pValue) =>
				{
					if (pError)
					{
						return tmpCallback(pError, '');
					}
					return tmpCallback(null, pValue);
				}, pContextArray, pScope, pState);
		}
		else
		{
			this.pict.parseTemplateSetByHash(tmpTemplateFromMapHash, tmpData,
				(pError, pValue) =>
				{
					if (pError)
					{
						return tmpCallback(pError, '');
					}
					return tmpCallback(null, pValue);
				}, pContextArray, pScope, pState);
		}
	}
}

module.exports = PictTemplateProviderTemplateSet;

},{"pict-template":144}],233:[function(require,module,exports){
const libPictTemplate = require('pict-template');

class PictTemplateProviderTemplateSetFromMap extends libPictTemplate
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.log;

		this.addPattern('{~TSFM:', '~}');
		this.addPattern('{~TemplateSetFromMap:', '~}');
	}

	/**
	 * Render a template expression, returning a string with the resulting content.
	 *
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {string} The rendered template
	 */
	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();
		let tmpData = (typeof (pRecord) === 'object') ? pRecord : {};

		if (this.pict.LogNoisiness > 4)
		{
			this.log.trace(`PICT TemplateFromMap [fTemplateFromMapSetRender]::[${tmpHash}] with tmpData:`, tmpData);
		}
		else if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PICT TemplateFromMap [fTemplateFromMapSetRender]::[${tmpHash}]`);
		}

		let tmpTemplateFromMapHash;
		let tmpAddressOfMap;
		let tmpAddressOfKey;

		// This is a 3 part hash with the map address and the key address both
		let tmpTemplateHashPart = tmpHash.split(':');

		if (tmpTemplateHashPart.length < 3)
		{
			this.log.trace(`PICT TemplateFromMap [fTemplateFromMapRenderAsync]::[${tmpHash}] failed because there were not three stanzas in the expression [${pTemplateHash}]`);
			return '';
		}

		tmpTemplateFromMapHash = tmpTemplateHashPart[0];
		tmpAddressOfMap = tmpTemplateHashPart[1];
		tmpAddressOfKey = tmpTemplateHashPart[2];

		// No TemplateFromMap hash
		if (!tmpTemplateFromMapHash)
		{
			this.log.warn(`Pict: TemplateFromMap Render Async: TemplateFromMapHash not resolved for [${tmpHash}]`);
			return '';
		}

		// Now resolve the data
		let tmpMap = this.resolveStateFromAddress(tmpAddressOfMap, tmpData, pContextArray, null, pScope, pState);
		let tmpKey = this.resolveStateFromAddress(tmpAddressOfKey, tmpData, pContextArray, null, pScope, pState);

		if (!tmpMap)
		{
			this.log.warn(`Pict: TemplateFromMap Render: Map not resolved for [${tmpHash}]`);
			return '';
		}

		tmpData = tmpMap[tmpKey];

		if (!tmpData)
		{
			// No address was provided, just render the TemplateFromMap with what this TemplateFromMap has.
			return this.pict.parseTemplateSetByHash(tmpTemplateFromMapHash, pRecord, null, pContextArray, pScope, pState);
		}
		else
		{
			return this.pict.parseTemplateSetByHash(tmpTemplateFromMapHash, tmpData, null, pContextArray, pScope, pState);
		}
	}

	/**
	 * Render a template expression, deliver a string with the resulting content to a callback function.
	 *
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {(error?: Error, content?: String) => void} fCallback - callback function invoked with the rendered template, or an error
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {void}
	 */
	renderAsync(pTemplateHash, pRecord, fCallback, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();
		let tmpData = (typeof (pRecord) === 'object') ? pRecord : {};
		let tmpCallback = (typeof (fCallback) === 'function') ? fCallback : () => { return ''; };

		if (this.pict.LogNoisiness > 4)
		{
			this.log.trace(`PICT TemplateFromMap [fTemplateFromMapSetRenderAsync]::[${tmpHash}] with tmpData:`, tmpData);
		}
		else if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PICT TemplateFromMap [fTemplateFromMapSetRenderAsync]::[${tmpHash}]`);
		}

		let tmpTemplateFromMapHash;
		let tmpAddressOfMap;
		let tmpAddressOfKey;

		// This is a 3 part hash with the map address and the key address both
		let tmpTemplateHashPart = tmpHash.split(':');

		if (tmpTemplateHashPart.length < 3)
		{
			this.log.trace(`PICT TemplateFromMap [fTemplateFromMapRenderAsync]::[${tmpHash}] failed because there were not three stanzas in the expression [${pTemplateHash}]`);
			return fCallback(null, '');
		}

		tmpTemplateFromMapHash = tmpTemplateHashPart[0];
		tmpAddressOfMap = tmpTemplateHashPart[1];
		tmpAddressOfKey = tmpTemplateHashPart[2];

		// No TemplateFromMap hash
		if (!tmpTemplateFromMapHash)
		{
			this.log.warn(`Pict: TemplateFromMapSet Render Async: TemplateFromMapHash not resolved for [${tmpHash}]`);
			return fCallback(null, '');
		}

		// Now resolve the data
		let tmpMap = this.resolveStateFromAddress(tmpAddressOfMap, tmpData, pContextArray, null, pScope, pState);
		let tmpKey = this.resolveStateFromAddress(tmpAddressOfKey, tmpData, pContextArray, null, pScope, pState);

		if (!tmpMap)
		{
			this.log.warn(`Pict: TemplateFromMapSet Render: Map not resolved for [${tmpHash}]`);
			return fCallback(null, '');
		}

		tmpData = tmpMap[tmpKey];

		if (!tmpData)
		{
			// No address was provided, just render the TemplateFromMap with what this TemplateFromMap has.
			// The async portion of this is a mind bender because of how entry can happen dynamically from TemplateFromMaps
			this.pict.parseTemplateSetByHash(tmpTemplateFromMapHash, pRecord,
				(pError, pValue) =>
				{
					if (pError)
					{
						return tmpCallback(pError, '');
					}
					return tmpCallback(null, pValue);
				}, pContextArray, pScope, pState);
		}
		else
		{
			this.pict.parseTemplateSetByHash(tmpTemplateFromMapHash, tmpData,
				(pError, pValue) =>
				{
					if (pError)
					{
						return tmpCallback(pError, '');
					}
					return tmpCallback(null, pValue);
				}, pContextArray, pScope, pState);
		}
	}
}

module.exports = PictTemplateProviderTemplateSetFromMap;

},{"pict-template":144}],234:[function(require,module,exports){
const libPictTemplate = require('pict-template');

class PictTemplateProviderTemplateSetWithPayload extends libPictTemplate
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.log;

		this.addPattern('{~TemplateSetWithPayload:', '~}');
		this.addPattern('{~TSWP:', '~}');
	}

	/**
	 * Render a template expression, returning a string with the resulting content.
	 *
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {string} The rendered template
	 */
	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();

		if (this.pict.LogNoisiness > 4)
		{
			this.log.trace(`PICT Template [fTemplateSetWithPayloadRender]::[${tmpHash}] with record:`, pRecord);
		}
		else if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PICT Template [fTemplateSetWithPayloadRender]::[${tmpHash}]`);
		}

		let tmpTemplateHash;
		let tmpAddressOfData;
		let tmpAddressOfPayload;

		// This is just a simple 3 part hash (template, address of set, address of payload)
		let tmpTemplateHashes = tmpHash.trim().split(':');
		if (tmpTemplateHashes.length < 3)
		{
			this.log.trace(`PICT Template [fTemplateSetWithPayloadRender]::[${tmpHash}] failed because there were not three stanzas in the expression [${pTemplateHash}]`);
			return ``;
		}
		tmpTemplateHash = tmpTemplateHashes[0];
		tmpAddressOfData = tmpTemplateHashes[1];
		tmpAddressOfPayload = tmpTemplateHashes[2];

		let tmpData = this.resolveStateFromAddress(tmpAddressOfData, pRecord, pContextArray, null, pScope, pState);
		if (!tmpData)
		{
			tmpData = pRecord;
		}
		if (!tmpData)
		{
			tmpData = {};
		}

		let tmpPayloadData = this.resolveStateFromAddress(tmpAddressOfPayload, pRecord, pContextArray, null, pScope, pState);
		if (!tmpPayloadData)
		{
			tmpPayloadData = pRecord;
		}
		if (!tmpPayloadData)
		{
			tmpPayloadData = {};
		}

		return this.pict.parseTemplateSetWithPayloadByHash(tmpTemplateHash, tmpData, tmpPayloadData, null, pContextArray, pScope, pState);
	}

	/**
	 * Render a template expression, deliver a string with the resulting content to a callback function.
	 *
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {(error?: Error, content?: String) => void} fCallback - callback function invoked with the rendered template, or an error
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {void}
	 */
	renderAsync(pTemplateHash, pRecord, fCallback, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();
		let tmpCallback = (typeof (fCallback) === 'function') ? fCallback : () => { return ''; };

		if (this.pict.LogNoisiness > 4)
		{
			this.log.trace(`PICT Template [fTemplateSetWithPayloadRenderAsync]::[${tmpHash}]`);
		}
		else if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PICT Template [fTemplateSetWithPayloadRenderAsync]::[${tmpHash}]`);
		}

		let tmpTemplateHash;
		let tmpAddressOfData;
		let tmpAddressOfPayload;

		// This is just a simple 3 part hash (template, address of set, address of payload)
		let tmpTemplateHashes = tmpHash.trim().split(':');
		if (tmpTemplateHashes.length < 3)
		{
			this.log.trace(`PICT Template [fTemplateSetWithPayloadRender]::[${tmpHash}] failed because there were not three stanzas in the expression [${pTemplateHash}]`);
			return fCallback(null, '');
		}
		tmpTemplateHash = tmpTemplateHashes[0];
		tmpAddressOfData = tmpTemplateHashes[1];
		tmpAddressOfPayload = tmpTemplateHashes[2];

		let tmpData = this.resolveStateFromAddress(tmpAddressOfData, pRecord, pContextArray, null, pScope, pState);
		if (!tmpData)
		{
			tmpData = pRecord;
		}
		if (!tmpData)
		{
			tmpData = {};
		}

		let tmpPayloadData = this.resolveStateFromAddress(tmpAddressOfPayload, pRecord, pContextArray, null, pScope, pState);
		if (!tmpPayloadData)
		{
			tmpPayloadData = pRecord;
		}
		if (!tmpPayloadData)
		{
			tmpPayloadData = {};
		}

		this.pict.parseTemplateSetWithPayloadByHash(tmpTemplateHash, tmpData, tmpPayloadData,
			(pError, pValue) =>
			{
				if (pError)
				{
					return tmpCallback(pError, '');
				}
				return tmpCallback(null, pValue);
			}, pContextArray, pScope, pState);
	}
}

module.exports = PictTemplateProviderTemplateSetWithPayload;

},{"pict-template":144}],235:[function(require,module,exports){
const libPictTemplate = require('pict-template');

class PictTemplateProviderTemplateValueSet extends libPictTemplate
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.log;

		this.addPattern('{~TemplateValueSet:', '~}');
		this.addPattern('{~TVS:', '~}');
	}

	/**
	 * Render a template expression, returning a string with the resulting content.
	 *
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {string} The rendered template
	 */
	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();
		let tmpData = (typeof (pRecord) === 'object') ? pRecord : {};

		if (this.pict.LogNoisiness > 4)
		{
			this.log.trace(`PICT Template [fTemplateValueSetRender]::[${tmpHash}] with tmpData:`, tmpData);
		}
		else if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PICT Template [fTemplateValueSetRender]::[${tmpHash}]`);
		}

		let tmpTemplateHash;
		let tmpAddressOfData;

		// This is just a simple 2 part hash (the entity and the ID)
		let tmpHashTemplateSeparator = tmpHash.indexOf(':');
		tmpTemplateHash = tmpHash.substring(0, tmpHashTemplateSeparator);
		if (tmpHashTemplateSeparator > -1)
		{
			tmpAddressOfData = tmpHash.substring(tmpHashTemplateSeparator + 1);
		}
		else
		{
			tmpTemplateHash = tmpHash;
		}

		// No template hash
		if (!tmpTemplateHash)
		{
			this.log.warn(`Pict: Template Render: TemplateHash not resolved for [${tmpHash}]`);
			return '';
		}

		tmpData = this.resolveStateFromAddress(tmpAddressOfData, tmpData, pContextArray, null, pScope, pState);

		let tmpDataValueSet = [];
		if (Array.isArray(tmpData))
		{
			for (let i = 0; i < tmpData.length; i++)
			{
				tmpDataValueSet.push({ Value: tmpData[i], Key: i });
			}
		}
		else if (typeof (tmpData) === 'object')
		{
			let tmpValueKeys = Object.keys(tmpData);
			for (let i = 0; i < tmpValueKeys.length; i++)
			{
				tmpDataValueSet.push({ Value: tmpData[tmpValueKeys[i]], Key: tmpValueKeys[i] });
			}
		}
		else
		{
			tmpDataValueSet.push({ Value: tmpData });
		}
		tmpData = tmpDataValueSet;

		if (!tmpData)
		{
			// No address was provided, just render the template with what this template has.
			return this.pict.parseTemplateSetByHash(tmpTemplateHash, pRecord, null, pContextArray, pScope, pState);
		}
		else
		{
			return this.pict.parseTemplateSetByHash(tmpTemplateHash, tmpData, null, pContextArray, pScope, pState);
		}
	}
	/**
	 * Render a template expression, deliver a string with the resulting content to a callback function.
	 *
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {(error?: Error, content?: String) => void} fCallback - callback function invoked with the rendered template, or an error
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {void}
	 */
	renderAsync(pTemplateHash, pRecord, fCallback, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();
		let tmpData = (typeof (pRecord) === 'object') ? pRecord : {};
		let tmpCallback = (typeof (fCallback) === 'function') ? fCallback : () => { return ''; };

		if (this.pict.LogNoisiness > 4)
		{
			this.log.trace(`PICT Template [fTemplateValueSetRenderAsync]::[${tmpHash}] with tmpData:`, tmpData);
		}
		else if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PICT Template [fTemplateValueSetRenderAsync]::[${tmpHash}]`);
		}

		let tmpTemplateFromMapHash;
		let tmpAddressOfData;

		// This is a 3 part hash with the map address and the key address both
		let tmpTemplateHashPart = tmpHash.split(':');

		if (tmpTemplateHashPart.length < 2)
		{
			this.log.trace(`PICT TemplateFromMap [fTemplateRenderAsync]::[${tmpHash}] failed because there were not three stanzas in the expression [${pTemplateHash}]`);
			return fCallback(null, '');
		}

		tmpTemplateFromMapHash = tmpTemplateHashPart[0]
		tmpAddressOfData = tmpTemplateHashPart[1];

		// No TemplateFromMap hash
		if (!tmpTemplateFromMapHash)
		{
			this.log.warn(`Pict: TemplateFromMap Render Async: TemplateFromMapHash not resolved for [${tmpHash}]`);
			return fCallback(null, '');
		}

		// Now resolve the data
		tmpData = this.resolveStateFromAddress(tmpAddressOfData, tmpData, pContextArray, null, pScope, pState);

		let tmpDataValueSet = [];
		if (Array.isArray(tmpData))
		{
			for (let i = 0; i < tmpData.length; i++)
			{
				tmpDataValueSet.push({ Value: tmpData[i], Key: i });
			}
		}
		else if (typeof (tmpData) === 'object')
		{
			let tmpValueKeys = Object.keys(tmpData);
			for (let i = 0; i < tmpValueKeys.length; i++)
			{
				tmpDataValueSet.push({ Value: tmpData[tmpValueKeys[i]], Key: tmpData[tmpValueKeys[i]] });
			}
		}
		else
		{
			tmpDataValueSet.push({ Value: tmpData });
		}
		tmpData = tmpDataValueSet;

		if (!tmpData)
		{
			// No address was provided, just render the template with what this template has.
			// The async portion of this is a mind bender because of how entry can happen dynamically from templates
			this.pict.parseTemplateSetByHash(tmpTemplateFromMapHash, pRecord,
				(pError, pValue) =>
				{
					if (pError)
					{
						return tmpCallback(pError, '');
					}
					return tmpCallback(null, pValue);
				}, pContextArray, pScope, pState);
		}
		else
		{
			this.pict.parseTemplateSetByHash(tmpTemplateFromMapHash, tmpData,
				(pError, pValue) =>
				{
					if (pError)
					{
						return tmpCallback(pError, '');
					}
					return tmpCallback(null, pValue);
				}, pContextArray, pScope, pState);
		}
	}
}

module.exports = PictTemplateProviderTemplateValueSet;

},{"pict-template":144}],236:[function(require,module,exports){
const libPictTemplate = require('pict-template');

class PictTemplateProviderView extends libPictTemplate
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.log;

		this.addPattern('{~V:', '~}');
		this.addPattern('{~View:', '~}');


		if (!('__TemplateOutputCache' in this.pict))
		{
			this.pict.__TemplateOutputCache = {};
		}
	}

	/**
	 * Render a template expression, returning a string with the resulting content.
	 *
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {string} The rendered template
	 */
	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		const tmpViewHash = pTemplateHash.trim();
		if (!(tmpViewHash in this.pict.views))
		{
			this.log.warn(`Pict: View Template Render: View not found for [${tmpViewHash}]`);
			return '';
		}

		let tmpRenderGUID = this.pict.getUUID();

		/** @type {import('pict-view')} */
		const tmpView = this.pict.views[tmpViewHash];

		tmpView.render('__Virtual', `__TemplateOutputCache.${tmpRenderGUID}`, pRecord, pState ? pState.RootRenderable : undefined);

		let tmpResult = this.pict.__TemplateOutputCache[tmpRenderGUID];
		// TODO: Uncomment this when we like how it's working
		//delete this.pict.__TemplateOutputCache[tmpRenderGUID];

		return tmpResult;
	}

	/**
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template
	 * @param {(pError?: Error, pResult?: string) => void} fCallback - The callback function to call with the result
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {void}
	 */
	renderAsync(pTemplateHash, pRecord, fCallback, pContextArray, pScope, pState)
	{
		const tmpViewHash = pTemplateHash.trim();
		if (!(tmpViewHash in this.pict.views))
		{
			this.log.warn(`Pict: View Template Render: View not found for [${tmpViewHash}]`);
			return fCallback(null, '');
		}

		let tmpRenderGUID = this.pict.getUUID();

		const tmpView = this.pict.views[tmpViewHash];

		return tmpView.renderAsync('__Virtual', `__TemplateOutputCache.${tmpRenderGUID}`, pRecord, pState ? pState.RootRenderable : undefined,
			(pError, pResult) =>
			{
				if (pError)
				{
					this.log.warn(`Pict: View Template Render: Error rendering view [${tmpViewHash}]`, pError);
					return fCallback(pError, '');
				}

				let tmpResult = this.pict.__TemplateOutputCache[tmpRenderGUID];
				// TODO: Uncomment this when we like how it's working
				//delete this.pict.__TemplateOutputCache[tmpRenderGUID];

				return fCallback(null, tmpResult);
			});
	}
}

module.exports = PictTemplateProviderView;

},{"pict-template":144}],237:[function(require,module,exports){
const libPictTemplate = require('pict-template');

class PictTemplateProviderRandomNumber extends libPictTemplate
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.log;

		this.addPattern('{~RandomNumber:', '~}');
		this.addPattern('{~RN:', '~}');
	}

	/**
	 * Render a template expression, returning a string with the resulting content.
	 *
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {string} The rendered template
	 */
	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();

		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PICT Template [fRandomNumber]::[${tmpHash}]`);
		}

		let tmpMinimumNumber = 0;
		let tmpMaxNumber = 9999999;

		if (tmpHash.length > 0)
		{
			let tmpHashParts = tmpHash.split(',');
			if (tmpHashParts.length > 0)
			{
				try
				{
					tmpMinimumNumber = parseInt(tmpHashParts[0]);
				}
				catch
				{
					tmpMinimumNumber = 0;
				}
			}
			if (tmpHashParts.length > 1)
			{
				try
				{
					tmpMaxNumber = parseInt(tmpHashParts[1]);
				}
				catch
				{
					tmpMaxNumber = 9999999;
				}

			}
		}

		return this.fable.DataGeneration.randomIntegerBetween(tmpMinimumNumber, tmpMaxNumber);
	}
}

module.exports = PictTemplateProviderRandomNumber;

},{"pict-template":144}],238:[function(require,module,exports){
const libPictTemplate = require('pict-template');

class PictTemplateProviderRandomNumberString extends libPictTemplate
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.log;

		this.addPattern('{~RandomNumberString:', '~}');
		this.addPattern('{~RNS:', '~}');
	}

	/**
	 * Render a template expression, returning a string with the resulting content.
	 *
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {string} The rendered template
	 */
	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();

		if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PICT Template [fRandomNumberString]::[${tmpHash}]`);
		}

		let tmpStringLength = 4;
		let tmpMaxNumber = 9999;

		if (tmpHash.length > 0)
		{
			let tmpHashParts = tmpHash.split(',');
			if (tmpHashParts.length > 0)
			{
				try
				{
					tmpStringLength = parseInt(tmpHashParts[0]);
				}
				catch
				{
					tmpStringLength = 4;
				}
			}
			if (tmpHashParts.length > 1)
			{
				try
				{
					tmpMaxNumber = parseInt(tmpHashParts[1]);
				}
				catch
				{
					tmpMaxNumber = 9999;
				}
			}
		}

		return this.fable.DataGeneration.randomNumericString(tmpStringLength, tmpMaxNumber);
	}
}

module.exports = PictTemplateProviderRandomNumberString;

},{"pict-template":144}],239:[function(require,module,exports){
const libPictTemplate = require('pict-template');

class PictTemplateProviderDataEncodeJavascriptString extends libPictTemplate
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.log;

		this.addPattern('{~DataEncodeJavascriptString:', '~}');
		this.addPattern('{~DEJS:', '~}');
	}

	/**
	 * Render a template expression, returning a string with the resulting content.
	 *
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {string} The rendered template
	 */
	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();
		let tmpData = (typeof (pRecord) === 'object') ? pRecord : {};

		if (this.pict.LogNoisiness > 4)
		{
			this.log.trace(`PICT Template [fDataJson]::[${tmpHash}] with tmpData:`, tmpData);
		}
		else if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PICT Template [fDataJson]::[${tmpHash}]`);
		}

		let tmpDataToEncode = this.resolveStateFromAddress(tmpHash, tmpData, pContextArray, null, pScope, pState);

		return this.pict.DataFormat.stringEncodeForJavascript(tmpDataToEncode);
	}
}

module.exports = PictTemplateProviderDataEncodeJavascriptString;

},{"pict-template":144}],240:[function(require,module,exports){
const libPictTemplate = require('pict-template');

class PictTemplateProviderJSONOutput extends libPictTemplate
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.log;

		this.addPattern('{~DataJson:', '~}');
		this.addPattern('{~DJ:', '~}');
	}

	/**
	 * Render a template expression, returning a string with the resulting content.
	 *
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {string} The rendered template
	 */
	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();
		let tmpData = (typeof (pRecord) === 'object') ? pRecord : {};

		if (this.pict.LogNoisiness > 4)
		{
			this.log.trace(`PICT Template [fDataJson]::[${tmpHash}] with tmpData:`, tmpData);
		}
		else if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PICT Template [fDataJson]::[${tmpHash}]`);
		}

		let tmpDataToStringify = this.resolveStateFromAddress(tmpHash, tmpData, pContextArray, null, pScope, pState);

		if (!tmpDataToStringify)
		{
			tmpDataToStringify = pRecord;
		}

		return JSON.stringify(tmpDataToStringify);
	}
}

module.exports = PictTemplateProviderJSONOutput;

},{"pict-template":144}],241:[function(require,module,exports){
const libPictTemplate = require('pict-template');

class PictTemplateProviderDateOnlyFormat extends libPictTemplate
{
	/**
	 * @param {import('fable')} pFable - The Fable Framework instance
	 * @param {any} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.options;
		/** @type {any} */
		this.log;

		this.addPattern('{~DateOnlyFormat:', '~}');
	}

	/**
	 * Render a template expression, returning a string with the resulting content.
	 *
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {string} The rendered template
	 */
	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();
		let tmpData = (typeof (pRecord) === 'object') ? pRecord : {};
		let tmpDateValueSet = tmpHash.split('^');

		if (tmpDateValueSet.length < 2)
		{
			this.log.error(`PICT Template [fDateOnlyFormat]::[${tmpHash}] did not have a valid format string and date.`);
			return '';
		}

		let tmpDateValue = this.resolveStateFromAddress(tmpDateValueSet[0], tmpData, pContextArray, null, pScope, pState);

		if (this.pict.LogNoisiness > 4)
		{
			this.log.trace(`PICT Template [fDateOnlyFormat]::[${tmpHash}] with data:`, tmpData);
		}
		else if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PICT Template [fDateOnlyFormat]::[${tmpHash}]`);
		}

		// Because this is "Date Only", we force the time to be UTC 00:00:00 and go with the date part only.
		let tmpDayJS = this.fable.Dates.dayJS.utc(tmpDateValue);

		return tmpDayJS.format(tmpDateValueSet[1]);
	}
}

module.exports = PictTemplateProviderDateOnlyFormat;

/*
# DEAR DEAD CODE DIARY:

```javascript

```
*/


},{"pict-template":144}],242:[function(require,module,exports){
const libPictTemplate = require('pict-template');

class PictTemplateProviderDateOnlyYMD extends libPictTemplate
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.options;
		/** @type {any} */
		this.log;

		this.addPattern('{~DateOnlyYMD:', '~}');
	}

	/**
	 * Render a template expression, returning a string with the resulting content.
	 *
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {string} The rendered template
	 */
	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();
		let tmpData = (typeof (pRecord) === 'object') ? pRecord : {};
		let tmpDateValue = this.resolveStateFromAddress(tmpHash, tmpData, pContextArray, null, pScope, pState);


		if (this.pict.LogNoisiness > 4)
		{
			this.log.trace(`PICT Template [fDateTimeYMD]::[${tmpHash}] with data:`, tmpData);
		}
		else if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PICT Template [fDateTimeYMD]::[${tmpHash}]`);
		}

		// Because this is "Date Only", we force the time to be UTC 00:00:00 and go with the date part only.
		let tmpDayJS = this.fable.Dates.dayJS.utc(tmpDateValue);

		//FIXME: this is kind of wacked out; -62167219200000 is the unix ms timestamp for 0000-01-01 00:00:00 UTC
		//       not even sure showing negative is right; showing the era is probably better (BCE vs CE)
		//const prefix = tmpDayJS.valueOf() < -62167219200000 ? '-' : '';
		const tmpPrefix = '';

		return tmpPrefix + tmpDayJS.format('YYYY-MM-DD');
	}
}

module.exports = PictTemplateProviderDateOnlyYMD;

},{"pict-template":144}],243:[function(require,module,exports){
const libPictTemplate = require('pict-template');

class PictTemplateProviderDateTimeFormat extends libPictTemplate
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.options;
		/** @type {any} */
		this.log;

		this.addPattern('{~DateTimeFormat:', '~}');
		this.addPattern('{~DateFormat:', '~}'); // for backwards compatibility
	}

	/**
	 * Render a template expression, returning a string with the resulting content.
	 *
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {string} The rendered template
	 */
	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();
		let tmpData = (typeof (pRecord) === 'object') ? pRecord : {};
		let tmpDateValueSet = tmpHash.split('^');

		if (tmpDateValueSet.length < 2)
		{
			this.log.error(`PICT Template [fDateTimeFormat]::[${tmpHash}] did not have a valid format string and date.`);
			return '';
		}

		let tmpDateValue = this.resolveStateFromAddress(tmpDateValueSet[0], tmpData, pContextArray, null, pScope, pState);

		if (this.pict.LogNoisiness > 4)
		{
			this.log.trace(`PICT Template [fDateTimeFormat]::[${tmpHash}] with data:`, tmpData);
		}
		else if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PICT Template [fDateTimeFormat]::[${tmpHash}]`);
		}

		// TODO: Modularize this
		let tmpDayJS = this.fable.Dates.dayJS.utc(tmpDateValue);
		try
		{
			// Try to cast the day to be a specific timezone if one is set for the app
			if (this.pict.options.Timezone)
			{
				tmpDayJS = tmpDayJS.tz(this.pict.options.Timezone);
			}
			else
			{
				try
				{
					tmpDayJS = tmpDayJS.tz(this.fable.Dates.dayJS.tz.guess());
				}
				catch (pError)
				{
					this.log.error(`Error guessing dayJS guess() function; dates may be formatted to GMT by default. (${pError.message || pError})`);
				}
			}
		}
		catch
		{
			//this.log.error(`Error casting date passed timezone using tz .. casting to the browser guess which is [${this.fable.Dates.dayJS.tz.guess()}].`);
			// Day.js will try to guess the user's timezone for us
			try
			{
				tmpDayJS = tmpDayJS.tz(this.fable.Dates.dayJS.tz.guess());
			}
			catch (pError)
			{
				this.log.error(`Error guessing dayJS guess() function; dates may be formatted to GMT by default. (${pError.message || pError})`);
			}
		}

		return tmpDayJS.format(tmpDateValueSet[1]);
	}
}

module.exports = PictTemplateProviderDateTimeFormat;

/*
# DEAR DEAD CODE DIARY:

```javascript

```
*/


},{"pict-template":144}],244:[function(require,module,exports){
const libPictTemplate = require('pict-template');

class PictTemplateProviderDateTimeYMD extends libPictTemplate
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.options;
		/** @type {any} */
		this.log;

		this.addPattern('{~DateTimeYMD:', '~}');
		this.addPattern('{~DateYMD:', '~}'); // for backwards compatibility
	}

	/**
	 * Render a template expression, returning a string with the resulting content.
	 *
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {string} The rendered template
	 */
	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();
		let tmpData = (typeof (pRecord) === 'object') ? pRecord : {};
		let tmpDateValue = this.resolveStateFromAddress(tmpHash, tmpData, pContextArray, null, pScope, pState);


		if (this.pict.LogNoisiness > 4)
		{
			this.log.trace(`PICT Template [fDateTimeYMD]::[${tmpHash}] with data:`, tmpData);
		}
		else if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PICT Template [fDateTimeYMD]::[${tmpHash}]`);
		}

		// TODO: Modularize this
		let tmpDayJS = this.fable.Dates.dayJS.utc(tmpDateValue);
		try
		{
			// Try to cast the day to be a specific timezone if one is set for the app
			if (this.pict.options.Timezone)
			{
				tmpDayJS = tmpDayJS.tz(this.pict.options.Timezone);
			}
			else
			{
				try
				{
					tmpDayJS = tmpDayJS.tz(this.fable.Dates.dayJS.tz.guess());
				}
				catch (pError)
				{
					this.log.error(`Error guessing dayJS guess() function; dates may be formatted to GMT by default. (${pError.message || pError})`);
				}
			}
		}
		catch
		{
			//this.log.error(`Error casting timezone using tz .. casting to the browser guess which is [${this.fable.Dates.dayJS.tz.guess()}].`);
			// Day.js will try to guess the user's timezone for us
			try
			{
				tmpDayJS = tmpDayJS.tz(this.fable.Dates.dayJS.tz.guess());
			}
			catch (pError)
			{
				this.log.error(`Error guessing dayJS guess() function; dates may be formatted to GMT by default. (${pError.message || pError})`);
			}
		}

		return tmpDayJS.format('YYYY-MM-DD');
	}
}

module.exports = PictTemplateProviderDateTimeYMD;

},{"pict-template":144}],245:[function(require,module,exports){
const libPictTemplate = require('pict-template');

class PictTemplateProviderDigits extends libPictTemplate
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.options;
		/** @type {any} */
		this.log;

		this.addPattern('{~Digits:', '~}');
	}

	/**
	 * Render a template expression, returning a string with the resulting content.
	 *
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {string} The rendered template
	 */
	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();
		let tmpData = (typeof (pRecord) === 'object') ? pRecord : {};

		if (this.pict.LogNoisiness > 4)
		{
			this.log.trace(`PICT Template [fDigits]::[${tmpHash}] with tmpData:`, tmpData);
		}
		else if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PICT Template [fDigits]::[${tmpHash}]`);
		}

		let tmpColumnData = this.resolveStateFromAddress(tmpHash, tmpData, pContextArray, null, pScope, pState);
		return this.fable.DataFormat.formatterAddCommasToNumber(this.fable.DataFormat.formatterRoundNumber(tmpColumnData, 2));
	}
}

module.exports = PictTemplateProviderDigits;

},{"pict-template":144}],246:[function(require,module,exports){
const libPictTemplate = require('pict-template');

class PictTemplateProviderDollars extends libPictTemplate
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.options;
		/** @type {any} */
		this.log;

		this.addPattern('{~Dollars:', '~}');
	}

	/**
	 * Render a template expression, returning a string with the resulting content.
	 *
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {string} The rendered template
	 */
	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();
		let tmpData = (typeof (pRecord) === 'object') ? pRecord : {};

		if (this.pict.LogNoisiness > 4)
		{
			this.log.trace(`PICT Template [fDollars]::[${tmpHash}] with tmpData:`, tmpData);
		}
		else if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PICT Template [fDollars]::[${tmpHash}]`);
		}

		let tmpColumnData = this.resolveStateFromAddress(tmpHash, tmpData, pContextArray, null, pScope, pState);
		return this.fable.DataFormat.formatterDollars(tmpColumnData);
	}
}

module.exports = PictTemplateProviderDollars;

},{"pict-template":144}],247:[function(require,module,exports){
const libPictTemplate = require('pict-template');

class PictTemplateProviderHTMLCommandEnd extends libPictTemplate
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.log;

		this.addPattern('{~HtmlCommentEnd:', '~}');
		this.addPattern('{~HCE:', '~}');
	}

	/**
	 * Render a template expression, returning a string with the resulting content.
	 *
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {string} The rendered template
	 */
	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();
		let tmpRecord = (typeof(pRecord) === 'object') ? pRecord : {};

		if (this.pict.LogNoisiness > 4)
		{
			this.log.trace(`PICT Template [fDataRender]::[${tmpHash}] with tmpData:`, tmpRecord);
		}
		else if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PICT Template [fDataRender]::[${tmpHash}]`);
		}

		let tmpValue = false;
		const [ tmpValueAddress, tmpPolarityStr ] = tmpHash.split(':');
		if (tmpValueAddress != null)
		{
			tmpValue = this.resolveStateFromAddress(tmpValueAddress, tmpRecord, pContextArray, null, pScope, pState);
		}
		const tmpPolarity = tmpPolarityStr != null ? tmpPolarityStr === '1' || tmpPolarityStr.toLowerCase() === 'true' || tmpPolarityStr.toLowerCase() === 't' : false;
		if (Boolean(tmpValue) == tmpPolarity)
		{
			return ' -->';
		}
		return '';
	}
}

module.exports = PictTemplateProviderHTMLCommandEnd;

},{"pict-template":144}],248:[function(require,module,exports){
const libPictTemplate = require('pict-template');

class PictTemplateProviderHTMLCommandStart extends libPictTemplate
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.log;

		this.addPattern('{~HtmlCommentStart:', '~}');
		this.addPattern('{~HCS:', '~}');
	}

	/**
	 * Render a template expression, returning a string with the resulting content.
	 *
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {string} The rendered template
	 */
	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();
		let tmpRecord = (typeof(pRecord) === 'object') ? pRecord : {};

		if (this.pict.LogNoisiness > 4)
		{
			this.log.trace(`PICT Template [fDataRender]::[${tmpHash}] with tmpData:`, tmpRecord);
		}
		else if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PICT Template [fDataRender]::[${tmpHash}]`);
		}

		let tmpValue = false;
		const [ tmpValueAddress, tmpPolarityStr ] = tmpHash.split(':');
		if (tmpValueAddress != null)
		{
			tmpValue = this.resolveStateFromAddress(tmpValueAddress, tmpRecord, pContextArray, null, pScope, pState);
		}
		const tmpPolarity = tmpPolarityStr != null ? tmpPolarityStr === '1' || tmpPolarityStr.toLowerCase() === 'true' || tmpPolarityStr.toLowerCase() === 't' : false;
		if (Boolean(tmpValue) == tmpPolarity)
		{
			return '<!-- ';
		}
		return '';
	}
}

module.exports = PictTemplateProviderHTMLCommandStart;

},{"pict-template":144}],249:[function(require,module,exports){
const libPictTemplate = require('pict-template');

class PictTemplateProviderJoin extends libPictTemplate
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.options;
		/** @type {any} */
		this.log;

		this.addPattern('{~Join:', '~}');
		this.addPattern('{~J:', '~}');
	}

	/**
	 * Render a template expression, returning a string with the resulting content.
	 *
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {string} The rendered template
	 */
	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash;
		let tmpData = (typeof (pRecord) === 'object') ? pRecord : {};

		if (this.pict.LogNoisiness > 4)
		{
			this.log.trace(`PICT Join [fDataRender]::[${tmpHash}] with tmpData:`, tmpData);
		}
		else if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PICT Join [fDataRender]::[${tmpHash}]`);
		}

		let tmpDataAddresses = tmpHash.split('^');
		if (tmpDataAddresses.length < 2)
		{
			return '';
		}

		// Get the separator string
		let tmpSeparator = tmpDataAddresses.shift();

		let tmpValueList = [];
		for (let i = 0; i < tmpDataAddresses.length; i++)
		{
			let tmpValueSet = this.resolveStateFromAddress(tmpDataAddresses[i], tmpData, pContextArray, null, pScope, pState);
			if (tmpValueSet && Array.isArray(tmpValueSet))
			{
				for (let j = 0; j < tmpValueSet.length; j++)
				{
					tmpValueList.push(tmpValueSet[j]);
				}
			}
			else if (tmpValueSet)
			{
				tmpValueList.push(tmpValueSet);
			}
		}

		return tmpValueList.join(tmpSeparator);
	}
}

module.exports = PictTemplateProviderJoin;

},{"pict-template":144}],250:[function(require,module,exports){
const libPictTemplate = require('pict-template');

class PictTemplateProviderJoinUnique extends libPictTemplate
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.options;
		/** @type {any} */
		this.log;

		this.addPattern('{~JoinUnique:', '~}');
		this.addPattern('{~JU:', '~}');
	}

	/**
	 * Render a template expression, returning a string with the resulting content.
	 *
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {string} The rendered template
	 */
	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash;
		let tmpData = (typeof (pRecord) === 'object') ? pRecord : {};

		if (this.pict.LogNoisiness > 4)
		{
			this.log.trace(`PICT Join Unique [fDataRender]::[${tmpHash}] with tmpData:`, tmpData);
		}
		else if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PICT Join Unique [fDataRender]::[${tmpHash}]`);
		}

		let tmpDataAddresses = tmpHash.split('^');
		if (tmpDataAddresses.length < 2)
		{
			return '';
		}

		// Get the separator string
		let tmpSeparator = tmpDataAddresses.shift();

		let tmpValueList = [];
		let tmpValueMap = {};
		for (let i = 0; i < tmpDataAddresses.length; i++)
		{
			let tmpValueSet = this.resolveStateFromAddress(tmpDataAddresses[i], tmpData, pContextArray, null, pScope, pState);

			if (tmpValueSet && Array.isArray(tmpValueSet))
			{
				for (let j = 0; j < tmpValueSet.length; j++)
				{
					if (!(tmpValueSet[j] in tmpValueMap))
					{
						tmpValueMap[tmpValueSet[j]] = true;
						tmpValueList.push(tmpValueSet[j]);
					}
				}
			}
			else if (tmpValueSet)
			{
				if (!(tmpValueSet in tmpValueMap))
				{
					tmpValueMap[tmpValueSet] = true;
					tmpValueList.push(tmpValueSet);
				}
			}
		}

		return tmpValueList.join(tmpSeparator);
	}
}

module.exports = PictTemplateProviderJoinUnique;

},{"pict-template":144}],251:[function(require,module,exports){
const libPictTemplate = require('pict-template');

class PictTemplateProviderPascalCaseIdentifier extends libPictTemplate
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.options;
		/** @type {any} */
		this.log;

		this.addPattern('{~PascalCaseIdentifier:', '~}');
	}

	/**
	 * Render a template expression, returning a string with the resulting content.
	 *
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {string} The rendered template
	 */
	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();
		let tmpData = (typeof (pRecord) === 'object') ? pRecord : {};

		if (this.pict.LogNoisiness > 4)
		{
			this.log.trace(`PICT Template [fPascalCaseIdentifier]::[${tmpHash}] with tmpData:`, tmpData);
		}
		else if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PICT Template [fPascalCaseIdentifier]::[${tmpHash}]`);
		}

		let tmpValue = this.resolveStateFromAddress(tmpHash, tmpData, pContextArray, null, pScope, pState);
		if ((tmpValue == null) || (tmpValue == 'undefined') || (typeof (tmpValue) == 'undefined'))
		{
			return '';
		}
		return this.pict.DataFormat.cleanNonAlphaCharacters(this.pict.DataFormat.capitalizeEachWord(tmpValue));
	}
}

module.exports = PictTemplateProviderPascalCaseIdentifier;

/*
# DEAR DEAD CODE DIARY:

```javascript

```
*/


},{"pict-template":144}],252:[function(require,module,exports){
const libPictTemplate = require('pict-template');

class PictTemplateProviderPluckJoinUnique extends libPictTemplate
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.options;
		/** @type {any} */
		this.log;

		this.addPattern('{~PluckJoinUnique:', '~}');
		this.addPattern('{~PJU:', '~}');
	}

	/**
	 * Render a template expression, returning a string with the resulting content.
	 *
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {string} The rendered template
	 */
	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash;
		let tmpData = (typeof (pRecord) === 'object') ? pRecord : {};

		if (this.pict.LogNoisiness > 4)
		{
			this.log.trace(`PICT Pluck Join Unique [fDataRender]::[${tmpHash}] with tmpData:`, tmpData);
		}
		else if (this.pict.LogNoisiness > 3)
		{
			this.log.trace(`PICT Pluck Join Unique [fDataRender]::[${tmpHash}]`);
		}

		let tmpDataAddresses = tmpHash.split('^');
		if (tmpDataAddresses.length < 3)
		{
			return '';
		}

		// Get the separator string
		let tmpSeparator = tmpDataAddresses.shift();
		let tmpAddress = tmpDataAddresses.shift();

		let tmpValueList = [];
		let tmpValueMap = {};
		for (let i = 0; i < tmpDataAddresses.length; i++)
		{
			let tmpValueSet = this.resolveStateFromAddress(tmpDataAddresses[i], tmpData, pContextArray, null, pScope, pState);

			if (tmpValueSet && Array.isArray(tmpValueSet))
			{
				// This one only works on arrays of objects.
				for (let j = 0; j < tmpValueSet.length; j++)
				{
					if ((tmpValueSet[j] === null) || (typeof(tmpValueSet) !== 'object'))
					{
						continue;
					}
					let tmpValue = this.pict.manifest.getValueByHash(tmpValueSet[j], tmpAddress);
					if (!(tmpValue in tmpValueMap))
					{
						tmpValueMap[tmpValue] = true;
						tmpValueList.push(tmpValue);
					}
				}
			}
			else if (tmpValueSet)
			{
				if (!(tmpValueSet in tmpValueMap))
				{
					tmpValueMap[tmpValueSet] = true;
					tmpValueList.push(tmpValueSet);
				}
			}
		}

		return tmpValueList.join(tmpSeparator);
	}
}

module.exports = PictTemplateProviderPluckJoinUnique;

},{"pict-template":144}],253:[function(require,module,exports){
const libPictTemplate = require('pict-template');

class PictTemplateProviderBreakpoint extends libPictTemplate
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.log;

		this.addPattern('{~Breakpoint', '~}');
	}

	/**
	 * Render a template expression, returning a string with the resulting content.
	 *
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {string} The rendered template
	 */
	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();
		let tmpError = new Error(`PICT Template Breakpoint: ${tmpHash}`);
		this.log.trace(`PICT Template Breakpoint: ${tmpHash}`, tmpError.stack);
		//throw tmpError;
		debugger; // eslint-disable-line no-debugger
		return '';
	}

}

module.exports = PictTemplateProviderBreakpoint;

},{"pict-template":144}],254:[function(require,module,exports){
const libPictTemplate = require('pict-template');

class PictTemplateProviderDataValueTree extends libPictTemplate
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.log;

		this.addPattern('{~DataTree:', '~}');
		this.addPattern('{~DT:', '~}');
	}

	/**
	 * Render a template expression, returning a string with the resulting content.
	 *
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {string} The rendered template
	 */
	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		let tmpData = (typeof (pRecord) === 'object') ? pRecord : {};
		tmpData.TemplateHash = pTemplateHash.trim();

		tmpData.ValueTreeParameters = tmpData.TemplateHash.split('^');
		if (tmpData.ValueTreeParameters.length < 1)
		{
			return '';
		}
		tmpData.ResolvedValue = this.resolveStateFromAddress(tmpData.ValueTreeParameters[0], tmpData, pContextArray, null, pScope, pState);
		tmpData.ResolvedValueType = typeof (tmpData.ResolvedValue);

		try
		{
			tmpData.TreeMaxDepth = (tmpData.ValueTreeParameters.length < 2) ? 1 : parseInt(tmpData.ValueTreeParameters[1]);
		}
		catch
		{
			tmpData.TreeMaxDepth = 1;
		}

		let tmpPictObjectWrapTemplate = this.pict.TemplateProvider.getTemplate('PICT-Object-Wrap');
		if (!tmpPictObjectWrapTemplate)
		{
			// This template is here because it is a default template.  Users can override this template by providing their own as PICT-Object-Wrap
			tmpPictObjectWrapTemplate = `<div class="PICT PICTObjectSet">{~D:Record.ObjectValueTree~}</div>`;
		}

		if (tmpData.ResolvedValueType == 'object')
		{
			tmpData.ObjectValueTree = this.dataValueTreeObjectSet(tmpData.ResolvedValue, tmpData.ResolvedValue, 0, tmpData.TreeMaxDepth, pContextArray, pScope);
		}
		else
		{
			this.log.trace(`PICT Template Log Value Tree: [${tmpData.TemplateHash}] resolved data is not an object.`, tmpData.ResolvedValue);
			tmpData.ObjectValueTree = tmpData.ResolveValue;
		}

		return this.pict.parseTemplate(tmpPictObjectWrapTemplate, tmpData, null, pContextArray, pScope, pState);
	}

	/**
	 * Render a template expression, returning a string with the resulting content.
	 *
	 * @param {Object} pObject - The object to be rendered as a value tree
	 * @param {Object} pRootObject - The root object for the value tree, used to provide context
	 * @param {number} pCurrentDepth - The current depth in the value tree
	 * @param {number} pMaxDepth - The maximum depth to render in the value tree
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {string} The rendered template
	 */
	dataValueTreeObjectSet(pObject, pRootObject, pCurrentDepth, pMaxDepth, pContextArray, pScope, pState)
	{
		let tmpTemplateResult = '';

		if (typeof (pObject) !== 'object')
		{
			return tmpTemplateResult;
		}

		let tmpObjectValueKeys = Object.keys(pObject);

		let tmpPictObjectBranchTemplate = this.pict.TemplateProvider.getTemplate('PICT-Object-Branch');
		if (!tmpPictObjectBranchTemplate)
		{
			// This template is here because it is a default template.  Users can override this template by providing their own as PICT-Object-Branch
			tmpPictObjectBranchTemplate = `
<div class="PICTObjectBranchDepth_{~D:Record.CurrentDepth~}"><div class="PICTObjectBranch">{~D:Record.BranchKey~}</div><div class="PICTObjectBranchValue">{~D:Record.BranchValue~}</div></div>
`
		}

		for (let i = 0; i < tmpObjectValueKeys.length; i++)
		{
			let tmpBranchType = typeof (pObject[tmpObjectValueKeys[i]]);

			let tmpBranchValue = '';

			switch (tmpBranchType)
			{
				case 'object':
					if (pCurrentDepth + 1 > pMaxDepth)
					{
						tmpBranchValue = '...';
					}
					else
					{
						tmpBranchValue = this.dataValueTreeObjectSet(pObject[tmpObjectValueKeys[i]], pRootObject, pCurrentDepth + 1, pMaxDepth, pContextArray, pScope);
					}
					break;

				default:
					tmpBranchValue = pObject[tmpObjectValueKeys[i]];
					break;
			}

			let tmpDataValue =
			{
				AppData: this.pict.AppData,
				Bundle: this.pict.Bundle,

				RootContainer: pRootObject,

				Container: pObject,
				BranchEntryCount: tmpObjectValueKeys.length,

				BranchIndex: i,
				BranchKey: tmpObjectValueKeys[i],
				BranchValue: tmpBranchValue,
				BranchDataType: tmpBranchType,

				CurrentDepth: pCurrentDepth,
				MaxDepth: pMaxDepth
			};
			tmpTemplateResult += this.pict.parseTemplate(tmpPictObjectBranchTemplate, tmpDataValue, null, pContextArray, pScope, pState);
		}

		return tmpTemplateResult;
	}
}

module.exports = PictTemplateProviderDataValueTree;

},{"pict-template":144}],255:[function(require,module,exports){
const libPictTemplate = require('pict-template');

class PictTemplateProviderLogStatement extends libPictTemplate
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.log;

		this.addPattern('{~LogStatement:', '~}');
		this.addPattern('{~LS:', '~}');
	}

	/**
	 * Render a template expression, returning a string with the resulting content.
	 *
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {string} The rendered template
	 */
	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();
		this.log.trace(`PICT Template Log Message: ${tmpHash}`);
		return '';
	}
}

module.exports = PictTemplateProviderLogStatement;

},{"pict-template":144}],256:[function(require,module,exports){
const libPictTemplate = require('pict-template');

class PictTemplateProviderLogValue extends libPictTemplate
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.log;

		this.addPattern('{~LogValue:', '~}');
		this.addPattern('{~LV:', '~}');
	}

	/**
	 * Render a template expression, returning a string with the resulting content.
	 *
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {string} The rendered template
	 */
	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();
		let tmpData = (typeof (pRecord) === 'object') ? pRecord : {};

		let tmpValue = this.resolveStateFromAddress(tmpHash, tmpData, pContextArray, null, pScope, pState);
		let tmpValueType = typeof (tmpValue);
		if ((tmpValue == null) || (tmpValueType == 'undefined'))
		{
			this.log.trace(`PICT Template Log Value: [${tmpHash}] is ${tmpValueType}.`);
		}
		else if (tmpValueType == 'object')
		{
			this.log.trace(`PICT Template Log Value: [${tmpHash}] is an object.`, tmpValue);
		}
		else
		{
			this.log.trace(`PICT Template Log Value: [${tmpHash}] is a ${tmpValueType} = [${tmpValue}]`);
		}
		return '';
	}
}

module.exports = PictTemplateProviderLogValue;

},{"pict-template":144}],257:[function(require,module,exports){
const libPictTemplate = require('pict-template');

class PictTemplateProviderLogValueTree extends libPictTemplate
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.log;

		this.addPattern('{~LogValueTree:', '~}');
		this.addPattern('{~LVT:', '~}');
	}

	/**
	 * Render a template expression, returning a string with the resulting content.
	 *
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {string} The rendered template
	 */
	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		let tmpData = (typeof (pRecord) === 'object') ? pRecord : {};
		tmpData.TemplateHash = pTemplateHash.trim();

		tmpData.ValueTreeParameters = tmpData.TemplateHash.split('^');
		if (tmpData.ValueTreeParameters.length < 1)
		{
			return '';
		}
		tmpData.ResolvedValue = this.resolveStateFromAddress(tmpData.ValueTreeParameters[0], tmpData, pContextArray, null, pScope, pState);
		tmpData.ResolvedValueType = typeof (tmpData.ResolvedValue);


		try
		{
			tmpData.TreeMaxDepth = (tmpData.ValueTreeParameters.length < 2) ? 1 : parseInt(tmpData.ValueTreeParameters[1]);
		}
		catch
		{
			tmpData.TreeMaxDepth = 1;
		}

		if (tmpData.ResolvedValueType == 'object')
		{
			this.logValueTreeObjectSet(tmpData.ResolvedValue, tmpData.ValueTreeParameters[0], tmpData.ResolvedValue, 0, tmpData.TreeMaxDepth);
		}
		else
		{
			this.log.trace(`PICT Template Log Value Tree: [${tmpData.TemplateHash}] resolved data is not an object.`, tmpData.ResolvedValue);
		}

		return '';
	}
	logValueTreeObjectSet = (pObject, pBaseAddress, pRootObject, pCurrentDepth, pMaxDepth) =>
	{
		let tmpTemplateResult = '';

		if (typeof (pObject) !== 'object')
		{
			return tmpTemplateResult;
		}

		let tmpObjectValueKeys = Object.keys(pObject);

		for (let i = 0; i < tmpObjectValueKeys.length; i++)
		{
			let tmpBranchType = typeof (pObject[tmpObjectValueKeys[i]]);
			let tmpBranchValue = '';

			switch (tmpBranchType)
			{
				case 'object':
					tmpBranchValue = '...';
					break;

				default:
					tmpBranchValue = pObject[tmpObjectValueKeys[i]];
					break;
			}
			this.log.trace(`[${pBaseAddress}.${tmpObjectValueKeys[i]}] (${tmpBranchType}):  ${tmpBranchValue}`);

			if (pCurrentDepth + 1 > pMaxDepth)
			{
				return '';
			}
			else if (tmpBranchType == 'object')
			{
				tmpBranchValue = this.logValueTreeObjectSet(pObject[tmpObjectValueKeys[i]], `${pBaseAddress}.${tmpObjectValueKeys[i]}`, pRootObject, pCurrentDepth + 1, pMaxDepth);
			}
		}

		return '';
	};
}

module.exports = PictTemplateProviderLogValueTree;

},{"pict-template":144}],258:[function(require,module,exports){
const libPictTemplate = require('pict-template');

class PictTemplateProviderNotEmpty extends libPictTemplate
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.log;

		this.addPattern('{~NotEmpty:', '~}');
		this.addPattern('{~NE:', '~}');
	}

	/**
	 * Render a template expression, returning a string with the resulting content.
	 *
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {string} The rendered template
	 */
	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();
		let tmpData = (typeof (pRecord) === 'object') ? pRecord : {};

		if (this.pict.LogNoisiness > 4)
		{
			this.log.trace(`PICT Template [fNotEmptyRender]::[${tmpHash}] with tmpData:`, tmpData);
		}
		else if (this.pict.LogNoisiness > 2)
		{
			this.log.trace(`PICT Template [fNotEmptyRender]::[${tmpHash}]`);
		}

		let tmpHashParts = tmpHash.split('^');

		// For now just check truthiness.  Not sure if this is grand.
		if (this.resolveStateFromAddress(tmpHashParts[0], tmpData, pContextArray, null, pScope, pState))
		{
			return tmpHashParts[1];
		}

		return '';
	}
}

module.exports = PictTemplateProviderNotEmpty;

},{"pict-template":144}],259:[function(require,module,exports){
const libPictTemplate = require('pict-template');

class PictTemplateProviderTemplateIfBase extends libPictTemplate
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
	}

	compareValues (pValueLeft, pOperator, pValueRight)
	{
		switch(pOperator)
		{
			case 'TRUE':
				return (pValueLeft === true);
			case 'FALSE':
				return (pValueLeft === false);
			case 'LNGT':
			case 'LENGTH_GREATER_THAN':
				switch(typeof(pValueLeft))
				{
					case 'string':
						return (pValueLeft.length > pValueRight);
					case 'object':
						return (pValueLeft.length > pValueRight);
					default:
						return false;
				}
			case 'LNLT':
			case 'LENGTH_LESS_THAN':
				switch(typeof(pValueLeft))
				{
					case 'string':
						return (pValueLeft.length < pValueRight);
					case 'object':
						return (pValueLeft.length < pValueRight);
					default:
						return false;
				}
			case '!==':
				return (pValueLeft !== pValueRight);
			case '!=':
				return (pValueLeft != pValueRight);
			case '<':
				return (pValueLeft < pValueRight);
			case '>':
				return (pValueLeft > pValueRight);
			case '<=':
				return (pValueLeft <= pValueRight);
			case '>=':
				return (pValueLeft >= pValueRight);
			case '===':
				return (pValueLeft === pValueRight);
			case '==':
				return (pValueLeft == pValueRight);
			default:
				return false;
		}
	}
}

module.exports = PictTemplateProviderTemplateIfBase;

},{"pict-template":144}],260:[function(require,module,exports){
const libPictTemplateIf = require('./Pict-Template-TemplateIf-Base.js');

class PictTemplateProviderTemplateIf extends libPictTemplateIf
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.log;

		this.addPattern('{~TemplateIf:', '~}');
		this.addPattern('{~TIf:', '~}');
	}

	/**
	 * Render a template expression, returning a string with the resulting content.
	 *
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {string} The rendered template
	 */
	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();
		let tmpData = (typeof (pRecord) === 'object') ? pRecord : {};

		if (this.pict.LogNoisiness > 4)
		{
			this.log.trace(`PICT Template [fTemplateIfAbsoluteValueRender]::[${tmpHash}] with tmpData:`, tmpData);
		}
		else if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PICT Template [fTemplateIfAbsoluteValueRender]::[${tmpHash}]`);
		}

		let tmpTemplateHash;
		let tmpAddressOfData;
		let tmpComparisonOperation;

		let tmpHashParts = tmpHash.split(':');

		if (tmpHashParts.length < 3)
		{
			this.log.warn(`Pict: Template If Absolute Value Render: TemplateHash not complete for [${tmpHash}]`);
			return '';
		}

		tmpTemplateHash = tmpHashParts[0];
		tmpAddressOfData = tmpHashParts[1];
		tmpComparisonOperation = tmpHashParts[2];

		// No template hash
		if (!tmpTemplateHash)
		{
			this.log.warn(`Pict: Template Render: TemplateHash not resolved for [${tmpHash}]`);
			return '';
		}
		// No comparison operation
		if (!tmpComparisonOperation)
		{
			this.log.warn(`Pict: Template Render: Comparison Operation not resolved for [${tmpHash}]`);
			return '';
		}

		// Now try to break the comparison into three parts...
		let tmpComparisonParts = tmpComparisonOperation.split('^');
		if (tmpComparisonParts.length < 3)
		{
			this.log.warn(`Pict: Template Render: Comparison Operation not complete (three parts expected) for [${tmpHash}]`);
			return '';
		}

		// Now look up the data at the comparison location
		try
		{
			let tmpComparisonResult = this.compareValues(
				this.resolveStateFromAddress(tmpComparisonParts[0], tmpData, pContextArray, null, pScope, pState),
				tmpComparisonParts[1],
				this.resolveStateFromAddress(tmpComparisonParts[2], tmpData, pContextArray, null, pScope, pState));

			if (!tmpComparisonResult)
			{
				return '';
			}
			if (!tmpAddressOfData)
			{
				// No address was provided, just render the template with what this template has.
				return this.pict.parseTemplateByHash(tmpTemplateHash, pRecord, null, pContextArray, pScope, pState);
			}
			else
			{
				return this.pict.parseTemplateByHash(tmpTemplateHash, this.resolveStateFromAddress(tmpAddressOfData, tmpData, pContextArray, null, pScope, pState), null, pContextArray, pScope, pState);
			}
		}
		catch (pError)
		{
			this.log.error(`Pict: Template Render: Error looking up comparison data for [${tmpHash}]: ${pError}`, pError);
			return '';
		}
	}

	/**
	 * Render a template expression, deliver a string with the resulting content to a callback function.
	 *
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {(error?: Error, content?: String) => void} fCallback - callback function invoked with the rendered template, or an error
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {void}
	 */
	renderAsync(pTemplateHash, pRecord, fCallback, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();
		let tmpData = (typeof (pRecord) === 'object') ? pRecord : {};
		let tmpCallback = (typeof (fCallback) === 'function') ? fCallback : () => { return ''; };

		if (this.pict.LogNoisiness > 4)
		{
			this.log.trace(`PICT Template [fTemplateIfAbsoluteValueRender]::[${tmpHash}] with tmpData:`, tmpData);
		}
		else if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PICT Template [fTemplateIfAbsoluteValueRender]::[${tmpHash}]`);
		}

		let tmpTemplateHash;
		let tmpAddressOfData;
		let tmpComparisonOperation;

		let tmpHashParts = tmpHash.split(':');

		if (tmpHashParts.length < 3)
		{
			this.log.warn(`Pict: Template If Absolute Value Render: TemplateHash not complete for [${tmpHash}]`);
			return tmpCallback(null, '');
		}

		tmpTemplateHash = tmpHashParts[0];
		tmpAddressOfData = tmpHashParts[1];
		tmpComparisonOperation = tmpHashParts[2];

		// No template hash
		if (!tmpTemplateHash)
		{
			this.log.warn(`Pict: Template Render: TemplateHash not resolved for [${tmpHash}]`);
			return tmpCallback(null, '');
		}
		// No comparison operation
		if (!tmpComparisonOperation)
		{
			this.log.warn(`Pict: Template Render: Comparison Operation not resolved for [${tmpHash}]`);
			return tmpCallback(null, '');
		}

		// Now try to break the comparison into three parts...
		let tmpComparisonParts = tmpComparisonOperation.split('^');
		if (tmpComparisonParts.length < 3)
		{
			this.log.warn(`Pict: Template Render: Comparison Operation not complete (three parts expected) for [${tmpHash}]`);
			return tmpCallback(null, '');
		}

		// Now look up the data at the comparison location
		try
		{
			// This is the only thing that's different from the absolute value function above.  Collapse these.
			let tmpComparisonResult = this.compareValues(
				this.resolveStateFromAddress(tmpComparisonParts[0], tmpData, pContextArray, null, pScope, pState),
				tmpComparisonParts[1],
				this.resolveStateFromAddress(tmpComparisonParts[2], tmpData, pContextArray, null, pScope, pState));

			if (!tmpComparisonResult)
			{
				return tmpCallback(null, '');
			}
			if (!tmpAddressOfData)
			{
				this.pict.parseTemplateByHash(tmpTemplateHash, pRecord,
					(pError, pValue) =>
					{
						if (pError)
						{
							return tmpCallback(pError, '');
						}
						return tmpCallback(null, pValue);
					}, pContextArray, pScope, pState);
			}
			else
			{
				this.pict.parseTemplateByHash(tmpTemplateHash, this.resolveStateFromAddress(tmpAddressOfData, tmpData, pContextArray, null, pScope, pState),
					(pError, pValue) =>
					{
						if (pError)
						{
							return tmpCallback(pError, '');
						}
						return tmpCallback(null, pValue);
					}, pContextArray, pScope, pState);
			}
		}
		catch (pError)
		{
			this.log.error(`Pict: Template Render: Error looking up comparison data for [${tmpHash}]: ${pError}`, pError);
			return tmpCallback(pError, '');
		}
	}
}

module.exports = PictTemplateProviderTemplateIf;

},{"./Pict-Template-TemplateIf-Base.js":259}],261:[function(require,module,exports){
const libPictTemplateIf = require('./Pict-Template-TemplateIf-Base.js');

class PictTemplateProviderTemplateIfAbsolute extends libPictTemplateIf
{
	/**
	 * @param {Object} pFable - The Fable Framework instance
	 * @param {Object} pOptions - The options for the service
	 * @param {String} pServiceHash - The hash of the service
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.log;

		this.addPattern('{~TemplateIfAbsolute:', '~}');
		this.addPattern('{~TIfAbs:', '~}');
	}

	/**
	 * Render a template expression, returning a string with the resulting content.
	 *
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {string} The rendered template
	 */
	render(pTemplateHash, pRecord, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();
		let tmpData = (typeof (pRecord) === 'object') ? pRecord : {};

		if (this.pict.LogNoisiness > 4)
		{
			this.log.trace(`PICT Template [fTemplateIfAbsoluteValueRender]::[${tmpHash}] with tmpData:`, tmpData);
		}
		else if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PICT Template [fTemplateIfAbsoluteValueRender]::[${tmpHash}]`);
		}

		let tmpTemplateHash;
		let tmpAddressOfData;
		let tmpComparisonOperation;

		let tmpHashParts = tmpHash.split(':');

		if (tmpHashParts.length < 3)
		{
			this.log.warn(`Pict: Template If Absolute Value Render: TemplateHash not complete for [${tmpHash}]`);
			return '';
		}

		tmpTemplateHash = tmpHashParts[0];
		tmpAddressOfData = tmpHashParts[1];
		tmpComparisonOperation = tmpHashParts[2];

		// No template hash
		if (!tmpTemplateHash)
		{
			this.log.warn(`Pict: Template Render: TemplateHash not resolved for [${tmpHash}]`);
			return '';
		}
		// No comparison operation
		if (!tmpComparisonOperation)
		{
			this.log.warn(`Pict: Template Render: Comparison Operation not resolved for [${tmpHash}]`);
			return '';
		}

		// Now try to break the comparison into three parts...
		let tmpComparisonParts = tmpComparisonOperation.split('^');
		if (tmpComparisonParts.length < 3)
		{
			this.log.warn(`Pict: Template Render: Comparison Operation not complete (three parts expected) for [${tmpHash}]`);
			return '';
		}

		// Now look up the data at the comparison location
		try
		{
			let tmpComparisonResult = this.compareValues(this.resolveStateFromAddress(tmpComparisonParts[0], tmpData, pContextArray, null, pScope, pState), tmpComparisonParts[1], tmpComparisonParts[2]);
			if (!tmpComparisonResult)
			{
				return '';
			}
			if (!tmpAddressOfData)
			{
				// No address was provided, just render the template with what this template has.
				return this.pict.parseTemplateByHash(tmpTemplateHash, pRecord, null, pContextArray, pScope, pState);
			}
			else
			{
				return this.pict.parseTemplateByHash(tmpTemplateHash, this.resolveStateFromAddress(tmpAddressOfData, tmpData, pContextArray, null, pScope, pState), null, pContextArray, pScope, pState);
			}
		}
		catch (pError)
		{
			this.log.error(`Pict: Template Render: Error looking up comparison data for [${tmpHash}]: ${pError}`, pError);
			return '';
		}
	}

	/**
	 * Render a template expression, deliver a string with the resulting content to a callback function.
	 *
	 * @param {string} pTemplateHash - The hash contents of the template (what's between the template start and stop tags)
	 * @param {any} pRecord - The json object to be used as the Record for the template render
	 * @param {(error?: Error, content?: String) => void} fCallback - callback function invoked with the rendered template, or an error
	 * @param {Array<any>} pContextArray - An array of context objects accessible from the template; safe to leave empty
	 * @param {any} [pScope] - A sticky scope that can be used to carry state and simplify template
	 * @param {any} [pState] - A catchall state object for plumbing data through template processing.
	 *
	 * @return {void}
	 */
	renderAsync(pTemplateHash, pRecord, fCallback, pContextArray, pScope, pState)
	{
		let tmpHash = pTemplateHash.trim();
		let tmpData = (typeof (pRecord) === 'object') ? pRecord : {};
		let tmpCallback = (typeof (fCallback) === 'function') ? fCallback : () => { return ''; };

		if (this.pict.LogNoisiness > 4)
		{
			this.log.trace(`PICT Template [fTemplateIfAbsoluteValueRender]::[${tmpHash}] with tmpData:`, tmpData);
		}
		else if (this.pict.LogNoisiness > 0)
		{
			this.log.trace(`PICT Template [fTemplateIfAbsoluteValueRender]::[${tmpHash}]`);
		}

		let tmpTemplateHash;
		let tmpAddressOfData;
		let tmpComparisonOperation;

		let tmpHashParts = tmpHash.split(':');

		if (tmpHashParts.length < 3)
		{
			this.log.warn(`Pict: Template If Absolute Value Render: TemplateHash not complete for [${tmpHash}]`);
			return tmpCallback(null, '');
		}

		tmpTemplateHash = tmpHashParts[0];
		tmpAddressOfData = tmpHashParts[1];
		tmpComparisonOperation = tmpHashParts[2];

		// No template hash
		if (!tmpTemplateHash)
		{
			this.log.warn(`Pict: Template Render: TemplateHash not resolved for [${tmpHash}]`);
			return tmpCallback(null, '');
		}
		// No comparison operation
		if (!tmpComparisonOperation)
		{
			this.log.warn(`Pict: Template Render: Comparison Operation not resolved for [${tmpHash}]`);
			return tmpCallback(null, '');
		}

		// Now try to break the comparison into three parts...
		let tmpComparisonParts = tmpComparisonOperation.split('^');
		if (tmpComparisonParts.length < 3)
		{
			this.log.warn(`Pict: Template Render: Comparison Operation not complete (three parts expected) for [${tmpHash}]`);
			return tmpCallback(null, '');
		}

		// Now look up the data at the comparison location
		try
		{
			let tmpComparisonResult = this.compareValues(this.resolveStateFromAddress(tmpComparisonParts[0], tmpData, pContextArray, null, pScope, pState), tmpComparisonParts[1], tmpComparisonParts[2]);
			if (!tmpComparisonResult)
			{
				return tmpCallback(null, '');
			}
			if (!tmpAddressOfData)
			{
				this.pict.parseTemplateByHash(tmpTemplateHash, pRecord,
					(pError, pValue) =>
					{
						if (pError)
						{
							return tmpCallback(pError, '');
						}
						return tmpCallback(null, pValue);
					}, pContextArray, pScope, pState);
			}
			else
			{
				this.pict.parseTemplateByHash(tmpTemplateHash, this.resolveStateFromAddress(tmpAddressOfData, tmpData, pContextArray, null, pScope, pState),
					(pError, pValue) =>
					{
						if (pError)
						{
							return tmpCallback(pError, '');
						}
						return tmpCallback(null, pValue);
					}, pContextArray, pScope, pState);
			}
		}
		catch (pError)
		{
			this.log.error(`Pict: Template Render: Error looking up comparison data for [${tmpHash}]: ${pError}`, pError);
			return tmpCallback(pError, '');
		}
	}
}

module.exports = PictTemplateProviderTemplateIfAbsolute;

},{"./Pict-Template-TemplateIf-Base.js":259}]},{},[201])(201)
});

